/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** PayableType */
export enum UpdateInvoiceRequestPayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** CoverageDecisionOption */
export enum UpdateInvoiceRequestCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/** GlobalFieldPlacement */
export enum UpdateGlobalFieldParamsGlobalFieldPlacement {
  Policy = "policy",
  IncidentDetails = "incident_details",
  SupplementaryInformation = "supplementary_information",
  FirstPartyInvolved = "first_party_involved",
  ThirdPartyInvolved = "third_party_involved",
}

/** GlobalFieldAnchor */
export enum UpdateGlobalFieldParamsGlobalFieldAnchor {
  Start = "start",
  End = "end",
}

/**
 * FundAccountDefaultBehavior
 * What the engine does for a payment no rule matched.
 *
 * ``block_payment`` applies whether or not the method has a payment provider, except to a
 * portal-routed method, which no rule can be scoped to. ``default_account`` and an unconfigured
 * engine apply only to a provider-backed method, and a method with no provider resolves to no
 * account under them.
 *
 * ``send_empty`` resolves to no account whatever the provider; whether an empty account is
 * acceptable is the provider's own question, asked at the approval seam against its
 * ``is_fund_account_required`` flag. So a method whose provider requires an account and that
 * matches no rule fails there instead, and one whose provider does not is unaffected.
 *
 * (DR §13 #1 states the same rejection, but in the Vitesse-only wording it was written in when
 * Vitesse was the only provider carrying the flag; the check has read the flag since.)
 */
export enum UpdateFundAccountEngineConfigParamsFundAccountDefaultBehavior {
  DefaultAccount = "default_account",
  BlockPayment = "block_payment",
  SendEmpty = "send_empty",
}

/**
 * ExternalToolPayloadFieldType
 * The payload-field types an external tool may declare.
 *
 * Restricted to the three types the design doc allows for external-tool payloads; the
 * manager re-validates the same allow-list against the persisted fields.
 */
export enum UpdateExternalToolConfigParamsExternalToolPayloadFieldType {
  Text = "text",
  Date = "date",
  Enum = "enum",
}

/** PayableType */
export enum UpdateExposureLineItemsRequestPayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** CoverageDecisionOption */
export enum UpdateExposureLineItemsRequestCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/**
 * RuleAssigneeKind
 * The four kinds an assignment rule's assignee can be.
 */
export enum UpdateAssignmentRuleParamsRuleAssigneeKind {
  FnolTaker = "fnol_taker",
  ClaimOwner = "claim_owner",
  User = "user",
  Group = "group",
}

/**
 * FileRole
 * Role of a file within the archive.
 */
export enum TemporaryUploadResponseFileRole {
  Config = "config",
  Asset = "asset",
}

/** FilteringMode */
export enum TemplateSectionConditionFieldsParamsFilteringMode {
  Intersection = "intersection",
  Union = "union",
}

/**
 * SorResolution
 * What an operator found at the SoR for an attempt the reconciler stopped retrying.
 */
export enum SorResolveAttemptParamsSorResolution {
  CompletedAtSor = "completed_at_sor",
  NotAtSor = "not_at_sor",
}

/**
 * SorReconcileOutcome
 * What one reconciler visit did to an attempt.
 */
export enum SorReconcileReportSorReconcileOutcome {
  Completed = "completed",
  Failed = "failed",
  Retrying = "retrying",
  NeedsAttention = "needs_attention",
  Unreachable = "unreachable",
  LoginRequired = "login_required",
}

/**
 * SorIssueStatus
 * An attempt's status as the Issues tab lists it: the stored status, except that an open attempt the
 * reconciler stopped retrying (``tries >= max_tries``) is ``needs_attention`` rather than ``pending`` or
 * ``remote_done``. Not stored: it is derived from the counter, so no write has to keep it in step.
 */
export enum SorIssueIdsParamsSorIssueStatus {
  NeedsAttention = "needs_attention",
  Pending = "pending",
  RemoteDone = "remote_done",
  Completed = "completed",
  Failed = "failed",
}

/**
 * SorIssueStatus
 * An attempt's status as the Issues tab lists it: the stored status, except that an open attempt the
 * reconciler stopped retrying (``tries >= max_tries``) is ``needs_attention`` rather than ``pending`` or
 * ``remote_done``. Not stored: it is derived from the counter, so no write has to keep it in step.
 */
export enum SorIssueSorIssueStatus {
  NeedsAttention = "needs_attention",
  Pending = "pending",
  RemoteDone = "remote_done",
  Completed = "completed",
  Failed = "failed",
}

/** SorCommitStatus */
export enum SorIssueSorCommitStatus {
  Pending = "pending",
  RemoteDone = "remote_done",
  Completed = "completed",
  Failed = "failed",
}

/**
 * SorAuthMode
 * How CMS authenticates its calls to the organization's SoR.
 */
export enum SorConfigurationResponseSorAuthMode {
  StaticToken = "static_token",
  UserSsoToken = "user_sso_token",
}

/**
 * SorAuthMode
 * How CMS authenticates its calls to the organization's SoR.
 */
export enum SorConfigurationParamsSorAuthMode {
  StaticToken = "static_token",
  UserSsoToken = "user_sso_token",
}

/** SorCommitStatus */
export enum SorActiveAttemptResponseSorCommitStatus {
  Pending = "pending",
  RemoteDone = "remote_done",
  Completed = "completed",
  Failed = "failed",
}

/**
 * SlaTemplateSource
 * Which SLA collection a template card came from.
 *
 * Also the picker's grouping: the curated system cards come first, the organization's own
 * folder after.
 */
export enum SlaTemplateItemListSlaTemplateSource {
  System = "system",
  Organization = "organization",
}

/**
 * SlaEntityLevel
 * What a rule's card returns one row per, derived from its column set.
 */
export enum SlaTemplateItemListSlaEntityLevel {
  Claim = "claim",
  Exposure = "exposure",
}

/**
 * SlaActionType
 * The action menu the SLA engine offers.
 *
 * Deliberately independent of the automation engine's action taxonomy: the SLA engine
 * does not run the automation rule engine and reads none of its action models.
 */
export enum SlaRuleUpdateRequestSlaActionType {
  Notification = "notification",
  Email = "email",
  Sms = "sms",
  EmailSuggestion = "email_suggestion",
}

/**
 * SlaEntityLevel
 * What a rule's card returns one row per, derived from its column set.
 */
export enum SlaRuleListResponseSlaEntityLevel {
  Claim = "claim",
  Exposure = "exposure",
}

/**
 * SlaActionType
 * The action menu the SLA engine offers.
 *
 * Deliberately independent of the automation engine's action taxonomy: the SLA engine
 * does not run the automation rule engine and reads none of its action models.
 */
export enum SlaRuleListResponseSlaActionType {
  Notification = "notification",
  Email = "email",
  Sms = "sms",
  EmailSuggestion = "email_suggestion",
}

/**
 * SlaEntityLevel
 * What a rule's card returns one row per, derived from its column set.
 */
export enum SlaRuleDTOSlaEntityLevel {
  Claim = "claim",
  Exposure = "exposure",
}

/**
 * SlaActionType
 * The action menu the SLA engine offers.
 *
 * Deliberately independent of the automation engine's action taxonomy: the SLA engine
 * does not run the automation rule engine and reads none of its action models.
 */
export enum SlaRuleDTOSlaActionType {
  Notification = "notification",
  Email = "email",
  Sms = "sms",
  EmailSuggestion = "email_suggestion",
}

/**
 * SlaActionType
 * The action menu the SLA engine offers.
 *
 * Deliberately independent of the automation engine's action taxonomy: the SLA engine
 * does not run the automation rule engine and reads none of its action models.
 */
export enum SlaRuleCreateRequestSlaActionType {
  Notification = "notification",
  Email = "email",
  Sms = "sms",
  EmailSuggestion = "email_suggestion",
}

/**
 * SlaActionType
 * The action menu the SLA engine offers.
 *
 * Deliberately independent of the automation engine's action taxonomy: the SLA engine
 * does not run the automation rule engine and reads none of its action models.
 */
export enum SlaRecipientOptionItemListSlaActionType {
  Notification = "notification",
  Email = "email",
  Sms = "sms",
  EmailSuggestion = "email_suggestion",
}

/**
 * DocumentTypeGroup
 * The named groups of document types the store assigns at store time.  The authoritative vocabulary for ``AppliesTo.type_groups`` on the ``document_signals`` config contract: ``DOCUMENT_TYPE_GROUPS`` keeps each group's document types, and CMS consumes this enum through the generated client, so a consumer can only name groups the store actually assigns.
 */
export enum SignalConfigEntryListDocumentTypeGroup {
  Images = "images",
  TextualFiles = "textual_files",
  Communications = "communications",
  Notes = "notes",
  Other = "other",
}

/**
 * StructuredOutputComponent
 * How an expert's structured output should be rendered in the insight UI.
 *
 * A semantic render descriptor owned by CMS, not a binding to a concrete UI
 * component. ``key_value`` means "render one object's fields as a label→value
 * list". Future-proofed so new layouts (e.g. a genuine collection ``table``) can
 * be added without a schema change.
 *
 * The layout was originally named ``table``; that legacy value is still accepted
 * on read as an alias for ``key_value`` so overrides persisted before the rename
 * keep deserializing. A data migration rewrites the stored values in place.
 */
export enum SetAiExpertScopeRequestStructuredOutputComponent {
  KeyValue = "key_value",
}

/** ConfiguredFieldType */
export enum SetAiExpertScopeRequestConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/**
 * DocumentRequestFileScanState
 * The malware-scan verdict per uploaded file. ``ERROR`` blocks, exactly like ``SUSPICIOUS``.
 *
 * This path fails closed: a scan that errored is never treated as clean, and the recovery is a
 * rescan rather than an override.
 */
export enum ScanStateDTODocumentRequestFileScanState {
  PENDING = "PENDING",
  CLEAN = "CLEAN",
  SUSPICIOUS = "SUSPICIOUS",
  ERROR = "ERROR",
}

/** PayableType */
export enum SaveInvoiceResponsePayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** InvoiceProcessingType */
export enum SaveInvoiceResponseInvoiceProcessingType {
  OdieInvoice = "odie_invoice",
  GenericInvoice = "generic_invoice",
}

/** CoverageDecisionOption */
export enum SaveInvoiceResponseCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/** PayableType */
export enum SaveInvoiceRequestPayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** InvoiceProcessingType */
export enum SaveInvoiceRequestInvoiceProcessingType {
  OdieInvoice = "odie_invoice",
  GenericInvoice = "generic_invoice",
}

/** CoverageDecisionOption */
export enum SaveInvoiceRequestCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/** PayableType */
export enum SaveInvoiceAndUpdateAiRequestPayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** InvoiceProcessingType */
export enum SaveInvoiceAndUpdateAiRequestInvoiceProcessingType {
  OdieInvoice = "odie_invoice",
  GenericInvoice = "generic_invoice",
}

/** CoverageDecisionOption */
export enum SaveInvoiceAndUpdateAiRequestCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/** FilteringMode */
export enum RulesEngineConditionFieldsParamsFilteringMode {
  Intersection = "intersection",
  Union = "union",
}

/**
 * RuleAssigneeKind
 * The four kinds an assignment rule's assignee can be.
 */
export enum RuleAssigneeOptionInfoListRuleAssigneeKind {
  FnolTaker = "fnol_taker",
  ClaimOwner = "claim_owner",
  User = "user",
  Group = "group",
}

/**
 * FieldType
 * Type of a queryable field. Mirrors `ConfiguredFieldType` plus `datetime` / `hierarchical`.
 *
 * - `datetime` — distinct from `date` and `time`; ISO datetime string semantics in CEL.
 * - `hierarchical` — composite parent+children value; rendered via a parent-select +
 *   dependent-child-multiselect FE adapter; emitted as `parent == 'X' && child in [...]`
 *   by the CEL compiler. See DR §5.13.
 * - `collection` — a list of rows a leaf *quantifies over* rather than compares:
 *   the leaf carries a `match` mode and a nested group of predicates on the row's own
 *   elements, and the compiler emits a CEL comprehension (`path.exists(_c0, …)`). The only
 *   type whose leaf has no scalar operand space at all, which is why the FE offers it no
 *   operators. See `cel/collections.py` for the element/alias scheme.
 * - `user` — a user's id. Compared only with another `user` field (`=` / `!=` against an
 *   `{anchor: <path>}` value) or tested for presence, never with a literal: an id is not
 *   something an author types, and a rule naming one would stop matching when the user leaves.
 */
export enum ResolvedClaimFieldsResponseFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
  Datetime = "datetime",
  Hierarchical = "hierarchical",
  Collection = "collection",
  User = "user",
}

/** GlobalFieldPlacement */
export enum ReorderGlobalFieldsParamsGlobalFieldPlacement {
  Policy = "policy",
  IncidentDetails = "incident_details",
  SupplementaryInformation = "supplementary_information",
  FirstPartyInvolved = "first_party_involved",
  ThirdPartyInvolved = "third_party_involved",
}

/** GlobalFieldAnchor */
export enum ReorderGlobalFieldsParamsGlobalFieldAnchor {
  Start = "start",
  End = "end",
}

/**
 * RecoveryRequestDerivedStatus
 * What a caller sees: the stored lifecycle statuses plus the two settlement-derived ones.
 */
export enum RecoveryRequestListResponseRecoveryRequestDerivedStatus {
  Pending = "pending",
  Requested = "requested",
  Cancelled = "cancelled",
  Failed = "failed",
  Expired = "expired",
  PartiallyPaid = "partially_paid",
  Paid = "paid",
}

/**
 * RecoveryRequestDerivedStatus
 * What a caller sees: the stored lifecycle statuses plus the two settlement-derived ones.
 */
export enum RecoveryRequestInfoRecoveryRequestDerivedStatus {
  Pending = "pending",
  Requested = "requested",
  Cancelled = "cancelled",
  Failed = "failed",
  Expired = "expired",
  PartiallyPaid = "partially_paid",
  Paid = "paid",
}

/**
 * EntityType
 * EntityType
 */
export enum PolicySearchResponseEntityType {
  Person = "person",
  Property = "property",
  Company = "company",
}

/**
 * SorIssueStatus
 * An attempt's status as the Issues tab lists it: the stored status, except that an open attempt the
 * reconciler stopped retrying (``tries >= max_tries``) is ``needs_attention`` rather than ``pending`` or
 * ``remote_done``. Not stored: it is derived from the counter, so no write has to keep it in step.
 */
export enum PageDataResponseSorIssueNoneTypeSorIssueStatus {
  NeedsAttention = "needs_attention",
  Pending = "pending",
  RemoteDone = "remote_done",
  Completed = "completed",
  Failed = "failed",
}

/** SorCommitStatus */
export enum PageDataResponseSorIssueNoneTypeSorCommitStatus {
  Pending = "pending",
  RemoteDone = "remote_done",
  Completed = "completed",
  Failed = "failed",
}

/**
 * FnolTaskErrorType
 * Classification of FNOL task error types for better error reporting.
 */
export enum PageDataResponseFnolInboxRecordNoneTypeFnolTaskErrorType {
  GeneralError = "general_error",
  PolicyNotFound = "policy_not_found",
  ProcessingError = "processing_error",
  Other = "other",
}

/** FnolInboxStatus */
export enum PageDataResponseFnolInboxRecordNoneTypeFnolInboxStatus {
  AiProcessing = "ai_processing",
  AiNew = "ai_new",
  New = "new",
  Created = "created",
  Attached = "attached",
  Dismissed = "dismissed",
  AiProcessingFailed = "ai_processing_failed",
  AiPolicyNotFound = "ai_policy_not_found",
  NoLobAndSubOrg = "no_lob_and_sub_org",
}

/** ConfiguredFieldType */
export enum OrganizationDocumentTypesDictConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/** NotificationsType */
export enum NotificationTypeCountListNotificationsType {
  InternalCommunicationClaimNotification = "internal_communication_claim_notification",
  FinancialRequestDecisionClaimNotification = "financial_request_decision_claim_notification",
  ClaimOwnerChangeClaimNotification = "claim_owner_change_claim_notification",
  CommunicationClaimNotification = "communication_claim_notification",
  ReminderClaimNotification = "reminder_claim_notification",
  CommunicationSuggestionClaimNotificationModel = "communication_suggestion_claim_notification_model",
}

/** NotificationKanbanConfigurationColumnEnum */
export enum NotificationKanbanConfigurationUpdateParamsNotificationKanbanConfigurationColumnEnum {
  Priority = "priority",
  DueDate = "due_date",
}

/** NotificationKanbanConfigurationColumnEnum */
export enum NotificationKanbanConfigurationParamsNotificationKanbanConfigurationColumnEnum {
  Priority = "priority",
  DueDate = "due_date",
}

/** AssigneeSelectOptionEnum */
export enum MoiAssigneeMethodResponseAssigneeSelectOptionEnum {
  InternalUser = "internal_user",
  ServiceProvider = "service_provider",
}

/** AssigneeMethodTypeEnum */
export enum MoiAssigneeMethodResponseAssigneeMethodTypeEnum {
  Standard = "standard",
  VendorSearch = "vendor_search",
}

/** MockPoolTool */
export enum MockPoolSearchRequestMockPoolTool {
  ClaimSearch = "claim_search",
  PolicySearch = "policy_search",
}

/**
 * ObjectType
 * Types of covered objects and involved parties.
 */
export enum LobConfigurationUpdateRequestObjectType {
  Person = "person",
  Property = "property",
}

/** ConfiguredFieldType */
export enum LobConfigurationUpdateRequestConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/**
 * ObjectType
 * Types of covered objects and involved parties.
 */
export enum LobConfigurationListObjectType {
  Person = "person",
  Property = "property",
}

/** ConfiguredFieldType */
export enum LobConfigurationListConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/**
 * ObjectType
 * Types of covered objects and involved parties.
 */
export enum LobConfigurationCreateRequestObjectType {
  Person = "person",
  Property = "property",
}

/** ConfiguredFieldType */
export enum LobConfigurationCreateRequestConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/**
 * ObjectType
 * Types of covered objects and involved parties.
 */
export enum LobConfigurationObjectType {
  Person = "person",
  Property = "property",
}

/** ConfiguredFieldType */
export enum LobConfigurationConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/**
 * LegacyOrgFeatureArea
 * Where in the product a feature shows; the values are the labels on the Legacy Bespoke Features page.
 */
export enum LegacyOrgFeatureResponseListLegacyOrgFeatureArea {
  Payments = "Payments",
  FNOL = "FNOL",
  ClaimPage = "Claim page",
  SearchAndLists = "Search and lists",
  DashboardsAndReports = "Dashboards and reports",
  Integrations = "Integrations",
  Communications = "Communications",
  Configuration = "Configuration",
  HelpAndSupport = "Help and support",
}

/** PayableType */
export enum InvoiceResponsePayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** InvoiceProcessingType */
export enum InvoiceResponseInvoiceProcessingType {
  OdieInvoice = "odie_invoice",
  GenericInvoice = "generic_invoice",
}

/** CoverageDecisionOption */
export enum InvoiceResponseCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/** PayableType */
export enum InvoiceListResponsePayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** InvoiceProcessingType */
export enum InvoiceListResponseInvoiceProcessingType {
  OdieInvoice = "odie_invoice",
  GenericInvoice = "generic_invoice",
}

/** CoverageDecisionOption */
export enum InvoiceListResponseCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/** CliveCoverageClassificationLevel */
export enum InvoiceConfigUpdateParamsCliveCoverageClassificationLevel {
  None = "none",
  AssignCoverage = "assign_coverage",
  FullClassification = "full_classification",
}

/** CliveCoverageClassificationLevel */
export enum InvoiceConfigInfoCliveCoverageClassificationLevel {
  None = "none",
  AssignCoverage = "assign_coverage",
  FullClassification = "full_classification",
}

/** CliveCoverageClassificationLevel */
export enum InvoiceConfigCreateParamsCliveCoverageClassificationLevel {
  None = "none",
  AssignCoverage = "assign_coverage",
  FullClassification = "full_classification",
}

/**
 * PromotionOrigin
 * Where a promotion came from, recorded on its source-side row: a live source organization, an uploaded
 * artifact, or a draft someone made through the configuration MCP.
 */
export enum IncomingPromotionListResultPromotionOrigin {
  Live = "live",
  Upload = "upload",
  McpDraft = "mcp_draft",
}

/**
 * PromotionOrigin
 * Where a promotion came from, recorded on its source-side row: a live source organization, an uploaded
 * artifact, or a draft someone made through the configuration MCP.
 */
export enum IncomingPromotionDetailPromotionOrigin {
  Live = "live",
  Upload = "upload",
  McpDraft = "mcp_draft",
}

/**
 * SorIssueStatus
 * An attempt's status as the Issues tab lists it: the stored status, except that an open attempt the
 * reconciler stopped retrying (``tries >= max_tries``) is ``needs_attention`` rather than ``pending`` or
 * ``remote_done``. Not stored: it is derived from the counter, so no write has to keep it in step.
 */
export enum IdsResponseIntSorIssueStatusCountsSorIssueStatus {
  NeedsAttention = "needs_attention",
  Pending = "pending",
  RemoteDone = "remote_done",
  Completed = "completed",
  Failed = "failed",
}

/** DataImportDirPathType */
export enum HospitalityDataImportLoadParamsDataImportDirPathType {
  Local = "local",
  FsGcs = "fs_gcs",
}

/** GlobalFieldPlacement */
export enum GlobalFieldInfoListGlobalFieldPlacement {
  Policy = "policy",
  IncidentDetails = "incident_details",
  SupplementaryInformation = "supplementary_information",
  FirstPartyInvolved = "first_party_involved",
  ThirdPartyInvolved = "third_party_involved",
}

/** GlobalFieldAnchor */
export enum GlobalFieldInfoListGlobalFieldAnchor {
  Start = "start",
  End = "end",
}

/** GlobalFieldPlacement */
export enum GlobalFieldInfoGlobalFieldPlacement {
  Policy = "policy",
  IncidentDetails = "incident_details",
  SupplementaryInformation = "supplementary_information",
  FirstPartyInvolved = "first_party_involved",
  ThirdPartyInvolved = "third_party_involved",
}

/** GlobalFieldAnchor */
export enum GlobalFieldInfoGlobalFieldAnchor {
  Start = "start",
  End = "end",
}

/** FilteringMode */
export enum GetConditionFieldsParamsFilteringMode {
  Intersection = "intersection",
  Union = "union",
}

/**
 * GenericTemplatesTokenValueType
 * What a token's resolved value is, structurally.
 *
 * ``TEXT`` is a plain scalar, safe to embed anywhere a string goes — body text or a
 * hyperlink ``href``. ``HTML`` resolves to markup (a whole ``<a>`` element, say) and
 * only makes sense in body text; putting one in an attribute would emit markup where
 * the browser expects a URL. The render path and the link dialog's token picker both
 * read this to decide which tokens an ``href`` accepts.
 */
export enum GenericTemplatesTokensResponseGenericTemplatesTokenValueType {
  Text = "text",
  Html = "html",
}

/** GeneratedReportStatus */
export enum GeneratedReportResponseGeneratedReportStatus {
  Initial = "initial",
  Processing = "processing",
  Completed = "completed",
  Failed = "failed",
}

/** GeneratedReportExportFormat */
export enum GeneratedReportResponseGeneratedReportExportFormat {
  Excel = "excel",
  Pdf = "pdf",
}

/** GeneratedReportStatus */
export enum GeneratedReportListResponseGeneratedReportStatus {
  Initial = "initial",
  Processing = "processing",
  Completed = "completed",
  Failed = "failed",
}

/** GeneratedReportExportFormat */
export enum GeneratedReportListResponseGeneratedReportExportFormat {
  Excel = "excel",
  Pdf = "pdf",
}

/** GeneratedReportExportFormat */
export enum GenerateReportRequestGeneratedReportExportFormat {
  Excel = "excel",
  Pdf = "pdf",
}

/**
 * FundAccountDefaultBehavior
 * What the engine does for a payment no rule matched.
 *
 * ``block_payment`` applies whether or not the method has a payment provider, except to a
 * portal-routed method, which no rule can be scoped to. ``default_account`` and an unconfigured
 * engine apply only to a provider-backed method, and a method with no provider resolves to no
 * account under them.
 *
 * ``send_empty`` resolves to no account whatever the provider; whether an empty account is
 * acceptable is the provider's own question, asked at the approval seam against its
 * ``is_fund_account_required`` flag. So a method whose provider requires an account and that
 * matches no rule fails there instead, and one whose provider does not is unaffected.
 *
 * (DR §13 #1 states the same rejection, but in the Vitesse-only wording it was written in when
 * Vitesse was the only provider carrying the flag; the check has read the flag since.)
 */
export enum FundAccountEngineConfigInfoFundAccountDefaultBehavior {
  DefaultAccount = "default_account",
  BlockPayment = "block_payment",
  SendEmpty = "send_empty",
}

/**
 * FnolTaskErrorType
 * Classification of FNOL task error types for better error reporting.
 */
export enum FnolInboxRecordFnolTaskErrorType {
  GeneralError = "general_error",
  PolicyNotFound = "policy_not_found",
  ProcessingError = "processing_error",
  Other = "other",
}

/** FnolInboxStatus */
export enum FnolInboxRecordFnolInboxStatus {
  AiProcessing = "ai_processing",
  AiNew = "ai_new",
  New = "new",
  Created = "created",
  Attached = "attached",
  Dismissed = "dismissed",
  AiProcessingFailed = "ai_processing_failed",
  AiPolicyNotFound = "ai_policy_not_found",
  NoLobAndSubOrg = "no_lob_and_sub_org",
}

/** FnolInboxType */
export enum FnolInboxItemIdsParamsFnolInboxType {
  InQueue = "in-queue",
  Done = "done",
}

/**
 * LineOfBusiness
 * LineOfBusiness
 */
export enum FnolFromAiRequestLineOfBusiness {
  Auto = "auto",
  Home = "home",
  Pet = "pet",
  GeneralLiability = "general_liability",
  WorkersCompensation = "workers_compensation",
  Cyber = "cyber",
  BopSmb = "bop_smb",
  GeneralProperty = "general_property",
  ProfessionalLiability = "professional_liability",
  Travel = "travel",
  Bike = "bike",
  CardProtection = "card_protection",
  Reinsurance = "reinsurance",
  ReinsuranceXol = "reinsurance_xol",
  ContractorsPlantMachinery = "contractors_plant_machinery",
  Other = "other",
}

/**
 * EntityType
 * EntityType
 */
export enum FnolFromAiRequestEntityType {
  Person = "person",
  Property = "property",
  Company = "company",
}

/**
 * CoverageIssueType
 * Coverage issues that can be raised in a claim
 */
export enum FnolFromAiRequestCoverageIssueType {
  IncidentDateOutsidePolicyPeriod = "incident_date_outside_policy_period",
  IncidentDateCloseToPolicyBoundaries = "incident_date_close_to_policy_boundaries",
  LossNotCovered = "loss_not_covered",
  LossMeetsExclusionCriteria = "loss_meets_exclusion_criteria",
}

/**
 * FieldType
 * Type of a queryable field. Mirrors `ConfiguredFieldType` plus `datetime` / `hierarchical`.
 *
 * - `datetime` — distinct from `date` and `time`; ISO datetime string semantics in CEL.
 * - `hierarchical` — composite parent+children value; rendered via a parent-select +
 *   dependent-child-multiselect FE adapter; emitted as `parent == 'X' && child in [...]`
 *   by the CEL compiler. See DR §5.13.
 * - `collection` — a list of rows a leaf *quantifies over* rather than compares:
 *   the leaf carries a `match` mode and a nested group of predicates on the row's own
 *   elements, and the compiler emits a CEL comprehension (`path.exists(_c0, …)`). The only
 *   type whose leaf has no scalar operand space at all, which is why the FE offers it no
 *   operators. See `cel/collections.py` for the element/alias scheme.
 * - `user` — a user's id. Compared only with another `user` field (`=` / `!=` against an
 *   `{anchor: <path>}` value) or tested for presence, never with a literal: an id is not
 *   something an author types, and a rule naming one would stop matching when the user leaves.
 */
export enum FieldDefinitionListFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
  Datetime = "datetime",
  Hierarchical = "hierarchical",
  Collection = "collection",
  User = "user",
}

/** ConfiguredFieldType */
export enum ExternalDocumentTypeResponseDictConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/** ConfiguredFieldType */
export enum ExternalDocumentTypeCreateRequestConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/** PayableType */
export enum ExposureLineItemsWithSummaryPayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** InvoiceProcessingType */
export enum ExposureLineItemsWithSummaryInvoiceProcessingType {
  OdieInvoice = "odie_invoice",
  GenericInvoice = "generic_invoice",
}

/** CoverageDecisionOption */
export enum ExposureLineItemsWithSummaryCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/** PayableType */
export enum ExposureLineItemsListPayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** InvoiceProcessingType */
export enum ExposureLineItemsListInvoiceProcessingType {
  OdieInvoice = "odie_invoice",
  GenericInvoice = "generic_invoice",
}

/** CoverageDecisionOption */
export enum ExposureLineItemsListCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/**
 * RequiresHumanApprovalReasonKey
 * Which gate held a ``REQUIRES_HUMAN_APPROVAL`` action for a person.
 *
 * The AI service stores the key as a plain string and never branches on it; these values are this
 * service's vocabulary, and the Conductor Hub picks the look of a waiting card's chip by them.
 *
 * - ``ALWAYS_HUMAN``: the action's execution mode is ``always_human``.
 * - ``BELOW_THRESHOLD``: the mode is ``above_threshold`` and the agent's confidence fell below it.
 * - ``GUARDRAIL``: a guardrails-engine rule only a person can clear tripped.
 */
export enum DynamicClaimActionResultRequiresHumanApprovalReasonKey {
  AlwaysHuman = "always_human",
  BelowThreshold = "below_threshold",
  Guardrail = "guardrail",
}

/**
 * ClaimActionExecutionResultType
 * How a claim action was handled, as five distinct outcomes.
 *
 * A single ``success`` flag conflates cases that mean different things: a request that is valid
 * but cannot be auto-executed without a person, a request a gate refused on a condition the
 * agent can itself satisfy, and a genuine failure (invalid params, disabled, unexpected error).
 * These keep them apart so a guardrail veto surfaces as a pending-approval card or as an in-band
 * refusal rather than as an error.
 *
 * - ``EXECUTED``: the action ran.
 * - ``REQUIRES_HUMAN_APPROVAL``: valid, but no further agent action changes the answer — the
 *   execution-mode gate refused (``always_human``, or a confidence below the configured
 *   threshold), or a guardrail tripped that only a person can clear (a ``route_to_human``
 *   outcome, or a ``warn`` escalated because a system caller has no override channel). Surfaced
 *   as pending approval, not an error.
 * - ``REFUSED_BY_GATE``: a precondition was unmet that the agent can satisfy — every tripped
 *   guardrail carried the ``block`` outcome, which is defined as "prevents the action until the
 *   rule conditions are satisfied". Not an error and not a pending card: the refusal text is
 *   returned to the agent in band, which is expected to answer it and may retry in the same run.
 *   Nothing is persisted (the veto raises before the request's single commit) and no milestone
 *   advances.
 * - ``HANDLER_HAS_CLAIM``: a handler has taken the claim over from the conductor, so the conductor's
 *   call is refused before anything runs. Not an error and not a pending card: the conductor is to
 *   stop acting on the claim. Nothing is persisted.
 * - ``ERROR``: invalid params, disabled, out-of-scope, or an unexpected failure.
 */
export enum DynamicClaimActionResultClaimActionExecutionResultType {
  Executed = "executed",
  RequiresHumanApproval = "requires_human_approval",
  RefusedByGate = "refused_by_gate",
  HandlerHasClaim = "handler_has_claim",
  Error = "error",
}

/** ConfiguredFieldType */
export enum DocumentTypeParamsConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/**
 * ESignStatus
 * E-signature request status values.
 */
export enum DocumentSignatureRequestsResponseESignStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  SENT = "SENT",
  VIEWED = "VIEWED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  ERROR = "ERROR",
}

/**
 * DocumentRequestStatus
 * The CMS mirror of the link's lifecycle.
 *
 * ``UPLOADING`` is what the app's ``signed-urls`` reports when the claimant presses "Upload and send".
 * The report is best-effort, so a link can also go straight from ``PENDING`` to ``SUBMITTED``.
 * ``CANCELLED`` is CMS's record of the app's ``revoked``, written only after the app confirmed the
 * revoke.
 */
export enum DocumentRequestListResponseDocumentRequestStatus {
  PENDING = "PENDING",
  UPLOADING = "UPLOADING",
  SUBMITTED = "SUBMITTED",
  CANCELLED = "CANCELLED",
}

/**
 * DocumentRequestFileScanState
 * The malware-scan verdict per uploaded file. ``ERROR`` blocks, exactly like ``SUSPICIOUS``.
 *
 * This path fails closed: a scan that errored is never treated as clean, and the recovery is a
 * rescan rather than an override.
 */
export enum DocumentRequestListResponseDocumentRequestFileScanState {
  PENDING = "PENDING",
  CLEAN = "CLEAN",
  SUSPICIOUS = "SUSPICIOUS",
  ERROR = "ERROR",
}

/**
 * DocumentRequestStatus
 * The CMS mirror of the link's lifecycle.
 *
 * ``UPLOADING`` is what the app's ``signed-urls`` reports when the claimant presses "Upload and send".
 * The report is best-effort, so a link can also go straight from ``PENDING`` to ``SUBMITTED``.
 * ``CANCELLED`` is CMS's record of the app's ``revoked``, written only after the app confirmed the
 * revoke.
 */
export enum DocumentRequestDTODocumentRequestStatus {
  PENDING = "PENDING",
  UPLOADING = "UPLOADING",
  SUBMITTED = "SUBMITTED",
  CANCELLED = "CANCELLED",
}

/**
 * DocumentRequestFileScanState
 * The malware-scan verdict per uploaded file. ``ERROR`` blocks, exactly like ``SUSPICIOUS``.
 *
 * This path fails closed: a scan that errored is never treated as clean, and the recovery is a
 * rescan rather than an override.
 */
export enum DocumentRequestDTODocumentRequestFileScanState {
  PENDING = "PENDING",
  CLEAN = "CLEAN",
  SUSPICIOUS = "SUSPICIOUS",
  ERROR = "ERROR",
}

/** ChangeType */
export enum DiffResponseChangeType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  REORDER = "REORDER",
}

/** DataImportDirPathType */
export enum DataImportLoadParamsDataImportDirPathType {
  Local = "local",
  FsGcs = "fs_gcs",
}

/** AllowedPayableTypes */
export enum DATypeConfigUpdateParamsAllowedPayableTypes {
  Indemnity = "indemnity",
  Expenses = "expenses",
  Both = "both",
}

/** AllowedPayableTypes */
export enum DATypeConfigInfoListAllowedPayableTypes {
  Indemnity = "indemnity",
  Expenses = "expenses",
  Both = "both",
}

/** AllowedPayableTypes */
export enum DATypeConfigInfoAllowedPayableTypes {
  Indemnity = "indemnity",
  Expenses = "expenses",
  Both = "both",
}

/** AllowedPayableTypes */
export enum DATypeConfigCreateParamsAllowedPayableTypes {
  Indemnity = "indemnity",
  Expenses = "expenses",
  Both = "both",
}

/**
 * RecoveryRequestPayableType
 * The reserve bucket the eventual recovery is intended for.
 *
 * The same two values ``RecoveryAmount.payable_type`` carries.
 */
export enum CreateRecoveryRequestParamsRecoveryRequestPayableType {
  Indemnity = "indemnity",
  Expenses = "expenses",
}

/** PayableType */
export enum CreateInvoiceRequestPayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** CoverageDecisionOption */
export enum CreateInvoiceRequestCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/** GlobalFieldPlacement */
export enum CreateGlobalFieldParamsGlobalFieldPlacement {
  Policy = "policy",
  IncidentDetails = "incident_details",
  SupplementaryInformation = "supplementary_information",
  FirstPartyInvolved = "first_party_involved",
  ThirdPartyInvolved = "third_party_involved",
}

/** GlobalFieldAnchor */
export enum CreateGlobalFieldParamsGlobalFieldAnchor {
  Start = "start",
  End = "end",
}

/**
 * ExternalToolPayloadFieldType
 * The payload-field types an external tool may declare.
 *
 * Restricted to the three types the design doc allows for external-tool payloads; the
 * manager re-validates the same allow-list against the persisted fields.
 */
export enum CreateExternalToolConfigParamsExternalToolPayloadFieldType {
  Text = "text",
  Date = "date",
  Enum = "enum",
}

/**
 * RuleAssigneeKind
 * The four kinds an assignment rule's assignee can be.
 */
export enum CreateAssignmentRuleParamsRuleAssigneeKind {
  FnolTaker = "fnol_taker",
  ClaimOwner = "claim_owner",
  User = "user",
  Group = "group",
}

/** PayableType */
export enum CoverageTotalsResponsePayableType {
  Expenses = "expenses",
  Indemnity = "indemnity",
}

/** InvoiceProcessingType */
export enum CoverageTotalsResponseInvoiceProcessingType {
  OdieInvoice = "odie_invoice",
  GenericInvoice = "generic_invoice",
}

/** CoverageDecisionOption */
export enum CoverageTotalsResponseCoverageDecisionOption {
  Covered = "covered",
  NotCovered = "not_covered",
  Excluded = "excluded",
}

/**
 * TokenBlankReason
 * Why a token resolved to no value, for the internal per-claim token inspector.
 */
export enum ClaimTokenValuesResponseTokenBlankReason {
  MissingContext = "missing_context",
  EvaluationError = "evaluation_error",
  GroupAllBlank = "group_all_blank",
  FieldEmpty = "field_empty",
}

/**
 * BulkResultErrorCode
 * Why one claim in a bulk request failed, as a value an integrator can branch on.
 *
 * ``error_message`` is free text for a human reading a log; retrying a partial batch programmatically
 * needs a stable value, and string-matching the message is not one. ALREADY_APPLIED / NOT_APPLIED are the
 * retry-safe outcomes (the claim is already in the requested state, so the retry can be treated as done);
 * every other code is a genuine failure. Both are emitted only for an item naming exactly ONE flag key,
 * because a flag item is applied all-or-nothing: a multi-key item rejected for one already-applied key
 * also rejected its other keys, so "treat as done" would silently lose them. Such a rejection carries a
 * null code and an ``error_message`` naming the offending key.
 *
 * One set is shared by the per-claim bulk endpoints (stage update, flag apply, flag remove) because they
 * share the loop that produces the results and the ``report_event`` seam the guardrails veto rides. Not
 * every code is reachable from every endpoint: the flag-specific ones (ALREADY_APPLIED / NOT_APPLIED /
 * FLAG_DISABLED) come only from the flag endpoints. NOT_FOUND deliberately covers every way a target can
 * be unaddressable -- an unknown claim number, a claim outside the caller's sub-org or the flag's LoB
 * scope, an ambiguous case-collision, an unknown flag key on the apply path -- rather than enumerating
 * causes an integrator would handle identically. A rejection outside this set leaves ``error_code`` null,
 * so a null code means "no published code for this failure", never "no failure": read ``success``.
 */
export enum ClaimStageBulkUpdateResponseBulkResultErrorCode {
  ALREADY_APPLIED = "ALREADY_APPLIED",
  NOT_APPLIED = "NOT_APPLIED",
  NOT_FOUND = "NOT_FOUND",
  FLAG_DISABLED = "FLAG_DISABLED",
  GUARDRAIL_BLOCKED = "GUARDRAIL_BLOCKED",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

/**
 * ClaimChangeSource
 * How a change to a claim (its stage, a milestone date) was initiated.
 */
export enum ClaimMilestonesResponseClaimChangeSource {
  UI = "UI",
  API = "API",
  BULK = "BULK",
  SYSTEM = "SYSTEM",
  AGENT = "AGENT",
}

/**
 * ClaimChangeSource
 * How a change to a claim (its stage, a milestone date) was initiated.
 */
export enum ClaimMilestoneModelClaimChangeSource {
  UI = "UI",
  API = "API",
  BULK = "BULK",
  SYSTEM = "SYSTEM",
  AGENT = "AGENT",
}

/**
 * InspectionScope
 * What the inspection was raised against.
 */
export enum ClaimInspectionsResourceSchemaInspectionScope {
  Claim = "claim",
  Exposure = "exposure",
  Exposures = "exposures",
}

/**
 * InspectionOutcome
 * How an inspection currently stands.  A published vocabulary, not the database status: ``pending`` and ``accepted`` both collapse to ``IN_PROGRESS``, and ``completed`` maps to ``AWAITING_REVIEW`` because it means the vendor finished, not the inspection finished. ``REJECTED`` conflates vendor-declined, adjuster-rejected and integration-cancelled.
 */
export enum ClaimInspectionsResourceSchemaInspectionOutcome {
  InProgress = "in_progress",
  AwaitingReview = "awaiting_review",
  Done = "done",
  Rejected = "rejected",
  CalledOff = "called_off",
}

/**
 * AssigneeKind
 * Who the inspection is assigned to, without naming them.
 */
export enum ClaimInspectionsResourceSchemaAssigneeKind {
  InternalUser = "internal_user",
  ServiceProvider = "service_provider",
}

/**
 * BulkResultErrorCode
 * Why one claim in a bulk request failed, as a value an integrator can branch on.
 *
 * ``error_message`` is free text for a human reading a log; retrying a partial batch programmatically
 * needs a stable value, and string-matching the message is not one. ALREADY_APPLIED / NOT_APPLIED are the
 * retry-safe outcomes (the claim is already in the requested state, so the retry can be treated as done);
 * every other code is a genuine failure. Both are emitted only for an item naming exactly ONE flag key,
 * because a flag item is applied all-or-nothing: a multi-key item rejected for one already-applied key
 * also rejected its other keys, so "treat as done" would silently lose them. Such a rejection carries a
 * null code and an ``error_message`` naming the offending key.
 *
 * One set is shared by the per-claim bulk endpoints (stage update, flag apply, flag remove) because they
 * share the loop that produces the results and the ``report_event`` seam the guardrails veto rides. Not
 * every code is reachable from every endpoint: the flag-specific ones (ALREADY_APPLIED / NOT_APPLIED /
 * FLAG_DISABLED) come only from the flag endpoints. NOT_FOUND deliberately covers every way a target can
 * be unaddressable -- an unknown claim number, a claim outside the caller's sub-org or the flag's LoB
 * scope, an ambiguous case-collision, an unknown flag key on the apply path -- rather than enumerating
 * causes an integrator would handle identically. A rejection outside this set leaves ``error_code`` null,
 * so a null code means "no published code for this failure", never "no failure": read ``success``.
 */
export enum ClaimFlagsBulkResponseBulkResultErrorCode {
  ALREADY_APPLIED = "ALREADY_APPLIED",
  NOT_APPLIED = "NOT_APPLIED",
  NOT_FOUND = "NOT_FOUND",
  FLAG_DISABLED = "FLAG_DISABLED",
  GUARDRAIL_BLOCKED = "GUARDRAIL_BLOCKED",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

/**
 * ConductorStatus
 * Whether the conductor is working on a claim and, when it is not, why.  ``PREPARING`` (the run's row committed, no worker has it yet), ``RUNNING`` (a worker is executing it, setup included) and ``WAITING_ON_EXPERTS`` (the run ended with consults open, whose answers wake the next) are active. Every ``ConductorRunDisposition`` member is mirrored value-for-value (pinned by a test) as the ending of a run that recorded one, and ``CRASHED`` is the ending of a run an unexpected exception ended, which records none.
 */
export enum ClaimConductorStatusResponseConductorStatus {
  Preparing = "preparing",
  Running = "running",
  Completed = "completed",
  PendingApproval = "pending_approval",
  Error = "error",
  Escalated = "escalated",
  WaitingOnExperts = "waiting_on_experts",
  Replied = "replied",
  Yielded = "yielded",
  Stopped = "stopped",
  Interrupted = "interrupted",
  Crashed = "crashed",
}

/**
 * ClaimChangeSource
 * How a change to a claim (its stage, a milestone date) was initiated.
 */
export enum ClaimConductorStageHistoryResponseClaimChangeSource {
  UI = "UI",
  API = "API",
  BULK = "BULK",
  SYSTEM = "SYSTEM",
  AGENT = "AGENT",
}

/**
 * ToldVia
 * How the first run to be told a message was told it: in the run-start block, or by the mid-run inbox at a turn boundary.
 */
export enum ClaimConductorMessagesResponseToldVia {
  RunStart = "run_start",
  Inbox = "inbox",
}

/**
 * MessageStatus
 * Whether a run has yet to answer the message.  The reply a run gives in ``finalize`` closes it, with every other message that run was told.
 */
export enum ClaimConductorMessagesResponseMessageStatus {
  Open = "open",
  Closed = "closed",
}

/**
 * MessageStatus
 * Whether a run has yet to answer the message.  The reply a run gives in ``finalize`` closes it, with every other message that run was told.
 */
export enum ClaimConductorMessagesQueryMessageStatus {
  Open = "open",
  Closed = "closed",
}

/**
 * ToldVia
 * How the first run to be told a message was told it: in the run-start block, or by the mid-run inbox at a turn boundary.
 */
export enum ClaimConductorMessageResponseToldVia {
  RunStart = "run_start",
  Inbox = "inbox",
}

/**
 * MessageStatus
 * Whether a run has yet to answer the message.  The reply a run gives in ``finalize`` closes it, with every other message that run was told.
 */
export enum ClaimConductorMessageResponseMessageStatus {
  Open = "open",
  Closed = "closed",
}

/**
 * HandlingMode
 * Who is driving the claim: the conductor, or a person who took it over.
 */
export enum ClaimConductorHandlingResponseHandlingMode {
  Conductor = "conductor",
  Handler = "handler",
}

/**
 * AskStatus
 * Whether the ask is still the handler's to deal with.  Two values only: how an ask ended is carried by ``human_response`` and ``agent_closure``, not by a third status.
 */
export enum ClaimConductorAsksResponseAskStatus {
  Open = "open",
  Closed = "closed",
}

/**
 * AgentClosedAs
 * How the agent itself closed an ask — both members are terminal.  ``RESOLVED`` is a request only — the work the agent asked for arrived. ``WITHDRAWN`` is either kind: the claim moved on and the ask no longer matters.
 */
export enum ClaimConductorAsksResponseAgentClosedAs {
  Resolved = "resolved",
  Withdrawn = "withdrawn",
}

/**
 * AskStatus
 * Whether the ask is still the handler's to deal with.  Two values only: how an ask ended is carried by ``human_response`` and ``agent_closure``, not by a third status.
 */
export enum ClaimConductorAsksQueryAskStatus {
  Open = "open",
  Closed = "closed",
}

/**
 * AskStatus
 * Whether the ask is still the handler's to deal with.  Two values only: how an ask ended is carried by ``human_response`` and ``agent_closure``, not by a third status.
 */
export enum ClaimConductorAskResponseAskStatus {
  Open = "open",
  Closed = "closed",
}

/**
 * AgentClosedAs
 * How the agent itself closed an ask — both members are terminal.  ``RESOLVED`` is a request only — the work the agent asked for arrived. ``WITHDRAWN`` is either kind: the claim moved on and the ask no longer matters.
 */
export enum ClaimConductorAskResponseAgentClosedAs {
  Resolved = "resolved",
  Withdrawn = "withdrawn",
}

/**
 * EntityType
 * EntityType
 */
export enum ClaimActionToolConfigListEntityType {
  Person = "person",
  Property = "property",
  Company = "company",
}

/**
 * DynamicDataModelFieldType
 * DynamicDataModelFieldType
 */
export enum ClaimActionToolConfigListDynamicDataModelFieldType {
  EntityReference = "entity_reference",
  Enum = "enum",
  EnumList = "enum_list",
  Text = "text",
  Boolean = "boolean",
  Date = "date",
  Time = "time",
  Datetime = "datetime",
  Year = "year",
  Number = "number",
  Model = "model",
  ModelList = "model_list",
  Location = "location",
  DocumentReference = "document_reference",
  DocumentReferenceList = "document_reference_list",
}

/**
 * ClaimActionKind
 * What a client-defined claim action *is* to the AI service.  The published closed set of kinds the service can dispatch on, and the single definition site for it: the generated ``fivesigma-ai`` client renders this as a real enum class, so CMS discriminates on a named member rather than a bare string. A kind exists so code can test for an action (e.g. gate the one that moves the claim between stages) rather than treat every action as opaque; it is single-valued and coexists with the per-action flags (``is_milestone``) rather than absorbing them. A ``SEARCH`` action finds things and records no decision.  The set being closed does not make the contract brittle: the two services deploy independently, and the *validator* on ``ClaimActionToolConfig.kind`` accepts a value outside this set by degrading it to ``None``. Publishing the enum and accepting outside it buys both the named type and the forward-compatibility.
 */
export enum ClaimActionToolConfigListClaimActionKind {
  StageChange = "stage_change",
  Search = "search",
}

/** ChangeType */
export enum AuditedConfigurationChangeListChangeType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  REORDER = "REORDER",
}

/**
 * RuleAssigneeKind
 * The four kinds an assignment rule's assignee can be.
 */
export enum AssignmentRuleInfoListRuleAssigneeKind {
  FnolTaker = "fnol_taker",
  ClaimOwner = "claim_owner",
  User = "user",
  Group = "group",
}

/**
 * EntityType
 * EntityType
 */
export enum AnalyzerConfigEntryListEntityType {
  Person = "person",
  Property = "property",
  Company = "company",
}

/**
 * DynamicDataModelFieldType
 * DynamicDataModelFieldType
 */
export enum AnalyzerConfigEntryListDynamicDataModelFieldType {
  EntityReference = "entity_reference",
  Enum = "enum",
  EnumList = "enum_list",
  Text = "text",
  Boolean = "boolean",
  Date = "date",
  Time = "time",
  Datetime = "datetime",
  Year = "year",
  Number = "number",
  Model = "model",
  ModelList = "model_list",
  Location = "location",
  DocumentReference = "document_reference",
  DocumentReferenceList = "document_reference_list",
}

/** ClaimInsightType */
export enum AiInsightsAndReferencesResponseClaimInsightType {
  DataExtraction = "data_extraction",
  DataPoint = "data_point",
  Warning = "warning",
  General = "general",
  Financial = "financial",
  Complexity = "complexity",
  ExpertAnalysis = "expert_analysis",
}

/** ClaimInsightType */
export enum AiInsightHistoryResponseClaimInsightType {
  DataExtraction = "data_extraction",
  DataPoint = "data_point",
  Warning = "warning",
  General = "general",
  Financial = "financial",
  Complexity = "complexity",
  ExpertAnalysis = "expert_analysis",
}

/**
 * StructuredOutputComponent
 * How an expert's structured output should be rendered in the insight UI.
 *
 * A semantic render descriptor owned by CMS, not a binding to a concrete UI
 * component. ``key_value`` means "render one object's fields as a label→value
 * list". Future-proofed so new layouts (e.g. a genuine collection ``table``) can
 * be added without a schema change.
 *
 * The layout was originally named ``table``; that legacy value is still accepted
 * on read as an alias for ``key_value`` so overrides persisted before the rename
 * keep deserializing. A data migration rewrites the stored values in place.
 */
export enum AiExpertScopeConfigurationInfoListStructuredOutputComponent {
  KeyValue = "key_value",
}

/** ConfiguredFieldType */
export enum AiExpertScopeConfigurationInfoListConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/**
 * StructuredOutputComponent
 * How an expert's structured output should be rendered in the insight UI.
 *
 * A semantic render descriptor owned by CMS, not a binding to a concrete UI
 * component. ``key_value`` means "render one object's fields as a label→value
 * list". Future-proofed so new layouts (e.g. a genuine collection ``table``) can
 * be added without a schema change.
 *
 * The layout was originally named ``table``; that legacy value is still accepted
 * on read as an alias for ``key_value`` so overrides persisted before the rename
 * keep deserializing. A data migration rewrites the stored values in place.
 */
export enum AiExpertScopeConfigurationInfoStructuredOutputComponent {
  KeyValue = "key_value",
}

/** ConfiguredFieldType */
export enum AiExpertScopeConfigurationInfoConfiguredFieldType {
  Boolean = "boolean",
  String = "string",
  MultilineString = "multiline_string",
  Number = "number",
  Monetary = "monetary",
  Location = "location",
  Contact = "contact",
  YesNoNaUnknown = "yes_no_na_unknown",
  Select = "select",
  Multiselect = "multiselect",
  UsStateSelect = "us_state_select",
  Date = "date",
  Time = "time",
}

/** ExchangeStatus */
export enum AgentExchangeExchangeStatus {
  Processing = "processing",
  Completed = "completed",
  Failed = "failed",
}

/** ExchangeStatus */
export enum AgentConversationExchangeStatus {
  Processing = "processing",
  Completed = "completed",
  Failed = "failed",
}

/** ActivePolicyCategoriesResponse */
export interface ActivePolicyCategoriesResponse {
  /** Active Policy Category Ids */
  active_policy_category_ids?: string[];
}

/**
 * AdaptedValidationError
 * Model of a validation error response for Spectree.
 */
export interface AdaptedValidationError {
  /** Errors */
  errors: Record<string, any>[];
  /** Message */
  message: string;
}

/** AddBulkDocuments */
export interface AddBulkDocuments {
  /** Assignment Token */
  assignment_token: string;
  /** Documents */
  documents: AddBulkDocumentsDocumentParam[];
}

/** DocumentParam */
export interface AddBulkDocumentsDocumentParam {
  /**
   * Additional Fields
   * Values for the document type's configured additional fields, keyed by field id. Validated against the document type's configured_fields definition; mandatory fields must be present and field-type validation applies.
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Extension
   * @default null
   */
  document_extension?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Type
   * @default null
   */
  document_type?: string | null;
  /**
   * Document Url
   * @default null
   */
  document_url?: string | null;
  /**
   * Exposure Numbers
   * List of exposure numbers associated with the document
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Exposures
   * Deprecated: Use exposure_numbers instead
   * @deprecated
   * @default null
   */
  exposures?: string[] | null;
  /** External Id */
  external_id: string;
  /**
   * Storage File Uuid
   * @default null
   */
  storage_file_uuid?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** AddBulkDocumentsParams */
export interface AddBulkDocumentsParams {
  /** Documents */
  documents: AddBulkDocumentsParamsDocumentParam[];
}

/** DocumentParam */
export interface AddBulkDocumentsParamsDocumentParam {
  /**
   * Additional Fields
   * Values for the document type's configured additional fields, keyed by field id. Validated against the document type's configured_fields definition; mandatory fields must be present and field-type validation applies.
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Extension
   * @default null
   */
  document_extension?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Type
   * @default null
   */
  document_type?: string | null;
  /**
   * Document Url
   * @default null
   */
  document_url?: string | null;
  /**
   * Exposure Numbers
   * List of exposure numbers associated with the document
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Exposures
   * Deprecated: Use exposure_numbers instead
   * @deprecated
   * @default null
   */
  exposures?: string[] | null;
  /** External Id */
  external_id: string;
  /**
   * Storage File Uuid
   * @default null
   */
  storage_file_uuid?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** AddContactToClaimResponse */
export interface AddContactToClaimResponse {
  /** Contact Id */
  contact_id: number;
}

/** AddDocumentParams */
export interface AddDocumentParams {
  document: AddDocumentParamsDocumentParam;
}

/** DocumentParam */
export interface AddDocumentParamsDocumentParam {
  /**
   * Additional Fields
   * Values for the document type's configured additional fields, keyed by field id. Validated against the document type's configured_fields definition; mandatory fields must be present and field-type validation applies.
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Extension
   * @default null
   */
  document_extension?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Type
   * @default null
   */
  document_type?: string | null;
  /**
   * Document Url
   * @default null
   */
  document_url?: string | null;
  /**
   * Exposure Numbers
   * List of exposure numbers associated with the document
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Exposures
   * Deprecated: Use exposure_numbers instead
   * @deprecated
   * @default null
   */
  exposures?: string[] | null;
  /** External Id */
  external_id: string;
  /**
   * Storage File Uuid
   * @default null
   */
  storage_file_uuid?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** AddDocumentQuery */
export interface AddDocumentQuery {
  /**
   * Beta
   * beta=true will return 200 response with body instead of 204. 204 responses will eventually be deprecated
   * @default false
   */
  beta?: boolean | null;
}

/** AddDocumentResponse */
export interface AddDocumentResponse {
  /** Api Uid */
  api_uid: string;
}

/** AddGeneralRecoveryGroupParams */
export interface AddGeneralRecoveryGroupParams {
  /**
   * Allocations
   * @minItems 1
   */
  allocations: AddGeneralRecoveryGroupParamsGeneralRecoveryAllocation[];
  /**
   * Cap Override Reason
   * @default null
   */
  cap_override_reason?: string | null;
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * Entered Basis
   * @default null
   */
  entered_basis?: "gross" | "net" | null;
  /**
   * Is Vat Included
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /** Recovered From Contact Id */
  recovered_from_contact_id: number;
  /**
   * Reference
   * @default null
   */
  reference?: string | null;
  /**
   * Settles Recovery Request Id
   * @default null
   */
  settles_recovery_request_id?: number | null;
}

/** GeneralRecoveryAllocation */
export interface AddGeneralRecoveryGroupParamsGeneralRecoveryAllocation {
  /** Amount */
  amount: number;
  /**
   * General Recovery Type
   * @default null
   */
  general_recovery_type?: string | null;
  /** Payable Type */
  payable_type: "indemnity" | "expenses";
  /**
   * Vat Amount
   * @default null
   */
  vat_amount?: number | null;
}

/** AddGeneralRecoveryGroupResponse */
export interface AddGeneralRecoveryGroupResponse {
  /** Ids */
  ids: number[];
  /**
   * Recovery Group Id
   * @default null
   */
  recovery_group_id?: string | null;
}

/** AddGeneralRecoveryParams */
export interface AddGeneralRecoveryParams {
  /** Amount */
  amount: number;
  /**
   * Cap Override Reason
   * @default null
   */
  cap_override_reason?: string | null;
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * Entered Basis
   * @default null
   */
  entered_basis?: "gross" | "net" | null;
  /**
   * General Recovery Type
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * Is Vat Included
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /** Recovered From Contact Id */
  recovered_from_contact_id: number;
  /**
   * Reference
   * @default null
   */
  reference?: string | null;
  /**
   * Settles Recovery Request Id
   * @default null
   */
  settles_recovery_request_id?: number | null;
  /**
   * Vat Amount
   * @default null
   */
  vat_amount?: number | null;
}

/** AddGeneralRecoveryResponse */
export interface AddGeneralRecoveryResponse {
  /** Id */
  id: number;
}

/** AddInvolvedPartyParams */
export interface AddInvolvedPartyParams {
  /**
   * Contacts
   * @default []
   */
  contacts?:
    | (
        | ({
            creation_mode: "";
          } & AddInvolvedPartyParamsContactInNewParam)
        | ({
            creation_mode: "existing";
          } & AddInvolvedPartyParamsContactInExistingParam)
        | ({
            creation_mode: "new";
          } & AddInvolvedPartyParamsContactInNewParam)
      )[]
    | null;
  /** Involved Party */
  involved_party:
    | AddInvolvedPartyParamsAddGenericInvolvedPersonParams
    | AddInvolvedPartyParamsAddInvolvedGenericPropertyParams;
}

/** AddGenericInvolvedPersonParams */
export interface AddInvolvedPartyParamsAddGenericInvolvedPersonParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: AddInvolvedPartyParamsBodilyInjuryLossParams | null;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /** Contact Ref Id */
  contact_ref_id: string;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: AddInvolvedPartyParamsPecuniaryLossDetailsParams | null;
  /** @default null */
  related_property_loss?: AddInvolvedPartyParamsPropertyLossWithItemsParams | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: string;
}

/** AddInvolvedGenericPropertyParams */
export interface AddInvolvedPartyParamsAddInvolvedGenericPropertyParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: AddInvolvedPartyParamsLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /** Owner Contact Ref Id */
  owner_contact_ref_id: string;
  /** @default null */
  pecuniary_loss?: AddInvolvedPartyParamsPecuniaryLossDetailsParams | null;
  /** @default null */
  property_damage?: AddInvolvedPartyParamsPropertyDamageParams | null;
  /** Property Description */
  property_description: string;
  /** @default null */
  related_property_loss?: AddInvolvedPartyParamsPropertyLossWithItemsParams | null;
  /** Type */
  type: string;
}

/** BodilyInjuryLossParams */
export interface AddInvolvedPartyParamsBodilyInjuryLossParams {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Bodily Injuries
   * @default null
   */
  bodily_injuries?: AddInvolvedPartyParamsBodilyInjuryModel[] | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Icd Codes
   * @default null
   */
  icd_codes?: AddInvolvedPartyParamsICDCodeModel[] | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface AddInvolvedPartyParamsBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/** ContactEmailModel */
export interface AddInvolvedPartyParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface AddInvolvedPartyParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface AddInvolvedPartyParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: AddInvolvedPartyParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: AddInvolvedPartyParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface AddInvolvedPartyParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ICDCodeModel */
export interface AddInvolvedPartyParamsICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** LocationModel */
export interface AddInvolvedPartyParamsLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PecuniaryLossDetailsParams */
export interface AddInvolvedPartyParamsPecuniaryLossDetailsParams {
  /**
   * Losses
   * @default null
   */
  losses?: AddInvolvedPartyParamsPecuniaryLossItemParams[] | null;
}

/** PecuniaryLossItemParams */
export interface AddInvolvedPartyParamsPecuniaryLossItemParams {
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /**
   * Claimed Loss
   * @default null
   */
  claimed_loss?: string | null;
  /** Display Name */
  display_name: string;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** PropertyDamageParams */
export interface AddInvolvedPartyParamsPropertyDamageParams {
  /**
   * Is Property Stolen
   * @default null
   */
  is_property_stolen?: boolean | null;
  /** @default null */
  location?: AddInvolvedPartyParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Property Damages
   * @default null
   */
  property_damages?: string[] | null;
  /**
   * Property Damages Description
   * @default null
   */
  property_damages_description?: string | null;
}

/** PropertyItemIncomingModel */
export interface AddInvolvedPartyParamsPropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyLossWithItemsParams */
export interface AddInvolvedPartyParamsPropertyLossWithItemsParams {
  /**
   * Damages
   * @default null
   */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /**
   * Items
   * @default null
   */
  items?: AddInvolvedPartyParamsPropertyItemIncomingModel[] | null;
  /** @default null */
  location?: AddInvolvedPartyParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** AddInvolvedPartyResponse */
export interface AddInvolvedPartyResponse {
  /** Api Uid */
  api_uid: string;
}

/** AddRecoveryAmountRequest */
export interface AddRecoveryAmountRequest {
  /**
   * Amount
   * Recovery amount received (must be positive)
   * @exclusiveMin 0
   */
  amount: number;
  /**
   * Cap Override Reason
   * Reason to override the recovery cap when payments configuration cap_recoveries_at_total_paid is set to 'warn' and this recovery would exceed total paid
   * @default null
   */
  cap_override_reason?: string | null;
  /**
   * Check Number
   * Check number for the recovery payment
   * @default null
   */
  check_number?: string | null;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the recovery amount
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * Note about the recovery amount
   * @default null
   */
  note?: string | null;
  /**
   * Vat Amount
   * GST/VAT amount included in the recovery
   * @default null
   */
  vat_amount?: number | null;
}

/** AdjusterCommunicationItemIdsParams */
export interface AdjusterCommunicationItemIdsParams {
  /**
   * Categories Ids
   * List of category IDs to filter by (use 0 for uncategorized)
   * @default null
   */
  categories_ids?: number[] | null;
  /**
   * Communication Channel
   * Filter by a single communication channel
   * @default null
   */
  communication_channel?:
    | "email"
    | "sms"
    | "phone_call"
    | "physical_mail"
    | "video_call"
    | "vendor"
    | null;
  /**
   * Communication Channels
   * Filter by multiple communication channels
   * @default null
   */
  communication_channels?:
    | (
        | "email"
        | "sms"
        | "phone_call"
        | "physical_mail"
        | "video_call"
        | "vendor"
      )[]
    | null;
  /**
   * Contact Id
   * Filter by contact ID
   * @default null
   */
  contact_id?: number | null;
  /**
   * Handled Status
   * Filter by handled status. "pending" = not yet marked handled, "handled" = marked handled. Omit for all communications, including outgoing ones, which carry no handled status and appear only when the filter is omitted.
   * @default null
   */
  handled_status?: "pending" | "handled" | null;
  /**
   * Search Text
   * Search text to filter communications
   * @default null
   */
  search_text?: string | null;
  /**
   * Sort By
   * Sort field with optional direction (+/-). Available: datetime
   * @default "-datetime"
   */
  sort_by?: string | null;
  /**
   * With Read Status
   * Include read status information
   * @default null
   */
  with_read_status?: boolean | null;
}

/** AdjusterCommunicationItemsByIdsParams */
export interface AdjusterCommunicationItemsByIdsParams {
  /**
   * Ids
   * List of communication IDs to retrieve
   */
  ids: number[];
  /**
   * With Read Status
   * Include read status information
   * @default null
   */
  with_read_status?: boolean | null;
}

/**
 * AgentConversation
 * A conversation with its turns, oldest first.
 */
export interface AgentConversation {
  /** Agent Key */
  agent_key: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Exchanges */
  exchanges: AgentConversationAgentExchange[];
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Title */
  title: string | null;
}

/**
 * AgentExchange
 * One turn: what the user wrote and, once the run finished, the agent's answer or why it failed. ``artifacts``
 * are what the run left behind, keyed by slot, as the domain's tools handed them out.
 */
export interface AgentConversationAgentExchange {
  /** Artifacts */
  artifacts: Record<string, any>;
  /** Completed At */
  completed_at: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Error */
  error: string | null;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Response */
  response: string | null;
  status: AgentConversationExchangeStatus;
  /** User Input */
  user_input: string;
}

/** AgentConversationCreated */
export interface AgentConversationCreated {
  /**
   * Id
   * @format uuid
   */
  id: string;
}

/**
 * AgentConversationSummary
 * A conversation as the previous-chats list shows it.
 */
export interface AgentConversationSummary {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Title */
  title: string | null;
}

/** AgentConversationSummaryList */
export type AgentConversationSummaryList =
  AgentConversationSummaryListAgentConversationSummary[];

/**
 * AgentConversationSummary
 * A conversation as the previous-chats list shows it.
 */
export interface AgentConversationSummaryListAgentConversationSummary {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Title */
  title: string | null;
}

/**
 * AgentExchange
 * One turn: what the user wrote and, once the run finished, the agent's answer or why it failed. ``artifacts``
 * are what the run left behind, keyed by slot, as the domain's tools handed them out.
 */
export interface AgentExchange {
  /** Artifacts */
  artifacts: Record<string, any>;
  /** Completed At */
  completed_at: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Error */
  error: string | null;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Response */
  response: string | null;
  status: AgentExchangeExchangeStatus;
  /** User Input */
  user_input: string;
}

/** AgentExchangeSubmitted */
export interface AgentExchangeSubmitted {
  /**
   * Exchange Id
   * @format uuid
   */
  exchange_id: string;
}

/** AiChatSchema */
export interface AiChatSchema {
  /** Chat Title */
  chat_title: string;
  /**
   * Created At
   * @default null
   */
  created_at?: string | null;
  /**
   * Exchanges
   * @default []
   */
  exchanges?: AiChatSchemaChatExchangeSchema[];
  /** Greeting */
  greeting: string;
  /** Id */
  id: string;
  /**
   * Internal Id
   * @default null
   */
  internal_id?: number | null;
  /** @default null */
  issue_token_response?: AiChatSchemaIssueTokenResponse | null;
  /** @default null */
  metadata?: AiChatSchemaAiChatMetadata | null;
  /** References */
  references: Record<string, AiChatSchemaCliveReferenceData>;
}

/**
 * AiChatMetadata
 * Contextual metadata about the chat.
 */
export interface AiChatSchemaAiChatMetadata {
  /**
   * Identifier
   * @default null
   */
  identifier?: string | null;
  /**
   * Is Auto Created
   * @default false
   */
  is_auto_created?: boolean;
}

/** ChatExchangeSchema */
export interface AiChatSchemaChatExchangeSchema {
  /** Context Document Ids */
  context_document_ids: number[];
  /**
   * Created At
   * @default null
   */
  created_at?: string | null;
  /** Documents Used */
  documents_used: string[];
  /**
   * Exchange Metadata
   * @default null
   */
  exchange_metadata?: Record<string, any> | null;
  /** Id */
  id: string;
  /** Response */
  response: string;
  /**
   * Response Time
   * @default null
   */
  response_time?: number | null;
  /**
   * User Feedback Score
   * @default null
   */
  user_feedback_score?: number | null;
  /**
   * User Feedback Text
   * @default null
   */
  user_feedback_text?: string | null;
  /** User Input */
  user_input: string;
}

/**
 * CliveReferenceData
 * Structured reference data for documents, notes, communications and AI-service sources used in AI chat.
 */
export interface AiChatSchemaCliveReferenceData {
  /**
   * Ai Summary
   * @default null
   */
  ai_summary?: string | null;
  /**
   * Claim Internal Id
   * @default null
   */
  claim_internal_id?: number | null;
  /**
   * Date
   * @default null
   */
  date?: string | null;
  /**
   * Document Title
   * @default null
   */
  document_title?: string | null;
  /** Id */
  id: number | string;
  /**
   * Is Latest
   * @default null
   */
  is_latest?: boolean | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Type
   * @default null
   */
  sub_type?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /**
   * Text
   * @default null
   */
  text?: string | null;
  /** Type */
  type: string;
  /**
   * Version At
   * @default null
   */
  version_at?: string | null;
}

/**
 * FirebaseWebAppConfigResponse
 * Firebase Web App configuration for frontend initialization.
 */
export interface AiChatSchemaFirebaseWebAppConfigResponse {
  /**
   * Api Key
   * Firebase Web API key
   */
  api_key: string;
  /**
   * App Id
   * Firebase Web App ID
   */
  app_id: string;
  /**
   * Auth Domain
   * Firebase authentication domain
   */
  auth_domain: string;
  /**
   * Database Url
   * Realtime Database URL (if applicable)
   * @default null
   */
  database_url?: string | null;
  /**
   * Messaging Sender Id
   * Firebase Cloud Messaging sender ID
   */
  messaging_sender_id: string;
  /**
   * Project Id
   * Firebase project ID
   */
  project_id: string;
  /**
   * Storage Bucket
   * Firebase storage bucket
   */
  storage_bucket: string;
}

/**
 * FirestoreConnectionConfig
 * Firestore connection configuration for the client.
 */
export interface AiChatSchemaFirestoreConnectionConfig {
  /** Collection Name */
  collection_name: string;
  /**
   * Database
   * @default "claims-llm"
   */
  database?: string | null;
  /**
   * Host
   * @default null
   */
  host?: string | null;
  /** Project Id */
  project_id: string;
}

/**
 * FirestoreQueryConfig
 * Query configuration for listening to real-time updates.
 */
export interface AiChatSchemaFirestoreQueryConfig {
  /**
   * Order By
   * @default null
   */
  order_by?: Record<string, string>[] | null;
  /** Where Clauses */
  where_clauses: Record<string, any>[];
}

/**
 * IssueTokenResponse
 * IssueTokenResponse
 */
export interface AiChatSchemaIssueTokenResponse {
  /** Expires At */
  expires_at: string;
  /** Firebase Custom Token */
  firebase_custom_token: string;
  /** Firebase Web App configuration for frontend initialization */
  firebase_web_app_config: AiChatSchemaFirebaseWebAppConfigResponse;
  /** Firestore connection configuration for the client. */
  firestore_config: AiChatSchemaFirestoreConnectionConfig;
  /** Query configuration for listening to real-time updates. */
  query_config: AiChatSchemaFirestoreQueryConfig;
  /** Scopes */
  scopes: Record<string, any>[];
}

/** AiClaimImportByClaimsPreviewRequest */
export interface AiClaimImportByClaimsPreviewRequest {
  /**
   * Claim Numbers
   * @minItems 1
   */
  claim_numbers: string[];
}

/** AiClaimImportByClaimsStartRequest */
export interface AiClaimImportByClaimsStartRequest {
  /**
   * Claim Numbers
   * @minItems 1
   */
  claim_numbers: string[];
}

/** AiClaimImportBySubOrgsStartRequest */
export interface AiClaimImportBySubOrgsStartRequest {
  /**
   * Sub Organization Ids
   * @minItems 1
   */
  sub_organization_ids: number[];
}

/** AiClaimImportPreviewByClaimsResponse */
export interface AiClaimImportPreviewByClaimsResponse {
  /** Closed Claims */
  closed_claims: AiClaimImportPreviewByClaimsResponseClosedClaimWarning[];
  /** Fully Processed Claims */
  fully_processed_claims: AiClaimImportPreviewByClaimsResponseFullyProcessedClaimWarning[];
  /** Non Ai Enabled Claims */
  non_ai_enabled_claims: AiClaimImportPreviewByClaimsResponseNonAiEnabledClaimWarning[];
  /** Not Found Claims */
  not_found_claims: AiClaimImportPreviewByClaimsResponseClaimNotFoundWarning[];
  /** Preview Rows */
  preview_rows: AiClaimImportPreviewByClaimsResponseSubOrgPreviewRow[];
  /** Total Claims */
  total_claims: number;
  /** Total Processable Claims */
  total_processable_claims: number;
}

/** ClaimNotFoundWarning */
export interface AiClaimImportPreviewByClaimsResponseClaimNotFoundWarning {
  /** Claim Id Display */
  claim_id_display: string;
}

/** ClosedClaimWarning */
export interface AiClaimImportPreviewByClaimsResponseClosedClaimWarning {
  /** Claim Id */
  claim_id: number;
  /** Claim Id Display */
  claim_id_display: string;
}

/** FullyProcessedClaimWarning */
export interface AiClaimImportPreviewByClaimsResponseFullyProcessedClaimWarning {
  /** Claim Id */
  claim_id: number;
  /** Claim Id Display */
  claim_id_display: string;
}

/** NonAiEnabledClaimWarning */
export interface AiClaimImportPreviewByClaimsResponseNonAiEnabledClaimWarning {
  /** Claim Id */
  claim_id: number;
  /** Claim Id Display */
  claim_id_display: string;
}

/** SubOrgPreviewRow */
export interface AiClaimImportPreviewByClaimsResponseSubOrgPreviewRow {
  /** Claims Count */
  claims_count: number;
  /** Communications Count */
  communications_count: number;
  /** Documents Count */
  documents_count: number;
  /** External Id */
  external_id: string | null;
  /** Is Ai Enabled */
  is_ai_enabled: boolean;
  /** Name */
  name: string;
  /** Notes Count */
  notes_count: number;
  /**
   * Predicted Cost
   * @default null
   */
  predicted_cost?: number | null;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/** AiClaimImportPreviewBySubOrgResponse */
export interface AiClaimImportPreviewBySubOrgResponse {
  /** Preview Rows */
  preview_rows: AiClaimImportPreviewBySubOrgResponseSubOrgPreviewRow[];
}

/** SubOrgPreviewRow */
export interface AiClaimImportPreviewBySubOrgResponseSubOrgPreviewRow {
  /** Claims Count */
  claims_count: number;
  /** Communications Count */
  communications_count: number;
  /** Documents Count */
  documents_count: number;
  /** External Id */
  external_id: string | null;
  /** Is Ai Enabled */
  is_ai_enabled: boolean;
  /** Name */
  name: string;
  /** Notes Count */
  notes_count: number;
  /**
   * Predicted Cost
   * @default null
   */
  predicted_cost?: number | null;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/** AiClaimImportRunListResponse */
export interface AiClaimImportRunListResponse {
  /** Runs */
  runs: AiClaimImportRunListResponseAiClaimImportRunListItem[];
}

/** AiClaimImportRunListItem */
export interface AiClaimImportRunListResponseAiClaimImportRunListItem {
  /** Created At */
  created_at: string;
  /** Import Type */
  import_type: string;
  /** Initiated By User Name */
  initiated_by_user_name: string;
  /** Run Id */
  run_id: string;
  /** Status */
  status: string;
  /** Total Claims */
  total_claims: number;
}

/** AiClaimImportRunProgress */
export interface AiClaimImportRunProgress {
  claims: AiClaimImportRunProgressStatusBreakdown;
  communications: AiClaimImportRunProgressStatusBreakdown;
  /** Created At */
  created_at: string;
  documents: AiClaimImportRunProgressStatusBreakdown;
  /** Import Type */
  import_type: string;
  /** Initiated By User Name */
  initiated_by_user_name: string;
  notes: AiClaimImportRunProgressStatusBreakdown;
  /** Run Id */
  run_id: string;
  /** Status */
  status: string;
  /** Total Claims */
  total_claims: number;
}

/** StatusBreakdown */
export interface AiClaimImportRunProgressStatusBreakdown {
  /** Completed */
  completed: number;
  /** Failed */
  failed: number;
  /** Pending */
  pending: number;
  /** Processing */
  processing: number;
  /** Total */
  total: number;
}

/** AiClaimImportStartResponse */
export interface AiClaimImportStartResponse {
  /** Message */
  message: string;
  /** Run Id */
  run_id: string;
  /** Total Claims */
  total_claims: number;
}

/** AiConfigurationResponse */
export interface AiConfigurationResponse {
  /** Configurations */
  configurations: AiConfigurationResponseAiConfigurationResponseRecord[];
  /** Is Sop Status Available */
  is_sop_status_available: boolean;
}

/** AiConfigurationResponseRecord */
export interface AiConfigurationResponseAiConfigurationResponseRecord {
  /**
   * Claim Chat
   * @default false
   */
  claim_chat?: boolean | null;
  /**
   * Clive Document Upload
   * @default false
   */
  clive_document_upload?: boolean | null;
  /**
   * Clive Insights Claim Tab
   * @default false
   */
  clive_insights_claim_tab?: boolean | null;
  /**
   * Create Document With Defaults On Failure
   * @default false
   */
  create_document_with_defaults_on_failure?: boolean | null;
  /**
   * Demo Acknowledgement Letter Action
   * @default false
   */
  demo_acknowledgement_letter_action?: boolean | null;
  /**
   * Demo Adjuster Assignment Action
   * @default false
   */
  demo_adjuster_assignment_action?: boolean | null;
  /** Description */
  description: string;
  /**
   * External Chat Api
   * @default false
   */
  external_chat_api?: boolean | null;
  /**
   * Fallback Document Type Key
   * @default null
   */
  fallback_document_type_key?: string | null;
  /**
   * Fnol To Claim Stp
   * @default false
   */
  fnol_to_claim_stp?: boolean | null;
  /**
   * Has Sop Configuration
   * @default null
   */
  has_sop_configuration?: boolean | null;
  /** Organization External Id */
  organization_external_id: string;
  /** Organization Id */
  organization_id: number;
  /**
   * Process Api Documents
   * @default false
   */
  process_api_documents?: boolean | null;
  /**
   * Process Email Attachments
   * @default false
   */
  process_email_attachments?: boolean | null;
  /**
   * Send Ai Data
   * @default false
   */
  send_ai_data?: boolean | null;
  /**
   * Skip Defaults Validation On Classify Upload
   * @default false
   */
  skip_defaults_validation_on_classify_upload?: boolean | null;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Use Demo Fnol Email Processing
   * @default false
   */
  use_demo_fnol_email_processing?: boolean | null;
  /**
   * Use Demo Fnol Policy Search
   * @default false
   */
  use_demo_fnol_policy_search?: boolean | null;
  /**
   * Web Search In Chat
   * @default false
   */
  web_search_in_chat?: boolean | null;
}

/** AiExpertInfo */
export interface AiExpertInfo {
  /** Confidence */
  confidence: number;
  /** Display Name */
  display_name: string;
  /** Icon */
  icon: string;
  /** Instructions */
  instructions: string | null;
  /** Is Demo */
  is_demo: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
}

/** AiExpertInfoList */
export type AiExpertInfoList = AiExpertInfoListAiExpertInfo[];

/** AiExpertInfo */
export interface AiExpertInfoListAiExpertInfo {
  /** Confidence */
  confidence: number;
  /** Display Name */
  display_name: string;
  /** Icon */
  icon: string;
  /** Instructions */
  instructions: string | null;
  /** Is Demo */
  is_demo: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
}

/**
 * AiExpertScopeConfigurationInfo
 * One expert's stored configuration for one scope.
 *
 * ``configured_fields`` and ``render_component`` are non-optional here even though their
 * columns are nullable: NULL means "nothing overridden", which the reader renders as an empty
 * list and the default component. The service normalises both when building this model, so a
 * permissive-null row never fails validation.
 */
export interface AiExpertScopeConfigurationInfo {
  /** Conductor Enabled */
  conductor_enabled: boolean;
  /** Configured Fields */
  configured_fields: AiExpertScopeConfigurationInfoConfiguredField[];
  /** Datetime Updated */
  datetime_updated: string | null;
  /** Expert Key */
  expert_key: string;
  /** Instructions */
  instructions: string | null;
  /** Last Updated By User Id */
  last_updated_by_user_id: string | null;
  /** Last Updated By Username */
  last_updated_by_username: string | null;
  /** Lob */
  lob: string;
  /**
   * How an expert's structured output should be rendered in the insight UI.
   *
   * A semantic render descriptor owned by CMS, not a binding to a concrete UI
   * component. ``key_value`` means "render one object's fields as a label→value
   * list". Future-proofed so new layouts (e.g. a genuine collection ``table``) can
   * be added without a schema change.
   *
   * The layout was originally named ``table``; that legacy value is still accepted
   * on read as an alias for ``key_value`` so overrides persisted before the rename
   * keep deserializing. A data migration rewrites the stored values in place.
   */
  render_component: AiExpertScopeConfigurationInfoStructuredOutputComponent;
  /** Standalone Confidence Threshold */
  standalone_confidence_threshold: number | null;
  /** Standalone Enabled */
  standalone_enabled: boolean;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/** ConfiguredField */
export interface AiExpertScopeConfigurationInfoConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?: AiExpertScopeConfigurationInfoConfiguredFieldSelectOption[] | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: AiExpertScopeConfigurationInfoConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface AiExpertScopeConfigurationInfoConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/** AiExpertScopeConfigurationInfoList */
export type AiExpertScopeConfigurationInfoList =
  AiExpertScopeConfigurationInfoListAiExpertScopeConfigurationInfo[];

/**
 * AiExpertScopeConfigurationInfo
 * One expert's stored configuration for one scope.
 *
 * ``configured_fields`` and ``render_component`` are non-optional here even though their
 * columns are nullable: NULL means "nothing overridden", which the reader renders as an empty
 * list and the default component. The service normalises both when building this model, so a
 * permissive-null row never fails validation.
 */
export interface AiExpertScopeConfigurationInfoListAiExpertScopeConfigurationInfo {
  /** Conductor Enabled */
  conductor_enabled: boolean;
  /** Configured Fields */
  configured_fields: AiExpertScopeConfigurationInfoListConfiguredField[];
  /** Datetime Updated */
  datetime_updated: string | null;
  /** Expert Key */
  expert_key: string;
  /** Instructions */
  instructions: string | null;
  /** Last Updated By User Id */
  last_updated_by_user_id: string | null;
  /** Last Updated By Username */
  last_updated_by_username: string | null;
  /** Lob */
  lob: string;
  /**
   * How an expert's structured output should be rendered in the insight UI.
   *
   * A semantic render descriptor owned by CMS, not a binding to a concrete UI
   * component. ``key_value`` means "render one object's fields as a label→value
   * list". Future-proofed so new layouts (e.g. a genuine collection ``table``) can
   * be added without a schema change.
   *
   * The layout was originally named ``table``; that legacy value is still accepted
   * on read as an alias for ``key_value`` so overrides persisted before the rename
   * keep deserializing. A data migration rewrites the stored values in place.
   */
  render_component: AiExpertScopeConfigurationInfoListStructuredOutputComponent;
  /** Standalone Confidence Threshold */
  standalone_confidence_threshold: number | null;
  /** Standalone Enabled */
  standalone_enabled: boolean;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/** ConfiguredField */
export interface AiExpertScopeConfigurationInfoListConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?:
    | AiExpertScopeConfigurationInfoListConfiguredFieldSelectOption[]
    | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: AiExpertScopeConfigurationInfoListConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface AiExpertScopeConfigurationInfoListConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/**
 * AiExpertScopesQuery
 * Scope selector for the ``GET /ai_experts/scopes`` read.
 *
 * Both fields optional: with no ``lob`` the read answers every row the organization has, in
 * one request, which is what the scope table needs to count ``n of m`` per row. ``lob`` alone
 * selects a flat organization's scope; ``lob`` + ``sub_organization_id`` a sub-org one.
 * Validated by spectree so a malformed ``sub_organization_id`` returns 400 rather than an
 * uncaught ``ValueError``.
 */
export interface AiExpertScopesQuery {
  /**
   * Lob
   * @default null
   */
  lob?: string | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** AiFilePathResponse */
export interface AiFilePathResponse {
  /** File Public Url */
  file_public_url: string | null;
  /** Type */
  type: string;
}

/**
 * AiInsightHistoryResponse
 * One page of an insight key's *older* versions, newest first.
 *
 * ``has_more`` tells the frontend whether another page exists. There is deliberately no cursor
 * field: the next page is requested with ``before=<id of the last insight in this page>``, and
 * that id is already on every item.
 */
export interface AiInsightHistoryResponse {
  /** Has More */
  has_more: boolean;
  /** Insights */
  insights: AiInsightHistoryResponseAiInsight[];
  /** References */
  references: Record<string, AiInsightHistoryResponseCliveReferenceData>;
}

/** AiInsight */
export interface AiInsightHistoryResponseAiInsight {
  /** Claim Number */
  claim_number: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * History Count
   * Number of older versions of this insight key, excluding this one
   * @default null
   */
  history_count?: number | null;
  /** Id */
  id: string;
  /** Insight Key */
  insight_key: string;
  /** Insight Metadata */
  insight_metadata?: Record<string, any> | null;
  /** Insight Text */
  insight_text: string;
  insight_type: AiInsightHistoryResponseClaimInsightType;
  /** Is Dismissed */
  is_dismissed: boolean;
  /**
   * Payload
   * Structured payload for expert-produced insights
   * @default null
   */
  payload?: Record<string, any> | null;
  /**
   * Related Documents
   * @default null
   */
  related_documents?: AiInsightHistoryResponseAiInsightDocument[] | null;
  /** Sub Title */
  sub_title: string;
  /** Title */
  title: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * AiInsightDocument
 * A document an insight cites, as the AI service's ``InsightDocument`` carries it.
 *
 * ``document_id`` is the key the frontend looks the reference up by in the response's
 * ``references`` map, so it has to survive the response schema rather than be dropped as an
 * undeclared field.
 */
export interface AiInsightHistoryResponseAiInsightDocument {
  /**
   * Document Id
   * @default null
   */
  document_id?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Type
   * @default null
   */
  document_type?: string | null;
}

/**
 * CliveReferenceData
 * Structured reference data for documents, notes, communications and AI-service sources used in AI chat.
 */
export interface AiInsightHistoryResponseCliveReferenceData {
  /**
   * Ai Summary
   * @default null
   */
  ai_summary?: string | null;
  /**
   * Claim Internal Id
   * @default null
   */
  claim_internal_id?: number | null;
  /**
   * Date
   * @default null
   */
  date?: string | null;
  /**
   * Document Title
   * @default null
   */
  document_title?: string | null;
  /** Id */
  id: number | string;
  /**
   * Is Latest
   * @default null
   */
  is_latest?: boolean | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Type
   * @default null
   */
  sub_type?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /**
   * Text
   * @default null
   */
  text?: string | null;
  /** Type */
  type: string;
  /**
   * Version At
   * @default null
   */
  version_at?: string | null;
}

/** AiInsightsAndReferencesResponse */
export interface AiInsightsAndReferencesResponse {
  /** Insights */
  insights: AiInsightsAndReferencesResponseAiInsight[];
  /** References */
  references: Record<string, AiInsightsAndReferencesResponseCliveReferenceData>;
}

/** AiInsight */
export interface AiInsightsAndReferencesResponseAiInsight {
  /** Claim Number */
  claim_number: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * History Count
   * Number of older versions of this insight key, excluding this one
   * @default null
   */
  history_count?: number | null;
  /** Id */
  id: string;
  /** Insight Key */
  insight_key: string;
  /** Insight Metadata */
  insight_metadata?: Record<string, any> | null;
  /** Insight Text */
  insight_text: string;
  insight_type: AiInsightsAndReferencesResponseClaimInsightType;
  /** Is Dismissed */
  is_dismissed: boolean;
  /**
   * Payload
   * Structured payload for expert-produced insights
   * @default null
   */
  payload?: Record<string, any> | null;
  /**
   * Related Documents
   * @default null
   */
  related_documents?: AiInsightsAndReferencesResponseAiInsightDocument[] | null;
  /** Sub Title */
  sub_title: string;
  /** Title */
  title: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * AiInsightDocument
 * A document an insight cites, as the AI service's ``InsightDocument`` carries it.
 *
 * ``document_id`` is the key the frontend looks the reference up by in the response's
 * ``references`` map, so it has to survive the response schema rather than be dropped as an
 * undeclared field.
 */
export interface AiInsightsAndReferencesResponseAiInsightDocument {
  /**
   * Document Id
   * @default null
   */
  document_id?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Type
   * @default null
   */
  document_type?: string | null;
}

/**
 * CliveReferenceData
 * Structured reference data for documents, notes, communications and AI-service sources used in AI chat.
 */
export interface AiInsightsAndReferencesResponseCliveReferenceData {
  /**
   * Ai Summary
   * @default null
   */
  ai_summary?: string | null;
  /**
   * Claim Internal Id
   * @default null
   */
  claim_internal_id?: number | null;
  /**
   * Date
   * @default null
   */
  date?: string | null;
  /**
   * Document Title
   * @default null
   */
  document_title?: string | null;
  /** Id */
  id: number | string;
  /**
   * Is Latest
   * @default null
   */
  is_latest?: boolean | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Type
   * @default null
   */
  sub_type?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /**
   * Text
   * @default null
   */
  text?: string | null;
  /** Type */
  type: string;
  /**
   * Version At
   * @default null
   */
  version_at?: string | null;
}

/** AlternativeDisputeResolutionPayload */
export interface AlternativeDisputeResolutionPayload {
  /**
   * Alternative Dispute Resolution Explored
   * @default null
   */
  alternative_dispute_resolution_explored?: string | null;
  /**
   * Alternative Dispute Resolution Text
   * @default null
   */
  alternative_dispute_resolution_text?: string | null;
  /**
   * Early Case Resolution Explored
   * @default null
   */
  early_case_resolution_explored?: string | null;
}

/**
 * AnalyzeRequest
 * Request schema for generating TOC from markdown pages.
 */
export interface AnalyzeRequest {
  /**
   * Markdown Pages
   * List of markdown strings to analyze
   */
  markdown_pages: string[];
  /**
   * Sub Organization Id
   * Sub-organization ID (for Phase 2)
   * @default null
   */
  sub_organization_id?: string | null;
}

/**
 * AnalyzeResponse
 * Response schema for TOC generation.
 */
export interface AnalyzeResponse {
  /**
   * Toc Markdown
   * Generated table of contents in markdown format
   */
  toc_markdown: string;
}

/** AnalyzerConfigEntryList */
export type AnalyzerConfigEntryList =
  AnalyzerConfigEntryListAnalyzerConfigEntry[];

/**
 * AnalyzerConfigEntry
 * One configured document analyzer: structured extraction over a document.  ``prompt`` is the instruction the analyzer runs on the document. ``trigger`` states when the analyzer runs: an OR-list of ``TriggerBranch`` AND-groups. ``output_schema`` is the list of fields the analyzer extracts. ``resources`` lists, by key, the claim resources whose data the analyzer is given. ``config_version`` is an opaque string naming the revision of this entry.
 */
export interface AnalyzerConfigEntryListAnalyzerConfigEntry {
  /** Config Version */
  config_version: string;
  /** Key */
  key: string;
  /** Output Schema */
  output_schema: AnalyzerConfigEntryListDynamicDataFieldConfigurationSchema[];
  /** Prompt */
  prompt: string;
  /** Resources */
  resources: string[];
  /** Trigger */
  trigger: AnalyzerConfigEntryListTriggerBranch[];
}

/**
 * DynamicDataFieldConfigurationSchema
 * DynamicDataFieldConfigurationSchema
 */
export interface AnalyzerConfigEntryListDynamicDataFieldConfigurationSchema {
  /**
   * Additional Instructions
   * @default null
   */
  additional_instructions?: string | null;
  /**
   * Allowed Entity Types
   * @default null
   */
  allowed_entity_types?: AnalyzerConfigEntryListEntityType[] | null;
  /** Description */
  description: string;
  /**
   * Entity Role
   * @default null
   */
  entity_role?: string | null;
  /**
   * Enum Values
   * @default null
   */
  enum_values?: string[] | null;
  /** DynamicDataModelFieldType */
  field_type: AnalyzerConfigEntryListDynamicDataModelFieldType;
  /** @default null */
  field_validation?: AnalyzerConfigEntryListFieldValidationSchema | null;
  /**
   * Is Required
   * @default null
   */
  is_required?: boolean | null;
  /** Key */
  key: string;
  /** @default null */
  nested_model_configuration?: AnalyzerConfigEntryListDynamicDataModelConfigurationSchema | null;
  /** Title */
  title: string;
  /**
   * Type Key
   * Key to reuse generated types (e.g., Enums, Models) across fields.
   * @default null
   */
  type_key?: string | null;
}

/**
 * DynamicDataModelConfigurationSchema
 * DynamicDataModelConfigurationSchema
 */
export interface AnalyzerConfigEntryListDynamicDataModelConfigurationSchema {
  /**
   * Additional Instructions
   * @default null
   */
  additional_instructions?: string | null;
  /** Fields */
  fields: AnalyzerConfigEntryListDynamicDataFieldConfigurationSchema[];
}

/**
 * FieldValidationSchema
 * FieldValidationSchema
 */
export interface AnalyzerConfigEntryListFieldValidationSchema {
  /**
   * Max Length
   * Maximum character length for a text field's extracted value.
   * @default null
   */
  max_length?: number | null;
}

/**
 * TriggerBranch
 * One AND-group of an analyzer's trigger; the trigger fires when any branch holds.  ``signals``: every listed signal key was detected. ``classifications``: the document's classification is one of these. A selector this version does not know is a newer consumer's vocabulary, not a contract break: it is ignored, never a validation error. The values are open strings: signal keys are CMS-authored, and the classification vocabulary is validated at save, in CMS.
 */
export interface AnalyzerConfigEntryListTriggerBranch {
  /**
   * Classifications
   * @default null
   */
  classifications?: string[] | null;
  /**
   * Signals
   * @default null
   */
  signals?: string[] | null;
}

/**
 * AnswerConductorAskRequest
 * The handler's answer to a question.
 *
 * ``from_options`` is required rather than defaulted: it is the handler's claim that ``answer`` is one
 * of the options the question offered, which the conductor checks, and a default would make that
 * claim on their behalf. The upstream body's ``actor`` is absent because the actor is the signed-in
 * user, so a body naming one is refused rather than answered for an actor that was dropped.
 */
export interface AnswerConductorAskRequest {
  /**
   * Answer
   * @minLength 1
   */
  answer: string;
  /** From Options */
  from_options: boolean;
}

/** ApplyClaimFlagsParams */
export interface ApplyClaimFlagsParams {
  /**
   * Flag Keys
   * @maxItems 100
   * @minItems 1
   */
  flag_keys: string[];
}

/** ApplyRequest */
export interface ApplyRequest {
  /** Export Data */
  export_data: Record<string, any>;
  /** Selected Change Ids */
  selected_change_ids: string[];
  /**
   * Strict Validation
   * @default true
   */
  strict_validation?: boolean;
}

/** ApplyResponse */
export interface ApplyResponse {
  /** Applied Changes */
  applied_changes?: string[];
  /**
   * Conflict Hash
   * @default null
   */
  conflict_hash?: string | null;
  /** Conflicts */
  conflicts?: ApplyResponseConflictInfo[];
  /** Errors */
  errors?: string[];
  /** Skipped Change Ids */
  skipped_change_ids?: string[];
  /** Success */
  success: boolean;
  /** Warnings */
  warnings?: string[];
}

/**
 * ConflictInfo
 * A located, per-change precondition conflict.
 *
 * The target's current value no longer matches the value the change expected (the target drifted
 * since the diff was computed). Precise (only the touched item) and located (the field path).
 */
export interface ApplyResponseConflictInfo {
  /**
   * Actual Current
   * @default null
   */
  actual_current?: any;
  /** Change Id */
  change_id: string;
  /**
   * Expected Old
   * @default null
   */
  expected_old?: any;
  /** Field Path */
  field_path: string;
  /** Message */
  message: string;
  /**
   * Overridable
   * @default true
   */
  overridable?: boolean;
}

/**
 * ApprovePromotionParams
 * Approve a request (target-side): snapshot the target and apply the reviewed diff.
 *
 * Phase 1 (report): ``override_change_ids`` omitted — detect conflicts and, if any, surface them for
 * resolution. Phase 2 (resolve): ``override_change_ids`` carries the conflicting change ids the approver
 * chose to apply anyway, and ``expected_conflict_hash`` is the hash the conflicts were reported under (the
 * stale-override guard).
 */
export interface ApprovePromotionParams {
  /**
   * Expected Conflict Hash
   * @default null
   */
  expected_conflict_hash?: string | null;
  /**
   * Override Change Ids
   * @default null
   */
  override_change_ids?: string[] | null;
  /** Request Uuid */
  request_uuid: string;
}

/**
 * ApproveVerificationResponse
 * Response schema for approve verification endpoint.
 */
export interface ApproveVerificationResponse {
  /**
   * Approved At
   * @format date-time
   */
  approved_at: string;
  /** Approved By */
  approved_by: string;
  /** Status */
  status: string;
  /** Verification Id */
  verification_id: number;
}

/** AskInsightRequest */
export interface AskInsightRequest {
  /**
   * Callback Url
   * @default null
   */
  callback_url?: string | null;
  /**
   * User Input
   * @minLength 1
   * @maxLength 10000
   */
  user_input: string;
}

/**
 * AssignAdjusterBulkRequestModel
 * Request model for bulk assignment of adjusters to claims.
 * A maximum of 100 claim numbers can be provided in a single request.
 * Duplicate claim numbers are not allowed.
 */
export interface AssignAdjusterBulkRequestModel {
  /**
   * Assignee User Email
   * Email of the adjuster to assign. Accepts either the user login email or the claims email address
   */
  assignee_user_email: string;
  /**
   * Claim Numbers
   * @maxItems 100
   */
  claim_numbers: string[];
  /** Do Not Reassign Closed Exposures */
  do_not_reassign_closed_exposures: boolean;
  /** Note */
  note: string | null;
}

/** AssignAdjusterBulkResponseModel */
export interface AssignAdjusterBulkResponseModel {
  /** Results */
  results: AssignAdjusterBulkResponseModelAssignAdjusterBulkResultModel[];
}

/** AssignAdjusterBulkResultModel */
export interface AssignAdjusterBulkResponseModelAssignAdjusterBulkResultModel {
  /** Claim Number */
  claim_number: string;
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /** Success */
  success: boolean;
}

/**
 * AssignExposureAdjusterBulkRequestModel
 * Request model for bulk assignment of adjusters to exposures.
 * A maximum of 100 exposure numbers can be provided in a single request.
 * Duplicate exposure numbers are not allowed.
 */
export interface AssignExposureAdjusterBulkRequestModel {
  /**
   * Assignee User Email
   * Email of the adjuster to assign. Accepts either the user login email or the claims email address
   */
  assignee_user_email: string;
  /**
   * Exposure Numbers
   * @maxItems 100
   */
  exposure_numbers: string[];
  /** Note */
  note: string;
}

/** AssignExposureToAdjusterBulkResponseModel */
export interface AssignExposureToAdjusterBulkResponseModel {
  /** Results */
  results: AssignExposureToAdjusterBulkResponseModelAssignExposureToAdjusterBulkResultModel[];
}

/** AssignExposureToAdjusterBulkResultModel */
export interface AssignExposureToAdjusterBulkResponseModelAssignExposureToAdjusterBulkResultModel {
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /** Exposure Number */
  exposure_number: string;
  /** Success */
  success: boolean;
}

/** AssignmentDefaultsInfo */
export interface AssignmentDefaultsInfo {
  /**
   * Fallback User Id
   * @default ""
   */
  fallback_user_id?: string;
  /** Id */
  id: number;
  /** Is Daily Max Enabled */
  is_daily_max_enabled: boolean | null;
  /** Is License Correlation Enabled */
  is_license_correlation_enabled: boolean | null;
  /** Is License Presentation Enabled */
  is_license_presentation_enabled: boolean | null;
  /** Is Load Balancing Enabled */
  is_load_balancing_enabled: boolean | null;
  /** Is Out Of Office Days Excluded */
  is_out_of_office_days_excluded: boolean | null;
  /** Look Back Period Amount */
  look_back_period_amount: number | null;
  /** Look Back Period Type */
  look_back_period_type: string | null;
  /** Max Daily Claim Assignments */
  max_daily_claim_assignments: number | null;
  /** Max Daily Exposure Assignments */
  max_daily_exposure_assignments: number | null;
}

/** AssignmentGroupInfoList */
export type AssignmentGroupInfoList =
  AssignmentGroupInfoListAssignmentGroupInfo[];

/** AssignmentGroupInfo */
export interface AssignmentGroupInfoListAssignmentGroupInfo {
  /** Assignment Group Key */
  assignment_group_key: string;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Rule Names */
  rule_names: string[];
  /** User Ids */
  user_ids: string[];
}

/** AssignmentRuleInfoList */
export type AssignmentRuleInfoList = AssignmentRuleInfoListAssignmentRuleInfo[];

/**
 * AssignmentRuleInfo
 * One assignment rule, in the assignments domain's own vocabulary.
 *
 * ``position`` / ``lob`` / ``entity`` are that vocabulary — one ordered list per entity, exactly
 * one line of business per rule, an entity an admin picks — and they stay even though the rule
 * is stored as an ``automation_rule`` whose columns are ``priority`` / ``lobs`` / ``type``.
 * Translating between the two is this DTO's job.
 *
 * ``position`` is 1-based within the rule's own entity, so a claim rule and an exposure rule can
 * and normally do share one. The two lists are evaluated independently — an exposure assignment
 * never consults a claim rule — so there is no ordering between them to express.
 */
export interface AssignmentRuleInfoListAssignmentRuleInfo {
  /**
   * Who an assignment rule assigns to, tagged with its kind.
   *
   * ``id`` carries the target's identifier for the two kinds that reference one — a user id for
   * ``user``, an assignment-group id for ``group`` — and is ``None`` for the two sentinel kinds,
   * which name a role resolved at assignment time (``fnol_taker`` is the user who filed the FNOL;
   * ``claim_owner`` is the owner of the exposure's claim).
   *
   * The tag is the only thing that says which kind an assignee is: no consumer may re-derive it
   * from the rule's ``(method, entity)`` pair or from the type of ``id``.
   */
  assignee: AssignmentRuleInfoListRuleAssignee;
  /** Assignee Desc */
  assignee_desc: string;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /** Entity */
  entity: string;
  /** Id */
  id: number;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Lob */
  lob: string;
  /** Method */
  method: string;
  /** Position */
  position: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
}

/**
 * RuleAssignee
 * Who an assignment rule assigns to, tagged with its kind.
 *
 * ``id`` carries the target's identifier for the two kinds that reference one — a user id for
 * ``user``, an assignment-group id for ``group`` — and is ``None`` for the two sentinel kinds,
 * which name a role resolved at assignment time (``fnol_taker`` is the user who filed the FNOL;
 * ``claim_owner`` is the owner of the exposure's claim).
 *
 * The tag is the only thing that says which kind an assignee is: no consumer may re-derive it
 * from the rule's ``(method, entity)`` pair or from the type of ``id``.
 */
export interface AssignmentRuleInfoListRuleAssignee {
  /**
   * Id
   * @default null
   */
  id?: string | number | null;
  /** The four kinds an assignment rule's assignee can be. */
  kind: AssignmentRuleInfoListRuleAssigneeKind;
}

/** AssignmentUserInfoList */
export type AssignmentUserInfoList = AssignmentUserInfoListAssignmentUserInfo[];

/** AssignmentUserInfo */
export interface AssignmentUserInfoListAssignmentUserInfo {
  /** Email */
  email: string | null;
  /** First Name */
  first_name: string | null;
  /** Id */
  id: string;
  /** Last Name */
  last_name: string | null;
  /** Role Id */
  role_id: number | null;
  /** Username */
  username: string;
}

/**
 * AsyncChatSubmitResponse
 * 202 handle returned when an exchange is submitted for async generation.
 *
 * The answer is produced off-request; the frontend resolves it via real-time updates
 * (real_time_token) or by polling the single-exchange GET. status is claims_llm's
 * ExchangeStatus value (processing at submit time).
 */
export interface AsyncChatSubmitResponse {
  /** Exchange Id */
  exchange_id: string;
  /** @default null */
  real_time_token?: AsyncChatSubmitResponseIssueTokenResponse | null;
  /**
   * Status
   * @default null
   */
  status?: string | null;
}

/**
 * FirebaseWebAppConfigResponse
 * Firebase Web App configuration for frontend initialization.
 */
export interface AsyncChatSubmitResponseFirebaseWebAppConfigResponse {
  /**
   * Api Key
   * Firebase Web API key
   */
  api_key: string;
  /**
   * App Id
   * Firebase Web App ID
   */
  app_id: string;
  /**
   * Auth Domain
   * Firebase authentication domain
   */
  auth_domain: string;
  /**
   * Database Url
   * Realtime Database URL (if applicable)
   * @default null
   */
  database_url?: string | null;
  /**
   * Messaging Sender Id
   * Firebase Cloud Messaging sender ID
   */
  messaging_sender_id: string;
  /**
   * Project Id
   * Firebase project ID
   */
  project_id: string;
  /**
   * Storage Bucket
   * Firebase storage bucket
   */
  storage_bucket: string;
}

/**
 * FirestoreConnectionConfig
 * Firestore connection configuration for the client.
 */
export interface AsyncChatSubmitResponseFirestoreConnectionConfig {
  /** Collection Name */
  collection_name: string;
  /**
   * Database
   * @default "claims-llm"
   */
  database?: string | null;
  /**
   * Host
   * @default null
   */
  host?: string | null;
  /** Project Id */
  project_id: string;
}

/**
 * FirestoreQueryConfig
 * Query configuration for listening to real-time updates.
 */
export interface AsyncChatSubmitResponseFirestoreQueryConfig {
  /**
   * Order By
   * @default null
   */
  order_by?: Record<string, string>[] | null;
  /** Where Clauses */
  where_clauses: Record<string, any>[];
}

/**
 * IssueTokenResponse
 * IssueTokenResponse
 */
export interface AsyncChatSubmitResponseIssueTokenResponse {
  /** Expires At */
  expires_at: string;
  /** Firebase Custom Token */
  firebase_custom_token: string;
  /** Firebase Web App configuration for frontend initialization */
  firebase_web_app_config: AsyncChatSubmitResponseFirebaseWebAppConfigResponse;
  /** Firestore connection configuration for the client. */
  firestore_config: AsyncChatSubmitResponseFirestoreConnectionConfig;
  /** Query configuration for listening to real-time updates. */
  query_config: AsyncChatSubmitResponseFirestoreQueryConfig;
  /** Scopes */
  scopes: Record<string, any>[];
}

/** AttachRequest */
export interface AttachRequest {
  /**
   * Selections
   * @minItems 1
   */
  selections: AttachRequestAttachSelectionDTO[];
}

/**
 * AttachSelectionDTO
 * One file the adjuster chose to attach, with the document fields the attach creates it with.
 */
export interface AttachRequestAttachSelectionDTO {
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Name
   * @default null
   */
  document_name?: string | null;
  /**
   * Document Type
   * @minLength 1
   */
  document_type: string;
  /** Exposure Ids */
  exposure_ids?: number[];
  /**
   * Summary
   * @default ""
   */
  summary?: string;
  /** Uploaded File Id */
  uploaded_file_id: string;
}

/** AttachResponse */
export interface AttachResponse {
  /** Attached */
  attached: AttachResponseAttachedDocumentDTO[];
}

/** AttachedDocumentDTO */
export interface AttachResponseAttachedDocumentDTO {
  /** Document Id */
  document_id: number;
  /** Stored File Id */
  stored_file_id: number;
  /** Uploaded File Id */
  uploaded_file_id: string;
}

/** AuditedConfigurationChangeList */
export type AuditedConfigurationChangeList =
  AuditedConfigurationChangeListAuditedConfigurationChange[];

/**
 * AuditedConfigurationChange
 * Frozen, v2-native read model for the configuration-change audit log and change-request views.
 *
 * Reconstructed solely from the flat, version-agnostic ``ConfigurationChangeAudit`` columns, so it
 * renders identically whether the applied change was originally v1 or v2. Carries no
 * ``current_value``/``baseline_value`` and no change-version discriminator - those were execution/diff
 * state that never belonged in the display model. The ``change_request`` JSONB stays a forensic-only
 * column and is intentionally NOT surfaced here.
 */
export interface AuditedConfigurationChangeListAuditedConfigurationChange {
  /**
   * Api Endpoint
   * @default null
   */
  api_endpoint?: string | null;
  /**
   * Applied At
   * @default null
   */
  applied_at?: string | null;
  /** Change Id */
  change_id: string;
  change_type: AuditedConfigurationChangeListChangeType;
  /**
   * Change Uuid
   * @default null
   */
  change_uuid?: string | null;
  /** Configuration Type */
  configuration_type: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Display Label
   * @default null
   */
  display_label?: string | null;
  field_path: AuditedConfigurationChangeListChangeFieldPath;
  /** Object Changes */
  object_changes?: AuditedConfigurationChangeListObjectChange[];
  /** Object Desc */
  object_desc: string;
  /** Transaction Id */
  transaction_id: string;
  /**
   * User Id
   * @default null
   */
  user_id?: string | null;
}

/** ChangeFieldPath */
export interface AuditedConfigurationChangeListChangeFieldPath {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Custom Field
   * @default null
   */
  custom_field?: string | null;
  /**
   * Display Label
   * @default null
   */
  display_label?: string | null;
  /**
   * Field Id
   * @default null
   */
  field_id?: string | null;
  /**
   * Identity Key
   * @default null
   */
  identity_key?: string | null;
  /**
   * Parent Path
   * @default null
   */
  parent_path?: string | null;
  /** Path */
  path: string;
}

/**
 * ObjectChange
 * Individual object change with key, description, and value changes.
 */
export interface AuditedConfigurationChangeListObjectChange {
  /** Desc */
  desc: string;
  /** Key */
  key: string;
  /** New Value */
  new_value: any;
  /** Old Value */
  old_value: any;
}

/** AuthorityLevelInfo */
export interface AuthorityLevelInfo {
  /** Assigned User Count */
  assigned_user_count: number;
  /** Id */
  id: number;
  /** Key */
  key: string;
  /**
   * Snapshot of all 6 limit fields. All fields required (no None).
   * Decimal matches request/approval amount precision (Numeric(19, 4)).
   */
  limits: AuthorityLevelInfoLimitSnapshot;
  /** Name */
  name: string;
}

/**
 * LimitSnapshot
 * Snapshot of all 6 limit fields. All fields required (no None).
 * Decimal matches request/approval amount precision (Numeric(19, 4)).
 */
export interface AuthorityLevelInfoLimitSnapshot {
  /**
   * Expenses Payments Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  expenses_payments_limit: string;
  /**
   * Expenses Reserves Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  expenses_reserves_limit: string;
  /**
   * Indemnity Payments Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  indemnity_payments_limit: string;
  /**
   * Indemnity Reserves Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  indemnity_reserves_limit: string;
  /**
   * Payments Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  payments_limit: string;
  /**
   * Reserves Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  reserves_limit: string;
}

/** AuthorityLevelInfoList */
export type AuthorityLevelInfoList = AuthorityLevelInfoListAuthorityLevelInfo[];

/** AuthorityLevelInfo */
export interface AuthorityLevelInfoListAuthorityLevelInfo {
  /** Assigned User Count */
  assigned_user_count: number;
  /** Id */
  id: number;
  /** Key */
  key: string;
  /**
   * Snapshot of all 6 limit fields. All fields required (no None).
   * Decimal matches request/approval amount precision (Numeric(19, 4)).
   */
  limits: AuthorityLevelInfoListLimitSnapshot;
  /** Name */
  name: string;
}

/**
 * LimitSnapshot
 * Snapshot of all 6 limit fields. All fields required (no None).
 * Decimal matches request/approval amount precision (Numeric(19, 4)).
 */
export interface AuthorityLevelInfoListLimitSnapshot {
  /**
   * Expenses Payments Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  expenses_payments_limit: string;
  /**
   * Expenses Reserves Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  expenses_reserves_limit: string;
  /**
   * Indemnity Payments Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  indemnity_payments_limit: string;
  /**
   * Indemnity Reserves Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  indemnity_reserves_limit: string;
  /**
   * Payments Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  payments_limit: string;
  /**
   * Reserves Limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  reserves_limit: string;
}

/**
 * AutocompleteParams
 * Standard request parameters for autocomplete endpoints.
 */
export interface AutocompleteParams {
  /**
   * Limit
   * @default 10
   */
  limit?: number | null;
  /**
   * Search Term
   * @default ""
   */
  search_term?: string;
}

/** AutocompleteResponseBaseModel[RuleOption] */
export interface AutocompleteResponseBaseModelRuleOption {
  /** Suggestions */
  suggestions: AutocompleteResponseBaseModelRuleOptionRuleOption[];
  /**
   * Total Count
   * @default null
   */
  total_count?: number | null;
}

/**
 * RuleOption
 * Model for rule option in autocomplete
 */
export interface AutocompleteResponseBaseModelRuleOptionRuleOption {
  /**
   * Id
   * Rule ID
   */
  id: number;
  /**
   * Name
   * Rule display name
   */
  name: string;
}

/** AutocompleteResponseBaseModel[WorkflowOption] */
export interface AutocompleteResponseBaseModelWorkflowOption {
  /** Suggestions */
  suggestions: AutocompleteResponseBaseModelWorkflowOptionWorkflowOption[];
  /**
   * Total Count
   * @default null
   */
  total_count?: number | null;
}

/**
 * WorkflowOption
 * Model for workflow option in autocomplete
 */
export interface AutocompleteResponseBaseModelWorkflowOptionWorkflowOption {
  /**
   * Id
   * Workflow ID
   */
  id: string;
  /**
   * Name
   * Workflow name
   */
  name: string;
}

/** Availability */
export interface Availability {
  /** Claim Number */
  claim_number: string;
  /** Is Allowed */
  is_allowed: boolean;
  /**
   * Reason
   * @default null
   */
  reason?: string | null;
}

/** AvailableRecoveryProviderInfoList */
export type AvailableRecoveryProviderInfoList =
  AvailableRecoveryProviderInfoListAvailableRecoveryProviderInfo[];

/**
 * AvailableRecoveryProviderInfo
 * One entry in the sysconfig provider picker: a registration key and its operator-facing label.
 *
 * The listing is exactly the set ``ProviderHandlerRegistry.assert_registered`` accepts, so the
 * picker cannot offer a key the write path then refuses.
 */
export interface AvailableRecoveryProviderInfoListAvailableRecoveryProviderInfo {
  /**
   * Configuration Fields
   * @default []
   */
  configuration_fields?: AvailableRecoveryProviderInfoListProviderConfigFieldInfo[];
  /** Display Name */
  display_name: string;
  /** Provider Key */
  provider_key: string;
}

/**
 * ProviderConfigFieldInfo
 * One per-scope value the configured provider needs, as the configuration screen sees it.
 *
 * The wire form of ``ProviderConfigField``, which providers declare as a stdlib dataclass because
 * the ABC that carries it sits on the ``server.models`` import chain. Converted at the registry,
 * the one place a handler is in scope.
 */
export interface AvailableRecoveryProviderInfoListProviderConfigFieldInfo {
  /**
   * Help Text
   * @default null
   */
  help_text?: string | null;
  /**
   * Is Required
   * @default false
   */
  is_required?: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/** AvailableToolResponseList */
export type AvailableToolResponseList =
  AvailableToolResponseListAvailableToolResponse[];

/**
 * AvailableToolResponse
 * One entry in the FE dropdown: a registry tool key + its human title, plus the tool's
 * code-defined response JSON Schema and its contract version (read-only, for the endpoint owner).
 */
export interface AvailableToolResponseListAvailableToolResponse {
  /** Http Method */
  http_method: string;
  /** Query Param Sources */
  query_param_sources?: string[];
  /**
   * Response Contract Version
   * @default null
   */
  response_contract_version?: string | null;
  /**
   * Response Json Schema
   * @default null
   */
  response_json_schema?: Record<string, any> | null;
  /** Tool Name */
  tool_name: string;
  /** Tool Title */
  tool_title: string;
}

/**
 * AvailableUsersQueryParams
 * Pydantic model for available users query parameters
 */
export interface AvailableUsersQueryParams {
  /**
   * Sub Org Id
   * @default null
   */
  sub_org_id?: number | null;
}

/** AvailableWorkflowsQuery */
export interface AvailableWorkflowsQuery {
  /**
   * Event Key
   * @default null
   */
  event_key?: string | null;
}

/**
 * AvailableWorkflowsResponse
 * Response model for available workflows endpoint
 */
export interface AvailableWorkflowsResponse {
  /**
   * Workflows
   * List of available workflows
   */
  workflows: AvailableWorkflowsResponseAvailableWorkflowModel[];
}

/**
 * AvailableWorkflowModel
 * Model for a single available workflow
 */
export interface AvailableWorkflowsResponseAvailableWorkflowModel {
  /**
   * Description
   * Workflow description
   * @default null
   */
  description?: string | null;
  /**
   * Id
   * Workflow ID
   */
  id: string;
  /**
   * Name
   * Workflow name
   */
  name: string;
}

/**
 * BindConfigVariableParams
 * Parameters for binding a value to a config variable.
 */
export interface BindConfigVariableParams {
  /**
   * Value
   * @minLength 1
   */
  value: string;
}

/** BulkDocumentResponse */
export interface BulkDocumentResponse {
  /** Failed Uploads */
  failed_uploads: BulkDocumentResponseDocumentUploadFailure[];
  /**
   * Message
   * @default null
   */
  message?: string | null;
  /** Successful Uploads */
  successful_uploads: string[];
}

/** DocumentUploadFailure */
export interface BulkDocumentResponseDocumentUploadFailure {
  /** Document Index */
  document_index: number;
  /** Document Name */
  document_name: string;
  /** Reason */
  reason: string;
}

/** CalculateDepreciationRequest */
export interface CalculateDepreciationRequest {
  /** Line Items */
  line_items: CalculateDepreciationRequestDepreciationCalculationLineItemRequest[];
}

/** DepreciationCalculationLineItemRequest */
export interface CalculateDepreciationRequestDepreciationCalculationLineItemRequest {
  /** Amount */
  amount: number;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /** Category */
  category: string;
  /** Covered Amount */
  covered_amount: number;
  /** Description */
  description: string;
  /** Id */
  id: string;
  /** Invoice Currency */
  invoice_currency: string;
  /** Invoice Date */
  invoice_date: string;
}

/** CalculateDepreciationResponse */
export interface CalculateDepreciationResponse {
  /** Results */
  results: CalculateDepreciationResponseDepreciationResult[];
}

/** DepreciationResult */
export interface CalculateDepreciationResponseDepreciationResult {
  /** Depreciation Percentage */
  depreciation_percentage: number;
  /** Id */
  id: string;
  /** Months Owned */
  months_owned: number;
  /** Settlement Amount */
  settlement_amount: number;
}

/**
 * CancelPaymentRequest
 * Request schema for cancelling a payment.
 */
export interface CancelPaymentRequest {
  /**
   * Cancel Reason
   * Reason for payment cancellation
   */
  cancel_reason: string;
  /**
   * Financial Status
   * New financial status ('cancelled' or 'error')
   */
  financial_status: string;
  /**
   * Override Issued
   * Override cancellation if payment is already issued
   * @default false
   */
  override_issued?: boolean | null;
  /**
   * Reopen Closed Exposure
   * Reopen exposure if it was closed
   * @default false
   */
  reopen_closed_exposure?: boolean | null;
}

/**
 * CancelPromotionParams
 * Cancel (withdraw) a pending request (source-side) with a reason.
 */
export interface CancelPromotionParams {
  /**
   * Reason
   * @minLength 1
   */
  reason: string;
  /** Request Uuid */
  request_uuid: string;
}

/**
 * CapacityAgreementCreateSchema
 * Schema for capacity agreement data (AU: Binder, UK: BAA, US: MGA)
 * @example {"agreement_number":"B-2024-001","capacity_slots":[{"details":"Applies to the northern depot only","external_id":"slot_001","slot_name":"Property Section","slot_number":1}],"carrier_name":"Lloyd's Syndicate 1234","effective_date":"2024-01-01","expiration_date":"2024-12-31","external_id":"binder_001","lloyds_risk_code":"A1","umr":"B1234ABC5678"}
 */
export interface CapacityAgreementCreateSchema {
  /**
   * Agreement Number
   * Agreement/binder number
   */
  agreement_number: string;
  /**
   * Capacity Slots
   * List of capacity slots within this agreement
   */
  capacity_slots?: CapacityAgreementCreateSchemaCapacitySlotCreateSchema[];
  /**
   * Carrier Name
   * Insurance carrier name
   */
  carrier_name: string;
  /**
   * Effective Date
   * Agreement effective date
   * @format date
   */
  effective_date: string;
  /**
   * Expiration Date
   * Agreement expiration date
   * @format date
   */
  expiration_date: string;
  /**
   * External Id
   * External system identifier. If not provided, one will be auto generated.
   * @default null
   */
  external_id?: string | null;
  /**
   * Lloyds Risk Code
   * A 1-2 character alphanumeric code identifying the Lloyd's risk category
   * @default null
   */
  lloyds_risk_code?: string | null;
  /**
   * Umr
   * Unique Market Reference (AU)
   * @default null
   */
  umr?: string | null;
}

/**
 * CapacitySlotCreateSchema
 * Schema for capacity slot creation (AU: Section)
 * @example {"details":"Applies to the northern depot only","external_id":"slot_001","slot_name":"Property Section","slot_number":1}
 */
export interface CapacityAgreementCreateSchemaCapacitySlotCreateSchema {
  /**
   * Details
   * Free-text details for the slot/section
   * @default null
   */
  details?: string | null;
  /**
   * External Id
   * External system identifier
   * @default null
   */
  external_id?: string | null;
  /**
   * Slot Name
   * Slot/section name
   */
  slot_name: string;
  /**
   * Slot Number
   * Slot/section number
   * @default null
   */
  slot_number?: number | null;
}

/**
 * CapacityAgreementUpdateSchema
 * Schema for capacity agreement updates (AU: Binder, UK: BAA, US: MGA)
 * @example {"agreement_number":"B-2024-001","capacity_slots":[{"details":"Applies to the northern depot only","external_id":"slot_001","slot_name":"Property Section","slot_number":1}],"carrier_name":"Lloyd's Syndicate 1234","effective_date":"2024-01-01","expiration_date":"2024-12-31","external_id":"binder_001","lloyds_risk_code":"A1","umr":"B1234ABC5678"}
 */
export interface CapacityAgreementUpdateSchema {
  /**
   * Agreement Number
   * Agreement/binder number
   * @default null
   */
  agreement_number?: string | null;
  /**
   * Capacity Slots Additions
   * List of capacity slots to add to this agreement
   */
  capacity_slots_additions?:
    | CapacityAgreementUpdateSchemaCapacitySlotCreateSchema[]
    | null;
  /**
   * Capacity Slots Updates
   * List of capacity slots updates within this agreement
   */
  capacity_slots_updates?:
    | CapacityAgreementUpdateSchemaCapacitySlotUpdateSchema[]
    | null;
  /**
   * Carrier Name
   * Insurance carrier name
   * @default null
   */
  carrier_name?: string | null;
  /**
   * Effective Date
   * Agreement effective date
   * @default null
   */
  effective_date?: string | null;
  /**
   * Expiration Date
   * Agreement expiration date
   * @default null
   */
  expiration_date?: string | null;
  /**
   * External Id
   * External system identifier
   */
  external_id: string;
  /**
   * Lloyds Risk Code
   * A 1-2 character alphanumeric code identifying the Lloyd's risk category
   * @default null
   */
  lloyds_risk_code?: string | null;
  /**
   * Umr
   * Unique Market Reference (AU)
   * @default null
   */
  umr?: string | null;
}

/**
 * CapacitySlotCreateSchema
 * Schema for capacity slot creation (AU: Section)
 * @example {"details":"Applies to the northern depot only","external_id":"slot_001","slot_name":"Property Section","slot_number":1}
 */
export interface CapacityAgreementUpdateSchemaCapacitySlotCreateSchema {
  /**
   * Details
   * Free-text details for the slot/section
   * @default null
   */
  details?: string | null;
  /**
   * External Id
   * External system identifier
   * @default null
   */
  external_id?: string | null;
  /**
   * Slot Name
   * Slot/section name
   */
  slot_name: string;
  /**
   * Slot Number
   * Slot/section number
   * @default null
   */
  slot_number?: number | null;
}

/**
 * CapacitySlotUpdateSchema
 * Schema for capacity slot update data (AU: Section)
 * @example {"details":"Applies to the northern depot only","external_id":"slot_001","slot_name":"Property Section","slot_number":1}
 */
export interface CapacityAgreementUpdateSchemaCapacitySlotUpdateSchema {
  /**
   * Details
   * Free-text details for the slot/section
   * @default null
   */
  details?: string | null;
  /**
   * External Id
   * External system identifier
   */
  external_id: string;
  /**
   * Slot Name
   * Slot/section name
   * @default null
   */
  slot_name?: string | null;
  /**
   * Slot Number
   * Slot/section number
   * @default null
   */
  slot_number?: number | null;
}

/** CatCodeSearchResultSchemaList */
export type CatCodeSearchResultSchemaList =
  CatCodeSearchResultSchemaListCatCodeSearchResultSchema[];

/**
 * CatCodeSearchResultSchema
 * CatCodeSearchResultSchema
 */
export interface CatCodeSearchResultSchemaListCatCodeSearchResultSchema {
  /**
   * Description
   * Description of the CAT code definition
   */
  description: string;
  /**
   * End Date
   * Optional end date until when the CAT code remains applicable
   * @default null
   */
  end_date?: string | null;
  /**
   * Event Type
   * Type of event associated with the CAT code definition
   * @default null
   */
  event_type?: string | null;
  /**
   * Id
   * Unique identifier for the CAT code definition
   */
  id: string;
  /**
   * Location
   * Optional list of locations where the CAT code applies
   * @default null
   */
  location?: string[] | null;
  /**
   * Name
   * Name of the CAT code definition
   */
  name: string;
  /**
   * Pcs Code
   * Optional PCS code associated with the CAT code
   * @default null
   */
  pcs_code?: string | null;
  /**
   * Start Date
   * The start date from which the CAT code is applicable
   * @format date
   */
  start_date: string;
}

/** CatConfigResponse */
export interface CatConfigResponse {
  /**
   * Enable Mark As Catastrophe
   * @default false
   */
  enable_mark_as_catastrophe?: boolean;
}

/** CatConfigUpdateParams */
export interface CatConfigUpdateParams {
  /** Status */
  status: boolean;
}

/** CatEventCreateParams */
export interface CatEventCreateParams {
  /** Code */
  code: string;
  /**
   * End Date
   * @default null
   */
  end_date?: string | null;
  /**
   * Is Hidden
   * @default false
   */
  is_hidden?: boolean;
  /** Name */
  name: string;
  /**
   * Pcs Number
   * @default null
   */
  pcs_number?: number | null;
  /**
   * Start Date
   * @default null
   */
  start_date?: string | null;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
  /**
   * Types
   * @default []
   */
  types?: string[];
  /**
   * Us States
   * @default []
   */
  us_states?: string[];
}

/** CatEventItemIdsParams */
export interface CatEventItemIdsParams {
  /**
   * Limit
   * @min 1
   * @max 5000
   * @default 5000
   */
  limit?: number;
  /**
   * Name Search
   * @default null
   */
  name_search?: string | null;
  /**
   * Sort By
   * @default null
   */
  sort_by?: string | null;
}

/** CatEventItemsByIdsParams */
export interface CatEventItemsByIdsParams {
  /** Ids */
  ids: number[];
}

/** CatEventUpdateParams */
export interface CatEventUpdateParams {
  /** Code */
  code: string;
  /**
   * End Date
   * @default null
   */
  end_date?: string | null;
  /**
   * Is Hidden
   * @default false
   */
  is_hidden?: boolean;
  /** Name */
  name: string;
  /**
   * Pcs Number
   * @default null
   */
  pcs_number?: number | null;
  /**
   * Start Date
   * @default null
   */
  start_date?: string | null;
  /**
   * Types
   * @default []
   */
  types?: string[];
  /**
   * Us States
   * @default []
   */
  us_states?: string[];
}

/** CccAssignment */
export interface CccAssignment {
  /** Ccc Transaction Id */
  ccc_transaction_id: string;
}

/** CccAssignmentParams */
export interface CccAssignmentParams {
  /** Method Of Inspection Id */
  method_of_inspection_id: number;
}

/** CccConfigurationParams */
export interface CccConfigurationParams {
  /**
   * Claim Office Branch Code
   * @default null
   */
  claim_office_branch_code?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** CccContact */
export interface CccContact {
  /** Appraiser Code */
  appraiser_code: string;
}

/** CccContactParams */
export interface CccContactParams {
  /**
   * Contact Id
   * @default null
   */
  contact_id?: number | null;
}

/** CccIncomingCredentials */
export interface CccIncomingCredentials {
  /** Password */
  password: string;
  /** Username */
  username: string;
}

/** CccModel */
export interface CccModel {
  /** Client Id */
  client_id: string;
  /** Client Secret Output */
  client_secret_output: string;
  /** Company Code */
  company_code: string;
  /** Configurations */
  configurations: CccModelCccConfigurationModel[];
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Org Level Configuration */
  is_org_level_configuration: boolean;
}

/** CccConfigurationModel */
export interface CccModelCccConfigurationModel {
  /** Ccc Configuration Id */
  ccc_configuration_id: number;
  /** Claim Office Branch Code */
  claim_office_branch_code: string;
  /** Is Enabled */
  is_enabled: boolean;
  /** Last Updated By Username */
  last_updated_by_username: string;
  /**
   * Last Updated Datetime
   * @format date-time
   */
  last_updated_datetime: string;
  /** Note */
  note: string;
  /** Organization Id */
  organization_id: number;
  /** Status */
  status: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** CccParams */
export interface CccParams {
  /**
   * Client Id
   * @default null
   */
  client_id?: string | null;
  /**
   * Client Password
   * @default null
   */
  client_password?: string | null;
  /**
   * Company Code
   * @default null
   */
  company_code?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
}

/** ChangeOwnerResponse */
export interface ChangeOwnerResponse {
  /** Assignment Method */
  assignment_method: "auto_rules" | "static";
  /** Claim Number */
  claim_number: string;
  /**
   * Info about the matched assignment rule (only for auto_rules method)
   * @default null
   */
  matched_rule?: ChangeOwnerResponseChangeOwnerMatchedRuleInfo | null;
  /**
   * Newly assigned owner
   * @default null
   */
  new_owner?: ChangeOwnerResponseUserExternalAPIBaseModel | null;
  /**
   * Owner Changed
   * Whether the owner was actually changed
   */
  owner_changed: boolean;
  /**
   * Previous owner, null if unassigned
   * @default null
   */
  previous_owner?: ChangeOwnerResponseUserExternalAPIBaseModel | null;
}

/** ChangeOwnerMatchedRuleInfo */
export interface ChangeOwnerResponseChangeOwnerMatchedRuleInfo {
  /**
   * Rule Name
   * Display name of the matched assignment rule
   * @default null
   */
  rule_name?: string | null;
  /**
   * Was Fallback
   * Whether the fallback user was used
   */
  was_fallback: boolean;
}

/** UserExternalAPIBaseModel */
export interface ChangeOwnerResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** Chat */
export interface Chat {
  /** Chat Uid */
  chat_uid: string;
  /** Claim Number */
  claim_number: string;
  /**
   * Created At
   * @default null
   */
  created_at?: string | null;
  /** Exchanges */
  exchanges?: ChatChatExchange[];
  /** Greeting */
  greeting: string;
  /** @default null */
  metadata?: ChatAiChatMetadata | null;
  /** References */
  references?: Record<string, ChatReference>;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * AiChatMetadata
 * Contextual metadata about the chat.
 */
export interface ChatAiChatMetadata {
  /**
   * Identifier
   * @default null
   */
  identifier?: string | null;
  /**
   * Is Auto Created
   * @default false
   */
  is_auto_created?: boolean;
}

/** ChatExchange */
export interface ChatChatExchange {
  /** Claim Number */
  claim_number: string;
  /**
   * Created At
   * @default null
   */
  created_at?: string | null;
  /** Documents Used */
  documents_used?: string[];
  /**
   * Error
   * @default null
   */
  error?: string | null;
  /**
   * Exchange Metadata
   * @default null
   */
  exchange_metadata?: Record<string, any> | null;
  /** Exchange Uid */
  exchange_uid: string;
  /**
   * Response
   * @default null
   */
  response?: string | null;
  /**
   * Response Time
   * @default null
   */
  response_time?: number | null;
  /**
   * Status
   * @default null
   */
  status?: string | null;
  /** User Input */
  user_input: string;
}

/** Reference */
export interface ChatReference {
  /**
   * Ai Summary
   * @default null
   */
  ai_summary?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Date
   * @default null
   */
  date?: string | null;
  /**
   * Document Title
   * @default null
   */
  document_title?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Type
   * @default null
   */
  sub_type?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /** Type */
  type: string;
}

/** ChatExchange */
export interface ChatExchange {
  /** Claim Number */
  claim_number: string;
  /**
   * Created At
   * @default null
   */
  created_at?: string | null;
  /** Documents Used */
  documents_used?: string[];
  /**
   * Error
   * @default null
   */
  error?: string | null;
  /**
   * Exchange Metadata
   * @default null
   */
  exchange_metadata?: Record<string, any> | null;
  /** Exchange Uid */
  exchange_uid: string;
  /**
   * Response
   * @default null
   */
  response?: string | null;
  /**
   * Response Time
   * @default null
   */
  response_time?: number | null;
  /**
   * Status
   * @default null
   */
  status?: string | null;
  /** User Input */
  user_input: string;
}

/** ChatExchangeQueryParams */
export interface ChatExchangeQueryParams {
  /** Chat Id */
  chat_id: number;
}

/** ChatExchangeRequest */
export interface ChatExchangeRequest {
  /**
   * Chat Id
   * @default null
   */
  chat_id?: number | null;
  /**
   * Context Document Ids
   * @default null
   */
  context_document_ids?: number[] | null;
  /**
   * Prompt Key
   * @default null
   */
  prompt_key?: string | null;
  /** User Input */
  user_input: string;
}

/** ChatFeedbackUpdateRequest */
export interface ChatFeedbackUpdateRequest {
  /**
   * Chat Id
   * @default null
   */
  chat_id?: number | null;
  /** User Feedback Score */
  user_feedback_score: number;
  /** User Feedback Text */
  user_feedback_text: string;
}

/** ChatList */
export interface ChatList {
  /** Chats */
  chats?: ChatListChatListItem[];
  /** Claim Number */
  claim_number: string;
}

/** ChatListItem */
export interface ChatListChatListItem {
  /** Chat Uid */
  chat_uid: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** ChatRegenerateRequest */
export interface ChatRegenerateRequest {
  /**
   * Chat Id
   * @default null
   */
  chat_id?: number | null;
}

/** ClaimAISummaryRefreshResponse */
export interface ClaimAISummaryRefreshResponse {
  /** Message */
  message: string;
  /** Status */
  status: string;
}

/** ClaimAISummaryResponse */
export interface ClaimAISummaryResponse {
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /**
   * Is Content Stale
   * @default false
   */
  is_content_stale?: boolean;
  /**
   * Needs Refresh
   * @default false
   */
  needs_refresh?: boolean;
  /**
   * References
   * @default {}
   */
  references?: Record<string, ClaimAISummaryResponseCliveReferenceData>;
  /** Status */
  status: "pending" | "processing" | "success" | "failed";
  /**
   * Summary Content Updated At
   * @default null
   */
  summary_content_updated_at?: string | null;
  /**
   * Summary Text
   * @default null
   */
  summary_text?: string | null;
}

/**
 * CliveReferenceData
 * Structured reference data for documents, notes, communications and AI-service sources used in AI chat.
 */
export interface ClaimAISummaryResponseCliveReferenceData {
  /**
   * Ai Summary
   * @default null
   */
  ai_summary?: string | null;
  /**
   * Claim Internal Id
   * @default null
   */
  claim_internal_id?: number | null;
  /**
   * Date
   * @default null
   */
  date?: string | null;
  /**
   * Document Title
   * @default null
   */
  document_title?: string | null;
  /** Id */
  id: number | string;
  /**
   * Is Latest
   * @default null
   */
  is_latest?: boolean | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Type
   * @default null
   */
  sub_type?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /**
   * Text
   * @default null
   */
  text?: string | null;
  /** Type */
  type: string;
  /**
   * Version At
   * @default null
   */
  version_at?: string | null;
}

/**
 * ClaimActionHistoryQueryParams
 * Keyset cursor for one page of a claim action's recorded versions.
 */
export interface ClaimActionHistoryQueryParams {
  /**
   * Before
   * The version_id of the oldest version already held. Omit it to start at the newest version.
   * @default null
   */
  before?: string | null;
  /**
   * Limit
   * How many versions to return.
   * @default null
   */
  limit?: number | null;
}

/**
 * ClaimActionHistoryResponse
 * One page of a claim action's recorded versions, newest first.
 */
export interface ClaimActionHistoryResponse {
  /**
   * Has More
   * Whether older versions exist. Request them with before=<the last version_id of this page>.
   */
  has_more: boolean;
  /** Versions */
  versions: ClaimActionHistoryResponseClaimActionVersion[];
}

/**
 * ClaimActionVersion
 * One recorded version of a claim action's task payload.
 */
export interface ClaimActionHistoryResponseClaimActionVersion {
  /**
   * Action Id
   * The action this version belongs to.
   * @default null
   */
  action_id?: string | null;
  /**
   * Recorded At
   * When this version was written.
   * @format date-time
   */
  recorded_at: string;
  /**
   * Task Data
   * The task payload as it stood in this version.
   * @default null
   */
  task_data?: Record<string, any> | null;
  /**
   * Version Id
   * The ID of this version; also the paging cursor.
   */
  version_id: string;
}

/**
 * ClaimActionRequestEnvelope
 * Execute-request body: business parameters under ``payload`` plus ``metadata``.
 */
export interface ClaimActionRequestEnvelope {
  /** Out-of-band execution metadata (everything that is not a business parameter). */
  metadata?: ClaimActionRequestEnvelopeClaimActionMetadata;
  /** Payload */
  payload: Record<string, any>;
}

/**
 * ClaimActionMetadata
 * Out-of-band execution metadata (everything that is not a business parameter).
 */
export interface ClaimActionRequestEnvelopeClaimActionMetadata {
  /**
   * Confidence
   * @default null
   */
  confidence?: number | null;
  /**
   * Revises Action Id
   * @default null
   */
  revises_action_id?: string | null;
  /**
   * Revision
   * @default null
   */
  revision?: number | null;
}

/** ClaimActionToolConfigList */
export type ClaimActionToolConfigList =
  ClaimActionToolConfigListClaimActionToolConfig[];

/**
 * ClaimActionToolConfig
 * Per-claim configuration for a single client-defined claim action.  Inherits url, customer_prompt_augmentation, and request_payload_config from the base class. Adds action-specific metadata (key and description) for identification and LLM instruction.
 */
export interface ClaimActionToolConfigListClaimActionToolConfig {
  /**
   * Customer Prompt Augmentation
   * Optional customer-specific prompt augmentation for tool behavior. Each tool uses this as applicable (e.g., search tools use it for query generation guidance).
   * @default null
   */
  customer_prompt_augmentation?: string | null;
  /**
   * Description
   * Human and LLM-readable description of what this claim action does.
   */
  description: string;
  /**
   * Display Name
   * Human-readable title for the action, distinct from the snake_case key (e.g. 'Decide on coverage' for key 'decide_on_coverage'). Mirrors the key vs label split on ConductorConfigStageSchema. Optional: consumers humanize the key when it is omitted.
   * @default null
   */
  display_name?: string | null;
  /**
   * Is Milestone
   * Whether performing this action surfaces as a milestone in agent progress notifications. Defaults to False so incidental actions (e.g. create_note, update_reserve) are not promoted.
   * @default false
   */
  is_milestone?: boolean | null;
  /**
   * Key
   * The action's identifier (tool name) within the claim context.
   */
  key: string;
  /**
   * The action's kind, when it is one the AI service can dispatch on (e.g. 'stage_change'). The set is closed and published, so the generated client gets a named enum; a value outside it is accepted and degraded to null rather than rejected, because the two services deploy independently and a kind this version predates must become a generic action. Rejecting it would fail this item's validation and the loader would skip this one action — deleting it from the agent's toolset, which for a stage-change action leaves the conductor unable to advance the claim. Distinct from is_milestone — kinds and flags coexist.
   * @default null
   */
  kind?: ClaimActionToolConfigListClaimActionKind | null;
  /** DynamicSchemaResourcePayloadSchema */
  request_payload_config: ClaimActionToolConfigListDynamicSchemaResourcePayloadSchema;
  /** Url */
  url: string;
}

/**
 * DynamicDataFieldConfigurationSchema
 * DynamicDataFieldConfigurationSchema
 */
export interface ClaimActionToolConfigListDynamicDataFieldConfigurationSchema {
  /**
   * Additional Instructions
   * @default null
   */
  additional_instructions?: string | null;
  /**
   * Allowed Entity Types
   * @default null
   */
  allowed_entity_types?: ClaimActionToolConfigListEntityType[] | null;
  /** Description */
  description: string;
  /**
   * Entity Role
   * @default null
   */
  entity_role?: string | null;
  /**
   * Enum Values
   * @default null
   */
  enum_values?: string[] | null;
  /** DynamicDataModelFieldType */
  field_type: ClaimActionToolConfigListDynamicDataModelFieldType;
  /** @default null */
  field_validation?: ClaimActionToolConfigListFieldValidationSchema | null;
  /**
   * Is Required
   * @default null
   */
  is_required?: boolean | null;
  /** Key */
  key: string;
  /** @default null */
  nested_model_configuration?: ClaimActionToolConfigListDynamicDataModelConfigurationSchema | null;
  /** Title */
  title: string;
  /**
   * Type Key
   * Key to reuse generated types (e.g., Enums, Models) across fields.
   * @default null
   */
  type_key?: string | null;
}

/**
 * DynamicDataModelConfigurationSchema
 * DynamicDataModelConfigurationSchema
 */
export interface ClaimActionToolConfigListDynamicDataModelConfigurationSchema {
  /**
   * Additional Instructions
   * @default null
   */
  additional_instructions?: string | null;
  /** Fields */
  fields: ClaimActionToolConfigListDynamicDataFieldConfigurationSchema[];
}

/**
 * DynamicSchemaResourcePayloadSchema
 * DynamicSchemaResourcePayloadSchema
 */
export interface ClaimActionToolConfigListDynamicSchemaResourcePayloadSchema {
  /** Payload Configuration */
  payload_configuration: ClaimActionToolConfigListDynamicDataFieldConfigurationSchema[];
  /**
   * Predefined Params
   * @default null
   */
  predefined_params?: Record<string, any> | null;
}

/**
 * FieldValidationSchema
 * FieldValidationSchema
 */
export interface ClaimActionToolConfigListFieldValidationSchema {
  /**
   * Max Length
   * Maximum character length for a text field's extracted value.
   * @default null
   */
  max_length?: number | null;
}

/**
 * ClaimActionsListResponse
 * The actions list, plus the demo-only extras `?additional_data=true` asks for.
 *
 * This is the route the Clive Insights tab actually reads — the execute/dismiss routes' bodies
 * are discarded and a refetch of this one is what re-renders the cards — so it is declared
 * rather than left as a bare dict. The two extras are omitted, not nulled, when they were not
 * asked for, which is why the routes dump with `exclude_unset`.
 */
export interface ClaimActionsListResponse {
  /** Actions */
  actions: ClaimActionsListResponseClaimAction[];
  /**
   * First Handling Adjuster Name
   * The claim's first handling adjuster, for the demo assignment card.
   * @default null
   */
  first_handling_adjuster_name?: string | null;
  /**
   * Reserves
   * Per-exposure reserves, for the demo reserve cards.
   */
  reserves?: ClaimActionsListResponseClaimActionsDemoReserve[];
}

/**
 * ClaimAction
 * An AI-recommended claim action, as CMS serves it to the client.
 *
 * The AI service's own fields, plus the ``related_exposure_id`` CMS hoists out of the task
 * payload while flattening it off the SDK's one-of wrapper.
 */
export interface ClaimActionsListResponseClaimAction {
  /** Action Id */
  action_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * History Count
   * How many of this action's versions are older than its current one; 0 if it was never revised.
   * @default 0
   */
  history_count?: number;
  /** Is Executed */
  is_executed: boolean;
  /** Is Ignored */
  is_ignored: boolean;
  /**
   * Related Exposure Id
   * The exposure the task is scoped to, where it is scoped to one.
   * @default null
   */
  related_exposure_id?: string | null;
  /**
   * Revision
   * A token for this action's task data that changes whenever the task data is written, and on nothing else. Send it back as expected_revision when executing the action.
   * @default 1
   */
  revision?: number;
  /**
   * The execute/dismiss transition recorded against this action, null until one is. Present does not mean settled: read is_executed / is_ignored for that, and read this only once they say the action is settled.
   * @default null
   */
  status_change?: ClaimActionsListResponseClaimActionStatusChange | null;
  /** Task Data */
  task_data: Record<string, any>;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * ClaimActionActor
 * Who performed an execute/dismiss transition.
 *
 * The AI service stores caller-supplied identity in a generic ``ref``/``ref_type`` pair. For a
 * transition CMS drove, ``ref`` is the acting user's id (see ``CMS_USER_ID_REF_TYPE``), which is
 * promoted to ``user_id`` below; ``ref`` itself is never served, and on a transition recorded
 * before that convention it is the user's email address, which is the reason it is not. This
 * model is closed, so both it and ``ref_type`` are dropped at validation.
 *
 * ``display_name`` is a snapshot taken when the action was settled and does not follow a rename,
 * so prefer ``user_id`` wherever the caller can resolve one.
 *
 * ``type`` is the AI service's own discriminator, validated there against this exact set.
 */
export interface ClaimActionsListResponseClaimActionActor {
  /**
   * Display Name
   * Name of the acting user, where there was one.
   * @default null
   */
  display_name?: string | null;
  /**
   * Type
   * Where the transition came from.
   */
  type: "user" | "agent" | "system";
  /**
   * User Id
   * The CMS user who acted, where the transition was driven from CMS and recorded with their id. Null for an agent or system transition, and for one recorded before CMS started sending the id.
   * @default null
   */
  user_id?: number | null;
}

/**
 * ClaimActionStatusChange
 * An execute/dismiss transition recorded against a claim action.
 */
export interface ClaimActionsListResponseClaimActionStatusChange {
  /**
   * Who settled it.
   * @default null
   */
  actor?: ClaimActionsListResponseClaimActionActor | null;
  /**
   * At
   * When the transition was recorded.
   * @format date-time
   */
  at: string;
  /**
   * Reason
   * The note the actor wrote when they settled the action.
   * @default null
   */
  reason?: string | null;
  /**
   * Transition
   * Which way the action was settled.
   */
  transition: "executed" | "dismissed";
}

/**
 * ClaimActionsDemoReserve
 * One exposure's reserves, as the demo Set Reserve card is built from.
 */
export interface ClaimActionsListResponseClaimActionsDemoReserve {
  /** Coverage Type Desc */
  coverage_type_desc: string;
  /** Expense Reserve */
  expense_reserve: number;
  /** Exposure Id */
  exposure_id: number;
  /** Indemnity Reserve */
  indemnity_reserve: number;
  /** Label Text */
  label_text: string;
}

/**
 * ClaimActionsResponse
 * Response wrapper for endpoints returning the claim's parsed actions.
 */
export interface ClaimActionsResponse {
  /** Actions */
  actions: ClaimActionsResponseClaimAction[];
}

/**
 * ClaimAction
 * An AI-recommended claim action, as CMS serves it to the client.
 *
 * The AI service's own fields, plus the ``related_exposure_id`` CMS hoists out of the task
 * payload while flattening it off the SDK's one-of wrapper.
 */
export interface ClaimActionsResponseClaimAction {
  /** Action Id */
  action_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * History Count
   * How many of this action's versions are older than its current one; 0 if it was never revised.
   * @default 0
   */
  history_count?: number;
  /** Is Executed */
  is_executed: boolean;
  /** Is Ignored */
  is_ignored: boolean;
  /**
   * Related Exposure Id
   * The exposure the task is scoped to, where it is scoped to one.
   * @default null
   */
  related_exposure_id?: string | null;
  /**
   * Revision
   * A token for this action's task data that changes whenever the task data is written, and on nothing else. Send it back as expected_revision when executing the action.
   * @default 1
   */
  revision?: number;
  /**
   * The execute/dismiss transition recorded against this action, null until one is. Present does not mean settled: read is_executed / is_ignored for that, and read this only once they say the action is settled.
   * @default null
   */
  status_change?: ClaimActionsResponseClaimActionStatusChange | null;
  /** Task Data */
  task_data: Record<string, any>;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * ClaimActionActor
 * Who performed an execute/dismiss transition.
 *
 * The AI service stores caller-supplied identity in a generic ``ref``/``ref_type`` pair. For a
 * transition CMS drove, ``ref`` is the acting user's id (see ``CMS_USER_ID_REF_TYPE``), which is
 * promoted to ``user_id`` below; ``ref`` itself is never served, and on a transition recorded
 * before that convention it is the user's email address, which is the reason it is not. This
 * model is closed, so both it and ``ref_type`` are dropped at validation.
 *
 * ``display_name`` is a snapshot taken when the action was settled and does not follow a rename,
 * so prefer ``user_id`` wherever the caller can resolve one.
 *
 * ``type`` is the AI service's own discriminator, validated there against this exact set.
 */
export interface ClaimActionsResponseClaimActionActor {
  /**
   * Display Name
   * Name of the acting user, where there was one.
   * @default null
   */
  display_name?: string | null;
  /**
   * Type
   * Where the transition came from.
   */
  type: "user" | "agent" | "system";
  /**
   * User Id
   * The CMS user who acted, where the transition was driven from CMS and recorded with their id. Null for an agent or system transition, and for one recorded before CMS started sending the id.
   * @default null
   */
  user_id?: number | null;
}

/**
 * ClaimActionStatusChange
 * An execute/dismiss transition recorded against a claim action.
 */
export interface ClaimActionsResponseClaimActionStatusChange {
  /**
   * Who settled it.
   * @default null
   */
  actor?: ClaimActionsResponseClaimActionActor | null;
  /**
   * At
   * When the transition was recorded.
   * @format date-time
   */
  at: string;
  /**
   * Reason
   * The note the actor wrote when they settled the action.
   * @default null
   */
  reason?: string | null;
  /**
   * Transition
   * Which way the action was settled.
   */
  transition: "executed" | "dismissed";
}

/**
 * ClaimBarConfigurationSaveJson
 * Everything an administrator changed on one scope's claim bar, saved together.
 *
 * The scope is the Default when both ``lob`` and ``sub_organization_id`` are absent. Only what was
 * changed is sent, never the configuration as it resolves: a stored entry is the override, so storing
 * the resolved list would stop every later Default change from reaching the scope. ``order`` is the
 * whole order when the administrator moved a field, and absent otherwise.
 */
export interface ClaimBarConfigurationSaveJson {
  /** Added */
  added?: ClaimBarConfigurationSaveJsonClaimBarFieldAdded[];
  /** Fields */
  fields?: ClaimBarConfigurationSaveJsonClaimBarFieldEdit[];
  /**
   * Lob
   * @default null
   */
  lob?: string | null;
  /**
   * Order
   * @default null
   */
  order?:
    | (
        | "claim_number"
        | "policy_number"
        | "sub_organization"
        | "policyholder"
        | "preferred_contact"
        | "time_of_loss"
        | "date_of_report"
        | "file_owner"
        | "days_open"
        | "incident_type"
        | "reporter"
        | "claim_alerts"
        | "claim_stage"
        | "claim_flags"
        | "claim_complexity"
        | "broker"
        | "conductor_handling"
        | string
      )[]
    | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * ClaimBarFieldAdded
 * A catalog field added in a save. Unlike the per-field append route's body, a key the save does not know is
 * refused, as everywhere else in the save, rather than dropped.
 */
export interface ClaimBarConfigurationSaveJsonClaimBarFieldAdded {
  /** Display Name */
  display_name: string;
  /** Field Key */
  field_key:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
}

/**
 * ClaimBarFieldEdit
 * A field an administrator changed, with only what they changed.
 */
export interface ClaimBarConfigurationSaveJsonClaimBarFieldEdit {
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /** Field Key */
  field_key:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
}

/** ClaimBarConfigurationSaveResponse */
export interface ClaimBarConfigurationSaveResponse {
  /** Form Id */
  form_id: number | null;
}

/** ClaimBarOrderJson */
export interface ClaimBarOrderJson {
  /**
   * Field Keys
   * @minItems 1
   */
  field_keys: (
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string
  )[];
}

/**
 * ClaimChatHistoryResponse
 * Response containing list of user's chat history for a claim.
 */
export interface ClaimChatHistoryResponse {
  /** Chats */
  chats: ClaimChatHistoryResponseClaimChatHistoryItem[];
}

/**
 * ClaimChatHistoryItem
 * Single chat history item.
 */
export interface ClaimChatHistoryResponseClaimChatHistoryItem {
  /**
   * Chat Title
   * @default null
   */
  chat_title?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** External Chat Id */
  external_chat_id: string;
  /** Id */
  id: number;
  /**
   * Is Bookmarked
   * @default false
   */
  is_bookmarked?: boolean;
}

/**
 * ClaimCliveReferencesQuery
 * Comma-separated ids, as the browser collects them from ``src:<kind>:<id>`` citations.
 *
 * A document's external id comes bare, and any other kind's id as ``kind:id``. Each id is URI-component-encoded
 * before joining, since an id such as a ``calc`` expression can carry a comma of its own.
 */
export interface ClaimCliveReferencesQuery {
  /**
   * Ids
   * @default ""
   */
  ids?: string;
}

/**
 * ClaimCliveReferencesResponse
 * The sources a claim's Clive text cites, keyed by each id exactly as the query sent it.
 *
 * An id nobody can resolve on this claim is absent rather than null, so the map only ever
 * holds references the reader may open.
 */
export interface ClaimCliveReferencesResponse {
  /** References */
  references: Record<string, ClaimCliveReferencesResponseCliveReferenceData>;
}

/**
 * CliveReferenceData
 * Structured reference data for documents, notes, communications and AI-service sources used in AI chat.
 */
export interface ClaimCliveReferencesResponseCliveReferenceData {
  /**
   * Ai Summary
   * @default null
   */
  ai_summary?: string | null;
  /**
   * Claim Internal Id
   * @default null
   */
  claim_internal_id?: number | null;
  /**
   * Date
   * @default null
   */
  date?: string | null;
  /**
   * Document Title
   * @default null
   */
  document_title?: string | null;
  /** Id */
  id: number | string;
  /**
   * Is Latest
   * @default null
   */
  is_latest?: boolean | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Type
   * @default null
   */
  sub_type?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /**
   * Text
   * @default null
   */
  text?: string | null;
  /** Type */
  type: string;
  /**
   * Version At
   * @default null
   */
  version_at?: string | null;
}

/** ClaimCommunicationItemIdsParams */
export interface ClaimCommunicationItemIdsParams {
  /**
   * Categories Ids
   * List of category IDs to filter by (use 0 for uncategorized)
   * @default null
   */
  categories_ids?: number[] | null;
  /**
   * Communication Channel
   * Filter by a single communication channel
   * @default null
   */
  communication_channel?:
    | "email"
    | "sms"
    | "phone_call"
    | "physical_mail"
    | "video_call"
    | "vendor"
    | null;
  /**
   * Communication Channels
   * Filter by multiple communication channels
   * @default null
   */
  communication_channels?:
    | (
        | "email"
        | "sms"
        | "phone_call"
        | "physical_mail"
        | "video_call"
        | "vendor"
      )[]
    | null;
  /**
   * Contact Id
   * Filter by contact ID
   * @default null
   */
  contact_id?: number | null;
  /**
   * Exposures Filters
   * List of exposure IDs to filter by (0 for general exposure)
   * @default null
   */
  exposures_filters?: number[] | null;
  /**
   * Handled Status
   * Filter by handled status. "pending" = not yet marked handled, "handled" = marked handled. Omit for all communications, including outgoing ones, which carry no handled status and appear only when the filter is omitted.
   * @default null
   */
  handled_status?: "pending" | "handled" | null;
  /**
   * Search Text
   * Search text to filter communications
   * @default null
   */
  search_text?: string | null;
  /**
   * Sort By
   * Sort field with optional direction (+/-). Available: datetime
   * @default "-datetime"
   */
  sort_by?: string | null;
  /**
   * User Id
   * Filter by adjuster/user ID
   * @default null
   */
  user_id?: string | null;
  /**
   * With Read Status
   * Include read status information
   * @default null
   */
  with_read_status?: boolean | null;
}

/** ClaimCommunicationItemsByIdsParams */
export interface ClaimCommunicationItemsByIdsParams {
  /**
   * Ids
   * List of communication IDs to retrieve
   */
  ids: number[];
  /**
   * With Read Status
   * Include read status information
   * @default null
   */
  with_read_status?: boolean | null;
}

/**
 * ClaimConductorAskResponse
 * The ask a gesture settled, as it reads now.
 */
export interface ClaimConductorAskResponse {
  /** Ask */
  ask:
    | ({
        kind: "question";
      } & ClaimConductorAskResponseConductorQuestion)
    | ({
        kind: "request";
      } & ClaimConductorAskResponseConductorRequest);
}

/**
 * ConductorAskActor
 * Who settled an ask, by the name the hub shows. Their reference is claims_llm's to resolve.
 */
export interface ClaimConductorAskResponseConductorAskActor {
  /** Display Name */
  display_name: string;
}

/**
 * ConductorAskAgentClosure
 * The agent closing an ask itself: the work it asked for arrived, or the claim moved on.
 */
export interface ClaimConductorAskResponseConductorAskAgentClosure {
  /**
   * At
   * @format date-time
   */
  at: string;
  /** How the agent itself closed an ask — both members are terminal.  ``RESOLVED`` is a request only — the work the agent asked for arrived. ``WITHDRAWN`` is either kind: the claim moved on and the ask no longer matters. */
  closed_as: ClaimConductorAskResponseAgentClosedAs;
  /** Reason */
  reason: string;
}

/**
 * ConductorAskAnswered
 * A question settled with the handler's answer; ``from_options`` is False when they wrote their own
 * rather than picking one the question offered.
 */
export interface ClaimConductorAskResponseConductorAskAnswered {
  /** Who settled an ask, by the name the hub shows. Their reference is claims_llm's to resolve. */
  actor: ClaimConductorAskResponseConductorAskActor;
  /** Answer */
  answer: string;
  /**
   * At
   * @format date-time
   */
  at: string;
  /** From Options */
  from_options: boolean;
  /** Gesture */
  gesture: "answered";
}

/**
 * ConductorAskRejected
 * A request the handler declined, with the reason the agent acts on.
 */
export interface ClaimConductorAskResponseConductorAskRejected {
  /** Who settled an ask, by the name the hub shows. Their reference is claims_llm's to resolve. */
  actor: ClaimConductorAskResponseConductorAskActor;
  /**
   * At
   * @format date-time
   */
  at: string;
  /** Gesture */
  gesture: "rejected";
  /** Reason */
  reason: string;
}

/**
 * ConductorQuestion
 * An ask the agent cannot proceed without; it waits for one of its options or the handler's own
 * answer. ``in_response_to`` names the handler messages it answers when a run raised it as its reply to
 * them; it is null on a question of the agent's own.
 */
export interface ClaimConductorAskResponseConductorQuestion {
  agent_closure: ClaimConductorAskResponseConductorAskAgentClosure | null;
  /** Ask */
  ask: string;
  /** Body */
  body: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description: string;
  /** Human Response */
  human_response:
    | (
        | ({
            gesture: "answered";
          } & ClaimConductorAskResponseConductorAskAnswered)
        | ({
            gesture: "rejected";
          } & ClaimConductorAskResponseConductorAskRejected)
      )
    | null;
  /** Id */
  id: string;
  /**
   * In Response To
   * @default null
   */
  in_response_to?: string[] | null;
  /** Kind */
  kind: "question";
  /** Options */
  options: string[];
  /** Whether the ask is still the handler's to deal with.  Two values only: how an ask ended is carried by ``human_response`` and ``agent_closure``, not by a third status. */
  status: ClaimConductorAskResponseAskStatus;
  /** Summary */
  summary: string;
}

/**
 * ConductorRequest
 * An ask for a piece of work; the agent carries on while it is outstanding.
 */
export interface ClaimConductorAskResponseConductorRequest {
  agent_closure: ClaimConductorAskResponseConductorAskAgentClosure | null;
  /** Ask */
  ask: string;
  /** Body */
  body: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description: string;
  /** Human Response */
  human_response:
    | (
        | ({
            gesture: "answered";
          } & ClaimConductorAskResponseConductorAskAnswered)
        | ({
            gesture: "rejected";
          } & ClaimConductorAskResponseConductorAskRejected)
      )
    | null;
  /** Id */
  id: string;
  /** Kind */
  kind: "request";
  /** Whether the ask is still the handler's to deal with.  Two values only: how an ask ended is carried by ``human_response`` and ``agent_closure``, not by a third status. */
  status: ClaimConductorAskResponseAskStatus;
  /** Summary */
  summary: string;
}

/**
 * ClaimConductorAsksQuery
 * Typed as the published enum, so an unknown status is refused here rather than round tripped.
 *
 * No status lists every ask, which is what the upstream route does without a filter.
 */
export interface ClaimConductorAsksQuery {
  /** @default null */
  status?: ClaimConductorAsksQueryAskStatus | null;
}

/**
 * ClaimConductorAsksResponse
 * The asks the agent raised on a claim, under the ``items`` envelope the upstream route uses.
 */
export interface ClaimConductorAsksResponse {
  /** Items */
  items: (
    | ({
        kind: "question";
      } & ClaimConductorAsksResponseConductorQuestion)
    | ({
        kind: "request";
      } & ClaimConductorAsksResponseConductorRequest)
  )[];
}

/**
 * ConductorAskActor
 * Who settled an ask, by the name the hub shows. Their reference is claims_llm's to resolve.
 */
export interface ClaimConductorAsksResponseConductorAskActor {
  /** Display Name */
  display_name: string;
}

/**
 * ConductorAskAgentClosure
 * The agent closing an ask itself: the work it asked for arrived, or the claim moved on.
 */
export interface ClaimConductorAsksResponseConductorAskAgentClosure {
  /**
   * At
   * @format date-time
   */
  at: string;
  /** How the agent itself closed an ask — both members are terminal.  ``RESOLVED`` is a request only — the work the agent asked for arrived. ``WITHDRAWN`` is either kind: the claim moved on and the ask no longer matters. */
  closed_as: ClaimConductorAsksResponseAgentClosedAs;
  /** Reason */
  reason: string;
}

/**
 * ConductorAskAnswered
 * A question settled with the handler's answer; ``from_options`` is False when they wrote their own
 * rather than picking one the question offered.
 */
export interface ClaimConductorAsksResponseConductorAskAnswered {
  /** Who settled an ask, by the name the hub shows. Their reference is claims_llm's to resolve. */
  actor: ClaimConductorAsksResponseConductorAskActor;
  /** Answer */
  answer: string;
  /**
   * At
   * @format date-time
   */
  at: string;
  /** From Options */
  from_options: boolean;
  /** Gesture */
  gesture: "answered";
}

/**
 * ConductorAskRejected
 * A request the handler declined, with the reason the agent acts on.
 */
export interface ClaimConductorAsksResponseConductorAskRejected {
  /** Who settled an ask, by the name the hub shows. Their reference is claims_llm's to resolve. */
  actor: ClaimConductorAsksResponseConductorAskActor;
  /**
   * At
   * @format date-time
   */
  at: string;
  /** Gesture */
  gesture: "rejected";
  /** Reason */
  reason: string;
}

/**
 * ConductorQuestion
 * An ask the agent cannot proceed without; it waits for one of its options or the handler's own
 * answer. ``in_response_to`` names the handler messages it answers when a run raised it as its reply to
 * them; it is null on a question of the agent's own.
 */
export interface ClaimConductorAsksResponseConductorQuestion {
  agent_closure: ClaimConductorAsksResponseConductorAskAgentClosure | null;
  /** Ask */
  ask: string;
  /** Body */
  body: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description: string;
  /** Human Response */
  human_response:
    | (
        | ({
            gesture: "answered";
          } & ClaimConductorAsksResponseConductorAskAnswered)
        | ({
            gesture: "rejected";
          } & ClaimConductorAsksResponseConductorAskRejected)
      )
    | null;
  /** Id */
  id: string;
  /**
   * In Response To
   * @default null
   */
  in_response_to?: string[] | null;
  /** Kind */
  kind: "question";
  /** Options */
  options: string[];
  /** Whether the ask is still the handler's to deal with.  Two values only: how an ask ended is carried by ``human_response`` and ``agent_closure``, not by a third status. */
  status: ClaimConductorAsksResponseAskStatus;
  /** Summary */
  summary: string;
}

/**
 * ConductorRequest
 * An ask for a piece of work; the agent carries on while it is outstanding.
 */
export interface ClaimConductorAsksResponseConductorRequest {
  agent_closure: ClaimConductorAsksResponseConductorAskAgentClosure | null;
  /** Ask */
  ask: string;
  /** Body */
  body: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description: string;
  /** Human Response */
  human_response:
    | (
        | ({
            gesture: "answered";
          } & ClaimConductorAsksResponseConductorAskAnswered)
        | ({
            gesture: "rejected";
          } & ClaimConductorAsksResponseConductorAskRejected)
      )
    | null;
  /** Id */
  id: string;
  /** Kind */
  kind: "request";
  /** Whether the ask is still the handler's to deal with.  Two values only: how an ask ended is carried by ``human_response`` and ``agent_closure``, not by a third status. */
  status: ClaimConductorAsksResponseAskStatus;
  /** Summary */
  summary: string;
}

/**
 * ClaimConductorHandlingResponse
 * Who drives the claim, and the latest switch: when, by whom and why. ``since``, ``actor`` and
 * ``reason`` are null on a claim nobody switched, never absent.
 */
export interface ClaimConductorHandlingResponse {
  actor: ClaimConductorHandlingResponseConductorHandlingActor | null;
  /** Who is driving the claim: the conductor, or a person who took it over. */
  mode: ClaimConductorHandlingResponseHandlingMode;
  /** Reason */
  reason: string | null;
  /** Since */
  since: string | null;
}

/**
 * ConductorHandlingActor
 * Who switched the claim, by display name. Their reference is the conductor's to read.
 */
export interface ClaimConductorHandlingResponseConductorHandlingActor {
  /** Display Name */
  display_name: string;
}

/**
 * ClaimConductorMessageResponse
 * The message as stored.
 */
export interface ClaimConductorMessageResponse {
  /**
   * A message as the hub renders it.
   *
   * Built from the published client's DTO (``to_dict()``), whose bookkeeping - the account, the claim number and the
   * reply's run reference and id - is not declared here and so is dropped on validation. ``reply`` is null
   * until a run has replied, never absent. ``told_at``, ``told_by_run_ref`` and ``told_via`` say when, by which
   * run and how the message was first told to a run; they are null until a run is told it, never absent.
   */
  message: ClaimConductorMessageResponseConductorMessage;
}

/**
 * ConductorMessage
 * A message as the hub renders it.
 *
 * Built from the published client's DTO (``to_dict()``), whose bookkeeping - the account, the claim number and the
 * reply's run reference and id - is not declared here and so is dropped on validation. ``reply`` is null
 * until a run has replied, never absent. ``told_at``, ``told_by_run_ref`` and ``told_via`` say when, by which
 * run and how the message was first told to a run; they are null until a run is told it, never absent.
 */
export interface ClaimConductorMessageResponseConductorMessage {
  /** Who sent a message, by the name the hub shows. Their reference is claims_llm's to resolve. */
  author: ClaimConductorMessageResponseConductorMessageAuthor;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Id */
  id: string;
  reply: ClaimConductorMessageResponseConductorMessageReply | null;
  /** Whether a run has yet to answer the message.  The reply a run gives in ``finalize`` closes it, with every other message that run was told. */
  status: ClaimConductorMessageResponseMessageStatus;
  /** Text */
  text: string;
  /**
   * Told At
   * @default null
   */
  told_at?: string | null;
  /**
   * Told By Run Ref
   * @default null
   */
  told_by_run_ref?: string | null;
  /** @default null */
  told_via?: ClaimConductorMessageResponseToldVia | null;
}

/**
 * ConductorMessageAuthor
 * Who sent a message, by the name the hub shows. Their reference is claims_llm's to resolve.
 */
export interface ClaimConductorMessageResponseConductorMessageAuthor {
  /** Display Name */
  display_name: string;
}

/**
 * ConductorMessageReply
 * What the run that read the message said back, and what it took the message to be about.
 *
 * The answer is ``text``, the questions the run raised as its reply (``ask_ids``), or both; ``text`` is
 * empty when the questions are the whole reply. A reply written before replies carried questions has
 * no ``ask_ids``, and reads as an empty list.
 */
export interface ClaimConductorMessageResponseConductorMessageReply {
  /**
   * Ask Ids
   * @default []
   */
  ask_ids?: string[];
  /**
   * At
   * @format date-time
   */
  at: string;
  /** Message Subject */
  message_subject: string;
  /** Text */
  text: string;
}

/**
 * ClaimConductorMessagesQuery
 * Typed as the published enum, so an unknown status is refused here rather than round tripped.
 *
 * No status lists every message, which is what the upstream route does without a filter.
 */
export interface ClaimConductorMessagesQuery {
  /** @default null */
  status?: ClaimConductorMessagesQueryMessageStatus | null;
}

/**
 * ClaimConductorMessagesResponse
 * The handler's messages on a claim, under the ``items`` envelope the upstream route uses.
 */
export interface ClaimConductorMessagesResponse {
  /** Items */
  items: ClaimConductorMessagesResponseConductorMessage[];
}

/**
 * ConductorMessage
 * A message as the hub renders it.
 *
 * Built from the published client's DTO (``to_dict()``), whose bookkeeping - the account, the claim number and the
 * reply's run reference and id - is not declared here and so is dropped on validation. ``reply`` is null
 * until a run has replied, never absent. ``told_at``, ``told_by_run_ref`` and ``told_via`` say when, by which
 * run and how the message was first told to a run; they are null until a run is told it, never absent.
 */
export interface ClaimConductorMessagesResponseConductorMessage {
  /** Who sent a message, by the name the hub shows. Their reference is claims_llm's to resolve. */
  author: ClaimConductorMessagesResponseConductorMessageAuthor;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Id */
  id: string;
  reply: ClaimConductorMessagesResponseConductorMessageReply | null;
  /** Whether a run has yet to answer the message.  The reply a run gives in ``finalize`` closes it, with every other message that run was told. */
  status: ClaimConductorMessagesResponseMessageStatus;
  /** Text */
  text: string;
  /**
   * Told At
   * @default null
   */
  told_at?: string | null;
  /**
   * Told By Run Ref
   * @default null
   */
  told_by_run_ref?: string | null;
  /** @default null */
  told_via?: ClaimConductorMessagesResponseToldVia | null;
}

/**
 * ConductorMessageAuthor
 * Who sent a message, by the name the hub shows. Their reference is claims_llm's to resolve.
 */
export interface ClaimConductorMessagesResponseConductorMessageAuthor {
  /** Display Name */
  display_name: string;
}

/**
 * ConductorMessageReply
 * What the run that read the message said back, and what it took the message to be about.
 *
 * The answer is ``text``, the questions the run raised as its reply (``ask_ids``), or both; ``text`` is
 * empty when the questions are the whole reply. A reply written before replies carried questions has
 * no ``ask_ids``, and reads as an empty list.
 */
export interface ClaimConductorMessagesResponseConductorMessageReply {
  /**
   * Ask Ids
   * @default []
   */
  ask_ids?: string[];
  /**
   * At
   * @format date-time
   */
  at: string;
  /** Message Subject */
  message_subject: string;
  /** Text */
  text: string;
}

/**
 * ClaimConductorStageHistoryResponse
 * Every stage change recorded for the claim, oldest first. Empty when none is recorded.
 */
export interface ClaimConductorStageHistoryResponse {
  /** History */
  history: ClaimConductorStageHistoryResponseClaimStageHistoryEntry[];
}

/**
 * ClaimStageHistoryEntry
 * One stage change of the claim.
 *
 * ``previous_stage_key`` is null when the claim had no stage before this change. ``changed_by`` is the
 * full name of the user who made the change, null when no user is recorded or the user has no
 * name.
 */
export interface ClaimConductorStageHistoryResponseClaimStageHistoryEntry {
  /** How a change to a claim (its stage, a milestone date) was initiated. */
  change_source: ClaimConductorStageHistoryResponseClaimChangeSource;
  /**
   * Changed At
   * @format date-time
   */
  changed_at: string;
  /** Changed By */
  changed_by: string | null;
  /** New Stage Key */
  new_stage_key: string;
  /** Previous Stage Key */
  previous_stage_key: string | null;
}

/**
 * ClaimConductorStagesResponse
 * The claim stages the conductor is served for the claim's scope, in claim-stage order.
 *
 * Empty when the conductor is off for that scope or none of its stages is configured.
 */
export interface ClaimConductorStagesResponse {
  /** Stage Keys */
  stage_keys: string[];
}

/**
 * ClaimConductorStatusResponse
 * Whether the conductor is working on the claim and, if not, why, with the asks still waiting on the
 * handler. ``conductor_status`` and ``run_id`` are null on a claim the conductor never ran on, and
 * ``conductor_status`` can be a status newer than the ones listed.
 */
export interface ClaimConductorStatusResponse {
  /** Conductor Status */
  conductor_status: ClaimConductorStatusResponseConductorStatus | string | null;
  /** Is Active */
  is_active: boolean;
  /** Open Asks */
  open_asks: number;
  /** Run Id */
  run_id: string | null;
}

/**
 * ClaimContactInfo
 * ContactInfo enriched with claim-scoped exposure labels.
 *
 * Inherits all contact fields and adds exposure data that only
 * exists in claim context.
 */
export interface ClaimContactInfo {
  /**
   * Account Details
   * @default null
   */
  account_details?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Bar Number
   * @default null
   */
  attorney_bar_number?: string | null;
  /**
   * Attorney Bar State
   * @default null
   */
  attorney_bar_state?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Change Ulid
   * @default null
   */
  au_tfn_change_ulid?: string | null;
  /**
   * Au Tfn Contact Document Id
   * @default null
   */
  au_tfn_contact_document_id?: number | null;
  /**
   * Au Tfn Exemption
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Bank Proof Contact Document Id
   * @default null
   */
  bank_proof_contact_document_id?: number | null;
  /**
   * Business Legal Name
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Coi Contact Document Id
   * @default null
   */
  coi_contact_document_id?: number | null;
  /**
   * Coi Expiration
   * @default null
   */
  coi_expiration?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /** @default null */
  contact_extra?: ClaimContactInfoContactExtraInfo | null;
  /**
   * Contract Of Service Contact Document Id
   * @default null
   */
  contract_of_service_contact_document_id?: number | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivated By User Id
   * @default null
   */
  deactivated_by_user_id?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: ClaimContactInfoContactEmailInfo[];
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * Exposure Ids
   * @default []
   */
  exposure_ids?: number[];
  /**
   * Finance Change Ulid
   * @default null
   */
  finance_change_ulid?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Address
   * @default null
   */
  full_address?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** Id */
  id: number;
  /**
   * Immutable Exposure Ids
   * @default []
   */
  immutable_exposure_ids?: number[];
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /** Is Company */
  is_company: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean;
  /**
   * Is Deceased
   * @default null
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Moi Service Provider
   * @default null
   */
  is_moi_service_provider?: boolean | null;
  /**
   * Is Policy Contact
   * @default null
   */
  is_policy_contact?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * Medical Provider Discount Fixed Amount
   * @default null
   */
  medical_provider_discount_fixed_amount?: number | null;
  /**
   * Medical Provider Discount Percentage
   * @default null
   */
  medical_provider_discount_percentage?: number | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Moi Expertises
   * @default []
   */
  moi_expertises?: string[];
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Organization External Id
   * @default null
   */
  organization_external_id?: string | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Phones
   * @default []
   */
  phones?: ClaimContactInfoContactPhoneInfo[];
  /**
   * Reference Contact Full Name
   * @default null
   */
  reference_contact_full_name?: string | null;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * Sex
   * @default null
   */
  sex?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Street Address1
   * @default null
   */
  street_address1?: string | null;
  /**
   * Street Address2
   * @default null
   */
  street_address2?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Granted At
   * @default null
   */
  trusted_payee_granted_at?: string | null;
  /**
   * Trusted Payee Granted By User Name
   * @default null
   */
  trusted_payee_granted_by_user_name?: string | null;
  /**
   * Trusted Payee Per Payment Limit
   * @default null
   */
  trusted_payee_per_payment_limit?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Trusted Payee Valid To
   * @default null
   */
  trusted_payee_valid_to?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Validations
   * @default []
   */
  validations?: ClaimContactInfoContactValidationInfo[];
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * W9 Contact Document Id
   * @default null
   */
  w9_contact_document_id?: number | null;
  /**
   * W9 Date
   * @default null
   */
  w9_date?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** AddressValidationDetails */
export interface ClaimContactInfoAddressValidationDetails {
  /**
   * Override Reason
   * @default null
   */
  override_reason?: string | null;
  /**
   * Override Timestamp
   * @default null
   */
  override_timestamp?: string | null;
  /**
   * Override User Name
   * @default null
   */
  override_user_name?: string | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Ref Type
   * @default null
   */
  ref_type?: string | null;
  /**
   * Type
   * @default "address"
   */
  type?: "address";
}

/** BusinessValidationDetails */
export interface ClaimContactInfoBusinessValidationDetails {
  /**
   * Bn
   * @default null
   */
  bn?: string | null;
  /**
   * Entity Type
   * @default null
   */
  entity_type?: string | null;
  /**
   * Gst Status
   * @default null
   */
  gst_status?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Type
   * @default "business"
   */
  type?: "business";
}

/** ContactEmailInfo */
export interface ClaimContactInfoContactEmailInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email */
  email: string;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
}

/** ContactExtraInfo */
export interface ClaimContactInfoContactExtraInfo {
  /**
   * Driving License Issue Date
   * @default null
   */
  driving_license_issue_date?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Is Unrecognized Number Contact
   * @default null
   */
  is_unrecognized_number_contact?: boolean | null;
  /**
   * Profession
   * @default null
   */
  profession?: string | null;
  /**
   * User Id
   * @default null
   */
  user_id?: string | null;
}

/** ContactPhoneInfo */
export interface ClaimContactInfoContactPhoneInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /** Phone */
  phone: string;
  /**
   * Phone Type
   * @default null
   */
  phone_type?: string | null;
  /**
   * Standardized Phone
   * @default null
   */
  standardized_phone?: string | null;
}

/** ContactValidationInfo */
export interface ClaimContactInfoContactValidationInfo {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Id */
  id: number;
  /** Provider */
  provider: string;
  /** Status */
  status: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Validation Details
   * @default null
   */
  validation_details?:
    | (
        | ({
            type: "address";
          } & ClaimContactInfoAddressValidationDetails)
        | ({
            type: "business";
          } & ClaimContactInfoBusinessValidationDetails)
      )
    | null;
  /** Validation Type */
  validation_type: string;
}

/** ClaimDisplayEntryList */
export type ClaimDisplayEntryList = ClaimDisplayEntryListClaimDisplayEntry[];

/** ClaimDisplayEntry */
export interface ClaimDisplayEntryListClaimDisplayEntry {
  /**
   * Cause Code
   * @default null
   */
  cause_code?: string | null;
  /**
   * Cause Codes Dict
   * @default null
   */
  cause_codes_dict?: Record<string, any> | null;
  /**
   * Claim Flag Keys
   * @default []
   */
  claim_flag_keys?: string[];
  /** Claim Id Display */
  claim_id_display: string;
  /**
   * Claimant Contact Full Name
   * @default null
   */
  claimant_contact_full_name?: string | null;
  /**
   * Claimant Contact Id
   * @default null
   */
  claimant_contact_id?: number | null;
  /** Client */
  client: string;
  /**
   * Creation Date
   * @format date-time
   */
  creation_date: string;
  /**
   * Date Closed
   * @default null
   */
  date_closed?: string | null;
  /**
   * Date Of Loss
   * @format date
   */
  date_of_loss: string;
  /**
   * First Party Involved Entities Display Names
   * @default null
   */
  first_party_involved_entities_display_names?: string[] | null;
  /**
   * Handling Adjuster
   * @default null
   */
  handling_adjuster?: string | null;
  /** Id */
  id: number;
  /**
   * Incident Sub Type
   * @default null
   */
  incident_sub_type?: string | null;
  /**
   * Incident Sub Type Desc
   * @default null
   */
  incident_sub_type_desc?: string | null;
  /**
   * Incident Type
   * @default null
   */
  incident_type?: string | null;
  /**
   * Incident Type Desc
   * @default null
   */
  incident_type_desc?: string | null;
  /**
   * Insured Contact Full Name
   * @default null
   */
  insured_contact_full_name?: string | null;
  /**
   * Insured Contact Id
   * @default null
   */
  insured_contact_id?: number | null;
  /**
   * Insured Property Id
   * @default null
   */
  insured_property_id?: number | null;
  /**
   * Insured Property Sublocation Id
   * @default null
   */
  insured_property_sublocation_id?: number | null;
  /**
   * Is Closed
   * @default false
   */
  is_closed?: boolean | null;
  /**
   * Last Touched
   * @default null
   */
  last_touched?: string | null;
  /** Lob */
  lob: string;
  /** Organization Name */
  organization_name: string;
  /**
   * Policy Country
   * @default null
   */
  policy_country?: string | null;
  /**
   * Policy Id
   * @default null
   */
  policy_id?: number | null;
  /**
   * Policy Number
   * @default null
   */
  policy_number?: string | null;
  /**
   * Reported Date
   * @default null
   */
  reported_date?: string | null;
  /**
   * Reporter Contact Full Name
   * @default null
   */
  reporter_contact_full_name?: string | null;
  /**
   * Reporter Contact Id
   * @default null
   */
  reporter_contact_id?: number | null;
  /**
   * Source Code
   * @default null
   */
  source_code?: string | null;
  /**
   * Source Codes Dict
   * @default null
   */
  source_codes_dict?: Record<string, any> | null;
  /**
   * Stage Key
   * @default null
   */
  stage_key?: string | null;
  /**
   * Subtype
   * @default null
   */
  subtype?: string | null;
  /**
   * Time Of Loss
   * @default null
   */
  time_of_loss?: string | null;
  /** Type */
  type: string;
}

/**
 * ClaimExportJobResponse
 * Enqueue response: the id of the created export job.
 */
export interface ClaimExportJobResponse {
  /** Export Job Id */
  export_job_id: number;
  /** Status */
  status: string;
}

/**
 * ClaimExportJobsListResponse
 * All export jobs for a claim plus the count of currently-active export jobs within the TTL.
 */
export interface ClaimExportJobsListResponse {
  /** Active Export Count */
  active_export_count: number;
  /** Jobs */
  jobs: ClaimExportJobsListResponseClaimExportJobStatusResponse[];
}

/**
 * ClaimExportJobStatusResponse
 * A single export job's status, for the jobs-list endpoint.
 */
export interface ClaimExportJobsListResponseClaimExportJobStatusResponse {
  /** Datetime Created */
  datetime_created: string;
  /**
   * Document Id
   * @default null
   */
  document_id?: number | null;
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /** Id */
  id: number;
  /** Status */
  status: string;
}

/**
 * ClaimExportRequest
 * Request body for POST /claims/<claim_id>/export.
 *
 * Every field is required, matching the contract this route has always enforced: it read all nine
 * keys with hard subscription, so a partial payload produced no export at all. Defaulting the
 * section flags instead would let ``{"should_export_entire_claim": true}`` return a 200 with notes,
 * financial transactions, contacts and dashboards silently missing from the PDF.
 */
export interface ClaimExportRequest {
  /** Communications Id List */
  communications_id_list: number[];
  /** Documents Id List */
  documents_id_list: number[];
  /** Exposures Id List */
  exposures_id_list: number[];
  /** Should Export Contacts */
  should_export_contacts: boolean;
  /** Should Export Entire Claim */
  should_export_entire_claim: boolean;
  /** Should Export Financial Transactions */
  should_export_financial_transactions: boolean;
  /** Should Export Liability Dashboards */
  should_export_liability_dashboards: boolean;
  /** Should Export Notes */
  should_export_notes: boolean;
  /** Should Export Pip Dashboards */
  should_export_pip_dashboards: boolean;
}

/**
 * ClaimExportSyncResponse
 * Synchronous-export response (feature flag off): the id of the built document.
 */
export interface ClaimExportSyncResponse {
  /** Document Id */
  document_id: number;
}

/** ClaimFieldAppendJson */
export interface ClaimFieldAppendJson {
  /** Display Name */
  display_name: string;
  /** Field Key */
  field_key:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
}

/**
 * ClaimFieldCatalogParams
 * The scope whose catalog is asked for. Neither set is the organization Default.
 */
export interface ClaimFieldCatalogParams {
  /**
   * Lob
   * @default null
   */
  lob?: string | null;
  /**
   * Sub Org Id
   * @default null
   */
  sub_org_id?: number | null;
}

/**
 * ClaimFieldCatalogResponse
 * Empty, not an error, for an organization or scope with nothing to add: a hospitality-only
 * organization offers nothing, and a scope with no incident configuration offers no
 * ``configured_fields`` entry.
 */
export interface ClaimFieldCatalogResponse {
  /** Fields */
  fields: ClaimFieldCatalogResponseClaimFieldCatalogEntry[];
}

/** ClaimFieldCatalogEntry */
export interface ClaimFieldCatalogResponseClaimFieldCatalogEntry {
  /** Field Key */
  field_key: string;
  /** Field Type */
  field_type:
    | "boolean"
    | "contact"
    | "date"
    | "datetime"
    | "hierarchical"
    | "location"
    | "monetary"
    | "multiline_string"
    | "multiselect"
    | "number"
    | "select"
    | "string"
    | "time"
    | "us_state_select"
    | "yes_no_na_unknown";
  /** Group */
  group: string[];
  /** Label */
  label: string;
  /** Namespace */
  namespace: "api" | "configured_fields";
}

/**
 * ClaimFieldsConfigurationMoveJson
 * Move the entry at ``from_index`` to ``to_index``. Both index the STORED column, which can hold
 * entries a screen does not render, so a client maps its displayed position before sending.
 * ``field_key`` names the entry the client sees at ``from_index`` and ``to_field_key`` the one it sees at
 * ``to_index``; a mismatch at either means the column changed since the client loaded it, and the move is
 * refused rather than applied to another entry or position.
 */
export interface ClaimFieldsConfigurationMoveJson {
  /** Field Key */
  field_key:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string
    | "summary"
    | "management"
    | "notes"
    | "legal_actions"
    | "finances"
    | "communications"
    | "contacts"
    | "documents"
    | "gallery"
    | "policy"
    | "related_claims"
    | "osha"
    | "notifications"
    | "clive_chat"
    | "clive_insights"
    | "conductor_hub"
    | "milestones";
  /**
   * From Index
   * @min 0
   */
  from_index: number;
  /** To Field Key */
  to_field_key:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string
    | "summary"
    | "management"
    | "notes"
    | "legal_actions"
    | "finances"
    | "communications"
    | "contacts"
    | "documents"
    | "gallery"
    | "policy"
    | "related_claims"
    | "osha"
    | "notifications"
    | "clive_chat"
    | "clive_insights"
    | "conductor_hub"
    | "milestones";
  /**
   * To Index
   * @min 0
   */
  to_index: number;
}

/** ClaimFieldsConfigurationSwapJson */
export interface ClaimFieldsConfigurationSwapJson {
  /** Field Key 1 */
  field_key_1:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string
    | "summary"
    | "management"
    | "notes"
    | "legal_actions"
    | "finances"
    | "communications"
    | "contacts"
    | "documents"
    | "gallery"
    | "policy"
    | "related_claims"
    | "osha"
    | "notifications"
    | "clive_chat"
    | "clive_insights"
    | "conductor_hub"
    | "milestones";
  /** Field Key 2 */
  field_key_2:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string
    | "summary"
    | "management"
    | "notes"
    | "legal_actions"
    | "finances"
    | "communications"
    | "contacts"
    | "documents"
    | "gallery"
    | "policy"
    | "related_claims"
    | "osha"
    | "notifications"
    | "clive_chat"
    | "clive_insights"
    | "conductor_hub"
    | "milestones";
}

/** ClaimFieldsConfigurationTargetQuery */
export interface ClaimFieldsConfigurationTargetQuery {
  /**
   * Form Id
   * @default null
   */
  form_id?: number | null;
}

/** ClaimFieldsConfigurationUpdateJson */
export interface ClaimFieldsConfigurationUpdateJson {
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
}

/** ClaimFieldsConfigurationsResponse */
export interface ClaimFieldsConfigurationsResponse {
  fields_configurations: ClaimFieldsConfigurationsResponseAllClaimFieldsConfigurations;
  /** Organization Id */
  organization_id: number;
}

/** AllClaimFieldsConfigurations */
export interface ClaimFieldsConfigurationsResponseAllClaimFieldsConfigurations {
  /** Claim Bar */
  claim_bar: ClaimFieldsConfigurationsResponseClaimBarFieldConfiguration[];
  /** Claim Sidebar */
  claim_sidebar: ClaimFieldsConfigurationsResponseClaimSidebarFieldConfiguration[];
}

/** ClaimBarFieldConfiguration */
export interface ClaimFieldsConfigurationsResponseClaimBarFieldConfiguration {
  /** Config Type */
  config_type: "claim_bar";
  /** Display Name */
  display_name: string;
  /** Field Key */
  field_key:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string;
  /** Is Enabled */
  is_enabled: boolean;
}

/** ClaimSidebarFieldConfiguration */
export interface ClaimFieldsConfigurationsResponseClaimSidebarFieldConfiguration {
  /** Config Type */
  config_type: "claim_sidebar";
  /** Display Name */
  display_name: string;
  /** Field Key */
  field_key:
    | "summary"
    | "management"
    | "notes"
    | "legal_actions"
    | "finances"
    | "communications"
    | "contacts"
    | "documents"
    | "gallery"
    | "policy"
    | "related_claims"
    | "osha"
    | "notifications"
    | "clive_chat"
    | "clive_insights"
    | "conductor_hub"
    | "milestones";
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * ClaimFieldsFormDetailResponse
 * One configuration as it resolves, in display order. A scoped configuration's ``claim_sidebar`` is
 * empty: the sidebar is configured on the Default only.
 *
 * ``last_updated_*`` describe this configuration's own row, so a Default edit that reaches it by
 * inheritance does not move them. A Five Sigma user's edit names the organization's system user. Both
 * are null for a row not changed since the row began recording them.
 */
export interface ClaimFieldsFormDetailResponse {
  /** Claim Bar */
  claim_bar: ClaimFieldsFormDetailResponseClaimFieldsFormFieldEntry[];
  /** Claim Sidebar */
  claim_sidebar: ClaimFieldsFormDetailResponseClaimFieldsFormFieldEntry[];
  /** Id */
  id: number;
  /** Is Default */
  is_default: boolean;
  /** Is Editable */
  is_editable: boolean;
  /**
   * Last Updated By Username
   * @default null
   */
  last_updated_by_username?: string | null;
  /**
   * Last Updated Datetime
   * @default null
   */
  last_updated_datetime?: string | null;
  /** Lob */
  lob: string | null;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/** ClaimFieldsFormFieldEntry */
export interface ClaimFieldsFormDetailResponseClaimFieldsFormFieldEntry {
  /** Display Name */
  display_name: string;
  /** Field Key */
  field_key: string;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Own */
  is_own: boolean;
}

/**
 * ClaimFieldsFormsResponse
 * Only the configurations that have a row of their own. An organization that never edited its claim
 * fields has no Default row, and so no Default entry here.
 */
export interface ClaimFieldsFormsResponse {
  /** Forms */
  forms: ClaimFieldsFormsResponseClaimFieldsFormResponse[];
}

/** ClaimFieldsFormResponse */
export interface ClaimFieldsFormsResponseClaimFieldsFormResponse {
  /** Id */
  id: number;
  /** Is Default */
  is_default: boolean;
  /** Is Editable */
  is_editable: boolean;
  /** Lob */
  lob: string | null;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/** ClaimFinanceRecoveriesResponse */
export interface ClaimFinanceRecoveriesResponse {
  /** Includes Recovery Types */
  includes_recovery_types: boolean;
  /** Recoveries */
  recoveries: ClaimFinanceRecoveriesResponseClaimRecoveryAmountRow[];
}

/** ClaimRecoveryAmountRow */
export interface ClaimFinanceRecoveriesResponseClaimRecoveryAmountRow {
  /** Amount */
  amount: number;
  /**
   * Exposure Label
   * @default null
   */
  exposure_label?: string | null;
  /**
   * General Recovery Type
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * General Recovery Type Desc
   * @default null
   */
  general_recovery_type_desc?: string | null;
  /** Id */
  id: number;
  /**
   * Is Vat Included
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Issued By
   * @default null
   */
  issued_by?: string | null;
  /** Net Amount */
  net_amount: number;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Payable Type
   * @default null
   */
  payable_type?: string | null;
  /**
   * Policy Currency
   * @default null
   */
  policy_currency?: string | null;
  /**
   * Recovered From
   * @default null
   */
  recovered_from?: string | null;
  /**
   * Recovery Date
   * @default null
   */
  recovery_date?: string | null;
  /**
   * Recovery Group Id
   * @default null
   */
  recovery_group_id?: string | null;
  /** Recovery Type */
  recovery_type: string;
  /**
   * Reference
   * @default null
   */
  reference?: string | null;
  /**
   * Vat Amount
   * @default null
   */
  vat_amount?: number | null;
}

/** ClaimFlagConfigurationCreateJson */
export interface ClaimFlagConfigurationCreateJson {
  /** Color */
  color:
    | "berry-600"
    | "berry-700"
    | "blue-600"
    | "blueSky-700"
    | "grey-600"
    | "orange-700"
    | "pink-600"
    | "purple-600"
    | "purple-700"
    | "teal-600"
    | "yellow-800";
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default true
   */
  is_all_sub_orgs?: boolean;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Key
   * @maxLength 128
   */
  key: string;
  /**
   * Label
   * @maxLength 255
   */
  label: string;
  /**
   * Lobs
   * @default []
   */
  lobs?: string[];
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[];
}

/** ClaimFlagConfigurationModel */
export interface ClaimFlagConfigurationModel {
  /** Color */
  color:
    | "berry-600"
    | "berry-700"
    | "blue-600"
    | "blueSky-700"
    | "grey-600"
    | "orange-700"
    | "pink-600"
    | "purple-600"
    | "purple-700"
    | "teal-600"
    | "yellow-800";
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
  /** Lobs */
  lobs: string[];
  /** Position */
  position: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
}

/** ClaimFlagConfigurationUpdateJson */
export interface ClaimFlagConfigurationUpdateJson {
  /**
   * Color
   * @default null
   */
  color?:
    | "berry-600"
    | "berry-700"
    | "blue-600"
    | "blueSky-700"
    | "grey-600"
    | "orange-700"
    | "pink-600"
    | "purple-600"
    | "purple-700"
    | "teal-600"
    | "yellow-800"
    | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** ClaimFlagConfigurationsResponse */
export interface ClaimFlagConfigurationsResponse {
  /** Flag Configurations */
  flag_configurations: ClaimFlagConfigurationsResponseClaimFlagConfigurationModel[];
  /** Organization Id */
  organization_id: number;
}

/** ClaimFlagConfigurationModel */
export interface ClaimFlagConfigurationsResponseClaimFlagConfigurationModel {
  /** Color */
  color:
    | "berry-600"
    | "berry-700"
    | "blue-600"
    | "blueSky-700"
    | "grey-600"
    | "orange-700"
    | "pink-600"
    | "purple-600"
    | "purple-700"
    | "teal-600"
    | "yellow-800";
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
  /** Lobs */
  lobs: string[];
  /** Position */
  position: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
}

/** ClaimFlagOrderJson */
export interface ClaimFlagOrderJson {
  /** Flag Keys */
  flag_keys: string[];
}

/** ClaimFlagsBulkRequest */
export interface ClaimFlagsBulkRequest {
  /**
   * Claims
   * @maxItems 100
   * @minItems 1
   */
  claims: ClaimFlagsBulkRequestClaimFlagsBulkItem[];
}

/** ClaimFlagsBulkItem */
export interface ClaimFlagsBulkRequestClaimFlagsBulkItem {
  /** Claim Number */
  claim_number: string;
  /**
   * Flag Keys
   * @maxItems 50
   * @minItems 1
   */
  flag_keys: string[];
}

/** ClaimFlagsBulkResponse */
export interface ClaimFlagsBulkResponse {
  /** Results */
  results: ClaimFlagsBulkResponseClaimFlagsBulkResultItem[];
}

/** ClaimFlagsBulkResultItem */
export interface ClaimFlagsBulkResponseClaimFlagsBulkResultItem {
  /** Claim Number */
  claim_number: string;
  /** @default null */
  error_code?: ClaimFlagsBulkResponseBulkResultErrorCode | null;
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /** Success */
  success: boolean;
}

/** ClaimInspectionsQuery */
export interface ClaimInspectionsQuery {
  /** Claim Number */
  claim_number: string;
}

/**
 * ClaimInspectionsResourceSchema
 * ClaimInspectionsResourceSchema
 */
export interface ClaimInspectionsResourceSchema {
  /**
   * Claim Inspections
   * The claim's inspections, oldest first.
   */
  claim_inspections: ClaimInspectionsResourceSchemaClaimInspectionEntry[];
}

/**
 * ClaimInspectionEntry
 * One inspection on the claim.
 */
export interface ClaimInspectionsResourceSchemaClaimInspectionEntry {
  /** Assigned At */
  assigned_at: string | null;
  /** Null on a pre-catalogue row, the only kind that can carry no assignee. */
  assignee_kind: ClaimInspectionsResourceSchemaAssigneeKind | null;
  /** Completed At */
  completed_at: string | null;
  /** Due At */
  due_at: string | null;
  /**
   * Exposure Ids
   * Empty whenever the inspection names no exposure.
   */
  exposure_ids: number[];
  /** Inspection Id */
  inspection_id: number;
  /**
   * Inspection Method Id
   * The inspection_methods catalogue entry this was created from. Null on a pre-catalogue row — one written before the catalogue existed, which has no entry to point at.
   */
  inspection_method_id: number | null;
  /**
   * Method Name
   * What the method is called: the catalogue display name, or the organization's title for a pre-catalogue method key. Always populated, for both kinds.
   */
  method_name: string;
  /** How an inspection currently stands.  A published vocabulary, not the database status: ``pending`` and ``accepted`` both collapse to ``IN_PROGRESS``, and ``completed`` maps to ``AWAITING_REVIEW`` because it means the vendor finished, not the inspection finished. ``REJECTED`` conflates vendor-declined, adjuster-rejected and integration-cancelled. */
  outcome: ClaimInspectionsResourceSchemaInspectionOutcome;
  /**
   * Outcome Reason
   * Free text, no enum behind it. The claim page only ever sets it alongside a rejected outcome, but an imported inspection is not held to that.
   */
  outcome_reason: string | null;
  /** What the inspection was raised against. */
  scope: ClaimInspectionsResourceSchemaInspectionScope;
}

/** ClaimInvoiceCoverageBreakdownResponse */
export interface ClaimInvoiceCoverageBreakdownResponse {
  breakdown: ClaimInvoiceCoverageBreakdownResponseClaimInvoiceCoverageBreakdown;
  metadata: ClaimInvoiceCoverageBreakdownResponseClaimInvoiceCoverageBreakdownMetadata;
}

/** ClaimInvoiceCoverageBreakdown */
export interface ClaimInvoiceCoverageBreakdownResponseClaimInvoiceCoverageBreakdown {
  /** Coverages */
  coverages: ClaimInvoiceCoverageBreakdownResponseDetailedCoverageTotals[];
  /** Total Covered */
  total_covered: number;
  /** Total Excess */
  total_excess: number;
  /** Total Excluded Amount */
  total_excluded_amount: number;
  /** Total Not Covered And Excluded */
  total_not_covered_and_excluded: number;
  /** Total Remaining To Pay */
  total_remaining_to_pay: number;
  /** Total Submitted */
  total_submitted: number;
}

/** ClaimInvoiceCoverageBreakdownMetadata */
export interface ClaimInvoiceCoverageBreakdownResponseClaimInvoiceCoverageBreakdownMetadata {
  /** With Coinsurance */
  with_coinsurance: boolean;
}

/** DetailedCoverageTotals */
export interface ClaimInvoiceCoverageBreakdownResponseDetailedCoverageTotals {
  /** Accumulated Deductible */
  accumulated_deductible: number;
  /** Co Insurance */
  co_insurance: number;
  /** Coverage Id */
  coverage_id: number;
  /** Coverage Key */
  coverage_key: string;
  /** Coverage Name */
  coverage_name: string;
  /** Covered Amount */
  covered_amount: number;
  /** Deducted To Date */
  deducted_to_date: number;
  /** Deductible To Apply */
  deductible_to_apply: number;
  /** Eligible For Reimbursement */
  eligible_for_reimbursement: number;
  /** Excess */
  excess: number | null;
  /** Not Covered Amount */
  not_covered_amount: number;
  /** Paid To Date */
  paid_to_date: number;
  /** Remaining Deductible */
  remaining_deductible: number;
  /** Remaining Limit */
  remaining_limit: number | null;
  /** Remaining To Pay */
  remaining_to_pay: number;
  /** Submitted Amount */
  submitted_amount: number;
}

/**
 * ClaimLayersInformationResponseSchema
 * ClaimLayersInformationResponseSchema
 */
export interface ClaimLayersInformationResponseSchema {
  /** Layers Information */
  layers_information: ClaimLayersInformationResponseSchemaClaimLayerInformation[];
}

/**
 * ClaimLayerInformation
 * ClaimLayerInformation
 */
export interface ClaimLayersInformationResponseSchemaClaimLayerInformation {
  /** Aggregate Limit */
  aggregate_limit: number;
  /** Attachment Point */
  attachment_point: number;
  /** Exposure Id */
  exposure_id: string;
  /**
   * Is Advised
   * @default null
   */
  is_advised?: boolean | null;
  /** Layer Name */
  layer_name: string | null;
  /** Layer Number */
  layer_number: number;
  /** Limit Per Occurrence */
  limit_per_occurrence: number;
  /** Limit Per Term */
  limit_per_term: number;
  /** Paid To Date */
  paid_to_date: number;
  /** Reserve Amount */
  reserve_amount: number;
  /** Signed Line */
  signed_line: number;
}

/**
 * ClaimMilestoneConditionFieldsParams
 * Query params of the condition-field catalog: the scope the edit form holds, which is the scope the save
 * validates the conditions against. As in the delegated-authority catalog's params, each all-flag defaults to
 * true and takes precedence over its list, and an empty list narrows nothing: the form refetches on every scope
 * change, and refuses to save an empty selection.
 */
export interface ClaimMilestoneConditionFieldsParams {
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default true
   */
  is_all_sub_orgs?: boolean;
  "lobs[]"?: ClaimMilestoneConditionFieldsParamsEnsuredListStr;
  "sub_org_ids[]"?: ClaimMilestoneConditionFieldsParamsEnsuredListInt;
}

export type ClaimMilestoneConditionFieldsParamsEnsuredListInt = number[];

export type ClaimMilestoneConditionFieldsParamsEnsuredListStr = string[];

/** ClaimMilestoneDefinitionCreateJson */
export interface ClaimMilestoneDefinitionCreateJson {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default true
   */
  is_all_sub_orgs?: boolean;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Key
   * @maxLength 128
   */
  key: string;
  /**
   * Label
   * @maxLength 255
   */
  label: string;
  /**
   * Lobs
   * @default []
   */
  lobs?: string[];
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[];
}

/** ClaimMilestoneDefinitionModel */
export interface ClaimMilestoneDefinitionModel {
  /** Conditions Json */
  conditions_json: Record<string, any> | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description: string | null;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
  /** Lobs */
  lobs: string[];
  /** Position */
  position: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
}

/** ClaimMilestoneDefinitionOrderJson */
export interface ClaimMilestoneDefinitionOrderJson {
  /** Milestone Keys */
  milestone_keys: string[];
}

/** ClaimMilestoneDefinitionUpdateJson */
export interface ClaimMilestoneDefinitionUpdateJson {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** ClaimMilestoneDefinitionsResponse */
export interface ClaimMilestoneDefinitionsResponse {
  /** Milestone Definitions */
  milestone_definitions: ClaimMilestoneDefinitionsResponseClaimMilestoneDefinitionModel[];
  /** Organization Id */
  organization_id: number;
}

/** ClaimMilestoneDefinitionModel */
export interface ClaimMilestoneDefinitionsResponseClaimMilestoneDefinitionModel {
  /** Conditions Json */
  conditions_json: Record<string, any> | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description: string | null;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
  /** Lobs */
  lobs: string[];
  /** Position */
  position: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
}

/**
 * ClaimMilestoneModel
 * One of the claim's milestones and the date it was reached; every field after ``label`` is null
 * while the milestone is not recorded.
 */
export interface ClaimMilestoneModel {
  /** Key */
  key: string;
  /** Label */
  label: string;
  /**
   * Occurred On
   * @default null
   */
  occurred_on?: string | null;
  /**
   * Set By User Id
   * @default null
   */
  set_by_user_id?: string | null;
  /** @default null */
  source?: ClaimMilestoneModelClaimChangeSource | null;
  /**
   * Updated At
   * @default null
   */
  updated_at?: string | null;
}

/** ClaimMilestonesResponse */
export interface ClaimMilestonesResponse {
  /** Milestones */
  milestones: ClaimMilestonesResponseClaimMilestoneModel[];
}

/**
 * ClaimMilestoneModel
 * One of the claim's milestones and the date it was reached; every field after ``label`` is null
 * while the milestone is not recorded.
 */
export interface ClaimMilestonesResponseClaimMilestoneModel {
  /** Key */
  key: string;
  /** Label */
  label: string;
  /**
   * Occurred On
   * @default null
   */
  occurred_on?: string | null;
  /**
   * Set By User Id
   * @default null
   */
  set_by_user_id?: string | null;
  /** @default null */
  source?: ClaimMilestonesResponseClaimChangeSource | null;
  /**
   * Updated At
   * @default null
   */
  updated_at?: string | null;
}

/**
 * ClaimRealTimeTokenResponse
 * Real-time token for reading one of a claim's topics (conductor, document progress) from rtu_events.
 */
export interface ClaimRealTimeTokenResponse {
  /** @default null */
  issue_token_response?: ClaimRealTimeTokenResponseIssueTokenResponse | null;
}

/**
 * FirebaseWebAppConfigResponse
 * Firebase Web App configuration for frontend initialization.
 */
export interface ClaimRealTimeTokenResponseFirebaseWebAppConfigResponse {
  /**
   * Api Key
   * Firebase Web API key
   */
  api_key: string;
  /**
   * App Id
   * Firebase Web App ID
   */
  app_id: string;
  /**
   * Auth Domain
   * Firebase authentication domain
   */
  auth_domain: string;
  /**
   * Database Url
   * Realtime Database URL (if applicable)
   * @default null
   */
  database_url?: string | null;
  /**
   * Messaging Sender Id
   * Firebase Cloud Messaging sender ID
   */
  messaging_sender_id: string;
  /**
   * Project Id
   * Firebase project ID
   */
  project_id: string;
  /**
   * Storage Bucket
   * Firebase storage bucket
   */
  storage_bucket: string;
}

/**
 * FirestoreConnectionConfig
 * Firestore connection configuration for the client.
 */
export interface ClaimRealTimeTokenResponseFirestoreConnectionConfig {
  /** Collection Name */
  collection_name: string;
  /**
   * Database
   * @default "claims-llm"
   */
  database?: string | null;
  /**
   * Host
   * @default null
   */
  host?: string | null;
  /** Project Id */
  project_id: string;
}

/**
 * FirestoreQueryConfig
 * Query configuration for listening to real-time updates.
 */
export interface ClaimRealTimeTokenResponseFirestoreQueryConfig {
  /**
   * Order By
   * @default null
   */
  order_by?: Record<string, string>[] | null;
  /** Where Clauses */
  where_clauses: Record<string, any>[];
}

/**
 * IssueTokenResponse
 * IssueTokenResponse
 */
export interface ClaimRealTimeTokenResponseIssueTokenResponse {
  /** Expires At */
  expires_at: string;
  /** Firebase Custom Token */
  firebase_custom_token: string;
  /** Firebase Web App configuration for frontend initialization */
  firebase_web_app_config: ClaimRealTimeTokenResponseFirebaseWebAppConfigResponse;
  /** Firestore connection configuration for the client. */
  firestore_config: ClaimRealTimeTokenResponseFirestoreConnectionConfig;
  /** Query configuration for listening to real-time updates. */
  query_config: ClaimRealTimeTokenResponseFirestoreQueryConfig;
  /** Scopes */
  scopes: Record<string, any>[];
}

/**
 * ClaimRecoveryRequestConfig
 * What the adjuster's surfaces on one claim may offer, right now — one boolean per decision.
 *
 * Deliberately not the gates behind them: each caller has exactly one decision to make, and
 * handing it the parts would leave the recombination — and the next gate this module adds — to
 * every consumer. The parts stay separable where they matter: ``create_and_send`` raises a
 * distinct error per gate, so an operator reading a 403 still learns which switch is off.
 *
 * Two decisions rather than one because they are gated differently, not because the caller wants
 * a menu: creating is a rollout-gated capability, while settling by hand answers money that has
 * already arrived against a request sent when the rollout gate was open.
 *
 * Distinct from ``RecoveryRequestsConfigInfo``, which is the administrator's view of one stored
 * row and carries ``SYSTEM_CONFIGURATION`` permission. This one carries claim read, answers for
 * the claim's sub-organization, and names no configuration the adjuster cannot act on.
 */
export interface ClaimRecoveryRequestConfig {
  /** Can Settle Manually */
  can_settle_manually: boolean;
  /** Is Enabled */
  is_enabled: boolean;
}

/** ClaimSearchResponseList */
export type ClaimSearchResponseList =
  ClaimSearchResponseListClaimSearchResponse[];

/**
 * ClaimSearchResponse
 * ClaimSearchResponse
 */
export interface ClaimSearchResponseListClaimSearchResponse {
  /** Claim Internal Information */
  claim_internal_information: Record<string, any>;
  /** Claim Number */
  claim_number: string;
  /**
   * Claim Structured Data
   * @default null
   */
  claim_structured_data?: Record<string, any> | null;
}

/** ClaimStageBulkUpdateRequest */
export interface ClaimStageBulkUpdateRequest {
  /**
   * Updates
   * @maxItems 100
   * @minItems 1
   */
  updates: ClaimStageBulkUpdateRequestClaimStageBulkUpdateItem[];
}

/** ClaimStageBulkUpdateItem */
export interface ClaimStageBulkUpdateRequestClaimStageBulkUpdateItem {
  /** Claim Number */
  claim_number: string;
  /** Stage Key */
  stage_key: string;
}

/** ClaimStageBulkUpdateResponse */
export interface ClaimStageBulkUpdateResponse {
  /** Results */
  results: ClaimStageBulkUpdateResponseClaimStageBulkUpdateResult[];
}

/** ClaimStageBulkUpdateResult */
export interface ClaimStageBulkUpdateResponseClaimStageBulkUpdateResult {
  /** Claim Number */
  claim_number: string;
  /** @default null */
  error_code?: ClaimStageBulkUpdateResponseBulkResultErrorCode | null;
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /** Success */
  success: boolean;
}

/** ClaimStageConfigurationCreateJson */
export interface ClaimStageConfigurationCreateJson {
  /** Color */
  color:
    | "berry-600"
    | "berry-700"
    | "blue-600"
    | "blueSky-700"
    | "grey-600"
    | "orange-700"
    | "pink-600"
    | "purple-600"
    | "purple-700"
    | "teal-600"
    | "yellow-800";
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Is Initial
   * @default false
   */
  is_initial?: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/** ClaimStageConfigurationModel */
export interface ClaimStageConfigurationModel {
  /** Color */
  color:
    | "berry-600"
    | "berry-700"
    | "blue-600"
    | "blueSky-700"
    | "grey-600"
    | "orange-700"
    | "pink-600"
    | "purple-600"
    | "purple-700"
    | "teal-600"
    | "yellow-800";
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Initial */
  is_initial: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/**
 * ClaimStageConfigurationMoveJson
 * Move the stage at ``from_index`` to ``to_index``, both indexing the stored stage list. ``stage_key``
 * names the stage the client sees at ``from_index`` and ``to_stage_key`` the one it sees at ``to_index``; a
 * mismatch at either means the list changed since the client loaded it, and the move is refused rather than
 * applied to another stage or position.
 */
export interface ClaimStageConfigurationMoveJson {
  /**
   * From Index
   * @min 0
   */
  from_index: number;
  /** Stage Key */
  stage_key: string;
  /**
   * To Index
   * @min 0
   */
  to_index: number;
  /** To Stage Key */
  to_stage_key: string;
}

/** ClaimStageConfigurationUpdateJson */
export interface ClaimStageConfigurationUpdateJson {
  /**
   * Color
   * @default null
   */
  color?:
    | "berry-600"
    | "berry-700"
    | "blue-600"
    | "blueSky-700"
    | "grey-600"
    | "orange-700"
    | "pink-600"
    | "purple-600"
    | "purple-700"
    | "teal-600"
    | "yellow-800"
    | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Is Initial
   * @default null
   */
  is_initial?: boolean | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
}

/** ClaimStageConfigurationsResponse */
export interface ClaimStageConfigurationsResponse {
  /** Organization Id */
  organization_id: number;
  /** Stage Configurations */
  stage_configurations: ClaimStageConfigurationsResponseClaimStageConfigurationModel[];
}

/** ClaimStageConfigurationModel */
export interface ClaimStageConfigurationsResponseClaimStageConfigurationModel {
  /** Color */
  color:
    | "berry-600"
    | "berry-700"
    | "blue-600"
    | "blueSky-700"
    | "grey-600"
    | "orange-700"
    | "pink-600"
    | "purple-600"
    | "purple-700"
    | "teal-600"
    | "yellow-800";
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Initial */
  is_initial: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/** ClaimStagesQuery */
export interface ClaimStagesQuery {
  /** Claim Number */
  claim_number: string;
}

/**
 * ClaimStagesResponseSchema
 * The claim's position in its stage log, and the log's own reach.
 */
export interface ClaimStagesResponseSchema {
  /**
   * Current Stage Key
   * Stage key the claim is in now, as the organization's ClaimStage declares it. Null when the claim has no stage recorded.
   */
  current_stage_key: string | null;
  /**
   * Current Stage Since
   * When the claim entered its current stage, from the latest stage history row. Null when the log has none.
   */
  current_stage_since: string | null;
  /**
   * History Reaches Creation
   * Whether the log reaches back to the claim's creation (its oldest row entered from no previous stage). False makes every visit count a lower bound rather than a count.
   */
  history_reaches_creation: boolean;
  /**
   * Visits
   * How many times the claim has been in each stage, keyed by stage key, aggregated over the whole log. A stage absent from the map was never visited.
   */
  visits: Record<string, number>;
}

/** ClaimTokenValuesQuery */
export interface ClaimTokenValuesQuery {
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * Moi Id
   * @default null
   */
  moi_id?: number | null;
}

/** ClaimTokenValuesResponse */
export interface ClaimTokenValuesResponse {
  /** Tokens */
  tokens: ClaimTokenValuesResponseInspectedTokenResponse[];
}

/** InspectedTokenResponse */
export interface ClaimTokenValuesResponseInspectedTokenResponse {
  /**
   * Blank Detail
   * @default null
   */
  blank_detail?: string | null;
  /** @default null */
  blank_reason?: ClaimTokenValuesResponseTokenBlankReason | null;
  /** Category */
  category: string;
  /** Display Name */
  display_name: string;
  /** Is Blank */
  is_blank: boolean;
  /**
   * Token Group
   * @default null
   */
  token_group?: string[] | null;
  /** Token Key */
  token_key: string;
  /**
   * Value
   * @default null
   */
  value?: string | null;
}

/** ClaimsDisplayRet */
export interface ClaimsDisplayRet {
  /** Claims */
  claims: ClaimsDisplayRetClaimDisplayEntry[];
  /** Count */
  count: number;
}

/** ClaimDisplayEntry */
export interface ClaimsDisplayRetClaimDisplayEntry {
  /**
   * Cause Code
   * @default null
   */
  cause_code?: string | null;
  /**
   * Cause Codes Dict
   * @default null
   */
  cause_codes_dict?: Record<string, any> | null;
  /**
   * Claim Flag Keys
   * @default []
   */
  claim_flag_keys?: string[];
  /** Claim Id Display */
  claim_id_display: string;
  /**
   * Claimant Contact Full Name
   * @default null
   */
  claimant_contact_full_name?: string | null;
  /**
   * Claimant Contact Id
   * @default null
   */
  claimant_contact_id?: number | null;
  /** Client */
  client: string;
  /**
   * Creation Date
   * @format date-time
   */
  creation_date: string;
  /**
   * Date Closed
   * @default null
   */
  date_closed?: string | null;
  /**
   * Date Of Loss
   * @format date
   */
  date_of_loss: string;
  /**
   * First Party Involved Entities Display Names
   * @default null
   */
  first_party_involved_entities_display_names?: string[] | null;
  /**
   * Handling Adjuster
   * @default null
   */
  handling_adjuster?: string | null;
  /** Id */
  id: number;
  /**
   * Incident Sub Type
   * @default null
   */
  incident_sub_type?: string | null;
  /**
   * Incident Sub Type Desc
   * @default null
   */
  incident_sub_type_desc?: string | null;
  /**
   * Incident Type
   * @default null
   */
  incident_type?: string | null;
  /**
   * Incident Type Desc
   * @default null
   */
  incident_type_desc?: string | null;
  /**
   * Insured Contact Full Name
   * @default null
   */
  insured_contact_full_name?: string | null;
  /**
   * Insured Contact Id
   * @default null
   */
  insured_contact_id?: number | null;
  /**
   * Insured Property Id
   * @default null
   */
  insured_property_id?: number | null;
  /**
   * Insured Property Sublocation Id
   * @default null
   */
  insured_property_sublocation_id?: number | null;
  /**
   * Is Closed
   * @default false
   */
  is_closed?: boolean | null;
  /**
   * Last Touched
   * @default null
   */
  last_touched?: string | null;
  /** Lob */
  lob: string;
  /** Organization Name */
  organization_name: string;
  /**
   * Policy Country
   * @default null
   */
  policy_country?: string | null;
  /**
   * Policy Id
   * @default null
   */
  policy_id?: number | null;
  /**
   * Policy Number
   * @default null
   */
  policy_number?: string | null;
  /**
   * Reported Date
   * @default null
   */
  reported_date?: string | null;
  /**
   * Reporter Contact Full Name
   * @default null
   */
  reporter_contact_full_name?: string | null;
  /**
   * Reporter Contact Id
   * @default null
   */
  reporter_contact_id?: number | null;
  /**
   * Source Code
   * @default null
   */
  source_code?: string | null;
  /**
   * Source Codes Dict
   * @default null
   */
  source_codes_dict?: Record<string, any> | null;
  /**
   * Stage Key
   * @default null
   */
  stage_key?: string | null;
  /**
   * Subtype
   * @default null
   */
  subtype?: string | null;
  /**
   * Time Of Loss
   * @default null
   */
  time_of_loss?: string | null;
  /** Type */
  type: string;
}

/**
 * ClaimsFilterRequest
 * Request model for filtering claims with cursor-based pagination.
 *
 * Extends the base CursorPaginationRequest with claims-specific filters
 * as specified in the solution document.
 */
export interface ClaimsFilterRequest {
  /**
   * Claim Status
   * Filter by claim status
   * @default null
   */
  claim_status?: "open" | "closed" | "reopened" | null;
  /**
   * Created Datetime End
   * Filter claims created on or before this datetime (ISO format)
   * @default null
   */
  created_datetime_end?: string | null;
  /**
   * Created Datetime Start
   * Filter claims created on or after this datetime (ISO format)
   * @default null
   */
  created_datetime_start?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Date Of Loss End
   * Filter claims with date of loss on or before this date (YYYY-MM-DD)
   * @default null
   */
  date_of_loss_end?: string | null;
  /**
   * Date Of Loss Start
   * Filter claims with date of loss on or after this date (YYYY-MM-DD)
   * @default null
   */
  date_of_loss_start?: string | null;
  /**
   * External Claim Number
   * Filter by exact external claim number
   * @default null
   */
  external_claim_number?: string | null;
  /**
   * Involved Party Name
   * Filter by involved party name (case insensitive partial match)
   * @default null
   */
  involved_party_name?: string | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Named Insured
   * Filter by named insured name (case insensitive partial match)
   * @default null
   */
  named_insured?: string | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Partial Data
   * Return partial claim data
   * @default false
   */
  partial_data?: boolean | null;
  /**
   * Policy Number
   * Filter by exact policy number
   * @default null
   */
  policy_number?: string | null;
  /**
   * Report Date End
   * Filter claims reported on or before this date (YYYY-MM-DD)
   * @default null
   */
  report_date_end?: string | null;
  /**
   * Report Date Start
   * Filter claims reported on or after this date (YYYY-MM-DD)
   * @default null
   */
  report_date_start?: string | null;
  /**
   * Sub Organizations External Id
   * Filter by sub-organization external IDs
   * @default null
   */
  sub_organizations_external_id?: string[] | null;
}

/** ClaimsNotificationsBaseParams */
export interface ClaimsNotificationsBaseParams {
  /**
   * Adjusters Ids
   * @default null
   */
  adjusters_ids?: string[] | null;
  /**
   * Categories Ids
   * @default null
   */
  categories_ids?: (number | "0")[] | null;
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
  /**
   * End Due Date
   * @default null
   */
  end_due_date?: string | null;
  /**
   * End Due Datetime
   * @default null
   */
  end_due_datetime?: string | null;
  /**
   * Include Dismissed
   * @default null
   */
  include_dismissed?: string | null;
  /**
   * Include Removed Users
   * @default null
   */
  include_removed_users?: boolean | null;
  /**
   * Notification Ids
   * @default null
   */
  notification_ids?: number[] | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Priorities
   * @default null
   */
  priorities?: string[] | null;
  /**
   * Show Future Reminders
   * @default null
   */
  show_future_reminders?: boolean | null;
  /**
   * Sort By Column
   * @default null
   */
  sort_by_column?: string | null;
  /**
   * Start Due Date
   * @default null
   */
  start_due_date?: string | null;
  /**
   * Start Due Datetime
   * @default null
   */
  start_due_datetime?: string | null;
  /**
   * Statuses
   * @default null
   */
  statuses?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Type Subtype Filters
   * @default null
   */
  type_subtype_filters?: string[] | null;
  /**
   * With Read Status
   * @default null
   */
  with_read_status?: boolean | null;
}

/** ClaimsNotificationsByIdsParams */
export interface ClaimsNotificationsByIdsParams {
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
  /** Notification Ids */
  notification_ids: number[];
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
}

/** ClaimsNotificationsParams */
export interface ClaimsNotificationsParams {
  /**
   * Adjusters Ids
   * @default null
   */
  adjusters_ids?: string[] | null;
  /**
   * Categories Ids
   * @default null
   */
  categories_ids?: (number | "0")[] | null;
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
  /**
   * End Due Date
   * @default null
   */
  end_due_date?: string | null;
  /**
   * End Due Datetime
   * @default null
   */
  end_due_datetime?: string | null;
  /**
   * Include Dismissed
   * @default null
   */
  include_dismissed?: string | null;
  /**
   * Include Removed Users
   * @default null
   */
  include_removed_users?: boolean | null;
  /**
   * Notification Ids
   * @default null
   */
  notification_ids?: number[] | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Page Number
   * @default null
   */
  page_number?: number | null;
  /**
   * Priorities
   * @default null
   */
  priorities?: string[] | null;
  /**
   * Results Per Page
   * @default null
   */
  results_per_page?: number | null;
  /**
   * Show Future Reminders
   * @default null
   */
  show_future_reminders?: boolean | null;
  /**
   * Sort By Column
   * @default null
   */
  sort_by_column?: string | null;
  /**
   * Start Due Date
   * @default null
   */
  start_due_date?: string | null;
  /**
   * Start Due Datetime
   * @default null
   */
  start_due_datetime?: string | null;
  /**
   * Statuses
   * @default null
   */
  statuses?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Type Subtype Filters
   * @default null
   */
  type_subtype_filters?: string[] | null;
  /**
   * With Read Status
   * @default null
   */
  with_read_status?: boolean | null;
}

/** ClaimsNotificationsQueryParams */
export interface ClaimsNotificationsQueryParams {
  /**
   * Adjuster Email
   * Email of the adjuster to filter by. Accepts either the user login email or the claims email address
   * @default null
   */
  adjuster_email?: string | null;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * End Created Date
   * Filter by creation date - end of range
   * @default null
   */
  end_created_date?: string | null;
  /**
   * End Due Date
   * Filter by due date - end of range
   * @default null
   */
  end_due_date?: string | null;
  /**
   * Include Dismissed
   * 'only_dismissed' - only dismissed, 'not_dismissed' - only not dismissed, 'both' - all
   * @default "not_dismissed"
   */
  include_dismissed?: "only_dismissed" | "not_dismissed" | "both" | null;
  /**
   * Page Number
   * Page number for pagination
   * @default 1
   */
  page_number?: number | null;
  /**
   * Per Page
   * Number of results per page
   * @default 10
   */
  per_page?: number | null;
  /**
   * Priorities
   * List for filter by priority - high, medium, low
   * @default null
   */
  priorities?: ("high" | "medium" | "low")[] | null;
  /**
   * Sort By Column
   * field to sort results by
   * @default null
   */
  sort_by_column?:
    | "type"
    | "effective_user"
    | "due_date"
    | "due_datetime"
    | "creation_datetime"
    | "claim_number"
    | "title"
    | "priority"
    | "dismissing_user"
    | "dismissed_datetime"
    | null;
  /**
   * Sort By Order
   * order to sort results by - asc or desc
   * @default "asc"
   */
  sort_by_order?: "asc" | "desc" | null;
  /**
   * Start Created Date
   * Filter by creation date - start of range
   * @default null
   */
  start_created_date?: string | null;
  /**
   * Start Due Date
   * Filter by due date - start of range
   * @default null
   */
  start_due_date?: string | null;
}

/**
 * ClientSpecificFlowTriggerAck
 * Acknowledgement that the run was accepted.
 *
 * Only the correlation id the AI service echoed is returned: the AI-service-internal ``task_id``
 * and real-time-update handles are not part of this endpoint's contract. ``None`` means the run was
 * accepted but the acknowledgement carried no readable echo.
 */
export interface ClientSpecificFlowTriggerAck {
  /**
   * Task External Id
   * The correlation id the AI service acknowledged
   * @default null
   */
  task_external_id?: string | null;
}

/**
 * ClientSpecificFlowTriggerRequest
 * Body of the client-specific-flow trigger: what to run, where to report, and who to run as.
 *
 * ``documents`` is forwarded verbatim — the AI service owns the nested store-operation contract
 * (including the "at least one" rule), and rejects a bad shape with a 422 that this endpoint
 * passes back. Re-declaring that schema in CMS would mean two contracts to keep in step.
 */
export interface ClientSpecificFlowTriggerRequest {
  /**
   * Client Context
   * Free-form context passed through to the flow
   * @default null
   */
  client_context?: Record<string, any> | null;
  /**
   * Documents
   * Store operation payloads for the run (files by URL and/or inline text, never raw bytes)
   * @maxItems 50
   */
  documents: Record<string, any>[];
  /**
   * Sub Organization External Id
   * External id of the sub-organization to run as; must be one the calling organization owns. Omit to run as the organization itself.
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Task External Id
   * The caller's correlation id for this run; optional, and an id already used is rejected with 409
   * @default null
   */
  task_external_id?: string | null;
  /**
   * Webhook Url
   * Where the AI service delivers the result; CMS forwards this URL and takes no part in the delivery
   * @minLength 1
   */
  webhook_url: string;
}

/** CloseClaimJsonParams */
export interface CloseClaimJsonParams {
  /** Close Reason Key */
  close_reason_key: string;
  /**
   * Dismiss All Notifications
   * @default null
   */
  dismiss_all_notifications?: boolean | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/**
 * CloseExposureJsonParams
 * Closes the exposure. Both of its reserves go to zero with it.
 */
export interface CloseExposureJsonParams {
  /**
   * Close Reason Key
   * Why the exposure closed, as the organization's closing reasons name it.
   */
  close_reason_key: string;
  /**
   * Dismiss All Notifications
   * Whether the close dismissed the exposure's open notifications.
   * @default null
   */
  dismiss_all_notifications?: boolean | null;
  /**
   * Note
   * Free text about the close.
   * @default null
   */
  note?: string | null;
}

/** CloseExposureParams */
export interface CloseExposureParams {
  /**
   * Extra
   * @default null
   */
  extra?: string | null;
  /** Reason */
  reason: string;
  /**
   * Should Dismiss All Exposure Notifications
   * @default false
   */
  should_dismiss_all_exposure_notifications?: boolean | null;
}

/** CloseLegalActionPayload */
export interface CloseLegalActionPayload {
  /** Final Settlement Amount */
  final_settlement_amount: number;
  /** Method Of Conclusion */
  method_of_conclusion: string;
  /** Method Of Conclusion Text */
  method_of_conclusion_text: string;
}

/** ClosingReasonCreateJson */
export interface ClosingReasonCreateJson {
  /** Category */
  category: string;
  /**
   * Closing Reason Key
   * @minLength 1
   * @maxLength 50
   */
  closing_reason_key: string;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 50
   */
  display_name: string;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is Note Enabled
   * @default null
   */
  is_note_enabled?: boolean | null;
  /**
   * Is Note Required
   * @default null
   */
  is_note_required?: boolean | null;
  /**
   * Is Org Level
   * @default null
   */
  is_org_level?: boolean | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /** Sub Category */
  sub_category: string;
  /**
   * Sub Org Ids
   * @default []
   */
  sub_org_ids?: number[];
  /** Type */
  type: "exposure" | "claim";
}

/** ClosingReasonReplaceJson */
export interface ClosingReasonReplaceJson {
  /** Category */
  category: string;
  /**
   * Closing Reason Key
   * @minLength 1
   * @maxLength 50
   */
  closing_reason_key: string;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 50
   */
  display_name: string;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is Note Enabled
   * @default null
   */
  is_note_enabled?: boolean | null;
  /**
   * Is Note Required
   * @default null
   */
  is_note_required?: boolean | null;
  /**
   * Is Org Level
   * @default null
   */
  is_org_level?: boolean | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /** Sub Category */
  sub_category: string;
  /**
   * Sub Org Ids
   * @default []
   */
  sub_org_ids?: number[];
  /** Type */
  type: "exposure" | "claim";
}

/** ClosingReasonUpdateJson */
export interface ClosingReasonUpdateJson {
  /** Is Enabled */
  is_enabled: boolean;
  /** Type */
  type: "exposure" | "claim";
}

/** CommunicationCategoryResponseList */
export type CommunicationCategoryResponseList =
  CommunicationCategoryResponseListCommunicationCategoryResponse[];

/** CommunicationCategoryResponse */
export interface CommunicationCategoryResponseListCommunicationCategoryResponse {
  /** Color */
  color: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/** CommunicationConfigurationInfo */
export interface CommunicationConfigurationInfo {
  /** Adjuster Page Handled Filter Defaults To Pending */
  adjuster_page_handled_filter_defaults_to_pending: boolean;
  /** Claim Tab Handled Filter Defaults To Pending */
  claim_tab_handled_filter_defaults_to_pending: boolean;
  /** Is Category Required */
  is_category_required: boolean;
  /** Is Communication Permission Required For All Contacts */
  is_communication_permission_required_for_all_contacts: boolean;
  /** Is Handled Status Enabled */
  is_handled_status_enabled: boolean;
}

/**
 * CommunicationResponse
 * Full clean external API response model for communications.
 */
export interface CommunicationResponse {
  /** Api Uuid */
  api_uuid: string;
  /**
   * Categories
   * The communication's categories (tags). Empty when none are applied. A category is identified by its `key`, which is stable across environments.
   */
  categories?: CommunicationResponseCommunicationCategoryModel[];
  /** Channel */
  channel: string;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Contacts
   * Array of contact details with ref_id mappings
   */
  contacts?: CommunicationResponseContactModel[];
  /**
   * Datetime
   * @format date-time
   */
  datetime: string;
  /** Direction */
  direction: string;
  /** @default null */
  email_specific?: CommunicationResponseEmailSpecificModel | null;
  /**
   * Exposure Ids
   * @default null
   */
  exposure_ids?: number[] | null;
  /**
   * Exposure Numbers
   * Exposure numbers in the format accepted by the add-document external API (e.g. 'ABC-12345-01'). '0' denotes a general communication not bound to an exposure. Ordered consistently with exposure_ids.
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Is Automatic
   * @default null
   */
  is_automatic?: boolean | null;
  /**
   * Is Handled
   * Whether an incoming communication has been actioned: `false` while it is still awaiting action, `true` once it has been handled. Always `null` on outgoing communications, which carry no handled status. Some incoming communications are already `true` when they arrive — an answered phone call, for example — so `true` does not necessarily mean someone acted on it.
   * @default null
   */
  is_handled?: boolean | null;
  /** @default null */
  phone_call_specific?: CommunicationResponsePhoneCallSpecificModel | null;
  /** @default null */
  physical_mail_specific?: CommunicationResponsePhysicalMailSpecificModel | null;
  /** @default null */
  sms_specific?: CommunicationResponseSmsSpecificModel | null;
  /**
   * Source
   * @default null
   */
  source?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /** @default null */
  user?: CommunicationResponseUserExternalAPIBaseModel | null;
  /** @default null */
  video_call_specific?: CommunicationResponseVideoCallSpecificModel | null;
}

/**
 * CommunicationAttachmentResponse
 * Communication attachment response model.
 */
export interface CommunicationResponseCommunicationAttachmentResponse {
  /**
   * File Name
   * @default null
   */
  file_name?: string | null;
  /**
   * Url
   * @default null
   */
  url?: string | null;
}

/**
 * CommunicationCategoryModel
 * A communication category (tag) as the external API exposes it.
 *
 * Deliberately a local model rather than the categories module's ``CategoryInfo``: that schema is
 * the service *interface* boundary, so a field added to it for an internal consumer would join
 * this public response — and every ``incoming_email_received`` webhook — with no change in this
 * module and nothing in CI to catch it.
 *
 * The field set is the minimum defensible one, because a public API field is a one-way door:
 * adding one later is cheap, removing one is breaking. Deliberately **not** exposed:
 *
 * - ``id`` — environment-local. The config repository identifies a category by ``key`` and exports
 *   it without an id, so the same category has a different id in every environment. Publishing it
 *   would invite integrations to key on it and break the moment they cross environments, which is
 *   worse than not shipping it at all.
 * - ``type`` — constant ``communication_category`` on this surface, so it carries no information.
 * - ``description`` — internal configuration copy; the internal ``category_model`` does not
 *   expose it either.
 *
 * Optionality mirrors the source columns, which are all nullable
 * (``server/modules/categories/internal/models/category.py``): one NULL ``color`` would otherwise
 * 500 a whole page rather than degrade a single record.
 */
export interface CommunicationResponseCommunicationCategoryModel {
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /**
   * Key
   * @default null
   */
  key?: string | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
}

/** ContactEmailModel */
export interface CommunicationResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface CommunicationResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CommunicationResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CommunicationResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CommunicationResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * EmailSpecificModel
 * Email-specific fields.
 */
export interface CommunicationResponseEmailSpecificModel {
  /**
   * Attachments
   * @default null
   */
  attachments?: CommunicationResponseCommunicationAttachmentResponse[] | null;
  /**
   * Body
   * @default null
   */
  body?: string | null;
  /**
   * Delivery Status
   * @default null
   */
  delivery_status?: string | null;
  /**
   * Recipient Type
   * @default null
   */
  recipient_type?: string | null;
  /**
   * Subject
   * @default null
   */
  subject?: string | null;
}

/** LocationModel */
export interface CommunicationResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/**
 * PhoneCallSpecificModel
 * Phone call-specific fields.
 */
export interface CommunicationResponsePhoneCallSpecificModel {
  /**
   * Call Duration Seconds
   * @default null
   */
  call_duration_seconds?: number | null;
  /**
   * Forwarded Phone Number
   * @default null
   */
  forwarded_phone_number?: string | null;
  /**
   * Is No Answer
   * @default null
   */
  is_no_answer?: boolean | null;
  /**
   * Is Phone Call Recorded
   * @default null
   */
  is_phone_call_recorded?: boolean | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Recording Url
   * @default null
   */
  recording_url?: string | null;
  /**
   * Voicemail Url
   * @default null
   */
  voicemail_url?: string | null;
}

/**
 * PhysicalMailSpecificModel
 * Physical mail-specific fields.
 */
export interface CommunicationResponsePhysicalMailSpecificModel {
  /** @default null */
  address?: CommunicationResponseLocationModel | null;
  /**
   * Attachments
   * @default null
   */
  attachments?: CommunicationResponseCommunicationAttachmentResponse[] | null;
  /**
   * Physical Mail Type
   * @default null
   */
  physical_mail_type?: string | null;
  /**
   * Recipient Name
   * @default null
   */
  recipient_name?: string | null;
}

/**
 * SmsSpecificModel
 * SMS-specific fields.
 */
export interface CommunicationResponseSmsSpecificModel {
  /**
   * Message
   * @default null
   */
  message?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
}

/** UserExternalAPIBaseModel */
export interface CommunicationResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * VideoCallSpecificModel
 * Video call-specific fields.
 */
export interface CommunicationResponseVideoCallSpecificModel {
  /**
   * Joined Participants
   * @default null
   */
  joined_participants?: string[] | null;
  /**
   * Meeting End Datetime
   * @default null
   */
  meeting_end_datetime?: string | null;
  /**
   * Meeting Start Datetime
   * @default null
   */
  meeting_start_datetime?: string | null;
  /**
   * Provider
   * @default null
   */
  provider?: string | null;
  /**
   * Recording Status
   * @default null
   */
  recording_status?: string | null;
  /**
   * Recording Url
   * @default null
   */
  recording_url?: string | null;
  /**
   * Transcript
   * @default null
   */
  transcript?: string | null;
}

/**
 * CommunicationRuleCreateRequest
 * Request body for creating a communication rule.
 */
export interface CommunicationRuleCreateRequest {
  /**
   * Category Id
   * @default null
   */
  category_id?: null;
  /** Cc Recipients */
  cc_recipients?: string[];
  /** Channel */
  channel: string;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Context */
  context: string;
  /** Display Name */
  display_name: string;
  /** Event Key */
  event_key: string;
  /** Generic Template Id */
  generic_template_id: any;
  /**
   * Id
   * @default null
   */
  id?: null;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /**
   * Is Suggestion
   * @default false
   */
  is_suggestion?: boolean;
  /** Lobs */
  lobs: string[];
  /** Recipient */
  recipient: string;
  /** Sender Type */
  sender_type: string;
  /** Sub Organization Ids */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
}

/**
 * CommunicationRuleDTO
 * Response DTO for a communication rule.
 */
export interface CommunicationRuleDTO {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /** Cc Recipients */
  cc_recipients?: string[];
  /** Channel */
  channel: string;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Context */
  context: string;
  /** Display Name */
  display_name: string;
  /** Event Key */
  event_key: string;
  /**
   * Generic Template Id
   * @default null
   */
  generic_template_id?: number | null;
  /** Id */
  id: number | string;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Suggestion */
  is_suggestion: boolean;
  /** Lobs */
  lobs: string[];
  /** Priority */
  priority: number;
  /** Recipient */
  recipient: string;
  /** Sender Type */
  sender_type: string;
  /** Strategy */
  strategy: string;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
}

/** CommunicationRuleDTOList */
export type CommunicationRuleDTOList =
  CommunicationRuleDTOListCommunicationRuleDTO[];

/**
 * CommunicationRuleDTO
 * Response DTO for a communication rule.
 */
export interface CommunicationRuleDTOListCommunicationRuleDTO {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /** Cc Recipients */
  cc_recipients?: string[];
  /** Channel */
  channel: string;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Context */
  context: string;
  /** Display Name */
  display_name: string;
  /** Event Key */
  event_key: string;
  /**
   * Generic Template Id
   * @default null
   */
  generic_template_id?: number | null;
  /** Id */
  id: number | string;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Suggestion */
  is_suggestion: boolean;
  /** Lobs */
  lobs: string[];
  /** Priority */
  priority: number;
  /** Recipient */
  recipient: string;
  /** Sender Type */
  sender_type: string;
  /** Strategy */
  strategy: string;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
}

/**
 * CommunicationRuleUpdateRequest
 * Request body for updating a communication rule.
 */
export interface CommunicationRuleUpdateRequest {
  /**
   * Category Id
   * @default null
   */
  category_id?: null;
  /** Cc Recipients */
  cc_recipients?: string[];
  /** Channel */
  channel: string;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Context */
  context: string;
  /** Display Name */
  display_name: string;
  /** Event Key */
  event_key: string;
  /** Generic Template Id */
  generic_template_id: any;
  /**
   * Id
   * @default null
   */
  id?: null;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /**
   * Is Suggestion
   * @default false
   */
  is_suggestion?: boolean;
  /** Lobs */
  lobs: string[];
  /** Recipient */
  recipient: string;
  /** Sender Type */
  sender_type: string;
  /** Sub Organization Ids */
  sub_organization_ids?: number[] | null;
}

/**
 * CommunicationsFilterRequest
 * Request model for filtering communications with cursor-based pagination.
 *
 * Extends the base CursorPaginationRequest with communications-specific filters
 * as specified in the solution document.
 */
export interface CommunicationsFilterRequest {
  /**
   * Claim Number
   * Filter by exact claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Communication Type
   * Filter by communication channel type
   * @default null
   */
  communication_type?:
    | "email"
    | "sms"
    | "phone_call"
    | "video_call"
    | "physical_mail"
    | "vendor"
    | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Direction
   * Filter by communication direction
   * @default null
   */
  direction?: "Incoming" | "Outgoing" | null;
  /**
   * End Datetime
   * Filter communications until this datetime (ISO format)
   * @default null
   */
  end_datetime?: string | null;
  /**
   * Is Phone Call Recorded
   * Filter phone calls which were recorded (only applies to phone_call type)
   * @default null
   */
  is_phone_call_recorded?: boolean | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Start Datetime
   * Filter communications from this datetime (ISO format)
   * @default null
   */
  start_datetime?: string | null;
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Was Voicemail Left
   * Filter phone calls where voicemail was left (only applies to phone_call type)
   * @default null
   */
  was_voicemail_left?: boolean | null;
}

/**
 * CommunicationsResponse
 * Response model for paginated communications data.
 */
export interface CommunicationsResponse {
  /** Pagination metadata */
  metadata: CommunicationsResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * List of communications matching the filter criteria
   */
  records: CommunicationsResponseCommunicationResponse[];
}

/**
 * CommunicationAttachmentResponse
 * Communication attachment response model.
 */
export interface CommunicationsResponseCommunicationAttachmentResponse {
  /**
   * File Name
   * @default null
   */
  file_name?: string | null;
  /**
   * Url
   * @default null
   */
  url?: string | null;
}

/**
 * CommunicationCategoryModel
 * A communication category (tag) as the external API exposes it.
 *
 * Deliberately a local model rather than the categories module's ``CategoryInfo``: that schema is
 * the service *interface* boundary, so a field added to it for an internal consumer would join
 * this public response — and every ``incoming_email_received`` webhook — with no change in this
 * module and nothing in CI to catch it.
 *
 * The field set is the minimum defensible one, because a public API field is a one-way door:
 * adding one later is cheap, removing one is breaking. Deliberately **not** exposed:
 *
 * - ``id`` — environment-local. The config repository identifies a category by ``key`` and exports
 *   it without an id, so the same category has a different id in every environment. Publishing it
 *   would invite integrations to key on it and break the moment they cross environments, which is
 *   worse than not shipping it at all.
 * - ``type`` — constant ``communication_category`` on this surface, so it carries no information.
 * - ``description`` — internal configuration copy; the internal ``category_model`` does not
 *   expose it either.
 *
 * Optionality mirrors the source columns, which are all nullable
 * (``server/modules/categories/internal/models/category.py``): one NULL ``color`` would otherwise
 * 500 a whole page rather than degrade a single record.
 */
export interface CommunicationsResponseCommunicationCategoryModel {
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /**
   * Key
   * @default null
   */
  key?: string | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
}

/**
 * CommunicationResponse
 * Full clean external API response model for communications.
 */
export interface CommunicationsResponseCommunicationResponse {
  /** Api Uuid */
  api_uuid: string;
  /**
   * Categories
   * The communication's categories (tags). Empty when none are applied. A category is identified by its `key`, which is stable across environments.
   */
  categories?: CommunicationsResponseCommunicationCategoryModel[];
  /** Channel */
  channel: string;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Contacts
   * Array of contact details with ref_id mappings
   */
  contacts?: CommunicationsResponseContactModel[];
  /**
   * Datetime
   * @format date-time
   */
  datetime: string;
  /** Direction */
  direction: string;
  /** @default null */
  email_specific?: CommunicationsResponseEmailSpecificModel | null;
  /**
   * Exposure Ids
   * @default null
   */
  exposure_ids?: number[] | null;
  /**
   * Exposure Numbers
   * Exposure numbers in the format accepted by the add-document external API (e.g. 'ABC-12345-01'). '0' denotes a general communication not bound to an exposure. Ordered consistently with exposure_ids.
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Is Automatic
   * @default null
   */
  is_automatic?: boolean | null;
  /**
   * Is Handled
   * Whether an incoming communication has been actioned: `false` while it is still awaiting action, `true` once it has been handled. Always `null` on outgoing communications, which carry no handled status. Some incoming communications are already `true` when they arrive — an answered phone call, for example — so `true` does not necessarily mean someone acted on it.
   * @default null
   */
  is_handled?: boolean | null;
  /** @default null */
  phone_call_specific?: CommunicationsResponsePhoneCallSpecificModel | null;
  /** @default null */
  physical_mail_specific?: CommunicationsResponsePhysicalMailSpecificModel | null;
  /** @default null */
  sms_specific?: CommunicationsResponseSmsSpecificModel | null;
  /**
   * Source
   * @default null
   */
  source?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /** @default null */
  user?: CommunicationsResponseUserExternalAPIBaseModel | null;
  /** @default null */
  video_call_specific?: CommunicationsResponseVideoCallSpecificModel | null;
}

/** ContactEmailModel */
export interface CommunicationsResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface CommunicationsResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CommunicationsResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CommunicationsResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CommunicationsResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * EmailSpecificModel
 * Email-specific fields.
 */
export interface CommunicationsResponseEmailSpecificModel {
  /**
   * Attachments
   * @default null
   */
  attachments?: CommunicationsResponseCommunicationAttachmentResponse[] | null;
  /**
   * Body
   * @default null
   */
  body?: string | null;
  /**
   * Delivery Status
   * @default null
   */
  delivery_status?: string | null;
  /**
   * Recipient Type
   * @default null
   */
  recipient_type?: string | null;
  /**
   * Subject
   * @default null
   */
  subject?: string | null;
}

/** LocationModel */
export interface CommunicationsResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface CommunicationsResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/**
 * PhoneCallSpecificModel
 * Phone call-specific fields.
 */
export interface CommunicationsResponsePhoneCallSpecificModel {
  /**
   * Call Duration Seconds
   * @default null
   */
  call_duration_seconds?: number | null;
  /**
   * Forwarded Phone Number
   * @default null
   */
  forwarded_phone_number?: string | null;
  /**
   * Is No Answer
   * @default null
   */
  is_no_answer?: boolean | null;
  /**
   * Is Phone Call Recorded
   * @default null
   */
  is_phone_call_recorded?: boolean | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Recording Url
   * @default null
   */
  recording_url?: string | null;
  /**
   * Voicemail Url
   * @default null
   */
  voicemail_url?: string | null;
}

/**
 * PhysicalMailSpecificModel
 * Physical mail-specific fields.
 */
export interface CommunicationsResponsePhysicalMailSpecificModel {
  /** @default null */
  address?: CommunicationsResponseLocationModel | null;
  /**
   * Attachments
   * @default null
   */
  attachments?: CommunicationsResponseCommunicationAttachmentResponse[] | null;
  /**
   * Physical Mail Type
   * @default null
   */
  physical_mail_type?: string | null;
  /**
   * Recipient Name
   * @default null
   */
  recipient_name?: string | null;
}

/**
 * SmsSpecificModel
 * SMS-specific fields.
 */
export interface CommunicationsResponseSmsSpecificModel {
  /**
   * Message
   * @default null
   */
  message?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
}

/** UserExternalAPIBaseModel */
export interface CommunicationsResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * VideoCallSpecificModel
 * Video call-specific fields.
 */
export interface CommunicationsResponseVideoCallSpecificModel {
  /**
   * Joined Participants
   * @default null
   */
  joined_participants?: string[] | null;
  /**
   * Meeting End Datetime
   * @default null
   */
  meeting_end_datetime?: string | null;
  /**
   * Meeting Start Datetime
   * @default null
   */
  meeting_start_datetime?: string | null;
  /**
   * Provider
   * @default null
   */
  provider?: string | null;
  /**
   * Recording Status
   * @default null
   */
  recording_status?: string | null;
  /**
   * Recording Url
   * @default null
   */
  recording_url?: string | null;
  /**
   * Transcript
   * @default null
   */
  transcript?: string | null;
}

/**
 * ConductorConfigurationModel
 * Response shape for one scope's authored configuration.
 *
 * Scoped to (organization_id, sub_organization_id, lob); ``sub_organization_id`` is
 * ``None`` for an organization-level configuration.
 *
 * ``id`` addresses the scope's configuration and is **stable** across edits -- a client
 * that keeps editing may reuse it.
 *
 * ``stages`` is keyed by claim stage key and carries content only. It is deliberately not
 * the shape the AI service receives, which is an ordered list carrying ``key`` and ``label``
 * as well: order and labels there come from the organization's claim-stage configuration at
 * serve time, not from this mapping, and an enabled stage is included only when its entry
 * here has both a goal and instructions.
 */
export interface ConductorConfigurationModel {
  /** General Instructions */
  general_instructions: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Lob */
  lob: string;
  /** Organization Id */
  organization_id: number;
  /** Stages */
  stages: Record<string, ConductorConfigurationModelConductorStageContentModel>;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/**
 * ConductorStageContentModel
 * What is authored against one claim stage.
 *
 * The stage key is the ``stages`` mapping's key rather than a field here, and ``label`` is
 * resolved from the organization's ClaimStage configuration when the stage is served, so
 * neither can drift from the stage it describes.
 *
 * Both fields default to ``''``: a stage with neither a goal nor instructions is a
 * legitimate state that saves, so the empty case costs the client nothing on the wire.
 */
export interface ConductorConfigurationModelConductorStageContentModel {
  /**
   * Goal
   * @default ""
   */
  goal?: string;
  /**
   * Instructions
   * @default ""
   */
  instructions?: string;
}

/** ConductorConfigurationModelList */
export type ConductorConfigurationModelList =
  ConductorConfigurationModelListConductorConfigurationModel[];

/**
 * ConductorConfigurationModel
 * Response shape for one scope's authored configuration.
 *
 * Scoped to (organization_id, sub_organization_id, lob); ``sub_organization_id`` is
 * ``None`` for an organization-level configuration.
 *
 * ``id`` addresses the scope's configuration and is **stable** across edits -- a client
 * that keeps editing may reuse it.
 *
 * ``stages`` is keyed by claim stage key and carries content only. It is deliberately not
 * the shape the AI service receives, which is an ordered list carrying ``key`` and ``label``
 * as well: order and labels there come from the organization's claim-stage configuration at
 * serve time, not from this mapping, and an enabled stage is included only when its entry
 * here has both a goal and instructions.
 */
export interface ConductorConfigurationModelListConductorConfigurationModel {
  /** General Instructions */
  general_instructions: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Lob */
  lob: string;
  /** Organization Id */
  organization_id: number;
  /** Stages */
  stages: Record<
    string,
    ConductorConfigurationModelListConductorStageContentModel
  >;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/**
 * ConductorStageContentModel
 * What is authored against one claim stage.
 *
 * The stage key is the ``stages`` mapping's key rather than a field here, and ``label`` is
 * resolved from the organization's ClaimStage configuration when the stage is served, so
 * neither can drift from the stage it describes.
 *
 * Both fields default to ``''``: a stage with neither a goal nor instructions is a
 * legitimate state that saves, so the empty case costs the client nothing on the wire.
 */
export interface ConductorConfigurationModelListConductorStageContentModel {
  /**
   * Goal
   * @default ""
   */
  goal?: string;
  /**
   * Instructions
   * @default ""
   */
  instructions?: string;
}

/**
 * ConductorConfigurationUpsertJson
 * Create / replace payload for the ``/api/v1`` collection routes.
 *
 * ``sub_organization_id`` is optional (``None`` = organization level); ``lob`` is required.
 * An empty ``stages`` is accepted -- a configuration carrying only ``general_instructions``
 * is a legitimate state.
 */
export interface ConductorConfigurationUpsertJson {
  /**
   * General Instructions
   * @default ""
   */
  general_instructions?: string;
  /** Lob */
  lob: string;
  /**
   * Stages
   * @default {}
   */
  stages?: Record<
    string,
    ConductorConfigurationUpsertJsonConductorStageContentModel
  >;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * ConductorStageContentModel
 * What is authored against one claim stage.
 *
 * The stage key is the ``stages`` mapping's key rather than a field here, and ``label`` is
 * resolved from the organization's ClaimStage configuration when the stage is served, so
 * neither can drift from the stage it describes.
 *
 * Both fields default to ``''``: a stage with neither a goal nor instructions is a
 * legitimate state that saves, so the empty case costs the client nothing on the wire.
 */
export interface ConductorConfigurationUpsertJsonConductorStageContentModel {
  /**
   * Goal
   * @default ""
   */
  goal?: string;
  /**
   * Instructions
   * @default ""
   */
  instructions?: string;
}

/**
 * ConductorHandlingSwitchRequest
 * The reason the handler gives for taking the claim over or handing it back, if any, without its
 * surrounding whitespace. A blank reason is recorded as no reason.
 */
export interface ConductorHandlingSwitchRequest {
  /**
   * Reason
   * @default null
   */
  reason?: string | null;
}

/**
 * ConductorScopeConfigurationModel
 * Response shape for the sysconfig ``GET``/``PATCH`` on one scope.
 *
 * Distinct from :class:`ConductorConfigurationModel` in one respect that matters: every
 * field bar the scope key is defaulted, because a scope with nothing authored answers 200
 * with this shape rather than 404. That is what lets the screen open any scope without a
 * create gesture -- the first save is what creates the row. ``id`` is therefore ``None``
 * exactly when no row exists yet.
 */
export interface ConductorScopeConfigurationModel {
  /**
   * General Instructions
   * @default ""
   */
  general_instructions?: string;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Is Enabled
   * @default false
   */
  is_enabled?: boolean;
  /**
   * Last Updated By Username
   * @default null
   */
  last_updated_by_username?: string | null;
  /**
   * Last Updated Datetime
   * @default null
   */
  last_updated_datetime?: string | null;
  /** Lob */
  lob: string;
  /**
   * Stages
   * @default {}
   */
  stages?: Record<
    string,
    ConductorScopeConfigurationModelConductorStageContentModel
  >;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * ConductorStageContentModel
 * What is authored against one claim stage.
 *
 * The stage key is the ``stages`` mapping's key rather than a field here, and ``label`` is
 * resolved from the organization's ClaimStage configuration when the stage is served, so
 * neither can drift from the stage it describes.
 *
 * Both fields default to ``''``: a stage with neither a goal nor instructions is a
 * legitimate state that saves, so the empty case costs the client nothing on the wire.
 */
export interface ConductorScopeConfigurationModelConductorStageContentModel {
  /**
   * Goal
   * @default ""
   */
  goal?: string;
  /**
   * Instructions
   * @default ""
   */
  instructions?: string;
}

/**
 * ConductorScopePatchJson
 * Sparse patch body for the sysconfig ``PATCH /scope``.
 *
 * ``sub_organization_id`` and ``lob`` address the scope; everything else is optional and a
 * field that is **omitted is left unchanged**. Each patchable field is three-state, with
 * ``None`` meaning "not sent" -- which is what keeps ``is_enabled=False`` (switch the
 * conductor off) distinguishable from an untouched switch. ``None`` carries no meaning of
 * its own for any of them: clearing the instructions is ``''``, not ``null``, so the
 * sibling ``ai_external_tool_config``'s ``model_fields_set`` reading is not needed here.
 *
 * ``stage`` patches one stage's content wholesale, so a caller clearing a goal sends the
 * stage with ``goal=''``. Stages the patch does not name keep what they hold.
 */
export interface ConductorScopePatchJson {
  /**
   * General Instructions
   * @default null
   */
  general_instructions?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /** Lob */
  lob: string;
  /** @default null */
  stage?: ConductorScopePatchJsonConductorStagePatchModel | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * ConductorStagePatchModel
 * One stage's content, addressed by key, as a patch carries it.
 *
 * ``key`` is a field here rather than a mapping key because a patch names a single stage;
 * it is validated against the organization's configured claim stages, as authoring one
 * naming no configured stage would store content that is never served.
 */
export interface ConductorScopePatchJsonConductorStagePatchModel {
  /**
   * Goal
   * @default ""
   */
  goal?: string;
  /**
   * Instructions
   * @default ""
   */
  instructions?: string;
  /** Key */
  key: string;
}

/**
 * ConductorScopeQuery
 * Scope selector for the sysconfig ``GET /scope`` read.
 *
 * Validated by spectree so a malformed ``sub_organization_id`` returns 400 rather than an
 * uncaught ``ValueError`` (500). Mirrors ``claim_action_configuration``'s
 * ``ListClaimActionsQuery``.
 */
export interface ConductorScopeQuery {
  /** Lob */
  lob: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * ConfigExportResponse
 * Target's current configuration export, serialized for the wire. ``export_zip_b64`` is the
 * base64-encoded snapshot-archive zip (``SerializedExport.zip_bytes``); the source decodes it and calls
 * ``deserialize_export``. base64-in-JSON keeps all machine routes uniform under ``@spec.validate`` and
 * lets the HMAC sign one JSON body. ``blocked_sections`` is non-empty only for an opted-in request.
 */
export interface ConfigExportResponse {
  /**
   * Blocked Sections
   * @default []
   */
  blocked_sections?: ConfigExportResponseConfigExportBlockedSection[];
  /** Export Zip B64 */
  export_zip_b64: string;
  /** Organization External Id */
  organization_external_id: string;
}

/**
 * ConfigExportBlockedSection
 * A section the target left out of its export because the export was blocked. The archive records the
 * type by name only; ``reasons`` ride in this response and the source never stores them.
 */
export interface ConfigExportResponseConfigExportBlockedSection {
  /** Configuration Type */
  configuration_type: string;
  /** Reasons */
  reasons: string[];
}

/**
 * ConfigVariableInfo
 * Base variable info — returned by get_all_variables() for FE display.
 */
export interface ConfigVariableInfo {
  /** Description */
  description: string | null;
  /** Is Bound */
  is_bound: boolean;
  /** Is Required */
  is_required: boolean;
  /** Name */
  name: string;
  /** Value Display */
  value_display: string | null;
  /** Variable Type */
  variable_type: string;
}

/** ConfigVariableInfoList */
export type ConfigVariableInfoList = ConfigVariableInfoListConfigVariableInfo[];

/**
 * ConfigVariableInfo
 * Base variable info — returned by get_all_variables() for FE display.
 */
export interface ConfigVariableInfoListConfigVariableInfo {
  /** Description */
  description: string | null;
  /** Is Bound */
  is_bound: boolean;
  /** Is Required */
  is_required: boolean;
  /** Name */
  name: string;
  /** Value Display */
  value_display: string | null;
  /** Variable Type */
  variable_type: string;
}

/** ConfigurationResponse */
export interface ConfigurationResponse {
  /** Account Id */
  account_id: string | null;
}

/**
 * ConfigurationSnapshot
 * Pydantic model for configuration snapshot responses.
 */
export interface ConfigurationSnapshot {
  /**
   * Created At
   * When snapshot was created
   */
  created_at: string;
  /**
   * Created By User Id
   * User who created the snapshot
   * @default null
   */
  created_by_user_id?: string | null;
  /**
   * Created By Username
   * Username of user who created the snapshot
   * @default null
   */
  created_by_username?: string | null;
  /**
   * Description
   * Optional description
   * @default null
   */
  description?: string | null;
  /**
   * Id
   * Database ID of the snapshot
   */
  id: number;
  /**
   * Organization Id
   * Organization ID
   */
  organization_id: number;
  /**
   * Reason
   * Reason for snapshot creation
   */
  reason: string;
  /**
   * Snapshot Hash
   * SHA-256 hash of the snapshot
   */
  snapshot_hash: string;
  /**
   * Snapshot Name
   * Name of the snapshot
   */
  snapshot_name: string;
}

/**
 * ConsentDecisionRequest
 * The signed-in user's answer to a consent request.
 */
export interface ConsentDecisionRequest {
  /** Approved */
  approved: boolean;
  /** Approved Scopes */
  approved_scopes?: string[];
  /** Request */
  request: string;
}

/**
 * ConsentDecisionResponse
 * Where the screen sends the user's browser: the client's redirect URI, carrying the answer.
 */
export interface ConsentDecisionResponse {
  /** Redirect Url */
  redirect_url: string;
}

/**
 * ConsentDetails
 * What the consent screen asks the signed-in user to approve.
 */
export interface ConsentDetails {
  /** Client Name */
  client_name: string;
  /** Redirect Host */
  redirect_host: string;
  /** Scopes */
  scopes: ConsentDetailsConsentScope[];
  /** User Email */
  user_email: string;
}

/**
 * ConsentScope
 * A scope the client asks for, as the consent screen shows it.
 */
export interface ConsentDetailsConsentScope {
  /** Description */
  description: string;
  /** Required */
  required: boolean;
  /** Scope */
  scope: string;
}

/**
 * ConsentRequestQuery
 * The consent request the screen was opened with, as the authorize endpoint signed it.
 */
export interface ConsentRequestQuery {
  /** Request */
  request: string;
}

/**
 * ContactInfo
 * Full contact DTO — matches the flask-restx contact_full_model exactly.
 */
export interface ContactInfo {
  /**
   * Account Details
   * @default null
   */
  account_details?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Bar Number
   * @default null
   */
  attorney_bar_number?: string | null;
  /**
   * Attorney Bar State
   * @default null
   */
  attorney_bar_state?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Change Ulid
   * @default null
   */
  au_tfn_change_ulid?: string | null;
  /**
   * Au Tfn Contact Document Id
   * @default null
   */
  au_tfn_contact_document_id?: number | null;
  /**
   * Au Tfn Exemption
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Bank Proof Contact Document Id
   * @default null
   */
  bank_proof_contact_document_id?: number | null;
  /**
   * Business Legal Name
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Coi Contact Document Id
   * @default null
   */
  coi_contact_document_id?: number | null;
  /**
   * Coi Expiration
   * @default null
   */
  coi_expiration?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /** @default null */
  contact_extra?: ContactInfoContactExtraInfo | null;
  /**
   * Contract Of Service Contact Document Id
   * @default null
   */
  contract_of_service_contact_document_id?: number | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivated By User Id
   * @default null
   */
  deactivated_by_user_id?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: ContactInfoContactEmailInfo[];
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * Finance Change Ulid
   * @default null
   */
  finance_change_ulid?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Address
   * @default null
   */
  full_address?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** Id */
  id: number;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /** Is Company */
  is_company: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean;
  /**
   * Is Deceased
   * @default null
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Moi Service Provider
   * @default null
   */
  is_moi_service_provider?: boolean | null;
  /**
   * Is Policy Contact
   * @default null
   */
  is_policy_contact?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * Medical Provider Discount Fixed Amount
   * @default null
   */
  medical_provider_discount_fixed_amount?: number | null;
  /**
   * Medical Provider Discount Percentage
   * @default null
   */
  medical_provider_discount_percentage?: number | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Moi Expertises
   * @default []
   */
  moi_expertises?: string[];
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Organization External Id
   * @default null
   */
  organization_external_id?: string | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Phones
   * @default []
   */
  phones?: ContactInfoContactPhoneInfo[];
  /**
   * Reference Contact Full Name
   * @default null
   */
  reference_contact_full_name?: string | null;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * Sex
   * @default null
   */
  sex?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Street Address1
   * @default null
   */
  street_address1?: string | null;
  /**
   * Street Address2
   * @default null
   */
  street_address2?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Granted At
   * @default null
   */
  trusted_payee_granted_at?: string | null;
  /**
   * Trusted Payee Granted By User Name
   * @default null
   */
  trusted_payee_granted_by_user_name?: string | null;
  /**
   * Trusted Payee Per Payment Limit
   * @default null
   */
  trusted_payee_per_payment_limit?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Trusted Payee Valid To
   * @default null
   */
  trusted_payee_valid_to?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Validations
   * @default []
   */
  validations?: ContactInfoContactValidationInfo[];
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * W9 Contact Document Id
   * @default null
   */
  w9_contact_document_id?: number | null;
  /**
   * W9 Date
   * @default null
   */
  w9_date?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** AddressValidationDetails */
export interface ContactInfoAddressValidationDetails {
  /**
   * Override Reason
   * @default null
   */
  override_reason?: string | null;
  /**
   * Override Timestamp
   * @default null
   */
  override_timestamp?: string | null;
  /**
   * Override User Name
   * @default null
   */
  override_user_name?: string | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Ref Type
   * @default null
   */
  ref_type?: string | null;
  /**
   * Type
   * @default "address"
   */
  type?: "address";
}

/** BusinessValidationDetails */
export interface ContactInfoBusinessValidationDetails {
  /**
   * Bn
   * @default null
   */
  bn?: string | null;
  /**
   * Entity Type
   * @default null
   */
  entity_type?: string | null;
  /**
   * Gst Status
   * @default null
   */
  gst_status?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Type
   * @default "business"
   */
  type?: "business";
}

/** ContactEmailInfo */
export interface ContactInfoContactEmailInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email */
  email: string;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
}

/** ContactExtraInfo */
export interface ContactInfoContactExtraInfo {
  /**
   * Driving License Issue Date
   * @default null
   */
  driving_license_issue_date?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Is Unrecognized Number Contact
   * @default null
   */
  is_unrecognized_number_contact?: boolean | null;
  /**
   * Profession
   * @default null
   */
  profession?: string | null;
  /**
   * User Id
   * @default null
   */
  user_id?: string | null;
}

/** ContactPhoneInfo */
export interface ContactInfoContactPhoneInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /** Phone */
  phone: string;
  /**
   * Phone Type
   * @default null
   */
  phone_type?: string | null;
  /**
   * Standardized Phone
   * @default null
   */
  standardized_phone?: string | null;
}

/** ContactValidationInfo */
export interface ContactInfoContactValidationInfo {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Id */
  id: number;
  /** Provider */
  provider: string;
  /** Status */
  status: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Validation Details
   * @default null
   */
  validation_details?:
    | (
        | ({
            type: "address";
          } & ContactInfoAddressValidationDetails)
        | ({
            type: "business";
          } & ContactInfoBusinessValidationDetails)
      )
    | null;
  /** Validation Type */
  validation_type: string;
}

/** ContactModel */
export interface ContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: ContactModelContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: ContactModelContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactEmailModel */
export interface ContactModelContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactPhoneModel */
export interface ContactModelContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ContactRoleEnabledParams */
export interface ContactRoleEnabledParams {
  /** Is Enabled */
  is_enabled: boolean;
}

/** ContactRoleParams */
export interface ContactRoleParams {
  /** Desc */
  desc: string;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /** Is Moi Enabled */
  is_moi_enabled: boolean;
  /** Is Multi Claim */
  is_multi_claim: boolean;
  /** Is Tin Required */
  is_tin_required: boolean;
  /** Lobs */
  lobs: string[];
  /** Role Key */
  role_key: string;
}

/** ContactRoleUpdateParams */
export interface ContactRoleUpdateParams {
  /** Desc */
  desc: string;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /** Is Moi Enabled */
  is_moi_enabled: boolean;
  /** Is Multi Claim */
  is_multi_claim: boolean;
  /** Is Tin Required */
  is_tin_required: boolean;
  /** Lobs */
  lobs: string[];
  /** Role Key */
  role_key: string;
}

/**
 * ContactsFilterRequest
 * Request model for filtering contacts with cursor-based pagination.
 *
 * Extends the base CursorPaginationRequest with contacts-specific filters
 * following the flat parameter pattern for better API design.
 */
export interface ContactsFilterRequest {
  /**
   * Claim Number
   * Filter contacts associated with specific claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contact Expertise
   * Filter by contact expertises
   * @default null
   */
  contact_expertise?: string[] | null;
  /**
   * Contact Role
   * Filter by contact roles (e.g., ["claimant", "insured", "witness"])
   * @default null
   */
  contact_role?: string[] | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Email Address
   * Filter by contact email address (partial match)
   * @default null
   */
  email_address?: string | null;
  /**
   * Include Multi Claim Only
   * Filter to only contacts associated with multiple claims
   * @default null
   */
  include_multi_claim_only?: boolean | null;
  /**
   * Is Company
   * Filter by company contacts (true) or individual contacts (false)
   * @default null
   */
  is_company?: boolean | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Name
   * Case-insensitive search on contact name (first, last, full name, or company name)
   * @default null
   */
  name?: string | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Phone Number
   * Filter by contact phone number (partial match)
   * @default null
   */
  phone_number?: string | null;
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Zipcode
   * Filter by contact ZIP/postal code
   * @default null
   */
  zipcode?: string | null;
}

/**
 * ContactsResponse
 * Response model for paginated contacts data.
 */
export interface ContactsResponse {
  /** Pagination metadata */
  metadata: ContactsResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * List of contacts matching the filter criteria
   */
  records: ContactsResponseContactModel[];
}

/** ContactEmailModel */
export interface ContactsResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface ContactsResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: ContactsResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: ContactsResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface ContactsResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface ContactsResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/** ControlFileCriteriaResponse */
export interface ControlFileCriteriaResponse {
  /** Records */
  records: ControlFileCriteriaResponseControlFileCriteriaItem[];
}

/** ControlFileCriteriaItem */
export interface ControlFileCriteriaResponseControlFileCriteriaItem {
  /** Desc */
  desc: string;
  /** Key */
  key: string;
  /** Short Desc */
  short_desc: string;
}

/**
 * CotConfigurationResponse
 * Response model for CotConfiguration API endpoints.
 *
 * Includes both the database fields and the parsed configuration data.
 */
export interface CotConfigurationResponse {
  /**
   * Pydantic model for Clive on Top configuration data stored in JSONB field.
   *
   * This represents the structure of the 'configuration' JSON field in CotConfiguration model.
   */
  configuration: CotConfigurationResponseCotConfigurationData;
  /** Cot Organization Id */
  cot_organization_id: number;
  /** Datetime Created */
  datetime_created: string | null;
  /** Datetime Updated */
  datetime_updated?: string | null;
  /** Id */
  id: number;
  /** Organization Id */
  organization_id: number;
}

/**
 * CotConfigurationData
 * Pydantic model for Clive on Top configuration data stored in JSONB field.
 *
 * This represents the structure of the 'configuration' JSON field in CotConfiguration model.
 * @example {"cot_organization_external_id":"cot_org_external_id","enabled_event_keys":["new_claim_created_event"],"is_enabled":true,"service_account_token":"secret_token_here"}
 */
export interface CotConfigurationResponseCotConfigurationData {
  /**
   * Cot Organization External Id
   * External ID of the COT organization for API calls
   */
  cot_organization_external_id: string;
  /**
   * Enabled Event Keys
   * List of event keys that should trigger cross-organization communication
   */
  enabled_event_keys?: string[];
  /**
   * Is Enabled
   * Whether this COT configuration is active
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Service Account Token
   * Service account token for authentication with COT organization
   */
  service_account_token: string;
}

/** CotConfigurationResponseList */
export type CotConfigurationResponseList =
  CotConfigurationResponseListCotConfigurationResponse[];

/**
 * CotConfigurationData
 * Pydantic model for Clive on Top configuration data stored in JSONB field.
 *
 * This represents the structure of the 'configuration' JSON field in CotConfiguration model.
 * @example {"cot_organization_external_id":"cot_org_external_id","enabled_event_keys":["new_claim_created_event"],"is_enabled":true,"service_account_token":"secret_token_here"}
 */
export interface CotConfigurationResponseListCotConfigurationData {
  /**
   * Cot Organization External Id
   * External ID of the COT organization for API calls
   */
  cot_organization_external_id: string;
  /**
   * Enabled Event Keys
   * List of event keys that should trigger cross-organization communication
   */
  enabled_event_keys?: string[];
  /**
   * Is Enabled
   * Whether this COT configuration is active
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Service Account Token
   * Service account token for authentication with COT organization
   */
  service_account_token: string;
}

/**
 * CotConfigurationResponse
 * Response model for CotConfiguration API endpoints.
 *
 * Includes both the database fields and the parsed configuration data.
 */
export interface CotConfigurationResponseListCotConfigurationResponse {
  /**
   * Pydantic model for Clive on Top configuration data stored in JSONB field.
   *
   * This represents the structure of the 'configuration' JSON field in CotConfiguration model.
   */
  configuration: CotConfigurationResponseListCotConfigurationData;
  /** Cot Organization Id */
  cot_organization_id: number;
  /** Datetime Created */
  datetime_created: string | null;
  /** Datetime Updated */
  datetime_updated?: string | null;
  /** Id */
  id: number;
  /** Organization Id */
  organization_id: number;
}

/** CountersViewResponse */
export interface CountersViewResponse {
  /** Fnol Queue Count */
  fnol_queue_count: number;
  /** General Queue Count */
  general_queue_count: number;
  /** Unread Notifications Count */
  unread_notifications_count: number;
}

/** CountriesConfigurationLocationUpdateParams */
export interface CountriesConfigurationLocationUpdateParams {
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Countries Selection
   * @default null
   */
  countries_selection?: "organization_country" | "all" | "multiple" | null;
  /**
   * Lob
   * @default null
   */
  lob?: string | null;
  /**
   * Location Type
   * @default null
   */
  location_type?:
    | "loss_location"
    | "vehicle_location"
    | "checks_address"
    | "physical_mail_address"
    | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** CountriesConfigurationUpdateParams */
export interface CountriesConfigurationUpdateParams {
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * CoverageConfigCreateParams
 * Parameters for creating a new coverage config.
 */
export interface CoverageConfigCreateParams {
  /**
   * Coverage Group Key
   * @default null
   */
  coverage_group_key?: string | null;
  /**
   * Coverage Key
   * @minLength 1
   */
  coverage_key: string;
  /**
   * Damage Assessment Type
   * @default null
   */
  damage_assessment_type?: string | null;
  /**
   * Depreciation Calculation Api Url
   * @default null
   */
  depreciation_calculation_api_url?: string | null;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 256
   */
  display_name: string;
  /**
   * Expense Policy Limit Config
   * @default null
   */
  expense_policy_limit_config?: Record<string, any> | null;
  /**
   * Include Depreciation
   * @default false
   */
  include_depreciation?: boolean;
  /**
   * Involved Types
   * @minItems 1
   */
  involved_types: string[];
  /**
   * Is Coinsurance
   * @default null
   */
  is_coinsurance?: boolean | null;
  /** Is Deductible */
  is_deductible: boolean;
  /** Is Limit Per Incident */
  is_limit_per_incident: boolean;
  /** Is Limit Per Person */
  is_limit_per_person: boolean;
  /**
   * Is Limit Per Policy Per Entity
   * @default null
   */
  is_limit_per_policy_per_entity?: boolean | null;
  /**
   * Iso Code
   * @default null
   */
  iso_code?: string | null;
  /** Lob */
  lob: string;
  /** Loss Type */
  loss_type: string;
  /**
   * Should Include Dates Of Service
   * @default false
   */
  should_include_dates_of_service?: boolean;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sub Reserves Config
   * @default {}
   */
  sub_reserves_config?: Record<string, any>;
  /**
   * Use Indemnity Sub Reserves
   * @default false
   */
  use_indemnity_sub_reserves?: boolean;
}

/**
 * CoverageConfigInfo
 * Public data representation for coverage config.
 */
export interface CoverageConfigInfo {
  /** Coverage Group Display Name */
  coverage_group_display_name: string;
  /** Coverage Group Key */
  coverage_group_key: string | null;
  /** Coverage Key */
  coverage_key: string;
  /** Coverage Type Id */
  coverage_type_id: string | null;
  /**
   * Damage Assessment Base Type
   * @default null
   */
  damage_assessment_base_type?: string | null;
  /** Damage Assessment Type */
  damage_assessment_type: string | null;
  /** Depreciation Calculation Api Url */
  depreciation_calculation_api_url: string | null;
  /** Display Name */
  display_name: string;
  /** Expense Policy Limit Config */
  expense_policy_limit_config: Record<string, any> | null;
  /** Id */
  id: number;
  /** Include Depreciation */
  include_depreciation: boolean;
  /** Involved Types */
  involved_types: string[];
  /** Is Coinsurance */
  is_coinsurance: boolean | null;
  /** Is Deductible */
  is_deductible: boolean;
  /** Is Disabled */
  is_disabled: boolean;
  /** Is Limit Per Incident */
  is_limit_per_incident: boolean;
  /** Is Limit Per Person */
  is_limit_per_person: boolean;
  /** Is Limit Per Policy Per Entity */
  is_limit_per_policy_per_entity: boolean | null;
  /** Is Org Level */
  is_org_level: boolean;
  /** Is Sub Reserves Config Enabled */
  is_sub_reserves_config_enabled: boolean;
  /** Iso Code */
  iso_code: string | null;
  /** Lob */
  lob: string;
  /** Loss Type */
  loss_type: string;
  /** Organization Id */
  organization_id: number;
  /** Should Include Dates Of Service */
  should_include_dates_of_service: boolean | null;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
  /** Sub Organizations */
  sub_organizations: CoverageConfigInfoSubOrganizationInfo[];
  /** Sub Reserves Config */
  sub_reserves_config: Record<string, any>;
}

/**
 * SubOrganizationInfo
 * Public data representation for sub-organization.
 */
export interface CoverageConfigInfoSubOrganizationInfo {
  /** External Id */
  external_id: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** CoverageConfigInfoList */
export type CoverageConfigInfoList = CoverageConfigInfoListCoverageConfigInfo[];

/**
 * CoverageConfigInfo
 * Public data representation for coverage config.
 */
export interface CoverageConfigInfoListCoverageConfigInfo {
  /** Coverage Group Display Name */
  coverage_group_display_name: string;
  /** Coverage Group Key */
  coverage_group_key: string | null;
  /** Coverage Key */
  coverage_key: string;
  /** Coverage Type Id */
  coverage_type_id: string | null;
  /**
   * Damage Assessment Base Type
   * @default null
   */
  damage_assessment_base_type?: string | null;
  /** Damage Assessment Type */
  damage_assessment_type: string | null;
  /** Depreciation Calculation Api Url */
  depreciation_calculation_api_url: string | null;
  /** Display Name */
  display_name: string;
  /** Expense Policy Limit Config */
  expense_policy_limit_config: Record<string, any> | null;
  /** Id */
  id: number;
  /** Include Depreciation */
  include_depreciation: boolean;
  /** Involved Types */
  involved_types: string[];
  /** Is Coinsurance */
  is_coinsurance: boolean | null;
  /** Is Deductible */
  is_deductible: boolean;
  /** Is Disabled */
  is_disabled: boolean;
  /** Is Limit Per Incident */
  is_limit_per_incident: boolean;
  /** Is Limit Per Person */
  is_limit_per_person: boolean;
  /** Is Limit Per Policy Per Entity */
  is_limit_per_policy_per_entity: boolean | null;
  /** Is Org Level */
  is_org_level: boolean;
  /** Is Sub Reserves Config Enabled */
  is_sub_reserves_config_enabled: boolean;
  /** Iso Code */
  iso_code: string | null;
  /** Lob */
  lob: string;
  /** Loss Type */
  loss_type: string;
  /** Organization Id */
  organization_id: number;
  /** Should Include Dates Of Service */
  should_include_dates_of_service: boolean | null;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
  /** Sub Organizations */
  sub_organizations: CoverageConfigInfoListSubOrganizationInfo[];
  /** Sub Reserves Config */
  sub_reserves_config: Record<string, any>;
}

/**
 * SubOrganizationInfo
 * Public data representation for sub-organization.
 */
export interface CoverageConfigInfoListSubOrganizationInfo {
  /** External Id */
  external_id: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/**
 * CoverageConfigUpdateParams
 * Parameters for updating an existing coverage config.
 */
export interface CoverageConfigUpdateParams {
  /**
   * Coverage Group Key
   * @default null
   */
  coverage_group_key?: string | null;
  /**
   * Depreciation Calculation Api Url
   * @default null
   */
  depreciation_calculation_api_url?: string | null;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 256
   */
  display_name: string;
  /**
   * Expense Policy Limit Config
   * @default null
   */
  expense_policy_limit_config?: Record<string, any> | null;
  /**
   * Include Depreciation
   * @default null
   */
  include_depreciation?: boolean | null;
  /**
   * Involved Types
   * @default null
   */
  involved_types?: string[] | null;
  /**
   * Iso Code
   * @default null
   */
  iso_code?: string | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sub Reserves Config
   * @default {}
   */
  sub_reserves_config?: Record<string, any>;
  /**
   * Use Indemnity Sub Reserves
   * @default false
   */
  use_indemnity_sub_reserves?: boolean;
}

/**
 * CoverageConfigurationPatchParams
 * Parameters for patching coverage configuration settings.
 */
export interface CoverageConfigurationPatchParams {
  /**
   * Is Capacity Agreement Enabled
   * @default null
   */
  is_capacity_agreement_enabled?: boolean | null;
  /**
   * Is General Expenses Disabled
   * @default null
   */
  is_general_expenses_disabled?: boolean | null;
  /**
   * Is General Expenses Disabled Per Sub Org
   * @default null
   */
  is_general_expenses_disabled_per_sub_org?: Record<string, boolean> | null;
  /**
   * Limit Per Claim
   * @default null
   */
  limit_per_claim?: boolean | null;
  /**
   * Limit Per Covered Entity
   * @default null
   */
  limit_per_covered_entity?: boolean | null;
  /**
   * Limit Per Policy
   * @default null
   */
  limit_per_policy?: boolean | null;
  /**
   * Limit Per Policy Per Covered Entity
   * @default null
   */
  limit_per_policy_per_covered_entity?: boolean | null;
  /**
   * Pre Fill Deductible
   * @default null
   */
  pre_fill_deductible?: boolean | null;
}

/**
 * CoverageDecisionJsonParams
 * The exposure's coverage decision. A denial sets the indemnity reserve to zero.
 */
export interface CoverageDecisionJsonParams {
  /** Coverage Decision */
  coverage_decision: "confirmed" | "denied" | "partial_coverage";
  /**
   * Is Eligibility Confirmed
   * Whether the claimant's eligibility is confirmed.
   * @default null
   */
  is_eligibility_confirmed?: boolean | null;
  /**
   * Reason
   * Why the decision was made. May be empty.
   */
  reason: string;
}

/**
 * CoverageDisableParams
 * Request body for enabling/disabling a coverage config.
 */
export interface CoverageDisableParams {
  /** Is Disabled */
  is_disabled: boolean;
}

/**
 * CoverageDisableResponse
 * Response for coverage disable toggle.
 */
export interface CoverageDisableResponse {
  /** Is Disabled */
  is_disabled: boolean;
}

/**
 * CoverageGroupCreateParams
 * Parameters for creating a new coverage group.
 */
export interface CoverageGroupCreateParams {
  /**
   * Coverage Group Key
   * @maxLength 128
   */
  coverage_group_key: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Display Name
   * @maxLength 128
   */
  display_name: string;
}

/**
 * CoverageGroupInfo
 * Public data representation for coverage group.
 */
export interface CoverageGroupInfo {
  /** Coverage Group Key */
  coverage_group_key: string;
  /** Coverages Configs */
  coverages_configs: string[];
  /** Description */
  description: string | null;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Disabled */
  is_disabled: boolean;
  /** Last Updated By User */
  last_updated_by_user: string | null;
  /**
   * Last Updated Datetime
   * @format date-time
   */
  last_updated_datetime: string;
}

/** CoverageGroupInfoList */
export type CoverageGroupInfoList = CoverageGroupInfoListCoverageGroupInfo[];

/**
 * CoverageGroupInfo
 * Public data representation for coverage group.
 */
export interface CoverageGroupInfoListCoverageGroupInfo {
  /** Coverage Group Key */
  coverage_group_key: string;
  /** Coverages Configs */
  coverages_configs: string[];
  /** Description */
  description: string | null;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Disabled */
  is_disabled: boolean;
  /** Last Updated By User */
  last_updated_by_user: string | null;
  /**
   * Last Updated Datetime
   * @format date-time
   */
  last_updated_datetime: string;
}

/**
 * CoverageGroupKeysUsedQueryParams
 * Query parameters for GET /coverages/groups/keys_used endpoint.
 */
export interface CoverageGroupKeysUsedQueryParams {
  /** @default [] */
  "ids_to_ignore[]"?: CoverageGroupKeysUsedQueryParamsEnsuredListInt;
}

export type CoverageGroupKeysUsedQueryParamsEnsuredListInt = number[];

/**
 * CoverageGroupUpdateParams
 * Parameters for updating an existing coverage group.
 */
export interface CoverageGroupUpdateParams {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
}

/**
 * CoverageKeysUsedQueryParams
 * Query parameters for GET /coverages/keys_used endpoint.
 */
export interface CoverageKeysUsedQueryParams {
  /**
   * Coverage Keys To Ignore[]
   * @default []
   */
  "coverage_keys_to_ignore[]"?: string[];
  /**
   * Shared Coverage Keys To Ignore[]
   * @default []
   */
  "shared_coverage_keys_to_ignore[]"?: string[];
}

/** CoverageTotalsResponse */
export interface CoverageTotalsResponse {
  metadata: CoverageTotalsResponseCoverageTotalsMetadata;
  /** Results */
  results: CoverageTotalsResponseCoverageTotalsForCoverageResponseItem[];
}

/** CoverageTotals */
export interface CoverageTotalsResponseCoverageTotals {
  /** Co Insurance */
  co_insurance: number;
  /** Coverage Id */
  coverage_id: number;
  /** Coverage Key */
  coverage_key: string;
  /** Coverage Name */
  coverage_name: string;
  /** Covered Amount */
  covered_amount: number;
  /** Eligible For Reimbursement */
  eligible_for_reimbursement: number;
  /** Not Covered Amount */
  not_covered_amount: number;
  /** Submitted Amount */
  submitted_amount: number;
}

/** CoverageTotalsForCoverageResponseItem */
export interface CoverageTotalsResponseCoverageTotalsForCoverageResponseItem {
  coverage_totals: CoverageTotalsResponseCoverageTotals;
  invoice: CoverageTotalsResponseInvoiceResponse;
}

/** CoverageTotalsMetadata */
export interface CoverageTotalsResponseCoverageTotalsMetadata {
  /** With Coinsurance */
  with_coinsurance: boolean;
}

/** InvoiceResponse */
export interface CoverageTotalsResponseInvoiceResponse {
  /** Claim Id */
  claim_id: number;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Document Id */
  document_id: number;
  /** Excluded Amount */
  excluded_amount: number;
  /** Extra */
  extra: Record<string, any>;
  /** Id */
  id: number;
  /**
   * Invoice Currency
   * @default null
   */
  invoice_currency?: string | null;
  /** Invoice Date */
  invoice_date: string | null;
  /** Invoice Number */
  invoice_number: string;
  invoice_processing_type: CoverageTotalsResponseInvoiceProcessingType;
  /** Line Items */
  line_items: CoverageTotalsResponseLineItemResponse[];
  /** Not Covered Amount */
  not_covered_amount: number;
  /** Organization Id */
  organization_id: number;
  /** Submitted Amount */
  submitted_amount: number;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Vendor */
  vendor: string | null;
}

/** LineItemResponse */
export interface CoverageTotalsResponseLineItemResponse {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: CoverageTotalsResponseCoverageDecisionOption;
  /** Coverage Id */
  coverage_id: number | null;
  /** Coverage Key */
  coverage_key: string | null;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Depreciation Applied Amount
   * @default null
   */
  depreciation_applied_amount?: number | null;
  /**
   * Depreciation Percentage
   * @default null
   */
  depreciation_percentage?: number | null;
  /** Description */
  description: string;
  /**
   * Entry Type
   * @default "line_item"
   */
  entry_type?: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /** Id */
  id: number;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /**
   * Is Depreciation Overridden
   * @default false
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default false
   */
  is_locked?: boolean;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: CoverageTotalsResponsePayableType | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/**
 * CoveragesExportQueryParams
 * Query parameters for GET /coverages/export endpoint.
 *
 * One parameter per filter on the Coverage Configuration screen's Coverages tab, so an export can
 * reproduce exactly what the user is looking at. All are optional and ANDed; omitting all three
 * exports the whole configuration.
 */
export interface CoveragesExportQueryParams {
  /** @default null */
  "lobs[]"?: CoveragesExportQueryParamsEnsuredListStr | null;
  /**
   * Search Text
   * @default null
   */
  search_text?: string | null;
  /** @default null */
  "sub_organization_ids[]"?: CoveragesExportQueryParamsEnsuredListInt | null;
}

export type CoveragesExportQueryParamsEnsuredListInt = number[];

export type CoveragesExportQueryParamsEnsuredListStr = string[];

/**
 * CoveragesFilterRequest
 * Request model for filtering coverages with cursor-based pagination.
 *
 * Extends the base CursorPaginationRequest with coverage-specific filters
 * as flat parameters for better REST API design.
 */
export interface CoveragesFilterRequest {
  /**
   * Coverage Group Key
   * Filter by coverage group key
   * @default null
   */
  coverage_group_key?: string | null;
  /**
   * Coverage Key
   * Exact lookup of a specific coverage by its key
   * @default null
   */
  coverage_key?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Include Disabled
   * Include disabled coverages (excluded by default)
   * @default false
   */
  include_disabled?: boolean;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Lob
   * Filter by line of business
   * @default null
   */
  lob?: string | null;
  /**
   * Loss Type
   * Filter by loss type
   * @default null
   */
  loss_type?: string | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field to sort by. Only 'coverage_key' is supported; defaults to it
   * @default null
   */
  order_by_field?: "coverage_key" | null;
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID: returns org-level coverages plus coverages linked to that sub-organization. Ignored for organizations that do not have sub-organizations enabled, which receive the whole catalogue
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/** CoveragesResponse */
export interface CoveragesResponse {
  /** Pagination metadata */
  metadata: CoveragesResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * List of coverages matching the filter criteria
   */
  records: CoveragesResponseCoverageResponse[];
}

/**
 * CoverageResponse
 * Response model for a single coverage config.
 */
export interface CoveragesResponseCoverageResponse {
  /**
   * Coverage Group Display Name
   * Display name of the coverage group the coverage belongs to, null if ungrouped
   * @default null
   */
  coverage_group_display_name?: string | null;
  /**
   * Coverage Group Key
   * Key of the coverage group the coverage belongs to, null if ungrouped
   * @default null
   */
  coverage_group_key?: string | null;
  /**
   * Coverage Key
   * Unique key of the coverage within the organization
   */
  coverage_key: string;
  /**
   * Damage Assessment Type
   * Damage assessment type of the coverage
   * @default null
   */
  damage_assessment_type?: string | null;
  /**
   * Display Name
   * Human-readable name of the coverage
   */
  display_name: string;
  /**
   * Include Depreciation
   * Whether the coverage includes depreciation
   */
  include_depreciation: boolean;
  /**
   * Involved Types
   * Involved entity types the coverage applies to
   */
  involved_types: string[];
  /**
   * Is Coinsurance
   * Whether the coverage has coinsurance
   * @default null
   */
  is_coinsurance?: boolean | null;
  /**
   * Is Deductible
   * Whether the coverage has a deductible
   */
  is_deductible: boolean;
  /**
   * Is Disabled
   * Whether the coverage is disabled
   */
  is_disabled: boolean;
  /**
   * Is Limit Per Incident
   * Whether the coverage limit applies per incident
   */
  is_limit_per_incident: boolean;
  /**
   * Is Limit Per Person
   * Whether the coverage limit applies per person
   */
  is_limit_per_person: boolean;
  /**
   * Is Limit Per Policy Per Entity
   * Whether the coverage limit applies per policy per entity
   * @default null
   */
  is_limit_per_policy_per_entity?: boolean | null;
  /**
   * Is Org Level
   * Whether the coverage applies to the whole organization
   */
  is_org_level: boolean;
  /**
   * Is Sub Reserves Config Enabled
   * Whether indemnity sub-reserves are enabled for the coverage
   */
  is_sub_reserves_config_enabled: boolean;
  /**
   * Iso Code
   * ISO code of the coverage
   * @default null
   */
  iso_code?: string | null;
  /**
   * Lob
   * Line of business the coverage belongs to
   */
  lob: string;
  /**
   * Loss Type
   * Loss type of the coverage
   */
  loss_type: string;
  /**
   * Should Include Dates Of Service
   * Whether payments on the coverage include dates of service
   * @default null
   */
  should_include_dates_of_service?: boolean | null;
  /**
   * Sub Organization External Ids
   * External IDs of the sub-organizations the coverage is linked to (empty for org-level coverages)
   */
  sub_organization_external_ids: string[];
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface CoveragesResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/**
 * CoveredEntityResponse
 * Wire format of a covered entity (see ``covered_entity_model`` in ``schemas.py``).
 *
 * ``shared_coverages_dict`` values carry the full coverage key set (mostly
 * ``None``) because the restx model nests the same ``wildcard_coverage_model``
 * for both dicts — shared coverages are *not* serialized with a narrower shape.
 */
export interface CoveredEntityResponse {
  /**
   * Coverages Dict
   * @default null
   */
  coverages_dict?: Record<
    string,
    CoveredEntityResponseCoverageResponse | null
  > | null;
  /**
   * Deductible Per Policy Per Covered Entity
   * @default null
   */
  deductible_per_policy_per_covered_entity?: number | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Limit Per Covered Entity
   * @default null
   */
  limit_per_covered_entity?: number | null;
  /**
   * Limit Per Policy Per Covered Entity
   * @default null
   */
  limit_per_policy_per_covered_entity?: number | null;
  /**
   * Shared Coverages Dict
   * @default null
   */
  shared_coverages_dict?: Record<
    string,
    CoveredEntityResponseCoverageResponse | null
  > | null;
}

/**
 * CoverageResponse
 * Wire format of a single coverage inside a covered entity.
 *
 * The field set (and the all-fields-optional tolerance) must stay in sync with
 * the flask_restx ``coverage_model`` in ``schemas.py``, which still defines the
 * wire format wherever covered entities are serialized as part of a parent
 * claim/policy schema.
 */
export interface CoveredEntityResponseCoverageResponse {
  /**
   * Coinsurance Insurer Percentage
   * @default null
   */
  coinsurance_insurer_percentage?: number | null;
  /**
   * Deductible
   * @default null
   */
  deductible?: number | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Is Covered
   * @default null
   */
  is_covered?: boolean | null;
  /**
   * Limit Per Incident
   * @default null
   */
  limit_per_incident?: number | null;
  /**
   * Limit Per Person
   * @default null
   */
  limit_per_person?: number | null;
  /**
   * Limit Per Policy Per Entity
   * @default null
   */
  limit_per_policy_per_entity?: number | null;
}

/** CoveredEntityWithParticipationsResponse */
export interface CoveredEntityWithParticipationsResponse {
  /**
   * Coverages Dict
   * @default null
   */
  coverages_dict?: Record<
    string,
    CoveredEntityWithParticipationsResponseCoverageWithParticipationsResponse | null
  > | null;
  /**
   * Deductible Per Policy Per Covered Entity
   * @default null
   */
  deductible_per_policy_per_covered_entity?: number | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Limit Per Covered Entity
   * @default null
   */
  limit_per_covered_entity?: number | null;
  /**
   * Limit Per Policy Per Covered Entity
   * @default null
   */
  limit_per_policy_per_covered_entity?: number | null;
  /**
   * Shared Coverages Dict
   * @default null
   */
  shared_coverages_dict?: Record<
    string,
    CoveredEntityWithParticipationsResponseCoverageResponse | null
  > | null;
}

/**
 * CoverageParticipationForFESchema
 * Schema for coverage participation in FE expected structure.
 *
 * Mirrors ``CoverageParticipationForFETypedDict``, built by
 * ``_get_coverage_participations_mapped_by_coverage_id``; reaches the FE
 * nested inside ``CoveredEntityWithParticipationsResponse``.
 */
export interface CoveredEntityWithParticipationsResponseCoverageParticipationForFESchema {
  /** Allocation Percentage */
  allocation_percentage: string;
  /** Capacity Slot Id */
  capacity_slot_id: string;
  /** Carrier Name */
  carrier_name: string;
  /** External Id */
  external_id: string;
  /** Is Lead */
  is_lead: boolean;
  /** Slot Name */
  slot_name: string;
}

/**
 * CoverageResponse
 * Wire format of a single coverage inside a covered entity.
 *
 * The field set (and the all-fields-optional tolerance) must stay in sync with
 * the flask_restx ``coverage_model`` in ``schemas.py``, which still defines the
 * wire format wherever covered entities are serialized as part of a parent
 * claim/policy schema.
 */
export interface CoveredEntityWithParticipationsResponseCoverageResponse {
  /**
   * Coinsurance Insurer Percentage
   * @default null
   */
  coinsurance_insurer_percentage?: number | null;
  /**
   * Deductible
   * @default null
   */
  deductible?: number | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Is Covered
   * @default null
   */
  is_covered?: boolean | null;
  /**
   * Limit Per Incident
   * @default null
   */
  limit_per_incident?: number | null;
  /**
   * Limit Per Person
   * @default null
   */
  limit_per_person?: number | null;
  /**
   * Limit Per Policy Per Entity
   * @default null
   */
  limit_per_policy_per_entity?: number | null;
}

/** CoverageWithParticipationsResponse */
export interface CoveredEntityWithParticipationsResponseCoverageWithParticipationsResponse {
  /**
   * Coinsurance Insurer Percentage
   * @default null
   */
  coinsurance_insurer_percentage?: number | null;
  /**
   * Deductible
   * @default null
   */
  deductible?: number | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Is Covered
   * @default null
   */
  is_covered?: boolean | null;
  /**
   * Limit Per Incident
   * @default null
   */
  limit_per_incident?: number | null;
  /**
   * Limit Per Person
   * @default null
   */
  limit_per_person?: number | null;
  /**
   * Limit Per Policy Per Entity
   * @default null
   */
  limit_per_policy_per_entity?: number | null;
  /**
   * Participations
   * @default null
   */
  participations?:
    | CoveredEntityWithParticipationsResponseCoverageParticipationForFESchema[]
    | null;
}

/**
 * CoveredObjectsQueryParams
 * Query parameters for the covered-objects endpoint.
 */
export interface CoveredObjectsQueryParams {
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Per Page
   * @min 1
   * @max 100
   * @default 15
   */
  per_page?: number;
  /**
   * Q
   * Substring search; accepted but ignored in NGTPA-24538, wired in NGTPA-24540.
   * @default null
   */
  q?: string | null;
  /**
   * Type
   * Covered-object type id, e.g. covered_vehicle.
   */
  type: string;
}

/**
 * CoveredObjectsResponse
 * Paginated response shape for the covered-objects endpoint.
 */
export interface CoveredObjectsResponse {
  /** Items */
  items: CoveredObjectsResponseCoveredObjectsItem[];
  /** Page */
  page: number;
  /** Per Page */
  per_page: number;
  /** Total Count */
  total_count: number;
}

/**
 * CoveredObjectsItem
 * One row in the paginated covered-objects response.
 *
 * The row payload mirrors the existing FE-facing v1 covered-object shape —
 * ``CoveredObjectForFe`` for non-auto types and ``CoveredVehicleForFe`` for
 * auto — so the FE consumes rows here the same way it consumes
 * ``claim.policy.covered_objects[i]`` / ``claim.policy.covered_vehicles[i]``
 * without re-projecting. The manager marshals the ORM row via the same
 * Flask-RESTX models the claim payload uses, and we only enrich with
 * ``is_first_party``.
 *
 * ``extra='allow'`` lets the polymorphic v1 shapes pass through without
 * forcing a Pydantic mirror of every nested field (contact, vehicle, etc.).
 */
export interface CoveredObjectsResponseCoveredObjectsItem {
  /** Id */
  id: number;
  /**
   * Is First Party
   * @default false
   */
  is_first_party?: boolean;
  [key: string]: any;
}

/** CreateAssignmentGroupParams */
export interface CreateAssignmentGroupParams {
  /** Assignment Group Key */
  assignment_group_key: string;
  /** Display Name */
  display_name: string;
  /** User Ids */
  user_ids: string[];
}

/** CreateAssignmentJsonParams */
export interface CreateAssignmentJsonParams {
  /** Assignee */
  assignee:
    | ({
        assignee_type: "internal_user";
      } & CreateAssignmentJsonParamsUserAssignee)
    | ({
        assignee_type: "service_provider";
      } & CreateAssignmentJsonParamsServiceProviderAssignee);
  /**
   * Attached Documents
   * @default []
   */
  attached_documents?: string[] | null;
  /**
   * Contacts
   * @default []
   */
  contacts?:
    | (
        | ({
            creation_mode: "";
          } & CreateAssignmentJsonParamsContactInNewParam)
        | ({
            creation_mode: "existing";
          } & CreateAssignmentJsonParamsContactInExistingParam)
        | ({
            creation_mode: "new";
          } & CreateAssignmentJsonParamsContactInNewParam)
      )[]
    | null;
  /**
   * Exposure Numbers
   * @default []
   */
  exposure_numbers?: string[] | null;
  /**
   * Inspection Due Date
   * @default null
   */
  inspection_due_date?: string | null;
  /** @default null */
  inspection_location?: CreateAssignmentJsonParamsLocationModel | null;
  /**
   * Is Claim Level
   * @default false
   */
  is_claim_level?: boolean | null;
  /** Required Method Of Inspection */
  required_method_of_inspection: string;
  /**
   * Scheduling Inspecion Contact Ref Id
   * @default null
   */
  scheduling_inspecion_contact_ref_id?: string | null;
  /**
   * Special Instructions
   * @default ""
   */
  special_instructions?: string | null;
}

/** ContactEmailModel */
export interface CreateAssignmentJsonParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface CreateAssignmentJsonParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface CreateAssignmentJsonParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CreateAssignmentJsonParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CreateAssignmentJsonParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CreateAssignmentJsonParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** LocationModel */
export interface CreateAssignmentJsonParamsLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ServiceProviderAssignee */
export interface CreateAssignmentJsonParamsServiceProviderAssignee {
  /**
   * Assignee Type
   * @default "service_provider"
   */
  assignee_type?: "service_provider";
  /** Service Provider Api Uid */
  service_provider_api_uid: string;
}

/** UserAssignee */
export interface CreateAssignmentJsonParamsUserAssignee {
  /**
   * Assignee Type
   * @default "internal_user"
   */
  assignee_type?: "internal_user";
  /** User Login Email */
  user_login_email: string;
}

/** CreateAssignmentJsonResponse */
export interface CreateAssignmentJsonResponse {
  /** Assignment Token */
  assignment_token: string;
}

/** CreateAssignmentRuleParams */
export interface CreateAssignmentRuleParams {
  /**
   * Who an assignment rule assigns to, tagged with its kind.
   *
   * ``id`` carries the target's identifier for the two kinds that reference one — a user id for
   * ``user``, an assignment-group id for ``group`` — and is ``None`` for the two sentinel kinds,
   * which name a role resolved at assignment time (``fnol_taker`` is the user who filed the FNOL;
   * ``claim_owner`` is the owner of the exposure's claim).
   *
   * The tag is the only thing that says which kind an assignee is: no consumer may re-derive it
   * from the rule's ``(method, entity)`` pair or from the type of ``id``.
   */
  assignee: CreateAssignmentRuleParamsRuleAssignee;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /** Entity */
  entity: string;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Lob */
  lob: string;
  /** Method */
  method: string;
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[];
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
}

/**
 * RuleAssignee
 * Who an assignment rule assigns to, tagged with its kind.
 *
 * ``id`` carries the target's identifier for the two kinds that reference one — a user id for
 * ``user``, an assignment-group id for ``group`` — and is ``None`` for the two sentinel kinds,
 * which name a role resolved at assignment time (``fnol_taker`` is the user who filed the FNOL;
 * ``claim_owner`` is the owner of the exposure's claim).
 *
 * The tag is the only thing that says which kind an assignee is: no consumer may re-derive it
 * from the rule's ``(method, entity)`` pair or from the type of ``id``.
 */
export interface CreateAssignmentRuleParamsRuleAssignee {
  /**
   * Id
   * @default null
   */
  id?: string | number | null;
  /** The four kinds an assignment rule's assignee can be. */
  kind: CreateAssignmentRuleParamsRuleAssigneeKind;
}

/** CreateChatRequest */
export interface CreateChatRequest {
  /**
   * Identifier
   * @default null
   */
  identifier?: string | null;
}

/**
 * CreateClaimRequest
 * Request schema for creating a Clive App claim.
 */
export interface CreateClaimRequest {
  /**
   * Claim Number
   * Claim number in the source system; must be unique within the organization, compared case-insensitively. A claim number that already exists answers 400.
   */
  claim_number: string;
  /**
   * Date Of Loss
   * Date the loss occurred. Also becomes the stub policy's effective date and expiration date, so a generated policy covers that single day.
   * @format date
   */
  date_of_loss: string;
  /**
   * Policy Number
   * Policy number to record for the claim. Generated as CLIVE_POL_<claim_number> when omitted.
   * @default null
   */
  policy_number?: string | null;
  /**
   * Reported Date
   * Date the claim was reported.
   * @format date
   */
  reported_date: string;
  /**
   * Sub Organization External Id
   * External id of the sub-organization the claim belongs to. Required when sub-organizations are enabled for the organization, and must be omitted when they are not. Omitting it where it is required answers 400 with the organization's known sub-organization external ids, which is how a caller discovers them.
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * CreateConfigVariableParams
 * Parameters for creating a new config variable definition.
 */
export interface CreateConfigVariableParams {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Required
   * @default true
   */
  is_required?: boolean;
  /**
   * Name
   * @minLength 3
   * @maxLength 128
   * @pattern ^[A-Z][A-Z0-9_]{1,126}[A-Z0-9]$
   */
  name: string;
  /**
   * Value
   * Optional initial binding value
   * @default null
   */
  value?: string | null;
  /**
   * Variable Type
   * Variable type: USER
   */
  variable_type: string;
}

/**
 * CreateCotConfigurationRequest
 * Request model for creating a new CotConfiguration.
 *
 * Note: organization_id is taken from the URL path, not the request body.
 */
export interface CreateCotConfigurationRequest {
  /** COT configuration data */
  configuration: CreateCotConfigurationRequestCotConfigurationData;
  /**
   * Cot Organization Id
   * ID of the COT (Clive on Top) organization
   */
  cot_organization_id: number;
}

/**
 * CotConfigurationData
 * Pydantic model for Clive on Top configuration data stored in JSONB field.
 *
 * This represents the structure of the 'configuration' JSON field in CotConfiguration model.
 * @example {"cot_organization_external_id":"cot_org_external_id","enabled_event_keys":["new_claim_created_event"],"is_enabled":true,"service_account_token":"secret_token_here"}
 */
export interface CreateCotConfigurationRequestCotConfigurationData {
  /**
   * Cot Organization External Id
   * External ID of the COT organization for API calls
   */
  cot_organization_external_id: string;
  /**
   * Enabled Event Keys
   * List of event keys that should trigger cross-organization communication
   */
  enabled_event_keys?: string[];
  /**
   * Is Enabled
   * Whether this COT configuration is active
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Service Account Token
   * Service account token for authentication with COT organization
   */
  service_account_token: string;
}

/** CreateESignConfigRequest */
export interface CreateESignConfigRequest {
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /** Vendor Config */
  vendor_config?: Record<string, any>;
  /** Vendor Type */
  vendor_type: "dropbox_sign";
}

/**
 * CreateExposureJsonParams
 * Opens an exposure on the claim. Each reserve opens as a total or split into its sub-reserves, not both.
 */
export interface CreateExposureJsonParams {
  /**
   * Coverage Key
   * The coverage the exposure is for, as the organization's coverages name it.
   */
  coverage_key: string;
  /**
   * Expenses Reserve
   * The expenses reserve the exposure opens with. Send this or expenses_sub_reserves.
   * @default null
   */
  expenses_reserve?: number | null;
  /**
   * Expenses Sub Reserves
   * The expenses reserve split by sub-reserve key; the reserve is their sum. Send this or expenses_reserve.
   * @default null
   */
  expenses_sub_reserves?: Record<string, number> | null;
  /**
   * Indemnity Reserve
   * The indemnity reserve the exposure opens with. Send this or indemnity_sub_reserves.
   * @default null
   */
  indemnity_reserve?: number | null;
  /**
   * Indemnity Sub Reserves
   * The indemnity reserve split by sub-reserve key; the reserve is their sum. Send this or indemnity_reserve.
   * @default null
   */
  indemnity_sub_reserves?: Record<string, number> | null;
  /**
   * Involved Api Uid
   * The involved party the exposure is for. Omit it for a coverage whose involved type is first-party unspecified: the exposure is then the insured's, with no specific involved party.
   * @default null
   */
  involved_api_uid?: string | null;
  /**
   * Use Stat Reserve Configuration
   * Open with the organization's statistical reserves instead of reserves sent with the request.
   * @default null
   */
  use_stat_reserve_configuration?: boolean | null;
}

/** CreateExposureJsonResponse */
export interface CreateExposureJsonResponse {
  /** Exposure Number */
  exposure_number: string;
}

/** CreateExternalClaimNumberParams */
export interface CreateExternalClaimNumberParams {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** External Claim Number */
  external_claim_number: string;
  /**
   * External Contact Id
   * @default null
   */
  external_contact_id?: number | null;
}

/**
 * CreateExternalClaimNumberRequest
 * Request model for creating an external claim number.
 *
 * To associate a contact, pass it in the `contacts` array (either existing or new)
 * and reference it using `external_contact_ref_id`.
 *
 * Example with existing contact:
 * {
 *     "external_claim_number": "EXT-123",
 *     "contacts": [{"creation_mode": "existing", "api_uid": "contact_abc", "ref_id": "c1"}],
 *     "external_contact_ref_id": "c1"
 * }
 *
 * Example with new contact:
 * {
 *     "external_claim_number": "EXT-123",
 *     "contacts": [{"creation_mode": "new", "ref_id": "c1", "role": "other", "first_name": "John", "last_name": "Doe"}],
 *     "external_contact_ref_id": "c1"
 * }
 */
export interface CreateExternalClaimNumberRequest {
  /**
   * Contacts
   * List of contacts to associate (new or existing)
   */
  contacts?: (
    | ({
        creation_mode: "";
      } & CreateExternalClaimNumberRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & CreateExternalClaimNumberRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & CreateExternalClaimNumberRequestContactInNewParam)
  )[];
  /**
   * Description
   * Optional description for the external claim number
   * @default null
   */
  description?: string | null;
  /**
   * External Claim Number
   * The external claim number value (required)
   * @minLength 1
   * @maxLength 128
   */
  external_claim_number: string;
  /**
   * External Contact Ref Id
   * Reference ID of the contact from the contacts list to associate
   * @default null
   */
  external_contact_ref_id?: string | null;
}

/** ContactEmailModel */
export interface CreateExternalClaimNumberRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface CreateExternalClaimNumberRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface CreateExternalClaimNumberRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CreateExternalClaimNumberRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CreateExternalClaimNumberRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CreateExternalClaimNumberRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** CreateExternalToolConfigParams */
export interface CreateExternalToolConfigParams {
  /**
   * Extra Headers
   * @default null
   */
  extra_headers?: Record<string, string> | null;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /** Payload Fields */
  payload_fields?: CreateExternalToolConfigParamsExternalToolPayloadFieldSchema[];
  /** Query Params */
  query_params?: Record<string, string>;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Tool Name
   * @minLength 1
   * @maxLength 256
   */
  tool_name: string;
  /**
   * Url
   * @minLength 1
   * @maxLength 2048
   */
  url: string;
}

/**
 * ExternalToolPayloadFieldSchema
 * CMS-native ("configured field") request-contract shape for one external-tool payload field.
 *
 * The service interface accepts these rather than fivesigma-ai's
 * ``DynamicDataFieldConfigurationSchema`` so consumers (e.g. the sysconfig API) speak CMS types
 * only and never import a fivesigma-ai type. The service dumps them to plain dicts at the
 * manager boundary, where they are validated and persisted (see
 * ``payload_fields_schema.validate_payload_fields``).
 */
export interface CreateExternalToolConfigParamsExternalToolPayloadFieldSchema {
  /** Description */
  description: string;
  /**
   * Enum Values
   * @default null
   */
  enum_values?: string[] | null;
  /**
   * The payload-field types an external tool may declare.
   *
   * Restricted to the three types the design doc allows for external-tool payloads; the
   * manager re-validates the same allow-list against the persisted fields.
   */
  field_type: CreateExternalToolConfigParamsExternalToolPayloadFieldType;
  /**
   * Is Required
   * @default null
   */
  is_required?: boolean | null;
  /** Key */
  key: string;
  /** Title */
  title: string;
}

/**
 * CreateFromSnapshotRequest
 * Request for creating organization from temporary upload.
 * @example {"email_domain_mapping":{"claims-uat.fivesigma.tech":"claims-dev.fivesigma.tech"},"target_organization_params":{"name":"New Organization"},"upload_key":"a1b2c3d4-e5f6-7890-1234-567890abcdef","users_upload_key":"b2c3d4e5-f6a7-8901-2345-678901bcdef0","variable_bindings":{"FALLBACK_USER":"admin@example.com"}}
 */
export interface CreateFromSnapshotRequest {
  /**
   * Email Domain Mapping
   * Map source email domains to target domains: {"source.com": "target.com"}. Used when importing to a different environment.
   * @default null
   */
  email_domain_mapping?: Record<string, string> | null;
  /**
   * Inline Users
   * Inline user entries for manual user import (alternative to users_upload_key)
   * @default null
   */
  inline_users?: CreateFromSnapshotRequestUserImportEntry[] | null;
  /** Parameters for new organization */
  target_organization_params: CreateFromSnapshotRequestTargetOrganizationParams;
  /**
   * Upload Key
   * Upload UUID from temporary upload
   */
  upload_key: string;
  /**
   * Users Upload Key
   * Upload key for users JSON file
   * @default null
   */
  users_upload_key?: string | null;
  /**
   * Variable Bindings
   * Bindings for config variables: {"VARIABLE_NAME": "user@example.com"}. Values are user emails that will be resolved to user IDs after users are imported.
   * @default null
   */
  variable_bindings?: Record<string, string> | null;
}

/**
 * TargetOrganizationParams
 * Parameters for overriding organization creation when importing from snapshot.
 *
 * Currently only 'name' is supported for MVP. Additional parameters can be added in future phases:
 * - organization_type: str (demo/operational)
 * - timezone: str
 * - external_id: str
 * @example {"name":"New Test Organization"}
 */
export interface CreateFromSnapshotRequestTargetOrganizationParams {
  /**
   * Name
   * Name for the new organization (must be unique)
   * @minLength 3
   * @maxLength 100
   */
  name: string;
}

/**
 * UserImportEntry
 * Schema for a single user in the users import JSON file.
 */
export interface CreateFromSnapshotRequestUserImportEntry {
  /** Email */
  email: string;
  /** First Name */
  first_name: string;
  /**
   * Is Org Level Supervisor
   * @default false
   */
  is_org_level_supervisor?: boolean;
  /**
   * Is Sys Config Editor
   * @default false
   */
  is_sys_config_editor?: boolean;
  /** Last Name */
  last_name: string;
  /** Lobs */
  lobs?: string[];
  /**
   * Mobile Phone Number
   * @default null
   */
  mobile_phone_number?: string | null;
  /**
   * Permission Profile Name
   * @default null
   */
  permission_profile_name?: string | null;
  /**
   * Phone Profile Name
   * @default null
   */
  phone_profile_name?: string | null;
  /** Role Type */
  role_type: string;
  /** Sub Organization External Ids */
  sub_organization_external_ids?: string[];
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Work Phone Number
   * @default null
   */
  work_phone_number?: string | null;
}

/**
 * CreateFromSnapshotResponse
 * Response from creating organization from snapshot.
 */
export interface CreateFromSnapshotResponse {
  /**
   * Applied Changes
   * Changes that were applied
   */
  applied_changes?: string[];
  /**
   * Applied Configurations
   * Configuration types applied
   */
  applied_configurations?: string[];
  /**
   * Errors
   * Errors during import
   */
  errors?: string[];
  /**
   * Import Snapshot Hash
   * Hash of the imported snapshot
   * @default null
   */
  import_snapshot_hash?: string | null;
  /**
   * Organization External Id
   * Created organization external ID
   * @default null
   */
  organization_external_id?: string | null;
  /**
   * Organization Id
   * Created organization ID
   * @default null
   */
  organization_id?: number | null;
  /**
   * Success
   * Whether creation was successful
   */
  success: boolean;
  /**
   * Upload Key
   * Upload key from temporary upload
   * @default null
   */
  upload_key?: string | null;
  /**
   * Result of users import if users file was provided
   * @default null
   */
  users_import_result?: CreateFromSnapshotResponseUsersImportResult | null;
  /**
   * Validation Snapshot Hash
   * Hash of validation snapshot created from imported organization
   * @default null
   */
  validation_snapshot_hash?: string | null;
  /**
   * Validation Snapshot Id
   * ID of validation snapshot created from imported organization
   * @default null
   */
  validation_snapshot_id?: number | null;
  /**
   * Warnings
   * Warnings during import
   */
  warnings?: string[];
}

/**
 * UsersImportResult
 * Result of importing users into an organization.
 */
export interface CreateFromSnapshotResponseUsersImportResult {
  /**
   * Created
   * Number of users successfully created
   */
  created: number;
  /**
   * Errors
   * Fatal errors per user
   */
  errors?: string[];
  /**
   * Total
   * Total users in the file
   */
  total: number;
  /**
   * Warnings
   * Non-fatal warnings
   */
  warnings?: string[];
}

/**
 * CreateGeneralRecoveryGroupRequest
 * One general-recovery action, divided across one or more allocations.
 *
 * The action-level facts (payee, reference, note, GST/VAT inclusion) are shared by every
 * allocation; only the payable type, recovery type and amounts differ between them.
 */
export interface CreateGeneralRecoveryGroupRequest {
  /**
   * Allocations
   * Allocations of this recovery; at least one is required. A single allocation forms no group, so the response carries a null recovery_group_id - send at least two for the rows to share one
   * @minItems 1
   */
  allocations: CreateGeneralRecoveryGroupRequestGeneralRecoveryAllocationRequest[];
  /**
   * Cap Override Reason
   * Reason to override the recovery cap when payments configuration cap_recoveries_at_total_paid is set to 'warn' and this recovery would exceed total paid
   * @default null
   */
  cap_override_reason?: string | null;
  /**
   * Check Number
   * Check number the recovery was received on
   * @default null
   */
  check_number?: string | null;
  /**
   * Contacts
   * List of contacts to associate
   */
  contacts?: (
    | ({
        creation_mode: "";
      } & CreateGeneralRecoveryGroupRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & CreateGeneralRecoveryGroupRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & CreateGeneralRecoveryGroupRequestContactInNewParam)
  )[];
  /**
   * Exposure Number
   * Exposure number for an exposure-level recovery. Omit for a claim-level recovery, which is only possible on general expenses - every allocation must then be of type 'expenses'
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the recovery amounts. Asked once per action; each allocation then carries its own vat_amount
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * Additional notes about the recovery
   * @default null
   */
  note?: string | null;
  /**
   * Recovered From Contact Ref Id
   * Reference ID of the contact from whom the recovery was received
   */
  recovered_from_contact_ref_id: string;
  /**
   * Reference
   * Reference number or identifier for the recovery
   * @default null
   */
  reference?: string | null;
}

/** ContactEmailModel */
export interface CreateGeneralRecoveryGroupRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface CreateGeneralRecoveryGroupRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface CreateGeneralRecoveryGroupRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CreateGeneralRecoveryGroupRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CreateGeneralRecoveryGroupRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CreateGeneralRecoveryGroupRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * GeneralRecoveryAllocationRequest
 * One allocation of a general-recovery action: a payable type and recovery type, and the
 * share of the action's amount that goes to them.
 */
export interface CreateGeneralRecoveryGroupRequestGeneralRecoveryAllocationRequest {
  /**
   * Amount
   * Amount allocated to this payable type and recovery type (must be positive)
   */
  amount: number;
  /**
   * General Recovery Type
   * Configured recovery type id; omit for an untyped allocation
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * Payable Type
   * Type of payable (indemnity or expenses)
   */
  payable_type: "indemnity" | "expenses";
  /**
   * Vat Amount
   * This allocation's GST/VAT amount. Required on every allocation when is_vat_included is true; may be zero, and cannot exceed the allocation amount. Must be omitted otherwise - a recovery that does not include GST/VAT carries no GST/VAT amount, so sending one (zero included) is rejected
   * @default null
   */
  vat_amount?: number | null;
}

/** CreateGeneralRecoveryRequest */
export interface CreateGeneralRecoveryRequest {
  /**
   * Amount
   * Recovery amount received (must be positive)
   * @exclusiveMin 0
   */
  amount: number;
  /**
   * Cap Override Reason
   * Reason to override the recovery cap when payments configuration cap_recoveries_at_total_paid is set to 'warn' and this recovery would exceed total paid
   * @default null
   */
  cap_override_reason?: string | null;
  /**
   * Check Number
   * Check number the recovery was received on
   * @default null
   */
  check_number?: string | null;
  /**
   * Contacts
   * List of contacts to associate
   */
  contacts?: (
    | ({
        creation_mode: "";
      } & CreateGeneralRecoveryRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & CreateGeneralRecoveryRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & CreateGeneralRecoveryRequestContactInNewParam)
  )[];
  /**
   * Exposure Number
   * Exposure number for exposure-level recovery (omit for claim-level)
   * @default null
   */
  exposure_number?: string | null;
  /**
   * General Recovery Type
   * Type of general recovery (e.g., deductible, subrogation, salvage)
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the recovery amount
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * Additional notes about the recovery
   * @default null
   */
  note?: string | null;
  /**
   * Payable Type
   * Type of payable (indemnity or expenses)
   */
  payable_type: "indemnity" | "expenses";
  /**
   * Recovered From Contact Ref Id
   * Reference ID of the contact from whom the recovery was received
   */
  recovered_from_contact_ref_id: string;
  /**
   * Reference
   * Reference number or identifier for the recovery
   * @default null
   */
  reference?: string | null;
  /**
   * Vat Amount
   * GST/VAT amount included in the recovery
   * @default null
   */
  vat_amount?: number | null;
}

/** ContactEmailModel */
export interface CreateGeneralRecoveryRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface CreateGeneralRecoveryRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface CreateGeneralRecoveryRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CreateGeneralRecoveryRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CreateGeneralRecoveryRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CreateGeneralRecoveryRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** CreateGeneralRecoveryResponse */
export interface CreateGeneralRecoveryResponse {
  /**
   * Amount
   * Recovery amount
   */
  amount: number;
  /**
   * Check Number
   * Check number the recovery was received on
   * @default null
   */
  check_number?: string | null;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Currency
   * Currency code
   */
  currency: string;
  /**
   * Exposure Number
   * Exposure number if this is an exposure-level recovery
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Id
   * Recovery amount ID
   */
  id: number;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the recovery amount
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Payable Type
   * Type of payable
   */
  payable_type: string;
  /**
   * Vat Amount
   * GST/VAT amount included in the recovery
   * @default null
   */
  vat_amount?: number | null;
}

/** CreateGenericTemplateMoiEmailRequest */
export interface CreateGenericTemplateMoiEmailRequest {
  /**
   * Applies To Moi Method Keys
   * @default []
   */
  applies_to_moi_method_keys?: string[];
  /** Body Template */
  body_template: string;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverage Keys
   * @default null
   */
  coverage_keys?: string[] | null;
  /**
   * Document Template Id
   * @default null
   */
  document_template_id?: number | null;
  /**
   * External Template Id
   * @default null
   */
  external_template_id?: string | null;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All States
   * @default null
   */
  is_all_states?: boolean | null;
  /**
   * Is All Suborgs
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /** Is Claim Level */
  is_claim_level: boolean;
  /**
   * Is Default
   * @default false
   */
  is_default?: boolean | null;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Ulid Override
   * @default null
   */
  sync_ulid_override?: string | null;
  /** Template Name */
  template_name: string;
  /** Template Type */
  template_type: string;
  /**
   * Title Template
   * @default null
   */
  title_template?: string | null;
}

/** CreateGenericTemplateRequest */
export interface CreateGenericTemplateRequest {
  /** Body Template */
  body_template: string;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverage Keys
   * @default null
   */
  coverage_keys?: string[] | null;
  /**
   * Document Template Id
   * @default null
   */
  document_template_id?: number | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /**
   * External Template Id
   * @default null
   */
  external_template_id?: string | null;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All States
   * @default null
   */
  is_all_states?: boolean | null;
  /**
   * Is All Suborgs
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /** Is Claim Level */
  is_claim_level: boolean;
  /**
   * Is Due Date Immediate
   * @default true
   */
  is_due_date_immediate?: boolean | null;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * Sections
   * The conditional sections the body wraps in `data-section-key` elements, one entry per key. Omitted: the stored sections are kept. `[]` removes every section. Without the conditional template sections feature a non-empty list is rejected and `[]` removes nothing.
   * @default null
   */
  sections?: CreateGenericTemplateRequestTemplateSectionRequest[] | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Ulid Override
   * @default null
   */
  sync_ulid_override?: string | null;
  /** Template Name */
  template_name: string;
  /** Template Type */
  template_type: string;
  /**
   * Title Template
   * @default null
   */
  title_template?: string | null;
}

/**
 * TemplateSectionRequest
 * One conditional section of the body, named by the ``data-section-key`` of the element wrapping it.
 */
export interface CreateGenericTemplateRequestTemplateSectionRequest {
  /**
   * Conditions Json
   * The condition tree. Omitted: an existing section keeps its condition. A new section needs one.
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Key
   * The ULID in the `data-section-key` attribute of the section wrapper
   */
  key: string;
  /**
   * Label
   * @minLength 1
   * @maxLength 255
   */
  label: string;
}

/**
 * CreateGlobalFieldParams
 * Body of the global-field create route.
 *
 * ``extra='forbid'`` rather than the repo's usual permissive default: spectree is configured
 * with ``validation_error_status=400``, so an unexpected field is rejected with a 400 instead
 * of being silently dropped.
 *
 * ``definition`` is the configured field minus ``id`` and ``active``: the projection supplies
 * ``id`` from ``key`` and forces ``active`` true, because a configuration may not deactivate a
 * global field and ``is_enabled`` on the row is the only switch. It is validated against the
 * repo's own ``ConfiguredField`` schema at save time (see the manager), not here, so the error
 * text a configurator sees is the same one the FNOL Configuration screen produces.
 *
 * An omitted ``position`` places the field after every field already in its (placement, anchor)
 * bucket, so a new field lands last whatever positions an earlier reorder wrote.
 */
export interface CreateGlobalFieldParams {
  /** @default "end" */
  anchor?: CreateGlobalFieldParamsGlobalFieldAnchor;
  /** Definition */
  definition: Record<string, any>;
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default true
   */
  is_all_sub_orgs?: boolean;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Key
   * @minLength 1
   * @maxLength 128
   */
  key: string;
  /** Lobs */
  lobs?: string[];
  placement: CreateGlobalFieldParamsGlobalFieldPlacement;
  /**
   * Position
   * @default null
   */
  position?: number | null;
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * CreateGlobalPolicyCategoryParams
 * Body of the global-category create route.
 *
 * ``extra='forbid'`` rather than the repo's usual permissive default: spectree is configured
 * with ``validation_error_status=400``, so an unexpected field is rejected with a 400 instead of
 * being silently dropped.
 */
export interface CreateGlobalPolicyCategoryParams {
  /** Conditions Json */
  conditions_json: Record<string, any>;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 128
   */
  display_name: string;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Key
   * @minLength 1
   * @maxLength 128
   */
  key: string;
}

/** CreateHookEndpointParams */
export interface CreateHookEndpointParams {
  /**
   * Callback Url
   * @minLength 1
   * @maxLength 2048
   */
  callback_url: string;
  /**
   * Key
   * @minLength 1
   * @maxLength 128
   * @pattern ^[a-z][a-z0-9_]*$
   */
  key: string;
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   */
  name: string;
  /**
   * Timeout Seconds
   * @min 1
   * @max 60
   * @default 10
   */
  timeout_seconds?: number;
}

/** CreateIncidentConfigurationDraftModel */
export interface CreateIncidentConfigurationDraftModel {
  /** Configuration */
  configuration: Record<string, any>;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /** Version */
  version: number;
}

/**
 * CreateIncomeProtectionDaSettingRequest
 * Request schema for creating a new Income Protection DA setting.
 */
export interface CreateIncomeProtectionDaSettingRequest {
  /**
   * Average Weekly Income
   * Average weekly income of the claimant
   */
  average_weekly_income: number | string;
  /**
   * Benefit Period Num Of Days
   * Benefit period in days
   * @min 0
   */
  benefit_period_num_of_days: number;
  /**
   * Claimant Weekly Limit
   * Maximum weekly payment limit for the claimant
   */
  claimant_weekly_limit: number | string;
  /**
   * Exposure Id
   * ID of the exposure
   */
  exposure_id: number;
  /**
   * Payee Contact Id
   * ID of the contact who will receive payments
   */
  payee_contact_id: number;
  /**
   * Payment Frequency Num Of Days
   * Payment frequency in days (e.g., 7, 14, or custom)
   * @exclusiveMin 0
   */
  payment_frequency_num_of_days: number;
  /**
   * Start Date
   * Start date of the income protection
   * @format date
   */
  start_date: string;
  /**
   * Waiting Period Num Of Days
   * Waiting period in days before payments start
   * @exclusiveMin 0
   */
  waiting_period_num_of_days: number;
  /**
   * Weekly Income Percentage
   * Percentage of weekly income to pay (0-100)
   */
  weekly_income_percentage: number | string;
  /**
   * Weekly Payment Limit
   * Maximum weekly payment limit
   */
  weekly_payment_limit: number | string;
}

/**
 * CreateIncomeProtectionMedicalRecordRequest
 * Request schema for creating a new income protection medical record.
 */
export interface CreateIncomeProtectionMedicalRecordRequest {
  /**
   * Certificate End
   * Certificate end date
   * @format date
   */
  certificate_end: string;
  /**
   * Certificate Start
   * Certificate start date
   * @format date
   */
  certificate_start: string;
  /**
   * Diagnoses
   * Diagnoses text
   */
  diagnoses: string;
  /**
   * Document Id
   * ID of the medical record document
   */
  document_id: number;
  /**
   * Medical Practitioner Contact Id
   * ID of the medical practitioner contact
   * @default null
   */
  medical_practitioner_contact_id?: number | null;
  /**
   * Rtw Date
   * Return to work date
   * @default null
   */
  rtw_date?: string | null;
}

/** CreateInvoiceRequest */
export interface CreateInvoiceRequest {
  /** Document Id */
  document_id: number;
  /** Extra */
  extra?: Record<string, any>;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /** Invoice Number */
  invoice_number: string;
  /** Line Items */
  line_items?: CreateInvoiceRequestLineItemData[];
  /**
   * Vendor
   * @default null
   */
  vendor?: string | null;
}

/** LineItemData */
export interface CreateInvoiceRequestLineItemData {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  coverage_decision: CreateInvoiceRequestCoverageDecisionOption;
  /**
   * Coverage Id
   * @default null
   */
  coverage_id?: number | null;
  /**
   * Covered Amount
   * @default null
   */
  covered_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * Is Depreciation Overridden
   * @default null
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /** @default null */
  payable_type?: CreateInvoiceRequestPayableType | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/** CreateLegalActionPayload */
export interface CreateLegalActionPayload {
  /**
   * Alternative Dispute Resolution Explored
   * @default null
   */
  alternative_dispute_resolution_explored?: string | null;
  /**
   * Alternative Dispute Resolution Text
   * @default null
   */
  alternative_dispute_resolution_text?: string | null;
  /** Complaint Allegations Summary */
  complaint_allegations_summary: string;
  /**
   * Complaint Number
   * @default null
   */
  complaint_number?: string | null;
  /**
   * Court
   * @default null
   */
  court?: string | null;
  /**
   * Date Filled In Court
   * @default null
   */
  date_filled_in_court?: string | null;
  /**
   * Dates Of Service
   * @default null
   */
  dates_of_service?:
    | CreateLegalActionPayloadLegalActionDateOfServicePayload[]
    | null;
  /** Display Name */
  display_name: string;
  /**
   * Dispute Resolution Professionals
   * @default null
   */
  dispute_resolution_professionals?:
    | CreateLegalActionPayloadDisputeResolutionProfessionalPayload[]
    | null;
  /**
   * Early Case Resolution Explored
   * @default null
   */
  early_case_resolution_explored?: string | null;
  /**
   * Exposures
   * @default null
   */
  exposures?: number[] | null;
  /** Is Claim Level */
  is_claim_level: boolean;
  /**
   * Jurisdiction State
   * @default null
   */
  jurisdiction_state?: string | null;
  /** Lawsuit Amount */
  lawsuit_amount: number;
  /**
   * Lawsuit Type
   * @default null
   */
  lawsuit_type?: string | null;
  /**
   * Legal Action Defendants
   * @default null
   */
  legal_action_defendants?:
    | CreateLegalActionPayloadLegalActionPartyPayload[]
    | null;
  /**
   * Legal Action Plaintiffs
   * @default null
   */
  legal_action_plaintiffs?:
    | CreateLegalActionPayloadLegalActionPartyPayload[]
    | null;
  /**
   * Nature Of Dispute
   * @default null
   */
  nature_of_dispute?: string | null;
  /**
   * Nature Of Dispute Text
   * @default null
   */
  nature_of_dispute_text?: string | null;
  /** Priority */
  priority: string;
  /**
   * Venue
   * @default null
   */
  venue?: string | null;
}

/** DisputeResolutionProfessionalPayload */
export interface CreateLegalActionPayloadDisputeResolutionProfessionalPayload {
  /** Contact Id */
  contact_id: number;
  /**
   * End Date
   * @default null
   */
  end_date?: string | null;
  /**
   * Start Date
   * @format date
   */
  start_date: string;
  /** Type */
  type: string;
}

/** LegalActionDateOfServicePayload */
export interface CreateLegalActionPayloadLegalActionDateOfServicePayload {
  /** Contact Id */
  contact_id: number;
  /**
   * Date Of Service
   * @format date
   */
  date_of_service: string;
  /**
   * Other Text
   * @default null
   */
  other_text?: string | null;
  /** Service Type */
  service_type: string;
}

/** LegalActionPartyPayload */
export interface CreateLegalActionPayloadLegalActionPartyPayload {
  /**
   * Contact Id
   * @default null
   */
  contact_id?: number | null;
  /**
   * Counsel Contact Id
   * @default null
   */
  counsel_contact_id?: number | null;
  /**
   * Date Of Representation
   * @default null
   */
  date_of_representation?: string | null;
  /**
   * File Number
   * @default null
   */
  file_number?: string | null;
  /**
   * Is Carrier Party
   * @default null
   */
  is_carrier_party?: boolean | null;
  /** Type */
  type: string;
}

/** CreateLevelParams */
export interface CreateLevelParams {
  /**
   * Key
   * @pattern ^[a-z][a-z0-9_]*$
   */
  key: string;
  /**
   * Snapshot of all 6 limit fields. All fields required (no None).
   * Decimal matches request/approval amount precision (Numeric(19, 4)).
   */
  limits: CreateLevelParamsLimitSnapshot;
  /** Name */
  name: string;
}

/**
 * LimitSnapshot
 * Snapshot of all 6 limit fields. All fields required (no None).
 * Decimal matches request/approval amount precision (Numeric(19, 4)).
 */
export interface CreateLevelParamsLimitSnapshot {
  /** Expenses Payments Limit */
  expenses_payments_limit: number | string;
  /** Expenses Reserves Limit */
  expenses_reserves_limit: number | string;
  /** Indemnity Payments Limit */
  indemnity_payments_limit: number | string;
  /** Indemnity Reserves Limit */
  indemnity_reserves_limit: number | string;
  /** Payments Limit */
  payments_limit: number | string;
  /** Reserves Limit */
  reserves_limit: number | string;
}

/** CreateLikeDraftQuery */
export interface CreateLikeDraftQuery {
  /** Target Lob */
  target_lob: string;
  /**
   * Target Policy Id
   * @default null
   */
  target_policy_id?: number | null;
  /**
   * Target Sub Organization Id
   * @default null
   */
  target_sub_organization_id?: number | null;
}

/** CreateLikeDraftResponse */
export interface CreateLikeDraftResponse {
  /** Draft */
  draft: Record<string, any>;
}

/**
 * CreateN8nConfigurationParams
 * Parameters for creating a new n8n configuration.
 */
export interface CreateN8NConfigurationParams {
  /**
   * Is Enabled
   * Whether the configuration is enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Timeout Seconds
   * Request timeout in seconds
   * @min 1
   * @default 30
   */
  timeout_seconds?: number;
}

/**
 * CreateNoteInput
 * Input schema for creating a note.
 */
export interface CreateNoteInput {
  /**
   * Claim Number
   * The claim number to attach the note to
   */
  claim_number: string;
  /**
   * Content
   * The content of the note
   */
  content: string;
  /**
   * Title
   * The title of the note
   */
  title: string;
}

/** CreateNoteJsonParams */
export interface CreateNoteJsonParams {
  /**
   * Exposure Numbers
   * @default ["0"]
   */
  exposure_numbers?: string[] | null;
  /**
   * Is Confidential
   * @default false
   */
  is_confidential?: boolean | null;
  /** Note */
  note: string;
  /** Title */
  title: string;
}

/** CreateNoteJsonResponse */
export interface CreateNoteJsonResponse {
  /** Api Uid */
  api_uid: string;
}

/**
 * CreateNoteResponse
 * Response schema for creating a note.
 */
export interface CreateNoteResponse {
  /**
   * Error Message
   * Error message if the note creation failed
   * @default null
   */
  error_message?: string | null;
  /**
   * Note Id
   * The ID of the created note
   * @default null
   */
  note_id?: string | null;
  /**
   * Success
   * Whether the note was created successfully
   */
  success: boolean;
}

/** CreateOrUpdatePostFnolHookBindingParams */
export interface CreateOrUpdatePostFnolHookBindingParams {
  /**
   * Hook Endpoint Key
   * @minLength 1
   */
  hook_endpoint_key: string;
  /**
   * Is Active
   * @default false
   */
  is_active?: boolean;
}

/** CreateOverrideRuleParams */
export interface CreateOverrideRuleParams {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default true
   */
  is_all_sub_orgs?: boolean;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /** Overrides */
  overrides: Record<string, CreateOverrideRuleParamsLevelOverrideLimits>;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
}

/**
 * LevelOverrideLimits
 * PATCH values for a single level inside a rule's action JSONB.
 * Null = keep level default.
 */
export interface CreateOverrideRuleParamsLevelOverrideLimits {
  /**
   * Expenses Payments Limit
   * @default null
   */
  expenses_payments_limit?: number | string | null;
  /**
   * Expenses Reserves Limit
   * @default null
   */
  expenses_reserves_limit?: number | string | null;
  /**
   * Indemnity Payments Limit
   * @default null
   */
  indemnity_payments_limit?: number | string | null;
  /**
   * Indemnity Reserves Limit
   * @default null
   */
  indemnity_reserves_limit?: number | string | null;
  /**
   * Payments Limit
   * @default null
   */
  payments_limit?: number | string | null;
  /**
   * Reserves Limit
   * @default null
   */
  reserves_limit?: number | string | null;
}

/**
 * CreatePolicyCategoryParams
 * Body of the policy-category create route.
 *
 * ``extra='forbid'`` rather than the repo's usual permissive default: spectree is
 * configured with ``validation_error_status=400``, so an unexpected field is rejected
 * with a 400 instead of being silently dropped.
 */
export interface CreatePolicyCategoryParams {
  /** Conditions Json */
  conditions_json: Record<string, any>;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 128
   */
  display_name: string;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Key
   * @minLength 1
   * @maxLength 128
   */
  key: string;
}

/**
 * CreatePredefinedPromptsResponse
 * Response after creating/updating predefined prompts.
 */
export interface CreatePredefinedPromptsResponse {
  /**
   * Message
   * Success message
   */
  message: string;
  /**
   * Prompt Id
   * UUID of the created/updated predefined prompt record
   */
  prompt_id: string;
  /**
   * Prompts Count
   * Number of prompts in the record
   */
  prompts_count: number;
}

/**
 * CreatePromotionParams
 * Create a pending promotion request from a previously previewed source→target diff.
 *
 * ``preview_token`` ties the request to the exact source+target the diff ran against (drift-free).
 * ``selected_change_ids`` is the curated subset to promote: a non-empty subset of the change ids the
 * stored preview computed. The created request and its summary reflect only those changes; selecting
 * every previewed id is equivalent to a full promotion. Ids outside the preview are rejected.
 */
export interface CreatePromotionParams {
  /** Pairing Id */
  pairing_id: number;
  /** Preview Token */
  preview_token: string;
  /**
   * Request Name
   * @minLength 1
   * @maxLength 256
   */
  request_name: string;
  /** Selected Change Ids */
  selected_change_ids: string[];
}

/** CreateRecoveryRequestParams */
export interface CreateRecoveryRequestParams {
  /**
   * Currency
   * @maxLength 20
   */
  currency: string;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * General Recovery Type
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * The reserve bucket the eventual recovery is intended for.
   *
   * The same two values ``RecoveryAmount.payable_type`` carries.
   */
  payable_type: CreateRecoveryRequestParamsRecoveryRequestPayableType;
  /** Payer Contact Id */
  payer_contact_id: number;
  /**
   * Requested Amount
   * @exclusiveMin 0
   */
  requested_amount: number;
}

/** CreateReminderJsonParams */
export interface CreateReminderJsonParams {
  /**
   * Category Key
   * @default null
   */
  category_key?: string | null;
  /**
   * Details
   * @default ""
   */
  details?: string | null;
  /**
   * Due Date
   * @default null
   */
  due_date?: string | null;
  /**
   * Due Datetime
   * @default null
   */
  due_datetime?: string | null;
  /**
   * Exposure Number
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /** Title */
  title: string;
  /**
   * User Email
   * Email of the user to assign the reminder to. Accepts either the user login email or the claims email address
   * @default null
   */
  user_email?: string | null;
}

/** CreateReminderJsonResponse */
export interface CreateReminderJsonResponse {
  /** Api Uid */
  api_uid: string;
}

/**
 * CreateReportTemplateRequest
 * Request schema for creating a new report template.
 */
export interface CreateReportTemplateRequest {
  /**
   * Gcs Path
   * GCS path from upload step
   */
  gcs_path: string;
  /**
   * Name
   * Template name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Sheets
   * Configuration for each sheet in the template
   * @minItems 1
   */
  sheets: CreateReportTemplateRequestSheetConfiguration[];
}

/**
 * SheetConfiguration
 * Configuration for a single sheet when creating a template.
 */
export interface CreateReportTemplateRequestSheetConfiguration {
  /**
   * Display Name
   * User-provided name for this sheet template
   * @minLength 1
   * @maxLength 255
   */
  display_name: string;
  /**
   * Metabase Question Id
   * ID of the Metabase question to map to this sheet
   */
  metabase_question_id: number;
  /**
   * Sheet Name
   * Original sheet name from the Excel file
   */
  sheet_name: string;
}

/** CreateSalvageRecoveryRequest */
export interface CreateSalvageRecoveryRequest {
  /**
   * Anticipated Amount
   * Anticipated salvage recovery amount
   * @default null
   */
  anticipated_amount?: number | null;
  /**
   * Contacts
   * List of contacts to associate
   */
  contacts?: (
    | ({
        creation_mode: "";
      } & CreateSalvageRecoveryRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & CreateSalvageRecoveryRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & CreateSalvageRecoveryRequestContactInNewParam)
  )[];
  /**
   * Note
   * Salvage recovery note
   * @default null
   */
  note?: string | null;
  /**
   * Salvage Parts
   * List of damaged vehicle parts (only for auto claims)
   * @default null
   */
  salvage_parts?: string[] | null;
  /**
   * Vendor Ref Id
   * Reference ID of the vendor (required for salvage)
   */
  vendor_ref_id: string;
  /**
   * Vendor Referral Number
   * Vendor referral number
   * @default null
   */
  vendor_referral_number?: string | null;
}

/** ContactEmailModel */
export interface CreateSalvageRecoveryRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface CreateSalvageRecoveryRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface CreateSalvageRecoveryRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CreateSalvageRecoveryRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CreateSalvageRecoveryRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CreateSalvageRecoveryRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** CreateScheduledReportExportRequest */
export interface CreateScheduledReportExportRequest {
  /**
   * Day Of Month
   * Day of month (1-28) — required for monthly recurrence
   * @default null
   */
  day_of_month?: number | null;
  /**
   * Display Name
   * Name for this scheduled export
   * @minLength 1
   * @maxLength 128
   */
  display_name: string;
  /**
   * End Date
   * Optional end date for the schedule
   * @default null
   */
  end_date?: string | null;
  /**
   * Export Days
   * Days of the week to run (0=Mon, 6=Sun) — required for daily recurrence
   * @default null
   */
  export_days?: ("0" | "1" | "2" | "3" | "4" | "5" | "6")[] | null;
  /**
   * Export Hour
   * Hour to run (HH:00 format, e.g., '09:00')
   * @pattern ^\d{2}:00$
   */
  export_hour: string;
  /**
   * Is Active
   * Whether the schedule is active
   * @default true
   */
  is_active?: boolean;
  /**
   * Parameters
   * Filter parameter values keyed by parameter ID
   * @default null
   */
  parameters?: Record<string, any> | null;
  /**
   * Recurrence Type
   * Schedule recurrence: daily or monthly
   * @default "daily"
   */
  recurrence_type?: "daily" | "monthly";
  /**
   * Report Template Id
   * ID of the report template to schedule
   */
  report_template_id: number;
  /** Target-specific configuration */
  target_configurations?: CreateScheduledReportExportRequestTargetConfigurations | null;
  /**
   * Target Type
   * Delivery target type
   */
  target_type: "email" | "sftp" | "s3_bucket" | "gcs_bucket";
  /**
   * User Id
   * User ID for email delivery target
   * @default null
   */
  user_id?: string | null;
}

/** GcsConfig */
export interface CreateScheduledReportExportRequestGcsConfig {
  /**
   * Bucket Name
   * GCS bucket name
   * @minLength 1
   */
  bucket_name: string;
  /**
   * Path
   * Path within the bucket
   * @minLength 1
   */
  path: string;
  /**
   * Secret Json
   * GCS service account JSON or masked placeholder
   * @minLength 1
   */
  secret_json: string;
}

/** S3Config */
export interface CreateScheduledReportExportRequestS3Config {
  /**
   * Access Key Id
   * AWS access key ID
   * @minLength 1
   */
  access_key_id: string;
  /**
   * Access Key Secret
   * AWS secret access key
   * @minLength 1
   */
  access_key_secret: string;
  /**
   * Bucket Name
   * S3 bucket name
   * @minLength 1
   */
  bucket_name: string;
  /**
   * Path
   * Path within the bucket
   * @minLength 1
   */
  path: string;
}

/** SftpConfig */
export interface CreateScheduledReportExportRequestSftpConfig {
  /**
   * Host
   * SFTP host
   * @minLength 1
   */
  host: string;
  /**
   * Password
   * SFTP password
   * @minLength 1
   */
  password: string;
  /**
   * Path
   * Remote path
   * @minLength 1
   */
  path: string;
  /**
   * Port
   * SFTP port
   * @minLength 1
   */
  port: string;
  /**
   * User
   * SFTP username
   * @minLength 1
   */
  user: string;
}

/** TargetConfigurations */
export interface CreateScheduledReportExportRequestTargetConfigurations {
  /** @default null */
  gcs_bucket?: CreateScheduledReportExportRequestGcsConfig | null;
  /** @default null */
  s3_bucket?: CreateScheduledReportExportRequestS3Config | null;
  /** @default null */
  sftp?: CreateScheduledReportExportRequestSftpConfig | null;
}

/** CreateSignatureRequestRequest */
export interface CreateSignatureRequestRequest {
  /** Contact Id */
  contact_id: number;
  /** Document Id */
  document_id: number;
  /**
   * Message
   * @default null
   */
  message?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** CreateSignatureRequestResponse */
export interface CreateSignatureRequestResponse {
  /** Sign Url */
  sign_url: string;
}

/** CreateSubrogationRecoveryRequest */
export interface CreateSubrogationRecoveryRequest {
  /**
   * Adverse Carrier Contact Ref Id
   * Reference ID of the adverse carrier contact
   * @default null
   */
  adverse_carrier_contact_ref_id?: string | null;
  /**
   * Anticipated Amount
   * Anticipated recovery amount
   * @default null
   */
  anticipated_amount?: number | null;
  /**
   * Assignee User Email
   * Email of the user to assign (required for internal_specialist_recovery). Accepts either the user login email or the claims email address
   * @default null
   */
  assignee_user_email?: string | null;
  /**
   * Assignment Type
   * Type of subrogation assignment
   */
  assignment_type: "internal_specialist_recovery" | "vendor_recovery";
  /**
   * Contacts
   * List of contacts to associate
   */
  contacts?: (
    | ({
        creation_mode: "";
      } & CreateSubrogationRecoveryRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & CreateSubrogationRecoveryRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & CreateSubrogationRecoveryRequestContactInNewParam)
  )[];
  /**
   * Note
   * Recovery note
   * @default null
   */
  note?: string | null;
  /**
   * Vendor Ref Id
   * Reference ID of the vendor (required for vendor_recovery)
   * @default null
   */
  vendor_ref_id?: string | null;
}

/** ContactEmailModel */
export interface CreateSubrogationRecoveryRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface CreateSubrogationRecoveryRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface CreateSubrogationRecoveryRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CreateSubrogationRecoveryRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CreateSubrogationRecoveryRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CreateSubrogationRecoveryRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** CreateTableauAccountParams */
export interface CreateTableauAccountParams {
  /** Site Role */
  site_role: string;
  /** User Id */
  user_id: string;
}

/** CreateUpdateCategoryResponse */
export interface CreateUpdateCategoryResponse {
  /** Id */
  id: number;
}

/** CreateUpdateCommunicationCategoryResponse */
export interface CreateUpdateCommunicationCategoryResponse {
  /** Id */
  id: number;
}

/**
 * CreateUploadPromotionParams
 * Create a pending promotion request from a previously previewed *uploaded* artifact.
 *
 * Mirrors ``CreatePromotionParams`` without ``pairing_id``: an upload promotion is target-local and
 * resolves the caller org's synthetic local pairing internally, so the caller only carries the preview
 * handoff ``preview_token`` and ``selected_change_ids`` (a non-empty subset of the previewed change ids).
 * The artifact itself was already uploaded at preview time and rides as multipart there, not here.
 */
export interface CreateUploadPromotionParams {
  /** Preview Token */
  preview_token: string;
  /**
   * Request Name
   * @minLength 1
   * @maxLength 256
   */
  request_name: string;
  /** Selected Change Ids */
  selected_change_ids: string[];
}

/**
 * CurrencyConversionErrorResponse
 * Error response model for currency conversion API.
 */
export interface CurrencyConversionErrorResponse {
  /**
   * Message
   * Error message
   */
  message: string;
}

/**
 * CustomerClaimRecordResponse
 * The claim record the Claims API returns and the new-claim webhook delivers: the claim with its applied
 * claim flags and its milestones.
 */
export interface CustomerClaimRecordResponse {
  /**
   * Claim Flag Keys
   * Keys of the flags currently applied to the claim, in configured display order. Omitted from webhook deliveries to vendor / service-provider clients, which receive the flagless claim record.
   */
  claim_flag_keys?: string[];
  /**
   * Claim Flag Labels
   * Labels of the flags currently applied to the claim, parallel to claim_flag_keys. Omitted from webhook deliveries to vendor / service-provider clients, which receive the flagless claim record.
   */
  claim_flag_labels?: string[];
  /** Claim Number */
  claim_number: string;
  /** Claim Status */
  claim_status: "open" | "closed" | "reopened";
  /**
   * Close Reason Display Name
   * @default null
   */
  close_reason_display_name?: string | null;
  /**
   * Close Reason Key
   * @default null
   */
  close_reason_key?: string | null;
  /**
   * Complexity
   * Deprecated. Use complexity_level instead
   * @default null
   */
  complexity?: string | null;
  /**
   * Complexity Level
   * Claim complexity level. One of: low, medium, high
   * @default null
   */
  complexity_level?: string | null;
  /**
   * Complexity Reason
   * Reason for the assigned complexity level
   * @default null
   */
  complexity_reason?: string | null;
  /** Contacts */
  contacts: CustomerClaimRecordResponseContactModel[];
  /** Creation Datetime */
  creation_datetime: string | null;
  /** Exposures */
  exposures?: CustomerClaimRecordResponseExposureSummaryModel[];
  /** External Claim Numbers */
  external_claim_numbers: CustomerClaimRecordResponseExternalClaimNumberExternalModel[];
  file_owner: CustomerClaimRecordResponseUserExternalAPIBaseModel | null;
  /** Fnol Handler Contact Ref Id */
  fnol_handler_contact_ref_id: string | null;
  /** Fnol Method */
  fnol_method: string | null;
  incident_details: CustomerClaimRecordResponseIncidentDetailsModel;
  /** Involved Parties */
  involved_parties?: (
    | CustomerClaimRecordResponseGenericInvolvedPersonModel
    | CustomerClaimRecordResponseInvolvedGenericPropertyModel
    | CustomerClaimRecordResponseInvolvedDriverModel
    | CustomerClaimRecordResponseInvolvedPassengerModel
    | CustomerClaimRecordResponseInvolvedNonMotoristModel
    | CustomerClaimRecordResponseInvolvedVehicleModel
    | CustomerClaimRecordResponseAutoGenericPropertyModel
  )[];
  /**
   * Is Manually Created
   * @default null
   */
  is_manually_created?: boolean | null;
  /**
   * Is Manually Filled
   * @default null
   */
  is_manually_filled?: boolean | null;
  /**
   * Legal Action Status
   * @default null
   */
  legal_action_status?: "Active" | "Closed" | null;
  /** Lob */
  lob: string;
  /**
   * Milestones
   * Every enabled milestone in the claim's line of business and sub-organization scope, in configured order, with the date the claim reached it, or null while that date is not recorded. A milestone with conditions is listed only while the claim matches them. Empty while claim milestones are not enabled for the organization.
   */
  milestones: CustomerClaimRecordResponseClaimMilestoneSummaryModel[];
  /** Policy External Id */
  policy_external_id: string | null;
  /** Policy Holder Contact Ref Id */
  policy_holder_contact_ref_id: string | null;
  /** Policy Number */
  policy_number: string;
  /** Reported Date */
  reported_date: string | null;
  /**
   * Stage Key
   * @default null
   */
  stage_key?: string | null;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
  /** Submission Mode */
  submission_mode: string | null;
}

/** AccidentFollowUpModel */
export interface CustomerClaimRecordResponseAccidentFollowUpModel {
  /**
   * Direction Ph Vehicle Was Going
   * @default null
   */
  direction_ph_vehicle_was_going?: string | null;
  /**
   * First Party Way Sign Or A Headlight
   * @default null
   */
  first_party_way_sign_or_a_headlight?: string | null;
  /**
   * Journey Purpose
   * @default null
   */
  journey_purpose?: string | null;
  /**
   * Street Condition
   * @default null
   */
  street_condition?: string | null;
  /**
   * Was Ambulance Called
   * @default null
   */
  was_ambulance_called?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Anyone Under The Influence Of Drugs Alcohol
   * @default null
   */
  was_anyone_under_the_influence_of_drugs_alcohol?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Was First Party Driver Using The Phone
   * @default null
   */
  was_first_party_driver_using_the_phone?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Weather Conditions
   * @default null
   */
  weather_conditions?: string | null;
  /**
   * Were First Party Vehicle Lights On
   * @default null
   */
  were_first_party_vehicle_lights_on?: "yes" | "no" | "na" | "unknown" | null;
}

/** AutoGenericPropertyModel */
export interface CustomerClaimRecordResponseAutoGenericPropertyModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Damages */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /** Items */
  items?: CustomerClaimRecordResponsePropertyItemIncomingModel[];
  /** @default null */
  location?: CustomerClaimRecordResponseLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** Type */
  type: "generic_involved_property";
}

/** AutoIncidentAdditionalModel */
export interface CustomerClaimRecordResponseAutoIncidentAdditionalModel {
  /** @default null */
  accident_follow_up?: CustomerClaimRecordResponseAccidentFollowUpModel | null;
  /**
   * Are Convictions Or Claims In The Last 5 Years
   * @default null
   */
  are_convictions_or_claims_in_the_last_5_years?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Convictions Or Claim Description
   * @default null
   */
  convictions_or_claim_description?: string | null;
  /**
   * Does Policyholder Second Occupation Exist
   * @default null
   */
  does_policyholder_second_occupation_exist?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /** @default null */
  fault_assessment?: CustomerClaimRecordResponseFaultAssessmentModel | null;
  /**
   * Is Policyholder Occupation Right
   * @default null
   */
  is_policyholder_occupation_right?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  police_and_fire_department?: CustomerClaimRecordResponsePoliceAndFireDepartmentModel | null;
  /**
   * Policyholder Current Occupation
   * @default null
   */
  policyholder_current_occupation?: string | null;
  /**
   * Policyholder Second Occupation
   * @default null
   */
  policyholder_second_occupation?: string | null;
  /**
   * Replacement Car Rental Date
   * @default null
   */
  replacement_car_rental_date?: string | null;
  /** @default null */
  theft_follow_up?: CustomerClaimRecordResponseTheftFollowUpModel | null;
  /**
   * Was Replacement Car Rented
   * @default null
   */
  was_replacement_car_rented?: boolean | null;
}

/** BodilyInjuryLossModel */
export interface CustomerClaimRecordResponseBodilyInjuryLossModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /** Bodily Injuries */
  bodily_injuries: CustomerClaimRecordResponseBodilyInjuryModel[];
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /** Icd Codes */
  icd_codes: CustomerClaimRecordResponseICDCodeModel[];
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface CustomerClaimRecordResponseBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/**
 * ClaimMilestoneSummaryModel
 * One of the claim's milestones and the date it was reached, null while the milestone is not recorded.
 * The shape the external Claims API lists on a claim.
 */
export interface CustomerClaimRecordResponseClaimMilestoneSummaryModel {
  /** Key */
  key: string;
  /** Label */
  label: string;
  /**
   * Occurred On
   * @default null
   */
  occurred_on?: string | null;
}

/** ContactEmailModel */
export interface CustomerClaimRecordResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface CustomerClaimRecordResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: CustomerClaimRecordResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: CustomerClaimRecordResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface CustomerClaimRecordResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ExposureSummaryModel */
export interface CustomerClaimRecordResponseExposureSummaryModel {
  /** Coverage Display Name */
  coverage_display_name: string;
  /**
   * Coverage Group Display Name
   * @default null
   */
  coverage_group_display_name?: string | null;
  /**
   * Coverage Group Key
   * @default null
   */
  coverage_group_key?: string | null;
  /** Coverage Key */
  coverage_key: string;
  /** Exposure Number */
  exposure_number: string;
  /** Exposure Status */
  exposure_status: "open" | "closed";
  /**
   * Involved Api Uid
   * @default null
   */
  involved_api_uid?: string | null;
  /**
   * Involved External Id
   * @default null
   */
  involved_external_id?: string | null;
}

/** ExternalClaimNumberExternalModel */
export interface CustomerClaimRecordResponseExternalClaimNumberExternalModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** External Claim Number */
  external_claim_number: string;
  /**
   * External Contact Ref Id
   * @default null
   */
  external_contact_ref_id?: string | null;
}

/** ExternalWitnessModel */
export interface CustomerClaimRecordResponseExternalWitnessModel {
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
}

/** FaultAssessmentModel */
export interface CustomerClaimRecordResponseFaultAssessmentModel {
  /**
   * Claim Handler Fault Assessment
   * @default null
   */
  claim_handler_fault_assessment?: string | null;
  /**
   * First Party Fault Assessment
   * @default null
   */
  first_party_fault_assessment?: string | null;
  /**
   * Is Fraud Review Needed
   * @default null
   */
  is_fraud_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Indemnity Review Needed
   * @default null
   */
  is_indemnity_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Liability Summary
   * @default null
   */
  liability_summary?: string | null;
  /**
   * Percentage Of Insured Liability
   * @default null
   */
  percentage_of_insured_liability?: string | null;
}

/** GenericInvolvedPersonModel */
export interface CustomerClaimRecordResponseGenericInvolvedPersonModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: CustomerClaimRecordResponseBodilyInjuryLossModel | null;
  /** Contact Ref Id */
  contact_ref_id: string;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: CustomerClaimRecordResponsePecuniaryLossDetailsModel | null;
  /** @default null */
  related_property_loss?: CustomerClaimRecordResponsePropertyLossWithItemsModel | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: string;
}

/** ICDCodeModel */
export interface CustomerClaimRecordResponseICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** IncidentDetailsModel */
export interface CustomerClaimRecordResponseIncidentDetailsModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** @default null */
  auto_incident_additional?: CustomerClaimRecordResponseAutoIncidentAdditionalModel | null;
  /**
   * Can Take Photos Of Damage
   * @default null
   */
  can_take_photos_of_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Cat Code
   * The catastrophe `code` of the linked cat event. Accepted as input (alternative to `cat_code_name`) and returned in responses. If both `cat_code` and `cat_code_name` are sent, they must reference the same cat.
   * @default null
   */
  cat_code?: string | null;
  /**
   * Cat Code Name
   * @default null
   */
  cat_code_name?: string | null;
  /**
   * Date Of Loss
   * @format date
   */
  date_of_loss: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Did Anyone Take Photos Or Video
   * @default null
   */
  did_anyone_take_photos_or_video?: "yes" | "no" | "na" | "unknown" | null;
  /** Incident Sub Type */
  incident_sub_type: string;
  /** Incident Type */
  incident_type: string;
  /**
   * Is Notification Only
   * @default null
   */
  is_notification_only?: boolean | null;
  /**
   * Is Other Policy Covering
   * @default null
   */
  is_other_policy_covering?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  loss_location?: CustomerClaimRecordResponseLocationModel | null;
  /**
   * Other Policy Description
   * @default null
   */
  other_policy_description?: string | null;
  /**
   * Photographer Contact Ref Id
   * @default null
   */
  photographer_contact_ref_id?: string | null;
  /**
   * Preferred Contact Ref Id
   * @default null
   */
  preferred_contact_ref_id?: string | null;
  /**
   * Reporter Contact Id
   * Required only if the field is active in the FNOL configuration for the organization.
   * @default null
   */
  reporter_contact_id?: string | null;
  /**
   * Special Internal Note
   * @default null
   */
  special_internal_note?: string | null;
  /**
   * Time Of Loss
   * Local wall-clock time of the loss (HH:MM), no timezone.
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Was Cctv Footage
   * @default null
   */
  was_cctv_footage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were There Any Witnesses
   * @default null
   */
  were_there_any_witnesses?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Witnesses
   * @default null
   */
  witnesses?: CustomerClaimRecordResponseExternalWitnessModel[] | null;
  /**
   * Witnesses Note
   * @default null
   */
  witnesses_note?: string | null;
}

/** InvolvedDriverModel */
export interface CustomerClaimRecordResponseInvolvedDriverModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Any Dvla Medical Conditions
   * @default null
   */
  any_dvla_medical_conditions?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: CustomerClaimRecordResponseBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Dvla Medical Conditions Description
   * @default null
   */
  dvla_medical_conditions_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * License Issuing State
   * @default null
   */
  license_issuing_state?: string | null;
  /**
   * License Number
   * @default null
   */
  license_number?: string | null;
  /**
   * License Type
   * @default null
   */
  license_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_driver";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Who Authorized The Driver To Drive The Vehicle
   * @default null
   */
  who_authorized_the_driver_to_drive_the_vehicle?: string | null;
  /**
   * Years Of Driving Experience
   * @default null
   */
  years_of_driving_experience?: number | null;
}

/** InvolvedGenericPropertyModel */
export interface CustomerClaimRecordResponseInvolvedGenericPropertyModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: CustomerClaimRecordResponseLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /** @default null */
  pecuniary_loss?: CustomerClaimRecordResponsePecuniaryLossDetailsModel | null;
  /** @default null */
  property_damage?: CustomerClaimRecordResponsePropertyDamageModel | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** @default null */
  related_property_loss?: CustomerClaimRecordResponsePropertyLossWithItemsModel | null;
  /** Type */
  type: string;
}

/** InvolvedNonMotoristModel */
export interface CustomerClaimRecordResponseInvolvedNonMotoristModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: CustomerClaimRecordResponseBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /** Means Of Transportation */
  means_of_transportation: string;
  /**
   * Non Motorist Type
   * @deprecated
   * @default null
   */
  non_motorist_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_non_motorist";
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedPassengerModel */
export interface CustomerClaimRecordResponseInvolvedPassengerModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: CustomerClaimRecordResponseBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Position
   * @default null
   */
  position?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_passenger";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedVehicleModel */
export interface CustomerClaimRecordResponseInvolvedVehicleModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Appraiser Contact Ref Id
   * @default null
   */
  appraiser_contact_ref_id?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Auto Repair Facility Contact Ref Id
   * @default null
   */
  auto_repair_facility_contact_ref_id?: string | null;
  /**
   * Child Seats
   * @default null
   */
  child_seats?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Covered Vehicle Id
   * @default null
   */
  covered_vehicle_id?: string | null;
  /**
   * Damage Areas
   * Areas of the vehicle that were damaged
   * @default null
   */
  damage_areas?: string[] | null;
  /**
   * Damage Description
   * @default null
   */
  damage_description?: string | null;
  /**
   * Damage Level
   * @default null
   */
  damage_level?: string | null;
  /**
   * Did Vehicle Have Previous Damage
   * @default null
   */
  did_vehicle_have_previous_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Does The Vehicle Have Any Modifications
   * @default null
   */
  does_the_vehicle_have_any_modifications?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is Car Safe To Drive
   * @default null
   */
  is_car_safe_to_drive?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Drivable
   * @default null
   */
  is_drivable?: "yes" | "no" | "na" | "unknown" | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Total Loss
   * @default null
   */
  is_total_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Tow
   * @default null
   */
  is_tow?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Active
   * @default null
   */
  is_vehicle_camera_active?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: CustomerClaimRecordResponseLocationModel | null;
  /**
   * Modification Description
   * @default null
   */
  modification_description?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Point Of Impact
   * @default null
   */
  point_of_impact?: string | null;
  /**
   * Previous Damage Description
   * @default null
   */
  previous_damage_description?: string | null;
  /**
   * Previous Damage Level
   * @default null
   */
  previous_damage_level?: string | null;
  /**
   * Scheduling Inspection Contact Ref Id
   * @default null
   */
  scheduling_inspection_contact_ref_id?: string | null;
  /**
   * Tower Contact Ref Id
   * @default null
   */
  tower_contact_ref_id?: string | null;
  /** Type */
  type: "involved_vehicle";
  /**
   * Detailed vehicle information
   * @default null
   */
  vehicle?: CustomerClaimRecordResponseVehicleDetailsModel | null;
  /**
   * Location details for the vehicle
   * @default null
   */
  vehicle_location?: CustomerClaimRecordResponseLocationModel | null;
  /**
   * Vehicle Speed
   * @default null
   */
  vehicle_speed?: string | null;
}

/** LocationModel */
export interface CustomerClaimRecordResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PecuniaryLossDetailsModel */
export interface CustomerClaimRecordResponsePecuniaryLossDetailsModel {
  /** Losses */
  losses: CustomerClaimRecordResponsePecuniaryLossItemModel[] | null;
}

/** PecuniaryLossItemModel */
export interface CustomerClaimRecordResponsePecuniaryLossItemModel {
  /** Claimed Amount */
  claimed_amount: number | null;
  /** Claimed Loss */
  claimed_loss: string | null;
  /** Display Name */
  display_name: string | null;
  /** Note */
  note: string | null;
}

/** PoliceAndFireDepartmentModel */
export interface CustomerClaimRecordResponsePoliceAndFireDepartmentModel {
  /**
   * Did Speak With Officer
   * @default null
   */
  did_speak_with_officer?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Fire Department Description
   * @default null
   */
  fire_department_description?: string | null;
  /**
   * Pending Prosecutions Or Investigations Exists
   * @default null
   */
  pending_prosecutions_or_investigations_exists?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Police Crime Reference Number
   * @default null
   */
  police_crime_reference_number?: string | null;
  /**
   * Police Department Contact Ref Id
   * @default null
   */
  police_department_contact_ref_id?: string | null;
  /**
   * Police Description
   * @default null
   */
  police_description?: string | null;
  /**
   * Police Report
   * @default null
   */
  police_report?: string | null;
  /**
   * Violation Title
   * @default null
   */
  violation_title?: string | null;
  /**
   * Was Ticket Received
   * @default null
   */
  was_ticket_received?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Any Hazardous Good Being Carried
   * @default null
   */
  were_any_hazardous_good_being_carried?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Were Fire Department Involved
   * @default null
   */
  were_fire_department_involved?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Police Involved
   * @default null
   */
  were_police_involved?: "yes" | "no" | "na" | "unknown" | null;
}

/** PropertyDamageModel */
export interface CustomerClaimRecordResponsePropertyDamageModel {
  /** Is Property Stolen */
  is_property_stolen: boolean | null;
  location: CustomerClaimRecordResponseLocationModel;
  /** Note */
  note: string | null;
  /** Property Damages */
  property_damages: string[] | null;
  /** Property Damages Description */
  property_damages_description: string | null;
}

/** PropertyItemIncomingModel */
export interface CustomerClaimRecordResponsePropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyItemOutgoingModel */
export interface CustomerClaimRecordResponsePropertyItemOutgoingModel {
  /** Category */
  category: string | null;
  /** Claimed Amount */
  claimed_amount: number | null;
  /** Description */
  description: string | null;
  /** Purchase Date */
  purchase_date: string | null;
  /** Purchase Price */
  purchase_price: number | null;
  /** Quantity */
  quantity: number | null;
  /** Scheduled */
  scheduled: string | null;
}

/** PropertyLossWithItemsModel */
export interface CustomerClaimRecordResponsePropertyLossWithItemsModel {
  /** Damages */
  damages: string[] | null;
  /** Damages Description */
  damages_description: string | null;
  /** Is Stolen */
  is_stolen: boolean | null;
  /** Items */
  items: CustomerClaimRecordResponsePropertyItemOutgoingModel[] | null;
  /** @default null */
  location?: CustomerClaimRecordResponseLocationModel | null;
  /** Note */
  note: string | null;
}

/** TheftFollowUpModel */
export interface CustomerClaimRecordResponseTheftFollowUpModel {
  /**
   * Belongings Stolen
   * @default null
   */
  belongings_stolen?: string | null;
  /**
   * Crime Reference Number
   * @default null
   */
  crime_reference_number?: string | null;
  /**
   * Current Num Of Keys
   * @default null
   */
  current_num_of_keys?: number | null;
  /**
   * Date Noticed Vehicle Missing
   * @default null
   */
  date_noticed_vehicle_missing?: string | null;
  /**
   * Date Vehicle Last Seen
   * @default null
   */
  date_vehicle_last_seen?: string | null;
  /**
   * Discovered The Loss Contact Ref Id
   * @default null
   */
  discovered_the_loss_contact_ref_id?: string | null;
  /**
   * Is Vehicle For Sale
   * @default null
   */
  is_vehicle_for_sale?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  keys_location?: CustomerClaimRecordResponseLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Num Of Keys Received On Purchase
   * @default null
   */
  num_of_keys_received_on_purchase?: number | null;
  /**
   * Person Liable For The Theft Is Known
   * @default null
   */
  person_liable_for_the_theft_is_known?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Security Devices Description
   * @default null
   */
  security_devices_description?: string | null;
  /**
   * Time Noticed Vehicle Missing
   * @default null
   */
  time_noticed_vehicle_missing?: string | null;
  /**
   * Time Vehicle Last Seen
   * @default null
   */
  time_vehicle_last_seen?: string | null;
  /**
   * Tracking Devices Description
   * @default null
   */
  tracking_devices_description?: string | null;
  /**
   * Vehicle Fitted With Security Devices
   * @default null
   */
  vehicle_fitted_with_security_devices?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Vehicle Fitted With Tracking Devices
   * @default null
   */
  vehicle_fitted_with_tracking_devices?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  vehicle_last_seen_location?: CustomerClaimRecordResponseLocationModel | null;
  /**
   * Vehicle Windows Closed And Secured
   * @default null
   */
  vehicle_windows_closed_and_secured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Vehicle Found With Keys
   * @default null
   */
  was_vehicle_found_with_keys?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Belongings Stolen From Vehicle
   * @default null
   */
  were_belongings_stolen_from_vehicle?: "yes" | "no" | "na" | "unknown" | null;
}

/** UserExternalAPIBaseModel */
export interface CustomerClaimRecordResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** VehicleDetailsModel */
export interface CustomerClaimRecordResponseVehicleDetailsModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Claim Free Years
   * @default null
   */
  claim_free_years?: number | null;
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Engine Capacity
   * @default null
   */
  engine_capacity?: number | null;
  /**
   * Engine Type
   * @default null
   */
  engine_type?: string | null;
  /**
   * Existing Damage
   * @default null
   */
  existing_damage?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Fuel Type
   * @default null
   */
  fuel_type?: string | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: boolean | null;
  /**
   * Make
   * @default null
   */
  make?: string | null;
  /**
   * Make Ncic Code
   * NCIC code for the vehicle make
   * @default null
   */
  make_ncic_code?: string | null;
  /**
   * Mileage
   * @default null
   */
  mileage?: number | null;
  /**
   * Model
   * @default null
   */
  model?: string | null;
  /**
   * Number Of Seats
   * @default null
   */
  number_of_seats?: number | null;
  /**
   * Ownership Status
   * @default null
   */
  ownership_status?: string | null;
  /**
   * Plate Number
   * @default null
   */
  plate_number?: string | null;
  /**
   * Series
   * @default null
   */
  series?: string | null;
  /**
   * Vehicle Cost New
   * @default null
   */
  vehicle_cost_new?: number | null;
  /**
   * Vehicle Owner Contact Ref Id
   * @default null
   */
  vehicle_owner_contact_ref_id?: string | null;
  /**
   * Vehicle Plate State
   * @default null
   */
  vehicle_plate_state?: string | null;
  /**
   * Vehicle Type
   * @default null
   */
  vehicle_type?: string | null;
  /**
   * Vehicle Use
   * @default null
   */
  vehicle_use?: string | null;
  /**
   * Vehicle Value
   * @default null
   */
  vehicle_value?: number | null;
  /**
   * Vehicle Weight
   * @default null
   */
  vehicle_weight?: number | null;
  /**
   * Vin
   * Vehicle Identification Number
   * @default null
   */
  vin?: string | null;
  /**
   * Year
   * @default null
   */
  year?: number | null;
}

/**
 * DAConfigInfo
 * Returned by get_config. Bundles DA's own flag with the org-level split/level
 * settings FE needs to render limit inputs.
 */
export interface DAConfigInfo {
  /** Are Payment Limits Split */
  are_payment_limits_split: boolean;
  /** Enabled */
  enabled: boolean;
  /** Payment Limits Level */
  payment_limits_level: "claim" | "exposure";
  /**
   * Round Robin Approver Selection Enabled
   * @default true
   */
  round_robin_approver_selection_enabled?: boolean;
}

/** DATypeConfigCreateParams */
export interface DATypeConfigCreateParams {
  /** @default {"allowed_payable_types":null,"enable_currency_conversion":true,"enable_depreciation":false,"enable_make_payment":true,"predefined_fields":{"coverage_decision":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"},"covered_amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"explanation":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"payable_type":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"}},"subtotal_includes_expenses":false} */
  config?: DATypeConfigCreateParamsDamageAssessmentConfigSchema;
  /** Display Name */
  display_name: string;
  /** Key */
  key: string;
}

/** AssessmentPredefinedFields */
export interface DATypeConfigCreateParamsAssessmentPredefinedFields {
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"} */
  coverage_decision?: DATypeConfigCreateParamsSelectPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  covered_amount?: DATypeConfigCreateParamsMonetaryPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  explanation?: DATypeConfigCreateParamsStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"} */
  payable_type?: DATypeConfigCreateParamsSelectPredefinedField;
}

/** DamageAssessmentConfigSchema */
export interface DATypeConfigCreateParamsDamageAssessmentConfigSchema {
  /** @default null */
  allowed_payable_types?: DATypeConfigCreateParamsAllowedPayableTypes | null;
  /**
   * Enable Currency Conversion
   * @default true
   */
  enable_currency_conversion?: boolean;
  /**
   * Enable Depreciation
   * @default false
   */
  enable_depreciation?: boolean;
  /**
   * Enable Make Payment
   * @default true
   */
  enable_make_payment?: boolean;
  /** @default {"coverage_decision":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"},"covered_amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"explanation":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"payable_type":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"}} */
  predefined_fields?: DATypeConfigCreateParamsAssessmentPredefinedFields;
  /**
   * Subtotal Includes Expenses
   * @default false
   */
  subtotal_includes_expenses?: boolean;
}

/** MonetaryPredefinedField */
export interface DATypeConfigCreateParamsMonetaryPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "monetary";
}

/** PredefinedFieldSelectOption */
export interface DATypeConfigCreateParamsPredefinedFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/** SelectPredefinedField */
export interface DATypeConfigCreateParamsSelectPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /**
   * Options
   * @default null
   */
  options?: DATypeConfigCreateParamsPredefinedFieldSelectOption[] | null;
  /** Type */
  type: "select";
}

/** StringPredefinedField */
export interface DATypeConfigCreateParamsStringPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "string";
}

/** DATypeConfigInfo */
export interface DATypeConfigInfo {
  config: DATypeConfigInfoDamageAssessmentConfigSchema;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Disabled */
  is_disabled: boolean;
  /** Key */
  key: string;
  /** Organization Id */
  organization_id: number;
}

/** AssessmentPredefinedFields */
export interface DATypeConfigInfoAssessmentPredefinedFields {
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"} */
  coverage_decision?: DATypeConfigInfoSelectPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  covered_amount?: DATypeConfigInfoMonetaryPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  explanation?: DATypeConfigInfoStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"} */
  payable_type?: DATypeConfigInfoSelectPredefinedField;
}

/** DamageAssessmentConfigSchema */
export interface DATypeConfigInfoDamageAssessmentConfigSchema {
  /** @default null */
  allowed_payable_types?: DATypeConfigInfoAllowedPayableTypes | null;
  /**
   * Enable Currency Conversion
   * @default true
   */
  enable_currency_conversion?: boolean;
  /**
   * Enable Depreciation
   * @default false
   */
  enable_depreciation?: boolean;
  /**
   * Enable Make Payment
   * @default true
   */
  enable_make_payment?: boolean;
  /** @default {"coverage_decision":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"},"covered_amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"explanation":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"payable_type":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"}} */
  predefined_fields?: DATypeConfigInfoAssessmentPredefinedFields;
  /**
   * Subtotal Includes Expenses
   * @default false
   */
  subtotal_includes_expenses?: boolean;
}

/** MonetaryPredefinedField */
export interface DATypeConfigInfoMonetaryPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "monetary";
}

/** PredefinedFieldSelectOption */
export interface DATypeConfigInfoPredefinedFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/** SelectPredefinedField */
export interface DATypeConfigInfoSelectPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /**
   * Options
   * @default null
   */
  options?: DATypeConfigInfoPredefinedFieldSelectOption[] | null;
  /** Type */
  type: "select";
}

/** StringPredefinedField */
export interface DATypeConfigInfoStringPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "string";
}

/** DATypeConfigInfoList */
export type DATypeConfigInfoList = DATypeConfigInfoListDATypeConfigInfo[];

/** AssessmentPredefinedFields */
export interface DATypeConfigInfoListAssessmentPredefinedFields {
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"} */
  coverage_decision?: DATypeConfigInfoListSelectPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  covered_amount?: DATypeConfigInfoListMonetaryPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  explanation?: DATypeConfigInfoListStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"} */
  payable_type?: DATypeConfigInfoListSelectPredefinedField;
}

/** DATypeConfigInfo */
export interface DATypeConfigInfoListDATypeConfigInfo {
  config: DATypeConfigInfoListDamageAssessmentConfigSchema;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Disabled */
  is_disabled: boolean;
  /** Key */
  key: string;
  /** Organization Id */
  organization_id: number;
}

/** DamageAssessmentConfigSchema */
export interface DATypeConfigInfoListDamageAssessmentConfigSchema {
  /** @default null */
  allowed_payable_types?: DATypeConfigInfoListAllowedPayableTypes | null;
  /**
   * Enable Currency Conversion
   * @default true
   */
  enable_currency_conversion?: boolean;
  /**
   * Enable Depreciation
   * @default false
   */
  enable_depreciation?: boolean;
  /**
   * Enable Make Payment
   * @default true
   */
  enable_make_payment?: boolean;
  /** @default {"coverage_decision":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"},"covered_amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"explanation":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"payable_type":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"}} */
  predefined_fields?: DATypeConfigInfoListAssessmentPredefinedFields;
  /**
   * Subtotal Includes Expenses
   * @default false
   */
  subtotal_includes_expenses?: boolean;
}

/** MonetaryPredefinedField */
export interface DATypeConfigInfoListMonetaryPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "monetary";
}

/** PredefinedFieldSelectOption */
export interface DATypeConfigInfoListPredefinedFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/** SelectPredefinedField */
export interface DATypeConfigInfoListSelectPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /**
   * Options
   * @default null
   */
  options?: DATypeConfigInfoListPredefinedFieldSelectOption[] | null;
  /** Type */
  type: "select";
}

/** StringPredefinedField */
export interface DATypeConfigInfoListStringPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "string";
}

/** DATypeConfigUpdateParams */
export interface DATypeConfigUpdateParams {
  /** @default null */
  config?: DATypeConfigUpdateParamsDamageAssessmentConfigSchema | null;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
}

/** AssessmentPredefinedFields */
export interface DATypeConfigUpdateParamsAssessmentPredefinedFields {
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"} */
  coverage_decision?: DATypeConfigUpdateParamsSelectPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  covered_amount?: DATypeConfigUpdateParamsMonetaryPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  explanation?: DATypeConfigUpdateParamsStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"} */
  payable_type?: DATypeConfigUpdateParamsSelectPredefinedField;
}

/** DamageAssessmentConfigSchema */
export interface DATypeConfigUpdateParamsDamageAssessmentConfigSchema {
  /** @default null */
  allowed_payable_types?: DATypeConfigUpdateParamsAllowedPayableTypes | null;
  /**
   * Enable Currency Conversion
   * @default true
   */
  enable_currency_conversion?: boolean;
  /**
   * Enable Depreciation
   * @default false
   */
  enable_depreciation?: boolean;
  /**
   * Enable Make Payment
   * @default true
   */
  enable_make_payment?: boolean;
  /** @default {"coverage_decision":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Coverage Decision","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"},"covered_amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Covered Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"explanation":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Explanation","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"payable_type":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Payable Type","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"options":null,"type":"select"}} */
  predefined_fields?: DATypeConfigUpdateParamsAssessmentPredefinedFields;
  /**
   * Subtotal Includes Expenses
   * @default false
   */
  subtotal_includes_expenses?: boolean;
}

/** MonetaryPredefinedField */
export interface DATypeConfigUpdateParamsMonetaryPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "monetary";
}

/** PredefinedFieldSelectOption */
export interface DATypeConfigUpdateParamsPredefinedFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/** SelectPredefinedField */
export interface DATypeConfigUpdateParamsSelectPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /**
   * Options
   * @default null
   */
  options?: DATypeConfigUpdateParamsPredefinedFieldSelectOption[] | null;
  /** Type */
  type: "select";
}

/** StringPredefinedField */
export interface DATypeConfigUpdateParamsStringPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "string";
}

/**
 * DaSettingExternalResponse
 * Full DA setting response for external API.
 */
export interface DaSettingExternalResponse {
  /**
   * Average Weekly Income
   * Claimant's average weekly income
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  average_weekly_income: string;
  /**
   * Benefit Period Num Of Days
   * Total benefit period in days
   */
  benefit_period_num_of_days: number;
  /**
   * Certificate Expiry Date
   * Latest medical certificate expiry date
   * @default null
   */
  certificate_expiry_date?: string | null;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Claimant Weekly Limit
   * Claimant's weekly limit cap
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  claimant_weekly_limit: string;
  /**
   * Contacts
   * List of contacts referenced in this response
   */
  contacts?: DaSettingExternalResponseContactModel[];
  /**
   * Exposure Label
   * Exposure label
   */
  exposure_label: string;
  /**
   * Last Payment End Date
   * End date of the most recent payment
   * @default null
   */
  last_payment_end_date?: string | null;
  /**
   * Payee Contact Ref Id
   * Reference ID of the payee contact in the contacts list
   */
  payee_contact_ref_id: string;
  /**
   * Payment Frequency Num Of Days
   * Payment frequency in days
   */
  payment_frequency_num_of_days: number;
  /**
   * Start Date
   * Income protection start date
   * @format date
   */
  start_date: string;
  /**
   * Total Incurred
   * Total incurred on exposure
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  total_incurred: string;
  /**
   * Total Paid
   * Total amount paid on exposure
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  total_paid: string;
  /**
   * Waiting Period End Date
   * End date of the waiting period (start_date - 1 day)
   * @format date
   */
  waiting_period_end_date: string;
  /**
   * Waiting Period Num Of Days
   * Waiting period in days before payments start
   */
  waiting_period_num_of_days: number;
  /**
   * Waiting Period Start Date
   * Start date of the waiting period (start_date - waiting_period_num_of_days)
   * @format date
   */
  waiting_period_start_date: string;
  /**
   * Weekly Income Percentage
   * Percentage of income to pay (0-100)
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  weekly_income_percentage: string;
  /**
   * Weekly Payment Limit
   * Maximum weekly payment limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  weekly_payment_limit: string;
}

/** ContactEmailModel */
export interface DaSettingExternalResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface DaSettingExternalResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: DaSettingExternalResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: DaSettingExternalResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface DaSettingExternalResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** DamageAssessmentJsonParams */
export interface DamageAssessmentJsonParams {
  /** Amount */
  amount: number;
  /** Estimation Reports Api Uids */
  estimation_reports_api_uids: string[];
  /** Inspection Date */
  inspection_date: string;
  /** Note */
  note: string;
}

/** DamageAssessmentResponse */
export interface DamageAssessmentResponse {
  /** Success */
  success: boolean;
}

/** DataImportGetSchemaParams */
export interface DataImportGetSchemaParams {
  additional_configurations: DataImportGetSchemaParamsDataImportConfig;
}

/** DataImportConfig */
export interface DataImportGetSchemaParamsDataImportConfig {
  /**
   * Should Generate Claim Numbers
   * @default true
   */
  should_generate_claim_numbers?: boolean;
}

/** DataImportLoadParams */
export interface DataImportLoadParams {
  additional_configurations: DataImportLoadParamsDataImportConfig;
  /** Import Dir Path */
  import_dir_path: string;
  import_dir_path_type: DataImportLoadParamsDataImportDirPathType;
  /** Organization External Id */
  organization_external_id: string;
}

/** DataImportConfig */
export interface DataImportLoadParamsDataImportConfig {
  /**
   * Should Generate Claim Numbers
   * @default true
   */
  should_generate_claim_numbers?: boolean;
}

/** DataImportResponse */
export interface DataImportResponse {
  /** Log Messages */
  log_messages: string[];
}

/**
 * DeactivateContactRequest
 * Payload for deactivating (soft-deleting) a contact.
 */
export interface DeactivateContactRequest {
  /** Reason */
  reason: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
}

/** DeleteAssignmentGroupParams */
export interface DeleteAssignmentGroupParams {
  /**
   * Deleterules
   * @default false
   */
  deleteRules?: boolean;
}

/**
 * DeleteConfigurationResponse
 * Response schema for delete operation.
 */
export interface DeleteConfigurationResponse {
  /**
   * Success
   * Indicates successful deletion
   * @default true
   */
  success?: boolean;
}

/** DeleteDocumentRequest */
export interface DeleteDocumentRequest {
  /** Remove Reason */
  remove_reason: string;
}

/**
 * DeployChangeRequestPayload
 * Request payload for deploying a change request.
 */
export interface DeployChangeRequestPayload {
  /**
   * Force On Drift
   * Deploy even if drift is detected
   * @default false
   */
  force_on_drift?: boolean;
}

/** DiffRequest */
export interface DiffRequest {
  /** Export Data */
  export_data: Record<string, any>;
}

/** DiffResponse */
export interface DiffResponse {
  changeset: DiffResponseChangeSet;
}

/** ChangeFieldPath */
export interface DiffResponseChangeFieldPath {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Custom Field
   * @default null
   */
  custom_field?: string | null;
  /**
   * Display Label
   * @default null
   */
  display_label?: string | null;
  /**
   * Field Id
   * @default null
   */
  field_id?: string | null;
  /**
   * Identity Key
   * @default null
   */
  identity_key?: string | null;
  /**
   * Parent Path
   * @default null
   */
  parent_path?: string | null;
  /** Path */
  path: string;
}

/**
 * ChangeScope
 * The LOBs / sub-organizations a change is attributed to, derived from the item schema's
 * ``__scope_refs__`` (see diff_engine). Drives the promotion UI's scope filter.
 *
 * An empty list for a dimension means the change is not scoped to specific members of that dimension —
 * either it applies to all of them (an ``is_all_*`` flag was set) or it carries no such reference. The
 * filter treats such a change as its own **"Global"** bucket, fail-closed: it does NOT match a
 * specific-member selection and is hidden under one; it surfaces only when the explicit "Global" facet
 * option is selected. This mirrors the frontend ``matchesFacet`` (promotionScope.ts) and the
 * ``_compute_change_scope`` docstring — the contract other adapters opting into scope refs read.
 */
export interface DiffResponseChangeScope {
  /** Lobs */
  lobs?: string[];
  /** Sub Organizations */
  sub_organizations?: string[];
}

/** ChangeSet */
export interface DiffResponseChangeSet {
  /** @default null */
  export_metadata?: DiffResponseExportMetadata | null;
  /**
   * Generated At
   * @format date-time
   */
  generated_at?: string;
  /** Items */
  items?: DiffResponseConfigurationChangeV2[];
  /** Summary */
  summary?: Record<string, any>;
}

/**
 * ConfigurationChangeV2
 * v2: Pure diff output — describes what should change, not execution state.
 *
 * Immutable after construction. Execution metadata (transaction_id, user_id,
 * applied_at) lives on the audit record, not the change.
 */
export interface DiffResponseConfigurationChangeV2 {
  /**
   * After Value
   * @default null
   */
  after_value?: null;
  /**
   * Before Value
   * @default null
   */
  before_value?: null;
  /** Change Id */
  change_id: string;
  change_type: DiffResponseChangeType;
  /** Change Uuid */
  change_uuid?: string;
  /** Configuration Type */
  configuration_type: string;
  /**
   * Configuration Type Change Version
   * @default 2
   */
  configuration_type_change_version?: 2;
  field_path: DiffResponseChangeFieldPath;
  /** Key Labels */
  key_labels?: Record<string, string>;
  /** Object Changes */
  object_changes?: DiffResponseObjectChange[];
  /** Object Desc */
  object_desc: string;
  /**
   * The LOBs / sub-organizations a change is attributed to, derived from the item schema's
   * ``__scope_refs__`` (see diff_engine). Drives the promotion UI's scope filter.
   *
   * An empty list for a dimension means the change is not scoped to specific members of that dimension —
   * either it applies to all of them (an ``is_all_*`` flag was set) or it carries no such reference. The
   * filter treats such a change as its own **"Global"** bucket, fail-closed: it does NOT match a
   * specific-member selection and is hidden under one; it surfaces only when the explicit "Global" facet
   * option is selected. This mirrors the frontend ``matchesFacet`` (promotionScope.ts) and the
   * ``_compute_change_scope`` docstring — the contract other adapters opting into scope refs read.
   */
  pruned?: DiffResponseChangeScope;
  /** Resolved After Value */
  resolved_after_value?: string[];
  /**
   * The LOBs / sub-organizations a change is attributed to, derived from the item schema's
   * ``__scope_refs__`` (see diff_engine). Drives the promotion UI's scope filter.
   *
   * An empty list for a dimension means the change is not scoped to specific members of that dimension —
   * either it applies to all of them (an ``is_all_*`` flag was set) or it carries no such reference. The
   * filter treats such a change as its own **"Global"** bucket, fail-closed: it does NOT match a
   * specific-member selection and is hidden under one; it surfaces only when the explicit "Global" facet
   * option is selected. This mirrors the frontend ``matchesFacet`` (promotionScope.ts) and the
   * ``_compute_change_scope`` docstring — the contract other adapters opting into scope refs read.
   */
  scope?: DiffResponseChangeScope;
  /** Warnings */
  warnings?: string[];
}

/**
 * ExportMetadata
 * Standardized metadata for all configuration exports.
 *
 * This schema ensures consistent metadata structure across all config repository adapters.
 */
export interface DiffResponseExportMetadata {
  /**
   * Config Repo Adapter Specific
   * Config-repository-adapter-specific metadata (counts, flags, etc.)
   */
  config_repo_adapter_specific?: Record<string, any> | null;
  /**
   * Config Repo Adapter Version
   * Semantic version of the config repository adapter
   * @pattern ^\d+\.\d+\.\d+$
   */
  config_repo_adapter_version: string;
  /**
   * Export Timestamp
   * ISO 8601 timestamp when export was created
   * @format date-time
   */
  export_timestamp: string;
  /**
   * Source Organization External Id
   * External ID of the source organization
   */
  source_organization_external_id: string;
}

/**
 * ObjectChange
 * Individual object change with key, description, and value changes.
 */
export interface DiffResponseObjectChange {
  /** Desc */
  desc: string;
  /** Key */
  key: string;
  /** New Value */
  new_value: any;
  /** Old Value */
  old_value: any;
}

/** DismissNotificationParams */
export interface DismissNotificationParams {
  /** Notification Api Uids */
  notification_api_uids: string[];
}

/** DismissNotificationsResponse */
export interface DismissNotificationsResponse {
  /** Results */
  results: DismissNotificationsResponseDismissNotificationResult[];
}

/** DismissNotificationResult */
export interface DismissNotificationsResponseDismissNotificationResult {
  /**
   * Error
   * @default null
   */
  error?: string | null;
  /** Notification Api Uid */
  notification_api_uid: string;
  /** Success */
  success: boolean;
}

/** DisputeResolutionProfessionalPayload */
export interface DisputeResolutionProfessionalPayload {
  /** Contact Id */
  contact_id: number;
  /**
   * End Date
   * @default null
   */
  end_date?: string | null;
  /**
   * Start Date
   * @format date
   */
  start_date: string;
  /** Type */
  type: string;
}

/**
 * DocumentAiConfigsQuery
 * The query of the document_signals and document_analyzers claim resources.
 */
export interface DocumentAiConfigsQuery {
  /** Claim Number */
  claim_number: string;
}

/**
 * DocumentRequestConfigurationInfo
 * What the sysconfig card renders.
 *
 * ``is_available`` false means the app could not be read: ``branding`` is then null and
 * ``unavailable_message`` says why. Absent configuration is ``is_available`` true with every
 * ``branding`` field null -- the two states never share a shape. ``share_templates`` is CMS's own and
 * is always set, whether or not the app could be read.
 */
export interface DocumentRequestConfigurationInfo {
  branding: DocumentRequestConfigurationInfoDocumentRequestUploadPageBrandingInfo | null;
  /** Is Available */
  is_available: boolean;
  /** The limits the server enforces on a logo, sent so the card checks against the same values. */
  logo_constraints: DocumentRequestConfigurationInfoDocumentRequestLogoConstraintsInfo;
  /** The SMS, email title and email body a document-request link is shared with. */
  share_templates: DocumentRequestConfigurationInfoDocumentRequestShareTemplatesInfo;
  /** Unavailable Message */
  unavailable_message: string | null;
}

/**
 * DocumentRequestLogoConstraintsInfo
 * The limits the server enforces on a logo, sent so the card checks against the same values.
 */
export interface DocumentRequestConfigurationInfoDocumentRequestLogoConstraintsInfo {
  /** Allowed Content Types */
  allowed_content_types: string[];
  /** Max Bytes */
  max_bytes: number;
}

/**
 * DocumentRequestShareTemplateInfo
 * One share-message template: the mention-token HTML in effect, and whether it is the packaged default.
 */
export interface DocumentRequestConfigurationInfoDocumentRequestShareTemplateInfo {
  /** Is Default */
  is_default: boolean;
  /** Template */
  template: string;
}

/**
 * DocumentRequestShareTemplatesInfo
 * The SMS, email title and email body a document-request link is shared with.
 */
export interface DocumentRequestConfigurationInfoDocumentRequestShareTemplatesInfo {
  /** One share-message template: the mention-token HTML in effect, and whether it is the packaged default. */
  email_body: DocumentRequestConfigurationInfoDocumentRequestShareTemplateInfo;
  /** One share-message template: the mention-token HTML in effect, and whether it is the packaged default. */
  email_title: DocumentRequestConfigurationInfoDocumentRequestShareTemplateInfo;
  /** One share-message template: the mention-token HTML in effect, and whether it is the packaged default. */
  sms: DocumentRequestConfigurationInfoDocumentRequestShareTemplateInfo;
}

/**
 * DocumentRequestUploadPageBrandingInfo
 * An organization's upload-page branding as the app stores it.
 *
 * Every field null means the app renders its packaged default for it.
 */
export interface DocumentRequestConfigurationInfoDocumentRequestUploadPageBrandingInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Logo Data Uri
   * @default null
   */
  logo_data_uri?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * DocumentRequestDTO
 * One link on a claim, with its expiry derived at read time.
 *
 * ``is_expired`` is true only for a link still ``PENDING`` past ``expires_at``: an uploading,
 * submitted or cancelled link is spent, not expired. ``url`` is null once the link is spent or
 * lapsed -- it is a bearer credential, re-displayed only while someone could still use it.
 */
export interface DocumentRequestDTO {
  /** Created By User Id */
  created_by_user_id: string;
  /**
   * Expires At
   * @format date-time
   */
  expires_at: string;
  /** Files */
  files?: DocumentRequestDTODocumentRequestFileDTO[];
  /** Id */
  id: number;
  /** Is Expired */
  is_expired: boolean;
  /**
   * The CMS mirror of the link's lifecycle.
   *
   * ``UPLOADING`` is what the app's ``signed-urls`` reports when the claimant presses "Upload and send".
   * The report is best-effort, so a link can also go straight from ``PENDING`` to ``SUBMITTED``.
   * ``CANCELLED`` is CMS's record of the app's ``revoked``, written only after the app confirmed the
   * revoke.
   */
  status: DocumentRequestDTODocumentRequestStatus;
  /**
   * Submitted At
   * @default null
   */
  submitted_at?: string | null;
  /**
   * Url
   * @default null
   */
  url?: string | null;
}

/**
 * DocumentRequestFileDTO
 * One uploaded file as the claim page lists it. No object path: the review URL is minted on demand.
 */
export interface DocumentRequestDTODocumentRequestFileDTO {
  /**
   * Attached Document Id
   * @default null
   */
  attached_document_id?: number | null;
  /** Content Type */
  content_type: string;
  /** Name */
  name: string;
  /**
   * The malware-scan verdict per uploaded file. ``ERROR`` blocks, exactly like ``SUSPICIOUS``.
   *
   * This path fails closed: a scan that errored is never treated as clean, and the recovery is a
   * rescan rather than an override.
   */
  scan_state: DocumentRequestDTODocumentRequestFileScanState;
  /** Size */
  size: number;
  /** Uploaded File Id */
  uploaded_file_id: string;
}

/** DocumentRequestListResponse */
export interface DocumentRequestListResponse {
  /** Document Requests */
  document_requests: DocumentRequestListResponseDocumentRequestDTO[];
}

/**
 * DocumentRequestDTO
 * One link on a claim, with its expiry derived at read time.
 *
 * ``is_expired`` is true only for a link still ``PENDING`` past ``expires_at``: an uploading,
 * submitted or cancelled link is spent, not expired. ``url`` is null once the link is spent or
 * lapsed -- it is a bearer credential, re-displayed only while someone could still use it.
 */
export interface DocumentRequestListResponseDocumentRequestDTO {
  /** Created By User Id */
  created_by_user_id: string;
  /**
   * Expires At
   * @format date-time
   */
  expires_at: string;
  /** Files */
  files?: DocumentRequestListResponseDocumentRequestFileDTO[];
  /** Id */
  id: number;
  /** Is Expired */
  is_expired: boolean;
  /**
   * The CMS mirror of the link's lifecycle.
   *
   * ``UPLOADING`` is what the app's ``signed-urls`` reports when the claimant presses "Upload and send".
   * The report is best-effort, so a link can also go straight from ``PENDING`` to ``SUBMITTED``.
   * ``CANCELLED`` is CMS's record of the app's ``revoked``, written only after the app confirmed the
   * revoke.
   */
  status: DocumentRequestListResponseDocumentRequestStatus;
  /**
   * Submitted At
   * @default null
   */
  submitted_at?: string | null;
  /**
   * Url
   * @default null
   */
  url?: string | null;
}

/**
 * DocumentRequestFileDTO
 * One uploaded file as the claim page lists it. No object path: the review URL is minted on demand.
 */
export interface DocumentRequestListResponseDocumentRequestFileDTO {
  /**
   * Attached Document Id
   * @default null
   */
  attached_document_id?: number | null;
  /** Content Type */
  content_type: string;
  /** Name */
  name: string;
  /**
   * The malware-scan verdict per uploaded file. ``ERROR`` blocks, exactly like ``SUSPICIOUS``.
   *
   * This path fails closed: a scan that errored is never treated as clean, and the recovery is a
   * rescan rather than an override.
   */
  scan_state: DocumentRequestListResponseDocumentRequestFileScanState;
  /** Size */
  size: number;
  /** Uploaded File Id */
  uploaded_file_id: string;
}

/** DocumentRequestShareTemplateQuery */
export interface DocumentRequestShareTemplateQuery {
  /** Contact Id */
  contact_id: number;
}

/**
 * DocumentRequestShareTemplatesUpdateParams
 * A partial update: a key left out keeps its template. Null, a value with no text and no token once its
 * tags are stripped, or the packaged default's own text resets that template to the packaged default.
 */
export interface DocumentRequestShareTemplatesUpdateParams {
  /**
   * Email Body Template
   * @default null
   */
  email_body_template?: string | null;
  /**
   * Email Title Template
   * @default null
   */
  email_title_template?: string | null;
  /**
   * Sms Template
   * @default null
   */
  sms_template?: string | null;
}

/**
 * DocumentRequestUploadPageBrandingUpdateParams
 * A full replace. All three keys are required and each may be null; null clears the field back
 * to the packaged default, which is how a logo is removed. Each value is trimmed, and a blank one
 * is taken as null. The title and description length caps count the value as sent, before the
 * trim -- the same text the card's own caps count.
 */
export interface DocumentRequestUploadPageBrandingUpdateParams {
  /** Description */
  description: string | null;
  /** Logo Data Uri */
  logo_data_uri: string | null;
  /** Title */
  title: string | null;
}

/** DocumentSignatureRequestsQuery */
export interface DocumentSignatureRequestsQuery {
  /** Claim Id */
  claim_id: number;
}

/** DocumentSignatureRequestsResponse */
export interface DocumentSignatureRequestsResponse {
  /** Signature Requests */
  signature_requests: DocumentSignatureRequestsResponseDocumentSignatureRequest[];
}

/** DocumentSignatureRequest */
export interface DocumentSignatureRequestsResponseDocumentSignatureRequest {
  /**
   * Contact Id
   * @default null
   */
  contact_id?: number | null;
  /** Document Id */
  document_id: number;
  /** Id */
  id: number;
  /**
   * E-signature request status values.
   * @default "DRAFT"
   */
  status?: DocumentSignatureRequestsResponseESignStatus;
}

/** DocumentTemplateUpdateIsEnabledParams */
export interface DocumentTemplateUpdateIsEnabledParams {
  /** Is Enabled */
  is_enabled: boolean;
}

/** DocumentTemplatesMetadataRequestQueryParams */
export interface DocumentTemplatesMetadataRequestQueryParams {
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Coverage Keys
   * @default []
   */
  coverage_keys?: string[] | null;
  /**
   * Document Type
   * @default null
   */
  document_type?: string | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /**
   * Is Claim Level
   * @default null
   */
  is_claim_level?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Is Strict
   * @default null
   */
  is_strict?: boolean | null;
  /**
   * Limit
   * @default null
   */
  limit?: number | null;
  /**
   * Lobs
   * @default []
   */
  lobs?: string[] | null;
  /**
   * Order By
   * @default null
   */
  order_by?: "desc" | "asc" | null;
  /**
   * Page
   * @default null
   */
  page?: number | null;
  /**
   * Sort By
   * @default "template_name"
   */
  sort_by?: "template_name" | "last_update_datetime";
  /**
   * States
   * @default []
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[] | null;
  /**
   * Template Name
   * @default null
   */
  template_name?: string | null;
  /**
   * Template Type
   * @default "document"
   */
  template_type?: string | null;
}

/** DocumentTemplatesMetadataResponse */
export interface DocumentTemplatesMetadataResponse {
  /** Count */
  count: number;
  /** Templates Metadata */
  templates_metadata: DocumentTemplatesMetadataResponseDocumentTemplateMetadataResponse[];
}

/** DocumentTemplateMetadataResponse */
export interface DocumentTemplatesMetadataResponseDocumentTemplateMetadataResponse {
  /** Comment */
  comment: string;
  /**
   * Connected Automatic Rule Actions Display Names
   * @default null
   */
  connected_automatic_rule_actions_display_names?: string[] | null;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverages
   * @default null
   */
  coverages?: string[] | null;
  /** Display Name */
  display_name: string;
  /** Document Type */
  document_type: string;
  /** Filename */
  filename: string;
  /** Id */
  id: number;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /**
   * Is Attached To Email Template
   * @default null
   */
  is_attached_to_email_template?: boolean | null;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean | null;
  /**
   * Last Updated By User Id
   * @default null
   */
  last_updated_by_user_id?: string | null;
  /**
   * Last Updated By Username
   * @default null
   */
  last_updated_by_username?: string | null;
  /**
   * Last Updated Datetime
   * @format date-time
   */
  last_updated_datetime: string;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** DocumentTypeParams */
export interface DocumentTypeParams {
  /**
   * Clive Instructions
   * @default null
   */
  clive_instructions?: string | null;
  /** @default null */
  configuration?: DocumentTypeParamsDocumentTypeConfiguration | null;
  /** Description */
  description: string;
  /** Display Name */
  display_name: string;
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean | null;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean | null;
  /** Key */
  key: string;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
}

/** ConfiguredField */
export interface DocumentTypeParamsConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?: DocumentTypeParamsConfiguredFieldSelectOption[] | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: DocumentTypeParamsConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface DocumentTypeParamsConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/**
 * DocumentTypeConfiguration
 * Typed view of the `document_type.configuration` JSONB column.
 */
export interface DocumentTypeParamsDocumentTypeConfiguration {
  /** Configured Fields */
  configured_fields?: DocumentTypeParamsConfiguredField[];
}

/** DocumentTypeRequestQueryParams */
export interface DocumentTypeRequestQueryParams {
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
}

/** DocumentTypeUpdateIsEnabledParams */
export interface DocumentTypeUpdateIsEnabledParams {
  /** Is Enabled */
  is_enabled: boolean;
}

/** DocumentUploadResponse */
export interface DocumentUploadResponse {
  /** Storage Filename */
  storage_filename: string;
  /** Upload Url */
  upload_url: string;
}

/** DownloadUrlResponse */
export interface DownloadUrlResponse {
  /** Url */
  url: string;
}

/**
 * DropboxSignWebhookAcknowledgment
 * Response model for Dropbox Sign webhook acknowledgment.
 *
 * Dropbox Sign requires webhooks to return 200 OK with the body
 * "Hello API Event Received" to acknowledge receipt.
 */
export interface DropboxSignWebhookAcknowledgment {
  /**
   * Message
   * @default "Hello API Event Received"
   */
  message?: string;
}

/** DuplicateContactData */
export interface DuplicateContactData {
  /**
   * Emails
   * @default []
   */
  emails?: DuplicateContactDataDuplicateData[];
  /** Has Duplicates */
  has_duplicates: boolean;
  /**
   * Phones
   * @default []
   */
  phones?: DuplicateContactDataDuplicateData[];
}

/** AddressValidationDetails */
export interface DuplicateContactDataAddressValidationDetails {
  /**
   * Override Reason
   * @default null
   */
  override_reason?: string | null;
  /**
   * Override Timestamp
   * @default null
   */
  override_timestamp?: string | null;
  /**
   * Override User Name
   * @default null
   */
  override_user_name?: string | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Ref Type
   * @default null
   */
  ref_type?: string | null;
  /**
   * Type
   * @default "address"
   */
  type?: "address";
}

/** BusinessValidationDetails */
export interface DuplicateContactDataBusinessValidationDetails {
  /**
   * Bn
   * @default null
   */
  bn?: string | null;
  /**
   * Entity Type
   * @default null
   */
  entity_type?: string | null;
  /**
   * Gst Status
   * @default null
   */
  gst_status?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Type
   * @default "business"
   */
  type?: "business";
}

/** ContactEmailInfo */
export interface DuplicateContactDataContactEmailInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email */
  email: string;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
}

/** ContactExtraInfo */
export interface DuplicateContactDataContactExtraInfo {
  /**
   * Driving License Issue Date
   * @default null
   */
  driving_license_issue_date?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Is Unrecognized Number Contact
   * @default null
   */
  is_unrecognized_number_contact?: boolean | null;
  /**
   * Profession
   * @default null
   */
  profession?: string | null;
  /**
   * User Id
   * @default null
   */
  user_id?: string | null;
}

/**
 * ContactInfo
 * Full contact DTO — matches the flask-restx contact_full_model exactly.
 */
export interface DuplicateContactDataContactInfo {
  /**
   * Account Details
   * @default null
   */
  account_details?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Bar Number
   * @default null
   */
  attorney_bar_number?: string | null;
  /**
   * Attorney Bar State
   * @default null
   */
  attorney_bar_state?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Change Ulid
   * @default null
   */
  au_tfn_change_ulid?: string | null;
  /**
   * Au Tfn Contact Document Id
   * @default null
   */
  au_tfn_contact_document_id?: number | null;
  /**
   * Au Tfn Exemption
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Bank Proof Contact Document Id
   * @default null
   */
  bank_proof_contact_document_id?: number | null;
  /**
   * Business Legal Name
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Coi Contact Document Id
   * @default null
   */
  coi_contact_document_id?: number | null;
  /**
   * Coi Expiration
   * @default null
   */
  coi_expiration?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /** @default null */
  contact_extra?: DuplicateContactDataContactExtraInfo | null;
  /**
   * Contract Of Service Contact Document Id
   * @default null
   */
  contract_of_service_contact_document_id?: number | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivated By User Id
   * @default null
   */
  deactivated_by_user_id?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: DuplicateContactDataContactEmailInfo[];
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * Finance Change Ulid
   * @default null
   */
  finance_change_ulid?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Address
   * @default null
   */
  full_address?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** Id */
  id: number;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /** Is Company */
  is_company: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean;
  /**
   * Is Deceased
   * @default null
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Moi Service Provider
   * @default null
   */
  is_moi_service_provider?: boolean | null;
  /**
   * Is Policy Contact
   * @default null
   */
  is_policy_contact?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * Medical Provider Discount Fixed Amount
   * @default null
   */
  medical_provider_discount_fixed_amount?: number | null;
  /**
   * Medical Provider Discount Percentage
   * @default null
   */
  medical_provider_discount_percentage?: number | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Moi Expertises
   * @default []
   */
  moi_expertises?: string[];
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Organization External Id
   * @default null
   */
  organization_external_id?: string | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Phones
   * @default []
   */
  phones?: DuplicateContactDataContactPhoneInfo[];
  /**
   * Reference Contact Full Name
   * @default null
   */
  reference_contact_full_name?: string | null;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * Sex
   * @default null
   */
  sex?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Street Address1
   * @default null
   */
  street_address1?: string | null;
  /**
   * Street Address2
   * @default null
   */
  street_address2?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Granted At
   * @default null
   */
  trusted_payee_granted_at?: string | null;
  /**
   * Trusted Payee Granted By User Name
   * @default null
   */
  trusted_payee_granted_by_user_name?: string | null;
  /**
   * Trusted Payee Per Payment Limit
   * @default null
   */
  trusted_payee_per_payment_limit?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Trusted Payee Valid To
   * @default null
   */
  trusted_payee_valid_to?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Validations
   * @default []
   */
  validations?: DuplicateContactDataContactValidationInfo[];
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * W9 Contact Document Id
   * @default null
   */
  w9_contact_document_id?: number | null;
  /**
   * W9 Date
   * @default null
   */
  w9_date?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneInfo */
export interface DuplicateContactDataContactPhoneInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /** Phone */
  phone: string;
  /**
   * Phone Type
   * @default null
   */
  phone_type?: string | null;
  /**
   * Standardized Phone
   * @default null
   */
  standardized_phone?: string | null;
}

/** ContactValidationInfo */
export interface DuplicateContactDataContactValidationInfo {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Id */
  id: number;
  /** Provider */
  provider: string;
  /** Status */
  status: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Validation Details
   * @default null
   */
  validation_details?:
    | (
        | ({
            type: "address";
          } & DuplicateContactDataAddressValidationDetails)
        | ({
            type: "business";
          } & DuplicateContactDataBusinessValidationDetails)
      )
    | null;
  /** Validation Type */
  validation_type: string;
}

/** DuplicateData */
export interface DuplicateContactDataDuplicateData {
  /**
   * Contacts
   * @default []
   */
  contacts?: DuplicateContactDataContactInfo[];
  /**
   * Value
   * @default null
   */
  value?: string | null;
}

/**
 * DynamicClaimActionResult
 * Result of executing a claim action: an explicit success flag + readable text.
 *
 * The ``Result`` suffix (rather than the ``Response`` convention) is intentional — it keeps
 * this 1:1 with the cross-repo wire contract (claims_llm's ``DynamicClaimActionResult``).
 */
export interface DynamicClaimActionResult {
  /** @default null */
  execution_result_type?: DynamicClaimActionResultClaimActionExecutionResultType | null;
  /**
   * Outcome Details
   * @default null
   */
  outcome_details?: Record<string, any> | null;
  /** @default null */
  requires_human_approval_reason?: DynamicClaimActionResultRequiresHumanApprovalReason | null;
  /** Result Text */
  result_text: string;
  /** Success */
  success: boolean;
}

/**
 * RequiresHumanApprovalReason
 * Why the action was held for a person: the reason's key and its ready-to-display sentence.
 */
export interface DynamicClaimActionResultRequiresHumanApprovalReason {
  /**
   * Which gate held a ``REQUIRES_HUMAN_APPROVAL`` action for a person.
   *
   * The AI service stores the key as a plain string and never branches on it; these values are this
   * service's vocabulary, and the Conductor Hub picks the look of a waiting card's chip by them.
   *
   * - ``ALWAYS_HUMAN``: the action's execution mode is ``always_human``.
   * - ``BELOW_THRESHOLD``: the mode is ``above_threshold`` and the agent's confidence fell below it.
   * - ``GUARDRAIL``: a guardrails-engine rule only a person can clear tripped.
   */
  key: DynamicClaimActionResultRequiresHumanApprovalReasonKey;
  /** Text */
  text: string;
}

/** DyteConfigurationAndImageResponse */
export interface DyteConfigurationAndImageResponse {
  /**
   * Background Images
   * @default []
   */
  background_images?: DyteConfigurationAndImageResponseDyteBackgroundImage[];
  /** Email Body Template */
  email_body_template: string;
  /** Email Title Template */
  email_title_template: string;
  /** Id */
  id: number;
  /** Is Automatic Recording Enabled */
  is_automatic_recording_enabled: boolean;
  /** Is Integration Enabled */
  is_integration_enabled: boolean;
  /** Sms Template */
  sms_template: string;
}

/** DyteBackgroundImage */
export interface DyteConfigurationAndImageResponseDyteBackgroundImage {
  /** Image Url */
  image_url: string;
  /** Stored File Id */
  stored_file_id: string;
}

/** DyteConfigurationResponse */
export interface DyteConfigurationResponse {
  /** Email Body Template */
  email_body_template: string;
  /** Email Title Template */
  email_title_template: string;
  /** Id */
  id: number;
  /** Is Automatic Recording Enabled */
  is_automatic_recording_enabled: boolean;
  /** Is Integration Enabled */
  is_integration_enabled: boolean;
  /** Sms Template */
  sms_template: string;
}

/** DyteUpdateConfigurationDict */
export interface DyteUpdateConfigurationDict {
  /**
   * Email Body Template
   * @default null
   */
  email_body_template?: string | null;
  /**
   * Email Title Template
   * @default null
   */
  email_title_template?: string | null;
  /**
   * Is Automatic Recording Enabled
   * @default null
   */
  is_automatic_recording_enabled?: boolean | null;
  /**
   * Is Integration Enabled
   * @default null
   */
  is_integration_enabled?: boolean | null;
  /**
   * Sms Template
   * @default null
   */
  sms_template?: string | null;
}

/** ERDParams */
export interface ERDParams {
  /**
   * Sub Org External Ids
   * List of sub-organization external IDs
   * @default null
   * @example "sub_org_1,sub_org_2"
   */
  sub_org_external_ids?: string[] | null;
}

/** ESignConfigResponse */
export interface ESignConfigResponse {
  /**
   * Client Id
   * @default null
   */
  client_id?: string | null;
  /** Created Datetime */
  created_datetime: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Last Updated By Username
   * @default null
   */
  last_updated_by_username?: string | null;
  /** Last Updated Datetime */
  last_updated_datetime: string;
  /** Vendor Type */
  vendor_type: string;
}

/**
 * EffectiveClaimActionConfig
 * An action's resolved config for one scope: persisted row, else default.
 *
 * The action's description is deliberately absent. It is a code artifact declared in
 * :mod:`server.generative_ai.claim_action_configuration.internal.defaults`, not something a
 * scope configures, and the CMS does not display it; only ``instructions`` -- the scope's own
 * addition to it -- is editable, and None means the scope added nothing.
 */
export interface EffectiveClaimActionConfig {
  /**
   * Confidence Threshold
   * @default null
   */
  confidence_threshold?: number | null;
  /** Display Name */
  display_name: string;
  /** Enabled */
  enabled: boolean;
  /** Execution Mode */
  execution_mode: "always_human" | "always_ai" | "above_threshold";
  /** Guardrail Event Keys */
  guardrail_event_keys?: string[];
  /**
   * Guardrails Required Conditions
   * @default null
   */
  guardrails_required_conditions?:
    | EffectiveClaimActionConfigGuardrailRequiredCondition[]
    | null;
  /**
   * Instructions
   * @default null
   */
  instructions?: string | null;
  /** Key */
  key: string;
}

/**
 * GuardrailRequiredCondition
 * A condition every guardrail on an action must carry, as a react-querybuilder leaf.
 *
 * For an action whose guardrail event another write also reports: the condition tells this
 * action's occurrences of the event apart, so its guardrails do not gate the other write too.
 */
export interface EffectiveClaimActionConfigGuardrailRequiredCondition {
  /** Field */
  field: string;
  /** Operator */
  operator: string;
  /** Value */
  value: string;
}

/**
 * EffectiveClaimActionConfigList
 * The effective config of every registered action for one scope.
 */
export interface EffectiveClaimActionConfigList {
  /** Configs */
  configs: EffectiveClaimActionConfigListEffectiveClaimActionConfig[];
}

/**
 * EffectiveClaimActionConfig
 * An action's resolved config for one scope: persisted row, else default.
 *
 * The action's description is deliberately absent. It is a code artifact declared in
 * :mod:`server.generative_ai.claim_action_configuration.internal.defaults`, not something a
 * scope configures, and the CMS does not display it; only ``instructions`` -- the scope's own
 * addition to it -- is editable, and None means the scope added nothing.
 */
export interface EffectiveClaimActionConfigListEffectiveClaimActionConfig {
  /**
   * Confidence Threshold
   * @default null
   */
  confidence_threshold?: number | null;
  /** Display Name */
  display_name: string;
  /** Enabled */
  enabled: boolean;
  /** Execution Mode */
  execution_mode: "always_human" | "always_ai" | "above_threshold";
  /** Guardrail Event Keys */
  guardrail_event_keys?: string[];
  /**
   * Guardrails Required Conditions
   * @default null
   */
  guardrails_required_conditions?:
    | EffectiveClaimActionConfigListGuardrailRequiredCondition[]
    | null;
  /**
   * Instructions
   * @default null
   */
  instructions?: string | null;
  /** Key */
  key: string;
}

/**
 * GuardrailRequiredCondition
 * A condition every guardrail on an action must carry, as a react-querybuilder leaf.
 *
 * For an action whose guardrail event another write also reports: the condition tells this
 * action's occurrences of the event apart, so its guardrails do not gate the other write too.
 */
export interface EffectiveClaimActionConfigListGuardrailRequiredCondition {
  /** Field */
  field: string;
  /** Operator */
  operator: string;
  /** Value */
  value: string;
}

/** EmailAutoAcknowledgmentCreationData */
export interface EmailAutoAcknowledgmentCreationData {
  /** Email Content */
  email_content: string;
  /**
   * Excluded Emails
   * @default []
   */
  excluded_emails?: EmailAutoAcknowledgmentCreationDataExcludedEmail[] | null;
  /** Frequency */
  frequency: number;
  /** Frequency Setting */
  frequency_setting: string;
}

/** ExcludedEmail */
export interface EmailAutoAcknowledgmentCreationDataExcludedEmail {
  /** Excluded Email */
  excluded_email: string;
}

/** EmailAutoAcknowledgmentResponseData */
export interface EmailAutoAcknowledgmentResponseData {
  /** Email Content */
  email_content: string;
  /**
   * Excluded Emails
   * @default []
   */
  excluded_emails?: EmailAutoAcknowledgmentResponseDataExcludedEmail[] | null;
  /** Frequency */
  frequency: number;
  /** Frequency Setting */
  frequency_setting: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
}

/** ExcludedEmail */
export interface EmailAutoAcknowledgmentResponseDataExcludedEmail {
  /** Excluded Email */
  excluded_email: string;
}

/** EmailConfigurationModel */
export interface EmailConfigurationModel {
  /**
   * Edited At
   * @format date-time
   */
  edited_at: string;
  /** Edited By Username */
  edited_by_username: string;
  /** Email Default Title */
  email_default_title: string;
  /**
   * Email Domain Id
   * @default null
   */
  email_domain_id?: number | null;
  /** Email Signature Html Template */
  email_signature_html_template: string;
  /** Id */
  id: number;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** EmailConfigurationTitleAndSignatureResponse */
export interface EmailConfigurationTitleAndSignatureResponse {
  /** Email Title */
  email_title: string;
  /**
   * Sender Email Address
   * @default null
   */
  sender_email_address?: string | null;
  /** User Email Signature Html */
  user_email_signature_html: string;
}

/** EmailConfigurationsResponse */
export interface EmailConfigurationsResponse {
  /** @default null */
  email_acknowledgment_configuration?: EmailConfigurationsResponseEmailAutoAcknowledgmentResponseData | null;
  /** @default null */
  email_general_configuration?: EmailConfigurationsResponseEmailGeneralConfigurationResponseData | null;
  /**
   * Email Notification Suppression Rules
   * @default []
   */
  email_notification_suppression_rules?:
    | EmailConfigurationsResponseEmailNotificationSuppressionRuleData[]
    | null;
  /** Email Signature And Title Configurations */
  email_signature_and_title_configurations: EmailConfigurationsResponseEmailConfigurationModel[];
}

/** EmailAutoAcknowledgmentResponseData */
export interface EmailConfigurationsResponseEmailAutoAcknowledgmentResponseData {
  /** Email Content */
  email_content: string;
  /**
   * Excluded Emails
   * @default []
   */
  excluded_emails?: EmailConfigurationsResponseExcludedEmail[] | null;
  /** Frequency */
  frequency: number;
  /** Frequency Setting */
  frequency_setting: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
}

/** EmailConfigurationModel */
export interface EmailConfigurationsResponseEmailConfigurationModel {
  /**
   * Edited At
   * @format date-time
   */
  edited_at: string;
  /** Edited By Username */
  edited_by_username: string;
  /** Email Default Title */
  email_default_title: string;
  /**
   * Email Domain Id
   * @default null
   */
  email_domain_id?: number | null;
  /** Email Signature Html Template */
  email_signature_html_template: string;
  /** Id */
  id: number;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** EmailGeneralConfigurationResponseData */
export interface EmailConfigurationsResponseEmailGeneralConfigurationResponseData {
  /**
   * Html Attachments Enabled
   * @default false
   */
  html_attachments_enabled?: boolean;
  /** Id */
  id: number;
  /**
   * Personal Email Signature Enabled
   * @default false
   */
  personal_email_signature_enabled?: boolean;
  /** Restrict Send As To Managed Users */
  restrict_send_as_to_managed_users: boolean;
  /** Should Extract Original From */
  should_extract_original_from: boolean;
  /** Supervisor Send As Other Adjuster */
  supervisor_send_as_other_adjuster: boolean;
}

/** EmailNotificationSuppressionRuleData */
export interface EmailConfigurationsResponseEmailNotificationSuppressionRuleData {
  /** Check Bcc Field */
  check_bcc_field: boolean;
  /** Check Cc Field */
  check_cc_field: boolean;
  /** Check To Field */
  check_to_field: boolean;
  /** Display Name */
  display_name: string;
  /**
   * Excluded Emails
   * @default []
   */
  excluded_emails?: EmailConfigurationsResponseExcludedEmail[] | null;
  /**
   * Excluded Words
   * @default []
   */
  excluded_words?: EmailConfigurationsResponseExcludedWord[] | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /** Is Enabled */
  is_enabled: boolean;
}

/** ExcludedEmail */
export interface EmailConfigurationsResponseExcludedEmail {
  /** Excluded Email */
  excluded_email: string;
}

/** ExcludedWord */
export interface EmailConfigurationsResponseExcludedWord {
  /** Excluded Word */
  excluded_word: string;
}

/**
 * EmailFromTemplateRequest
 * Request model for email from template external API endpoint.
 */
export interface EmailFromTemplateRequest {
  /**
   * Contacts
   * List of contacts to include in template context
   * @example [{"api_uid":"contact_01HQXYZ123456789ABCDEF","creation_mode":"existing","ref_id":"contact_01HQXYZ123456789ABCDEF"}]
   */
  contacts: (
    | ({
        creation_mode: "";
      } & EmailFromTemplateRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & EmailFromTemplateRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & EmailFromTemplateRequestContactInNewParam)
  )[];
  /**
   * Optional dynamic tokens to provide additional context for template generation
   * @default null
   */
  dynamic_tokens?: EmailFromTemplateRequestEmailFromTemplateDynamicTokens | null;
  /**
   * Exposure Number
   * Exposure number within the claim for template context
   * @default null
   * @example "CLAIM-0000001-01"
   */
  exposure_number?: string | null;
  /**
   * Recipient Contact Email Address
   * Email address of the recipient. If contact with this email does not exist in the organization, a new contact will be created and added to the claim
   * @minLength 3
   * @maxLength 255
   * @example "claimant@example.com"
   */
  recipient_contact_email_address: string;
  /**
   * Recipient Contact Ref Id
   * Ref ID of the contact who will receive the email
   * @example "contact_01HQXYZ123456789ABCDEF"
   */
  recipient_contact_ref_id: string;
  /**
   * Sender Email Address
   * Email address of the user sending the email. Accepts either the user login email or the claims email address (must be a valid user in the organization)
   * @example "adjuster@company.com"
   */
  sender_email_address: string;
  /**
   * Summary
   * Summary of the communication for internal tracking
   * @default null
   * @example "Sent settlement offer to claimant"
   */
  summary?: string | null;
  /**
   * Template Api Uid
   * API UID of the generic template to use for email generation
   * @example "template_01HQXYZ123456789ABCDEF"
   */
  template_api_uid: string;
}

/** ContactEmailModel */
export interface EmailFromTemplateRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface EmailFromTemplateRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface EmailFromTemplateRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: EmailFromTemplateRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: EmailFromTemplateRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface EmailFromTemplateRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * EmailFromTemplateDynamicTokens
 * Dynamic tokens for template context resolution.
 */
export interface EmailFromTemplateRequestEmailFromTemplateDynamicTokens {
  /**
   * Contact Ref Id
   * Ref ID of additional contact to include in template context
   * @default null
   * @example "contact_01HQXYZ123456789ABCDEF"
   */
  contact_ref_id?: string | null;
  /**
   * Document Api Uid
   * API UID of document to include in template context
   * @default null
   * @example "document_01HQXYZ123456789ABCDEF"
   */
  document_api_uid?: string | null;
  /**
   * Payment Api Id
   * API UID of payment request to include in template context
   * @default null
   * @example "financial_request_01HQXYZ123456789ABCDEF"
   */
  payment_api_id?: string | null;
}

/** EmailFromTemplateResponse */
export interface EmailFromTemplateResponse {
  /**
   * Api Uid
   * API UID of the email communication created
   * @example "communication_01HQXYZ123456789ABCDEF"
   */
  api_uid: string;
}

/** EmailGeneralConfigurationCreationData */
export interface EmailGeneralConfigurationCreationData {
  /**
   * Html Attachments Enabled
   * @default false
   */
  html_attachments_enabled?: boolean;
  /**
   * Personal Email Signature Enabled
   * @default false
   */
  personal_email_signature_enabled?: boolean;
  /** Restrict Send As To Managed Users */
  restrict_send_as_to_managed_users: boolean;
  /** Should Extract Original From */
  should_extract_original_from: boolean;
  /** Supervisor Send As Other Adjuster */
  supervisor_send_as_other_adjuster: boolean;
}

/** EmailGeneralConfigurationResponseData */
export interface EmailGeneralConfigurationResponseData {
  /**
   * Html Attachments Enabled
   * @default false
   */
  html_attachments_enabled?: boolean;
  /** Id */
  id: number;
  /**
   * Personal Email Signature Enabled
   * @default false
   */
  personal_email_signature_enabled?: boolean;
  /** Restrict Send As To Managed Users */
  restrict_send_as_to_managed_users: boolean;
  /** Should Extract Original From */
  should_extract_original_from: boolean;
  /** Supervisor Send As Other Adjuster */
  supervisor_send_as_other_adjuster: boolean;
}

/** EmailNotificationSuppressionRuleData */
export interface EmailNotificationSuppressionRuleData {
  /** Check Bcc Field */
  check_bcc_field: boolean;
  /** Check Cc Field */
  check_cc_field: boolean;
  /** Check To Field */
  check_to_field: boolean;
  /** Display Name */
  display_name: string;
  /**
   * Excluded Emails
   * @default []
   */
  excluded_emails?: EmailNotificationSuppressionRuleDataExcludedEmail[] | null;
  /**
   * Excluded Words
   * @default []
   */
  excluded_words?: EmailNotificationSuppressionRuleDataExcludedWord[] | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /** Is Enabled */
  is_enabled: boolean;
}

/** ExcludedEmail */
export interface EmailNotificationSuppressionRuleDataExcludedEmail {
  /** Excluded Email */
  excluded_email: string;
}

/** ExcludedWord */
export interface EmailNotificationSuppressionRuleDataExcludedWord {
  /** Excluded Word */
  excluded_word: string;
}

/**
 * EmailSignatureData
 * The user's own email signature, and whether it is in use.
 *
 * ``email_signature_active`` is what decides between the personal and the organization signature.
 * It is the non-destructive of the two ways to fall back: it leaves the stored template alone so
 * the user can turn their signature back on without retyping it.
 *
 * The content is stored verbatim, empty markup included -- an emptied editor with the switch on is
 * a user asking to send no signature, not a request for the organization one. Only a null template
 * still falls back, and that is the never-written row rather than an empty signature.
 *
 * The template is required but nullable, which is the asymmetry the switch forces. It stays
 * nullable because ``EmailSignatureResponseData`` inherits it and the stored column is nullable,
 * so the GET has to be able to report null -- a plain ``str`` was never available. But a *missing*
 * template can no longer mean null: the otherwise-natural switch-only body
 * (``{"email_signature_active": false}``) would then write null over the very content the switch
 * exists to preserve. Omitting it is a 400.
 *
 * The switch itself does default to on, so a body carrying only a template -- what this endpoint
 * accepted before the switch existed -- still stores a signature that is actually used.
 */
export interface EmailSignatureData {
  /**
   * Email Signature Active
   * @default true
   */
  email_signature_active?: boolean;
  /** Email Signature Html Template */
  email_signature_html_template: string | null;
}

/**
 * EmailSignatureResponseData
 * The stored signature and switch, plus whether the organization allows personal signatures
 * at all.
 *
 * ``is_enabled`` is the organization's own General Email Settings toggle, resolved server-side so
 * the UI has one thing to read rather than resolving the gate client-side.
 */
export interface EmailSignatureResponseData {
  /**
   * Email Signature Active
   * @default true
   */
  email_signature_active?: boolean;
  /** Email Signature Html Template */
  email_signature_html_template: string | null;
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * EnableOverrideRuleParams
 * Body of POST /override_rules/<id>/enable — flips the rule's strategy.
 */
export interface EnableOverrideRuleParams {
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * EnableQueueVoicemailResponse
 * Returned by POST /twilio_configuration/queue_voicemail_defaults on enable.
 */
export interface EnableQueueVoicemailResponse {
  /** Queue Voicemail Enabled */
  queue_voicemail_enabled: boolean;
}

/**
 * EnableRuleParams
 * Request schema for enabling/disabling workflow rules
 */
export interface EnableRuleParams {
  /**
   * Is Enabled
   * Whether the rule should be enabled
   */
  is_enabled: boolean;
}

/**
 * EnableRuleRequest
 * Request body for enabling/disabling a rule.
 */
export interface EnableRuleRequest {
  /** Is Enabled */
  is_enabled: boolean;
}

/** EnableSlaRuleRequest */
export interface EnableSlaRuleRequest {
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * ErdSchemaResponse
 * Response schema for the sink DB ERD schema endpoint.
 */
export interface ErdSchemaResponse {
  /** Relationships */
  relationships: ErdSchemaResponseErdRelationshipSchema[];
  /** Tables */
  tables: ErdSchemaResponseErdTableSchema[];
}

/**
 * ErdColumnRef
 * A (table, column) reference used by relationship endpoints.
 */
export interface ErdSchemaResponseErdColumnRef {
  /** Column */
  column: string;
  /** Table */
  table: string;
}

/**
 * ErdColumnSchema
 * A single column of a sink DB table.
 */
export interface ErdSchemaResponseErdColumnSchema {
  /** Is Foreign Key */
  is_foreign_key: boolean;
  /** Is Primary Key */
  is_primary_key: boolean;
  /** Name */
  name: string;
  /** Type */
  type: string;
}

/**
 * ErdRelationshipSchema
 * A FK relationship between two sink DB columns.
 */
export interface ErdSchemaResponseErdRelationshipSchema {
  /** A (table, column) reference used by relationship endpoints. */
  from: ErdSchemaResponseErdColumnRef;
  /** A (table, column) reference used by relationship endpoints. */
  to: ErdSchemaResponseErdColumnRef;
}

/**
 * ErdTableSchema
 * A sink DB table with its columns.
 */
export interface ErdSchemaResponseErdTableSchema {
  /** Columns */
  columns: ErdSchemaResponseErdColumnSchema[];
  /** Name */
  name: string;
}

/** ExchangeHandle */
export interface ExchangeHandle {
  /** Claim Number */
  claim_number: string;
  /** Exchange Uid */
  exchange_uid: string;
  /** Status */
  status: string;
}

/**
 * ExchangeRatesResponse
 * Response model for exchange rates.
 */
export interface ExchangeRatesResponse {
  /**
   * Api Source
   * Source of the exchange rate data
   */
  api_source: string;
  /**
   * Base Currency
   * Base currency (USD)
   */
  base_currency: string;
  /**
   * Date
   * Date of the exchange rates (actual API date used)
   */
  date: string;
  /**
   * Fetched At
   * ISO timestamp when data was fetched
   */
  fetched_at: string;
  /**
   * Rates
   * Currency code to exchange rate mapping
   */
  rates: Record<string, number>;
}

/**
 * ExecuteActionToolResponse
 * Outcome of executing an escalated claim action via its registered ClaimActionTool.
 */
export interface ExecuteActionToolResponse {
  /**
   * Already Executed
   * @default false
   */
  already_executed?: boolean;
  /** Executed */
  executed: boolean;
  /**
   * Result
   * @default null
   */
  result?: Record<string, any> | null;
}

/**
 * ExecuteClaimActionParams
 * The optional body of a request to execute a claim action.
 */
export interface ExecuteClaimActionParams {
  /**
   * Expected Revision
   * The action's revision as the handler last read it. The execute is refused if the action has changed since. Omit it to execute the action whatever its revision.
   * @default null
   */
  expected_revision?: number | null;
}

/** ExecutionDetailsQuery */
export interface ExecutionDetailsQuery {
  /**
   * Include Event Payload
   * @default true
   */
  include_event_payload?: boolean;
  /**
   * Include Execution Details
   * @default true
   */
  include_execution_details?: boolean;
}

/** ExecutionIdsResponse */
export interface ExecutionIdsResponse {
  /** @default null */
  extra_data?: ExecutionIdsResponseExecutionSummaryData | null;
  /** Ids */
  ids: string[];
  /** Results Truncated */
  results_truncated: boolean;
}

/**
 * ExecutionSummaryData
 * Summary data for execution lists
 */
export interface ExecutionIdsResponseExecutionSummaryData {
  /** Status Counts */
  status_counts: Record<string, number>;
  /** Total Executions */
  total_executions: number;
}

/** ExecutionsByIdsResponse */
export interface ExecutionsByIdsResponse {
  /**
   * Meta
   * @default null
   */
  meta?: any;
  /** Results */
  results: ExecutionsByIdsResponseWorkflowExecutionModel[];
}

/**
 * WorkflowExecutionModel
 * Response model for workflow executions
 */
export interface ExecutionsByIdsResponseWorkflowExecutionModel {
  /**
   * Completed Datetime
   * @default null
   */
  completed_datetime?: string | null;
  /**
   * Created Datetime
   * @format date-time
   */
  created_datetime: string;
  /**
   * Error Summary
   * @default null
   */
  error_summary?: string | null;
  /** Event Key */
  event_key: string;
  /**
   * Event Payload
   * @default null
   */
  event_payload?: Record<string, any> | null;
  /**
   * Execution Details
   * @default null
   */
  execution_details?: Record<string, any> | null;
  /** Execution Uuid */
  execution_uuid: string;
  /**
   * External Execution Id
   * @default null
   */
  external_execution_id?: string | null;
  /** Id */
  id: string;
  /** Organization Id */
  organization_id: number;
  /**
   * Raw Status Response
   * @default null
   */
  raw_status_response?: Record<string, any> | null;
  /**
   * Rule Display Name
   * @default null
   */
  rule_display_name?: string | null;
  /**
   * Started Datetime
   * @default null
   */
  started_datetime?: string | null;
  /** Status */
  status: string;
  /**
   * Storage Path
   * @default null
   */
  storage_path?: string | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Submitted Datetime
   * @default null
   */
  submitted_datetime?: string | null;
  /** Workflow Action Id */
  workflow_action_id: number;
  /** Workflow Engine */
  workflow_engine: string;
  /** Workflow Id */
  workflow_id: string;
  /**
   * Workflow Name
   * @default null
   */
  workflow_name?: string | null;
}

/** ExperimentFnolInboxItemResponse */
export interface ExperimentFnolInboxItemResponse {
  /** Attachments */
  attachments: ExperimentFnolInboxItemResponseAttachmentItem[];
  configs: ExperimentFnolInboxItemResponseExperimentFnolInboxItemConfigs;
  email: ExperimentFnolInboxItemResponseEmailPayload;
  ground_truth: ExperimentFnolInboxItemResponseExperimentFnolInboxItemGroundTruth;
  org_context: ExperimentFnolInboxItemResponseOrgContext;
  policy: ExperimentFnolInboxItemResponseExperimentFnolInboxItemPolicy;
}

/** AttachmentItem */
export interface ExperimentFnolInboxItemResponseAttachmentItem {
  /** Gcs Bucket */
  gcs_bucket: string;
  /** Gcs Path */
  gcs_path: string;
  /**
   * Mime Type
   * @default null
   */
  mime_type?: string | null;
  /**
   * Original Filename
   * @default null
   */
  original_filename?: string | null;
}

/** ConfigBlock */
export interface ExperimentFnolInboxItemResponseConfigBlock {
  /** Content */
  content: any;
  /** Content Hash */
  content_hash: string;
}

/** EmailPayload */
export interface ExperimentFnolInboxItemResponseEmailPayload {
  /**
   * Body Html
   * @default null
   */
  body_html?: string | null;
  /**
   * Body Text
   * @default null
   */
  body_text?: string | null;
  /**
   * Cc
   * @default null
   */
  cc?: any;
  /**
   * Datetime
   * @default null
   */
  datetime?: string | null;
  /**
   * From
   * @default null
   */
  from?: any;
  /**
   * Subject
   * @default null
   */
  subject?: string | null;
  /**
   * To
   * @default null
   */
  to?: any;
}

/** ExperimentFnolInboxItemConfigs */
export interface ExperimentFnolInboxItemResponseExperimentFnolInboxItemConfigs {
  fnol_configuration: ExperimentFnolInboxItemResponseConfigBlock;
  incident_configuration: ExperimentFnolInboxItemResponseConfigBlock;
  policy_search_guidance: ExperimentFnolInboxItemResponseConfigBlock;
}

/** ExperimentFnolInboxItemGroundTruth */
export interface ExperimentFnolInboxItemResponseExperimentFnolInboxItemGroundTruth {
  /**
   * Claim
   * @default null
   */
  claim?: Record<string, any> | null;
  /**
   * Incident
   * @default null
   */
  incident?: Record<string, any> | null;
}

/** ExperimentFnolInboxItemPolicy */
export interface ExperimentFnolInboxItemResponseExperimentFnolInboxItemPolicy {
  /** Entities */
  entities: Record<string, any>[];
  /**
   * Policy Api Data
   * @default null
   */
  policy_api_data?: Record<string, any> | null;
}

/** OrgContext */
export interface ExperimentFnolInboxItemResponseOrgContext {
  /** External Id */
  external_id: string;
  /**
   * Line Of Business
   * @default null
   */
  line_of_business?: string | null;
  /**
   * Sub Account
   * @default null
   */
  sub_account?: string | null;
}

/** ExperimentUnclassifiedEmailResponse */
export interface ExperimentUnclassifiedEmailResponse {
  /** Attachments */
  attachments: ExperimentUnclassifiedEmailResponseAttachmentItem[];
  configs: ExperimentUnclassifiedEmailResponseExperimentUnclassifiedEmailConfigs;
  email: ExperimentUnclassifiedEmailResponseEmailPayload;
  ground_truth: ExperimentUnclassifiedEmailResponseExperimentUnclassifiedEmailGroundTruth;
  org_context: ExperimentUnclassifiedEmailResponseOrgContext;
}

/** AttachmentItem */
export interface ExperimentUnclassifiedEmailResponseAttachmentItem {
  /** Gcs Bucket */
  gcs_bucket: string;
  /** Gcs Path */
  gcs_path: string;
  /**
   * Mime Type
   * @default null
   */
  mime_type?: string | null;
  /**
   * Original Filename
   * @default null
   */
  original_filename?: string | null;
}

/** ConfigBlock */
export interface ExperimentUnclassifiedEmailResponseConfigBlock {
  /** Content */
  content: any;
  /** Content Hash */
  content_hash: string;
}

/** EmailPayload */
export interface ExperimentUnclassifiedEmailResponseEmailPayload {
  /**
   * Body Html
   * @default null
   */
  body_html?: string | null;
  /**
   * Body Text
   * @default null
   */
  body_text?: string | null;
  /**
   * Cc
   * @default null
   */
  cc?: any;
  /**
   * Datetime
   * @default null
   */
  datetime?: string | null;
  /**
   * From
   * @default null
   */
  from?: any;
  /**
   * Subject
   * @default null
   */
  subject?: string | null;
  /**
   * To
   * @default null
   */
  to?: any;
}

/** ExperimentUnclassifiedEmailConfigs */
export interface ExperimentUnclassifiedEmailResponseExperimentUnclassifiedEmailConfigs {
  claim_search: ExperimentUnclassifiedEmailResponseConfigBlock;
}

/** ExperimentUnclassifiedEmailGroundTruth */
export interface ExperimentUnclassifiedEmailResponseExperimentUnclassifiedEmailGroundTruth {
  /**
   * Claim Id Display
   * @default null
   */
  claim_id_display?: string | null;
  /**
   * Policy Number
   * @default null
   */
  policy_number?: string | null;
  /** Status History */
  status_history: ExperimentUnclassifiedEmailResponseStatusTransition[];
}

/** OrgContext */
export interface ExperimentUnclassifiedEmailResponseOrgContext {
  /** External Id */
  external_id: string;
  /**
   * Line Of Business
   * @default null
   */
  line_of_business?: string | null;
  /**
   * Sub Account
   * @default null
   */
  sub_account?: string | null;
}

/** StatusTransition */
export interface ExperimentUnclassifiedEmailResponseStatusTransition {
  /** New Status */
  new_status: string;
  /**
   * Old Status
   * @default null
   */
  old_status?: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/**
 * ExportConfigurationRequest
 * Request schema for creating manual configuration snapshots.
 * @example {"description":"Full configuration export for backup purposes","snapshot_name":"Production Export 2024-01-15"}
 */
export interface ExportConfigurationRequest {
  /**
   * Description
   * Optional description for the snapshot
   * @default null
   */
  description?: string | null;
  /**
   * Snapshot Name
   * Name for the snapshot
   */
  snapshot_name: string;
}

/** ExportDocumentTemplatesParams */
export interface ExportDocumentTemplatesParams {
  /** Document Template Ids */
  document_template_ids: number[];
}

/** ExposureDeductiblePutJsonParams */
export interface ExposureDeductiblePutJsonParams {
  /**
   * Deductible Amount
   * @default null
   */
  deductible_amount?: number | null;
  /**
   * Deductible Reason
   * @default null
   */
  deductible_reason?: string | null;
  /** Is Deductible Waived */
  is_deductible_waived: boolean;
}

/**
 * ExposureEnableRuleRequest
 * Request body for enabling/disabling an exposure rule.
 */
export interface ExposureEnableRuleRequest {
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * ExposureLineItemsList
 * List of line items for an exposure.
 */
export type ExposureLineItemsList =
  ExposureLineItemsListLineItemWithInvoiceInfo[];

/**
 * LineItemWithInvoiceInfo
 * Line item with associated invoice information.
 */
export interface ExposureLineItemsListLineItemWithInvoiceInfo {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: ExposureLineItemsListCoverageDecisionOption;
  /** Coverage Id */
  coverage_id: number | null;
  /** Coverage Key */
  coverage_key: string | null;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description: string;
  /** Document Id */
  document_id: number;
  /**
   * Entry Type
   * @default "line_item"
   */
  entry_type?: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /** Invoice Id */
  invoice_id: number;
  invoice_processing_type: ExposureLineItemsListInvoiceProcessingType;
  /**
   * Is Depreciation Overridden
   * @default false
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default false
   */
  is_locked?: boolean;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /** Line Item Id */
  line_item_id: number;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: ExposureLineItemsListPayableType | null;
  /**
   * Payment Financial Status
   * @default null
   */
  payment_financial_status?: string | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * ExposureLineItemsWithSummary
 * Exposure line items with settlement summary for the DA view.
 */
export interface ExposureLineItemsWithSummary {
  /** Line Items */
  line_items: ExposureLineItemsWithSummaryLineItemWithInvoiceInfo[];
  /**
   * Parameters for the settlement formula, enabling frontend recalculation on edit.
   *
   * The backend owns which rate/deductible/flag applies (business logic).
   * The frontend uses these to recompute the overall settlement instantly when line items change.
   * Only sum(covered_amount) per payable_type changes during editing; all other params are exposure-level.
   */
  settlement_params: ExposureLineItemsWithSummarySettlementParams;
  /** Summary */
  summary: ExposureLineItemsWithSummarySummaryItemResponse[];
}

/**
 * LineItemWithInvoiceInfo
 * Line item with associated invoice information.
 */
export interface ExposureLineItemsWithSummaryLineItemWithInvoiceInfo {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: ExposureLineItemsWithSummaryCoverageDecisionOption;
  /** Coverage Id */
  coverage_id: number | null;
  /** Coverage Key */
  coverage_key: string | null;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Description */
  description: string;
  /** Document Id */
  document_id: number;
  /**
   * Entry Type
   * @default "line_item"
   */
  entry_type?: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /** Invoice Id */
  invoice_id: number;
  invoice_processing_type: ExposureLineItemsWithSummaryInvoiceProcessingType;
  /**
   * Is Depreciation Overridden
   * @default false
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default false
   */
  is_locked?: boolean;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /** Line Item Id */
  line_item_id: number;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: ExposureLineItemsWithSummaryPayableType | null;
  /**
   * Payment Financial Status
   * @default null
   */
  payment_financial_status?: string | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * SettlementParams
 * Parameters for the settlement formula, enabling frontend recalculation on edit.
 *
 * The backend owns which rate/deductible/flag applies (business logic).
 * The frontend uses these to recompute the overall settlement instantly when line items change.
 * Only sum(covered_amount) per payable_type changes during editing; all other params are exposure-level.
 */
export interface ExposureLineItemsWithSummarySettlementParams {
  /** Coinsurance Insurer Percentage */
  coinsurance_insurer_percentage: number;
  /** Deductible */
  deductible: number;
  /** Has Co Insurance */
  has_co_insurance: boolean;
  /** Has Deductible */
  has_deductible: boolean;
  /** Subtotal Includes Expenses */
  subtotal_includes_expenses: boolean;
}

/**
 * SummaryItemResponse
 * A single item in the ordered settlement summary.
 */
export interface ExposureLineItemsWithSummarySummaryItemResponse {
  /** Display */
  display: boolean;
  /** Key */
  key: string;
  /** Label */
  label: string;
  /** Value */
  value: number;
}

/**
 * ExposureReservesJsonParams
 * Sets a reserve, as a total or split into its sub-reserves, not both.
 */
export interface ExposureReservesJsonParams {
  /**
   * Currency
   * The reserve's currency: the policy's.
   * @default null
   */
  currency?: string | null;
  /**
   * Reserve Amount
   * The new reserve. Send this or sub_reserve_amounts.
   * @default null
   */
  reserve_amount?: number | null;
  /**
   * Reserve Change Reason
   * Why the reserve changed.
   * @default null
   */
  reserve_change_reason?: string | null;
  /**
   * Sub Reserve Amounts
   * The new reserve split by sub-reserve key; the reserve is their sum. Send this or reserve_amount.
   * @default null
   */
  sub_reserve_amounts?: Record<string, number> | null;
}

/**
 * ExposureRuleCreateRequest
 * Request body for creating an exposure rule.
 */
export interface ExposureRuleCreateRequest {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Coverage Key */
  coverage_key: string;
  /**
   * Display Name
   * @minLength 1
   */
  display_name: string;
  /**
   * Expenses Reserve
   * @min 0
   * @default 0
   */
  expenses_reserve?: number;
  /**
   * Expenses Sub Reserves
   * @default null
   */
  expenses_sub_reserves?: Record<string, number> | null;
  /**
   * Id
   * @default null
   */
  id?: null;
  /**
   * Indemnity Reserve
   * @min 0
   * @default 0
   */
  indemnity_reserve?: number;
  /**
   * Indemnity Sub Reserves
   * @default null
   */
  indemnity_sub_reserves?: Record<string, number> | null;
  /**
   * Involved Parties
   * @minItems 1
   */
  involved_parties: string[];
  /**
   * Lob
   * @minLength 1
   */
  lob: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
  /**
   * Use Stat Reserve Configuration
   * @default false
   */
  use_stat_reserve_configuration?: boolean;
}

/** ExposureRuleDTOList */
export type ExposureRuleDTOList = ExposureRuleDTOListExposureRuleDTO[];

/**
 * ExposureRuleDTO
 * Response DTO for an exposure rule.
 */
export interface ExposureRuleDTOListExposureRuleDTO {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Coverage Key */
  coverage_key: string;
  /** Coverage Name */
  coverage_name: string;
  /** Display Name */
  display_name: string;
  /**
   * Event Key
   * @default null
   */
  event_key?: string | null;
  /**
   * Expenses Reserve
   * @default null
   */
  expenses_reserve?: number | null;
  /**
   * Expenses Sub Reserves
   * @default null
   */
  expenses_sub_reserves?: Record<string, any> | null;
  /** Id */
  id: number | string;
  /**
   * Indemnity Reserve
   * @default null
   */
  indemnity_reserve?: number | null;
  /**
   * Indemnity Sub Reserves
   * @default null
   */
  indemnity_sub_reserves?: Record<string, any> | null;
  /**
   * Involved Parties
   * @default null
   */
  involved_parties?: string[] | null;
  /**
   * Involved Parties Summary
   * @default null
   */
  involved_parties_summary?: string | null;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Lobs */
  lobs: string[];
  /** Priority */
  priority: number;
  /** Strategy */
  strategy: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /** Use Stat Reserve Configuration */
  use_stat_reserve_configuration: boolean;
}

/**
 * ExposureRuleUpdateRequest
 * Request body for updating an exposure rule.
 */
export interface ExposureRuleUpdateRequest {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Coverage Key */
  coverage_key: string;
  /**
   * Display Name
   * @minLength 1
   */
  display_name: string;
  /**
   * Expenses Reserve
   * @min 0
   * @default 0
   */
  expenses_reserve?: number;
  /**
   * Expenses Sub Reserves
   * @default null
   */
  expenses_sub_reserves?: Record<string, number> | null;
  /**
   * Id
   * @default null
   */
  id?: null;
  /**
   * Indemnity Reserve
   * @min 0
   * @default 0
   */
  indemnity_reserve?: number;
  /**
   * Indemnity Sub Reserves
   * @default null
   */
  indemnity_sub_reserves?: Record<string, number> | null;
  /**
   * Involved Parties
   * @minItems 1
   */
  involved_parties: string[];
  /**
   * Lob
   * @minLength 1
   */
  lob: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Use Stat Reserve Configuration
   * @default false
   */
  use_stat_reserve_configuration?: boolean;
}

/**
 * ExposureRulesConfigInfo
 * The organization's exposure-rule settings, as the configuration screen sees them.
 */
export interface ExposureRulesConfigInfo {
  /** Require Coverage For Automatic Exposures */
  require_coverage_for_automatic_exposures: boolean;
}

/** ExtendedPaymentsConfigurationResponse */
export interface ExtendedPaymentsConfigurationResponse {
  additional_details: ExtendedPaymentsConfigurationResponsePaymentsConfigurationAdditionalDetails;
  payments_configuration: ExtendedPaymentsConfigurationResponsePaymentsConfigurationResponse;
}

/**
 * MultiCurrencyConfiguration
 * Configuration model for multi-currency payment settings.
 */
export interface ExtendedPaymentsConfigurationResponseMultiCurrencyConfiguration {
  /**
   * Organization Currencies
   * List of allowed currency codes for the organization
   * @default null
   */
  organization_currencies?:
    | (
        | "AED"
        | "AFN"
        | "ALL"
        | "AMD"
        | "AOA"
        | "ARS"
        | "AUD"
        | "AZN"
        | "BAM"
        | "BBD"
        | "BDT"
        | "BGN"
        | "BHD"
        | "BIF"
        | "BND"
        | "BOB"
        | "BRL"
        | "BSD"
        | "BTN"
        | "BWP"
        | "BYN"
        | "BZD"
        | "CAD"
        | "CDF"
        | "CHF"
        | "CLP"
        | "CNY"
        | "COP"
        | "CRC"
        | "CUP"
        | "CVE"
        | "CZK"
        | "DJF"
        | "DKK"
        | "DOP"
        | "DZD"
        | "EGP"
        | "ERN"
        | "ETB"
        | "EUR"
        | "FJD"
        | "GBP"
        | "GEL"
        | "GHS"
        | "GMD"
        | "GNF"
        | "GTQ"
        | "GYD"
        | "HKD"
        | "HNL"
        | "HRK"
        | "HTG"
        | "HUF"
        | "IDR"
        | "ILS"
        | "INR"
        | "IQD"
        | "IRR"
        | "ISK"
        | "JMD"
        | "JOD"
        | "JPY"
        | "KES"
        | "KGS"
        | "KHR"
        | "KMF"
        | "KRW"
        | "KWD"
        | "KZT"
        | "LAK"
        | "LBP"
        | "LKR"
        | "LRD"
        | "LSL"
        | "LYD"
        | "MAD"
        | "MDL"
        | "MGA"
        | "MKD"
        | "MMK"
        | "MNT"
        | "MUR"
        | "MVR"
        | "MWK"
        | "MXN"
        | "MYR"
        | "MZN"
        | "NAD"
        | "NGN"
        | "NIO"
        | "NOK"
        | "NPR"
        | "NZD"
        | "OMR"
        | "PAB"
        | "PEN"
        | "PGK"
        | "PHP"
        | "PKR"
        | "PLN"
        | "PYG"
        | "QAR"
        | "RON"
        | "RSD"
        | "RWF"
        | "SAR"
        | "SBD"
        | "SCR"
        | "SDG"
        | "SEK"
        | "SGD"
        | "SLL"
        | "SOS"
        | "SRD"
        | "STP"
        | "SYP"
        | "SZL"
        | "THB"
        | "TJS"
        | "TMT"
        | "TND"
        | "TOP"
        | "TRY"
        | "TTD"
        | "TWD"
        | "TZS"
        | "UAH"
        | "UGX"
        | "USD"
        | "UYU"
        | "UZS"
        | "VES"
        | "VND"
        | "VUV"
        | "WST"
        | "XAF"
        | "XAG"
        | "XAU"
        | "XOF"
        | "XPD"
        | "XPT"
        | "ZAR"
        | "ZMW"
        | "ZWL"
      )[]
    | null;
  /**
   * Sub Organizations
   * List of sub-organization currency configurations
   * @default null
   */
  sub_organizations?:
    | ExtendedPaymentsConfigurationResponseSubOrganizationCurrencyConfig[]
    | null;
}

/** PaymentMethodConfigurationResponse */
export interface ExtendedPaymentsConfigurationResponsePaymentMethodConfigurationResponse {
  /** Id */
  id: number;
  /** Is Disabled */
  is_disabled: boolean;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /** Method Configuration */
  method_configuration: Record<string, any>;
  /** Organization Id */
  organization_id: number;
  /** Payment Method */
  payment_method: string;
  /**
   * Payment Method Display Name
   * @default null
   */
  payment_method_display_name?: string | null;
  /**
   * Payment Method External Id
   * @default null
   */
  payment_method_external_id?: string | null;
  /** Payments Configuration Id */
  payments_configuration_id: number;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** PaymentsConfigurationAdditionalDetails */
export interface ExtendedPaymentsConfigurationResponsePaymentsConfigurationAdditionalDetails {
  /** Is One Inc Configured */
  is_one_inc_configured: boolean;
  /** Is Stripe Configured */
  is_stripe_configured: boolean;
  /** Is Vitesse Configured */
  is_vitesse_configured: boolean;
}

/** PaymentsConfigurationResponse */
export interface ExtendedPaymentsConfigurationResponsePaymentsConfigurationResponse {
  /**
   * Additional Approving User Ids
   * @default null
   */
  additional_approving_user_ids?: any[] | null;
  /**
   * Additional Submitting User Ids
   * @default null
   */
  additional_submitting_user_ids?: any[] | null;
  /**
   * Adjust Reserve After Payment Cancellation
   * @default null
   */
  adjust_reserve_after_payment_cancellation?: boolean | null;
  /**
   * Adjust Reserve Includes Deductible
   * @default null
   */
  adjust_reserve_includes_deductible?: boolean | null;
  /**
   * Allow Claim Multi Currency
   * @default null
   */
  allow_claim_multi_currency?: boolean | null;
  /**
   * Allow Indemnity Payments Only For Existing Property Owner
   * @default null
   */
  allow_indemnity_payments_only_for_existing_property_owner?: boolean | null;
  /**
   * Allow Multiple Pending Payment Requests
   * @default null
   */
  allow_multiple_pending_payment_requests?: boolean | null;
  /**
   * Amounts Basis
   * @default null
   */
  amounts_basis?: "gross" | "net" | null;
  /**
   * Cap Recoveries At Total Paid
   * @default null
   */
  cap_recoveries_at_total_paid?: "off" | "warn" | "block" | null;
  /**
   * Contact Au Tfn Mandatory Coverages
   * @default null
   */
  contact_au_tfn_mandatory_coverages?: string[] | null;
  /**
   * Disable Adjuster Modifying Self Payment Limits
   * @default null
   */
  disable_adjuster_modifying_self_payment_limits?: boolean | null;
  /**
   * Display Net Amounts
   * @default null
   */
  display_net_amounts?: boolean | null;
  /**
   * Duplicate Payments Action
   * @default null
   */
  duplicate_payments_action?: string | null;
  /**
   * Duplicate Payments Level Of Verification
   * @default null
   */
  duplicate_payments_level_of_verification?: string | null;
  /**
   * Duplicate Payments Verification Initialized
   * @default null
   */
  duplicate_payments_verification_initialized?: boolean | null;
  /**
   * Enable 1099 Fields
   * @default null
   */
  enable_1099_fields?: boolean | null;
  /**
   * Enable Approval Screen
   * @default null
   */
  enable_approval_screen?: boolean | null;
  /**
   * Enable Duplicate Payments Verification
   * @default null
   */
  enable_duplicate_payments_verification?: boolean | null;
  /**
   * Enable Paying Expenses If Coverage Issue Exists
   * @default null
   */
  enable_paying_expenses_if_coverage_issue_exists?: boolean | null;
  /**
   * Enable Paying Expenses If Exposure Is Closed
   * @default null
   */
  enable_paying_expenses_if_exposure_is_closed?: boolean | null;
  /**
   * Enable Paying Indemnity If Exposure Is Closed
   * @default null
   */
  enable_paying_indemnity_if_exposure_is_closed?: boolean | null;
  /**
   * Enable Sanctions Io Integration
   * @default null
   */
  enable_sanctions_io_integration?: boolean | null;
  /**
   * Enable Split General Recovery
   * @default null
   */
  enable_split_general_recovery?: boolean | null;
  /**
   * Enable Submission Screen
   * @default null
   */
  enable_submission_screen?: boolean | null;
  /**
   * Enable Trusted Payee Payments
   * @default null
   */
  enable_trusted_payee_payments?: boolean | null;
  /**
   * Enable Uk Bank Account Validation
   * @default null
   */
  enable_uk_bank_account_validation?: boolean | null;
  /**
   * Expenses Limit For Closed Exposure
   * @default null
   */
  expenses_limit_for_closed_exposure?: number | null;
  /**
   * Expenses Sub Reserves Config
   * @default null
   */
  expenses_sub_reserves_config?: Record<string, any> | null;
  /**
   * General Recoveries Configuration
   * @default null
   */
  general_recoveries_configuration?: Record<string, any> | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Include Vat In Finances Summary
   * @default null
   */
  include_vat_in_finances_summary?: boolean | null;
  /**
   * Include Vat In Payment Screen
   * @default null
   */
  include_vat_in_payment_screen?: boolean | null;
  /**
   * Indemnity Limit For Closed Exposure
   * @default null
   */
  indemnity_limit_for_closed_exposure?: number | null;
  /**
   * Is Anticipated Amount Included In Recoveries Calc
   * @default null
   */
  is_anticipated_amount_included_in_recoveries_calc?: boolean | null;
  /**
   * Is Expenses Limit For Closed Exposure Enabled
   * @default null
   */
  is_expenses_limit_for_closed_exposure_enabled?: boolean | null;
  /**
   * Is Expenses Sub Reserves Config Enabled
   * @default null
   */
  is_expenses_sub_reserves_config_enabled?: boolean | null;
  /**
   * Is General Recoveries Enabled
   * @default null
   */
  is_general_recoveries_enabled?: boolean | null;
  /**
   * Is Indemnity Limit For Closed Exposure Enabled
   * @default null
   */
  is_indemnity_limit_for_closed_exposure_enabled?: boolean | null;
  /**
   * Is Multiple Sub Reserve Payments Enabled
   * @default null
   */
  is_multiple_sub_reserve_payments_enabled?: boolean | null;
  /**
   * Is Org Level Configuration
   * @default null
   */
  is_org_level_configuration?: boolean | null;
  /**
   * Is Payment Method Auto Fill Mail To From Payee
   * @default null
   */
  is_payment_method_auto_fill_mail_to_from_payee?: boolean | null;
  /**
   * Is Prefill Reserve Amounts Capability Enabled
   * @default null
   */
  is_prefill_reserve_amounts_capability_enabled?: boolean | null;
  /**
   * Is Recoveries Included In Incurred Calc
   * @default null
   */
  is_recoveries_included_in_incurred_calc?: boolean | null;
  /**
   * Is Split Routing Enabled
   * @default null
   */
  is_split_routing_enabled?: boolean | null;
  /**
   * Is Sub Reserves Enabled
   * @default null
   */
  is_sub_reserves_enabled?: boolean | null;
  /** @default null */
  multi_currency_configuration?: ExtendedPaymentsConfigurationResponseMultiCurrencyConfiguration | null;
  /**
   * Ofac Fuzzy Match Enabled
   * @default null
   */
  ofac_fuzzy_match_enabled?: boolean | null;
  /**
   * Ofac Fuzzy Match Score
   * @default null
   */
  ofac_fuzzy_match_score?: number | null;
  /**
   * Ofac Is Send Address Fields Enabled
   * @default null
   */
  ofac_is_send_address_fields_enabled?: boolean | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Payment Method Configurations
   * @default null
   */
  payment_method_configurations?:
    | ExtendedPaymentsConfigurationResponsePaymentMethodConfigurationResponse[]
    | null;
  /**
   * Prefill Indemnity Payee With Claimant
   * @default null
   */
  prefill_indemnity_payee_with_claimant?: boolean | null;
  /**
   * Reduce Reserves By Net Paid
   * @default null
   */
  reduce_reserves_by_net_paid?: boolean | null;
  /**
   * Require Approval For Every Payment
   * @default null
   */
  require_approval_for_every_payment?: boolean | null;
  /**
   * Require Tin For Indemnity Payees
   * @default null
   */
  require_tin_for_indemnity_payees?: boolean | null;
  /**
   * Require Verification For Contact Au Tfn Edit
   * @default null
   */
  require_verification_for_contact_au_tfn_edit?: boolean | null;
  /**
   * Require Verification For Contact Finance Edit
   * @default null
   */
  require_verification_for_contact_finance_edit?: boolean | null;
  /**
   * Sanctions Io Api Key Output
   * @default null
   */
  sanctions_io_api_key_output?: string | null;
  /**
   * Sanctions Io Data Sources
   * @default null
   */
  sanctions_io_data_sources?: string[] | null;
  /**
   * Sanctions Io Include Address
   * @default null
   */
  sanctions_io_include_address?: boolean | null;
  /**
   * Sanctions Io Min Score
   * @default null
   */
  sanctions_io_min_score?: number | null;
  /**
   * Should Disable Payment Exceeding Reserve
   * @default null
   */
  should_disable_payment_exceeding_reserve?: boolean | null;
  /**
   * Skip Approval For Record Only Payments
   * @default null
   */
  skip_approval_for_record_only_payments?: boolean | null;
}

/**
 * SubOrganizationCurrencyConfig
 * Configuration for a specific sub-organization's currency settings.
 */
export interface ExtendedPaymentsConfigurationResponseSubOrganizationCurrencyConfig {
  /**
   * Currencies
   * List of allowed currency codes for this sub-organization
   */
  currencies: (
    | "AED"
    | "AFN"
    | "ALL"
    | "AMD"
    | "AOA"
    | "ARS"
    | "AUD"
    | "AZN"
    | "BAM"
    | "BBD"
    | "BDT"
    | "BGN"
    | "BHD"
    | "BIF"
    | "BND"
    | "BOB"
    | "BRL"
    | "BSD"
    | "BTN"
    | "BWP"
    | "BYN"
    | "BZD"
    | "CAD"
    | "CDF"
    | "CHF"
    | "CLP"
    | "CNY"
    | "COP"
    | "CRC"
    | "CUP"
    | "CVE"
    | "CZK"
    | "DJF"
    | "DKK"
    | "DOP"
    | "DZD"
    | "EGP"
    | "ERN"
    | "ETB"
    | "EUR"
    | "FJD"
    | "GBP"
    | "GEL"
    | "GHS"
    | "GMD"
    | "GNF"
    | "GTQ"
    | "GYD"
    | "HKD"
    | "HNL"
    | "HRK"
    | "HTG"
    | "HUF"
    | "IDR"
    | "ILS"
    | "INR"
    | "IQD"
    | "IRR"
    | "ISK"
    | "JMD"
    | "JOD"
    | "JPY"
    | "KES"
    | "KGS"
    | "KHR"
    | "KMF"
    | "KRW"
    | "KWD"
    | "KZT"
    | "LAK"
    | "LBP"
    | "LKR"
    | "LRD"
    | "LSL"
    | "LYD"
    | "MAD"
    | "MDL"
    | "MGA"
    | "MKD"
    | "MMK"
    | "MNT"
    | "MUR"
    | "MVR"
    | "MWK"
    | "MXN"
    | "MYR"
    | "MZN"
    | "NAD"
    | "NGN"
    | "NIO"
    | "NOK"
    | "NPR"
    | "NZD"
    | "OMR"
    | "PAB"
    | "PEN"
    | "PGK"
    | "PHP"
    | "PKR"
    | "PLN"
    | "PYG"
    | "QAR"
    | "RON"
    | "RSD"
    | "RWF"
    | "SAR"
    | "SBD"
    | "SCR"
    | "SDG"
    | "SEK"
    | "SGD"
    | "SLL"
    | "SOS"
    | "SRD"
    | "STP"
    | "SYP"
    | "SZL"
    | "THB"
    | "TJS"
    | "TMT"
    | "TND"
    | "TOP"
    | "TRY"
    | "TTD"
    | "TWD"
    | "TZS"
    | "UAH"
    | "UGX"
    | "USD"
    | "UYU"
    | "UZS"
    | "VES"
    | "VND"
    | "VUV"
    | "WST"
    | "XAF"
    | "XAG"
    | "XAU"
    | "XOF"
    | "XPD"
    | "XPT"
    | "ZAR"
    | "ZMW"
    | "ZWL"
  )[];
  /**
   * Enabled
   * Whether multi-currency is enabled for this sub-organization
   */
  enabled: boolean;
  /**
   * Sub Organization Id
   * ID of the sub-organization
   */
  sub_organization_id: number;
}

/** ExternalClaimNumber */
export interface ExternalClaimNumber {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** External Claim Number */
  external_claim_number: string;
  /**
   * External Contact Full Name
   * @default null
   */
  external_contact_full_name?: string | null;
  /**
   * External Contact Id
   * @default null
   */
  external_contact_id?: number | null;
  /** Id */
  id: number;
}

/** ExternalClaimNumberList */
export type ExternalClaimNumberList =
  ExternalClaimNumberListExternalClaimNumber[];

/** ExternalClaimNumber */
export interface ExternalClaimNumberListExternalClaimNumber {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** External Claim Number */
  external_claim_number: string;
  /**
   * External Contact Full Name
   * @default null
   */
  external_contact_full_name?: string | null;
  /**
   * External Contact Id
   * @default null
   */
  external_contact_id?: number | null;
  /** Id */
  id: number;
}

/**
 * ExternalClaimNumberListResponse
 * Response model for listing external claim numbers.
 */
export interface ExternalClaimNumberListResponse {
  /**
   * Records
   * List of external claim numbers for the claim
   */
  records: ExternalClaimNumberListResponseExternalClaimNumberResponse[];
}

/** ContactEmailModel */
export interface ExternalClaimNumberListResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface ExternalClaimNumberListResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: ExternalClaimNumberListResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: ExternalClaimNumberListResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface ExternalClaimNumberListResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * ExternalClaimNumberResponse
 * Response model for a single external claim number.
 */
export interface ExternalClaimNumberListResponseExternalClaimNumberResponse {
  /**
   * Api Uid
   * Unique API identifier for the external claim number
   */
  api_uid: string;
  /**
   * Contacts
   * List of contacts associated with this external claim number
   */
  contacts?: ExternalClaimNumberListResponseContactModel[];
  /**
   * Description
   * Optional description for the external claim number
   * @default null
   */
  description?: string | null;
  /**
   * External Claim Number
   * The external claim number value
   */
  external_claim_number: string;
  /**
   * External Contact Ref Id
   * Reference ID of the associated external contact in the contacts list
   * @default null
   */
  external_contact_ref_id?: string | null;
}

/**
 * ExternalClaimNumberResponse
 * Response model for a single external claim number.
 */
export interface ExternalClaimNumberResponse {
  /**
   * Api Uid
   * Unique API identifier for the external claim number
   */
  api_uid: string;
  /**
   * Contacts
   * List of contacts associated with this external claim number
   */
  contacts?: ExternalClaimNumberResponseContactModel[];
  /**
   * Description
   * Optional description for the external claim number
   * @default null
   */
  description?: string | null;
  /**
   * External Claim Number
   * The external claim number value
   */
  external_claim_number: string;
  /**
   * External Contact Ref Id
   * Reference ID of the associated external contact in the contacts list
   * @default null
   */
  external_contact_ref_id?: string | null;
}

/** ContactEmailModel */
export interface ExternalClaimNumberResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface ExternalClaimNumberResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: ExternalClaimNumberResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: ExternalClaimNumberResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface ExternalClaimNumberResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * ExternalDocumentTypeCreateRequest
 * Request schema for external POST /document_types (NGTPA-23515).
 *
 * ``configured_fields`` reuses the canonical :class:`ConfiguredField` so the wire
 * shape, in-memory shape, and JSONB storage shape are all identical (id/desc/type/
 * mandatory/options/clive_instructions/...). Per-field validation lives on
 * ``ConfiguredField`` and on ``DocumentTypeParams``, which the route builds from
 * this request; the manager enforces the list-level uniqueness rule via
 * ``_validate_configured_fields_uniqueness`` so every create path (internal,
 * external, migration) shares one source of truth.
 */
export interface ExternalDocumentTypeCreateRequest {
  /**
   * Configured Fields
   * @default null
   */
  configured_fields?: ExternalDocumentTypeCreateRequestConfiguredField[] | null;
  /** Description */
  description: string;
  /** Display Name */
  display_name: string;
  /**
   * Instructions
   * @default null
   */
  instructions?: string | null;
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean | null;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean | null;
  /** Key */
  key: string;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
}

/** ConfiguredField */
export interface ExternalDocumentTypeCreateRequestConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?:
    | ExternalDocumentTypeCreateRequestConfiguredFieldSelectOption[]
    | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: ExternalDocumentTypeCreateRequestConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface ExternalDocumentTypeCreateRequestConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/** ExternalDocumentTypeResponseDict */
export type ExternalDocumentTypeResponseDict = Record<
  string,
  ExternalDocumentTypeResponseDictExternalDocumentTypeResponse
>;

/** ConfiguredField */
export interface ExternalDocumentTypeResponseDictConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?:
    | ExternalDocumentTypeResponseDictConfiguredFieldSelectOption[]
    | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: ExternalDocumentTypeResponseDictConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface ExternalDocumentTypeResponseDictConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/** ExternalDocumentTypeResponse */
export interface ExternalDocumentTypeResponseDictExternalDocumentTypeResponse {
  /** Configured Fields */
  configured_fields?: ExternalDocumentTypeResponseDictConfiguredField[];
  /** Description */
  description: string;
  /** Display Name */
  display_name: string;
  /**
   * Instructions
   * @default ""
   */
  instructions?: string;
  /** Key */
  key: string;
}

/**
 * ExternalToolConfigQuery
 * Query params selecting the scope for PUT / DELETE (``sub_organization_id`` None = org-level).
 *
 * Validated by spectree so a malformed value returns 400, not an uncaught ``ValueError`` (500).
 * Mirrors ``claim_action_configuration``'s ``ListClaimActionsQuery``.
 */
export interface ExternalToolConfigQuery {
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * ExternalToolConfigResponse
 * List item / create result / update result. ``tool_title`` is enriched from the registry.
 */
export interface ExternalToolConfigResponse {
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Payload Fields */
  payload_fields: Record<string, any>[];
  /** Query Params */
  query_params?: Record<string, string>;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /** Tool Name */
  tool_name: string;
  /** Tool Title */
  tool_title: string;
  /** Url */
  url: string;
}

/** ExternalToolConfigResponseList */
export type ExternalToolConfigResponseList =
  ExternalToolConfigResponseListExternalToolConfigResponse[];

/**
 * ExternalToolConfigResponse
 * List item / create result / update result. ``tool_title`` is enriched from the registry.
 */
export interface ExternalToolConfigResponseListExternalToolConfigResponse {
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Payload Fields */
  payload_fields: Record<string, any>[];
  /** Query Params */
  query_params?: Record<string, string>;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /** Tool Name */
  tool_name: string;
  /** Tool Title */
  tool_title: string;
  /** Url */
  url: string;
}

/** FNOLInboxConfigUpdatePayload */
export interface FNOLInboxConfigUpdatePayload {
  /**
   * Fnol Email Inbox Name
   * The name for the FNOL email inbox.
   */
  fnol_email_inbox_name: string | null;
  /**
   * Should Send Fnol Email Inbox To Clive
   * Boolean flag indicating if FNOL emails for this inbox should be sent to Clive.
   */
  should_send_fnol_email_inbox_to_clive: boolean;
}

/** FNOLInboxErrorResponse */
export interface FNOLInboxErrorResponse {
  /**
   * Message
   * Description of the error.
   */
  message: string;
  /**
   * Status
   * @default "error"
   */
  status?: string;
}

/** FieldDefinitionList */
export type FieldDefinitionList = FieldDefinitionListFieldDefinition[];

/**
 * EnumOption
 * A selectable value for a string-shaped field (select, multiselect, us_state_select, etc.).
 */
export interface FieldDefinitionListEnumOption {
  /** Label */
  label: string;
  /** Value */
  value: string;
}

/**
 * FieldDefinition
 * Describes a queryable field exposed by a ContextProvider to the FE QueryBuilder.
 *
 * Wire-serializable Pydantic model. The provider populates `enum_values` and `hints`
 * concretely at request time — no resolvers, no callables.
 *
 * See DR §5.8 (DTO shape), §5.9 (FieldType), §5.11 (source-namespaced paths), §5.13 (hierarchical).
 */
export interface FieldDefinitionListFieldDefinition {
  /**
   * Enum Values
   * @default null
   */
  enum_values?: FieldDefinitionListEnumOption[] | null;
  /**
   * Type of a queryable field. Mirrors `ConfiguredFieldType` plus `datetime` / `hierarchical`.
   *
   * - `datetime` — distinct from `date` and `time`; ISO datetime string semantics in CEL.
   * - `hierarchical` — composite parent+children value; rendered via a parent-select +
   *   dependent-child-multiselect FE adapter; emitted as `parent == 'X' && child in [...]`
   *   by the CEL compiler. See DR §5.13.
   * - `collection` — a list of rows a leaf *quantifies over* rather than compares:
   *   the leaf carries a `match` mode and a nested group of predicates on the row's own
   *   elements, and the compiler emits a CEL comprehension (`path.exists(_c0, …)`). The only
   *   type whose leaf has no scalar operand space at all, which is why the FE offers it no
   *   operators. See `cel/collections.py` for the element/alias scheme.
   * - `user` — a user's id. Compared only with another `user` field (`=` / `!=` against an
   *   `{anchor: <path>}` value) or tested for presence, never with a literal: an id is not
   *   something an author types, and a rule naming one would stop matching when the user leaves.
   */
  field_type: FieldDefinitionListFieldType;
  /** Group */
  group?: string[];
  /** Hints */
  hints?: Record<string, any>;
  /** Label */
  label: string;
  /** Path */
  path: string;
  /**
   * Source
   * @default "api"
   */
  source?: string;
}

/** FnolAnalysisExtra */
export interface FnolAnalysisExtra {
  /**
   * Related Claims
   * @default []
   */
  related_claims?: FnolAnalysisExtraRelatedClaim[] | null;
  /** @default null */
  related_claims_stats?: FnolAnalysisExtraRelatedClaimsStats | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** RelatedClaim */
export interface FnolAnalysisExtraRelatedClaim {
  /** Claim Id */
  claim_id: number;
  /** Claim Id Display */
  claim_id_display: string;
}

/** RelatedClaimsStats */
export interface FnolAnalysisExtraRelatedClaimsStats {
  /** Len After Fuzzy */
  len_after_fuzzy: number;
  /** Len Exact Found */
  len_exact_found: number;
  /**
   * Was Fuzzy Successful
   * @default true
   */
  was_fuzzy_successful?: boolean;
}

/**
 * FnolAnalysisRequest
 * Request schema for FNOL comparison analysis
 */
export interface FnolAnalysisRequest {
  /**
   * Ai Data
   * The original AI-generated FNOL data
   */
  ai_data: Record<string, any>;
  /**
   * Incident Config
   * Optional incident configuration for field metadata lookup (preconfigured vs client_configured, is_required)
   * @default null
   */
  incident_config?: Record<string, any> | null;
  /**
   * Line Of Business
   * Line of business (e.g., 'auto_claim')
   */
  line_of_business: string;
  /**
   * Organization Region
   * Optional organization region code (e.g., 'AU'). Filters out contact country additions matching this value.
   * @default null
   */
  organization_region?: string | null;
  /**
   * User Data
   * The user-edited FNOL data from the UI
   */
  user_data: Record<string, any>;
}

/** FnolDraftItemIdsParams */
export interface FnolDraftItemIdsParams {
  /**
   * Limit
   * @default null
   */
  limit?: number | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Sort By
   * @default null
   */
  sort_by?: string | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** FnolDraftItemsByIdsParams */
export interface FnolDraftItemsByIdsParams {
  /** Ids */
  ids: number[];
}

/**
 * FnolFromAiRequest
 * Request schema for FNOL from AI.
 */
export interface FnolFromAiRequest {
  /** FnolDataV2 */
  fnol_data_v2: FnolFromAiRequestFnolDataV2;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * Address
 * Address
 */
export interface FnolFromAiRequestAddress {
  /** Address Line 1 */
  address_line_1: string | null;
  /** Address Line 2 */
  address_line_2: string | null;
  /** City */
  city: string | null;
  /** Country */
  country: string | null;
  /** State */
  state: string | null;
  /** Zip Code */
  zip_code: string | null;
}

/**
 * CatCodeInformation
 * CatCodeInformation
 */
export interface FnolFromAiRequestCatCodeInformation {
  /** Cat Code Id */
  cat_code_id: string;
  /** Confidence Level */
  confidence_level: number;
  /** Explanation */
  explanation: string;
}

/**
 * ContactDetails
 * ContactDetails
 */
export interface FnolFromAiRequestContactDetails {
  /**
   * Addresses
   * @default null
   */
  addresses?: FnolFromAiRequestAddress[] | null;
  /**
   * Emails
   * @default null
   */
  emails?: string[] | null;
  /** First Name */
  first_name: string | null;
  /** Last Name */
  last_name: string | null;
  /** Middle Name */
  middle_name: string | null;
  /**
   * Phone Numbers
   * @default null
   */
  phone_numbers?: string[] | null;
}

/**
 * EntityInformation
 * EntityInformation
 */
export interface FnolFromAiRequestEntityInformation {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Claim Role
   * @default null
   */
  claim_role?: string | null;
  contact_details: FnolFromAiRequestContactDetails | null;
  /** Description */
  description: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /** Id */
  id: string;
  /** Identifier */
  identifier: string | null;
  /** Identifier Type */
  identifier_type: string | null;
  /** Name */
  name: string;
  /** EntityType */
  type: FnolFromAiRequestEntityType;
}

/**
 * FnolDataV2
 * FnolDataV2
 */
export interface FnolFromAiRequestFnolDataV2 {
  /** Entities */
  entities: FnolFromAiRequestEntityInformation[];
  /** Fnol Data */
  fnol_data: Record<string, any>;
  /** FnolGeneralInformation */
  fnol_general_information: FnolFromAiRequestFnolGeneralInformation;
  /**
   * Fnol Summary
   * @default null
   */
  fnol_summary?: string | null;
  /** @default null */
  policy?: FnolFromAiRequestFnolPolicyInformation | null;
  /** @default null */
  processing_metadata?: FnolFromAiRequestFnolProcessingMetadata | null;
  /** @default null */
  triage?: FnolFromAiRequestFnolTriage | null;
}

/**
 * FnolGeneralInformation
 * FnolGeneralInformation
 */
export interface FnolFromAiRequestFnolGeneralInformation {
  /** @default null */
  cat_code?: FnolFromAiRequestCatCodeInformation | null;
  /**
   * Client Provided Line Of Business
   * The actual line of business string used for processing. May not match the enum value if a custom LOB was provided.
   * @default null
   */
  client_provided_line_of_business?: string | null;
  /**
   * Complexity
   * @default null
   */
  complexity?: string | null;
  /**
   * Datetime Of Loss
   * @format date-time
   */
  datetime_of_loss: string;
  /**
   * Datetime Reported
   * @format date-time
   */
  datetime_reported: string;
  /** Incident Description */
  incident_description: string;
  /**
   * Incident Sub Type
   * @default null
   */
  incident_sub_type?: string | null;
  /**
   * Incident Type
   * @default null
   */
  incident_type?: string | null;
  /** LineOfBusiness */
  line_of_business: FnolFromAiRequestLineOfBusiness;
  /** Preferred Contact Entity Id */
  preferred_contact_entity_id: string | null;
  /** Primary Contact Entity Id */
  primary_contact_entity_id: string | null;
}

/**
 * FnolPolicyInformation
 * FnolPolicyInformation
 */
export interface FnolFromAiRequestFnolPolicyInformation {
  /** Policy Data */
  policy_data: Record<string, any>;
  /** Policy Number */
  policy_number: string;
}

/**
 * FnolProcessingMetadata
 * Metadata about the FNOL processing pipeline versions for debugging.
 */
export interface FnolFromAiRequestFnolProcessingMetadata {
  /**
   * Incident Classifier Version
   * @default null
   */
  incident_classifier_version?: string | null;
  /**
   * Processing Mode
   * @default null
   */
  processing_mode?: string | null;
}

/**
 * FnolTriage
 * FnolTriage
 */
export interface FnolFromAiRequestFnolTriage {
  /** @default null */
  cat_code_classification?: FnolFromAiRequestCatCodeInformation | null;
  /**
   * Complexity Level
   * @default null
   */
  complexity_level?: string | null;
  /** @default null */
  coverage_analysis?: FnolFromAiRequestInitialCoverageAnalysis | null;
}

/**
 * InitialAnalysisCoverageIssue
 * InitialAnalysisCoverageIssue
 */
export interface FnolFromAiRequestInitialAnalysisCoverageIssue {
  /**
   * Confidence Level
   * A confidence level in the assessment of the issue, between 0 and 1
   */
  confidence_level: number;
  /**
   * Explanation
   * An explanation of why the issue exists
   */
  explanation: string;
  /**
   * Issue Description
   * A description of the coverage issue
   */
  issue_description: string;
  /** The type of the coverage issue */
  issue_type: FnolFromAiRequestIssueType;
  /**
   * Quote From Incident
   * A brief quote from the incident details indicating the issue
   */
  quote_from_incident: string | null;
  /**
   * Quote From Policy
   * A brief quote and/or reference from the policy document or policy data indicating the issue
   */
  quote_from_policy: string | null;
}

/**
 * InitialCoverageAnalysis
 * InitialCoverageAnalysis
 */
export interface FnolFromAiRequestInitialCoverageAnalysis {
  /** Checks Preformed */
  checks_preformed: FnolFromAiRequestInitialCoverageTestResult[];
  /** Coverage Issues */
  coverage_issues: FnolFromAiRequestInitialAnalysisCoverageIssue[];
  /** Description */
  description: string;
}

/**
 * InitialCoverageTestResult
 * InitialCoverageTestResult
 */
export interface FnolFromAiRequestInitialCoverageTestResult {
  /** Did Test Pass */
  did_test_pass: boolean;
  /** Notes */
  notes: string;
  /** Test Description */
  test_description: string;
  /** Test Title */
  test_title: string;
}

/**
 * IssueType
 * The type of the coverage issue
 */
export interface FnolFromAiRequestIssueType {
  /**
   * Actual Instance
   * @default null
   */
  actual_instance?: any;
  /**
   * Any Of Schemas
   * @uniqueItems true
   * @default ["CoverageIssueType","str"]
   */
  any_of_schemas?: string[];
  /** @default null */
  anyof_schema_1_validator?: FnolFromAiRequestCoverageIssueType | null;
  /**
   * Anyof Schema 2 Validator
   * @default null
   */
  anyof_schema_2_validator?: string | null;
}

/** FnolInboxApplicableSubOrgsResponse */
export interface FnolInboxApplicableSubOrgsResponse {
  /** Applicable Sub Organizations */
  applicable_sub_organizations: FnolInboxApplicableSubOrgsResponseApplicableSubOrganization[];
}

/** ApplicableSubOrganization */
export interface FnolInboxApplicableSubOrgsResponseApplicableSubOrganization {
  /** External Id */
  external_id: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** FnolInboxAvailableInboxesForGqMoveResponse */
export interface FnolInboxAvailableInboxesForGqMoveResponse {
  /** Available Inboxes */
  available_inboxes: FnolInboxAvailableInboxesForGqMoveResponseFnolInboxConfigOption[];
  /** @default null */
  recommended_inbox?: FnolInboxAvailableInboxesForGqMoveResponseRecommendedInbox | null;
}

/** FnolInboxConfigOption */
export interface FnolInboxAvailableInboxesForGqMoveResponseFnolInboxConfigOption {
  /** Fnol Email Inbox Name */
  fnol_email_inbox_name: string;
  /** Lob */
  lob: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Sub Organization Name
   * @default null
   */
  sub_organization_name?: string | null;
}

/** RecommendedInbox */
export interface FnolInboxAvailableInboxesForGqMoveResponseRecommendedInbox {
  /** Lob */
  lob: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** FnolInboxAvailableInboxesResponse */
export interface FnolInboxAvailableInboxesResponse {
  /** Available Inboxes */
  available_inboxes: FnolInboxAvailableInboxesResponseFnolInboxConfigOption[];
}

/** FnolInboxConfigOption */
export interface FnolInboxAvailableInboxesResponseFnolInboxConfigOption {
  /** Fnol Email Inbox Name */
  fnol_email_inbox_name: string;
  /** Lob */
  lob: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Sub Organization Name
   * @default null
   */
  sub_organization_name?: string | null;
}

/** FnolInboxFeContextResponse */
export interface FnolInboxFeContextResponse {
  /** @default null */
  fnol_draft?: FnolInboxFeContextResponseFnolDraft | null;
  /**
   * Policy
   * @default null
   */
  policy?: Record<string, any> | null;
}

/** FnolDraft */
export interface FnolInboxFeContextResponseFnolDraft {
  /**
   * Creating Adjuster Id
   * @default null
   */
  creating_adjuster_id?: string | null;
  /**
   * Datetime Created
   * @format date-time
   */
  datetime_created: string;
  /** Draft */
  draft: Record<string, any>;
  /** Id */
  id: number | string;
  /**
   * Last Editing Adjuster Id
   * @default null
   */
  last_editing_adjuster_id?: string | null;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /** Organization Id */
  organization_id: number;
  /**
   * Policy Id
   * @default null
   */
  policy_id?: number | null;
  /**
   * Policy Lob
   * @default null
   */
  policy_lob?: string | null;
  /**
   * Policy Number
   * @default null
   */
  policy_number?: string | null;
  /**
   * Sub Organization Name
   * @default null
   */
  sub_organization_name?: string | null;
}

/** FnolInboxIsAllowedResponse */
export interface FnolInboxIsAllowedResponse {
  /** Is Allowed */
  is_allowed: boolean;
}

/** FnolInboxItemIdsParams */
export interface FnolInboxItemIdsParams {
  inbox_type: FnolInboxItemIdsParamsFnolInboxType;
  /**
   * Include Unknown Lob
   * @default false
   */
  include_unknown_lob?: boolean | null;
  /**
   * Include Unknown Sub Organization
   * @default false
   */
  include_unknown_sub_organization?: boolean | null;
  /**
   * Limit
   * @default null
   */
  limit?: number | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Sort By
   * @default null
   */
  sort_by?: string | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** FnolInboxItemsByIdsParams */
export interface FnolInboxItemsByIdsParams {
  /** Ids */
  ids: number[];
  /**
   * With Read Status
   * @default false
   */
  with_read_status?: boolean | null;
}

/** FnolInboxRecord */
export interface FnolInboxRecord {
  /** @default null */
  analysis_extra?: FnolInboxRecordFnolAnalysisExtra | null;
  /** Attachments */
  attachments: boolean;
  /**
   * Can Move To Gq
   * @default false
   */
  can_move_to_gq?: boolean;
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contact Full Name
   * @default null
   */
  contact_full_name?: string | null;
  /**
   * Date Received
   * @default null
   */
  date_received?: string | null;
  /** Effective Sub Org Id */
  effective_sub_org_id: number | null;
  /** Email Address */
  email_address: string;
  /** Email Communication Id */
  email_communication_id: number;
  /**
   * Email Summary
   * @default null
   */
  email_summary?: string | null;
  /** @default null */
  error_type?: FnolInboxRecordFnolTaskErrorType | null;
  /**
   * Fnol Summary
   * @default null
   */
  fnol_summary?: string | null;
  /** Id */
  id: number;
  /**
   * Is Clive Enabled For Incident Configuration
   * @default null
   */
  is_clive_enabled_for_incident_configuration?: boolean | null;
  /**
   * Is Read
   * @default null
   */
  is_read?: boolean | null;
  /** Line Of Business */
  line_of_business: string | null;
  /** Organization Id */
  organization_id: number;
  /** @default null */
  policy?: FnolInboxRecordFnolInboxPolicy | null;
  status: FnolInboxRecordFnolInboxStatus;
  /** Sub Organization Id */
  sub_organization_id: number | null;
  /**
   * Sub Organization Name
   * @default null
   */
  sub_organization_name?: string | null;
  /** Subject */
  subject: string;
  /** Was Sent To Ai Service */
  was_sent_to_ai_service: boolean;
}

/** FnolAnalysisExtra */
export interface FnolInboxRecordFnolAnalysisExtra {
  /**
   * Related Claims
   * @default []
   */
  related_claims?: FnolInboxRecordRelatedClaim[] | null;
  /** @default null */
  related_claims_stats?: FnolInboxRecordRelatedClaimsStats | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** FnolInboxPolicy */
export interface FnolInboxRecordFnolInboxPolicy {
  /**
   * Policy Data
   * @default null
   */
  policy_data?: Record<string, any> | null;
  /** Policy Number */
  policy_number: string;
}

/** RelatedClaim */
export interface FnolInboxRecordRelatedClaim {
  /** Claim Id */
  claim_id: number;
  /** Claim Id Display */
  claim_id_display: string;
}

/** RelatedClaimsStats */
export interface FnolInboxRecordRelatedClaimsStats {
  /** Len After Fuzzy */
  len_after_fuzzy: number;
  /** Len Exact Found */
  len_exact_found: number;
  /**
   * Was Fuzzy Successful
   * @default true
   */
  was_fuzzy_successful?: boolean;
}

/** FnolInboxReprocessArguments */
export interface FnolInboxReprocessArguments {
  /** Selected Policy */
  selected_policy:
    | FnolInboxReprocessArgumentsApiV1SelectedPolicySearchResult
    | FnolInboxReprocessArgumentsApiV2SelectedPolicySearchResult
    | null;
}

/** ApiV1SelectedPolicySearchResult */
export interface FnolInboxReprocessArgumentsApiV1SelectedPolicySearchResult {
  /**
   * Client
   * @default null
   */
  client?: string | null;
  /**
   * Display Names
   * @default null
   */
  display_names?: Record<string, any>[] | null;
  /**
   * Insured Contact
   * @default null
   */
  insured_contact?: Record<string, any> | null;
  /**
   * Insured Contact Full Name
   * @default null
   */
  insured_contact_full_name?: string | null;
  /**
   * Insured Contact Id
   * @default null
   */
  insured_contact_id?: string | number | null;
  /**
   * Is Claims Made
   * @default false
   */
  is_claims_made?: boolean | null;
  /**
   * Policy Data
   * @default null
   */
  policy_data?: Record<string, any> | null;
  /**
   * Policy Effective Date
   * @default null
   */
  policy_effective_date?: string | null;
  /**
   * Policy Effective Datetime
   * @default null
   */
  policy_effective_datetime?: string | null;
  /**
   * Policy Expiration Date
   * @default null
   */
  policy_expiration_date?: string | null;
  /**
   * Policy Expiration Datetime
   * @default null
   */
  policy_expiration_datetime?: string | null;
  /**
   * Policy Number
   * @default null
   */
  policy_number?: string | null;
  /**
   * Policy Type
   * @default null
   */
  policy_type?: string | null;
  /**
   * Retroactive Date
   * @default null
   */
  retroactive_date?: string | null;
  /**
   * Retroactive Datetime
   * @default null
   */
  retroactive_datetime?: string | null;
  /**
   * Runoff Provision
   * @default null
   */
  runoff_provision?: number | null;
  /**
   * Search Type
   * @default "API"
   */
  search_type?: "API";
  /**
   * Underwriting Company
   * @default ""
   */
  underwriting_company?: string;
}

/** ApiV2SelectedPolicySearchResult */
export interface FnolInboxReprocessArgumentsApiV2SelectedPolicySearchResult {
  /**
   * Display Fields
   * One entry per `display_schema` column, keyed by its `id`. Values are rendered as text.
   */
  display_fields: Record<string, string>;
  /** Display Schema */
  display_schema: FnolInboxReprocessArgumentsPolicyApiDisplaySchemaField[];
  /** Lob */
  lob: string;
  /**
   * Retrieval Token
   * Opaque token Five Sigma sends back to the retrieval endpoint to fetch the full policy
   */
  retrieval_token: string;
  /** Search Type */
  search_type: "API_V2";
}

/**
 * PolicyApiDisplaySchemaField
 * One column of the search-results table, as you ask Five Sigma to render it.
 */
export interface FnolInboxReprocessArgumentsPolicyApiDisplaySchemaField {
  /**
   * Desc
   * The column header Five Sigma displays
   */
  desc: string;
  /**
   * Id
   * The key to read this column from every result's `display_fields`
   */
  id: string;
  /**
   * Type
   * How Five Sigma renders the column
   */
  type: "string" | "date" | "select";
}

/** FnolInboxStatusResponse */
export interface FnolInboxStatusResponse {
  /** Is Ai High Demand */
  is_ai_high_demand: boolean;
  /** New Items Count */
  new_items_count: number;
}

/**
 * FnolOrganizationConfigurationModel
 * The organization-wide FNOL settings stored under ``configuration['fnol_configuration']``.
 *
 * Unlike an incident configuration, these do not vary by line of business or sub-organization. Every setting is off
 * when absent.
 */
export interface FnolOrganizationConfigurationModel {
  /**
   * Show Asterisk On Mandatory Fields
   * @default false
   */
  show_asterisk_on_mandatory_fields?: boolean;
}

/**
 * FnolPerformanceAnalysisData
 * Complete FNOL comparison analysis result payload for database storage
 */
export interface FnolPerformanceAnalysisData {
  /**
   * Ai Align Contact Pairs Count
   * @default 0
   */
  ai_align_contact_pairs_count?: number;
  /**
   * Ai Align Drop Count
   * @default 0
   */
  ai_align_drop_count?: number;
  /**
   * Ai Align Drops Json
   * @default null
   */
  ai_align_drops_json?: string | null;
  /**
   * Ai Align Party Pairs Count
   * @default 0
   */
  ai_align_party_pairs_count?: number;
  /**
   * Ai Alignment Called
   * @default false
   */
  ai_alignment_called?: boolean;
  /**
   * Ai Alignment Succeeded
   * @default false
   */
  ai_alignment_succeeded?: boolean;
  /** Metadata about the FNOL comparison analysis execution */
  analysis_metadata: FnolPerformanceAnalysisDataAnalysisMetadata;
  /**
   * Both Empty Fields
   * @default null
   */
  both_empty_fields?: string[] | null;
  /** @default null */
  categorized_analysis?: FnolPerformanceAnalysisDataCategorizedAnalysis | null;
  /** @default null */
  change_statistics?: FnolPerformanceAnalysisDataChangeStatistics | null;
  /**
   * Clive Excluded Fields
   * @default null
   */
  clive_excluded_fields?: string[] | null;
  /**
   * Cross Refs Translated Count
   * @default 0
   */
  cross_refs_translated_count?: number;
  /**
   * Detailed Changes
   * @default null
   */
  detailed_changes?: FnolPerformanceAnalysisDataChangeData[] | null;
  /**
   * Detailed Matches
   * @default null
   */
  detailed_matches?: FnolPerformanceAnalysisDataMatchData[] | null;
  /**
   * Duplicate Contacts Collapsed Count Ai
   * @default 0
   */
  duplicate_contacts_collapsed_count_ai?: number;
  /**
   * Duplicate Contacts Collapsed Count User
   * @default 0
   */
  duplicate_contacts_collapsed_count_user?: number;
  /** @default null */
  error_info?: FnolPerformanceAnalysisDataErrorInfo | null;
  /** @default null */
  field_density_comparison?: FnolPerformanceAnalysisDataFieldDensityComparison | null;
  /** @default null */
  investigation_statistics?: FnolPerformanceAnalysisDataInvestigationStatistics | null;
  /** @default null */
  judgement_audit?: FnolPerformanceAnalysisDataJudgementAudit | null;
  /** @default null */
  match_statistics?: FnolPerformanceAnalysisDataMatchStatistics | null;
  /** @default null */
  object_level_analysis?: FnolPerformanceAnalysisDataObjectLevelAnalysis | null;
  /**
   * System Fields
   * @default null
   */
  system_fields?: string[] | null;
}

/**
 * AnalysisMetadata
 * Metadata about the FNOL comparison analysis execution
 */
export interface FnolPerformanceAnalysisDataAnalysisMetadata {
  /** Comparison Version */
  comparison_version: string;
  /** Line Of Business */
  line_of_business: string;
  /** Processing Time Ms */
  processing_time_ms: number | null;
  /**
   * Skipped Reason
   * @default null
   */
  skipped_reason?: string | null;
  /** Timestamp */
  timestamp: string;
}

/**
 * CategorizedAnalysis
 * Categorized breakdown of changes by section
 */
export interface FnolPerformanceAnalysisDataCategorizedAnalysis {
  /**
   * Changes By Section
   * @default {}
   */
  changes_by_section?: Record<string, number>;
  /**
   * Id Mappings
   * @default {}
   */
  id_mappings?: Record<string, string>;
  /**
   * Significant Edits
   * @default []
   */
  significant_edits?: FnolPerformanceAnalysisDataChangeData[];
  /**
   * User Additions
   * @default []
   */
  user_additions?: FnolPerformanceAnalysisDataChangeData[];
}

/**
 * ChangeData
 * Structure of a change record in dictionary format
 */
export interface FnolPerformanceAnalysisDataChangeData {
  /**
   * Ai Value
   * @default null
   */
  ai_value?: string | number | boolean | Record<string, any> | any[] | null;
  /**
   * Field Config Type
   * @default null
   */
  field_config_type?: string | null;
  /**
   * Is Required
   * @default null
   */
  is_required?: boolean | null;
  /**
   * Judgement Score
   * @default 0
   */
  judgement_score?: number;
  /**
   * Party Type
   * @default null
   */
  party_type?: string | null;
  /** Path */
  path: string;
  /** Type */
  type: string;
  /**
   * User Value
   * @default null
   */
  user_value?: string | number | boolean | Record<string, any> | any[] | null;
}

/**
 * ChangeStatistics
 * Statistics about changes detected in FNOL comparison
 */
export interface FnolPerformanceAnalysisDataChangeStatistics {
  /**
   * Addition Count
   * @default 0
   */
  addition_count?: number;
  /**
   * Edit Count
   * @default 0
   */
  edit_count?: number;
  /**
   * List Edit Count
   * @default 0
   */
  list_edit_count?: number;
  /**
   * Object Addition Count
   * @default 0
   */
  object_addition_count?: number;
  /**
   * Object Removal Count
   * @default 0
   */
  object_removal_count?: number;
  /**
   * Removal Count
   * @default 0
   */
  removal_count?: number;
  /**
   * Total Changes
   * @default 0
   */
  total_changes?: number;
}

/**
 * ErrorInfo
 * Information about errors that occurred during analysis
 */
export interface FnolPerformanceAnalysisDataErrorInfo {
  /** Error Message */
  error_message: string;
  /** Error Type */
  error_type: string;
  /** Timestamp */
  timestamp: string;
}

/**
 * FieldDensityComparison
 * Results of field density fnol_comparison between AI and user data
 */
export interface FnolPerformanceAnalysisDataFieldDensityComparison {
  /** Ai Density Score */
  ai_density_score: number;
  /** Improvement */
  improvement: number;
  /** Improvement Percentage */
  improvement_percentage: number;
  /** Ui Density Score */
  ui_density_score: number;
}

/**
 * InvestigationStatistics
 * Per-case investigation statistics (from investigation_statistics.py).
 *
 * Flat structure designed for easy aggregation in BigQuery.
 * All fields have defaults of 0/False for safe aggregation.
 */
export interface FnolPerformanceAnalysisDataInvestigationStatistics {
  /**
   * Configured Ai Edited
   * @default 0
   */
  configured_ai_edited?: number;
  /**
   * Configured Ai Removed
   * @default 0
   */
  configured_ai_removed?: number;
  /**
   * Configured Ai Success
   * @default 0
   */
  configured_ai_success?: number;
  /**
   * Configured Ai Total
   * @default 0
   */
  configured_ai_total?: number;
  /**
   * Configured Change Count
   * @default 0
   */
  configured_change_count?: number;
  /**
   * Configured User Added
   * @default 0
   */
  configured_user_added?: number;
  /**
   * Configured User Edited
   * @default 0
   */
  configured_user_edited?: number;
  /**
   * Configured User Success
   * @default 0
   */
  configured_user_success?: number;
  /**
   * Configured User Total
   * @default 0
   */
  configured_user_total?: number;
  /**
   * Contacts Ai Edited
   * @default 0
   */
  contacts_ai_edited?: number;
  /**
   * Contacts Ai Removed
   * @default 0
   */
  contacts_ai_removed?: number;
  /**
   * Contacts Ai Success
   * @default 0
   */
  contacts_ai_success?: number;
  /**
   * Contacts Ai Total
   * @default 0
   */
  contacts_ai_total?: number;
  /**
   * Contacts User Added
   * @default 0
   */
  contacts_user_added?: number;
  /**
   * Contacts User Edited
   * @default 0
   */
  contacts_user_edited?: number;
  /**
   * Contacts User Success
   * @default 0
   */
  contacts_user_success?: number;
  /**
   * Contacts User Total
   * @default 0
   */
  contacts_user_total?: number;
  /**
   * Involved Parties Ai Edited
   * @default 0
   */
  involved_parties_ai_edited?: number;
  /**
   * Involved Parties Ai Removed
   * @default 0
   */
  involved_parties_ai_removed?: number;
  /**
   * Involved Parties Ai Success
   * @default 0
   */
  involved_parties_ai_success?: number;
  /**
   * Involved Parties Ai Total
   * @default 0
   */
  involved_parties_ai_total?: number;
  /**
   * Involved Parties User Added
   * @default 0
   */
  involved_parties_user_added?: number;
  /**
   * Involved Parties User Edited
   * @default 0
   */
  involved_parties_user_edited?: number;
  /**
   * Involved Parties User Success
   * @default 0
   */
  involved_parties_user_success?: number;
  /**
   * Involved Parties User Total
   * @default 0
   */
  involved_parties_user_total?: number;
  /**
   * Policy Ai Found
   * @default false
   */
  policy_ai_found?: boolean;
  /**
   * Policy Changed
   * @default false
   */
  policy_changed?: boolean;
  /**
   * Policy Found
   * @default false
   */
  policy_found?: boolean;
  /**
   * Policy User Has
   * @default false
   */
  policy_user_has?: boolean;
  /**
   * Predefined Ai Edited
   * @default 0
   */
  predefined_ai_edited?: number;
  /**
   * Predefined Ai Removed
   * @default 0
   */
  predefined_ai_removed?: number;
  /**
   * Predefined Ai Success
   * @default 0
   */
  predefined_ai_success?: number;
  /**
   * Predefined Ai Total
   * @default 0
   */
  predefined_ai_total?: number;
  /**
   * Predefined Change Count
   * @default 0
   */
  predefined_change_count?: number;
  /**
   * Predefined User Added
   * @default 0
   */
  predefined_user_added?: number;
  /**
   * Predefined User Edited
   * @default 0
   */
  predefined_user_edited?: number;
  /**
   * Predefined User Success
   * @default 0
   */
  predefined_user_success?: number;
  /**
   * Predefined User Total
   * @default 0
   */
  predefined_user_total?: number;
  /**
   * Required Ai Edited
   * @default 0
   */
  required_ai_edited?: number;
  /**
   * Required Ai Removed
   * @default 0
   */
  required_ai_removed?: number;
  /**
   * Required Ai Success
   * @default 0
   */
  required_ai_success?: number;
  /**
   * Required Ai Total
   * @default 0
   */
  required_ai_total?: number;
  /**
   * Required User Added
   * @default 0
   */
  required_user_added?: number;
  /**
   * Required User Edited
   * @default 0
   */
  required_user_edited?: number;
  /**
   * Required User Success
   * @default 0
   */
  required_user_success?: number;
  /**
   * Required User Total
   * @default 0
   */
  required_user_total?: number;
  /**
   * Witnesses Ai Count
   * @default 0
   */
  witnesses_ai_count?: number;
  /**
   * Witnesses User Count
   * @default 0
   */
  witnesses_user_count?: number;
}

/**
 * JudgementAudit
 * Audit trail for the v3 judgement pipeline.
 *
 * ``succeeded`` is True only when every phase ran cleanly. Any False
 * component means the orchestrator degraded to a partial-credit or
 * v2-only result; the failing component carries the cause.
 */
export interface FnolPerformanceAnalysisDataJudgementAudit {
  /**
   * Audit row for a judgement HTTP phase (addresses or free_text).
   *
   * Carries request/response counts on top of the PhaseAudit success flag,
   * so an operator can see partial drops (e.g. LLM returned 8 of 10 entries).
   */
  addresses: FnolPerformanceAnalysisDataJudgementAuditEntry;
  /**
   * Per-phase audit row for v3 judgement pipeline.
   *
   * Records whether a phase succeeded; on failure, the exception type and
   * a truncated message land here (full trace goes to Sentry).
   */
  classification: FnolPerformanceAnalysisDataPhaseAudit;
  /**
   * Audit row for a judgement HTTP phase (addresses or free_text).
   *
   * Carries request/response counts on top of the PhaseAudit success flag,
   * so an operator can see partial drops (e.g. LLM returned 8 of 10 entries).
   */
  free_text: FnolPerformanceAnalysisDataJudgementAuditEntry;
  /**
   * Per-phase audit row for v3 judgement pipeline.
   *
   * Records whether a phase succeeded; on failure, the exception type and
   * a truncated message land here (full trace goes to Sentry).
   */
  merge: FnolPerformanceAnalysisDataPhaseAudit;
  /** Succeeded */
  succeeded: boolean;
}

/**
 * JudgementAuditEntry
 * Audit row for a judgement HTTP phase (addresses or free_text).
 *
 * Carries request/response counts on top of the PhaseAudit success flag,
 * so an operator can see partial drops (e.g. LLM returned 8 of 10 entries).
 */
export interface FnolPerformanceAnalysisDataJudgementAuditEntry {
  /**
   * Dropped
   * @default 0
   */
  dropped?: number;
  /**
   * Error Categories
   * @default {}
   */
  error_categories?: Record<string, number>;
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /**
   * Error Type
   * @default null
   */
  error_type?: string | null;
  /**
   * Requested
   * @default 0
   */
  requested?: number;
  /** Succeeded */
  succeeded: boolean;
  /**
   * Succeeded Count
   * @default 0
   */
  succeeded_count?: number;
}

/**
 * MatchData
 * Structure of a match record in dictionary format
 */
export interface FnolPerformanceAnalysisDataMatchData {
  /**
   * Field Config Type
   * @default null
   */
  field_config_type?: string | null;
  /**
   * Is Required
   * @default null
   */
  is_required?: boolean | null;
  /**
   * Judgement Score
   * @default 1
   */
  judgement_score?: number;
  /** Path */
  path: string;
  /**
   * Value
   * @default null
   */
  value?: string | number | boolean | Record<string, any> | any[] | null;
}

/**
 * MatchStatistics
 * Statistics about matched fields between AI and user data
 */
export interface FnolPerformanceAnalysisDataMatchStatistics {
  /**
   * Effective Match Rate
   * @default null
   */
  effective_match_rate?: number | null;
  /**
   * Judgement Credit
   * @default null
   */
  judgement_credit?: number | null;
  /** Match Rate */
  match_rate: number;
  /** Matched Field Paths */
  matched_field_paths: string[];
  /** Total Matches */
  total_matches: number;
}

/**
 * ObjectLevelAnalysis
 * Complete object-level analysis for all object types
 */
export interface FnolPerformanceAnalysisDataObjectLevelAnalysis {
  /** @default null */
  contacts?: FnolPerformanceAnalysisDataObjectTypeAnalysis | null;
  /** @default null */
  involved_parties?: FnolPerformanceAnalysisDataObjectTypeAnalysis | null;
  /** @default null */
  witnesses?: FnolPerformanceAnalysisDataObjectTypeAnalysis | null;
}

/**
 * ObjectPerspectiveMetrics
 * Metrics for a single perspective of object-level analysis
 */
export interface FnolPerformanceAnalysisDataObjectPerspectiveMetrics {
  /**
   * Added
   * @default 0
   */
  added?: number;
  /**
   * Edited
   * @default 0
   */
  edited?: number;
  /**
   * Removed
   * @default 0
   */
  removed?: number;
  /**
   * Success
   * @default 0
   */
  success?: number;
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/**
 * ObjectTypeAnalysis
 * Analysis for a specific object type (contacts, involved_parties, witnesses)
 */
export interface FnolPerformanceAnalysisDataObjectTypeAnalysis {
  /**
   * Metrics for a single perspective of object-level analysis
   * @default {"added":0,"edited":0,"removed":0,"success":0,"total":0}
   */
  ai_perspective?: FnolPerformanceAnalysisDataObjectPerspectiveMetrics;
  /**
   * Metrics for a single perspective of object-level analysis
   * @default {"added":0,"edited":0,"removed":0,"success":0,"total":0}
   */
  submitted_perspective?: FnolPerformanceAnalysisDataObjectPerspectiveMetrics;
}

/**
 * PhaseAudit
 * Per-phase audit row for v3 judgement pipeline.
 *
 * Records whether a phase succeeded; on failure, the exception type and
 * a truncated message land here (full trace goes to Sentry).
 */
export interface FnolPerformanceAnalysisDataPhaseAudit {
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /**
   * Error Type
   * @default null
   */
  error_type?: string | null;
  /** Succeeded */
  succeeded: boolean;
}

/**
 * FnolRequest
 * Complete FNOL request schema for external API.
 */
export interface FnolRequest {
  /**
   * Claim Flag Keys
   * Optional claim flag keys to apply on creation. Each must be an enabled flag in the claim's sub-organization/LoB scope. Honored only when the FNOL claim_flags field is active.
   * @default null
   */
  claim_flag_keys?: string[] | null;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Claim Owner Email
   * @default null
   */
  claim_owner_email?: string | null;
  /**
   * Complexity Level
   * Claim complexity level. One of: low, medium, high
   * @default null
   */
  complexity_level?: "high" | "medium" | "low" | null;
  /**
   * Complexity Reason
   * Reason for the assigned complexity level.
   * @default null
   */
  complexity_reason?: string | null;
  /** Contacts */
  contacts: (
    | ({
        creation_mode: "";
      } & FnolRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & FnolRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & FnolRequestContactInNewParam)
  )[];
  /**
   * Documents
   * @default null
   */
  documents?: FnolRequestFnolDocumentModel[] | null;
  /**
   * External Claim Numbers
   * @default null
   */
  external_claim_numbers?: FnolRequestExternalClaimNumberExternalModel[] | null;
  /** External Id */
  external_id: string;
  /**
   * Fnol Handler Contact Ref Id
   * @default null
   */
  fnol_handler_contact_ref_id?: string | null;
  /**
   * Fnol Policyholder Contact Id
   * @deprecated
   * @default null
   */
  fnol_policyholder_contact_id?: string | null;
  /**
   * Fnol Policyholder Contact Ref Id
   * @default null
   */
  fnol_policyholder_contact_ref_id?: string | null;
  incident_details: FnolRequestIncidentDetailsModel;
  /** Involved Parties */
  involved_parties: (
    | FnolRequestAddGenericInvolvedPersonParams
    | FnolRequestAddInvolvedGenericPropertyParams
    | FnolRequestInvolvedDriverModel
    | FnolRequestInvolvedPassengerModel
    | FnolRequestInvolvedNonMotoristModel
    | FnolRequestInvolvedVehicleModel
    | FnolRequestAutoGenericPropertyModel
  )[];
  /** Lob */
  lob: string;
  /** Policy retrieval object for FNOL. */
  policy_retrieval_object: FnolRequestPolicyRetrievalObjectModel;
  /**
   * Reported Date
   * Required only if the field is active in the FNOL configuration for the organization.
   * @default null
   */
  reported_date?: string | null;
  /**
   * Stage Key
   * Optional claim stage key to override the default initial stage. Must be an enabled stage key.
   * @default null
   */
  stage_key?: string | null;
  /**
   * Sub Organization External Id
   * Required if sub-organizations are enabled
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Submission Mode
   * Required only if the field is active in the FNOL configuration for the organization.
   * @default null
   */
  submission_mode?: string | null;
  /**
   * Deprecated. Use top-level complexity_level and complexity_reason fields instead.
   * @deprecated
   * @default null
   */
  triage?: FnolRequestFnolTriageModel | null;
}

/** AccidentFollowUpModel */
export interface FnolRequestAccidentFollowUpModel {
  /**
   * Direction Ph Vehicle Was Going
   * @default null
   */
  direction_ph_vehicle_was_going?: string | null;
  /**
   * First Party Way Sign Or A Headlight
   * @default null
   */
  first_party_way_sign_or_a_headlight?: string | null;
  /**
   * Journey Purpose
   * @default null
   */
  journey_purpose?: string | null;
  /**
   * Street Condition
   * @default null
   */
  street_condition?: string | null;
  /**
   * Was Ambulance Called
   * @default null
   */
  was_ambulance_called?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Anyone Under The Influence Of Drugs Alcohol
   * @default null
   */
  was_anyone_under_the_influence_of_drugs_alcohol?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Was First Party Driver Using The Phone
   * @default null
   */
  was_first_party_driver_using_the_phone?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Weather Conditions
   * @default null
   */
  weather_conditions?: string | null;
  /**
   * Were First Party Vehicle Lights On
   * @default null
   */
  were_first_party_vehicle_lights_on?: "yes" | "no" | "na" | "unknown" | null;
}

/** AddGenericInvolvedPersonParams */
export interface FnolRequestAddGenericInvolvedPersonParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: FnolRequestBodilyInjuryLossParams | null;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /** Contact Ref Id */
  contact_ref_id: string;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: FnolRequestPecuniaryLossDetailsParams | null;
  /** @default null */
  related_property_loss?: FnolRequestPropertyLossWithItemsParams | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: string;
}

/** AddInvolvedGenericPropertyParams */
export interface FnolRequestAddInvolvedGenericPropertyParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: FnolRequestLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /** Owner Contact Ref Id */
  owner_contact_ref_id: string;
  /** @default null */
  pecuniary_loss?: FnolRequestPecuniaryLossDetailsParams | null;
  /** @default null */
  property_damage?: FnolRequestPropertyDamageParams | null;
  /** Property Description */
  property_description: string;
  /** @default null */
  related_property_loss?: FnolRequestPropertyLossWithItemsParams | null;
  /** Type */
  type: string;
}

/** AutoGenericPropertyModel */
export interface FnolRequestAutoGenericPropertyModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Damages */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /** Items */
  items?: FnolRequestPropertyItemIncomingModel[];
  /** @default null */
  location?: FnolRequestLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** Type */
  type: "generic_involved_property";
}

/** AutoIncidentAdditionalModel */
export interface FnolRequestAutoIncidentAdditionalModel {
  /** @default null */
  accident_follow_up?: FnolRequestAccidentFollowUpModel | null;
  /**
   * Are Convictions Or Claims In The Last 5 Years
   * @default null
   */
  are_convictions_or_claims_in_the_last_5_years?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Convictions Or Claim Description
   * @default null
   */
  convictions_or_claim_description?: string | null;
  /**
   * Does Policyholder Second Occupation Exist
   * @default null
   */
  does_policyholder_second_occupation_exist?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /** @default null */
  fault_assessment?: FnolRequestFaultAssessmentModel | null;
  /**
   * Is Policyholder Occupation Right
   * @default null
   */
  is_policyholder_occupation_right?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  police_and_fire_department?: FnolRequestPoliceAndFireDepartmentModel | null;
  /**
   * Policyholder Current Occupation
   * @default null
   */
  policyholder_current_occupation?: string | null;
  /**
   * Policyholder Second Occupation
   * @default null
   */
  policyholder_second_occupation?: string | null;
  /**
   * Replacement Car Rental Date
   * @default null
   */
  replacement_car_rental_date?: string | null;
  /** @default null */
  theft_follow_up?: FnolRequestTheftFollowUpModel | null;
  /**
   * Was Replacement Car Rented
   * @default null
   */
  was_replacement_car_rented?: boolean | null;
}

/** BodilyInjuryLossParams */
export interface FnolRequestBodilyInjuryLossParams {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Bodily Injuries
   * @default null
   */
  bodily_injuries?: FnolRequestBodilyInjuryModel[] | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Icd Codes
   * @default null
   */
  icd_codes?: FnolRequestICDCodeModel[] | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface FnolRequestBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/** ContactEmailModel */
export interface FnolRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface FnolRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface FnolRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: FnolRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: FnolRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface FnolRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ExternalClaimNumberExternalModel */
export interface FnolRequestExternalClaimNumberExternalModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** External Claim Number */
  external_claim_number: string;
  /**
   * External Contact Ref Id
   * @default null
   */
  external_contact_ref_id?: string | null;
}

/** ExternalWitnessModel */
export interface FnolRequestExternalWitnessModel {
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
}

/** FaultAssessmentModel */
export interface FnolRequestFaultAssessmentModel {
  /**
   * Claim Handler Fault Assessment
   * @default null
   */
  claim_handler_fault_assessment?: string | null;
  /**
   * First Party Fault Assessment
   * @default null
   */
  first_party_fault_assessment?: string | null;
  /**
   * Is Fraud Review Needed
   * @default null
   */
  is_fraud_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Indemnity Review Needed
   * @default null
   */
  is_indemnity_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Liability Summary
   * @default null
   */
  liability_summary?: string | null;
  /**
   * Percentage Of Insured Liability
   * @default null
   */
  percentage_of_insured_liability?: string | null;
}

/**
 * FnolDocumentModel
 * Document model for FNOL creation.
 * Based on DOCUMENTS_SCHEMA from fnol.jsonschema.
 */
export interface FnolRequestFnolDocumentModel {
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /** Document Name */
  document_name: string;
  /** Document Type */
  document_type: string;
  /** Document Url */
  document_url: string;
  /** External Id */
  external_id: string;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/**
 * FnolTriageModel
 * Triage information for FNOL.
 */
export interface FnolRequestFnolTriageModel {
  /**
   * Complexity
   * @default null
   */
  complexity?: string | null;
  /**
   * Complexity Reason
   * @default null
   */
  complexity_reason?: string | null;
}

/** ICDCodeModel */
export interface FnolRequestICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** IncidentDetailsModel */
export interface FnolRequestIncidentDetailsModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** @default null */
  auto_incident_additional?: FnolRequestAutoIncidentAdditionalModel | null;
  /**
   * Can Take Photos Of Damage
   * @default null
   */
  can_take_photos_of_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Cat Code
   * The catastrophe `code` of the linked cat event. Accepted as input (alternative to `cat_code_name`) and returned in responses. If both `cat_code` and `cat_code_name` are sent, they must reference the same cat.
   * @default null
   */
  cat_code?: string | null;
  /**
   * Cat Code Name
   * @default null
   */
  cat_code_name?: string | null;
  /**
   * Date Of Loss
   * @format date
   */
  date_of_loss: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Did Anyone Take Photos Or Video
   * @default null
   */
  did_anyone_take_photos_or_video?: "yes" | "no" | "na" | "unknown" | null;
  /** Incident Sub Type */
  incident_sub_type: string;
  /** Incident Type */
  incident_type: string;
  /**
   * Is Notification Only
   * @default null
   */
  is_notification_only?: boolean | null;
  /**
   * Is Other Policy Covering
   * @default null
   */
  is_other_policy_covering?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  loss_location?: FnolRequestLocationModel | null;
  /**
   * Other Policy Description
   * @default null
   */
  other_policy_description?: string | null;
  /**
   * Photographer Contact Ref Id
   * @default null
   */
  photographer_contact_ref_id?: string | null;
  /**
   * Preferred Contact Ref Id
   * @default null
   */
  preferred_contact_ref_id?: string | null;
  /**
   * Reporter Contact Id
   * Required only if the field is active in the FNOL configuration for the organization.
   * @default null
   */
  reporter_contact_id?: string | null;
  /**
   * Special Internal Note
   * @default null
   */
  special_internal_note?: string | null;
  /**
   * Time Of Loss
   * Local wall-clock time of the loss (HH:MM), no timezone.
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Was Cctv Footage
   * @default null
   */
  was_cctv_footage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were There Any Witnesses
   * @default null
   */
  were_there_any_witnesses?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Witnesses
   * @default null
   */
  witnesses?: FnolRequestExternalWitnessModel[] | null;
  /**
   * Witnesses Note
   * @default null
   */
  witnesses_note?: string | null;
}

/** InvolvedDriverModel */
export interface FnolRequestInvolvedDriverModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Any Dvla Medical Conditions
   * @default null
   */
  any_dvla_medical_conditions?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: FnolRequestBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Dvla Medical Conditions Description
   * @default null
   */
  dvla_medical_conditions_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * License Issuing State
   * @default null
   */
  license_issuing_state?: string | null;
  /**
   * License Number
   * @default null
   */
  license_number?: string | null;
  /**
   * License Type
   * @default null
   */
  license_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_driver";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Who Authorized The Driver To Drive The Vehicle
   * @default null
   */
  who_authorized_the_driver_to_drive_the_vehicle?: string | null;
  /**
   * Years Of Driving Experience
   * @default null
   */
  years_of_driving_experience?: number | null;
}

/** InvolvedNonMotoristModel */
export interface FnolRequestInvolvedNonMotoristModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: FnolRequestBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /** Means Of Transportation */
  means_of_transportation: string;
  /**
   * Non Motorist Type
   * @deprecated
   * @default null
   */
  non_motorist_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_non_motorist";
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedPassengerModel */
export interface FnolRequestInvolvedPassengerModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: FnolRequestBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Position
   * @default null
   */
  position?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_passenger";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedVehicleModel */
export interface FnolRequestInvolvedVehicleModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Appraiser Contact Ref Id
   * @default null
   */
  appraiser_contact_ref_id?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Auto Repair Facility Contact Ref Id
   * @default null
   */
  auto_repair_facility_contact_ref_id?: string | null;
  /**
   * Child Seats
   * @default null
   */
  child_seats?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Covered Vehicle Id
   * @default null
   */
  covered_vehicle_id?: string | null;
  /**
   * Damage Areas
   * Areas of the vehicle that were damaged
   * @default null
   */
  damage_areas?: string[] | null;
  /**
   * Damage Description
   * @default null
   */
  damage_description?: string | null;
  /**
   * Damage Level
   * @default null
   */
  damage_level?: string | null;
  /**
   * Did Vehicle Have Previous Damage
   * @default null
   */
  did_vehicle_have_previous_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Does The Vehicle Have Any Modifications
   * @default null
   */
  does_the_vehicle_have_any_modifications?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is Car Safe To Drive
   * @default null
   */
  is_car_safe_to_drive?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Drivable
   * @default null
   */
  is_drivable?: "yes" | "no" | "na" | "unknown" | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Total Loss
   * @default null
   */
  is_total_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Tow
   * @default null
   */
  is_tow?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Active
   * @default null
   */
  is_vehicle_camera_active?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: FnolRequestLocationModel | null;
  /**
   * Modification Description
   * @default null
   */
  modification_description?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Point Of Impact
   * @default null
   */
  point_of_impact?: string | null;
  /**
   * Previous Damage Description
   * @default null
   */
  previous_damage_description?: string | null;
  /**
   * Previous Damage Level
   * @default null
   */
  previous_damage_level?: string | null;
  /**
   * Scheduling Inspection Contact Ref Id
   * @default null
   */
  scheduling_inspection_contact_ref_id?: string | null;
  /**
   * Tower Contact Ref Id
   * @default null
   */
  tower_contact_ref_id?: string | null;
  /** Type */
  type: "involved_vehicle";
  /**
   * Detailed vehicle information
   * @default null
   */
  vehicle?: FnolRequestVehicleDetailsModel | null;
  /**
   * Location details for the vehicle
   * @default null
   */
  vehicle_location?: FnolRequestLocationModel | null;
  /**
   * Vehicle Speed
   * @default null
   */
  vehicle_speed?: string | null;
}

/** LocationModel */
export interface FnolRequestLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PecuniaryLossDetailsParams */
export interface FnolRequestPecuniaryLossDetailsParams {
  /**
   * Losses
   * @default null
   */
  losses?: FnolRequestPecuniaryLossItemParams[] | null;
}

/** PecuniaryLossItemParams */
export interface FnolRequestPecuniaryLossItemParams {
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /**
   * Claimed Loss
   * @default null
   */
  claimed_loss?: string | null;
  /** Display Name */
  display_name: string;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** PoliceAndFireDepartmentModel */
export interface FnolRequestPoliceAndFireDepartmentModel {
  /**
   * Did Speak With Officer
   * @default null
   */
  did_speak_with_officer?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Fire Department Description
   * @default null
   */
  fire_department_description?: string | null;
  /**
   * Pending Prosecutions Or Investigations Exists
   * @default null
   */
  pending_prosecutions_or_investigations_exists?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Police Crime Reference Number
   * @default null
   */
  police_crime_reference_number?: string | null;
  /**
   * Police Department Contact Ref Id
   * @default null
   */
  police_department_contact_ref_id?: string | null;
  /**
   * Police Description
   * @default null
   */
  police_description?: string | null;
  /**
   * Police Report
   * @default null
   */
  police_report?: string | null;
  /**
   * Violation Title
   * @default null
   */
  violation_title?: string | null;
  /**
   * Was Ticket Received
   * @default null
   */
  was_ticket_received?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Any Hazardous Good Being Carried
   * @default null
   */
  were_any_hazardous_good_being_carried?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Were Fire Department Involved
   * @default null
   */
  were_fire_department_involved?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Police Involved
   * @default null
   */
  were_police_involved?: "yes" | "no" | "na" | "unknown" | null;
}

/**
 * PolicyRetrievalObjectModel
 * Policy retrieval object for FNOL.
 */
export interface FnolRequestPolicyRetrievalObjectModel {
  /**
   * Policy
   * @default null
   */
  policy?: Record<string, any> | null;
  /**
   * Policy Api Uid
   * @default null
   */
  policy_api_uid?: string | null;
  /**
   * Policy Holder Contact
   * @default null
   */
  policy_holder_contact?: Record<string, any> | null;
  /**
   * Policy Holder Contact Id
   * @deprecated
   * @default null
   */
  policy_holder_contact_id?: string | null;
  /**
   * Policy Holder Contact Ref Id
   * @default null
   */
  policy_holder_contact_ref_id?: string | null;
  /** Retrieval Mode */
  retrieval_mode: "manual" | "included" | "policy_api_uid";
}

/** PropertyDamageParams */
export interface FnolRequestPropertyDamageParams {
  /**
   * Is Property Stolen
   * @default null
   */
  is_property_stolen?: boolean | null;
  /** @default null */
  location?: FnolRequestLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Property Damages
   * @default null
   */
  property_damages?: string[] | null;
  /**
   * Property Damages Description
   * @default null
   */
  property_damages_description?: string | null;
}

/** PropertyItemIncomingModel */
export interface FnolRequestPropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyLossWithItemsParams */
export interface FnolRequestPropertyLossWithItemsParams {
  /**
   * Damages
   * @default null
   */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /**
   * Items
   * @default null
   */
  items?: FnolRequestPropertyItemIncomingModel[] | null;
  /** @default null */
  location?: FnolRequestLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** TheftFollowUpModel */
export interface FnolRequestTheftFollowUpModel {
  /**
   * Belongings Stolen
   * @default null
   */
  belongings_stolen?: string | null;
  /**
   * Crime Reference Number
   * @default null
   */
  crime_reference_number?: string | null;
  /**
   * Current Num Of Keys
   * @default null
   */
  current_num_of_keys?: number | null;
  /**
   * Date Noticed Vehicle Missing
   * @default null
   */
  date_noticed_vehicle_missing?: string | null;
  /**
   * Date Vehicle Last Seen
   * @default null
   */
  date_vehicle_last_seen?: string | null;
  /**
   * Discovered The Loss Contact Ref Id
   * @default null
   */
  discovered_the_loss_contact_ref_id?: string | null;
  /**
   * Is Vehicle For Sale
   * @default null
   */
  is_vehicle_for_sale?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  keys_location?: FnolRequestLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Num Of Keys Received On Purchase
   * @default null
   */
  num_of_keys_received_on_purchase?: number | null;
  /**
   * Person Liable For The Theft Is Known
   * @default null
   */
  person_liable_for_the_theft_is_known?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Security Devices Description
   * @default null
   */
  security_devices_description?: string | null;
  /**
   * Time Noticed Vehicle Missing
   * @default null
   */
  time_noticed_vehicle_missing?: string | null;
  /**
   * Time Vehicle Last Seen
   * @default null
   */
  time_vehicle_last_seen?: string | null;
  /**
   * Tracking Devices Description
   * @default null
   */
  tracking_devices_description?: string | null;
  /**
   * Vehicle Fitted With Security Devices
   * @default null
   */
  vehicle_fitted_with_security_devices?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Vehicle Fitted With Tracking Devices
   * @default null
   */
  vehicle_fitted_with_tracking_devices?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  vehicle_last_seen_location?: FnolRequestLocationModel | null;
  /**
   * Vehicle Windows Closed And Secured
   * @default null
   */
  vehicle_windows_closed_and_secured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Vehicle Found With Keys
   * @default null
   */
  was_vehicle_found_with_keys?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Belongings Stolen From Vehicle
   * @default null
   */
  were_belongings_stolen_from_vehicle?: "yes" | "no" | "na" | "unknown" | null;
}

/** VehicleDetailsModel */
export interface FnolRequestVehicleDetailsModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Claim Free Years
   * @default null
   */
  claim_free_years?: number | null;
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Engine Capacity
   * @default null
   */
  engine_capacity?: number | null;
  /**
   * Engine Type
   * @default null
   */
  engine_type?: string | null;
  /**
   * Existing Damage
   * @default null
   */
  existing_damage?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Fuel Type
   * @default null
   */
  fuel_type?: string | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: boolean | null;
  /**
   * Make
   * @default null
   */
  make?: string | null;
  /**
   * Make Ncic Code
   * NCIC code for the vehicle make
   * @default null
   */
  make_ncic_code?: string | null;
  /**
   * Mileage
   * @default null
   */
  mileage?: number | null;
  /**
   * Model
   * @default null
   */
  model?: string | null;
  /**
   * Number Of Seats
   * @default null
   */
  number_of_seats?: number | null;
  /**
   * Ownership Status
   * @default null
   */
  ownership_status?: string | null;
  /**
   * Plate Number
   * @default null
   */
  plate_number?: string | null;
  /**
   * Series
   * @default null
   */
  series?: string | null;
  /**
   * Vehicle Cost New
   * @default null
   */
  vehicle_cost_new?: number | null;
  /**
   * Vehicle Owner Contact Ref Id
   * @default null
   */
  vehicle_owner_contact_ref_id?: string | null;
  /**
   * Vehicle Plate State
   * @default null
   */
  vehicle_plate_state?: string | null;
  /**
   * Vehicle Type
   * @default null
   */
  vehicle_type?: string | null;
  /**
   * Vehicle Use
   * @default null
   */
  vehicle_use?: string | null;
  /**
   * Vehicle Value
   * @default null
   */
  vehicle_value?: number | null;
  /**
   * Vehicle Weight
   * @default null
   */
  vehicle_weight?: number | null;
  /**
   * Vin
   * Vehicle Identification Number
   * @default null
   */
  vin?: string | null;
  /**
   * Year
   * @default null
   */
  year?: number | null;
}

/**
 * FnolResponse
 * Response model for FNOL creation.
 */
export interface FnolResponse {
  /**
   * Api Assignment Failure Message
   * Error message if claim owner assignment failed
   * @default null
   */
  api_assignment_failure_message?: string | null;
  /**
   * Claim Id
   * Organization external ID of the created claim
   */
  claim_id: string;
  /**
   * Claim Number
   * Display claim number
   */
  claim_number: string;
  /** Assigned file owner information */
  file_owner: FnolResponseUserExternalAPIBaseModel;
}

/** UserExternalAPIBaseModel */
export interface FnolResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * FnolTimelineTokenResponse
 * Real-time token for reading an FNOL processing task's progress timeline from Firestore.
 *
 * ``issue_token_response`` is null while the item's AI task has not reached the AI service yet.
 * That is a transient pre-enqueue state rather than an error, so callers should retry rather
 * than treat it as a failure.
 */
export interface FnolTimelineTokenResponse {
  /** @default null */
  issue_token_response?: FnolTimelineTokenResponseIssueTokenResponse | null;
}

/**
 * FirebaseWebAppConfigResponse
 * Firebase Web App configuration for frontend initialization.
 */
export interface FnolTimelineTokenResponseFirebaseWebAppConfigResponse {
  /**
   * Api Key
   * Firebase Web API key
   */
  api_key: string;
  /**
   * App Id
   * Firebase Web App ID
   */
  app_id: string;
  /**
   * Auth Domain
   * Firebase authentication domain
   */
  auth_domain: string;
  /**
   * Database Url
   * Realtime Database URL (if applicable)
   * @default null
   */
  database_url?: string | null;
  /**
   * Messaging Sender Id
   * Firebase Cloud Messaging sender ID
   */
  messaging_sender_id: string;
  /**
   * Project Id
   * Firebase project ID
   */
  project_id: string;
  /**
   * Storage Bucket
   * Firebase storage bucket
   */
  storage_bucket: string;
}

/**
 * FirestoreConnectionConfig
 * Firestore connection configuration for the client.
 */
export interface FnolTimelineTokenResponseFirestoreConnectionConfig {
  /** Collection Name */
  collection_name: string;
  /**
   * Database
   * @default "claims-llm"
   */
  database?: string | null;
  /**
   * Host
   * @default null
   */
  host?: string | null;
  /** Project Id */
  project_id: string;
}

/**
 * FirestoreQueryConfig
 * Query configuration for listening to real-time updates.
 */
export interface FnolTimelineTokenResponseFirestoreQueryConfig {
  /**
   * Order By
   * @default null
   */
  order_by?: Record<string, string>[] | null;
  /** Where Clauses */
  where_clauses: Record<string, any>[];
}

/**
 * IssueTokenResponse
 * IssueTokenResponse
 */
export interface FnolTimelineTokenResponseIssueTokenResponse {
  /** Expires At */
  expires_at: string;
  /** Firebase Custom Token */
  firebase_custom_token: string;
  /** Firebase Web App configuration for frontend initialization */
  firebase_web_app_config: FnolTimelineTokenResponseFirebaseWebAppConfigResponse;
  /** Firestore connection configuration for the client. */
  firestore_config: FnolTimelineTokenResponseFirestoreConnectionConfig;
  /** Query configuration for listening to real-time updates. */
  query_config: FnolTimelineTokenResponseFirestoreQueryConfig;
  /** Scopes */
  scopes: Record<string, any>[];
}

/** ForwardCallParams */
export interface ForwardCallParams {
  /**
   * Adjuster Id
   * @default null
   */
  adjuster_id?: string | null;
  /**
   * Contact Id
   * @default null
   */
  contact_id?: number | null;
  /**
   * Contact Phone Id
   * @default null
   */
  contact_phone_id?: number | null;
  /** Forward To Type */
  forward_to_type: "queue" | "adjuster" | "phone_number" | "contact";
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Queue Name
   * @default null
   */
  queue_name?: string | null;
}

/**
 * FundAccountEngineConfigInfo
 * The org's engine default-behavior card.
 *
 * ``default_behavior`` is None while the org has not configured one; that state
 * blocks selecting ``source='rules'`` on any payment-method config, and a provider-backed
 * method's resolution fails safe to ``block_payment`` should it be reached anyway (DR §6.4).
 * A method with no provider resolves to no account under it.
 */
export interface FundAccountEngineConfigInfo {
  /** Default Account Id */
  default_account_id: string | null;
  default_behavior: FundAccountEngineConfigInfoFundAccountDefaultBehavior | null;
}

/**
 * FundAccountRuleCreateParams
 * Parameters to author a fund-account rule.
 */
export interface FundAccountRuleCreateParams {
  /** Account Number */
  account_number: string;
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /** Name */
  name: string;
  /**
   * The rule's ``payment_methods`` scope on the write side — maps 1:1 to
   * ``rules_engine.RuleScopeDimension``.
   *
   * Membership is checked here because the engine cannot: ``scope_dimensions`` declares which
   * dimensions are legal, not which values are. ``is_all=False`` with no values is left to the
   * engine, which rejects a rule scoped to nothing for every dimension alike.
   */
  payment_methods?: FundAccountRuleCreateParamsFundAccountRulePaymentMethodScope;
  /** Sub-organization / LoB scoping, consistent with the other rules-engine consumers. */
  scope?: FundAccountRuleCreateParamsFundAccountRuleScope;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
}

/**
 * FundAccountRulePaymentMethodScope
 * The rule's ``payment_methods`` scope on the write side — maps 1:1 to
 * ``rules_engine.RuleScopeDimension``.
 *
 * Membership is checked here because the engine cannot: ``scope_dimensions`` declares which
 * dimensions are legal, not which values are. ``is_all=False`` with no values is left to the
 * engine, which rejects a rule scoped to nothing for every dimension alike.
 */
export interface FundAccountRuleCreateParamsFundAccountRulePaymentMethodScope {
  /**
   * Is All
   * @default false
   */
  is_all?: boolean;
  /** Values */
  values?: (
    | "au_bank_transfer"
    | "check"
    | "compensation"
    | "custom_method"
    | "echeck"
    | "iban_bank_transfer"
    | "nz_bank_transfer"
    | "uk_bank_transfer"
    | "us_ach"
  )[];
}

/**
 * FundAccountRuleScope
 * Sub-organization / LoB scoping, consistent with the other rules-engine consumers.
 */
export interface FundAccountRuleCreateParamsFundAccountRuleScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * FundAccountRuleInfo
 * One fund-account rule, flattened for the config screen.
 *
 * Built by ``fund_account_rules_manager._to_rule_info`` — the mapping from the engine's
 * ``RuleInfo`` lives there, next to the ``rule_set_configs`` symbols it needs, because
 * importing those here would close a cycle (``rule_set_configs`` imports this module).
 */
export interface FundAccountRuleInfo {
  /** Account Number */
  account_number: string;
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /** Name */
  name: string;
  /**
   * The stored ``payment_methods`` scope as it is *read back*.
   *
   * ``values`` is ``list[str]``, not the write side's ``Literal``: that ``Literal`` is derived at
   * import time from the payment-method metadata, so re-validating stored values against it would
   * turn a row holding a method that metadata no longer carries — or one another writer scoped to
   * a portal-routed method, since the engine validates dimension *names* and not values — into a
   * 500 on the list route, with no UI path left to correct the row. Reading permissively keeps a
   * stale scope visible and editable; the write params below still reject it.
   */
  payment_methods: FundAccountRuleInfoFundAccountRulePaymentMethodScopeInfo;
  /** Priority */
  priority: number;
  /** Sub-organization / LoB scoping, consistent with the other rules-engine consumers. */
  scope: FundAccountRuleInfoFundAccountRuleScope;
}

/**
 * FundAccountRulePaymentMethodScopeInfo
 * The stored ``payment_methods`` scope as it is *read back*.
 *
 * ``values`` is ``list[str]``, not the write side's ``Literal``: that ``Literal`` is derived at
 * import time from the payment-method metadata, so re-validating stored values against it would
 * turn a row holding a method that metadata no longer carries — or one another writer scoped to
 * a portal-routed method, since the engine validates dimension *names* and not values — into a
 * 500 on the list route, with no UI path left to correct the row. Reading permissively keeps a
 * stale scope visible and editable; the write params below still reject it.
 */
export interface FundAccountRuleInfoFundAccountRulePaymentMethodScopeInfo {
  /**
   * Is All
   * @default false
   */
  is_all?: boolean;
  /** Values */
  values?: string[];
}

/**
 * FundAccountRuleScope
 * Sub-organization / LoB scoping, consistent with the other rules-engine consumers.
 */
export interface FundAccountRuleInfoFundAccountRuleScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/** FundAccountRuleInfoList */
export type FundAccountRuleInfoList =
  FundAccountRuleInfoListFundAccountRuleInfo[];

/**
 * FundAccountRuleInfo
 * One fund-account rule, flattened for the config screen.
 *
 * Built by ``fund_account_rules_manager._to_rule_info`` — the mapping from the engine's
 * ``RuleInfo`` lives there, next to the ``rule_set_configs`` symbols it needs, because
 * importing those here would close a cycle (``rule_set_configs`` imports this module).
 */
export interface FundAccountRuleInfoListFundAccountRuleInfo {
  /** Account Number */
  account_number: string;
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /** Name */
  name: string;
  /**
   * The stored ``payment_methods`` scope as it is *read back*.
   *
   * ``values`` is ``list[str]``, not the write side's ``Literal``: that ``Literal`` is derived at
   * import time from the payment-method metadata, so re-validating stored values against it would
   * turn a row holding a method that metadata no longer carries — or one another writer scoped to
   * a portal-routed method, since the engine validates dimension *names* and not values — into a
   * 500 on the list route, with no UI path left to correct the row. Reading permissively keeps a
   * stale scope visible and editable; the write params below still reject it.
   */
  payment_methods: FundAccountRuleInfoListFundAccountRulePaymentMethodScopeInfo;
  /** Priority */
  priority: number;
  /** Sub-organization / LoB scoping, consistent with the other rules-engine consumers. */
  scope: FundAccountRuleInfoListFundAccountRuleScope;
}

/**
 * FundAccountRulePaymentMethodScopeInfo
 * The stored ``payment_methods`` scope as it is *read back*.
 *
 * ``values`` is ``list[str]``, not the write side's ``Literal``: that ``Literal`` is derived at
 * import time from the payment-method metadata, so re-validating stored values against it would
 * turn a row holding a method that metadata no longer carries — or one another writer scoped to
 * a portal-routed method, since the engine validates dimension *names* and not values — into a
 * 500 on the list route, with no UI path left to correct the row. Reading permissively keeps a
 * stale scope visible and editable; the write params below still reject it.
 */
export interface FundAccountRuleInfoListFundAccountRulePaymentMethodScopeInfo {
  /**
   * Is All
   * @default false
   */
  is_all?: boolean;
  /** Values */
  values?: string[];
}

/**
 * FundAccountRuleScope
 * Sub-organization / LoB scoping, consistent with the other rules-engine consumers.
 */
export interface FundAccountRuleInfoListFundAccountRuleScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * FundAccountRuleUpdateParams
 * Parameters to update a fund-account rule — all fields optional (partial update).
 */
export interface FundAccountRuleUpdateParams {
  /**
   * Account Number
   * @default null
   */
  account_number?: string | null;
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /** @default null */
  payment_methods?: FundAccountRuleUpdateParamsFundAccountRulePaymentMethodScope | null;
  /** @default null */
  scope?: FundAccountRuleUpdateParamsFundAccountRuleScope | null;
}

/**
 * FundAccountRulePaymentMethodScope
 * The rule's ``payment_methods`` scope on the write side — maps 1:1 to
 * ``rules_engine.RuleScopeDimension``.
 *
 * Membership is checked here because the engine cannot: ``scope_dimensions`` declares which
 * dimensions are legal, not which values are. ``is_all=False`` with no values is left to the
 * engine, which rejects a rule scoped to nothing for every dimension alike.
 */
export interface FundAccountRuleUpdateParamsFundAccountRulePaymentMethodScope {
  /**
   * Is All
   * @default false
   */
  is_all?: boolean;
  /** Values */
  values?: (
    | "au_bank_transfer"
    | "check"
    | "compensation"
    | "custom_method"
    | "echeck"
    | "iban_bank_transfer"
    | "nz_bank_transfer"
    | "uk_bank_transfer"
    | "us_ach"
  )[];
}

/**
 * FundAccountRuleScope
 * Sub-organization / LoB scoping, consistent with the other rules-engine consumers.
 */
export interface FundAccountRuleUpdateParamsFundAccountRuleScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * FundAccountRulesSourceAvailability
 * Whether one payment method may be sourced from rules — the answer the method-config
 * dialog's source radio gates on (DR §6.5).
 *
 * The method and the sub-organization are echoed back rather than left implicit in the request:
 * the dialog re-asks when the operator switches method, and a response that did not name what it
 * answered for could be applied to whichever configuration is on screen when it lands.
 */
export interface FundAccountRulesSourceAvailability {
  /** Is Rules Source Available */
  is_rules_source_available: boolean;
  /** Payment Method */
  payment_method: string;
  /** Sub Organization Id */
  sub_organization_id: number | null;
}

/**
 * FundAccountRulesSourceAvailabilityQuery
 * Query params for the readiness GET.
 *
 * ``sub_organization_id`` is the configuration row the dialog was opened on — method
 * configurations are per (sub-org × method), and the resolver narrows every rule walk by the
 * payment's sub-organization, so readiness has to ask the same question. Omitted for the
 * org-level row, which is the row every payment uses when an organization's payments
 * configuration is org-level: it is bound to no one sub-organization, so it narrows to none.
 */
export interface FundAccountRulesSourceAvailabilityQuery {
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** GbgAddressFindParams */
export interface GbgAddressFindParams {
  /**
   * Country
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  /**
   * Full Address
   * @minLength 1
   */
  full_address: string;
  /**
   * Max Results
   * @min 1
   * @max 50
   * @default 10
   */
  max_results?: number;
}

/** GbgAddressFindResponse */
export interface GbgAddressFindResponse {
  /** Suggestions */
  suggestions: GbgAddressFindResponseGbgAddressFindSuggestion[];
}

/** GbgAddressFindSuggestion */
export interface GbgAddressFindResponseGbgAddressFindSuggestion {
  /** Full Address */
  full_address: string;
  /** Id */
  id: string;
}

/** GbgAddressRetrieveParams */
export interface GbgAddressRetrieveParams {
  /**
   * Address Id
   * @minLength 1
   */
  address_id: string;
}

/** GbgAddressRetrieveResponse */
export interface GbgAddressRetrieveResponse {
  address: GbgAddressRetrieveResponseGbgAddressRetrieveResult;
}

/** AddressValidationDetails */
export interface GbgAddressRetrieveResponseAddressValidationDetails {
  /**
   * Override Reason
   * @default null
   */
  override_reason?: string | null;
  /**
   * Override Timestamp
   * @default null
   */
  override_timestamp?: string | null;
  /**
   * Override User Name
   * @default null
   */
  override_user_name?: string | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Ref Type
   * @default null
   */
  ref_type?: string | null;
  /**
   * Type
   * @default "address"
   */
  type?: "address";
}

/** GbgAddressRetrieveResult */
export interface GbgAddressRetrieveResponseGbgAddressRetrieveResult {
  /** City */
  city: string;
  /** Country */
  country: string;
  /** Full Address */
  full_address: string;
  /** Postcode */
  postcode: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /** Street Address1 */
  street_address1: string;
  /**
   * Street Address2
   * @default null
   */
  street_address2?: string | null;
  /** @default null */
  validation?: GbgAddressRetrieveResponseGbgAddressRetrieveValidation | null;
}

/** GbgAddressRetrieveValidation */
export interface GbgAddressRetrieveResponseGbgAddressRetrieveValidation {
  /**
   * Provider
   * @default "gbg"
   */
  provider?: "gbg";
  /**
   * Status
   * @default "not_validated"
   */
  status?:
    | "verified"
    | "verified_corrected"
    | "manual_override"
    | "not_validated";
  /** @default null */
  validation_details?: GbgAddressRetrieveResponseAddressValidationDetails | null;
  /**
   * Validation Type
   * @default "address"
   */
  validation_type?: "address";
}

/** GbgBusinessFindParams */
export interface GbgBusinessFindParams {
  /**
   * Country
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  /** Name */
  name: string;
}

/** GbgBusinessFindResponse */
export interface GbgBusinessFindResponse {
  /** Suggestions */
  suggestions: GbgBusinessFindResponseGbgBusinessFindSuggestion[];
}

/** GbgBusinessFindSuggestion */
export interface GbgBusinessFindResponseGbgBusinessFindSuggestion {
  /** Id */
  id: string;
  /** Name */
  name: string;
}

/** GbgBusinessRetrieveParams */
export interface GbgBusinessRetrieveParams {
  /**
   * Country
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  /** Name */
  name: string;
}

/** GbgBusinessRetrieveResponse */
export interface GbgBusinessRetrieveResponse {
  business: GbgBusinessRetrieveResponseGbgBusinessRetrieveResult;
}

/** BusinessValidationDetails */
export interface GbgBusinessRetrieveResponseBusinessValidationDetails {
  /**
   * Bn
   * @default null
   */
  bn?: string | null;
  /**
   * Entity Type
   * @default null
   */
  entity_type?: string | null;
  /**
   * Gst Status
   * @default null
   */
  gst_status?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Type
   * @default "business"
   */
  type?: "business";
}

/** GbgBusinessRetrieveResult */
export interface GbgBusinessRetrieveResponseGbgBusinessRetrieveResult {
  /**
   * Bn
   * @default ""
   */
  bn?: string;
  /**
   * Bn Status
   * @default ""
   */
  bn_status?: "ACT" | "CAN" | string;
  /**
   * Cn
   * @default ""
   */
  cn?: string;
  /**
   * Display Name
   * @default ""
   */
  display_name?: string;
  /**
   * Entity Type Text
   * @default ""
   */
  entity_type_text?: string;
  /**
   * Legal Name
   * @default ""
   */
  legal_name?: string;
  /**
   * Tax Status
   * @default null
   */
  tax_status?: "ACT" | "CAN" | "NON" | string | null;
  /**
   * Trading Name
   * @default null
   */
  trading_name?: string | null;
  /** @default null */
  validation?: GbgBusinessRetrieveResponseGbgBusinessRetrieveValidation | null;
}

/** GbgBusinessRetrieveValidation */
export interface GbgBusinessRetrieveResponseGbgBusinessRetrieveValidation {
  /**
   * Bn
   * @default ""
   */
  bn?: string;
  /**
   * Provider
   * @default "gbg"
   */
  provider?: "gbg";
  /**
   * Status
   * @default "not_validated"
   */
  status?:
    | "bn_verified"
    | "bn_verified_no_gst"
    | "bn_verified_gst_unknown"
    | "bn_cancelled"
    | "bn_invalid"
    | "not_validated";
  /** @default null */
  validation_details?: GbgBusinessRetrieveResponseBusinessValidationDetails | null;
  /**
   * Validation Type
   * @default "business"
   */
  validation_type?: "business";
}

/** GbgConfigurationParams */
export interface GbgConfigurationParams {
  /**
   * Api Base Url
   * @default null
   */
  api_base_url?: string | null;
  /**
   * Api Token
   * @default null
   */
  api_token?: string | null;
  /**
   * Api Username
   * @default null
   */
  api_username?: string | null;
  /**
   * Is Address Validation Enabled
   * @default null
   */
  is_address_validation_enabled?: boolean | null;
  /**
   * Is Business Validation Enabled
   * @default null
   */
  is_business_validation_enabled?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
}

/** GbgConfigurationResponse */
export interface GbgConfigurationResponse {
  /** @default null */
  configuration?: GbgConfigurationResponseGbgConfigurationInfo | null;
}

/** GbgConfigurationInfo */
export interface GbgConfigurationResponseGbgConfigurationInfo {
  /**
   * Api Base Url
   * @default null
   */
  api_base_url?: string | null;
  /**
   * Api Token Output
   * @default null
   */
  api_token_output?: string | null;
  /**
   * Api Username
   * @default null
   */
  api_username?: string | null;
  /** Id */
  id: number;
  /** Is Address Validation Enabled */
  is_address_validation_enabled: boolean;
  /** Is Business Validation Enabled */
  is_business_validation_enabled: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Last Updated By Username */
  last_updated_by_username: string;
  /** Last Updated Datetime */
  last_updated_datetime: string;
  /** Organization Id */
  organization_id: number;
}

/** GbgSuburbFindParams */
export interface GbgSuburbFindParams {
  /**
   * Country
   * @minLength 2
   * @maxLength 2
   */
  country: string;
  /** Locality */
  locality: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
}

/** GbgSuburbFindResponse */
export interface GbgSuburbFindResponse {
  /** Suggestions */
  suggestions: GbgSuburbFindResponseGbgSuburbSuggestion[];
}

/** GbgSuburbSuggestion */
export interface GbgSuburbFindResponseGbgSuburbSuggestion {
  /** City */
  city: string;
  /** Full Address */
  full_address: string;
  /** Postcode */
  postcode: string;
  /** State */
  state: string;
  /**
   * Street Address2
   * @default null
   */
  street_address2?: string | null;
}

/**
 * GeneralExpensesConfigParams
 * Request body for setting general expenses configuration.
 */
export interface GeneralExpensesConfigParams {
  /** Is General Expenses Disabled */
  is_general_expenses_disabled: boolean;
  /**
   * Is General Expenses Disabled Per Sub Org
   * @default null
   */
  is_general_expenses_disabled_per_sub_org?: Record<string, boolean> | null;
}

/**
 * GeneralRecoveredAmountsFilterRequest
 * Filters for the general recovered-amounts endpoint.
 */
export interface GeneralRecoveredAmountsFilterRequest {
  /**
   * Claim Number
   * Filter by claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * End Date
   * Only include recovered amounts on or before this recovery date
   * @default null
   */
  end_date?: string | null;
  /**
   * Exposure Number
   * Filter by exposure number
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Include Cancelled
   * Include cancelled recovered amounts (defaults to excluding them)
   * @default false
   */
  include_cancelled?: boolean | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Payable Types
   * Filter general recoveries by payable type
   * @default null
   */
  payable_types?: ("indemnity" | "expenses")[] | null;
  /**
   * Start Date
   * Only include recovered amounts on or after this recovery date
   * @default null
   */
  start_date?: string | null;
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * GeneralRecoveredAmountsListResponse
 * Response schema for the general recovered-amounts list endpoint.
 */
export interface GeneralRecoveredAmountsListResponse {
  /** Pagination metadata */
  metadata: GeneralRecoveredAmountsListResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * General recovered-amount records
   */
  records: GeneralRecoveredAmountsListResponseGeneralRecoveredAmountResponse[];
}

/** ContactEmailModel */
export interface GeneralRecoveredAmountsListResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface GeneralRecoveredAmountsListResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: GeneralRecoveredAmountsListResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: GeneralRecoveredAmountsListResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface GeneralRecoveredAmountsListResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * GeneralRecoveredAmountResponse
 * A single general recovered-amount line item.
 */
export interface GeneralRecoveredAmountsListResponseGeneralRecoveredAmountResponse {
  /**
   * Amount
   * Recovered amount
   * @default null
   */
  amount?: number | null;
  /**
   * Cancellation Datetime
   * When the amount was cancelled (ISO 8601)
   * @default null
   */
  cancellation_datetime?: string | null;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Contacts
   * Contacts related to this recovered amount
   */
  contacts?: GeneralRecoveredAmountsListResponseContactModel[];
  /**
   * Currency
   * Currency code
   * @default null
   */
  currency?: string | null;
  /**
   * Exposure Number
   * Exposure number, if the recovery is exposure-level
   * @default null
   */
  exposure_number?: string | null;
  /**
   * General Recovery Type
   * Configured general recovery type
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * Id
   * Recovered amount ID
   */
  id: number;
  /**
   * Is Cancelled
   * Whether this recovered amount has been cancelled
   */
  is_cancelled: boolean;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the amount
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * Recovery note
   * @default null
   */
  note?: string | null;
  /**
   * Payable Type
   * Payable type (indemnity / expenses)
   * @default null
   */
  payable_type?: string | null;
  /**
   * Recovered From Contact Ref Id
   * Reference ID of the contact the amount was recovered from
   * @default null
   */
  recovered_from_contact_ref_id?: string | null;
  /**
   * Recovery Date
   * When the amount was recovered (ISO 8601)
   * @default null
   */
  recovery_date?: string | null;
  /**
   * Recovery Group Id
   * Shared id linking the allocation rows of a single split recovery action. Rows of one group may span pages, and total_count counts rows (allocations), not user actions — group rows by this id to reconstruct actions.
   * @default null
   */
  recovery_group_id?: string | null;
  /**
   * Reference
   * Reference number or identifier
   * @default null
   */
  reference?: string | null;
  /**
   * Vat Amount
   * GST/VAT amount included in the recovery
   * @default null
   */
  vat_amount?: number | null;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface GeneralRecoveredAmountsListResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/** GeneralRecovery */
export interface GeneralRecovery {
  /** Amount */
  amount: number;
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * General Recovery Type
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * Is Vat Included
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /** Recovered From Contact Id */
  recovered_from_contact_id: number;
  /**
   * Reference
   * @default null
   */
  reference?: string | null;
  /**
   * Vat Amount
   * @default null
   */
  vat_amount?: number | null;
}

/** GeneralRecoveryFilterRequest */
export interface GeneralRecoveryFilterRequest {
  /**
   * Completed Datetime End
   * Filter recoveries completed on or before this date (ISO 8601 format)
   * @default null
   */
  completed_datetime_end?: string | null;
  /**
   * Completed Datetime Start
   * Filter recoveries completed on or after this date (ISO 8601 format)
   * @default null
   */
  completed_datetime_start?: string | null;
  /**
   * Created Datetime End
   * Filter recoveries created on or before this date (ISO 8601 format)
   * @default null
   */
  created_datetime_end?: string | null;
  /**
   * Created Datetime Start
   * Filter recoveries created on or after this date (ISO 8601 format)
   * @default null
   */
  created_datetime_start?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Exposure Number
   * Filter by exposure number
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
}

/** GeneralRecoveryGroup */
export interface GeneralRecoveryGroup {
  /** Allocations */
  allocations: GeneralRecoveryGroupGeneralRecoveryGroupAllocation[];
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * Is Vat Included
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /** Recovered From Contact Id */
  recovered_from_contact_id: number;
  /** Recovery Group Id */
  recovery_group_id: string;
  /**
   * Reference
   * @default null
   */
  reference?: string | null;
  /** Total Amount */
  total_amount: number;
}

/** GeneralRecoveryGroupAllocation */
export interface GeneralRecoveryGroupGeneralRecoveryGroupAllocation {
  /** Amount */
  amount: number;
  /**
   * General Recovery Type
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * General Recovery Type Desc
   * @default null
   */
  general_recovery_type_desc?: string | null;
  /** Id */
  id: number;
  /**
   * Payable Type
   * @default null
   */
  payable_type?: string | null;
  /**
   * Vat Amount
   * @default null
   */
  vat_amount?: number | null;
}

/**
 * GeneralRecoveryGroupResponse
 * One general-recovery action, as returned by the create.
 *
 * Serialized through the same builder as the general_recovery_posted webhook payload, so an
 * action looks the same however a consumer receives it - plus ``check_number``, the one field
 * this response carries and that payload does not. The totals sum the allocations, the flat
 * fields are the action-level facts every allocation shares, and the division lives in
 * ``allocations`` (a one-element array when the action wrote a single row).
 */
export interface GeneralRecoveryGroupResponse {
  /**
   * Allocations
   * The action's allocations; a single recovery carries exactly one
   */
  allocations: GeneralRecoveryGroupResponseGeneralRecoveryGroupAllocationResponse[];
  /**
   * Check Number
   * Check number the recovery was received on
   * @default null
   */
  check_number?: string | null;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Contacts
   * Array of contact models related to this recovery
   */
  contacts?: GeneralRecoveryGroupResponseContactModel[];
  /**
   * Currency
   * Currency code
   */
  currency: string;
  /**
   * Exposure Number
   * Exposure number if this is an exposure-level recovery
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the recovery amounts
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * Recovery notes
   * @default null
   */
  note?: string | null;
  /**
   * Recovered From Contact Ref Id
   * Reference ID of the contact from whom recovery was received
   * @default null
   */
  recovered_from_contact_ref_id?: string | null;
  /**
   * Recovery Group Id
   * Shared id linking the allocation rows of this action in the row-based recovery APIs; null when the action had a single allocation, which forms no group
   * @default null
   */
  recovery_group_id?: string | null;
  /**
   * Reference
   * Reference number or identifier
   * @default null
   */
  reference?: string | null;
  /**
   * Total Amount
   * The action's total recovery amount (sum of the allocations)
   */
  total_amount: number;
  /**
   * Total Vat Amount
   * The action's total GST/VAT (sum of the allocations); null when not included
   * @default null
   */
  total_vat_amount?: number | null;
}

/** ContactEmailModel */
export interface GeneralRecoveryGroupResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface GeneralRecoveryGroupResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: GeneralRecoveryGroupResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: GeneralRecoveryGroupResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface GeneralRecoveryGroupResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * GeneralRecoveryGroupAllocationResponse
 * One allocation of a general-recovery action.
 *
 * ``id`` is the ``RecoveryAmount`` row identifier - the rows have no ``api_uid``, so these ids
 * are what correlate the action with the row-based recoveries list.
 */
export interface GeneralRecoveryGroupResponseGeneralRecoveryGroupAllocationResponse {
  /**
   * Amount
   * Amount allocated to this payable type and recovery type
   */
  amount: number;
  /**
   * General Recovery Type
   * Configured recovery type id; null for an untyped allocation
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * General Recovery Type Desc
   * Configured display description of the recovery type; null for an untyped allocation
   * @default null
   */
  general_recovery_type_desc?: string | null;
  /**
   * Id
   * Identifier of the general recovery amount record
   */
  id: number;
  /**
   * Payable Type
   * Type of payable (indemnity or expenses)
   */
  payable_type: string;
  /**
   * Vat Amount
   * This allocation's GST/VAT amount; null when the action carries no GST/VAT
   * @default null
   */
  vat_amount?: number | null;
}

/** GeneralRecoveryListResponse */
export interface GeneralRecoveryListResponse {
  /** Pagination metadata */
  metadata: GeneralRecoveryListResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * List of general recovery amount records for this page
   */
  records: GeneralRecoveryListResponseGeneralRecoveryAmountResponse[];
}

/** ContactEmailModel */
export interface GeneralRecoveryListResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface GeneralRecoveryListResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: GeneralRecoveryListResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: GeneralRecoveryListResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface GeneralRecoveryListResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** GeneralRecoveryAmountResponse */
export interface GeneralRecoveryListResponseGeneralRecoveryAmountResponse {
  /**
   * Amount
   * Recovery amount
   */
  amount: number;
  /**
   * Check Number
   * Check number the recovery was received on
   * @default null
   */
  check_number?: string | null;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Contacts
   * Array of contact models related to this recovery
   */
  contacts?: GeneralRecoveryListResponseContactModel[];
  /**
   * Currency
   * Currency code
   */
  currency: string;
  /**
   * Exposure Number
   * Exposure number if this is an exposure-level recovery
   * @default null
   */
  exposure_number?: string | null;
  /**
   * General Recovery Type
   * Configured recovery type id; null for an untyped recovery
   * @default null
   */
  general_recovery_type?: string | null;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the recovery amount
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * Recovery notes
   * @default null
   */
  note?: string | null;
  /**
   * Payable Type
   * Type of payable (indemnity or expenses)
   */
  payable_type: string;
  /**
   * Recovered From Contact Ref Id
   * Reference ID of the contact from whom recovery was received
   * @default null
   */
  recovered_from_contact_ref_id?: string | null;
  /**
   * Recovery Group Id
   * Shared id linking the allocation rows of a single split recovery action; null for single-allocation actions and legacy rows
   * @default null
   */
  recovery_group_id?: string | null;
  /**
   * Reference
   * Reference number or identifier
   * @default null
   */
  reference?: string | null;
  /**
   * Vat Amount
   * GST/VAT amount included in the recovery
   * @default null
   */
  vat_amount?: number | null;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface GeneralRecoveryListResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/** GenerateReportRequest */
export interface GenerateReportRequest {
  /**
   * Output format for the generated report
   * @default "excel"
   */
  export_format?: GenerateReportRequestGeneratedReportExportFormat;
  /**
   * Name
   * User-provided name for the generated report
   * @default null
   */
  name?: string | null;
  /**
   * Parameters
   * Filter parameter values keyed by parameter ID, e.g. {"param-uuid": "value"}
   * @default null
   */
  parameters?: Record<string, any> | null;
  /**
   * Report Template Id
   * ID of the report template to generate
   */
  report_template_id: number;
  /**
   * Snapshot Date
   * Snapshot date for historical report generation (YYYY-MM-DD)
   * @default null
   */
  snapshot_date?: string | null;
}

/** GeneratedGenericTemplateResponse */
export interface GeneratedGenericTemplateResponse {
  /** @default null */
  additional_data?: GeneratedGenericTemplateResponseNotificationTemplateFields | null;
  /** Body Template */
  body_template: string;
  /** Failed Token Display Names */
  failed_token_display_names: string[];
  /** Id */
  id: number;
  /**
   * Title Template
   * @default null
   */
  title_template?: string | null;
}

/** NotificationTemplateFields */
export interface GeneratedGenericTemplateResponseNotificationTemplateFields {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Due Date
   * @default null
   */
  due_date?: string | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
}

/** GeneratedReportErrorResponse */
export interface GeneratedReportErrorResponse {
  /**
   * Message
   * Error message describing the failure
   */
  message: string;
}

/** GeneratedReportListResponse */
export interface GeneratedReportListResponse {
  /**
   * Reports
   * List of generated report records
   */
  reports?: GeneratedReportListResponseGeneratedReportResponse[];
  /**
   * Total
   * Total number of generated reports
   */
  total: number;
}

/** GeneratedReportResponse */
export interface GeneratedReportListResponseGeneratedReportResponse {
  /**
   * Completed At
   * When the report completed or failed
   * @default null
   */
  completed_at?: string | null;
  /**
   * Error Message
   * Error message if status is failed
   * @default null
   */
  error_message?: string | null;
  /** Output format of the generated file */
  export_format: GeneratedReportListResponseGeneratedReportExportFormat;
  /**
   * File Name
   * Name of the generated file if completed
   * @default null
   */
  file_name?: string | null;
  /**
   * Id
   * Unique identifier for this generated report
   */
  id: number;
  /**
   * Name
   * User-provided or auto-generated name for the report
   * @default null
   */
  name?: string | null;
  /**
   * Report Template Id
   * ID of the report template used
   */
  report_template_id: number;
  /**
   * Report Template Name
   * Name of the report template
   * @default null
   */
  report_template_name?: string | null;
  /**
   * Requested At
   * When the report was requested
   * @format date-time
   */
  requested_at: string;
  /**
   * Requested By Name
   * Display name of the requesting user
   * @default null
   */
  requested_by_name?: string | null;
  /**
   * Requested By User Id
   * ID of the user who requested the report
   */
  requested_by_user_id: string;
  /**
   * Snapshot Date
   * Snapshot date if report was generated from a historical snapshot
   * @default null
   */
  snapshot_date?: string | null;
  /** Current status of the report generation */
  status: GeneratedReportListResponseGeneratedReportStatus;
  /**
   * Stored File Id
   * ID of the generated file if completed
   * @default null
   */
  stored_file_id?: number | null;
}

/** GeneratedReportResponse */
export interface GeneratedReportResponse {
  /**
   * Completed At
   * When the report completed or failed
   * @default null
   */
  completed_at?: string | null;
  /**
   * Error Message
   * Error message if status is failed
   * @default null
   */
  error_message?: string | null;
  /** Output format of the generated file */
  export_format: GeneratedReportResponseGeneratedReportExportFormat;
  /**
   * File Name
   * Name of the generated file if completed
   * @default null
   */
  file_name?: string | null;
  /**
   * Id
   * Unique identifier for this generated report
   */
  id: number;
  /**
   * Name
   * User-provided or auto-generated name for the report
   * @default null
   */
  name?: string | null;
  /**
   * Report Template Id
   * ID of the report template used
   */
  report_template_id: number;
  /**
   * Report Template Name
   * Name of the report template
   * @default null
   */
  report_template_name?: string | null;
  /**
   * Requested At
   * When the report was requested
   * @format date-time
   */
  requested_at: string;
  /**
   * Requested By Name
   * Display name of the requesting user
   * @default null
   */
  requested_by_name?: string | null;
  /**
   * Requested By User Id
   * ID of the user who requested the report
   */
  requested_by_user_id: string;
  /**
   * Snapshot Date
   * Snapshot date if report was generated from a historical snapshot
   * @default null
   */
  snapshot_date?: string | null;
  /** Current status of the report generation */
  status: GeneratedReportResponseGeneratedReportStatus;
  /**
   * Stored File Id
   * ID of the generated file if completed
   * @default null
   */
  stored_file_id?: number | null;
}

/** GeneratedVideoTemplateResponse */
export interface GeneratedVideoTemplateResponse {
  /** Body Email Html */
  body_email_html: string;
  /**
   * Sms Html
   * @default null
   */
  sms_html?: string | null;
  /** Title Email Html */
  title_email_html: string;
}

/**
 * GenericResponse
 * Generic response model for simple operations.
 */
export interface GenericResponse {
  /** Message */
  message: string;
  /**
   * Success
   * @default true
   */
  success?: boolean;
}

/** GenericTemplateResponse */
export interface GenericTemplateResponse {
  /** Body Template */
  body_template: string;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Connected Automatic Rule Actions Display Names
   * @default null
   */
  connected_automatic_rule_actions_display_names?: string[] | null;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverage Keys
   * @default null
   */
  coverage_keys?: string[] | null;
  /**
   * Datetime Created
   * @default null
   */
  datetime_created?: string | null;
  /**
   * Datetime Enabled
   * @default null
   */
  datetime_enabled?: string | null;
  /**
   * Document Template Id
   * @default null
   */
  document_template_id?: number | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /**
   * Dynamic Token Fields
   * @default null
   */
  dynamic_token_fields?: string[] | null;
  /**
   * External Template Id
   * @default null
   */
  external_template_id?: string | null;
  /** Id */
  id: number;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All States
   * @default null
   */
  is_all_states?: boolean | null;
  /**
   * Is All Suborgs
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /** Is Claim Level */
  is_claim_level: boolean;
  /**
   * Is Due Date Immediate
   * @default null
   */
  is_due_date_immediate?: boolean | null;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Last Update Datetime
   * @default null
   */
  last_update_datetime?: string | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Ulid
   * @default null
   */
  sync_ulid?: string | null;
  /** Template Name */
  template_name: string;
  /** Template Type */
  template_type: string;
  /**
   * Title Template
   * @default null
   */
  title_template?: string | null;
}

/**
 * GenericTemplateSectionsResponse
 * A template's live conditional sections, in the order they were added.
 */
export interface GenericTemplateSectionsResponse {
  /** Sections */
  sections: GenericTemplateSectionsResponseGenericTemplateSectionResponse[];
}

/**
 * GenericTemplateSectionResponse
 * A live conditional section of a template.
 */
export interface GenericTemplateSectionsResponseGenericTemplateSectionResponse {
  /** Conditions Json */
  conditions_json: Record<string, any>;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/** GenericTemplatesGenerateFromTemplateRequest */
export interface GenericTemplatesGenerateFromTemplateRequest {
  /**
   * Contact Id
   * @default null
   */
  contact_id?: number | null;
  /**
   * Document Id
   * @default null
   */
  document_id?: number | null;
  /**
   * Document Request Id
   * @default null
   */
  document_request_id?: number | null;
  /**
   * E Signature Contact Id
   * @default null
   */
  e_signature_contact_id?: number | null;
  /**
   * E Signature Document Id
   * @default null
   */
  e_signature_document_id?: number | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * Is Preview
   * @default false
   */
  is_preview?: boolean;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Recipient Contact Id
   * @default null
   */
  recipient_contact_id?: number | null;
}

/**
 * GenericTemplatesMetadataRequest
 * The generic template list's query: the shared filters plus the column to order by.
 */
export interface GenericTemplatesMetadataRequest {
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Coverage Keys
   * @default []
   */
  coverage_keys?: string[] | null;
  /**
   * Include Moi Email
   * @default false
   */
  include_moi_email?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * True restricts the list to templates that target every line of business. Omitted or false applies no such restriction.
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Suborgs
   * True restricts the list to templates that target every sub-organization. Omitted or false applies no such restriction.
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /**
   * Is Claim Level
   * @default null
   */
  is_claim_level?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Limit
   * @default null
   */
  limit?: number | null;
  /**
   * Lobs
   * @default []
   */
  lobs?: string[] | null;
  /**
   * Match Full Scope
   * True requires a template to target every listed sub-organization and every listed line of business (or All on that dimension). Omitted or false lists a template that targets any of them.
   * @default null
   */
  match_full_scope?: boolean | null;
  /**
   * Order By
   * @default null
   */
  order_by?: "asc" | "desc" | null;
  /**
   * Page
   * @default null
   */
  page?: number | null;
  /**
   * Sort By
   * @default "template_name"
   */
  sort_by?: "template_name" | "last_update_datetime";
  /**
   * States
   * @default []
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[] | null;
  /**
   * Template Name
   * @default null
   */
  template_name?: string | null;
  /**
   * Template Type
   * @default null
   */
  template_type?: string | null;
}

/** GenericTemplatesMetadataResponse */
export interface GenericTemplatesMetadataResponse {
  /** Count */
  count: number;
  /** Templates Metadata */
  templates_metadata: GenericTemplatesMetadataResponseGenericTemplateMetadataResponse[];
}

/** GenericTemplateMetadataResponse */
export interface GenericTemplatesMetadataResponseGenericTemplateMetadataResponse {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Connected Automatic Rule Actions Display Names
   * @default null
   */
  connected_automatic_rule_actions_display_names?: string[] | null;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverage Keys
   * @default null
   */
  coverage_keys?: string[] | null;
  /**
   * Document Template Id
   * @default null
   */
  document_template_id?: number | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /** Dynamic Token Fields */
  dynamic_token_fields: string[];
  /** Id */
  id: number;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is Due Date Immediate
   * @default true
   */
  is_due_date_immediate?: boolean | null;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Last Update Datetime
   * @format date-time
   */
  last_update_datetime: string;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /** Template Name */
  template_name: string;
  /** Template Type */
  template_type: string;
}

/** GenericTemplatesTokensResponse */
export interface GenericTemplatesTokensResponse {
  /** Tokens */
  tokens: GenericTemplatesTokensResponseGenericTemplatesTokenResponse[];
}

/** GenericTemplatesTokenResponse */
export interface GenericTemplatesTokensResponseGenericTemplatesTokenResponse {
  /** Category */
  category: string;
  /** Display Name */
  display_name: string;
  /**
   * Exclude Feature Specific
   * @default null
   */
  exclude_feature_specific?: string[] | null;
  /**
   * Feature Specific
   * @default null
   */
  feature_specific?: string[] | null;
  /** Lobs */
  lobs: GenericTemplatesTokensResponseTokenLobResponse[];
  /**
   * Sub Organizations
   * @default null
   */
  sub_organizations?:
    | GenericTemplatesTokensResponseTokenSubOrgResponse[]
    | null;
  /**
   * Tags
   * @default null
   */
  tags?: string[] | null;
  /**
   * Token Group
   * @default null
   */
  token_group?: string[] | null;
  /** Token Key */
  token_key: string;
  /** Url Safe */
  url_safe: boolean;
  /**
   * What a token's resolved value is, structurally.
   *
   * ``TEXT`` is a plain scalar, safe to embed anywhere a string goes — body text or a
   * hyperlink ``href``. ``HTML`` resolves to markup (a whole ``<a>`` element, say) and
   * only makes sense in body text; putting one in an attribute would emit markup where
   * the browser expects a URL. The render path and the link dialog's token picker both
   * read this to decide which tokens an ``href`` accepts.
   */
  value_type: GenericTemplatesTokensResponseGenericTemplatesTokenValueType;
}

/** TokenLobResponse */
export interface GenericTemplatesTokensResponseTokenLobResponse {
  /** Display Name */
  display_name: string;
  /** Key */
  key: string;
}

/** TokenSubOrgResponse */
export interface GenericTemplatesTokensResponseTokenSubOrgResponse {
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** GetActionsParams */
export interface GetActionsParams {
  /**
   * Additional Data
   * @default "additional_data"
   */
  additional_data?: boolean | null;
}

/** GetCategoriesResponseList */
export type GetCategoriesResponseList =
  GetCategoriesResponseListGetCategoriesResponse[];

/** GetCategoriesResponse */
export interface GetCategoriesResponseListGetCategoriesResponse {
  /** Color */
  color: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/**
 * GetConditionFieldsParams
 * Query params for the QueryBuilder field-registry endpoint.
 *
 * `entity` selects which providers contribute fields:
 * - 'claims'    → claim_context_provider only
 * - 'exposures' → claim_context_provider + exposure_context_provider
 *
 * `is_all_sub_orgs` / `sub_org_ids` narrow enum enrichment to specific sub-orgs'
 * configs (None / all-flag → all sub-orgs). `filtering_mode` is documented for
 * forward compat; only INTERSECTION is wired through the catalog flow today.
 */
export interface GetConditionFieldsParams {
  /** Entity */
  entity: "claims" | "exposures";
  /** @default "intersection" */
  filtering_mode?: GetConditionFieldsParamsFilteringMode;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lob */
  lob: string;
  "sub_org_ids[]"?: GetConditionFieldsParamsEnsuredListInt;
}

export type GetConditionFieldsParamsEnsuredListInt = number[];

/** GetControlFileJsonResponse */
export interface GetControlFileJsonResponse {
  /**
   * Criteria
   * @default null
   */
  criteria?: string[] | null;
  /** Is Marked */
  is_marked: boolean;
  /**
   * Report Status
   * @default null
   */
  report_status?: string | null;
}

/**
 * GetCoverageConfigsQueryParams
 * Query parameters for GET /coverage_configs and /shared_coverage_configs endpoints.
 */
export interface GetCoverageConfigsQueryParams {
  /**
   * Include Disabled
   * @default false
   */
  include_disabled?: boolean;
  /**
   * Lob
   * Line of Business
   */
  lob: string;
  /** @default null */
  "sub_organization_ids[]"?: GetCoverageConfigsQueryParamsEnsuredListInt | null;
}

export type GetCoverageConfigsQueryParamsEnsuredListInt = number[];

/**
 * GetCoveragesQueryParams
 * Query parameters for GET /coverages endpoint.
 */
export interface GetCoveragesQueryParams {
  /**
   * Lob
   * Line of Business
   */
  lob: string;
  /**
   * Only Org Level Required
   * @default false
   */
  only_org_level_required?: boolean;
  /** @default null */
  "sub_orgs_ids[]"?: GetCoveragesQueryParamsEnsuredListInt | null;
}

export type GetCoveragesQueryParamsEnsuredListInt = number[];

/** GetDocumentsResponse */
export interface GetDocumentsResponse {
  metadata: GetDocumentsResponsePaginationMetadata;
  /** Records */
  records: GetDocumentsResponseDocumentOutModel[];
}

/** DocumentOutModel */
export interface GetDocumentsResponseDocumentOutModel {
  /**
   * Additional Fields
   * Values for the document type's configured additional fields, keyed by field id. Validated against the document type's configured_fields definition; mandatory fields must be present and field-type validation applies.
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** Api Uid */
  api_uid: string | null;
  /**
   * Datetime Uploaded
   * Timestamp (UTC, ISO-8601, with a Z suffix) at which the document was uploaded to the claim. This is the upload time shown in the Five Sigma UI, and is distinct from the business dates document_date and document_date_received. Null if not recorded.
   * @default null
   */
  datetime_uploaded?: string | null;
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Extension
   * @default null
   */
  document_extension?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Size
   * File size of the document in bytes. Null if size is not recorded.
   * @default null
   */
  document_size?: number | null;
  /** Document Type */
  document_type: string;
  /**
   * Document Url
   * @default null
   */
  document_url?: string | null;
  /**
   * Exposure Numbers
   * List of exposure numbers associated with the document
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Exposures
   * Deprecated: Use exposure_numbers instead
   * @deprecated
   * @default null
   */
  exposures?: string[] | null;
  /** External Id */
  external_id: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** PaginationLinks */
export interface GetDocumentsResponsePaginationLinks {
  /**
   * Current
   * URL for current page
   */
  current: string | null;
  /**
   * Next
   * URL for next page, null if on last page
   */
  next: string | null;
  /**
   * Previous
   * URL for previous page, null if on first page
   */
  previous: string | null;
}

/** PaginationMetadata */
export interface GetDocumentsResponsePaginationMetadata {
  /**
   * Current Page
   * Current page number
   * @min 1
   */
  current_page: number;
  links: GetDocumentsResponsePaginationLinks;
  /**
   * Per Page
   * Number of results per page
   * @exclusiveMin 0
   */
  per_page: number;
  /**
   * Total Count
   * Total number of results
   */
  total_count: number;
  /**
   * Total Pages
   * Total number of pages
   */
  total_pages: number;
}

/**
 * GetExchangeRatesParams
 * Request parameters for getting exchange rates.
 */
export interface GetExchangeRatesParams {
  /**
   * Base Currency
   * Base currency for exchange rates (default: USD)
   * @default "USD"
   */
  base_currency?: string;
  /**
   * Currencies
   * List of currency codes to fetch rates for
   */
  currencies: string[];
  /**
   * Date
   * Date for historical exchange rates (YYYY-MM-DD)
   * @format date
   */
  date: string;
}

/** GetExposureResponse */
export interface GetExposureResponse {
  /** Claim Number */
  claim_number: string;
  /** Close Reason */
  close_reason: string | null;
  /** Contacts */
  contacts: GetExposureResponseContactModel[];
  /** Coverage Decision */
  coverage_decision: string | null;
  /** Coverage Display Name */
  coverage_display_name: string;
  /** Coverage Group Display Name */
  coverage_group_display_name: string | null;
  /** Coverage Group Key */
  coverage_group_key: string | null;
  /** Coverage Iso Code */
  coverage_iso_code: string | null;
  /** Coverage Issue */
  coverage_issue: string | null;
  /** Coverage Key */
  coverage_key: string;
  damage_assessment: GetExposureResponseDamageAssessment;
  /** Date Closed */
  date_closed: string | null;
  /** Deductible Amount */
  deductible_amount: number | null;
  /** Deductible Reason */
  deductible_reason: string | null;
  /**
   * Expenses General Recovered
   * @default null
   */
  expenses_general_recovered?: number | null;
  /** Expenses Paid Sum */
  expenses_paid_sum: number;
  /** Expenses Reserve */
  expenses_reserve: number;
  /**
   * Expenses Sub Reserves
   * @default null
   */
  expenses_sub_reserves?: Record<string, number> | null;
  /** Exposure Number */
  exposure_number: string;
  /**
   * Indemnity General Recovered
   * @default null
   */
  indemnity_general_recovered?: number | null;
  /** Indemnity Paid Sum */
  indemnity_paid_sum: number;
  /** Indemnity Reserve */
  indemnity_reserve: number;
  /**
   * Indemnity Sub Reserves
   * @default null
   */
  indemnity_sub_reserves?: Record<string, number> | null;
  /** Involved Party */
  involved_party:
    | (
        | GetExposureResponseGenericInvolvedPersonModel
        | GetExposureResponseInvolvedGenericPropertyModel
        | GetExposureResponseInvolvedDriverModel
        | GetExposureResponseInvolvedPassengerModel
        | GetExposureResponseInvolvedNonMotoristModel
        | GetExposureResponseInvolvedVehicleModel
        | GetExposureResponseAutoGenericPropertyModel
      )
    | null;
  /**
   * Is Deductible Applied
   * @default null
   */
  is_deductible_applied?: boolean | null;
  /** Is Deductible Waived */
  is_deductible_waived: boolean | null;
  /**
   * Is In Litigation
   * @default null
   */
  is_in_litigation?: boolean | null;
  /** Is Moi Assigned */
  is_moi_assigned: boolean;
  /**
   * Legal Action Status
   * @default null
   */
  legal_action_status?: "Active" | "Closed" | null;
  /**
   * Mor
   * Method of Resolution
   */
  mor: string | null;
  owner: GetExposureResponseUserExternalAPIBaseModel;
  /** Policy Number */
  policy_number: string | null;
  /** Salvage Received */
  salvage_received: number | null;
  /** Status */
  status: "open" | "closed";
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
  /** Subro Received */
  subro_received: number | null;
}

/** AutoGenericPropertyModel */
export interface GetExposureResponseAutoGenericPropertyModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Damages */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /** Items */
  items?: GetExposureResponsePropertyItemIncomingModel[];
  /** @default null */
  location?: GetExposureResponseLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** Type */
  type: "generic_involved_property";
}

/** BodilyInjuryLossModel */
export interface GetExposureResponseBodilyInjuryLossModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /** Bodily Injuries */
  bodily_injuries: GetExposureResponseBodilyInjuryModel[];
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /** Icd Codes */
  icd_codes: GetExposureResponseICDCodeModel[];
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface GetExposureResponseBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/** ContactEmailModel */
export interface GetExposureResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface GetExposureResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: GetExposureResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: GetExposureResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface GetExposureResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** DamageAssessment */
export interface GetExposureResponseDamageAssessment {
  /** Amount */
  amount: number | null;
  /** Inspection Date */
  inspection_date: string | null;
}

/** GenericInvolvedPersonModel */
export interface GetExposureResponseGenericInvolvedPersonModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: GetExposureResponseBodilyInjuryLossModel | null;
  /** Contact Ref Id */
  contact_ref_id: string;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: GetExposureResponsePecuniaryLossDetailsModel | null;
  /** @default null */
  related_property_loss?: GetExposureResponsePropertyLossWithItemsModel | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: string;
}

/** ICDCodeModel */
export interface GetExposureResponseICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** InvolvedDriverModel */
export interface GetExposureResponseInvolvedDriverModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Any Dvla Medical Conditions
   * @default null
   */
  any_dvla_medical_conditions?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: GetExposureResponseBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Dvla Medical Conditions Description
   * @default null
   */
  dvla_medical_conditions_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * License Issuing State
   * @default null
   */
  license_issuing_state?: string | null;
  /**
   * License Number
   * @default null
   */
  license_number?: string | null;
  /**
   * License Type
   * @default null
   */
  license_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_driver";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Who Authorized The Driver To Drive The Vehicle
   * @default null
   */
  who_authorized_the_driver_to_drive_the_vehicle?: string | null;
  /**
   * Years Of Driving Experience
   * @default null
   */
  years_of_driving_experience?: number | null;
}

/** InvolvedGenericPropertyModel */
export interface GetExposureResponseInvolvedGenericPropertyModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: GetExposureResponseLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /** @default null */
  pecuniary_loss?: GetExposureResponsePecuniaryLossDetailsModel | null;
  /** @default null */
  property_damage?: GetExposureResponsePropertyDamageModel | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** @default null */
  related_property_loss?: GetExposureResponsePropertyLossWithItemsModel | null;
  /** Type */
  type: string;
}

/** InvolvedNonMotoristModel */
export interface GetExposureResponseInvolvedNonMotoristModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: GetExposureResponseBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /** Means Of Transportation */
  means_of_transportation: string;
  /**
   * Non Motorist Type
   * @deprecated
   * @default null
   */
  non_motorist_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_non_motorist";
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedPassengerModel */
export interface GetExposureResponseInvolvedPassengerModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: GetExposureResponseBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Position
   * @default null
   */
  position?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_passenger";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedVehicleModel */
export interface GetExposureResponseInvolvedVehicleModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Appraiser Contact Ref Id
   * @default null
   */
  appraiser_contact_ref_id?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Auto Repair Facility Contact Ref Id
   * @default null
   */
  auto_repair_facility_contact_ref_id?: string | null;
  /**
   * Child Seats
   * @default null
   */
  child_seats?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Covered Vehicle Id
   * @default null
   */
  covered_vehicle_id?: string | null;
  /**
   * Damage Areas
   * Areas of the vehicle that were damaged
   * @default null
   */
  damage_areas?: string[] | null;
  /**
   * Damage Description
   * @default null
   */
  damage_description?: string | null;
  /**
   * Damage Level
   * @default null
   */
  damage_level?: string | null;
  /**
   * Did Vehicle Have Previous Damage
   * @default null
   */
  did_vehicle_have_previous_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Does The Vehicle Have Any Modifications
   * @default null
   */
  does_the_vehicle_have_any_modifications?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is Car Safe To Drive
   * @default null
   */
  is_car_safe_to_drive?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Drivable
   * @default null
   */
  is_drivable?: "yes" | "no" | "na" | "unknown" | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Total Loss
   * @default null
   */
  is_total_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Tow
   * @default null
   */
  is_tow?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Active
   * @default null
   */
  is_vehicle_camera_active?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: GetExposureResponseLocationModel | null;
  /**
   * Modification Description
   * @default null
   */
  modification_description?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Point Of Impact
   * @default null
   */
  point_of_impact?: string | null;
  /**
   * Previous Damage Description
   * @default null
   */
  previous_damage_description?: string | null;
  /**
   * Previous Damage Level
   * @default null
   */
  previous_damage_level?: string | null;
  /**
   * Scheduling Inspection Contact Ref Id
   * @default null
   */
  scheduling_inspection_contact_ref_id?: string | null;
  /**
   * Tower Contact Ref Id
   * @default null
   */
  tower_contact_ref_id?: string | null;
  /** Type */
  type: "involved_vehicle";
  /**
   * Detailed vehicle information
   * @default null
   */
  vehicle?: GetExposureResponseVehicleDetailsModel | null;
  /**
   * Location details for the vehicle
   * @default null
   */
  vehicle_location?: GetExposureResponseLocationModel | null;
  /**
   * Vehicle Speed
   * @default null
   */
  vehicle_speed?: string | null;
}

/** LocationModel */
export interface GetExposureResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PecuniaryLossDetailsModel */
export interface GetExposureResponsePecuniaryLossDetailsModel {
  /** Losses */
  losses: GetExposureResponsePecuniaryLossItemModel[] | null;
}

/** PecuniaryLossItemModel */
export interface GetExposureResponsePecuniaryLossItemModel {
  /** Claimed Amount */
  claimed_amount: number | null;
  /** Claimed Loss */
  claimed_loss: string | null;
  /** Display Name */
  display_name: string | null;
  /** Note */
  note: string | null;
}

/** PropertyDamageModel */
export interface GetExposureResponsePropertyDamageModel {
  /** Is Property Stolen */
  is_property_stolen: boolean | null;
  location: GetExposureResponseLocationModel;
  /** Note */
  note: string | null;
  /** Property Damages */
  property_damages: string[] | null;
  /** Property Damages Description */
  property_damages_description: string | null;
}

/** PropertyItemIncomingModel */
export interface GetExposureResponsePropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyItemOutgoingModel */
export interface GetExposureResponsePropertyItemOutgoingModel {
  /** Category */
  category: string | null;
  /** Claimed Amount */
  claimed_amount: number | null;
  /** Description */
  description: string | null;
  /** Purchase Date */
  purchase_date: string | null;
  /** Purchase Price */
  purchase_price: number | null;
  /** Quantity */
  quantity: number | null;
  /** Scheduled */
  scheduled: string | null;
}

/** PropertyLossWithItemsModel */
export interface GetExposureResponsePropertyLossWithItemsModel {
  /** Damages */
  damages: string[] | null;
  /** Damages Description */
  damages_description: string | null;
  /** Is Stolen */
  is_stolen: boolean | null;
  /** Items */
  items: GetExposureResponsePropertyItemOutgoingModel[] | null;
  /** @default null */
  location?: GetExposureResponseLocationModel | null;
  /** Note */
  note: string | null;
}

/** UserExternalAPIBaseModel */
export interface GetExposureResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** VehicleDetailsModel */
export interface GetExposureResponseVehicleDetailsModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Claim Free Years
   * @default null
   */
  claim_free_years?: number | null;
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Engine Capacity
   * @default null
   */
  engine_capacity?: number | null;
  /**
   * Engine Type
   * @default null
   */
  engine_type?: string | null;
  /**
   * Existing Damage
   * @default null
   */
  existing_damage?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Fuel Type
   * @default null
   */
  fuel_type?: string | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: boolean | null;
  /**
   * Make
   * @default null
   */
  make?: string | null;
  /**
   * Make Ncic Code
   * NCIC code for the vehicle make
   * @default null
   */
  make_ncic_code?: string | null;
  /**
   * Mileage
   * @default null
   */
  mileage?: number | null;
  /**
   * Model
   * @default null
   */
  model?: string | null;
  /**
   * Number Of Seats
   * @default null
   */
  number_of_seats?: number | null;
  /**
   * Ownership Status
   * @default null
   */
  ownership_status?: string | null;
  /**
   * Plate Number
   * @default null
   */
  plate_number?: string | null;
  /**
   * Series
   * @default null
   */
  series?: string | null;
  /**
   * Vehicle Cost New
   * @default null
   */
  vehicle_cost_new?: number | null;
  /**
   * Vehicle Owner Contact Ref Id
   * @default null
   */
  vehicle_owner_contact_ref_id?: string | null;
  /**
   * Vehicle Plate State
   * @default null
   */
  vehicle_plate_state?: string | null;
  /**
   * Vehicle Type
   * @default null
   */
  vehicle_type?: string | null;
  /**
   * Vehicle Use
   * @default null
   */
  vehicle_use?: string | null;
  /**
   * Vehicle Value
   * @default null
   */
  vehicle_value?: number | null;
  /**
   * Vehicle Weight
   * @default null
   */
  vehicle_weight?: number | null;
  /**
   * Vin
   * Vehicle Identification Number
   * @default null
   */
  vin?: string | null;
  /**
   * Year
   * @default null
   */
  year?: number | null;
}

/** GetInvoicesQuery */
export interface GetInvoicesQuery {
  /**
   * Coverage Id
   * @default null
   */
  coverage_id?: number | null;
  /**
   * Document Id
   * @default null
   */
  document_id?: number | null;
}

/** GetNotificationsResponse */
export interface GetNotificationsResponse {
  metadata: GetNotificationsResponsePaginationMetadata;
  /** Records */
  records: GetNotificationsResponseNotificationExternalModel[];
}

/** NotificationExternalModel */
export interface GetNotificationsResponseNotificationExternalModel {
  /**
   * Api Uid
   * FiveSigma External Notifications ID
   */
  api_uid: string;
  /**
   * Category
   * The notification category
   */
  category: string | null;
  /**
   * Claim Number
   * The claim number
   */
  claim_number: string | null;
  /**
   * Creation Datetime
   * The datetime the notification was created
   */
  creation_datetime: string | null;
  /**
   * Creator User Email
   * Email of the user who created the notification
   */
  creator_user_email: string | null;
  /**
   * Creator User Name
   * Name of the user who created the notification
   */
  creator_user_name: string | null;
  /**
   * Details
   * The notifications details
   */
  details: string | null;
  /**
   * Dismissed Datetime
   * The datetime the notification was dismissed
   */
  dismissed_datetime: string | null;
  /**
   * Dismissing User Email
   * Email of the user that dismissed the notification
   */
  dismissing_user_email: string | null;
  /**
   * Dismissing User Name
   * Name of the user that dismissed the notification
   */
  dismissing_user_name: string | null;
  /**
   * Due Date
   * The date the notification is due
   */
  due_date: string | null;
  /**
   * Due Datetime
   * The datetime the notification is due
   */
  due_datetime: string | null;
  /**
   * Effective User Email
   * Email of the user currently receiving the notifications
   */
  effective_user_email: string | null;
  /**
   * Effective User Name
   * Name of the user currently receiving the notifications
   */
  effective_user_name: string | null;
  /**
   * Exposure Number
   * The exposure number
   */
  exposure_number: string | null;
  /**
   * Is Automatic
   * true if the notification was created by the system
   */
  is_automatic: boolean | null;
  /**
   * Priority
   * The notification priority
   */
  priority: "high" | "medium" | "low" | null;
  /**
   * Title
   * Notification title
   */
  title: string | null;
  /**
   * Type
   * Notification type
   */
  type:
    | "internal_communication_claim_notification"
    | "financial_request_decision_claim_notification"
    | "claim_owner_change_claim_notification"
    | "communication_claim_notification"
    | "reminder_claim_notification"
    | "communication_suggestion_claim_notification_model";
}

/** PaginationLinks */
export interface GetNotificationsResponsePaginationLinks {
  /**
   * Current
   * URL for current page
   */
  current: string | null;
  /**
   * Next
   * URL for next page, null if on last page
   */
  next: string | null;
  /**
   * Previous
   * URL for previous page, null if on first page
   */
  previous: string | null;
}

/** PaginationMetadata */
export interface GetNotificationsResponsePaginationMetadata {
  /**
   * Current Page
   * Current page number
   * @min 1
   */
  current_page: number;
  links: GetNotificationsResponsePaginationLinks;
  /**
   * Per Page
   * Number of results per page
   * @exclusiveMin 0
   */
  per_page: number;
  /**
   * Total Count
   * Total number of results
   */
  total_count: number;
  /**
   * Total Pages
   * Total number of pages
   */
  total_pages: number;
}

/** GetSiuJsonResponse */
export interface GetSiuJsonResponse {
  /** Is Marked As Siu */
  is_marked_as_siu: boolean;
  /**
   * Report Status
   * @default null
   */
  report_status?: string | null;
  /**
   * Siu Criteria
   * @default null
   */
  siu_criteria?: string[] | null;
}

/** GetUploadUrlParams */
export interface GetUploadUrlParams {
  /** Assignment Token */
  assignment_token: string;
  /** File Extension */
  file_extension: string;
  /** File Size */
  file_size: number;
  /** Mime Type */
  mime_type: string;
}

/** GetUploadUrlPayload */
export interface GetUploadUrlPayload {
  /** File Size */
  file_size: number;
  /** File Type */
  file_type: string;
}

/**
 * GlobalFieldInfo
 * One global field as the Global Configuration screen lists it.
 *
 * Carries the scope in both halves rather than a rendered string, so the screen's context
 * picker round-trips what it was given.
 *
 * Built with ``from_row`` rather than ``model_validate(row)``: ``updated_by`` is the
 * username the list column shows, and the row carries a user id. Resolving it here keeps
 * the join in one place instead of leaving every caller to remember it.
 */
export interface GlobalFieldInfo {
  anchor: GlobalFieldInfoGlobalFieldAnchor;
  /**
   * Created Datetime
   * @format date-time
   */
  created_datetime: string;
  /** Definition */
  definition: Record<string, any>;
  /** Id */
  id: number;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /**
   * Last Updated On
   * @format date-time
   */
  last_updated_on: string;
  /** Lobs */
  lobs: string[];
  placement: GlobalFieldInfoGlobalFieldPlacement;
  /** Position */
  position: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
  /** Updated By */
  updated_by: string;
}

/** GlobalFieldInfoList */
export type GlobalFieldInfoList = GlobalFieldInfoListGlobalFieldInfo[];

/**
 * GlobalFieldInfo
 * One global field as the Global Configuration screen lists it.
 *
 * Carries the scope in both halves rather than a rendered string, so the screen's context
 * picker round-trips what it was given.
 *
 * Built with ``from_row`` rather than ``model_validate(row)``: ``updated_by`` is the
 * username the list column shows, and the row carries a user id. Resolving it here keeps
 * the join in one place instead of leaving every caller to remember it.
 */
export interface GlobalFieldInfoListGlobalFieldInfo {
  anchor: GlobalFieldInfoListGlobalFieldAnchor;
  /**
   * Created Datetime
   * @format date-time
   */
  created_datetime: string;
  /** Definition */
  definition: Record<string, any>;
  /** Id */
  id: number;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /**
   * Last Updated On
   * @format date-time
   */
  last_updated_on: string;
  /** Lobs */
  lobs: string[];
  placement: GlobalFieldInfoListGlobalFieldPlacement;
  /** Position */
  position: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
  /** Updated By */
  updated_by: string;
}

/**
 * GlobalPolicyCategoryInfo
 * One global category as the Categories tab lists it.
 */
export interface GlobalPolicyCategoryInfo {
  /** Conditions Json */
  conditions_json: Record<string, any> | null;
  /**
   * Created Datetime
   * @format date-time
   */
  created_datetime: string;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is In Use */
  is_in_use: boolean;
  /** Key */
  key: string;
  /**
   * Last Updated On
   * @format date-time
   */
  last_updated_on: string;
  /** Updated By */
  updated_by: string;
}

/** GlobalPolicyCategoryInfoList */
export type GlobalPolicyCategoryInfoList =
  GlobalPolicyCategoryInfoListGlobalPolicyCategoryInfo[];

/**
 * GlobalPolicyCategoryInfo
 * One global category as the Categories tab lists it.
 */
export interface GlobalPolicyCategoryInfoListGlobalPolicyCategoryInfo {
  /** Conditions Json */
  conditions_json: Record<string, any> | null;
  /**
   * Created Datetime
   * @format date-time
   */
  created_datetime: string;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is In Use */
  is_in_use: boolean;
  /** Key */
  key: string;
  /**
   * Last Updated On
   * @format date-time
   */
  last_updated_on: string;
  /** Updated By */
  updated_by: string;
}

/**
 * GuardrailForbiddenResponse
 * Body of a 403 on a route a guardrail rule can veto. ``guardrails`` is present only on a veto; a 403 for
 * another reason (a missing API permission, for one) carries ``message`` alone.
 */
export interface GuardrailForbiddenResponse {
  /**
   * Present only when a guardrail rule vetoed the request
   * @default null
   */
  guardrails?: GuardrailForbiddenResponseGuardrailVetoDetails | null;
  /**
   * Message
   * On a veto, the admin-authored message of every tripped rule joined with '; ', or 'Action blocked by guardrails.' when the verdict names no rule
   */
  message: string;
}

/**
 * GuardrailVetoDetails
 * The ``guardrails`` object of a vetoed request's error body.
 */
export interface GuardrailForbiddenResponseGuardrailVetoDetails {
  /**
   * Attempt Id
   * @default null
   */
  attempt_id?: string | null;
  /** Is Blocked */
  is_blocked: boolean;
  /** Violations */
  violations: GuardrailForbiddenResponseGuardrailViolation[];
}

/**
 * GuardrailViolation
 * A single triggered guardrail, tagged with the rule's outcome (§6.1b/c).
 *
 * ``type`` is the rule's own configured outcome, never the escalated verdict: a warn the engine
 * escalated for a non-interactive caller still arrives here as ``'warn'``, and the escalation is
 * visible only on ``GuardrailEvalResult.is_blocked``.
 */
export interface GuardrailForbiddenResponseGuardrailViolation {
  /** Key */
  key: string;
  /** Message */
  message: string;
  /** Type */
  type: "warn" | "block" | "route_to_human";
}

/**
 * GuardrailRuleCreateParams
 * Parameters to author a guardrail rule.
 */
export interface GuardrailRuleCreateParams {
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /** Message */
  message: string;
  /** Name */
  name: string;
  /** Outcome */
  outcome: "warn" | "block" | "route_to_human";
  /**
   * Sub-organization / LoB scoping for a guardrail, consistent with the other
   * rules-engine consumers.
   */
  scope?: GuardrailRuleCreateParamsGuardrailScope;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
  /** Trigger Event */
  trigger_event: string;
}

/**
 * GuardrailScope
 * Sub-organization / LoB scoping for a guardrail, consistent with the other
 * rules-engine consumers.
 */
export interface GuardrailRuleCreateParamsGuardrailScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * GuardrailRuleEnableRequest
 * Request body for enabling/disabling a guardrail rule.
 */
export interface GuardrailRuleEnableRequest {
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * GuardrailRuleInfo
 * Flattened view over an ``AutomationRule`` + its ``GuardrailAction`` — the DTO
 * returned to the API (§6.1a). Built via an explicit ``from_rule``-style mapper when
 * CRUD lands (fields draw from both the rule and its action), not from ``from_attributes``.
 */
export interface GuardrailRuleInfo {
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /** Id */
  id: number;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /** Key */
  key: string;
  /** Message */
  message: string;
  /** Name */
  name: string;
  /** Outcome */
  outcome: "warn" | "block" | "route_to_human";
  /**
   * Sub-organization / LoB scoping for a guardrail, consistent with the other
   * rules-engine consumers.
   */
  scope?: GuardrailRuleInfoGuardrailScope;
  /** Trigger Event */
  trigger_event: string;
}

/**
 * GuardrailScope
 * Sub-organization / LoB scoping for a guardrail, consistent with the other
 * rules-engine consumers.
 */
export interface GuardrailRuleInfoGuardrailScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/** GuardrailRuleInfoList */
export type GuardrailRuleInfoList = GuardrailRuleInfoListGuardrailRuleInfo[];

/**
 * GuardrailRuleInfo
 * Flattened view over an ``AutomationRule`` + its ``GuardrailAction`` — the DTO
 * returned to the API (§6.1a). Built via an explicit ``from_rule``-style mapper when
 * CRUD lands (fields draw from both the rule and its action), not from ``from_attributes``.
 */
export interface GuardrailRuleInfoListGuardrailRuleInfo {
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /** Id */
  id: number;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /** Key */
  key: string;
  /** Message */
  message: string;
  /** Name */
  name: string;
  /** Outcome */
  outcome: "warn" | "block" | "route_to_human";
  /**
   * Sub-organization / LoB scoping for a guardrail, consistent with the other
   * rules-engine consumers.
   */
  scope?: GuardrailRuleInfoListGuardrailScope;
  /** Trigger Event */
  trigger_event: string;
}

/**
 * GuardrailScope
 * Sub-organization / LoB scoping for a guardrail, consistent with the other
 * rules-engine consumers.
 */
export interface GuardrailRuleInfoListGuardrailScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * GuardrailRuleListQuery
 * Query parameters for the guardrail rules list endpoint.
 */
export interface GuardrailRuleListQuery {
  /** @default null */
  "lobs[]"?: GuardrailRuleListQueryEnsuredListStr | null;
  /**
   * Outcome
   * Filter by outcome (warn / block / route_to_human)
   * @default null
   */
  outcome?: "warn" | "block" | "route_to_human" | null;
  /**
   * Search Term
   * Free-text search over rule name and message
   * @default null
   */
  search_term?: string | null;
  /** @default null */
  "sub_organization_ids[]"?: GuardrailRuleListQueryEnsuredListInt | null;
}

export type GuardrailRuleListQueryEnsuredListInt = number[];

export type GuardrailRuleListQueryEnsuredListStr = string[];

/**
 * GuardrailRuleUpdateParams
 * Parameters to update a guardrail rule — all fields optional (partial update).
 */
export interface GuardrailRuleUpdateParams {
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Message
   * @default null
   */
  message?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Outcome
   * @default null
   */
  outcome?: "warn" | "block" | "route_to_human" | null;
  /** @default null */
  scope?: GuardrailRuleUpdateParamsGuardrailScope | null;
  /**
   * Trigger Event
   * @default null
   */
  trigger_event?: string | null;
}

/**
 * GuardrailScope
 * Sub-organization / LoB scoping for a guardrail, consistent with the other
 * rules-engine consumers.
 */
export interface GuardrailRuleUpdateParamsGuardrailScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * GuardrailSupportedEventsResponse
 * Trigger events an admin can attach a guardrail to, keyed by event_key.
 */
export interface GuardrailSupportedEventsResponse {
  /** Events */
  events: Record<
    string,
    GuardrailSupportedEventsResponseGuardrailSupportedEventModel
  >;
}

/**
 * GuardrailSupportedEventModel
 * One selectable trigger event for a guardrail rule.
 */
export interface GuardrailSupportedEventsResponseGuardrailSupportedEventModel {
  /**
   * Desc
   * Human-readable event description
   */
  desc: string;
  /**
   * Scope
   * Event scope (claim / exposure)
   */
  scope: string;
}

/** HierarchyLabelsRequest */
export interface HierarchyLabelsRequest {
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
  /**
   * Group Id
   * @minLength 1
   */
  group_id: string;
  /**
   * Policy
   * @default null
   */
  policy?: Record<string, any> | null;
  /**
   * Value Ids
   * @maxItems 5
   */
  value_ids: string[];
}

/** HierarchyLabelsResponse */
export interface HierarchyLabelsResponse {
  /** Labels */
  labels: Record<string, string>;
}

/**
 * HierarchyTree
 * A whole hierarchy payload: the roots of the tree.
 *
 * Empty is allowed -- a live source legitimately has nothing to offer for some policies, and
 * answering with an empty tree is truthful where refusing would look like an outage.
 */
export interface HierarchyTree {
  /** Nodes */
  nodes?: HierarchyTreeHierarchyNode[];
}

/**
 * HierarchyNode
 * One selectable value at one level of the hierarchy.
 *
 * ``children`` absent and ``children: []`` both mean a leaf; the source decides how it spells it.
 */
export interface HierarchyTreeHierarchyNode {
  /**
   * Children
   * @default null
   */
  children?: HierarchyTreeHierarchyNode[] | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
}

/**
 * HierarchyTreeRequest
 * Which group to serve, and the policy to resolve it against.
 */
export interface HierarchyTreeRequest {
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
  /**
   * Group Id
   * @minLength 1
   */
  group_id: string;
  /**
   * Policy
   * @default null
   */
  policy?: Record<string, any> | null;
}

/** HistoricalClaimContextQuery */
export interface HistoricalClaimContextQuery {
  /** Claim Number */
  claim_number: string;
  /**
   * Cutoff
   * @format date-time
   */
  cutoff: string;
}

/** HolidaySubdivisionsQuery */
export interface HolidaySubdivisionsQuery {
  /**
   * Locale
   * Answer for this locale instead of the organization's stored one, so the settings screen can preview the options for a locale the user has picked but not yet saved.
   * @default null
   */
  locale?: string | null;
}

/** HolidaySubdivisionsResponse */
export interface HolidaySubdivisionsResponse {
  /**
   * Subdivisions
   * Subdivisions available for the territory. Empty when the territory has none, in which case the organization stays on the country-level holiday calendar.
   */
  subdivisions: HolidaySubdivisionsResponseHolidaySubdivision[];
  /**
   * Territory
   * Territory the subdivisions belong to, derived from the organization's locale.
   */
  territory: string;
}

/** HolidaySubdivision */
export interface HolidaySubdivisionsResponseHolidaySubdivision {
  /**
   * Code
   * Canonical subdivision code stored in the organization's configuration.
   */
  code: string;
  /**
   * Name
   * Human-readable subdivision name, for display in the settings select.
   */
  name: string;
}

/** HookEndpointResponse */
export interface HookEndpointResponse {
  /** Callback Url */
  callback_url: string;
  /** Id */
  id: number;
  /** Key */
  key: string;
  /** Name */
  name: string;
  /** Timeout Seconds */
  timeout_seconds: number;
}

/** HookEndpointResponseList */
export type HookEndpointResponseList =
  HookEndpointResponseListHookEndpointResponse[];

/** HookEndpointResponse */
export interface HookEndpointResponseListHookEndpointResponse {
  /** Callback Url */
  callback_url: string;
  /** Id */
  id: number;
  /** Key */
  key: string;
  /** Name */
  name: string;
  /** Timeout Seconds */
  timeout_seconds: number;
}

/** HospitalityDataImportGetSchemaParams */
export interface HospitalityDataImportGetSchemaParams {
  additional_configurations: HospitalityDataImportGetSchemaParamsDataImportConfig;
}

/** DataImportConfig */
export interface HospitalityDataImportGetSchemaParamsDataImportConfig {
  /**
   * Should Generate Claim Numbers
   * @default true
   */
  should_generate_claim_numbers?: boolean;
}

/** HospitalityDataImportLoadParams */
export interface HospitalityDataImportLoadParams {
  additional_configurations: HospitalityDataImportLoadParamsDataImportConfig;
  /** Import Dir Path */
  import_dir_path: string;
  import_dir_path_type: HospitalityDataImportLoadParamsDataImportDirPathType;
  /** Organization External Id */
  organization_external_id: string;
}

/** DataImportConfig */
export interface HospitalityDataImportLoadParamsDataImportConfig {
  /**
   * Should Generate Claim Numbers
   * @default true
   */
  should_generate_claim_numbers?: boolean;
}

/** HospitalityDataImportResponse */
export interface HospitalityDataImportResponse {
  /** Log Messages */
  log_messages: string[];
}

/** IdResponse */
export interface IdResponse {
  /** Id */
  id: number;
}

/** IdsResponse[int, CatEventListExtraData] */
export interface IdsResponseIntCatEventListExtraData {
  /** @default null */
  extra_data?: IdsResponseIntCatEventListExtraDataCatEventListExtraData | null;
  /** Ids */
  ids: number[];
  /** Results Truncated */
  results_truncated: boolean;
}

/** CatEventListExtraData */
export interface IdsResponseIntCatEventListExtraDataCatEventListExtraData {
  /** Has Incidents With Cat */
  has_incidents_with_cat: boolean;
}

/** IdsResponse[int, CommunicationIdsExtraData] */
export interface IdsResponseIntCommunicationIdsExtraData {
  /** @default null */
  extra_data?: IdsResponseIntCommunicationIdsExtraDataCommunicationIdsExtraData | null;
  /** Ids */
  ids: number[];
  /** Results Truncated */
  results_truncated: boolean;
}

/** CommunicationIdsExtraData */
export interface IdsResponseIntCommunicationIdsExtraDataCommunicationIdsExtraData {
  /**
   * Available Channels
   * Channels the scope of the request - a claim or an adjuster - has communications on, computed over the whole scope and independent of the filters in the request, so the channel tabs stay stable when a filter matches nothing.
   */
  available_channels: (
    | "email"
    | "sms"
    | "phone_call"
    | "physical_mail"
    | "video_call"
    | "vendor"
  )[];
}

/** IdsResponse[int, NoneType] */
export interface IdsResponseIntNoneType {
  /**
   * Extra Data
   * @default null
   */
  extra_data?: null;
  /** Ids */
  ids: number[];
  /** Results Truncated */
  results_truncated: boolean;
}

/** IdsResponse[int, SorIssueStatusCounts] */
export interface IdsResponseIntSorIssueStatusCounts {
  /** @default null */
  extra_data?: IdsResponseIntSorIssueStatusCountsSorIssueStatusCounts | null;
  /** Ids */
  ids: number[];
  /** Results Truncated */
  results_truncated: boolean;
}

/**
 * SorIssueStatusCounts
 * How many attempts each status would list under the other filters, so a status filter shows its count
 * before it is chosen. Every status is present, with 0 when none.
 */
export interface IdsResponseIntSorIssueStatusCountsSorIssueStatusCounts {
  /** Status Counts */
  status_counts: Record<string, number>;
  /** Total */
  total: number;
}

/** IdsResponse[str, NoneType] */
export interface IdsResponseStrNoneType {
  /**
   * Extra Data
   * @default null
   */
  extra_data?: null;
  /** Ids */
  ids: string[];
  /** Results Truncated */
  results_truncated: boolean;
}

/**
 * IgnoreActionParams
 * The note a handler writes when they turn a recommendation down.
 *
 * Required, and blank is not a note: a rejection without one tells Clive nothing, while
 * "the broker is sending a corrected one" and "we're settling on the original figure" send
 * it somewhere different.
 */
export interface IgnoreActionParams {
  /**
   * Reason
   * Why the recommendation was turned down.
   * @minLength 1
   */
  reason: string;
}

/**
 * ImpersonateJwtRequest
 * Request schema for impersonation JWT endpoint.
 */
export interface ImpersonateJwtRequest {
  /** Organization Id */
  organization_id: number;
  /** @default null */
  permissions?: ImpersonateJwtRequestImpersonatePermissions | null;
  /** User Id */
  user_id: string;
}

/**
 * ImpersonatePermissions
 * Permissions to grant during impersonation.
 */
export interface ImpersonateJwtRequestImpersonatePermissions {
  /**
   * Creator
   * @default false
   */
  creator?: boolean;
  /**
   * General
   * @default false
   */
  general?: boolean;
  /**
   * Manager
   * @default false
   */
  manager?: boolean;
}

/** ImportDocumentTemplatesForm */
export interface ImportDocumentTemplatesForm {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** InboxSelectionRequest */
export interface InboxSelectionRequest {
  /** Target Lob */
  target_lob: string;
  /**
   * Target Sub Organization Id
   * @default null
   */
  target_sub_organization_id?: number | null;
}

/** IncidentConfigurationDraftModel */
export interface IncidentConfigurationDraftModel {
  /** Base Version */
  base_version: number;
  /** Configuration */
  configuration: Record<string, any>;
  /** Id */
  id: number;
  /** Incident Configuration Id */
  incident_configuration_id: number;
  /** Lob */
  lob: string;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** IncidentConfigurationDraftSummaryModelList */
export type IncidentConfigurationDraftSummaryModelList =
  IncidentConfigurationDraftSummaryModelListIncidentConfigurationDraftSummaryModel[];

/** IncidentConfigurationDraftSummaryModel */
export interface IncidentConfigurationDraftSummaryModelListIncidentConfigurationDraftSummaryModel {
  /** Base Version */
  base_version: number;
  /**
   * Created Datetime
   * @format date-time
   */
  created_datetime: string;
  /** Id */
  id: number;
  /**
   * Incident Configuration Display Name
   * @default null
   */
  incident_configuration_display_name?: string | null;
  /** Incident Configuration Id */
  incident_configuration_id: number;
  /** Last Updated By Username */
  last_updated_by_username: string;
  /**
   * Last Updated Datetime
   * @format date-time
   */
  last_updated_datetime: string;
  /** Lob */
  lob: string;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** IncidentConfigurationModel */
export interface IncidentConfigurationModel {
  /** Configuration */
  configuration: Record<string, any>;
  /** Display Name */
  display_name: string;
  /** @default null */
  global_fields_status?: IncidentConfigurationModelGlobalFieldsStatus | null;
  /** Id */
  id: number;
  /** Lob */
  lob: string;
  /** Organization Id */
  organization_id: number;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /** Version */
  version: number;
}

/**
 * GlobalFieldsStatus
 * Whether one configuration's projected entries match the global field rows.
 *
 * Returned on the incident-configuration GET and the reconcile response, and never computed on
 * a runtime read path. ``in_sync`` false means a trigger was missed; ``reconcile_global_fields``
 * re-projects that row and logs the drift at ERROR.
 */
export interface IncidentConfigurationModelGlobalFieldsStatus {
  /**
   * Extra
   * @default []
   */
  extra?: string[];
  /** In Sync */
  in_sync: boolean;
  /**
   * Missing
   * @default []
   */
  missing?: string[];
  /**
   * Stale
   * @default []
   */
  stale?: string[];
}

/** IncidentConfigurationSummaryList */
export type IncidentConfigurationSummaryList =
  IncidentConfigurationSummaryListIncidentConfigurationSummary[];

/** IncidentConfigurationSummary */
export interface IncidentConfigurationSummaryListIncidentConfigurationSummary {
  /**
   * Clive Policy Config
   * @default null
   */
  clive_policy_config?: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /**
   * Fnol Email Inbox Name
   * @default null
   */
  fnol_email_inbox_name?: string | null;
  /** Id */
  id: number;
  /** Last Updated By Username */
  last_updated_by_username: string;
  /**
   * Last Updated Datetime
   * @format date-time
   */
  last_updated_datetime: string;
  /** Lob */
  lob: string;
  /** Organization Id */
  organization_id: number;
  /**
   * Policy Categories Count
   * @default 0
   */
  policy_categories_count?: number;
  /**
   * Should Send Fnol Email Inbox To Clive
   * @default null
   */
  should_send_fnol_email_inbox_to_clive?: boolean | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /** Version */
  version: number;
}

/** IncidentConfigurationSummaryQueryParams */
export interface IncidentConfigurationSummaryQueryParams {
  /**
   * Include Policy Categories Count
   * @default false
   */
  include_policy_categories_count?: boolean;
  /**
   * Lob
   * @default null
   */
  lob?: string | null;
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[] | null;
}

/** IncidentDetailsResponse */
export interface IncidentDetailsResponse {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** @default null */
  auto_incident_additional?: IncidentDetailsResponseAutoIncidentAdditionalModel | null;
  /**
   * Can Take Photos Of Damage
   * @default null
   */
  can_take_photos_of_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Cat Code
   * The catastrophe `code` of the linked cat event. Accepted as input (alternative to `cat_code_name`) and returned in responses. If both `cat_code` and `cat_code_name` are sent, they must reference the same cat.
   * @default null
   */
  cat_code?: string | null;
  /**
   * Cat Code Name
   * @default null
   */
  cat_code_name?: string | null;
  /** Contacts */
  contacts: IncidentDetailsResponseContactModel[];
  /**
   * Date Of Loss
   * @format date
   */
  date_of_loss: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Did Anyone Take Photos Or Video
   * @default null
   */
  did_anyone_take_photos_or_video?: "yes" | "no" | "na" | "unknown" | null;
  /** Incident Sub Type */
  incident_sub_type: string;
  /** Incident Type */
  incident_type: string;
  /**
   * Is Notification Only
   * @default null
   */
  is_notification_only?: boolean | null;
  /**
   * Is Other Policy Covering
   * @default null
   */
  is_other_policy_covering?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  loss_location?: IncidentDetailsResponseLocationModel | null;
  /**
   * Other Policy Description
   * @default null
   */
  other_policy_description?: string | null;
  /**
   * Photographer Contact Ref Id
   * @default null
   */
  photographer_contact_ref_id?: string | null;
  /**
   * Preferred Contact Ref Id
   * @default null
   */
  preferred_contact_ref_id?: string | null;
  /**
   * Reporter Contact Id
   * Required only if the field is active in the FNOL configuration for the organization.
   * @default null
   */
  reporter_contact_id?: string | null;
  /**
   * Special Internal Note
   * @default null
   */
  special_internal_note?: string | null;
  /**
   * Time Of Loss
   * Local wall-clock time of the loss (HH:MM), no timezone.
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Was Cctv Footage
   * @default null
   */
  was_cctv_footage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were There Any Witnesses
   * @default null
   */
  were_there_any_witnesses?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Witnesses
   * @default null
   */
  witnesses?: IncidentDetailsResponseExternalWitnessModel[] | null;
  /**
   * Witnesses Note
   * @default null
   */
  witnesses_note?: string | null;
}

/** AccidentFollowUpModel */
export interface IncidentDetailsResponseAccidentFollowUpModel {
  /**
   * Direction Ph Vehicle Was Going
   * @default null
   */
  direction_ph_vehicle_was_going?: string | null;
  /**
   * First Party Way Sign Or A Headlight
   * @default null
   */
  first_party_way_sign_or_a_headlight?: string | null;
  /**
   * Journey Purpose
   * @default null
   */
  journey_purpose?: string | null;
  /**
   * Street Condition
   * @default null
   */
  street_condition?: string | null;
  /**
   * Was Ambulance Called
   * @default null
   */
  was_ambulance_called?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Anyone Under The Influence Of Drugs Alcohol
   * @default null
   */
  was_anyone_under_the_influence_of_drugs_alcohol?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Was First Party Driver Using The Phone
   * @default null
   */
  was_first_party_driver_using_the_phone?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Weather Conditions
   * @default null
   */
  weather_conditions?: string | null;
  /**
   * Were First Party Vehicle Lights On
   * @default null
   */
  were_first_party_vehicle_lights_on?: "yes" | "no" | "na" | "unknown" | null;
}

/** AutoIncidentAdditionalModel */
export interface IncidentDetailsResponseAutoIncidentAdditionalModel {
  /** @default null */
  accident_follow_up?: IncidentDetailsResponseAccidentFollowUpModel | null;
  /**
   * Are Convictions Or Claims In The Last 5 Years
   * @default null
   */
  are_convictions_or_claims_in_the_last_5_years?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Convictions Or Claim Description
   * @default null
   */
  convictions_or_claim_description?: string | null;
  /**
   * Does Policyholder Second Occupation Exist
   * @default null
   */
  does_policyholder_second_occupation_exist?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /** @default null */
  fault_assessment?: IncidentDetailsResponseFaultAssessmentModel | null;
  /**
   * Is Policyholder Occupation Right
   * @default null
   */
  is_policyholder_occupation_right?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  police_and_fire_department?: IncidentDetailsResponsePoliceAndFireDepartmentModel | null;
  /**
   * Policyholder Current Occupation
   * @default null
   */
  policyholder_current_occupation?: string | null;
  /**
   * Policyholder Second Occupation
   * @default null
   */
  policyholder_second_occupation?: string | null;
  /**
   * Replacement Car Rental Date
   * @default null
   */
  replacement_car_rental_date?: string | null;
  /** @default null */
  theft_follow_up?: IncidentDetailsResponseTheftFollowUpModel | null;
  /**
   * Was Replacement Car Rented
   * @default null
   */
  was_replacement_car_rented?: boolean | null;
}

/** ContactEmailModel */
export interface IncidentDetailsResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface IncidentDetailsResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: IncidentDetailsResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: IncidentDetailsResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface IncidentDetailsResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ExternalWitnessModel */
export interface IncidentDetailsResponseExternalWitnessModel {
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
}

/** FaultAssessmentModel */
export interface IncidentDetailsResponseFaultAssessmentModel {
  /**
   * Claim Handler Fault Assessment
   * @default null
   */
  claim_handler_fault_assessment?: string | null;
  /**
   * First Party Fault Assessment
   * @default null
   */
  first_party_fault_assessment?: string | null;
  /**
   * Is Fraud Review Needed
   * @default null
   */
  is_fraud_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Indemnity Review Needed
   * @default null
   */
  is_indemnity_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Liability Summary
   * @default null
   */
  liability_summary?: string | null;
  /**
   * Percentage Of Insured Liability
   * @default null
   */
  percentage_of_insured_liability?: string | null;
}

/** LocationModel */
export interface IncidentDetailsResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PoliceAndFireDepartmentModel */
export interface IncidentDetailsResponsePoliceAndFireDepartmentModel {
  /**
   * Did Speak With Officer
   * @default null
   */
  did_speak_with_officer?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Fire Department Description
   * @default null
   */
  fire_department_description?: string | null;
  /**
   * Pending Prosecutions Or Investigations Exists
   * @default null
   */
  pending_prosecutions_or_investigations_exists?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Police Crime Reference Number
   * @default null
   */
  police_crime_reference_number?: string | null;
  /**
   * Police Department Contact Ref Id
   * @default null
   */
  police_department_contact_ref_id?: string | null;
  /**
   * Police Description
   * @default null
   */
  police_description?: string | null;
  /**
   * Police Report
   * @default null
   */
  police_report?: string | null;
  /**
   * Violation Title
   * @default null
   */
  violation_title?: string | null;
  /**
   * Was Ticket Received
   * @default null
   */
  was_ticket_received?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Any Hazardous Good Being Carried
   * @default null
   */
  were_any_hazardous_good_being_carried?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Were Fire Department Involved
   * @default null
   */
  were_fire_department_involved?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Police Involved
   * @default null
   */
  were_police_involved?: "yes" | "no" | "na" | "unknown" | null;
}

/** TheftFollowUpModel */
export interface IncidentDetailsResponseTheftFollowUpModel {
  /**
   * Belongings Stolen
   * @default null
   */
  belongings_stolen?: string | null;
  /**
   * Crime Reference Number
   * @default null
   */
  crime_reference_number?: string | null;
  /**
   * Current Num Of Keys
   * @default null
   */
  current_num_of_keys?: number | null;
  /**
   * Date Noticed Vehicle Missing
   * @default null
   */
  date_noticed_vehicle_missing?: string | null;
  /**
   * Date Vehicle Last Seen
   * @default null
   */
  date_vehicle_last_seen?: string | null;
  /**
   * Discovered The Loss Contact Ref Id
   * @default null
   */
  discovered_the_loss_contact_ref_id?: string | null;
  /**
   * Is Vehicle For Sale
   * @default null
   */
  is_vehicle_for_sale?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  keys_location?: IncidentDetailsResponseLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Num Of Keys Received On Purchase
   * @default null
   */
  num_of_keys_received_on_purchase?: number | null;
  /**
   * Person Liable For The Theft Is Known
   * @default null
   */
  person_liable_for_the_theft_is_known?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Security Devices Description
   * @default null
   */
  security_devices_description?: string | null;
  /**
   * Time Noticed Vehicle Missing
   * @default null
   */
  time_noticed_vehicle_missing?: string | null;
  /**
   * Time Vehicle Last Seen
   * @default null
   */
  time_vehicle_last_seen?: string | null;
  /**
   * Tracking Devices Description
   * @default null
   */
  tracking_devices_description?: string | null;
  /**
   * Vehicle Fitted With Security Devices
   * @default null
   */
  vehicle_fitted_with_security_devices?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Vehicle Fitted With Tracking Devices
   * @default null
   */
  vehicle_fitted_with_tracking_devices?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  vehicle_last_seen_location?: IncidentDetailsResponseLocationModel | null;
  /**
   * Vehicle Windows Closed And Secured
   * @default null
   */
  vehicle_windows_closed_and_secured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Vehicle Found With Keys
   * @default null
   */
  was_vehicle_found_with_keys?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Belongings Stolen From Vehicle
   * @default null
   */
  were_belongings_stolen_from_vehicle?: "yes" | "no" | "na" | "unknown" | null;
}

/**
 * IncomeProtectionDaFullDetailsResponse
 * Response schema for Income Protection DA full details.
 */
export interface IncomeProtectionDaFullDetailsResponse {
  /** Exposure Id */
  exposure_id: number;
  /**
   * Is Medical Document Notification Enabled
   * Whether the medical document notification type is enabled for this organization
   */
  is_medical_document_notification_enabled: boolean;
  /**
   * Is Payment Notification Enabled
   * Whether the payment notification type is enabled for this organization
   */
  is_payment_notification_enabled: boolean;
  /**
   * Income Protection DA setting for given exposure, or None if none exists
   * @default null
   */
  setting?: IncomeProtectionDaFullDetailsResponseIncomeProtectionDaSettingModel | null;
  /** Income Protection DA summary for given exposure */
  summary: IncomeProtectionDaFullDetailsResponseIncomeProtectionDaSummaryModel;
}

/**
 * IncomeProtectionDaSettingModel
 * Response schema for Income Protection DA setting.
 */
export interface IncomeProtectionDaFullDetailsResponseIncomeProtectionDaSettingModel {
  /**
   * Average Weekly Income
   * Average weekly income of the claimant
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  average_weekly_income: string;
  /**
   * Benefit Period Num Of Days
   * Benefit period in days
   * @min 0
   */
  benefit_period_num_of_days: number;
  /** Claim Id */
  claim_id: number;
  /**
   * Claimant Weekly Limit
   * Maximum weekly payment limit for the claimant
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  claimant_weekly_limit: string;
  /**
   * Exposure Id
   * ID of the exposure
   */
  exposure_id: number;
  /** Id */
  id: number;
  /**
   * Minimal medical document notification details (if active)
   * @default null
   */
  medical_document_notification?: IncomeProtectionDaFullDetailsResponseIncomeProtectionNotificationMinimalDataModel | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Payee Contact Full Name
   * Full name of the payee contact
   */
  payee_contact_full_name: string;
  /**
   * Payee Contact Id
   * ID of the contact who will receive payments
   */
  payee_contact_id: number;
  /**
   * Payment Frequency Num Of Days
   * Payment frequency in days (e.g., 7, 14, or custom)
   * @exclusiveMin 0
   */
  payment_frequency_num_of_days: number;
  /**
   * Minimal payment notification details (if active)
   * @default null
   */
  payment_notification?: IncomeProtectionDaFullDetailsResponseIncomeProtectionNotificationMinimalDataModel | null;
  /**
   * Start Date
   * Start date of the income protection
   * @format date
   */
  start_date: string;
  /**
   * Waiting Period Num Of Days
   * Waiting period in days before payments start
   * @exclusiveMin 0
   */
  waiting_period_num_of_days: number;
  /**
   * Weekly Income Percentage
   * Percentage of weekly income to pay (0-100)
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,3}|(?=[\d.]{1,6}0*$)\d{0,3}\.\d{0,2}0*$)
   */
  weekly_income_percentage: string;
  /**
   * Weekly Payment Limit
   * Maximum weekly payment limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  weekly_payment_limit: string;
}

/**
 * IncomeProtectionDaSummaryModel
 * Response schema for Income Protection DA summary.
 */
export interface IncomeProtectionDaFullDetailsResponseIncomeProtectionDaSummaryModel {
  /** Claimant Full Name */
  claimant_full_name: string | null;
  /** Claimant Id */
  claimant_id: number | null;
  /** Days Paid */
  days_paid: number;
  /** Days Remaining */
  days_remaining: number;
  /** Exposure Id */
  exposure_id: number;
  /** Exposure Number */
  exposure_number: string;
  /** Medical Certificate Expiry Date */
  medical_certificate_expiry_date: string | null;
  /**
   * Total Incurred
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  total_incurred: string;
  /**
   * Total Paid
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  total_paid: string;
}

/**
 * IncomeProtectionNotificationMinimalDataModel
 * Schema for payment notification details needed by the frontend ReminderDisplay component.
 */
export interface IncomeProtectionDaFullDetailsResponseIncomeProtectionNotificationMinimalDataModel {
  /** Claim Id */
  claim_id: number;
  /**
   * Due Date
   * @format date
   */
  due_date: string;
  /** Id */
  id: number;
}

/**
 * IncomeProtectionDaSettingResponse
 * Response schema for Income Protection DA setting.
 */
export interface IncomeProtectionDaSettingResponse {
  /** Exposure Id */
  exposure_id: number;
  /**
   * Income Protection DA setting for given exposure, or None if none exists
   * @default null
   */
  setting?: IncomeProtectionDaSettingResponseIncomeProtectionDaSettingModel | null;
}

/**
 * IncomeProtectionDaSettingModel
 * Response schema for Income Protection DA setting.
 */
export interface IncomeProtectionDaSettingResponseIncomeProtectionDaSettingModel {
  /**
   * Average Weekly Income
   * Average weekly income of the claimant
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  average_weekly_income: string;
  /**
   * Benefit Period Num Of Days
   * Benefit period in days
   * @min 0
   */
  benefit_period_num_of_days: number;
  /** Claim Id */
  claim_id: number;
  /**
   * Claimant Weekly Limit
   * Maximum weekly payment limit for the claimant
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  claimant_weekly_limit: string;
  /**
   * Exposure Id
   * ID of the exposure
   */
  exposure_id: number;
  /** Id */
  id: number;
  /**
   * Minimal medical document notification details (if active)
   * @default null
   */
  medical_document_notification?: IncomeProtectionDaSettingResponseIncomeProtectionNotificationMinimalDataModel | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Payee Contact Full Name
   * Full name of the payee contact
   */
  payee_contact_full_name: string;
  /**
   * Payee Contact Id
   * ID of the contact who will receive payments
   */
  payee_contact_id: number;
  /**
   * Payment Frequency Num Of Days
   * Payment frequency in days (e.g., 7, 14, or custom)
   * @exclusiveMin 0
   */
  payment_frequency_num_of_days: number;
  /**
   * Minimal payment notification details (if active)
   * @default null
   */
  payment_notification?: IncomeProtectionDaSettingResponseIncomeProtectionNotificationMinimalDataModel | null;
  /**
   * Start Date
   * Start date of the income protection
   * @format date
   */
  start_date: string;
  /**
   * Waiting Period Num Of Days
   * Waiting period in days before payments start
   * @exclusiveMin 0
   */
  waiting_period_num_of_days: number;
  /**
   * Weekly Income Percentage
   * Percentage of weekly income to pay (0-100)
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,3}|(?=[\d.]{1,6}0*$)\d{0,3}\.\d{0,2}0*$)
   */
  weekly_income_percentage: string;
  /**
   * Weekly Payment Limit
   * Maximum weekly payment limit
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  weekly_payment_limit: string;
}

/**
 * IncomeProtectionNotificationMinimalDataModel
 * Schema for payment notification details needed by the frontend ReminderDisplay component.
 */
export interface IncomeProtectionDaSettingResponseIncomeProtectionNotificationMinimalDataModel {
  /** Claim Id */
  claim_id: number;
  /**
   * Due Date
   * @format date
   */
  due_date: string;
  /** Id */
  id: number;
}

/**
 * IncomeProtectionMedicalRecordsResponse
 * Response schema for list of income protection medical records.
 */
export interface IncomeProtectionMedicalRecordsResponse {
  /** Exposure Id */
  exposure_id: number;
  /**
   * Medical Records
   * List of medical records for the exposure
   */
  medical_records?: IncomeProtectionMedicalRecordsResponseIncomeProtectionMedicalRecordModel[];
}

/**
 * IncomeProtectionMedicalRecordModel
 * Response schema for an income protection medical record.
 */
export interface IncomeProtectionMedicalRecordsResponseIncomeProtectionMedicalRecordModel {
  /**
   * Certificate End
   * @format date
   */
  certificate_end: string;
  /**
   * Certificate Start
   * @format date
   */
  certificate_start: string;
  /** Claim Id */
  claim_id: number;
  /**
   * Creation Date
   * @format date
   */
  creation_date: string;
  /**
   * Diagnoses
   * Diagnoses text
   */
  diagnoses: string;
  /**
   * Document Date
   * Date of the medical record document
   * @default null
   */
  document_date?: string | null;
  /** Document Id */
  document_id: number;
  /**
   * Document Name
   * Name of the medical record document
   */
  document_name: string;
  /** Exposure Id */
  exposure_id: number;
  /** Id */
  id: number;
  /** Income Protection Da Setting Id */
  income_protection_da_setting_id: number;
  /** Is Removed */
  is_removed: boolean;
  /**
   * Medical Practitioner Contact Full Name
   * Full name of the medical practitioner
   * @default null
   */
  medical_practitioner_contact_full_name?: string | null;
  /**
   * Medical Practitioner Contact Id
   * ID of the medical practitioner contact
   * @default null
   */
  medical_practitioner_contact_id?: number | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Rtw Date
   * Return to work date
   * @default null
   */
  rtw_date?: string | null;
}

/**
 * IncomeProtectionPaymentsSummaryResponse
 * Response schema for payment summary.
 * @example {"exposure_id":1,"payments_summary":{"is_benefit_period_reached":false,"last_payment_end_date":"2026-01-31","paid_periods":[{"end_date":"2026-01-31","start_date":"2026-01-22"}],"total_days_paid":10,"total_incurred":"1200.00","total_paid":"1200.00"}}
 */
export interface IncomeProtectionPaymentsSummaryResponse {
  /** Exposure Id */
  exposure_id: number;
  /** Payments summary for the exposure */
  payments_summary: IncomeProtectionPaymentsSummaryResponseIncomeProtectionPaymentsSummary;
}

/**
 * IncomeProtectionPaidPeriod
 * A run of consecutive days covered by at least one active/pending payment.
 */
export interface IncomeProtectionPaymentsSummaryResponseIncomeProtectionPaidPeriod {
  /**
   * End Date
   * Last day of the period (inclusive)
   * @format date
   */
  end_date: string;
  /**
   * Start Date
   * First day of the period
   * @format date
   */
  start_date: string;
}

/**
 * IncomeProtectionPaymentsSummary
 * Summary of active/pending payments for an Income Protection exposure.
 */
export interface IncomeProtectionPaymentsSummaryResponseIncomeProtectionPaymentsSummary {
  /**
   * Is Benefit Period Reached
   * Whether total days paid meets or exceeds the benefit period
   */
  is_benefit_period_reached: boolean;
  /**
   * Last Payment Creation Datetime
   * Creation date of the most recent payment, or None if no payments
   * @default null
   */
  last_payment_creation_datetime?: string | null;
  /**
   * Last Payment End Date
   * End date of the most recent payment, or None if no payments
   * @default null
   */
  last_payment_end_date?: string | null;
  /**
   * Paid Periods
   * Non-overlapping periods covered by active payments, in date order
   */
  paid_periods: IncomeProtectionPaymentsSummaryResponseIncomeProtectionPaidPeriod[];
  /**
   * Total Days Paid
   * Total days covered by active payments
   */
  total_days_paid: number;
  /**
   * Total Incurred
   * Total amount incurred by active payments
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  total_incurred: string;
  /**
   * Total Paid
   * Total amount paid by active payments
   * @pattern ^(?!^[-+.]*$)[+-]?0*(?:\d{0,15}|(?=[\d.]{1,18}0*$)\d{0,15}\.\d{0,2}0*$)
   */
  total_paid: string;
}

/**
 * IncomingPromotionDetail
 * An incoming row plus its flat change list (the target's own authoritative GCS copy), and — for a
 * resolved request that had conflicts — the recorded resolution decision (read-only, a committed fact).
 */
export interface IncomingPromotionDetail {
  /**
   * Apply Error
   * @default null
   */
  apply_error?: string | null;
  /** Approver Display Name */
  approver_display_name: string | null;
  /** Approving User Id */
  approving_user_id: string | null;
  /** Changes */
  changes: Record<string, any>[];
  /** Changes Hash */
  changes_hash: string;
  /** @default null */
  conflict_resolution?: IncomingPromotionDetailPromotionConflictResolution | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Deferred Configuration Types
   * @default []
   */
  deferred_configuration_types?: string[];
  /**
   * Drafted By Display Name
   * @default null
   */
  drafted_by_display_name?: string | null;
  /**
   * Drafted By User Id
   * @default null
   */
  drafted_by_user_id?: string | null;
  /**
   * Is Upload
   * @default false
   */
  is_upload?: boolean;
  /** Kind */
  kind: string;
  /** @default null */
  origin?: IncomingPromotionDetailPromotionOrigin | null;
  /** Pairing Id */
  pairing_id: number;
  /** Reject Reason */
  reject_reason: string | null;
  /**
   * Rejecter Display Name
   * @default null
   */
  rejecter_display_name?: string | null;
  /** Request Name */
  request_name: string | null;
  /** Request Uuid */
  request_uuid: string;
  /** Requester Display Name */
  requester_display_name: string | null;
  /** Requester Email */
  requester_email: string | null;
  /** Resolved At */
  resolved_at: string | null;
  /**
   * Rolls Back Request Uuid
   * @default null
   */
  rolls_back_request_uuid?: string | null;
  /** Source Deployment Id */
  source_deployment_id: string;
  /** Source Org External Id */
  source_org_external_id: string;
  /** Status */
  status: string;
  /** Summary */
  summary: IncomingPromotionDetailPromotionRequestTypeCounts[];
}

/**
 * PromotionConflictResolution
 * The recorded outcome of an approver resolving conflicts: which conflicts they chose to override
 * (overwrite the target) vs skip (leave the target's current value). Persisted only on a committed
 * resolve; surfaced read-only on a resolved request. Who/when are on the request
 * (``approving_user_id`` / ``resolved_at``).
 */
export interface IncomingPromotionDetailPromotionConflictResolution {
  /**
   * Overridden
   * @default []
   */
  overridden?: IncomingPromotionDetailPromotionResolvedConflict[];
  /**
   * Skipped
   * @default []
   */
  skipped?: IncomingPromotionDetailPromotionResolvedConflict[];
}

/**
 * PromotionRequestTypeCounts
 * Per-configuration-type CREATE/UPDATE/DELETE counts for a change list.
 */
export interface IncomingPromotionDetailPromotionRequestTypeCounts {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Create Count
   * @default 0
   */
  create_count?: number;
  /**
   * Delete Count
   * @default 0
   */
  delete_count?: number;
  /**
   * Update Count
   * @default 0
   */
  update_count?: number;
}

/**
 * PromotionResolvedConflict
 * One conflict as recorded in the approver's resolution decision: the per-change conflict snapshot
 * (the previous/expected value and the target value at decision time). The promotion's written value is
 * recoverable from the change list, so it is not duplicated here.
 */
export interface IncomingPromotionDetailPromotionResolvedConflict {
  /**
   * Actual Current
   * @default null
   */
  actual_current?: any;
  /** Change Id */
  change_id: string;
  /**
   * Expected Old
   * @default null
   */
  expected_old?: any;
  /** Field Path */
  field_path: string;
}

/** IncomingPromotionListResult */
export interface IncomingPromotionListResult {
  /** Items */
  items: IncomingPromotionListResultIncomingPromotionItem[];
}

/**
 * IncomingPromotionItem
 * A row in the target-side incoming list — read from ``ConfigurationPromotionRequest``, and for an upload
 * self-promotion also from its co-located source-side ``ConfigurationPromotionOutgoing`` row.
 */
export interface IncomingPromotionListResultIncomingPromotionItem {
  /** Approver Display Name */
  approver_display_name: string | null;
  /** Approving User Id */
  approving_user_id: string | null;
  /** Changes Hash */
  changes_hash: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Deferred Configuration Types
   * @default []
   */
  deferred_configuration_types?: string[];
  /**
   * Drafted By Display Name
   * @default null
   */
  drafted_by_display_name?: string | null;
  /**
   * Drafted By User Id
   * @default null
   */
  drafted_by_user_id?: string | null;
  /**
   * Is Upload
   * @default false
   */
  is_upload?: boolean;
  /** Kind */
  kind: string;
  /** @default null */
  origin?: IncomingPromotionListResultPromotionOrigin | null;
  /** Pairing Id */
  pairing_id: number;
  /** Reject Reason */
  reject_reason: string | null;
  /** Request Name */
  request_name: string | null;
  /** Request Uuid */
  request_uuid: string;
  /** Requester Display Name */
  requester_display_name: string | null;
  /** Requester Email */
  requester_email: string | null;
  /** Resolved At */
  resolved_at: string | null;
  /**
   * Rolls Back Request Uuid
   * @default null
   */
  rolls_back_request_uuid?: string | null;
  /** Source Deployment Id */
  source_deployment_id: string;
  /** Source Org External Id */
  source_org_external_id: string;
  /** Status */
  status: string;
  /** Summary */
  summary: IncomingPromotionListResultPromotionRequestTypeCounts[];
}

/**
 * PromotionRequestTypeCounts
 * Per-configuration-type CREATE/UPDATE/DELETE counts for a change list.
 */
export interface IncomingPromotionListResultPromotionRequestTypeCounts {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Create Count
   * @default 0
   */
  create_count?: number;
  /**
   * Delete Count
   * @default 0
   */
  delete_count?: number;
  /**
   * Update Count
   * @default 0
   */
  update_count?: number;
}

/** Insight */
export interface Insight {
  /** Claim Number */
  claim_number: string;
  /** Documents Used */
  documents_used?: string[];
  /**
   * Error
   * @default null
   */
  error?: string | null;
  /** Insight Uid */
  insight_uid: string;
  /**
   * Response
   * @default null
   */
  response?: string | null;
  /** Status */
  status: string;
}

/**
 * InsightHandle
 * The 202 accepted-for-processing handle.
 */
export interface InsightHandle {
  /** Claim Number */
  claim_number: string;
  /** Insight Uid */
  insight_uid: string;
  /** Status */
  status: string;
}

/**
 * InsightHistoryQueryParams
 * Keyset cursor for one page of an insight key's older versions.
 *
 * ``before`` is required on purpose. It is the version id the caller already holds — the latest
 * insight's id for the first page, then the last id of the previous page — and the strict keyset
 * it produces is what keeps the timeline older-only. Omitting it would silently repeat the version
 * the card is already showing, so a forgotten cursor has to fail loudly instead.
 *
 * An empty or blank ``before`` is rejected too. Either satisfies ``str`` but carries no position,
 * so without the floor a templating bug that renders the cursor as '' or ' ' would reach the AI
 * service as a silently-cursorless request — the same duplicate the required param exists to
 * prevent. Whitespace is stripped before the floor applies, so a padded cursor still resolves.
 *
 * ``limit`` is optional and only forwarded when supplied, so the AI service's own default and
 * maximum stay authoritative. The floor here rejects a page size that is nonsense on its face;
 * the ceiling is deliberately left to the service rather than duplicated into a second, silently
 * diverging source of truth.
 */
export interface InsightHistoryQueryParams {
  /**
   * Before
   * @minLength 1
   */
  before: string;
  /**
   * Limit
   * @default null
   */
  limit?: number | null;
}

/**
 * InsightsUndismissedCountResponse
 * How many of this claim's insights are still undismissed.
 *
 * A count read kept separate from the list route: a caller that needs only the number -- an
 * unopened tab's header, say -- should not have to fetch and enrich every insight to get it.
 */
export interface InsightsUndismissedCountResponse {
  /** Undismissed Count */
  undismissed_count: number;
}

/** InspectionMethodsQuery */
export interface InspectionMethodsQuery {
  /** Claim Number */
  claim_number: string;
}

/**
 * InspectionMethodsResourceSchema
 * InspectionMethodsResourceSchema
 */
export interface InspectionMethodsResourceSchema {
  /**
   * Inspection Methods
   * The claim's legal methods, ordered by inspection_method_id ascending. The order is contractual and imposed by CMS, not incidental to its source query, so a consumer may break a tie between equally good candidates by taking the first entry. Methods that exist only to drive a third-party integration are never present.
   */
  inspection_methods: InspectionMethodsResourceSchemaInspectionMethodEntry[];
}

/**
 * CoverageSchema
 * CoverageSchema
 */
export interface InspectionMethodsResourceSchemaCoverageSchema {
  /** Coverage Display Name */
  coverage_display_name: string;
  /** Coverage Key */
  coverage_key: string;
}

/**
 * InspectionMethodEntry
 * One inspection method the claim may be assigned.
 */
export interface InspectionMethodsResourceSchemaInspectionMethodEntry {
  /**
   * Coverages
   * Allowlist of coverages this method may be assigned against. An empty list means unrestricted (every coverage), not "none allowed". A non-empty list is checked per exposure and every exposure must match, so a multi-exposure inspection where one exposure falls outside the list is rejected outright rather than partially accepted. Match on coverage_key; coverage_display_name equals what an exposure reports as its coverage type only where the organization has configurable coverages enabled, and resolves from a legacy label dictionary otherwise.
   */
  coverages: InspectionMethodsResourceSchemaCoverageSchema[];
  /**
   * Description
   * The organization-authored statement of what this method is for. Null when nobody has written one.
   */
  description: string | null;
  /**
   * Display Name
   * What a human calls the method; renameable, so not a stable handle.
   */
  display_name: string;
  /**
   * Inspection Method Id
   * The method's stable identifier, used to select it when assigning.
   */
  inspection_method_id: number;
  /**
   * Is Claim Level Allowed
   * Whether the method may be assigned at claim level (no exposures). Already the organization switch combined with the method's own setting — the answer, not an input to combine further.
   */
  is_claim_level_allowed: boolean;
  /**
   * Is Multiple Exposures Allowed
   * Whether one assignment of the method may cover more than one exposure. Already the organization switch combined with the method's own setting — the answer, not an input to combine further.
   */
  is_multiple_exposures_allowed: boolean;
  /**
   * Key
   * Immutable handle for the method; unique per organization and LOB.
   */
  key: string;
}

/** IntrospectResponse */
export interface IntrospectResponse {
  /**
   * Active
   * Whether the access token is active
   */
  active: boolean;
}

/** InvoiceConfigCreateParams */
export interface InvoiceConfigCreateParams {
  /** @default {"clive_coverage_classification":"none","entity_granularity":"line_item","predefined_fields":{"amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"amount_currency":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Currency","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"description":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Description","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"document":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Document","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"item_date":{"active":true,"allow_future":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Date","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"date"},"third_party_amount":{"active":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Third Party Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"}}} */
  config?: InvoiceConfigCreateParamsInvoiceConfigSchema;
  /** Display Name */
  display_name: string;
}

/** DatePredefinedField */
export interface InvoiceConfigCreateParamsDatePredefinedField {
  /** Active */
  active: boolean;
  /**
   * Allow Future
   * @default false
   */
  allow_future?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "date";
}

/** InvoiceConfigSchema */
export interface InvoiceConfigCreateParamsInvoiceConfigSchema {
  /** @default "none" */
  clive_coverage_classification?: InvoiceConfigCreateParamsCliveCoverageClassificationLevel;
  /**
   * Entity Granularity
   * @default "line_item"
   */
  entity_granularity?: "line_item" | "invoice";
  /** @default {"amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"amount_currency":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Currency","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"description":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Description","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"document":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Document","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"item_date":{"active":true,"allow_future":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Date","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"date"},"third_party_amount":{"active":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Third Party Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"}} */
  predefined_fields?: InvoiceConfigCreateParamsInvoicePredefinedFields;
}

/** InvoicePredefinedFields */
export interface InvoiceConfigCreateParamsInvoicePredefinedFields {
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  amount?: InvoiceConfigCreateParamsMonetaryPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Currency","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  amount_currency?: InvoiceConfigCreateParamsStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Description","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  description?: InvoiceConfigCreateParamsStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Document","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  document?: InvoiceConfigCreateParamsStringPredefinedField;
  /** @default {"active":true,"allow_future":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Date","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"date"} */
  item_date?: InvoiceConfigCreateParamsDatePredefinedField;
  /** @default {"active":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Third Party Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  third_party_amount?: InvoiceConfigCreateParamsMonetaryPredefinedField;
}

/** MonetaryPredefinedField */
export interface InvoiceConfigCreateParamsMonetaryPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "monetary";
}

/** StringPredefinedField */
export interface InvoiceConfigCreateParamsStringPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "string";
}

/** InvoiceConfigInfo */
export interface InvoiceConfigInfo {
  config: InvoiceConfigInfoInvoiceConfigSchema;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Organization Id */
  organization_id: number;
}

/** DatePredefinedField */
export interface InvoiceConfigInfoDatePredefinedField {
  /** Active */
  active: boolean;
  /**
   * Allow Future
   * @default false
   */
  allow_future?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "date";
}

/** InvoiceConfigSchema */
export interface InvoiceConfigInfoInvoiceConfigSchema {
  /** @default "none" */
  clive_coverage_classification?: InvoiceConfigInfoCliveCoverageClassificationLevel;
  /**
   * Entity Granularity
   * @default "line_item"
   */
  entity_granularity?: "line_item" | "invoice";
  /** @default {"amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"amount_currency":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Currency","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"description":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Description","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"document":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Document","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"item_date":{"active":true,"allow_future":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Date","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"date"},"third_party_amount":{"active":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Third Party Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"}} */
  predefined_fields?: InvoiceConfigInfoInvoicePredefinedFields;
}

/** InvoicePredefinedFields */
export interface InvoiceConfigInfoInvoicePredefinedFields {
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  amount?: InvoiceConfigInfoMonetaryPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Currency","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  amount_currency?: InvoiceConfigInfoStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Description","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  description?: InvoiceConfigInfoStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Document","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  document?: InvoiceConfigInfoStringPredefinedField;
  /** @default {"active":true,"allow_future":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Date","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"date"} */
  item_date?: InvoiceConfigInfoDatePredefinedField;
  /** @default {"active":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Third Party Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  third_party_amount?: InvoiceConfigInfoMonetaryPredefinedField;
}

/** MonetaryPredefinedField */
export interface InvoiceConfigInfoMonetaryPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "monetary";
}

/** StringPredefinedField */
export interface InvoiceConfigInfoStringPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "string";
}

/** InvoiceConfigUpdateParams */
export interface InvoiceConfigUpdateParams {
  /** @default null */
  config?: InvoiceConfigUpdateParamsInvoiceConfigSchema | null;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
}

/** DatePredefinedField */
export interface InvoiceConfigUpdateParamsDatePredefinedField {
  /** Active */
  active: boolean;
  /**
   * Allow Future
   * @default false
   */
  allow_future?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "date";
}

/** InvoiceConfigSchema */
export interface InvoiceConfigUpdateParamsInvoiceConfigSchema {
  /** @default "none" */
  clive_coverage_classification?: InvoiceConfigUpdateParamsCliveCoverageClassificationLevel;
  /**
   * Entity Granularity
   * @default "line_item"
   */
  entity_granularity?: "line_item" | "invoice";
  /** @default {"amount":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"},"amount_currency":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Currency","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"description":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Description","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"document":{"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Document","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"},"item_date":{"active":true,"allow_future":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Date","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"date"},"third_party_amount":{"active":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Third Party Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"}} */
  predefined_fields?: InvoiceConfigUpdateParamsInvoicePredefinedFields;
}

/** InvoicePredefinedFields */
export interface InvoiceConfigUpdateParamsInvoicePredefinedFields {
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  amount?: InvoiceConfigUpdateParamsMonetaryPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Currency","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  amount_currency?: InvoiceConfigUpdateParamsStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Description","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  description?: InvoiceConfigUpdateParamsStringPredefinedField;
  /** @default {"active":true,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Document","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"string"} */
  document?: InvoiceConfigUpdateParamsStringPredefinedField;
  /** @default {"active":true,"allow_future":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Date","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"date"} */
  item_date?: InvoiceConfigUpdateParamsDatePredefinedField;
  /** @default {"active":false,"claim_closing_mandatory":false,"clive_additional_instructions":null,"clive_excluded":false,"db_field":null,"desc":"Third Party Amount","dynamic":true,"geo_specific":null,"incident_sub_type_categories":null,"mandatory":false,"type":"monetary"} */
  third_party_amount?: InvoiceConfigUpdateParamsMonetaryPredefinedField;
}

/** MonetaryPredefinedField */
export interface InvoiceConfigUpdateParamsMonetaryPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "monetary";
}

/** StringPredefinedField */
export interface InvoiceConfigUpdateParamsStringPredefinedField {
  /** Active */
  active: boolean;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /**
   * Dynamic
   * @default null
   */
  dynamic?: boolean | null;
  /**
   * Geo Specific
   * @default null
   */
  geo_specific?: "US" | "GB" | null;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
  /** Mandatory */
  mandatory: boolean;
  /** Type */
  type: "string";
}

/** InvoiceCoverageBreakdownQuery */
export interface InvoiceCoverageBreakdownQuery {
  /**
   * Document Id
   * @default null
   */
  document_id?: number | null;
  /**
   * Invoice Document Source Id
   * @default null
   */
  invoice_document_source_id?: string | null;
}

/** InvoiceCoveragesBreakdown */
export interface InvoiceCoveragesBreakdown {
  /** Coverages */
  coverages: InvoiceCoveragesBreakdownCoverageTotals[];
  /** Invoice Id */
  invoice_id: number;
}

/** CoverageTotals */
export interface InvoiceCoveragesBreakdownCoverageTotals {
  /** Co Insurance */
  co_insurance: number;
  /** Coverage Id */
  coverage_id: number;
  /** Coverage Key */
  coverage_key: string;
  /** Coverage Name */
  coverage_name: string;
  /** Covered Amount */
  covered_amount: number;
  /** Eligible For Reimbursement */
  eligible_for_reimbursement: number;
  /** Not Covered Amount */
  not_covered_amount: number;
  /** Submitted Amount */
  submitted_amount: number;
}

/** InvoiceListResponse */
export interface InvoiceListResponse {
  /** Invoices */
  invoices: InvoiceListResponseInvoiceResponse[];
}

/** InvoiceResponse */
export interface InvoiceListResponseInvoiceResponse {
  /** Claim Id */
  claim_id: number;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Document Id */
  document_id: number;
  /** Excluded Amount */
  excluded_amount: number;
  /** Extra */
  extra: Record<string, any>;
  /** Id */
  id: number;
  /**
   * Invoice Currency
   * @default null
   */
  invoice_currency?: string | null;
  /** Invoice Date */
  invoice_date: string | null;
  /** Invoice Number */
  invoice_number: string;
  invoice_processing_type: InvoiceListResponseInvoiceProcessingType;
  /** Line Items */
  line_items: InvoiceListResponseLineItemResponse[];
  /** Not Covered Amount */
  not_covered_amount: number;
  /** Organization Id */
  organization_id: number;
  /** Submitted Amount */
  submitted_amount: number;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Vendor */
  vendor: string | null;
}

/** LineItemResponse */
export interface InvoiceListResponseLineItemResponse {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: InvoiceListResponseCoverageDecisionOption;
  /** Coverage Id */
  coverage_id: number | null;
  /** Coverage Key */
  coverage_key: string | null;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Depreciation Applied Amount
   * @default null
   */
  depreciation_applied_amount?: number | null;
  /**
   * Depreciation Percentage
   * @default null
   */
  depreciation_percentage?: number | null;
  /** Description */
  description: string;
  /**
   * Entry Type
   * @default "line_item"
   */
  entry_type?: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /** Id */
  id: number;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /**
   * Is Depreciation Overridden
   * @default false
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default false
   */
  is_locked?: boolean;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: InvoiceListResponsePayableType | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/** InvoiceResponse */
export interface InvoiceResponse {
  /** Claim Id */
  claim_id: number;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Document Id */
  document_id: number;
  /** Excluded Amount */
  excluded_amount: number;
  /** Extra */
  extra: Record<string, any>;
  /** Id */
  id: number;
  /**
   * Invoice Currency
   * @default null
   */
  invoice_currency?: string | null;
  /** Invoice Date */
  invoice_date: string | null;
  /** Invoice Number */
  invoice_number: string;
  invoice_processing_type: InvoiceResponseInvoiceProcessingType;
  /** Line Items */
  line_items: InvoiceResponseLineItemResponse[];
  /** Not Covered Amount */
  not_covered_amount: number;
  /** Organization Id */
  organization_id: number;
  /** Submitted Amount */
  submitted_amount: number;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Vendor */
  vendor: string | null;
}

/** LineItemResponse */
export interface InvoiceResponseLineItemResponse {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: InvoiceResponseCoverageDecisionOption;
  /** Coverage Id */
  coverage_id: number | null;
  /** Coverage Key */
  coverage_key: string | null;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Depreciation Applied Amount
   * @default null
   */
  depreciation_applied_amount?: number | null;
  /**
   * Depreciation Percentage
   * @default null
   */
  depreciation_percentage?: number | null;
  /** Description */
  description: string;
  /**
   * Entry Type
   * @default "line_item"
   */
  entry_type?: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /** Id */
  id: number;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /**
   * Is Depreciation Overridden
   * @default false
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default false
   */
  is_locked?: boolean;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: InvoiceResponsePayableType | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/**
 * InvolvedPartiesOptionsQuery
 * Query parameters for involved parties options endpoint.
 */
export interface InvolvedPartiesOptionsQuery {
  /**
   * Coverage
   * @default null
   */
  coverage?: string | null;
  /**
   * Lob
   * @default null
   */
  lob?: string | null;
  /** @default null */
  "sub_organization_ids[]"?: InvolvedPartiesOptionsQueryEnsuredListInt | null;
}

export type InvolvedPartiesOptionsQueryEnsuredListInt = number[];

/** IsMultiClaimResponse */
export interface IsMultiClaimResponse {
  /** Is Multi Claim */
  is_multi_claim: boolean;
}

/** LegacyOrgFeatureResponseList */
export type LegacyOrgFeatureResponseList =
  LegacyOrgFeatureResponseListLegacyOrgFeatureResponse[];

/** LegacyOrgFeatureOrganizationResponse */
export interface LegacyOrgFeatureResponseListLegacyOrgFeatureOrganizationResponse {
  /** Id */
  id: number;
  /** Is Hidden */
  is_hidden: boolean | null;
  /** Name */
  name: string | null;
}

/** LegacyOrgFeatureResponse */
export interface LegacyOrgFeatureResponseListLegacyOrgFeatureResponse {
  /** Where in the product a feature shows; the values are the labels on the Legacy Bespoke Features page. */
  area: LegacyOrgFeatureResponseListLegacyOrgFeatureArea;
  /** Details */
  details: string;
  /** Matches No Organization */
  matches_no_organization: boolean;
  /** Name */
  name: string;
  /** Organizations */
  organizations: LegacyOrgFeatureResponseListLegacyOrgFeatureOrganizationResponse[];
  /** Owners */
  owners: string[];
  /** Summary */
  summary: string;
  /** Title */
  title: string;
}

/** LegacyOrgFeaturesQuery */
export interface LegacyOrgFeaturesQuery {
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
}

/** LegalActionDateOfServicePayload */
export interface LegalActionDateOfServicePayload {
  /** Contact Id */
  contact_id: number;
  /**
   * Date Of Service
   * @format date
   */
  date_of_service: string;
  /**
   * Other Text
   * @default null
   */
  other_text?: string | null;
  /** Service Type */
  service_type: string;
}

/** LegalActionJurisdictionPayload */
export interface LegalActionJurisdictionPayload {
  /**
   * Court
   * @default null
   */
  court?: string | null;
  /**
   * Date Filled In Court
   * @default null
   */
  date_filled_in_court?: string | null;
  /**
   * Jurisdiction State
   * @default null
   */
  jurisdiction_state?: string | null;
  /**
   * Venue
   * @default null
   */
  venue?: string | null;
}

/** LegalActionLawsuitDetailsPayload */
export interface LegalActionLawsuitDetailsPayload {
  /**
   * Complaint Number
   * @default null
   */
  complaint_number?: string | null;
  /**
   * Lawsuit Type
   * @default null
   */
  lawsuit_type?: string | null;
  /**
   * Nature Of Dispute
   * @default null
   */
  nature_of_dispute?: string | null;
  /**
   * Nature Of Dispute Text
   * @default null
   */
  nature_of_dispute_text?: string | null;
}

/** LegalActionLogPayload */
export interface LegalActionLogPayload {
  /**
   * Counsel Update
   * @default null
   */
  counsel_update?: string | null;
  /**
   * Date
   * @format date
   */
  date: string;
  /**
   * Due Date
   * @default null
   */
  due_date?: string | null;
  /**
   * File Name
   * @default null
   */
  file_name?: string | null;
  /**
   * File Type
   * @default null
   */
  file_type?: string | null;
  /** Log Type */
  log_type: string;
  /**
   * Log Type Text
   * @default null
   */
  log_type_text?: string | null;
  /**
   * Next Action
   * @default null
   */
  next_action?: string | null;
  /**
   * Status Of Litigation
   * @default null
   */
  status_of_litigation?: string | null;
  /**
   * Status Of Litigation Text
   * @default null
   */
  status_of_litigation_text?: string | null;
  /**
   * Storage Filename
   * @default null
   */
  storage_filename?: string | null;
}

/** LegalActionLogUpdatePayload */
export interface LegalActionLogUpdatePayload {
  /**
   * Counsel Update
   * @default null
   */
  counsel_update?: string | null;
  /**
   * Date
   * @format date
   */
  date: string;
  /**
   * Due Date
   * @default null
   */
  due_date?: string | null;
  /**
   * File Name
   * @default null
   */
  file_name?: string | null;
  /**
   * File Type
   * @default null
   */
  file_type?: string | null;
  /** Log Type */
  log_type: string;
  /**
   * Log Type Text
   * @default null
   */
  log_type_text?: string | null;
  /**
   * Next Action
   * @default null
   */
  next_action?: string | null;
  /**
   * Should Remove Document
   * @default false
   */
  should_remove_document?: boolean | null;
  /**
   * Status Of Litigation
   * @default null
   */
  status_of_litigation?: string | null;
  /**
   * Status Of Litigation Text
   * @default null
   */
  status_of_litigation_text?: string | null;
  /**
   * Storage Filename
   * @default null
   */
  storage_filename?: string | null;
}

/** LegalActionNegotiationPayload */
export interface LegalActionNegotiationPayload {
  /**
   * Adverse Party Contact Id
   * @default null
   */
  adverse_party_contact_id?: number;
  /**
   * Adverse Party Demand
   * @default null
   */
  adverse_party_demand?: number | null;
  /**
   * Date
   * @format date
   */
  date: string;
  /**
   * Notes
   * @default null
   */
  notes?: string | null;
  /**
   * Offer
   * @default null
   */
  offer?: number | null;
}

/** LegalActionPartyPayload */
export interface LegalActionPartyPayload {
  /**
   * Contact Id
   * @default null
   */
  contact_id?: number | null;
  /**
   * Counsel Contact Id
   * @default null
   */
  counsel_contact_id?: number | null;
  /**
   * Date Of Representation
   * @default null
   */
  date_of_representation?: string | null;
  /**
   * File Number
   * @default null
   */
  file_number?: string | null;
  /**
   * Is Carrier Party
   * @default null
   */
  is_carrier_party?: boolean | null;
  /** Type */
  type: string;
}

/** LegalActionPartyTerminateRepresentationPayload */
export interface LegalActionPartyTerminateRepresentationPayload {
  /**
   * End Date Of Representation
   * @format date
   */
  end_date_of_representation: string;
}

/** LegalActionProConPayload */
export interface LegalActionProConPayload {
  /** Pro Con Type */
  pro_con_type: string;
  /** Rationale */
  rationale: string;
}

/** LegalActionSummaryPayload */
export interface LegalActionSummaryPayload {
  /** Complaint Allegations Summary */
  complaint_allegations_summary: string;
  /** Display Name */
  display_name: string;
  /**
   * Exposures
   * @default null
   */
  exposures?: number[] | null;
  /** Is Claim Level */
  is_claim_level: boolean;
  /** Lawsuit Amount */
  lawsuit_amount: number;
  /** Priority */
  priority: string;
}

/**
 * ListClaimActionsQuery
 * Query params for the list endpoint — schema-validated by spectree.
 */
export interface ListClaimActionsQuery {
  /** Lob */
  lob: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * LoadDocumentRequest
 * Request schema for loading a document into a Clive App claim.
 */
export interface LoadDocumentRequest {
  /**
   * Callback Url
   * @default null
   */
  callback_url?: string | null;
  /**
   * Creation Date
   * Original creation date in the external system
   * @default null
   */
  creation_date?: string | null;
  /**
   * External Id
   * External system's document identifier for tracking and deduplication
   * @default null
   */
  external_id?: string | null;
  /**
   * File Url
   * URL to fetch the document file from (must be accessible)
   */
  file_url: string;
  /**
   * Source Document Description
   * Optional description or summary of the document
   * @default null
   */
  source_document_description?: string | null;
  /**
   * Source Document Name
   * Display name for the document
   * @default null
   */
  source_document_name?: string | null;
}

/**
 * LoadDocumentResponse
 * The document a Load Document call stored.
 */
export interface LoadDocumentResponse {
  /**
   * Api Uid
   * The document's Five Sigma identifier
   */
  api_uid: string;
  /**
   * External Id
   * The document's external_id: the one supplied, or the one Five Sigma generated when none was. The callback for this load carries the same value.
   */
  external_id: string;
}

/**
 * LoadNoteRequest
 * Request schema for loading a note into a Clive App claim.
 */
export interface LoadNoteRequest {
  /**
   * Callback Url
   * @default null
   */
  callback_url?: string | null;
  /**
   * Content
   * Note content/body
   */
  content: string;
  /**
   * Creation Date
   * Original creation date of the note in the source system
   * @default null
   */
  creation_date?: string | null;
  /**
   * External Id
   * External system's note identifier for deduplication
   * @default null
   */
  external_id?: string | null;
  /**
   * Title
   * Note title
   */
  title: string;
}

/**
 * LoadNoteResponse
 * The note a Load Note call stored.
 */
export interface LoadNoteResponse {
  /**
   * Api Uid
   * The note's Five Sigma identifier
   */
  api_uid: string;
  /**
   * External Id
   * The note's external_id: the one supplied, or the one Five Sigma generated when none was. The callback for this load carries the same value.
   */
  external_id: string;
}

/**
 * LobConfiguration
 * Model for LOB configuration.
 */
export interface LobConfiguration {
  /**
   * Root schema for LOB (Line of Business) configuration.
   *
   * This schema represents the complete structure of a LOB configuration,
   * including display settings and incident handling configuration.
   */
  configuration: LobConfigurationLobConfigurationSchema;
  /** Env Type */
  env_type: string;
  /**
   * Has Claims
   * @default null
   */
  has_claims?: boolean | null;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default null
   */
  is_removed?: boolean | null;
  /** Lob */
  lob: string;
  /** Version */
  version: number;
}

/** ConfiguredField */
export interface LobConfigurationConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?: LobConfigurationConfiguredFieldSelectOption[] | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: LobConfigurationConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface LobConfigurationConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/**
 * DisplayConfigurationSection
 * Display configuration section.
 */
export interface LobConfigurationDisplayConfigurationSection {
  /** Covered Objects */
  covered_objects?: LobConfigurationDisplayCoveredObject[];
  /** Desc */
  desc: string;
  /** Icon */
  icon: string;
  /** Involved Parties */
  involved_parties?: LobConfigurationDisplayInvolvedParty[];
}

/**
 * DisplayCoveredObject
 * Covered object in display configuration.
 */
export interface LobConfigurationDisplayCoveredObject {
  /** Desc */
  desc: string;
  /** Icon */
  icon: string;
  /** Id */
  id: string;
}

/**
 * DisplayInvolvedParty
 * Involved party in display configuration.
 */
export interface LobConfigurationDisplayInvolvedParty {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Covered Object Type
   * @default null
   */
  covered_object_type?: string | null;
  /** Desc */
  desc: string;
  /**
   * Icon
   * @default null
   */
  icon?: string | null;
  /** Id */
  id: string;
  /**
   * Is Allowed Bodily Injury
   * @default false
   */
  is_allowed_bodily_injury?: boolean;
  /**
   * Is Allowed Pecuniary Loss
   * @default false
   */
  is_allowed_pecuniary_loss?: boolean;
  /**
   * Is Allowed Property Damage
   * @default false
   */
  is_allowed_property_damage?: boolean;
  /**
   * Is Allowed Related Damaged Property
   * @default false
   */
  is_allowed_related_damaged_property?: boolean;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Multiple First Parties
   * @default false
   */
  is_multiple_first_parties?: boolean;
}

/**
 * IncidentConfigurationSection
 * Incident configuration section.
 */
export interface LobConfigurationIncidentConfigurationSection {
  /** Covered Objects */
  covered_objects: LobConfigurationIncidentCoveredObject[];
  /** Default Incident Configured Fields */
  default_incident_configured_fields?: LobConfigurationConfiguredField[];
  /** Default Incident Types */
  default_incident_types: LobConfigurationIncidentType[];
  /** Incident Configuration Overrides */
  incident_configuration_overrides?: Record<string, any>;
  /** Involved Parties */
  involved_parties: LobConfigurationIncidentInvolvedParty[];
  [key: string]: any;
}

/**
 * IncidentCoveredObject
 * Covered object in incident configuration.
 */
export interface LobConfigurationIncidentCoveredObject {
  /** Configured Fields */
  configured_fields?: LobConfigurationConfiguredField[];
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /** Types of covered objects and involved parties. */
  type: LobConfigurationObjectType;
  [key: string]: any;
}

/**
 * IncidentInvolvedParty
 * Involved party in incident configuration.
 */
export interface LobConfigurationIncidentInvolvedParty {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Configured Fields */
  configured_fields?: LobConfigurationConfiguredField[];
  /**
   * Covered Object Type
   * @default null
   */
  covered_object_type?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Inherit
   * @default null
   */
  inherit?: string | null;
  /**
   * Is Allowed Bodily Injury
   * @default false
   */
  is_allowed_bodily_injury?: boolean;
  /**
   * Is Allowed Pecuniary Loss
   * @default false
   */
  is_allowed_pecuniary_loss?: boolean;
  /**
   * Is Allowed Property Damage
   * @default false
   */
  is_allowed_property_damage?: boolean;
  /**
   * Is Allowed Related Damaged Property
   * @default false
   */
  is_allowed_related_damaged_property?: boolean;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Multiple First Parties
   * @default false
   */
  is_multiple_first_parties?: boolean;
  /** Types of covered objects and involved parties. */
  type: LobConfigurationObjectType;
  [key: string]: any;
}

/**
 * IncidentSubType
 * Sub-type of an incident type.
 */
export interface LobConfigurationIncidentSubType {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
}

/**
 * IncidentType
 * Incident type definition.
 */
export interface LobConfigurationIncidentType {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /** Sub Types */
  sub_types: LobConfigurationIncidentSubType[];
}

/**
 * LobConfigurationSchema
 * Root schema for LOB (Line of Business) configuration.
 *
 * This schema represents the complete structure of a LOB configuration,
 * including display settings and incident handling configuration.
 */
export interface LobConfigurationLobConfigurationSchema {
  /** Display configuration section. */
  display_configuration: LobConfigurationDisplayConfigurationSection;
  /** Incident configuration section. */
  incident_configuration: LobConfigurationIncidentConfigurationSection;
}

/**
 * LobConfigurationCreateRequest
 * Request model for creating a new LOB configuration.
 */
export interface LobConfigurationCreateRequest {
  /**
   * Root schema for LOB (Line of Business) configuration.
   *
   * This schema represents the complete structure of a LOB configuration,
   * including display settings and incident handling configuration.
   */
  configuration: LobConfigurationCreateRequestLobConfigurationSchema;
  /** Env Type */
  env_type: string;
  /** Lob */
  lob: string;
}

/** ConfiguredField */
export interface LobConfigurationCreateRequestConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?: LobConfigurationCreateRequestConfiguredFieldSelectOption[] | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: LobConfigurationCreateRequestConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface LobConfigurationCreateRequestConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/**
 * DisplayConfigurationSection
 * Display configuration section.
 */
export interface LobConfigurationCreateRequestDisplayConfigurationSection {
  /** Covered Objects */
  covered_objects?: LobConfigurationCreateRequestDisplayCoveredObject[];
  /** Desc */
  desc: string;
  /** Icon */
  icon: string;
  /** Involved Parties */
  involved_parties?: LobConfigurationCreateRequestDisplayInvolvedParty[];
}

/**
 * DisplayCoveredObject
 * Covered object in display configuration.
 */
export interface LobConfigurationCreateRequestDisplayCoveredObject {
  /** Desc */
  desc: string;
  /** Icon */
  icon: string;
  /** Id */
  id: string;
}

/**
 * DisplayInvolvedParty
 * Involved party in display configuration.
 */
export interface LobConfigurationCreateRequestDisplayInvolvedParty {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Covered Object Type
   * @default null
   */
  covered_object_type?: string | null;
  /** Desc */
  desc: string;
  /**
   * Icon
   * @default null
   */
  icon?: string | null;
  /** Id */
  id: string;
  /**
   * Is Allowed Bodily Injury
   * @default false
   */
  is_allowed_bodily_injury?: boolean;
  /**
   * Is Allowed Pecuniary Loss
   * @default false
   */
  is_allowed_pecuniary_loss?: boolean;
  /**
   * Is Allowed Property Damage
   * @default false
   */
  is_allowed_property_damage?: boolean;
  /**
   * Is Allowed Related Damaged Property
   * @default false
   */
  is_allowed_related_damaged_property?: boolean;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Multiple First Parties
   * @default false
   */
  is_multiple_first_parties?: boolean;
}

/**
 * IncidentConfigurationSection
 * Incident configuration section.
 */
export interface LobConfigurationCreateRequestIncidentConfigurationSection {
  /** Covered Objects */
  covered_objects: LobConfigurationCreateRequestIncidentCoveredObject[];
  /** Default Incident Configured Fields */
  default_incident_configured_fields?: LobConfigurationCreateRequestConfiguredField[];
  /** Default Incident Types */
  default_incident_types: LobConfigurationCreateRequestIncidentType[];
  /** Incident Configuration Overrides */
  incident_configuration_overrides?: Record<string, any>;
  /** Involved Parties */
  involved_parties: LobConfigurationCreateRequestIncidentInvolvedParty[];
  [key: string]: any;
}

/**
 * IncidentCoveredObject
 * Covered object in incident configuration.
 */
export interface LobConfigurationCreateRequestIncidentCoveredObject {
  /** Configured Fields */
  configured_fields?: LobConfigurationCreateRequestConfiguredField[];
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /** Types of covered objects and involved parties. */
  type: LobConfigurationCreateRequestObjectType;
  [key: string]: any;
}

/**
 * IncidentInvolvedParty
 * Involved party in incident configuration.
 */
export interface LobConfigurationCreateRequestIncidentInvolvedParty {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Configured Fields */
  configured_fields?: LobConfigurationCreateRequestConfiguredField[];
  /**
   * Covered Object Type
   * @default null
   */
  covered_object_type?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Inherit
   * @default null
   */
  inherit?: string | null;
  /**
   * Is Allowed Bodily Injury
   * @default false
   */
  is_allowed_bodily_injury?: boolean;
  /**
   * Is Allowed Pecuniary Loss
   * @default false
   */
  is_allowed_pecuniary_loss?: boolean;
  /**
   * Is Allowed Property Damage
   * @default false
   */
  is_allowed_property_damage?: boolean;
  /**
   * Is Allowed Related Damaged Property
   * @default false
   */
  is_allowed_related_damaged_property?: boolean;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Multiple First Parties
   * @default false
   */
  is_multiple_first_parties?: boolean;
  /** Types of covered objects and involved parties. */
  type: LobConfigurationCreateRequestObjectType;
  [key: string]: any;
}

/**
 * IncidentSubType
 * Sub-type of an incident type.
 */
export interface LobConfigurationCreateRequestIncidentSubType {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
}

/**
 * IncidentType
 * Incident type definition.
 */
export interface LobConfigurationCreateRequestIncidentType {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /** Sub Types */
  sub_types: LobConfigurationCreateRequestIncidentSubType[];
}

/**
 * LobConfigurationSchema
 * Root schema for LOB (Line of Business) configuration.
 *
 * This schema represents the complete structure of a LOB configuration,
 * including display settings and incident handling configuration.
 */
export interface LobConfigurationCreateRequestLobConfigurationSchema {
  /** Display configuration section. */
  display_configuration: LobConfigurationCreateRequestDisplayConfigurationSection;
  /** Incident configuration section. */
  incident_configuration: LobConfigurationCreateRequestIncidentConfigurationSection;
}

/** LobConfigurationList */
export type LobConfigurationList = LobConfigurationListLobConfiguration[];

/** ConfiguredField */
export interface LobConfigurationListConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?: LobConfigurationListConfiguredFieldSelectOption[] | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: LobConfigurationListConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface LobConfigurationListConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/**
 * DisplayConfigurationSection
 * Display configuration section.
 */
export interface LobConfigurationListDisplayConfigurationSection {
  /** Covered Objects */
  covered_objects?: LobConfigurationListDisplayCoveredObject[];
  /** Desc */
  desc: string;
  /** Icon */
  icon: string;
  /** Involved Parties */
  involved_parties?: LobConfigurationListDisplayInvolvedParty[];
}

/**
 * DisplayCoveredObject
 * Covered object in display configuration.
 */
export interface LobConfigurationListDisplayCoveredObject {
  /** Desc */
  desc: string;
  /** Icon */
  icon: string;
  /** Id */
  id: string;
}

/**
 * DisplayInvolvedParty
 * Involved party in display configuration.
 */
export interface LobConfigurationListDisplayInvolvedParty {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Covered Object Type
   * @default null
   */
  covered_object_type?: string | null;
  /** Desc */
  desc: string;
  /**
   * Icon
   * @default null
   */
  icon?: string | null;
  /** Id */
  id: string;
  /**
   * Is Allowed Bodily Injury
   * @default false
   */
  is_allowed_bodily_injury?: boolean;
  /**
   * Is Allowed Pecuniary Loss
   * @default false
   */
  is_allowed_pecuniary_loss?: boolean;
  /**
   * Is Allowed Property Damage
   * @default false
   */
  is_allowed_property_damage?: boolean;
  /**
   * Is Allowed Related Damaged Property
   * @default false
   */
  is_allowed_related_damaged_property?: boolean;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Multiple First Parties
   * @default false
   */
  is_multiple_first_parties?: boolean;
}

/**
 * IncidentConfigurationSection
 * Incident configuration section.
 */
export interface LobConfigurationListIncidentConfigurationSection {
  /** Covered Objects */
  covered_objects: LobConfigurationListIncidentCoveredObject[];
  /** Default Incident Configured Fields */
  default_incident_configured_fields?: LobConfigurationListConfiguredField[];
  /** Default Incident Types */
  default_incident_types: LobConfigurationListIncidentType[];
  /** Incident Configuration Overrides */
  incident_configuration_overrides?: Record<string, any>;
  /** Involved Parties */
  involved_parties: LobConfigurationListIncidentInvolvedParty[];
  [key: string]: any;
}

/**
 * IncidentCoveredObject
 * Covered object in incident configuration.
 */
export interface LobConfigurationListIncidentCoveredObject {
  /** Configured Fields */
  configured_fields?: LobConfigurationListConfiguredField[];
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /** Types of covered objects and involved parties. */
  type: LobConfigurationListObjectType;
  [key: string]: any;
}

/**
 * IncidentInvolvedParty
 * Involved party in incident configuration.
 */
export interface LobConfigurationListIncidentInvolvedParty {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Configured Fields */
  configured_fields?: LobConfigurationListConfiguredField[];
  /**
   * Covered Object Type
   * @default null
   */
  covered_object_type?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Inherit
   * @default null
   */
  inherit?: string | null;
  /**
   * Is Allowed Bodily Injury
   * @default false
   */
  is_allowed_bodily_injury?: boolean;
  /**
   * Is Allowed Pecuniary Loss
   * @default false
   */
  is_allowed_pecuniary_loss?: boolean;
  /**
   * Is Allowed Property Damage
   * @default false
   */
  is_allowed_property_damage?: boolean;
  /**
   * Is Allowed Related Damaged Property
   * @default false
   */
  is_allowed_related_damaged_property?: boolean;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Multiple First Parties
   * @default false
   */
  is_multiple_first_parties?: boolean;
  /** Types of covered objects and involved parties. */
  type: LobConfigurationListObjectType;
  [key: string]: any;
}

/**
 * IncidentSubType
 * Sub-type of an incident type.
 */
export interface LobConfigurationListIncidentSubType {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
}

/**
 * IncidentType
 * Incident type definition.
 */
export interface LobConfigurationListIncidentType {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /** Sub Types */
  sub_types: LobConfigurationListIncidentSubType[];
}

/**
 * LobConfiguration
 * Model for LOB configuration.
 */
export interface LobConfigurationListLobConfiguration {
  /**
   * Root schema for LOB (Line of Business) configuration.
   *
   * This schema represents the complete structure of a LOB configuration,
   * including display settings and incident handling configuration.
   */
  configuration: LobConfigurationListLobConfigurationSchema;
  /** Env Type */
  env_type: string;
  /**
   * Has Claims
   * @default null
   */
  has_claims?: boolean | null;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default null
   */
  is_removed?: boolean | null;
  /** Lob */
  lob: string;
  /** Version */
  version: number;
}

/**
 * LobConfigurationSchema
 * Root schema for LOB (Line of Business) configuration.
 *
 * This schema represents the complete structure of a LOB configuration,
 * including display settings and incident handling configuration.
 */
export interface LobConfigurationListLobConfigurationSchema {
  /** Display configuration section. */
  display_configuration: LobConfigurationListDisplayConfigurationSection;
  /** Incident configuration section. */
  incident_configuration: LobConfigurationListIncidentConfigurationSection;
}

/**
 * LobConfigurationListQuery
 * Query parameters for listing LOB configurations.
 */
export interface LobConfigurationListQuery {
  /**
   * With Claim Exist Check
   * @default false
   */
  with_claim_exist_check?: boolean | null;
}

/**
 * LobConfigurationUpdateRequest
 * Request model for updating an existing LOB configuration.
 */
export interface LobConfigurationUpdateRequest {
  /**
   * Root schema for LOB (Line of Business) configuration.
   *
   * This schema represents the complete structure of a LOB configuration,
   * including display settings and incident handling configuration.
   */
  configuration: LobConfigurationUpdateRequestLobConfigurationSchema;
}

/** ConfiguredField */
export interface LobConfigurationUpdateRequestConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?: LobConfigurationUpdateRequestConfiguredFieldSelectOption[] | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: LobConfigurationUpdateRequestConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface LobConfigurationUpdateRequestConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/**
 * DisplayConfigurationSection
 * Display configuration section.
 */
export interface LobConfigurationUpdateRequestDisplayConfigurationSection {
  /** Covered Objects */
  covered_objects?: LobConfigurationUpdateRequestDisplayCoveredObject[];
  /** Desc */
  desc: string;
  /** Icon */
  icon: string;
  /** Involved Parties */
  involved_parties?: LobConfigurationUpdateRequestDisplayInvolvedParty[];
}

/**
 * DisplayCoveredObject
 * Covered object in display configuration.
 */
export interface LobConfigurationUpdateRequestDisplayCoveredObject {
  /** Desc */
  desc: string;
  /** Icon */
  icon: string;
  /** Id */
  id: string;
}

/**
 * DisplayInvolvedParty
 * Involved party in display configuration.
 */
export interface LobConfigurationUpdateRequestDisplayInvolvedParty {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Covered Object Type
   * @default null
   */
  covered_object_type?: string | null;
  /** Desc */
  desc: string;
  /**
   * Icon
   * @default null
   */
  icon?: string | null;
  /** Id */
  id: string;
  /**
   * Is Allowed Bodily Injury
   * @default false
   */
  is_allowed_bodily_injury?: boolean;
  /**
   * Is Allowed Pecuniary Loss
   * @default false
   */
  is_allowed_pecuniary_loss?: boolean;
  /**
   * Is Allowed Property Damage
   * @default false
   */
  is_allowed_property_damage?: boolean;
  /**
   * Is Allowed Related Damaged Property
   * @default false
   */
  is_allowed_related_damaged_property?: boolean;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Multiple First Parties
   * @default false
   */
  is_multiple_first_parties?: boolean;
}

/**
 * IncidentConfigurationSection
 * Incident configuration section.
 */
export interface LobConfigurationUpdateRequestIncidentConfigurationSection {
  /** Covered Objects */
  covered_objects: LobConfigurationUpdateRequestIncidentCoveredObject[];
  /** Default Incident Configured Fields */
  default_incident_configured_fields?: LobConfigurationUpdateRequestConfiguredField[];
  /** Default Incident Types */
  default_incident_types: LobConfigurationUpdateRequestIncidentType[];
  /** Incident Configuration Overrides */
  incident_configuration_overrides?: Record<string, any>;
  /** Involved Parties */
  involved_parties: LobConfigurationUpdateRequestIncidentInvolvedParty[];
  [key: string]: any;
}

/**
 * IncidentCoveredObject
 * Covered object in incident configuration.
 */
export interface LobConfigurationUpdateRequestIncidentCoveredObject {
  /** Configured Fields */
  configured_fields?: LobConfigurationUpdateRequestConfiguredField[];
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /** Types of covered objects and involved parties. */
  type: LobConfigurationUpdateRequestObjectType;
  [key: string]: any;
}

/**
 * IncidentInvolvedParty
 * Involved party in incident configuration.
 */
export interface LobConfigurationUpdateRequestIncidentInvolvedParty {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Configured Fields */
  configured_fields?: LobConfigurationUpdateRequestConfiguredField[];
  /**
   * Covered Object Type
   * @default null
   */
  covered_object_type?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Inherit
   * @default null
   */
  inherit?: string | null;
  /**
   * Is Allowed Bodily Injury
   * @default false
   */
  is_allowed_bodily_injury?: boolean;
  /**
   * Is Allowed Pecuniary Loss
   * @default false
   */
  is_allowed_pecuniary_loss?: boolean;
  /**
   * Is Allowed Property Damage
   * @default false
   */
  is_allowed_property_damage?: boolean;
  /**
   * Is Allowed Related Damaged Property
   * @default false
   */
  is_allowed_related_damaged_property?: boolean;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Multiple First Parties
   * @default false
   */
  is_multiple_first_parties?: boolean;
  /** Types of covered objects and involved parties. */
  type: LobConfigurationUpdateRequestObjectType;
  [key: string]: any;
}

/**
 * IncidentSubType
 * Sub-type of an incident type.
 */
export interface LobConfigurationUpdateRequestIncidentSubType {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
}

/**
 * IncidentType
 * Incident type definition.
 */
export interface LobConfigurationUpdateRequestIncidentType {
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /** Sub Types */
  sub_types: LobConfigurationUpdateRequestIncidentSubType[];
}

/**
 * LobConfigurationSchema
 * Root schema for LOB (Line of Business) configuration.
 *
 * This schema represents the complete structure of a LOB configuration,
 * including display settings and incident handling configuration.
 */
export interface LobConfigurationUpdateRequestLobConfigurationSchema {
  /** Display configuration section. */
  display_configuration: LobConfigurationUpdateRequestDisplayConfigurationSection;
  /** Incident configuration section. */
  incident_configuration: LobConfigurationUpdateRequestIncidentConfigurationSection;
}

/**
 * ManualHandleTaskRequest
 * Request model for manually handling async tasks.
 */
export interface ManualHandleTaskRequest {
  /** Task Ids */
  task_ids: string[];
}

/**
 * ManualHandleTaskResponse
 * Response model for manually handling async tasks.
 */
export interface ManualHandleTaskResponse {
  /** Failed */
  failed: ManualHandleTaskResponseFailedTask[];
  /** Processed */
  processed: string[];
  /** Skipped */
  skipped: ManualHandleTaskResponseSkippedTask[];
}

/**
 * FailedTask
 * A task that failed during manual handling.
 */
export interface ManualHandleTaskResponseFailedTask {
  /** Error */
  error: string;
  /** Task Id */
  task_id: string;
}

/**
 * SkippedTask
 * A task that was skipped because it was already in a final state.
 */
export interface ManualHandleTaskResponseSkippedTask {
  /** Status */
  status: string;
  /** Task Id */
  task_id: string;
}

/**
 * ManualIncomeProtectionNotificationRequest
 * Request schema for manually setting/creating an income protection notification (medical document or payment).
 */
export interface ManualIncomeProtectionNotificationRequest {
  /**
   * Due Date
   * Due date for the notification
   * @format date
   */
  due_date: string;
}

/** MetabaseAdminOrganizationResponseList */
export type MetabaseAdminOrganizationResponseList =
  MetabaseAdminOrganizationResponseListMetabaseAdminOrganizationResponse[];

/**
 * MetabaseAdminOrganizationResponse
 * Response schema for listing metabase-enabled organizations.
 */
export interface MetabaseAdminOrganizationResponseListMetabaseAdminOrganizationResponse {
  /** External Id */
  external_id: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/**
 * MetabaseCardMetadata
 * Schema for Metabase card result metadata with column details.
 */
export interface MetabaseCardMetadata {
  /**
   * Columns
   * Column definitions from result_metadata
   */
  columns?: MetabaseCardMetadataMetabaseColumn[];
  /**
   * Parameters
   * Filter parameters/variables defined on the question
   */
  parameters?: MetabaseCardMetadataMetabaseParameter[];
  /**
   * Question Id
   * Metabase question/card ID
   */
  question_id: number;
  /**
   * Question Name
   * Question name
   */
  question_name: string;
}

/**
 * MetabaseColumn
 * Schema for a single column in a Metabase question's result metadata.
 */
export interface MetabaseCardMetadataMetabaseColumn {
  /**
   * Base Type
   * Metabase type, e.g., 'type/Text', 'type/Integer'
   */
  base_type: string;
  /**
   * Display Name
   * Human-readable column name
   */
  display_name: string;
  /**
   * Name
   * Column name/identifier
   */
  name: string;
}

/**
 * MetabaseParameter
 * Schema for a Metabase question parameter (filter variable).
 */
export interface MetabaseCardMetadataMetabaseParameter {
  /**
   * Default
   * Default value for the parameter
   * @default null
   */
  default?: null;
  /**
   * Id
   * Parameter UUID
   */
  id: string;
  /**
   * Ismultiselect
   * Whether multiple values can be selected
   * @default false
   */
  isMultiSelect?: boolean;
  /**
   * Name
   * Human-readable parameter name
   */
  name: string;
  /**
   * Required
   * Whether the parameter must have a value
   * @default false
   */
  required?: boolean;
  /**
   * Slug
   * URL-friendly identifier matching the template-tag name
   */
  slug: string;
  /**
   * Target
   * Parameter-to-template-tag mapping
   */
  target?: any[];
  /**
   * Type
   * Parameter type, e.g., 'date/single', 'string/=', 'boolean/='
   */
  type: string;
  /**
   * Values Query Type
   * Type of values query to use for the parameter
   * @default null
   */
  values_query_type?: string | null;
}

/**
 * MetabaseConfigurationResponse
 * Response schema for Metabase configuration endpoints (GET, POST, PATCH).
 */
export interface MetabaseConfigurationResponse {
  /**
   * Initialized At
   * @default null
   */
  initialized_at?: string | null;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Initialized */
  is_initialized: boolean;
  /** @default null */
  metabase_resources?: MetabaseConfigurationResponseMetabaseResourcesSchema | null;
}

/** CollectionIdsSchema */
export interface MetabaseConfigurationResponseCollectionIdsSchema {
  /** Adjuster */
  adjuster: number;
  /** Drafts */
  drafts: number;
  /** General */
  general: number;
  /** Management */
  management: number;
  /** Reporting */
  reporting: number;
  /** Root */
  root: number;
  /** Self Service */
  self_service: number;
}

/** GroupIdsSchema */
export interface MetabaseConfigurationResponseGroupIdsSchema {
  /** Creators */
  creators: number;
  /** General */
  general: number;
  /** Managers */
  managers: number;
  /** Viewers */
  viewers: number;
}

/** MetabaseResourcesSchema */
export interface MetabaseConfigurationResponseMetabaseResourcesSchema {
  collection_ids: MetabaseConfigurationResponseCollectionIdsSchema;
  /** Group Id */
  group_id: number;
  /** @default null */
  group_ids?: MetabaseConfigurationResponseGroupIdsSchema | null;
}

/**
 * MetabaseEmbeddingJwtResponse
 * Response schema for Metabase embedding JWT endpoint.
 */
export interface MetabaseEmbeddingJwtResponse {
  /** Jwt */
  jwt: string;
  /** Metabase Site Url */
  metabase_site_url: string;
}

/**
 * MetabaseParameterValuesResponse
 * Response schema for Metabase parameter values (used for list-type filter dropdowns).
 */
export interface MetabaseParameterValuesResponse {
  /**
   * Has More Values
   * Whether there are more values beyond this page
   * @default false
   */
  has_more_values?: boolean;
  /**
   * Values
   * Available values, each as a single-element list
   */
  values?: any[][];
}

/**
 * MetabaseQuestionsListResponse
 * Response schema for listing Metabase questions.
 */
export interface MetabaseQuestionsListResponse {
  /**
   * Questions
   * List of questions
   */
  questions?: MetabaseQuestionsListResponseMetabaseQuestion[];
}

/**
 * MetabaseQuestion
 * Schema for a lightweight Metabase question (card) representation.
 */
export interface MetabaseQuestionsListResponseMetabaseQuestion {
  /**
   * Description
   * Question description
   * @default null
   */
  description?: string | null;
  /**
   * Id
   * Metabase question/card ID
   */
  id: number;
  /**
   * Name
   * Question name
   */
  name: string;
  /**
   * Updated At
   * Last update timestamp
   * @format date-time
   */
  updated_at: string;
}

/**
 * MigrationResult
 * Outcome of `POST /sysconfig/api/v1/configured_fields_unpacker/migrate`.
 */
export interface MigrationResult {
  /**
   * Failed
   * Organization ids that failed, mapped to a short error description.
   */
  failed?: Record<string, string>;
  /**
   * Organizations Total
   * Number of Metabase-initialised orgs considered.
   */
  organizations_total: number;
  /**
   * Succeeded
   * Organization ids that were migrated successfully.
   */
  succeeded: number[];
}

/**
 * MockPolicyServerStatusModel
 * Response model for mock policy server status.
 */
export interface MockPolicyServerStatusModel {
  /** Enabled */
  enabled: boolean;
}

/**
 * MockPolicyServerToggleResult
 * Response model for enable/disable operations.
 */
export interface MockPolicyServerToggleResult {
  /**
   * Disabled At
   * @default null
   */
  disabled_at?: string | null;
  /** Enabled */
  enabled: boolean;
  /**
   * Enabled At
   * @default null
   */
  enabled_at?: string | null;
}

/** MockPoolSearchRequest */
export interface MockPoolSearchRequest {
  /**
   * Noise Per Case
   * @min 0
   */
  noise_per_case: number;
  tool: MockPoolSearchRequestMockPoolTool;
  /**
   * True Cases
   * @minItems 1
   */
  true_cases: MockPoolSearchRequestTrueCaseInput[];
}

/** TrueCaseInput */
export interface MockPoolSearchRequestTrueCaseInput {
  /**
   * Claim Id Display
   * @default null
   */
  claim_id_display?: string | null;
  /** Org External Id */
  org_external_id: string;
  /**
   * Policy Number
   * @default null
   */
  policy_number?: string | null;
  /** Sub Account Id */
  sub_account_id: string;
}

/** MockPoolSearchResponse */
export interface MockPoolSearchResponse {
  /** Fulfillment */
  fulfillment: MockPoolSearchResponseFulfillmentEntry[];
  /** Pool */
  pool: MockPoolSearchResponsePoolEntry[];
}

/** FulfillmentEntry */
export interface MockPoolSearchResponseFulfillmentEntry {
  /** Group */
  group: string;
  /** Noise Added */
  noise_added: number;
  /** True Count */
  true_count: number;
}

/** PoolEntry */
export interface MockPoolSearchResponsePoolEntry {
  /** Is Noise */
  is_noise: boolean;
  /** Org External Id */
  org_external_id: string;
  /** Payload */
  payload: any;
  /** Sub Account Id */
  sub_account_id: string;
}

/** MoiAssigneeMethodParams */
export interface MoiAssigneeMethodParams {
  /** Exposure Ids */
  exposure_ids: number[];
  /** Method Specific */
  method_specific: Record<string, any>;
  /** Moi Method Key */
  moi_method_key: string;
}

/** MoiAssigneeMethodResponse */
export interface MoiAssigneeMethodResponse {
  /** Assignee Method Params */
  assignee_method_params:
    | MoiAssigneeMethodResponseMoiAssigneeMethodStandardParams
    | MoiAssigneeMethodResponseMoiAssigneeMethodVendorSearchParams;
  assignee_method_type: MoiAssigneeMethodResponseAssigneeMethodTypeEnum;
  /** @default null */
  override_params?: MoiAssigneeMethodResponseOverrideAssigneeMethodParams | null;
}

/** AddressValidationDetails */
export interface MoiAssigneeMethodResponseAddressValidationDetails {
  /**
   * Override Reason
   * @default null
   */
  override_reason?: string | null;
  /**
   * Override Timestamp
   * @default null
   */
  override_timestamp?: string | null;
  /**
   * Override User Name
   * @default null
   */
  override_user_name?: string | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Ref Type
   * @default null
   */
  ref_type?: string | null;
  /**
   * Type
   * @default "address"
   */
  type?: "address";
}

/** BusinessValidationDetails */
export interface MoiAssigneeMethodResponseBusinessValidationDetails {
  /**
   * Bn
   * @default null
   */
  bn?: string | null;
  /**
   * Entity Type
   * @default null
   */
  entity_type?: string | null;
  /**
   * Gst Status
   * @default null
   */
  gst_status?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Type
   * @default "business"
   */
  type?: "business";
}

/** ContactEmailInfo */
export interface MoiAssigneeMethodResponseContactEmailInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email */
  email: string;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
}

/** ContactExtraInfo */
export interface MoiAssigneeMethodResponseContactExtraInfo {
  /**
   * Driving License Issue Date
   * @default null
   */
  driving_license_issue_date?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Is Unrecognized Number Contact
   * @default null
   */
  is_unrecognized_number_contact?: boolean | null;
  /**
   * Profession
   * @default null
   */
  profession?: string | null;
  /**
   * User Id
   * @default null
   */
  user_id?: string | null;
}

/**
 * ContactInfo
 * Full contact DTO — matches the flask-restx contact_full_model exactly.
 */
export interface MoiAssigneeMethodResponseContactInfo {
  /**
   * Account Details
   * @default null
   */
  account_details?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Bar Number
   * @default null
   */
  attorney_bar_number?: string | null;
  /**
   * Attorney Bar State
   * @default null
   */
  attorney_bar_state?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Change Ulid
   * @default null
   */
  au_tfn_change_ulid?: string | null;
  /**
   * Au Tfn Contact Document Id
   * @default null
   */
  au_tfn_contact_document_id?: number | null;
  /**
   * Au Tfn Exemption
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Bank Proof Contact Document Id
   * @default null
   */
  bank_proof_contact_document_id?: number | null;
  /**
   * Business Legal Name
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Coi Contact Document Id
   * @default null
   */
  coi_contact_document_id?: number | null;
  /**
   * Coi Expiration
   * @default null
   */
  coi_expiration?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /** @default null */
  contact_extra?: MoiAssigneeMethodResponseContactExtraInfo | null;
  /**
   * Contract Of Service Contact Document Id
   * @default null
   */
  contract_of_service_contact_document_id?: number | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivated By User Id
   * @default null
   */
  deactivated_by_user_id?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: MoiAssigneeMethodResponseContactEmailInfo[];
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * Finance Change Ulid
   * @default null
   */
  finance_change_ulid?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Address
   * @default null
   */
  full_address?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** Id */
  id: number;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /** Is Company */
  is_company: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean;
  /**
   * Is Deceased
   * @default null
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Moi Service Provider
   * @default null
   */
  is_moi_service_provider?: boolean | null;
  /**
   * Is Policy Contact
   * @default null
   */
  is_policy_contact?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * Medical Provider Discount Fixed Amount
   * @default null
   */
  medical_provider_discount_fixed_amount?: number | null;
  /**
   * Medical Provider Discount Percentage
   * @default null
   */
  medical_provider_discount_percentage?: number | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Moi Expertises
   * @default []
   */
  moi_expertises?: string[];
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Organization External Id
   * @default null
   */
  organization_external_id?: string | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Phones
   * @default []
   */
  phones?: MoiAssigneeMethodResponseContactPhoneInfo[];
  /**
   * Reference Contact Full Name
   * @default null
   */
  reference_contact_full_name?: string | null;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * Sex
   * @default null
   */
  sex?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Street Address1
   * @default null
   */
  street_address1?: string | null;
  /**
   * Street Address2
   * @default null
   */
  street_address2?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Granted At
   * @default null
   */
  trusted_payee_granted_at?: string | null;
  /**
   * Trusted Payee Granted By User Name
   * @default null
   */
  trusted_payee_granted_by_user_name?: string | null;
  /**
   * Trusted Payee Per Payment Limit
   * @default null
   */
  trusted_payee_per_payment_limit?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Trusted Payee Valid To
   * @default null
   */
  trusted_payee_valid_to?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Validations
   * @default []
   */
  validations?: MoiAssigneeMethodResponseContactValidationInfo[];
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * W9 Contact Document Id
   * @default null
   */
  w9_contact_document_id?: number | null;
  /**
   * W9 Date
   * @default null
   */
  w9_date?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneInfo */
export interface MoiAssigneeMethodResponseContactPhoneInfo {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /** Phone */
  phone: string;
  /**
   * Phone Type
   * @default null
   */
  phone_type?: string | null;
  /**
   * Standardized Phone
   * @default null
   */
  standardized_phone?: string | null;
}

/** ContactValidationInfo */
export interface MoiAssigneeMethodResponseContactValidationInfo {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Id */
  id: number;
  /** Provider */
  provider: string;
  /** Status */
  status: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Validation Details
   * @default null
   */
  validation_details?:
    | (
        | ({
            type: "address";
          } & MoiAssigneeMethodResponseAddressValidationDetails)
        | ({
            type: "business";
          } & MoiAssigneeMethodResponseBusinessValidationDetails)
      )
    | null;
  /** Validation Type */
  validation_type: string;
}

/** MoiAssigneeMethodSearchParams */
export interface MoiAssigneeMethodResponseMoiAssigneeMethodSearchParams {
  /** Name */
  name: string;
  /** Radius */
  radius: number;
  /** Vendor Type */
  vendor_type: string;
}

/** MoiAssigneeMethodStandardParams */
export interface MoiAssigneeMethodResponseMoiAssigneeMethodStandardParams {
  /** Alert Content */
  alert_content: string;
  /** @default null */
  automatic_rules_assignee?: MoiAssigneeMethodResponseMoiAutomaticRulesAssignee | null;
  default_select: MoiAssigneeMethodResponseAssigneeSelectOptionEnum;
  /** Disable Select */
  disable_select: boolean;
}

/** MoiAssigneeMethodVendorSearchParams */
export interface MoiAssigneeMethodResponseMoiAssigneeMethodVendorSearchParams {
  search_default_values: MoiAssigneeMethodResponseMoiAssigneeMethodSearchParams;
  /** Search Title */
  search_title: string;
}

/**
 * MoiAutomaticRulesAssignee
 * The vendor the organization's MOI vendor-assignment rules name for the method, or why they name none.
 */
export interface MoiAssigneeMethodResponseMoiAutomaticRulesAssignee {
  contact: MoiAssigneeMethodResponseContactInfo | null;
  /** Unavailable Reason */
  unavailable_reason: string | null;
}

/** OverrideAssigneeMethodParams */
export interface MoiAssigneeMethodResponseOverrideAssigneeMethodParams {
  /** Assignee Method Params */
  assignee_method_params:
    | MoiAssigneeMethodResponseMoiAssigneeMethodStandardParams
    | MoiAssigneeMethodResponseMoiAssigneeMethodVendorSearchParams;
  assignee_method_type: MoiAssigneeMethodResponseAssigneeMethodTypeEnum;
  /** Override Button Title */
  override_button_title: string;
}

/** MoiConfigurationPatchJson */
export interface MoiConfigurationPatchJson {
  /**
   * Claim Level Moi Enabled
   * @default null
   */
  claim_level_moi_enabled?: boolean | null;
  /**
   * Multiple Exposures Moi Enabled
   * @default null
   */
  multiple_exposures_moi_enabled?: boolean | null;
}

/**
 * MoiEmailTemplateResponse
 * A single MOI email template item served by the dedicated MOI email endpoints.
 */
export interface MoiEmailTemplateResponse {
  /** Body Template */
  body_template: string;
  /**
   * Connected Automatic Rule Actions Display Names
   * @default null
   */
  connected_automatic_rule_actions_display_names?: string[] | null;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverage Keys
   * @default null
   */
  coverage_keys?: string[] | null;
  /**
   * Datetime Created
   * @default null
   */
  datetime_created?: string | null;
  /**
   * Datetime Enabled
   * @default null
   */
  datetime_enabled?: string | null;
  /**
   * Document Template Id
   * @default null
   */
  document_template_id?: number | null;
  /**
   * Dynamic Token Fields
   * @default null
   */
  dynamic_token_fields?: string[] | null;
  /**
   * External Template Id
   * @default null
   */
  external_template_id?: string | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All States
   * @default null
   */
  is_all_states?: boolean | null;
  /**
   * Is All Suborgs
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /** Is Claim Level */
  is_claim_level: boolean;
  /**
   * Is Default
   * @default false
   */
  is_default?: boolean | null;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Last Update Datetime
   * @default null
   */
  last_update_datetime?: string | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Moi Methods
   * @default []
   */
  moi_methods?: MoiEmailTemplateResponseMoiMethodResponse[];
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Ulid
   * @default null
   */
  sync_ulid?: string | null;
  /** Template Name */
  template_name: string;
  /** Template Type */
  template_type: string;
  /**
   * Title Template
   * @default null
   */
  title_template?: string | null;
}

/**
 * MoiMethodResponse
 * A MOI method the template is mapped to, identified by its org-stable key with a display name
 * resolved for the UI. ``document_template_id`` is intentionally absent — MOI methods never carry an
 * attached document template.
 */
export interface MoiEmailTemplateResponseMoiMethodResponse {
  /** Display Name */
  display_name: string;
  /** Key */
  key: string;
}

/**
 * MoiEmailTemplatesMetadataRequest
 * The MOI email list's query: the shared template filters plus the MOI-method filter.
 *
 * ``moi_method_keys`` is OR semantics — a template mapped to ANY of the selected method keys
 * matches. Kept off the shared base so the non-MOI template routes don't grow an MOI-only concept.
 *
 * ``sort_by`` is off this request for the same reason: the MOI list orders by its own
 * enablement/mapping group rank and never reads a caller-supplied column, so advertising the
 * parameter here would document a no-op.
 */
export interface MoiEmailTemplatesMetadataRequest {
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Coverage Keys
   * @default []
   */
  coverage_keys?: string[] | null;
  /**
   * Include Moi Email
   * @default false
   */
  include_moi_email?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * True restricts the list to templates that target every line of business. Omitted or false applies no such restriction.
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Suborgs
   * True restricts the list to templates that target every sub-organization. Omitted or false applies no such restriction.
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /**
   * Is Claim Level
   * @default null
   */
  is_claim_level?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Limit
   * @default null
   */
  limit?: number | null;
  /**
   * Lobs
   * @default []
   */
  lobs?: string[] | null;
  /**
   * Match Full Scope
   * True requires a template to target every listed sub-organization and every listed line of business (or All on that dimension). Omitted or false lists a template that targets any of them.
   * @default null
   */
  match_full_scope?: boolean | null;
  /**
   * Moi Method Keys
   * @default []
   */
  moi_method_keys?: string[] | null;
  /**
   * Order By
   * @default null
   */
  order_by?: "asc" | "desc" | null;
  /**
   * Page
   * @default null
   */
  page?: number | null;
  /**
   * States
   * @default []
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[] | null;
  /**
   * Template Name
   * @default null
   */
  template_name?: string | null;
  /**
   * Template Type
   * @default null
   */
  template_type?: string | null;
}

/** MoiEmailTemplatesResponse */
export interface MoiEmailTemplatesResponse {
  /** Count */
  count: number;
  /** Templates */
  templates: MoiEmailTemplatesResponseMoiEmailTemplateResponse[];
}

/**
 * MoiEmailTemplateResponse
 * A single MOI email template item served by the dedicated MOI email endpoints.
 */
export interface MoiEmailTemplatesResponseMoiEmailTemplateResponse {
  /** Body Template */
  body_template: string;
  /**
   * Connected Automatic Rule Actions Display Names
   * @default null
   */
  connected_automatic_rule_actions_display_names?: string[] | null;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverage Keys
   * @default null
   */
  coverage_keys?: string[] | null;
  /**
   * Datetime Created
   * @default null
   */
  datetime_created?: string | null;
  /**
   * Datetime Enabled
   * @default null
   */
  datetime_enabled?: string | null;
  /**
   * Document Template Id
   * @default null
   */
  document_template_id?: number | null;
  /**
   * Dynamic Token Fields
   * @default null
   */
  dynamic_token_fields?: string[] | null;
  /**
   * External Template Id
   * @default null
   */
  external_template_id?: string | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All States
   * @default null
   */
  is_all_states?: boolean | null;
  /**
   * Is All Suborgs
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /** Is Claim Level */
  is_claim_level: boolean;
  /**
   * Is Default
   * @default false
   */
  is_default?: boolean | null;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Last Update Datetime
   * @default null
   */
  last_update_datetime?: string | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Moi Methods
   * @default []
   */
  moi_methods?: MoiEmailTemplatesResponseMoiMethodResponse[];
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Ulid
   * @default null
   */
  sync_ulid?: string | null;
  /** Template Name */
  template_name: string;
  /** Template Type */
  template_type: string;
  /**
   * Title Template
   * @default null
   */
  title_template?: string | null;
}

/**
 * MoiMethodResponse
 * A MOI method the template is mapped to, identified by its org-stable key with a display name
 * resolved for the UI. ``document_template_id`` is intentionally absent — MOI methods never carry an
 * attached document template.
 */
export interface MoiEmailTemplatesResponseMoiMethodResponse {
  /** Display Name */
  display_name: string;
  /** Key */
  key: string;
}

/** MoiMethodCreateJson */
export interface MoiMethodCreateJson {
  /**
   * Coverage Keys
   * @default []
   */
  coverage_keys?: string[];
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Display Name */
  display_name: string;
  /**
   * Is Attached Documents Allowed
   * @default null
   */
  is_attached_documents_allowed?: boolean | null;
  /**
   * Is Claim Level Allowed
   * @default null
   */
  is_claim_level_allowed?: boolean | null;
  /**
   * Is Multiple Exposures Allowed
   * @default null
   */
  is_multiple_exposures_allowed?: boolean | null;
  /** Is Org Level */
  is_org_level: boolean;
  /** Key */
  key: string;
  /** Lob */
  lob: string;
  /** Method Type Key */
  method_type_key: string;
  /** Moi Expertises */
  moi_expertises: string[];
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** MoiMethodInfoList */
export type MoiMethodInfoList = MoiMethodInfoListMoiMethodInfo[];

/** MoiMethodInfo */
export interface MoiMethodInfoListMoiMethodInfo {
  /** Coverages */
  coverages: string[];
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Active */
  is_active: boolean;
  /** Is Attached Documents Allowed */
  is_attached_documents_allowed: boolean;
  /** Is Claim Level Allowed */
  is_claim_level_allowed: boolean;
  /** Is Multiple Exposures Allowed */
  is_multiple_exposures_allowed: boolean;
  /** Is Org Level */
  is_org_level: boolean;
  /** Key */
  key: string;
  /** Lob */
  lob: string;
  /** Method Type Key */
  method_type_key: string;
  /** Moi Expertises */
  moi_expertises: string[];
  /** Organization Id */
  organization_id: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
}

/** MoiMethodUpdateJson */
export interface MoiMethodUpdateJson {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Display Name */
  display_name: string;
  /**
   * Is Active
   * @default null
   */
  is_active?: boolean | null;
  /** Is Org Level */
  is_org_level: boolean;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/**
 * MoiMethodsResponse
 * The org's selectable MOI methods (one entry per org-stable key, deduped + sorted) — used to
 * populate the method picker when configuring a MOI email template.
 */
export interface MoiMethodsResponse {
  /**
   * Methods
   * @default []
   */
  methods?: MoiMethodsResponseMoiMethodResponse[];
}

/**
 * MoiMethodResponse
 * A MOI method the template is mapped to, identified by its org-stable key with a display name
 * resolved for the UI. ``document_template_id`` is intentionally absent — MOI methods never carry an
 * attached document template.
 */
export interface MoiMethodsResponseMoiMethodResponse {
  /** Display Name */
  display_name: string;
  /** Key */
  key: string;
}

/** MoiStatusUpdate */
export interface MoiStatusUpdate {
  /**
   * Additional Info
   * @default null
   */
  additional_info?: MoiStatusUpdateMoiVendorStatusData[] | null;
  /** Assignment Token */
  assignment_token: string;
  /**
   * Completion Datetime
   * @default null
   */
  completion_datetime?: string | null;
  /**
   * Reject Reason
   * @default null
   */
  reject_reason?: string | null;
  /**
   * Update Datetime
   * @default null
   */
  update_datetime?: string | null;
  /** Updated Status */
  updated_status: string;
}

/** MoiVendorStatusData */
export interface MoiStatusUpdateMoiVendorStatusData {
  /** Display Name */
  display_name: string;
  /** Is Datetime */
  is_datetime: boolean;
  /** Key */
  key: string;
  /** Value */
  value: string;
}

/**
 * MoiVendorAssignmentRuleCreateParams
 * Parameters to create a rule.
 */
export interface MoiVendorAssignmentRuleCreateParams {
  /** Assignee */
  assignee:
    | ({
        strategy: "contact_role";
      } & MoiVendorAssignmentRuleCreateParamsContactRoleAssignee)
    | ({
        strategy: "static";
      } & MoiVendorAssignmentRuleCreateParamsStaticContactAssignee);
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean;
  /** The MOI methods a rule covers: every method, or a list of method keys. */
  moi_methods: MoiVendorAssignmentRuleCreateParamsMoiMethodScope;
  /** Name */
  name: string;
  /** Sub-organization and LOB scope. */
  scope?: MoiVendorAssignmentRuleCreateParamsMoiVendorAssignmentRuleScope;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
}

/**
 * ContactRoleAssignee
 * A matching inspection goes to the one active MOI service provider of this role whose
 * expertises fit the method, found when the inspection is created.
 */
export interface MoiVendorAssignmentRuleCreateParamsContactRoleAssignee {
  /** Contact Role */
  contact_role: string;
  /** Strategy */
  strategy: "contact_role";
}

/**
 * MoiMethodScope
 * The MOI methods a rule covers: every method, or a list of method keys.
 */
export interface MoiVendorAssignmentRuleCreateParamsMoiMethodScope {
  /**
   * Is All
   * @default false
   */
  is_all?: boolean;
  /** Values */
  values?: string[];
}

/**
 * MoiVendorAssignmentRuleScope
 * Sub-organization and LOB scope.
 */
export interface MoiVendorAssignmentRuleCreateParamsMoiVendorAssignmentRuleScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * StaticContactAssignee
 * A matching inspection goes to this contact.
 */
export interface MoiVendorAssignmentRuleCreateParamsStaticContactAssignee {
  /** Contact Id */
  contact_id: number;
  /** Strategy */
  strategy: "static";
}

/**
 * MoiVendorAssignmentRuleInfo
 * One MOI vendor-assignment rule.
 */
export interface MoiVendorAssignmentRuleInfo {
  /** Assignee */
  assignee:
    | ({
        strategy: "contact_role";
      } & MoiVendorAssignmentRuleInfoContactRoleAssignee)
    | ({
        strategy: "static";
      } & MoiVendorAssignmentRuleInfoStaticContactAssignee);
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /** The MOI methods a rule covers: every method, or a list of method keys. */
  moi_methods: MoiVendorAssignmentRuleInfoMoiMethodScope;
  /** Name */
  name: string;
  /** Priority */
  priority: number;
  /** Sub-organization and LOB scope. */
  scope: MoiVendorAssignmentRuleInfoMoiVendorAssignmentRuleScope;
}

/**
 * ContactRoleAssignee
 * A matching inspection goes to the one active MOI service provider of this role whose
 * expertises fit the method, found when the inspection is created.
 */
export interface MoiVendorAssignmentRuleInfoContactRoleAssignee {
  /** Contact Role */
  contact_role: string;
  /** Strategy */
  strategy: "contact_role";
}

/**
 * MoiMethodScope
 * The MOI methods a rule covers: every method, or a list of method keys.
 */
export interface MoiVendorAssignmentRuleInfoMoiMethodScope {
  /**
   * Is All
   * @default false
   */
  is_all?: boolean;
  /** Values */
  values?: string[];
}

/**
 * MoiVendorAssignmentRuleScope
 * Sub-organization and LOB scope.
 */
export interface MoiVendorAssignmentRuleInfoMoiVendorAssignmentRuleScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * StaticContactAssignee
 * A matching inspection goes to this contact.
 */
export interface MoiVendorAssignmentRuleInfoStaticContactAssignee {
  /** Contact Id */
  contact_id: number;
  /** Strategy */
  strategy: "static";
}

/** MoiVendorAssignmentRuleInfoList */
export type MoiVendorAssignmentRuleInfoList =
  MoiVendorAssignmentRuleInfoListMoiVendorAssignmentRuleInfo[];

/**
 * ContactRoleAssignee
 * A matching inspection goes to the one active MOI service provider of this role whose
 * expertises fit the method, found when the inspection is created.
 */
export interface MoiVendorAssignmentRuleInfoListContactRoleAssignee {
  /** Contact Role */
  contact_role: string;
  /** Strategy */
  strategy: "contact_role";
}

/**
 * MoiMethodScope
 * The MOI methods a rule covers: every method, or a list of method keys.
 */
export interface MoiVendorAssignmentRuleInfoListMoiMethodScope {
  /**
   * Is All
   * @default false
   */
  is_all?: boolean;
  /** Values */
  values?: string[];
}

/**
 * MoiVendorAssignmentRuleInfo
 * One MOI vendor-assignment rule.
 */
export interface MoiVendorAssignmentRuleInfoListMoiVendorAssignmentRuleInfo {
  /** Assignee */
  assignee:
    | ({
        strategy: "contact_role";
      } & MoiVendorAssignmentRuleInfoListContactRoleAssignee)
    | ({
        strategy: "static";
      } & MoiVendorAssignmentRuleInfoListStaticContactAssignee);
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /** The MOI methods a rule covers: every method, or a list of method keys. */
  moi_methods: MoiVendorAssignmentRuleInfoListMoiMethodScope;
  /** Name */
  name: string;
  /** Priority */
  priority: number;
  /** Sub-organization and LOB scope. */
  scope: MoiVendorAssignmentRuleInfoListMoiVendorAssignmentRuleScope;
}

/**
 * MoiVendorAssignmentRuleScope
 * Sub-organization and LOB scope.
 */
export interface MoiVendorAssignmentRuleInfoListMoiVendorAssignmentRuleScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * StaticContactAssignee
 * A matching inspection goes to this contact.
 */
export interface MoiVendorAssignmentRuleInfoListStaticContactAssignee {
  /** Contact Id */
  contact_id: number;
  /** Strategy */
  strategy: "static";
}

/**
 * MoiVendorAssignmentRuleUpdateParams
 * Parameters to update a rule. An omitted field is left untouched; ``conditions: null``
 * clears the conditions.
 */
export interface MoiVendorAssignmentRuleUpdateParams {
  /**
   * Assignee
   * @default null
   */
  assignee?:
    | (
        | ({
            strategy: "contact_role";
          } & MoiVendorAssignmentRuleUpdateParamsContactRoleAssignee)
        | ({
            strategy: "static";
          } & MoiVendorAssignmentRuleUpdateParamsStaticContactAssignee)
      )
    | null;
  /**
   * Conditions
   * @default null
   */
  conditions?: Record<string, any> | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /** @default null */
  moi_methods?: MoiVendorAssignmentRuleUpdateParamsMoiMethodScope | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /** @default null */
  scope?: MoiVendorAssignmentRuleUpdateParamsMoiVendorAssignmentRuleScope | null;
}

/**
 * ContactRoleAssignee
 * A matching inspection goes to the one active MOI service provider of this role whose
 * expertises fit the method, found when the inspection is created.
 */
export interface MoiVendorAssignmentRuleUpdateParamsContactRoleAssignee {
  /** Contact Role */
  contact_role: string;
  /** Strategy */
  strategy: "contact_role";
}

/**
 * MoiMethodScope
 * The MOI methods a rule covers: every method, or a list of method keys.
 */
export interface MoiVendorAssignmentRuleUpdateParamsMoiMethodScope {
  /**
   * Is All
   * @default false
   */
  is_all?: boolean;
  /** Values */
  values?: string[];
}

/**
 * MoiVendorAssignmentRuleScope
 * Sub-organization and LOB scope.
 */
export interface MoiVendorAssignmentRuleUpdateParamsMoiVendorAssignmentRuleScope {
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
}

/**
 * StaticContactAssignee
 * A matching inspection goes to this contact.
 */
export interface MoiVendorAssignmentRuleUpdateParamsStaticContactAssignee {
  /** Contact Id */
  contact_id: number;
  /** Strategy */
  strategy: "static";
}

/** MultipleCountriesToggleParams */
export interface MultipleCountriesToggleParams {
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * N8nConfigurationModel
 * Response model for n8n configuration.
 */
export interface N8NConfigurationModel {
  /** Created Datetime */
  created_datetime: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Last Updated By Username */
  last_updated_by_username: string;
  /** Last Updated Datetime */
  last_updated_datetime: string;
  /** Organization Id */
  organization_id: number;
  /** Timeout Seconds */
  timeout_seconds: number;
}

/** NewPaymentJsonParams */
export interface NewPaymentJsonParams {
  /**
   * Amount
   * @min 0
   */
  amount: number;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Base Amount Currency
   * @default null
   */
  base_amount_currency?: string | null;
  /** Contacts */
  contacts: (
    | ({
        creation_mode: "";
      } & NewPaymentJsonParamsContactInNewParam)
    | ({
        creation_mode: "existing";
      } & NewPaymentJsonParamsContactInExistingParam)
    | ({
        creation_mode: "new";
      } & NewPaymentJsonParamsContactInNewParam)
  )[];
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  /**
   * Currency
   * @default null
   */
  currency?: string | null;
  /**
   * Expense Other Type
   * @default null
   */
  expense_other_type?: string | null;
  /**
   * Expenses Sub Reserves
   * @default null
   */
  expenses_sub_reserves?: Record<string, number> | null;
  /**
   * External Payment Id
   * @default null
   */
  external_payment_id?: string | null;
  /**
   * Indemnity Sub Reserves
   * @default null
   */
  indemnity_sub_reserves?: Record<string, number> | null;
  /**
   * Invoice Number
   * @default null
   */
  invoice_number?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Record Only
   * @default null
   */
  is_record_only?: boolean | null;
  /**
   * Is Reissued Payment
   * @default null
   */
  is_reissued_payment?: boolean | null;
  /**
   * Is Vat Included
   * @default null
   */
  is_vat_included?: boolean | null;
  /** @default null */
  method_specific_fields?: NewPaymentJsonParamsPaymentMethodSpecificFields | null;
  /** Payees */
  payees: NewPaymentJsonParamsPayeeModel[];
  /**
   * Payment Desc
   * @default null
   */
  payment_desc?: string | null;
  /** Payment Method */
  payment_method: string;
  /**
   * Payment Reason
   * @default null
   */
  payment_reason?: string | null;
  /**
   * Payment Type
   * @default null
   */
  payment_type?: string | null;
  /**
   * Reportable 1099 Indemnity Amount
   * @default null
   */
  reportable_1099_indemnity_amount?: number | null;
  /**
   * Service End Date
   * @default null
   */
  service_end_date?: string | null;
  /**
   * Service Start Date
   * @default null
   */
  service_start_date?: string | null;
  /**
   * Vat Amount
   * @default null
   */
  vat_amount?: number | null;
}

/** ContactEmailModel */
export interface NewPaymentJsonParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface NewPaymentJsonParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface NewPaymentJsonParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: NewPaymentJsonParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: NewPaymentJsonParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface NewPaymentJsonParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** LocationModel */
export interface NewPaymentJsonParamsLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PayeeModel */
export interface NewPaymentJsonParamsPayeeModel {
  /** Contact Ref Id */
  contact_ref_id: string;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /** Is Primary */
  is_primary: boolean;
  /**
   * Payee Type
   * @default null
   */
  payee_type?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
}

/** PaymentMethodSpecificFields */
export interface NewPaymentJsonParamsPaymentMethodSpecificFields {
  /**
   * Account Details
   * The primary payee contact's account details captured when the payment request is created (later edits to the contact do not affect it). Null when the contact had no account details at request creation, and for payments created before the snapshot was introduced. Returned for custom payment methods only. Response-only: ignored on payment creation/update input - set it via the contacts API.
   * @default null
   */
  account_details?: string | null;
  /**
   * Account Number
   * @default null
   */
  account_number?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Check Date
   * @default null
   */
  check_date?: string | null;
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * Custom Display Name
   * @default null
   */
  custom_display_name?: string | null;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** @default null */
  mail_to_address?: NewPaymentJsonParamsLocationModel | null;
  /**
   * Mail To Contact Ref Id
   * @default null
   */
  mail_to_contact_ref_id?: string | null;
  /**
   * Mail To Name
   * @default null
   */
  mail_to_name?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * One Inc Check Issuance Type
   * @default null
   */
  one_inc_check_issuance_type?: string | null;
  /**
   * One Inc Claimspay Method
   * @default null
   */
  one_inc_claimspay_method?: string | null;
  /**
   * One Inc Claimspay Type
   * @default null
   */
  one_inc_claimspay_type?: string | null;
  /**
   * One Inc Home Loan Account Number
   * @default null
   */
  one_inc_home_loan_account_number?: string | null;
  /**
   * One Inc Is Approval Required
   * @default null
   */
  one_inc_is_approval_required?: boolean | null;
  /**
   * One Inc Lienholder Loan Account Number
   * @default null
   */
  one_inc_lienholder_loan_account_number?: string | null;
  /**
   * Pay To Line
   * @default null
   */
  pay_to_line?: string | null;
  /**
   * Payment Reference
   * @default null
   */
  payment_reference?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Sort Code
   * @default null
   */
  sort_code?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Us Bank Account Number
   * @default null
   */
  us_bank_account_number?: string | null;
  /**
   * Us Bank Name
   * @default null
   */
  us_bank_name?: string | null;
  /**
   * Us Routing Number
   * @default null
   */
  us_routing_number?: string | null;
}

/** NotesConfigurationInfo */
export interface NotesConfigurationInfo {
  /**
   * Default Notes Per Page
   * @default null
   */
  default_notes_per_page?: number | null;
  /**
   * Is Default Notes Per Page Enabled
   * @default null
   */
  is_default_notes_per_page_enabled?: boolean | null;
  /**
   * Is Edit Note Enabled
   * @default false
   */
  is_edit_note_enabled?: boolean | null;
  /**
   * Is Notes Expanded By Default
   * @default false
   */
  is_notes_expanded_by_default?: boolean | null;
  /**
   * Is Rich Text Notes Enabled
   * @default false
   */
  is_rich_text_notes_enabled?: boolean | null;
  /**
   * Note Edit Time In Seconds
   * @default null
   */
  note_edit_time_in_seconds?: number | null;
}

/** NotesConfigurationPatchParams */
export interface NotesConfigurationPatchParams {
  /**
   * Default Notes Per Page
   * @default null
   */
  default_notes_per_page?: number | null;
  /**
   * Is Default Notes Per Page Enabled
   * @default null
   */
  is_default_notes_per_page_enabled?: boolean | null;
  /**
   * Is Edit Note Enabled
   * @default null
   */
  is_edit_note_enabled?: boolean | null;
  /**
   * Is Notes Expanded By Default
   * @default null
   */
  is_notes_expanded_by_default?: boolean | null;
  /**
   * Is Rich Text Notes Enabled
   * @default null
   */
  is_rich_text_notes_enabled?: boolean | null;
  /**
   * Note Edit Time In Seconds
   * @default null
   */
  note_edit_time_in_seconds?: number | null;
}

/** NotificationConfigSummaryList */
export type NotificationConfigSummaryList =
  NotificationConfigSummaryListNotificationConfigSummary[];

/**
 * NotificationConfigSummary
 * For disabled_map and config listing.
 */
export interface NotificationConfigSummaryListNotificationConfigSummary {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /** Id */
  id: number;
  /**
   * Is All States
   * @default true
   */
  is_all_states?: boolean;
  /** Is Disabled */
  is_disabled: boolean;
  /**
   * Is Due Date Immediate
   * @default null
   */
  is_due_date_immediate?: boolean | null;
  /**
   * Notification Key
   * @default null
   */
  notification_key?: string | null;
  /**
   * Notification Rule Trigger Id
   * @default null
   */
  notification_rule_trigger_id?: number | null;
  /**
   * Predefined Notification Conditions
   * @default null
   */
  predefined_notification_conditions?: Record<string, any> | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
}

/** NotificationKanbanConfigurationParams */
export interface NotificationKanbanConfigurationParams {
  /**
   * Categories
   * @default []
   */
  categories?: NotificationKanbanConfigurationParamsNotificationKanbanCategoryConfigurationAssociationParams[];
  /** @default "priority" */
  default_column_sort_by_type?: NotificationKanbanConfigurationParamsNotificationKanbanConfigurationColumnEnum;
}

/** NotificationKanbanCategoryConfigurationAssociationParams */
export interface NotificationKanbanConfigurationParamsNotificationKanbanCategoryConfigurationAssociationParams {
  /** Category Id */
  category_id: number;
  /**
   * Is Enabled
   * @default true
   */
  is_enabled?: boolean | null;
  /** Kanban Column Index */
  kanban_column_index: number;
  /**
   * Max Notification Per Category
   * @default null
   */
  max_notification_per_category?: number | null;
}

/** NotificationKanbanConfigurationUpdateParams */
export interface NotificationKanbanConfigurationUpdateParams {
  /** @default "priority" */
  default_column_sort_by_type?: NotificationKanbanConfigurationUpdateParamsNotificationKanbanConfigurationColumnEnum | null;
  /** Default Max Notification Per Category */
  default_max_notification_per_category: number | null;
}

/** NotificationRuleCreateJson */
export interface NotificationRuleCreateJson {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /** Conditions */
  conditions: NotificationRuleCreateJsonNotificationRuleConditionJson[];
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Content */
  content: string;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /**
   * Event Criteria Types
   * @default null
   */
  event_criteria_types?: string[] | null;
  /**
   * Event Key
   * @default null
   */
  event_key?: string | null;
  /**
   * Is All States
   * @default true
   */
  is_all_states?: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /**
   * Is Due Date Immediate
   * @default null
   */
  is_due_date_immediate?: boolean | null;
  /**
   * Is Immediate
   * @default true
   */
  is_immediate?: boolean;
  /** Lob */
  lob: string;
  /**
   * Organization Unit Id
   * @default null
   */
  organization_unit_id?: number | null;
  /**
   * Predefined Notification Conditions
   * @default null
   */
  predefined_notification_conditions?: Record<string, any> | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /** Recipient */
  recipient: string;
  /** Rule Name */
  rule_name: string;
  /**
   * Rule Trigger Type
   * @default "event_based"
   */
  rule_trigger_type?: string;
  /**
   * Schedule Number
   * @default null
   */
  schedule_number?: number | null;
  /**
   * Schedule Timeframe
   * @default null
   */
  schedule_timeframe?: string | null;
  /** Scope */
  scope: string;
  /** Scope Status */
  scope_status: string;
  /**
   * Scope Sub Types
   * @default null
   */
  scope_sub_types?: string[] | null;
  /**
   * Scope Types
   * @default null
   */
  scope_types?: string[] | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /** Title */
  title: string;
}

/** NotificationRuleConditionJson */
export interface NotificationRuleCreateJsonNotificationRuleConditionJson {
  /**
   * Condition Date Range End Date
   * @default null
   */
  condition_date_range_end_date?: string | null;
  /**
   * Condition Date Range End Time
   * @default null
   */
  condition_date_range_end_time?: string | null;
  /**
   * Condition Date Range Start Date
   * @default null
   */
  condition_date_range_start_date?: string | null;
  /**
   * Condition Date Range Start Time
   * @default null
   */
  condition_date_range_start_time?: string | null;
  /**
   * Condition Key
   * @default null
   */
  condition_key?: string | null;
  /**
   * Condition Numeric Value
   * @default null
   */
  condition_numeric_value?: number | null;
  /**
   * Condition Schedule Timeframe Value
   * @default null
   */
  condition_schedule_timeframe_value?: string | null;
  /**
   * Condition Schedule Value
   * @default null
   */
  condition_schedule_value?: number | null;
  /**
   * Condition Text Value
   * @default null
   */
  condition_text_value?: string | null;
  /**
   * Criteria Filters
   * @default null
   */
  criteria_filters?: Record<string, any> | null;
  /** Criteria Key */
  criteria_key: string;
  /**
   * Criteria Types
   * @default null
   */
  criteria_types?: string[] | null;
}

/** NotificationRuleInfoList */
export type NotificationRuleInfoList =
  NotificationRuleInfoListNotificationRuleInfo[];

/**
 * CategoryInfo
 * Pydantic representation of a Category, used at the service interface boundary.
 */
export interface NotificationRuleInfoListCategoryInfo {
  /** Color */
  color: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /** Key */
  key: string;
  /** Label */
  label: string;
  /** Type */
  type: string;
}

/** NotificationConfigInfo */
export interface NotificationRuleInfoListNotificationConfigInfo {
  /** @default null */
  category?: NotificationRuleInfoListCategoryInfo | null;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /** Id */
  id: number;
  /**
   * Is All States
   * @default true
   */
  is_all_states?: boolean;
  /** Is Disabled */
  is_disabled: boolean;
  /**
   * Is Due Date Immediate
   * @default null
   */
  is_due_date_immediate?: boolean | null;
  /**
   * Notification Key
   * @default null
   */
  notification_key?: string | null;
  /**
   * Predefined Notification Conditions
   * @default null
   */
  predefined_notification_conditions?: Record<string, any> | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
}

/** NotificationRuleConditionInfo */
export interface NotificationRuleInfoListNotificationRuleConditionInfo {
  /**
   * Condition Date Range End Date
   * @default null
   */
  condition_date_range_end_date?: string | null;
  /**
   * Condition Date Range End Time
   * @default null
   */
  condition_date_range_end_time?: string | null;
  /**
   * Condition Date Range Start Date
   * @default null
   */
  condition_date_range_start_date?: string | null;
  /**
   * Condition Date Range Start Time
   * @default null
   */
  condition_date_range_start_time?: string | null;
  /**
   * Condition Key
   * @default null
   */
  condition_key?: string | null;
  /**
   * Condition Numeric Value
   * @default null
   */
  condition_numeric_value?: number | null;
  /**
   * Condition Schedule Timeframe Value
   * @default null
   */
  condition_schedule_timeframe_value?: string | null;
  /**
   * Condition Schedule Value
   * @default null
   */
  condition_schedule_value?: number | null;
  /**
   * Condition Text Value
   * @default null
   */
  condition_text_value?: string | null;
  /**
   * Criteria Filters
   * @default null
   */
  criteria_filters?: Record<string, any> | null;
  /**
   * Criteria Key
   * @default null
   */
  criteria_key?: string | null;
  /**
   * Criteria Types
   * @default null
   */
  criteria_types?: string | null;
  /** Id */
  id: number;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
}

/**
 * NotificationRuleInfo
 * Full rule info returned by get_notification_rules.
 */
export interface NotificationRuleInfoListNotificationRuleInfo {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Conditions
   * @default []
   */
  conditions?: NotificationRuleInfoListNotificationRuleConditionInfo[];
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Content
   * @default null
   */
  content?: string | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /**
   * Event Criteria Types
   * @default null
   */
  event_criteria_types?: string | null;
  /**
   * Event Key
   * @default null
   */
  event_key?: string | null;
  /** Id */
  id: number;
  /**
   * Is All States
   * @default true
   */
  is_all_states?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  /**
   * Is Disabled
   * @default false
   */
  is_disabled?: boolean;
  /**
   * Is Due Date Immediate
   * @default null
   */
  is_due_date_immediate?: boolean | null;
  /**
   * Is Immediate
   * @default true
   */
  is_immediate?: boolean;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /**
   * Lob
   * @default "all"
   */
  lob?: string | null;
  /** @default null */
  notification_configuration?: NotificationRuleInfoListNotificationConfigInfo | null;
  /** Notification Key */
  notification_key: string;
  /**
   * Notification Type
   * @default "self_configured"
   */
  notification_type?: "self_configured";
  /**
   * Organization Unit Id
   * @default null
   */
  organization_unit_id?: number | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * Recipient
   * @default null
   */
  recipient?: string | null;
  /**
   * Rule Name
   * @default null
   */
  rule_name?: string | null;
  /**
   * Rule Trigger Type
   * @default "event_based"
   */
  rule_trigger_type?: string;
  /**
   * Schedule Number
   * @default null
   */
  schedule_number?: number | null;
  /**
   * Schedule Timeframe
   * @default null
   */
  schedule_timeframe?: string | null;
  /**
   * Scope
   * @default null
   */
  scope?: string | null;
  /**
   * Scope Status
   * @default "all"
   */
  scope_status?: string | null;
  /**
   * Scope Sub Types
   * @default null
   */
  scope_sub_types?: string | null;
  /**
   * Scope Types
   * @default "all"
   */
  scope_types?: string | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[];
  /**
   * Sub Orgs
   * @default "all"
   */
  sub_orgs?: string;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * NotificationRuleUpdateJson
 * Update payload extends create with update-only fields.
 */
export interface NotificationRuleUpdateJson {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /** Conditions */
  conditions: NotificationRuleUpdateJsonNotificationRuleConditionJson[];
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Content */
  content: string;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /**
   * Event Criteria Types
   * @default null
   */
  event_criteria_types?: string[] | null;
  /**
   * Event Key
   * @default null
   */
  event_key?: string | null;
  /**
   * Is All States
   * @default true
   */
  is_all_states?: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /**
   * Is Due Date Immediate
   * @default null
   */
  is_due_date_immediate?: boolean | null;
  /**
   * Is Immediate
   * @default true
   */
  is_immediate?: boolean;
  /** Lob */
  lob: string;
  /**
   * Organization Unit Id
   * @default null
   */
  organization_unit_id?: number | null;
  /**
   * Predefined Notification Conditions
   * @default null
   */
  predefined_notification_conditions?: Record<string, any> | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /** Recipient */
  recipient: string;
  /** Rule Name */
  rule_name: string;
  /**
   * Rule Trigger Type
   * @default "event_based"
   */
  rule_trigger_type?: string;
  /**
   * Schedule Number
   * @default null
   */
  schedule_number?: number | null;
  /**
   * Schedule Timeframe
   * @default null
   */
  schedule_timeframe?: string | null;
  /** Scope */
  scope: string;
  /** Scope Status */
  scope_status: string;
  /**
   * Scope Sub Types
   * @default null
   */
  scope_sub_types?: string[] | null;
  /**
   * Scope Types
   * @default null
   */
  scope_types?: string[] | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /** Title */
  title: string;
}

/** NotificationRuleConditionJson */
export interface NotificationRuleUpdateJsonNotificationRuleConditionJson {
  /**
   * Condition Date Range End Date
   * @default null
   */
  condition_date_range_end_date?: string | null;
  /**
   * Condition Date Range End Time
   * @default null
   */
  condition_date_range_end_time?: string | null;
  /**
   * Condition Date Range Start Date
   * @default null
   */
  condition_date_range_start_date?: string | null;
  /**
   * Condition Date Range Start Time
   * @default null
   */
  condition_date_range_start_time?: string | null;
  /**
   * Condition Key
   * @default null
   */
  condition_key?: string | null;
  /**
   * Condition Numeric Value
   * @default null
   */
  condition_numeric_value?: number | null;
  /**
   * Condition Schedule Timeframe Value
   * @default null
   */
  condition_schedule_timeframe_value?: string | null;
  /**
   * Condition Schedule Value
   * @default null
   */
  condition_schedule_value?: number | null;
  /**
   * Condition Text Value
   * @default null
   */
  condition_text_value?: string | null;
  /**
   * Criteria Filters
   * @default null
   */
  criteria_filters?: Record<string, any> | null;
  /** Criteria Key */
  criteria_key: string;
  /**
   * Criteria Types
   * @default null
   */
  criteria_types?: string[] | null;
}

/** NotificationTypeCountList */
export type NotificationTypeCountList =
  NotificationTypeCountListNotificationTypeCount[];

/** NotificationTypeCount */
export interface NotificationTypeCountListNotificationTypeCount {
  /**
   * Count
   * @default null
   */
  count?: number | null;
  /**
   * Subtype
   * @default null
   */
  subtype?: string | null;
  type: NotificationTypeCountListNotificationsType;
}

/** NotificationTypeCountsQueryParams */
export interface NotificationTypeCountsQueryParams {
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
}

/** NotificationsPreferencesInfo */
export interface NotificationsPreferencesInfo {
  /**
   * Default Notifications Per Page
   * @default null
   */
  default_notifications_per_page?: number | null;
  /**
   * Default Sort Order
   * @default null
   */
  default_sort_order?: "desc" | "asc" | null;
  /**
   * Is Default Notifications Per Page Enabled
   * @default null
   */
  is_default_notifications_per_page_enabled?: boolean | null;
  /**
   * Is Default Sort Order Enabled
   * @default null
   */
  is_default_sort_order_enabled?: boolean | null;
  /**
   * Is Default View All In Claims Page
   * @default null
   */
  is_default_view_all_in_claims_page?: boolean | null;
  /**
   * Is Overdue Date In Red
   * @default null
   */
  is_overdue_date_in_red?: boolean | null;
}

/** NotificationsPreferencesPatchParams */
export interface NotificationsPreferencesPatchParams {
  /**
   * Default Notifications Per Page
   * @default null
   */
  default_notifications_per_page?: number | null;
  /**
   * Default Sort Order
   * @default null
   */
  default_sort_order?: "desc" | "asc" | null;
  /**
   * Is Default Notifications Per Page Enabled
   * @default null
   */
  is_default_notifications_per_page_enabled?: boolean | null;
  /**
   * Is Default Sort Order Enabled
   * @default null
   */
  is_default_sort_order_enabled?: boolean | null;
  /**
   * Is Default View All In Claims Page
   * @default null
   */
  is_default_view_all_in_claims_page?: boolean | null;
  /**
   * Is Overdue Date In Red
   * @default null
   */
  is_overdue_date_in_red?: boolean | null;
}

/** OneIncConfigurationArguments */
export interface OneIncConfigurationArguments {
  /** Password */
  password: string;
  /** Url */
  url: string;
  /** Username */
  username: string;
}

/**
 * OneIncInboundTenantConfigInfo
 * What a caller may learn about the organization's One Inc tenant.
 *
 * Carries **neither** authentication key, by construction rather than by the screen choosing not
 * to render them: a ``PortalOneAuthenticationKey`` in a response body is a credential leaving the
 * system, and the screen only ever needs to know whether one is stored. The two booleans are what
 * let it show "configured" without ever holding the value.
 */
export interface OneIncInboundTenantConfigInfo {
  /**
   * Base Url
   * @default null
   */
  base_url?: string | null;
  /**
   * Has Authentication Key
   * @default false
   */
  has_authentication_key?: boolean;
  /**
   * Has Ui Authentication Key
   * @default false
   */
  has_ui_authentication_key?: boolean;
  /**
   * Has Webhook Signing Key
   * @default false
   */
  has_webhook_signing_key?: boolean;
  /**
   * Webhook Url
   * @default null
   */
  webhook_url?: string | null;
}

/** OneIncWebhookCredentialsResponse */
export interface OneIncWebhookCredentialsResponse {
  /** Webhook Password */
  webhook_password: string;
  /** Webhook Username */
  webhook_username: string;
}

/** OrgUnitCreateJson */
export interface OrgUnitCreateJson {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Key */
  key: string;
  /** Leader User Id */
  leader_user_id: string;
  /**
   * Member User Ids
   * @default null
   */
  member_user_ids?: string[] | null;
  /** Name */
  name: string;
  /**
   * Parent Unit Id
   * @default null
   */
  parent_unit_id?: number | null;
}

/** OrgUnitInfo */
export interface OrgUnitInfo {
  /** Api Uid */
  api_uid: string;
  /** Description */
  description: string | null;
  /** Has Sub Units */
  has_sub_units: boolean;
  /** Id */
  id: number;
  /** Is Active */
  is_active: boolean;
  /** Key */
  key: string;
  /** Last Updated */
  last_updated: string | null;
  /** Leader User Id */
  leader_user_id: string;
  /** Leader User Name */
  leader_user_name: string;
  /** Members */
  members: OrgUnitInfoOrgUnitMemberInfo[];
  /** Members Count */
  members_count: number;
  /** Name */
  name: string;
  /** Organization Id */
  organization_id: number;
  /** Parent Unit Id */
  parent_unit_id: number | null;
  /** Parent Unit Name */
  parent_unit_name: string;
}

/** OrgUnitMemberInfo */
export interface OrgUnitInfoOrgUnitMemberInfo {
  /** Member User Id */
  member_user_id: string;
  /** Member User Name */
  member_user_name: string;
}

/** OrgUnitInfoList */
export type OrgUnitInfoList = OrgUnitInfoListOrgUnitInfo[];

/** OrgUnitInfo */
export interface OrgUnitInfoListOrgUnitInfo {
  /** Api Uid */
  api_uid: string;
  /** Description */
  description: string | null;
  /** Has Sub Units */
  has_sub_units: boolean;
  /** Id */
  id: number;
  /** Is Active */
  is_active: boolean;
  /** Key */
  key: string;
  /** Last Updated */
  last_updated: string | null;
  /** Leader User Id */
  leader_user_id: string;
  /** Leader User Name */
  leader_user_name: string;
  /** Members */
  members: OrgUnitInfoListOrgUnitMemberInfo[];
  /** Members Count */
  members_count: number;
  /** Name */
  name: string;
  /** Organization Id */
  organization_id: number;
  /** Parent Unit Id */
  parent_unit_id: number | null;
  /** Parent Unit Name */
  parent_unit_name: string;
}

/** OrgUnitMemberInfo */
export interface OrgUnitInfoListOrgUnitMemberInfo {
  /** Member User Id */
  member_user_id: string;
  /** Member User Name */
  member_user_name: string;
}

/** OrgUnitUpdateJson */
export interface OrgUnitUpdateJson {
  /** Description */
  description: string;
  /** Leader User Id */
  leader_user_id: string;
  /** Member User Ids */
  member_user_ids: string[];
  /** Name */
  name: string;
  /**
   * Parent Unit Id
   * @default null
   */
  parent_unit_id?: number | null;
}

/** OrganizationAiExpertInfoList */
export type OrganizationAiExpertInfoList =
  OrganizationAiExpertInfoListOrganizationAiExpertInfo[];

/**
 * OrganizationAiExpertInfo
 * A catalog expert as an organization's configuration screens see it, with the run modes it can perform.
 *
 * Only the organization read resolves the modes, so the admin catalog routes keep returning plain
 * ``AiExpertInfo`` rather than values nothing computed.
 */
export interface OrganizationAiExpertInfoListOrganizationAiExpertInfo {
  /**
   * Conductor Supported
   * Whether the expert can run with the conductor. Never for the QA expert, which only runs standalone; otherwise true when nothing constrains it: a demo expert, a static expert the AI service does not list, or the AI service not answering.
   */
  conductor_supported: boolean;
  /** Confidence */
  confidence: number;
  /** Display Name */
  display_name: string;
  /** Icon */
  icon: string;
  /** Instructions */
  instructions: string | null;
  /** Is Demo */
  is_demo: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Key */
  key: string;
  /**
   * Standalone Supported
   * Whether the expert can run standalone, on its own trigger. True when nothing constrains it, as for conductor_supported.
   */
  standalone_supported: boolean;
}

/** OrganizationContactRolesDict */
export type OrganizationContactRolesDict = Record<
  string,
  OrganizationContactRolesDictContactRoleResponse
>;

/** ContactRoleResponse */
export interface OrganizationContactRolesDictContactRoleResponse {
  /** Desc */
  desc: string;
  /** Id */
  id: number;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is Coi Required */
  is_coi_required: boolean;
  /** Is Contract Of Service Required */
  is_contract_of_service_required: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Mandatory */
  is_mandatory: boolean;
  /** Is Moi Enabled */
  is_moi_enabled: boolean;
  /** Is Multi Claim */
  is_multi_claim: boolean;
  /** Is System */
  is_system: boolean;
  /** Is Tin Required */
  is_tin_required: boolean;
  /** Lobs */
  lobs: string[];
  /** Role Key */
  role_key: string;
}

/** OrganizationDocumentTypesDict */
export type OrganizationDocumentTypesDict = Record<
  string,
  OrganizationDocumentTypesDictDocumentTypeResponse
>;

/** ConfiguredField */
export interface OrganizationDocumentTypesDictConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?: OrganizationDocumentTypesDictConfiguredFieldSelectOption[] | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: OrganizationDocumentTypesDictConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface OrganizationDocumentTypesDictConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/**
 * DocumentTypeConfiguration
 * Typed view of the `document_type.configuration` JSONB column.
 */
export interface OrganizationDocumentTypesDictDocumentTypeConfiguration {
  /** Configured Fields */
  configured_fields?: OrganizationDocumentTypesDictConfiguredField[];
}

/** DocumentTypeResponse */
export interface OrganizationDocumentTypesDictDocumentTypeResponse {
  /**
   * Can Disable
   * Whether an admin may switch this document type off.
   */
  can_disable: boolean;
  /**
   * Clive Instructions
   * @default null
   */
  clive_instructions?: string | null;
  /** @default null */
  configuration?: OrganizationDocumentTypesDictDocumentTypeConfiguration | null;
  /** Description */
  description: string;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Is Public Option
   * @default true
   */
  is_public_option?: boolean | null;
  /**
   * Is Sensitive
   * @default false
   */
  is_sensitive?: boolean | null;
  /** Key */
  key: string;
  /**
   * Last Updated By Username
   * @default null
   */
  last_updated_by_username?: string | null;
  /**
   * Last Updated Datetime
   * @default null
   */
  last_updated_datetime?: string | null;
  /** Lobs */
  lobs: string[];
  /** Type */
  type: string;
}

/** OutOfOfficeData */
export interface OutOfOfficeData {
  /**
   * Back To Office Date
   * @default null
   */
  back_to_office_date?: string | null;
  /**
   * Forward Notification User Ids
   * @default []
   */
  forward_notification_user_ids?: string[] | null;
  /**
   * Is User Out Of Office
   * @default false
   */
  is_user_out_of_office?: boolean;
  /**
   * Ooo Email Content
   * @default null
   */
  ooo_email_content?: string | null;
  /**
   * Should Send Out Of Office Email
   * @default false
   */
  should_send_out_of_office_email?: boolean | null;
  /**
   * Should Use Out Of Office Voice Mail
   * @default false
   */
  should_use_out_of_office_voice_mail?: boolean;
}

/**
 * OutgoingPromotionDetail
 * An outgoing row plus its flat change list (the source's own GCS copy), grouped by
 * ``configuration_type`` on the frontend.
 */
export interface OutgoingPromotionDetail {
  /** Cached Reject Reason */
  cached_reject_reason: string | null;
  /** Cached Status */
  cached_status: string;
  /** Changes */
  changes: Record<string, any>[];
  /** Changes Hash */
  changes_hash: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Pairing Id */
  pairing_id: number;
  /** Request Name */
  request_name: string | null;
  /** Request Uuid */
  request_uuid: string;
  /** Requesting User Display Name */
  requesting_user_display_name: string | null;
  /** Requesting User Id */
  requesting_user_id: string;
  /** Summary */
  summary: OutgoingPromotionDetailPromotionRequestTypeCounts[];
  /** Target Deployment Id */
  target_deployment_id: string;
  /** Target Org External Id */
  target_org_external_id: string;
}

/**
 * PromotionRequestTypeCounts
 * Per-configuration-type CREATE/UPDATE/DELETE counts for a change list.
 */
export interface OutgoingPromotionDetailPromotionRequestTypeCounts {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Create Count
   * @default 0
   */
  create_count?: number;
  /**
   * Delete Count
   * @default 0
   */
  delete_count?: number;
  /**
   * Update Count
   * @default 0
   */
  update_count?: number;
}

/** OutgoingPromotionListResult */
export interface OutgoingPromotionListResult {
  /** Items */
  items: OutgoingPromotionListResultOutgoingPromotionItem[];
}

/**
 * OutgoingPromotionItem
 * A row in the source-side outgoing list — read from ``ConfigurationPromotionOutgoing``.
 */
export interface OutgoingPromotionListResultOutgoingPromotionItem {
  /** Cached Reject Reason */
  cached_reject_reason: string | null;
  /** Cached Status */
  cached_status: string;
  /** Changes Hash */
  changes_hash: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Pairing Id */
  pairing_id: number;
  /** Request Name */
  request_name: string | null;
  /** Request Uuid */
  request_uuid: string;
  /** Requesting User Display Name */
  requesting_user_display_name: string | null;
  /** Requesting User Id */
  requesting_user_id: string;
  /** Summary */
  summary: OutgoingPromotionListResultPromotionRequestTypeCounts[];
  /** Target Deployment Id */
  target_deployment_id: string;
  /** Target Org External Id */
  target_org_external_id: string;
}

/**
 * PromotionRequestTypeCounts
 * Per-configuration-type CREATE/UPDATE/DELETE counts for a change list.
 */
export interface OutgoingPromotionListResultPromotionRequestTypeCounts {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Create Count
   * @default 0
   */
  create_count?: number;
  /**
   * Delete Count
   * @default 0
   */
  delete_count?: number;
  /**
   * Update Count
   * @default 0
   */
  update_count?: number;
}

/**
 * OverrideRuleConditionFieldsParams
 * Query params for the delegated-authority QueryBuilder field-registry endpoint.
 *
 * The two scope pairs narrow the catalog to the scope the author picked in the
 * upsert dialog, so the rule is authored against the same catalog it will be
 * saved against. `lobs` carries every LOB the rule is scoped to, repeated as
 * `lobs[]=a&lobs[]=b` exactly like `sub_org_ids[]`; the catalog is the
 * intersection across them. `is_all_lobs` / `is_all_sub_orgs` are the scope
 * those lists cannot express — "every LOB / sub-org the organization has,
 * including future ones" — and each takes precedence over its list.
 *
 * Both all-flags default to true, so a list narrows the catalog only when the
 * request also sends its flag as false.
 *
 * `lobs[]` is optional, and the route reads an empty list as no LOB narrowing.
 * This is a deliberate divergence from the framework sibling
 * `RulesEngineConditionFieldsParams`, which requires `lobs[]` unless
 * `is_all_lobs` is set. The dialog refetches the catalog on every scope change,
 * and while its LOB picker is empty (it clears itself whenever the sub-org
 * selection changes) that request carries `is_all_lobs=false` and no `lobs[]`;
 * the sibling's 400 would open an error dialog on each such change. The dialog
 * will not save an empty LOB selection, so no rule is saved against that
 * catalog.
 *
 * Delegated authority is single-rule-set, so there is no `entity` selector.
 * The route always resolves through
 * `rules_engine.get_condition_fields('delegated_authority', scope)` and
 * post-filters `exposure.*` paths in claim-level mode (DR §5.2).
 */
export interface OverrideRuleConditionFieldsParams {
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default true
   */
  is_all_sub_orgs?: boolean;
  "lobs[]"?: OverrideRuleConditionFieldsParamsEnsuredListStr;
  "sub_org_ids[]"?: OverrideRuleConditionFieldsParamsEnsuredListInt;
}

export type OverrideRuleConditionFieldsParamsEnsuredListInt = number[];

export type OverrideRuleConditionFieldsParamsEnsuredListStr = string[];

/**
 * OverrideRuleWithOverridesInfo
 * Composite admin view of a delegated-authority override rule: the rule
 * core fields, its QueryBuilder conditions tree, and the per-level overrides
 * dict assembled from the attached
 * AuthorityRuleLevelOverrideAction.action_params JSONB.
 *
 * `conditions_json` is the only conditions representation — both the
 * override-rules table read-side and the upsert dialog consume it. A null tree
 * means "no conditions / match all".
 *
 * The four scope fields are the read counterpart of the ones
 * ``CreateOverrideRuleParams`` / ``UpdateOverrideRuleParams`` already accept:
 * they come off the ``RuleInfo`` this DTO is assembled from, so exposing them
 * costs no extra query, and without them the rules table and the upsert dialog
 * would have no way to show or re-edit a rule's scope. Their optionality
 * mirrors ``RuleInfo``'s.
 */
export interface OverrideRuleWithOverridesInfo {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Overrides
   * @default {}
   */
  overrides?: Record<string, OverrideRuleWithOverridesInfoLevelOverrideLimits>;
  /** Priority */
  priority: number;
  /** Rule Id */
  rule_id: number;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
}

/**
 * LevelOverrideLimits
 * PATCH values for a single level inside a rule's action JSONB.
 * Null = keep level default.
 */
export interface OverrideRuleWithOverridesInfoLevelOverrideLimits {
  /**
   * Expenses Payments Limit
   * @default null
   */
  expenses_payments_limit?: string | null;
  /**
   * Expenses Reserves Limit
   * @default null
   */
  expenses_reserves_limit?: string | null;
  /**
   * Indemnity Payments Limit
   * @default null
   */
  indemnity_payments_limit?: string | null;
  /**
   * Indemnity Reserves Limit
   * @default null
   */
  indemnity_reserves_limit?: string | null;
  /**
   * Payments Limit
   * @default null
   */
  payments_limit?: string | null;
  /**
   * Reserves Limit
   * @default null
   */
  reserves_limit?: string | null;
}

/** OverrideRuleWithOverridesInfoList */
export type OverrideRuleWithOverridesInfoList =
  OverrideRuleWithOverridesInfoListOverrideRuleWithOverridesInfo[];

/**
 * LevelOverrideLimits
 * PATCH values for a single level inside a rule's action JSONB.
 * Null = keep level default.
 */
export interface OverrideRuleWithOverridesInfoListLevelOverrideLimits {
  /**
   * Expenses Payments Limit
   * @default null
   */
  expenses_payments_limit?: string | null;
  /**
   * Expenses Reserves Limit
   * @default null
   */
  expenses_reserves_limit?: string | null;
  /**
   * Indemnity Payments Limit
   * @default null
   */
  indemnity_payments_limit?: string | null;
  /**
   * Indemnity Reserves Limit
   * @default null
   */
  indemnity_reserves_limit?: string | null;
  /**
   * Payments Limit
   * @default null
   */
  payments_limit?: string | null;
  /**
   * Reserves Limit
   * @default null
   */
  reserves_limit?: string | null;
}

/**
 * OverrideRuleWithOverridesInfo
 * Composite admin view of a delegated-authority override rule: the rule
 * core fields, its QueryBuilder conditions tree, and the per-level overrides
 * dict assembled from the attached
 * AuthorityRuleLevelOverrideAction.action_params JSONB.
 *
 * `conditions_json` is the only conditions representation — both the
 * override-rules table read-side and the upsert dialog consume it. A null tree
 * means "no conditions / match all".
 *
 * The four scope fields are the read counterpart of the ones
 * ``CreateOverrideRuleParams`` / ``UpdateOverrideRuleParams`` already accept:
 * they come off the ``RuleInfo`` this DTO is assembled from, so exposing them
 * costs no extra query, and without them the rules table and the upsert dialog
 * would have no way to show or re-edit a rule's scope. Their optionality
 * mirrors ``RuleInfo``'s.
 */
export interface OverrideRuleWithOverridesInfoListOverrideRuleWithOverridesInfo {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Overrides
   * @default {}
   */
  overrides?: Record<
    string,
    OverrideRuleWithOverridesInfoListLevelOverrideLimits
  >;
  /** Priority */
  priority: number;
  /** Rule Id */
  rule_id: number;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
}

/** PageDataResponse[CatEventResponse, NoneType] */
export interface PageDataResponseCatEventResponseNoneType {
  /**
   * Meta
   * @default null
   */
  meta?: null;
  /** Results */
  results: PageDataResponseCatEventResponseNoneTypeCatEventResponse[];
}

/** CatEventResponse */
export interface PageDataResponseCatEventResponseNoneTypeCatEventResponse {
  /** Code */
  code: string;
  /**
   * Count
   * @default null
   */
  count?: number | null;
  /**
   * End Date
   * @default null
   */
  end_date?: string | null;
  /** Id */
  id: number;
  /**
   * Is Hidden
   * @default false
   */
  is_hidden?: boolean | null;
  /** Name */
  name: string;
  /**
   * Pcs Number
   * @default null
   */
  pcs_number?: number | null;
  /**
   * Start Date
   * @default null
   */
  start_date?: string | null;
  /** Sync Key */
  sync_key: string;
  /**
   * Types
   * @default []
   */
  types?: string[];
  /**
   * Us States
   * @default []
   */
  us_states?: string[];
}

/** PageDataResponse[FnolInboxRecord, NoneType] */
export interface PageDataResponseFnolInboxRecordNoneType {
  /**
   * Meta
   * @default null
   */
  meta?: null;
  /** Results */
  results: PageDataResponseFnolInboxRecordNoneTypeFnolInboxRecord[];
}

/** FnolAnalysisExtra */
export interface PageDataResponseFnolInboxRecordNoneTypeFnolAnalysisExtra {
  /**
   * Related Claims
   * @default []
   */
  related_claims?: PageDataResponseFnolInboxRecordNoneTypeRelatedClaim[] | null;
  /** @default null */
  related_claims_stats?: PageDataResponseFnolInboxRecordNoneTypeRelatedClaimsStats | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** FnolInboxPolicy */
export interface PageDataResponseFnolInboxRecordNoneTypeFnolInboxPolicy {
  /**
   * Policy Data
   * @default null
   */
  policy_data?: Record<string, any> | null;
  /** Policy Number */
  policy_number: string;
}

/** FnolInboxRecord */
export interface PageDataResponseFnolInboxRecordNoneTypeFnolInboxRecord {
  /** @default null */
  analysis_extra?: PageDataResponseFnolInboxRecordNoneTypeFnolAnalysisExtra | null;
  /** Attachments */
  attachments: boolean;
  /**
   * Can Move To Gq
   * @default false
   */
  can_move_to_gq?: boolean;
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contact Full Name
   * @default null
   */
  contact_full_name?: string | null;
  /**
   * Date Received
   * @default null
   */
  date_received?: string | null;
  /** Effective Sub Org Id */
  effective_sub_org_id: number | null;
  /** Email Address */
  email_address: string;
  /** Email Communication Id */
  email_communication_id: number;
  /**
   * Email Summary
   * @default null
   */
  email_summary?: string | null;
  /** @default null */
  error_type?: PageDataResponseFnolInboxRecordNoneTypeFnolTaskErrorType | null;
  /**
   * Fnol Summary
   * @default null
   */
  fnol_summary?: string | null;
  /** Id */
  id: number;
  /**
   * Is Clive Enabled For Incident Configuration
   * @default null
   */
  is_clive_enabled_for_incident_configuration?: boolean | null;
  /**
   * Is Read
   * @default null
   */
  is_read?: boolean | null;
  /** Line Of Business */
  line_of_business: string | null;
  /** Organization Id */
  organization_id: number;
  /** @default null */
  policy?: PageDataResponseFnolInboxRecordNoneTypeFnolInboxPolicy | null;
  status: PageDataResponseFnolInboxRecordNoneTypeFnolInboxStatus;
  /** Sub Organization Id */
  sub_organization_id: number | null;
  /**
   * Sub Organization Name
   * @default null
   */
  sub_organization_name?: string | null;
  /** Subject */
  subject: string;
  /** Was Sent To Ai Service */
  was_sent_to_ai_service: boolean;
}

/** RelatedClaim */
export interface PageDataResponseFnolInboxRecordNoneTypeRelatedClaim {
  /** Claim Id */
  claim_id: number;
  /** Claim Id Display */
  claim_id_display: string;
}

/** RelatedClaimsStats */
export interface PageDataResponseFnolInboxRecordNoneTypeRelatedClaimsStats {
  /** Len After Fuzzy */
  len_after_fuzzy: number;
  /** Len Exact Found */
  len_exact_found: number;
  /**
   * Was Fuzzy Successful
   * @default true
   */
  was_fuzzy_successful?: boolean;
}

/** PageDataResponse[SorIssue, NoneType] */
export interface PageDataResponseSorIssueNoneType {
  /**
   * Meta
   * @default null
   */
  meta?: null;
  /** Results */
  results: PageDataResponseSorIssueNoneTypeSorIssue[];
}

/**
 * SorIssue
 * One attempt as the Issues tab lists it: everything an operator needs to resolve it, behind the Issues
 * permission, unlike the claim lock's view, which carries no claim content. ``status`` stays the stored status;
 * ``issue_status`` is the one the tab filters on; ``max_tries`` is the organization's configuration.
 */
export interface PageDataResponseSorIssueNoneTypeSorIssue {
  /** Api Identifier */
  api_identifier: string;
  /** Claim Id */
  claim_id: number;
  /** Claim Number */
  claim_number: string;
  /** Entity Id */
  entity_id: number;
  /** Entity Type */
  entity_type: string;
  /**
   * Error
   * @default null
   */
  error?: string | null;
  /** Id */
  id: number;
  /** Idempotency Key */
  idempotency_key: string;
  /**
   * An attempt's status as the Issues tab lists it: the stored status, except that an open attempt the
   * reconciler stopped retrying (``tries >= max_tries``) is ``needs_attention`` rather than ``pending`` or
   * ``remote_done``. Not stored: it is derived from the counter, so no write has to keep it in step.
   */
  issue_status: PageDataResponseSorIssueNoneTypeSorIssueStatus;
  /** Label */
  label: string;
  /**
   * Last Reconciled At
   * @default null
   */
  last_reconciled_at?: string | null;
  /** Max Tries */
  max_tries: number;
  /** Operation */
  operation: string;
  /**
   * Replayed As User Id
   * @default null
   */
  replayed_as_user_id?: string | null;
  /** Requested By User Id */
  requested_by_user_id: string;
  /**
   * Resolution Note
   * @default null
   */
  resolution_note?: string | null;
  /**
   * Resolved By User Id
   * @default null
   */
  resolved_by_user_id?: string | null;
  /**
   * Responded At
   * @default null
   */
  responded_at?: string | null;
  /**
   * Sent At
   * @default null
   */
  sent_at?: string | null;
  /**
   * Sent Payload
   * @default null
   */
  sent_payload?: Record<string, any> | null;
  /**
   * Sor External Id
   * @default null
   */
  sor_external_id?: string | null;
  /**
   * Sor Latency Ms
   * @default null
   */
  sor_latency_ms?: number | null;
  /**
   * Sor Response
   * @default null
   */
  sor_response?: Record<string, any> | null;
  /**
   * Started At
   * @format date-time
   */
  started_at: string;
  status: PageDataResponseSorIssueNoneTypeSorCommitStatus;
  /** Tries */
  tries: number;
}

/** PageDataResponse[TfnPendingVerificationItem, NoneType] */
export interface PageDataResponseTfnPendingVerificationItemNoneType {
  /**
   * Meta
   * @default null
   */
  meta?: null;
  /** Results */
  results: PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem[];
}

/**
 * TfnPendingVerificationItem
 * Schema for a single pending TFN verification in the list.
 */
export interface PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem {
  /** Change Ulid */
  change_ulid: string;
  /** Changed Fields */
  changed_fields: Record<string, any>;
  /** Contact External Id */
  contact_external_id: string | null;
  /** Contact Id */
  contact_id: number;
  /** Contact Name */
  contact_name: string;
  /** Id */
  id: string;
  /**
   * Request Datetime
   * @format date-time
   */
  request_datetime: string;
  /** Requesting User */
  requesting_user: string;
  /** Requesting User Id */
  requesting_user_id: string;
}

/** PageDataResponse[dict, NotificationsPageMeta] */
export interface PageDataResponseDictNotificationsPageMeta {
  /** @default null */
  meta?: PageDataResponseDictNotificationsPageMetaNotificationsPageMeta | null;
  /** Results */
  results: Record<string, any>[];
}

/**
 * NotificationsPageMeta
 * Metadata returned with paginated notification results.
 */
export interface PageDataResponseDictNotificationsPageMetaNotificationsPageMeta {
  /** Exposures */
  exposures: Record<string, any>[];
  /** Notifications Read Status */
  notifications_read_status: Record<string, boolean>;
}

/** PageDataResponse[dict, dict] */
export interface PageDataResponseDictDict {
  /**
   * Meta
   * @default null
   */
  meta?: Record<string, any> | null;
  /** Results */
  results: Record<string, any>[];
}

/**
 * PairingInfo
 * Public representation of an environment pairing.
 */
export interface PairingInfo {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Customer Identifier */
  customer_identifier: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Pairing Uuid */
  pairing_uuid: string;
  /** Role */
  role: string;
  /** Source Org External Id */
  source_org_external_id: string;
  /** Target Deployment Id */
  target_deployment_id: string;
  /** Target Org External Id */
  target_org_external_id: string;
}

/**
 * PairingListResult
 * Wrapper for the pairings list endpoint (spectree needs a top-level model, not a bare list).
 */
export interface PairingListResult {
  /** Items */
  items: PairingListResultPairingInfo[];
}

/**
 * PairingInfo
 * Public representation of an environment pairing.
 */
export interface PairingListResultPairingInfo {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Customer Identifier */
  customer_identifier: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Pairing Uuid */
  pairing_uuid: string;
  /** Role */
  role: string;
  /** Source Org External Id */
  source_org_external_id: string;
  /** Target Deployment Id */
  target_deployment_id: string;
  /** Target Org External Id */
  target_org_external_id: string;
}

/** PatchCategoryParams */
export interface PatchCategoryParams {
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
}

/** PatchCommunicationCategoryParams */
export interface PatchCommunicationCategoryParams {
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Id */
  id: number;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
}

/** PatchCommunicationConfigurationParams */
export interface PatchCommunicationConfigurationParams {
  /**
   * Adjuster Page Handled Filter Defaults To Pending
   * @default null
   */
  adjuster_page_handled_filter_defaults_to_pending?: boolean | null;
  /**
   * Claim Tab Handled Filter Defaults To Pending
   * @default null
   */
  claim_tab_handled_filter_defaults_to_pending?: boolean | null;
  /**
   * Is Category Required
   * @default null
   */
  is_category_required?: boolean | null;
  /**
   * Is Communication Permission Required For All Contacts
   * @default null
   */
  is_communication_permission_required_for_all_contacts?: boolean | null;
  /**
   * Is Handled Status Enabled
   * @default null
   */
  is_handled_status_enabled?: boolean | null;
}

/** PatchDueDateParams */
export interface PatchDueDateParams {
  /**
   * Claim Id
   * @default null
   */
  claim_id?: string | null;
  /**
   * Due Datetime
   * @format date-time
   */
  due_datetime: string;
}

/** PatchExternalClaimNumberParams */
export interface PatchExternalClaimNumberParams {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * External Claim Number
   * @default null
   */
  external_claim_number?: string | null;
  /**
   * External Contact Id
   * @default null
   */
  external_contact_id?: number | null;
}

/**
 * PatchExternalClaimNumberRequest
 * Request model for updating an external claim number. All fields are optional.
 *
 * To update the associated contact, pass it in the `contacts` array and reference it
 * using `external_contact_ref_id`. To remove the contact association, omit both fields.
 */
export interface PatchExternalClaimNumberRequest {
  /**
   * Contacts
   * List of contacts to associate (new or existing)
   */
  contacts?: (
    | ({
        creation_mode: "";
      } & PatchExternalClaimNumberRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & PatchExternalClaimNumberRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & PatchExternalClaimNumberRequestContactInNewParam)
  )[];
  /**
   * Description
   * Optional description for the external claim number
   * @default null
   */
  description?: string | null;
  /**
   * External Claim Number
   * The external claim number value
   * @default null
   */
  external_claim_number?: string | null;
  /**
   * External Contact Ref Id
   * Reference ID of the contact from the contacts list to associate
   * @default null
   */
  external_contact_ref_id?: string | null;
}

/** ContactEmailModel */
export interface PatchExternalClaimNumberRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface PatchExternalClaimNumberRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface PatchExternalClaimNumberRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: PatchExternalClaimNumberRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: PatchExternalClaimNumberRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface PatchExternalClaimNumberRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** PatchIncidentConfigurationModel */
export interface PatchIncidentConfigurationModel {
  new_configuration: PatchIncidentConfigurationModelIncidentConfigurationModel;
  old_configuration: PatchIncidentConfigurationModelIncidentConfigurationModel;
}

/**
 * GlobalFieldsStatus
 * Whether one configuration's projected entries match the global field rows.
 *
 * Returned on the incident-configuration GET and the reconcile response, and never computed on
 * a runtime read path. ``in_sync`` false means a trigger was missed; ``reconcile_global_fields``
 * re-projects that row and logs the drift at ERROR.
 */
export interface PatchIncidentConfigurationModelGlobalFieldsStatus {
  /**
   * Extra
   * @default []
   */
  extra?: string[];
  /** In Sync */
  in_sync: boolean;
  /**
   * Missing
   * @default []
   */
  missing?: string[];
  /**
   * Stale
   * @default []
   */
  stale?: string[];
}

/** IncidentConfigurationModel */
export interface PatchIncidentConfigurationModelIncidentConfigurationModel {
  /** Configuration */
  configuration: Record<string, any>;
  /** Display Name */
  display_name: string;
  /** @default null */
  global_fields_status?: PatchIncidentConfigurationModelGlobalFieldsStatus | null;
  /** Id */
  id: number;
  /** Lob */
  lob: string;
  /** Organization Id */
  organization_id: number;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /** Version */
  version: number;
}

/** PatchIncidentDetailsParams */
export interface PatchIncidentDetailsParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** @default null */
  auto_incident_additional?: PatchIncidentDetailsParamsAutoIncidentAdditionalModel | null;
  /**
   * Can Take Photos Of Damage
   * @default null
   */
  can_take_photos_of_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Cat Code
   * The catastrophe `code` of the linked cat event. Accepted as input (alternative to `cat_code_name`). If both `cat_code` and `cat_code_name` are sent, they must reference the same cat.
   * @default null
   */
  cat_code?: string | null;
  /**
   * Cat Code Name
   * @default null
   */
  cat_code_name?: string | null;
  /**
   * Contacts
   * @default null
   */
  contacts?:
    | (
        | ({
            creation_mode: "";
          } & PatchIncidentDetailsParamsContactInNewParam)
        | ({
            creation_mode: "existing";
          } & PatchIncidentDetailsParamsContactInExistingParam)
        | ({
            creation_mode: "new";
          } & PatchIncidentDetailsParamsContactInNewParam)
      )[]
    | null;
  /**
   * Date Of Loss
   * @default null
   */
  date_of_loss?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Did Anyone Take Photos Or Video
   * @default null
   */
  did_anyone_take_photos_or_video?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Incident Sub Type
   * @default null
   */
  incident_sub_type?: string | null;
  /**
   * Incident Type
   * @default null
   */
  incident_type?: string | null;
  /**
   * Is Notification Only
   * @default null
   */
  is_notification_only?: boolean | null;
  /**
   * Is Other Policy Covering
   * @default null
   */
  is_other_policy_covering?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  loss_location?: PatchIncidentDetailsParamsLocationModel | null;
  /**
   * Other Policy Description
   * @default null
   */
  other_policy_description?: string | null;
  /**
   * Photographer Contact Ref Id
   * @default null
   */
  photographer_contact_ref_id?: string | null;
  /**
   * Preferred Contact Ref Id
   * @default null
   */
  preferred_contact_ref_id?: string | null;
  /**
   * Special Internal Note
   * @default null
   */
  special_internal_note?: string | null;
  /**
   * Time Of Loss
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Was Cctv Footage
   * @default null
   */
  was_cctv_footage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were There Any Witnesses
   * @default null
   */
  were_there_any_witnesses?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Witnesses
   * @default null
   */
  witnesses?: PatchIncidentDetailsParamsExternalWitnessModel[] | null;
  /**
   * Witnesses Note
   * @default null
   */
  witnesses_note?: string | null;
}

/** AccidentFollowUpModel */
export interface PatchIncidentDetailsParamsAccidentFollowUpModel {
  /**
   * Direction Ph Vehicle Was Going
   * @default null
   */
  direction_ph_vehicle_was_going?: string | null;
  /**
   * First Party Way Sign Or A Headlight
   * @default null
   */
  first_party_way_sign_or_a_headlight?: string | null;
  /**
   * Journey Purpose
   * @default null
   */
  journey_purpose?: string | null;
  /**
   * Street Condition
   * @default null
   */
  street_condition?: string | null;
  /**
   * Was Ambulance Called
   * @default null
   */
  was_ambulance_called?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Anyone Under The Influence Of Drugs Alcohol
   * @default null
   */
  was_anyone_under_the_influence_of_drugs_alcohol?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Was First Party Driver Using The Phone
   * @default null
   */
  was_first_party_driver_using_the_phone?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Weather Conditions
   * @default null
   */
  weather_conditions?: string | null;
  /**
   * Were First Party Vehicle Lights On
   * @default null
   */
  were_first_party_vehicle_lights_on?: "yes" | "no" | "na" | "unknown" | null;
}

/** AutoIncidentAdditionalModel */
export interface PatchIncidentDetailsParamsAutoIncidentAdditionalModel {
  /** @default null */
  accident_follow_up?: PatchIncidentDetailsParamsAccidentFollowUpModel | null;
  /**
   * Are Convictions Or Claims In The Last 5 Years
   * @default null
   */
  are_convictions_or_claims_in_the_last_5_years?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Convictions Or Claim Description
   * @default null
   */
  convictions_or_claim_description?: string | null;
  /**
   * Does Policyholder Second Occupation Exist
   * @default null
   */
  does_policyholder_second_occupation_exist?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /** @default null */
  fault_assessment?: PatchIncidentDetailsParamsFaultAssessmentModel | null;
  /**
   * Is Policyholder Occupation Right
   * @default null
   */
  is_policyholder_occupation_right?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  police_and_fire_department?: PatchIncidentDetailsParamsPoliceAndFireDepartmentModel | null;
  /**
   * Policyholder Current Occupation
   * @default null
   */
  policyholder_current_occupation?: string | null;
  /**
   * Policyholder Second Occupation
   * @default null
   */
  policyholder_second_occupation?: string | null;
  /**
   * Replacement Car Rental Date
   * @default null
   */
  replacement_car_rental_date?: string | null;
  /** @default null */
  theft_follow_up?: PatchIncidentDetailsParamsTheftFollowUpModel | null;
  /**
   * Was Replacement Car Rented
   * @default null
   */
  was_replacement_car_rented?: boolean | null;
}

/** ContactEmailModel */
export interface PatchIncidentDetailsParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface PatchIncidentDetailsParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface PatchIncidentDetailsParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: PatchIncidentDetailsParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: PatchIncidentDetailsParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface PatchIncidentDetailsParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ExternalWitnessModel */
export interface PatchIncidentDetailsParamsExternalWitnessModel {
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
}

/** FaultAssessmentModel */
export interface PatchIncidentDetailsParamsFaultAssessmentModel {
  /**
   * Claim Handler Fault Assessment
   * @default null
   */
  claim_handler_fault_assessment?: string | null;
  /**
   * First Party Fault Assessment
   * @default null
   */
  first_party_fault_assessment?: string | null;
  /**
   * Is Fraud Review Needed
   * @default null
   */
  is_fraud_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Indemnity Review Needed
   * @default null
   */
  is_indemnity_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Liability Summary
   * @default null
   */
  liability_summary?: string | null;
  /**
   * Percentage Of Insured Liability
   * @default null
   */
  percentage_of_insured_liability?: string | null;
}

/** LocationModel */
export interface PatchIncidentDetailsParamsLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PoliceAndFireDepartmentModel */
export interface PatchIncidentDetailsParamsPoliceAndFireDepartmentModel {
  /**
   * Did Speak With Officer
   * @default null
   */
  did_speak_with_officer?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Fire Department Description
   * @default null
   */
  fire_department_description?: string | null;
  /**
   * Pending Prosecutions Or Investigations Exists
   * @default null
   */
  pending_prosecutions_or_investigations_exists?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Police Crime Reference Number
   * @default null
   */
  police_crime_reference_number?: string | null;
  /**
   * Police Department Contact Ref Id
   * @default null
   */
  police_department_contact_ref_id?: string | null;
  /**
   * Police Description
   * @default null
   */
  police_description?: string | null;
  /**
   * Police Report
   * @default null
   */
  police_report?: string | null;
  /**
   * Violation Title
   * @default null
   */
  violation_title?: string | null;
  /**
   * Was Ticket Received
   * @default null
   */
  was_ticket_received?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Any Hazardous Good Being Carried
   * @default null
   */
  were_any_hazardous_good_being_carried?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Were Fire Department Involved
   * @default null
   */
  were_fire_department_involved?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Police Involved
   * @default null
   */
  were_police_involved?: "yes" | "no" | "na" | "unknown" | null;
}

/** TheftFollowUpModel */
export interface PatchIncidentDetailsParamsTheftFollowUpModel {
  /**
   * Belongings Stolen
   * @default null
   */
  belongings_stolen?: string | null;
  /**
   * Crime Reference Number
   * @default null
   */
  crime_reference_number?: string | null;
  /**
   * Current Num Of Keys
   * @default null
   */
  current_num_of_keys?: number | null;
  /**
   * Date Noticed Vehicle Missing
   * @default null
   */
  date_noticed_vehicle_missing?: string | null;
  /**
   * Date Vehicle Last Seen
   * @default null
   */
  date_vehicle_last_seen?: string | null;
  /**
   * Discovered The Loss Contact Ref Id
   * @default null
   */
  discovered_the_loss_contact_ref_id?: string | null;
  /**
   * Is Vehicle For Sale
   * @default null
   */
  is_vehicle_for_sale?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  keys_location?: PatchIncidentDetailsParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Num Of Keys Received On Purchase
   * @default null
   */
  num_of_keys_received_on_purchase?: number | null;
  /**
   * Person Liable For The Theft Is Known
   * @default null
   */
  person_liable_for_the_theft_is_known?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Security Devices Description
   * @default null
   */
  security_devices_description?: string | null;
  /**
   * Time Noticed Vehicle Missing
   * @default null
   */
  time_noticed_vehicle_missing?: string | null;
  /**
   * Time Vehicle Last Seen
   * @default null
   */
  time_vehicle_last_seen?: string | null;
  /**
   * Tracking Devices Description
   * @default null
   */
  tracking_devices_description?: string | null;
  /**
   * Vehicle Fitted With Security Devices
   * @default null
   */
  vehicle_fitted_with_security_devices?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Vehicle Fitted With Tracking Devices
   * @default null
   */
  vehicle_fitted_with_tracking_devices?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  vehicle_last_seen_location?: PatchIncidentDetailsParamsLocationModel | null;
  /**
   * Vehicle Windows Closed And Secured
   * @default null
   */
  vehicle_windows_closed_and_secured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Vehicle Found With Keys
   * @default null
   */
  was_vehicle_found_with_keys?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Belongings Stolen From Vehicle
   * @default null
   */
  were_belongings_stolen_from_vehicle?: "yes" | "no" | "na" | "unknown" | null;
}

/** PatchInvolvedPartyParams */
export interface PatchInvolvedPartyParams {
  /**
   * Contacts
   * @default []
   */
  contacts?:
    | (
        | ({
            creation_mode: "";
          } & PatchInvolvedPartyParamsContactInNewParam)
        | ({
            creation_mode: "existing";
          } & PatchInvolvedPartyParamsContactInExistingParam)
        | ({
            creation_mode: "new";
          } & PatchInvolvedPartyParamsContactInNewParam)
      )[]
    | null;
  /** Involved Party */
  involved_party:
    | PatchInvolvedPartyParamsPatchGenericInvolvedPersonParams
    | PatchInvolvedPartyParamsPatchInvolvedGenericPropertyParams;
}

/** BodilyInjuryLossParams */
export interface PatchInvolvedPartyParamsBodilyInjuryLossParams {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Bodily Injuries
   * @default null
   */
  bodily_injuries?: PatchInvolvedPartyParamsBodilyInjuryModel[] | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Icd Codes
   * @default null
   */
  icd_codes?: PatchInvolvedPartyParamsICDCodeModel[] | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface PatchInvolvedPartyParamsBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/** ContactEmailModel */
export interface PatchInvolvedPartyParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface PatchInvolvedPartyParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface PatchInvolvedPartyParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: PatchInvolvedPartyParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: PatchInvolvedPartyParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface PatchInvolvedPartyParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ICDCodeModel */
export interface PatchInvolvedPartyParamsICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** LocationModel */
export interface PatchInvolvedPartyParamsLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PatchGenericInvolvedPersonParams */
export interface PatchInvolvedPartyParamsPatchGenericInvolvedPersonParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: PatchInvolvedPartyParamsBodilyInjuryLossParams | null;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is First Party
   * @default null
   */
  is_first_party?: boolean | null;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: PatchInvolvedPartyParamsPecuniaryLossDetailsParams | null;
  /** @default null */
  related_property_loss?: PatchInvolvedPartyParamsPropertyLossWithItemsParams | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /**
   * Type
   * @default null
   */
  type?: string | null;
}

/** PatchInvolvedGenericPropertyParams */
export interface PatchInvolvedPartyParamsPatchInvolvedGenericPropertyParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is First Party
   * @default null
   */
  is_first_party?: boolean | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: PatchInvolvedPartyParamsLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /** @default null */
  pecuniary_loss?: PatchInvolvedPartyParamsPecuniaryLossDetailsParams | null;
  /** @default null */
  property_damage?: PatchInvolvedPartyParamsPropertyDamageParams | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** @default null */
  related_property_loss?: PatchInvolvedPartyParamsPropertyLossWithItemsParams | null;
  /**
   * Type
   * @default null
   */
  type?: string | null;
}

/** PecuniaryLossDetailsParams */
export interface PatchInvolvedPartyParamsPecuniaryLossDetailsParams {
  /**
   * Losses
   * @default null
   */
  losses?: PatchInvolvedPartyParamsPecuniaryLossItemParams[] | null;
}

/** PecuniaryLossItemParams */
export interface PatchInvolvedPartyParamsPecuniaryLossItemParams {
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /**
   * Claimed Loss
   * @default null
   */
  claimed_loss?: string | null;
  /** Display Name */
  display_name: string;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** PropertyDamageParams */
export interface PatchInvolvedPartyParamsPropertyDamageParams {
  /**
   * Is Property Stolen
   * @default null
   */
  is_property_stolen?: boolean | null;
  /** @default null */
  location?: PatchInvolvedPartyParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Property Damages
   * @default null
   */
  property_damages?: string[] | null;
  /**
   * Property Damages Description
   * @default null
   */
  property_damages_description?: string | null;
}

/** PropertyItemIncomingModel */
export interface PatchInvolvedPartyParamsPropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyLossWithItemsParams */
export interface PatchInvolvedPartyParamsPropertyLossWithItemsParams {
  /**
   * Damages
   * @default null
   */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /**
   * Items
   * @default null
   */
  items?: PatchInvolvedPartyParamsPropertyItemIncomingModel[] | null;
  /** @default null */
  location?: PatchInvolvedPartyParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** PatchInvolvedPartyResponse */
export interface PatchInvolvedPartyResponse {
  /** Api Uid */
  api_uid: string;
}

/** PatchPriorityParams */
export interface PatchPriorityParams {
  /**
   * Claim Id
   * @default null
   */
  claim_id?: string | null;
  /** Priority */
  priority: "high" | "medium" | "low";
}

/** PatchReminderParams */
export interface PatchReminderParams {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Details
   * @default null
   */
  details?: string | null;
  /**
   * Due Date
   * @default null
   */
  due_date?: string | null;
  /**
   * Due Datetime
   * @default null
   */
  due_datetime?: string | null;
  /**
   * Is Restricted
   * @default null
   */
  is_restricted?: boolean | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * Recipient
   * @default null
   */
  recipient?:
    | (
        | ({
            type: "claim_handler";
          } & PatchReminderParamsReminderSimpleRecipientParam)
        | ({
            type: "exposure_handler";
          } & PatchReminderParamsReminderExposureRecipientParam)
        | ({
            type: "myself";
          } & PatchReminderParamsReminderSimpleRecipientParam)
        | ({
            type: "organization_unit_leader";
          } & PatchReminderParamsReminderOrganizationUnitLeaderRecipientParam)
        | ({
            type: "other_adjuster";
          } & PatchReminderParamsReminderOtherAdjusterRecipientParam)
      )
    | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** ReminderExposureRecipientParam */
export interface PatchReminderParamsReminderExposureRecipientParam {
  /** Exposure Id */
  exposure_id: number;
  /** Type */
  type: "exposure_handler";
}

/** ReminderOrganizationUnitLeaderRecipientParam */
export interface PatchReminderParamsReminderOrganizationUnitLeaderRecipientParam {
  /** Organization Unit Id */
  organization_unit_id: number;
  /** Type */
  type: "organization_unit_leader";
}

/** ReminderOtherAdjusterRecipientParam */
export interface PatchReminderParamsReminderOtherAdjusterRecipientParam {
  /** Other Adjuster Id */
  other_adjuster_id: string;
  /** Type */
  type: "other_adjuster";
}

/** ReminderSimpleRecipientParam */
export interface PatchReminderParamsReminderSimpleRecipientParam {
  /** Type */
  type: "claim_handler" | "myself";
}

/** PaymentJsonResponseWithApiUid */
export interface PaymentJsonResponseWithApiUid {
  /**
   * Amount
   * Payment amount
   * @min 0
   */
  amount: number;
  /**
   * Api Uid
   * Payment API UID
   */
  api_uid?: string | null;
  /**
   * Approved Date
   * Datetime when approved in ISO format
   * @default null
   */
  approved_date?: string | null;
  /**
   * Approving User Email
   * Email of approving user
   * @default null
   */
  approving_user_email?: string | null;
  /**
   * Approving User Name
   * Name of approving user
   * @default null
   */
  approving_user_name?: string | null;
  /**
   * Attached Documents
   * Attached document objects
   * @default null
   */
  attached_documents?: PaymentJsonResponseWithApiUidDocumentOutModel[] | null;
  /**
   * Cancelled Date
   * Datetime when payment was cancelled in ISO format
   * @default null
   */
  cancelled_date?: string | null;
  /**
   * Claim Number
   * Claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contacts
   * Array of contact details with ref_id mappings
   * @default null
   */
  contacts?: PaymentJsonResponseWithApiUidContactModel[] | null;
  /**
   * Coverage Display Name
   * Coverage type display name
   * @default null
   */
  coverage_display_name?: string | null;
  /**
   * Coverage Key
   * Coverage type key
   * @default null
   */
  coverage_key?: string | null;
  /**
   * Coverage Type
   * Legacy: use coverage_key instead
   * @default null
   */
  coverage_type?: string | null;
  /**
   * Currency
   * Currency
   * @default null
   */
  currency?: string | null;
  /**
   * Custom Fields
   * Custom fields array
   * @default null
   */
  custom_fields?: Record<string, any>[] | null;
  /**
   * Date Of Loss
   * Date of loss in ISO format
   * @default null
   */
  date_of_loss?: string | null;
  /**
   * Deductible Amount
   * Deductible amount if applied
   * @default null
   */
  deductible_amount?: number | null;
  /**
   * Exposure Number
   * Exposure number if applicable
   * @default null
   */
  exposure_number?: string | null;
  /**
   * External Payment Id
   * External payment ID
   * @default null
   */
  external_payment_id?: string | null;
  /**
   * Financial Status
   * Financial status
   * @default null
   */
  financial_status?: string | null;
  /**
   * Fund Account Number
   * Fund account the payment is sent from, resolved at approval
   * @default null
   */
  fund_account_number?: string | null;
  /**
   * Insured Contact Ref Id
   * Contact ref ID for insured party
   * @default null
   */
  insured_contact_ref_id?: string | null;
  /**
   * Invoice Number
   * Invoice number
   * @default null
   */
  invoice_number?: string | null;
  /**
   * Is 1099 Reportable
   * Whether payment is 1099 reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Deductible Applied
   * Whether deductible was applied to this payment
   * @default null
   */
  is_deductible_applied?: boolean | null;
  /**
   * Is Record Only
   * Whether this is record-only
   * @default null
   */
  is_record_only?: boolean | null;
  /**
   * Is Reissued Payment
   * Whether this is a reissued payment
   * @default null
   */
  is_reissued_payment?: boolean | null;
  /**
   * Is Vat Included
   * Whether VAT is included
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Last Modified Status Date
   * Last status modification datetime in ISO format
   * @default null
   */
  last_modified_status_date?: string | null;
  /**
   * Method-specific payment fields
   * @default null
   */
  method_specific_fields?: PaymentJsonResponseWithApiUidPaymentMethodSpecificFields | null;
  /**
   * Payable Type
   * Type of payable (indemnity/expenses)
   * @default null
   */
  payable_type?: string | null;
  /**
   * Payees
   * List of payees
   */
  payees: PaymentJsonResponseWithApiUidResponsePayeeModel[];
  /**
   * Payment Approval Status
   * Payment approval status
   * @default null
   */
  payment_approval_status?: string | null;
  /**
   * Payment Desc
   * Payment description
   * @default null
   */
  payment_desc?: string | null;
  /**
   * Payment Id
   * Payment ID
   * @default null
   */
  payment_id?: number | null;
  /**
   * Payment Method
   * Payment method
   */
  payment_method: string;
  /**
   * Payment Method Display Name
   * Display name for payment method
   * @default null
   */
  payment_method_display_name?: string | null;
  /**
   * Payment Other Type
   * Other payment type if applicable
   * @default null
   */
  payment_other_type?: string | null;
  /**
   * Payment Reason
   * Reason for payment
   * @default null
   */
  payment_reason?: string | null;
  /**
   * Payment Type
   * Type of payment
   * @default null
   */
  payment_type?: string | null;
  /**
   * Policy Number
   * Policy number
   * @default null
   */
  policy_number?: string | null;
  /** The payee the payment is made out to. Also included in the payees list. */
  primary_payee: PaymentJsonResponseWithApiUidResponsePayeeModel;
  /**
   * Reportable 1099 Indemnity Amount
   * 1099 reportable amount
   * @default null
   */
  reportable_1099_indemnity_amount?: number | null;
  /**
   * Request Date
   * Datetime when payment was requested in ISO format
   * @default null
   */
  request_date?: string | null;
  /**
   * Requesting User Email
   * Email of requesting user
   * @default null
   */
  requesting_user_email?: string | null;
  /**
   * Requesting User Name
   * Name of requesting user
   * @default null
   */
  requesting_user_name?: string | null;
  /**
   * Service End Date
   * Service end date
   * @default null
   */
  service_end_date?: string | null;
  /**
   * Service Start Date
   * Service start date
   * @default null
   */
  service_start_date?: string | null;
  /**
   * Sub Org Name
   * Legacy: use sub_organization_name instead
   * @default null
   */
  sub_org_name?: string | null;
  /**
   * Sub Organization External Id
   * Sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Sub Organization Name
   * Sub-organization name
   * @default null
   */
  sub_organization_name?: string | null;
  /**
   * Time Of Loss
   * Time of loss in HH:MM format
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Vat Amount
   * VAT amount
   * @default null
   */
  vat_amount?: number | null;
}

/** ContactEmailModel */
export interface PaymentJsonResponseWithApiUidContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface PaymentJsonResponseWithApiUidContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: PaymentJsonResponseWithApiUidContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: PaymentJsonResponseWithApiUidContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface PaymentJsonResponseWithApiUidContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** DocumentOutModel */
export interface PaymentJsonResponseWithApiUidDocumentOutModel {
  /**
   * Additional Fields
   * Values for the document type's configured additional fields, keyed by field id. Validated against the document type's configured_fields definition; mandatory fields must be present and field-type validation applies.
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** Api Uid */
  api_uid: string | null;
  /**
   * Datetime Uploaded
   * Timestamp (UTC, ISO-8601, with a Z suffix) at which the document was uploaded to the claim. This is the upload time shown in the Five Sigma UI, and is distinct from the business dates document_date and document_date_received. Null if not recorded.
   * @default null
   */
  datetime_uploaded?: string | null;
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Extension
   * @default null
   */
  document_extension?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Size
   * File size of the document in bytes. Null if size is not recorded.
   * @default null
   */
  document_size?: number | null;
  /** Document Type */
  document_type: string;
  /**
   * Document Url
   * @default null
   */
  document_url?: string | null;
  /**
   * Exposure Numbers
   * List of exposure numbers associated with the document
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Exposures
   * Deprecated: Use exposure_numbers instead
   * @deprecated
   * @default null
   */
  exposures?: string[] | null;
  /** External Id */
  external_id: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** LocationModel */
export interface PaymentJsonResponseWithApiUidLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PaymentMethodSpecificFields */
export interface PaymentJsonResponseWithApiUidPaymentMethodSpecificFields {
  /**
   * Account Details
   * The primary payee contact's account details captured when the payment request is created (later edits to the contact do not affect it). Null when the contact had no account details at request creation, and for payments created before the snapshot was introduced. Returned for custom payment methods only. Response-only: ignored on payment creation/update input - set it via the contacts API.
   * @default null
   */
  account_details?: string | null;
  /**
   * Account Number
   * @default null
   */
  account_number?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Check Date
   * @default null
   */
  check_date?: string | null;
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * Custom Display Name
   * @default null
   */
  custom_display_name?: string | null;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** @default null */
  mail_to_address?: PaymentJsonResponseWithApiUidLocationModel | null;
  /**
   * Mail To Contact Ref Id
   * @default null
   */
  mail_to_contact_ref_id?: string | null;
  /**
   * Mail To Name
   * @default null
   */
  mail_to_name?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * One Inc Check Issuance Type
   * @default null
   */
  one_inc_check_issuance_type?: string | null;
  /**
   * One Inc Claimspay Method
   * @default null
   */
  one_inc_claimspay_method?: string | null;
  /**
   * One Inc Claimspay Type
   * @default null
   */
  one_inc_claimspay_type?: string | null;
  /**
   * One Inc Home Loan Account Number
   * @default null
   */
  one_inc_home_loan_account_number?: string | null;
  /**
   * One Inc Is Approval Required
   * @default null
   */
  one_inc_is_approval_required?: boolean | null;
  /**
   * One Inc Lienholder Loan Account Number
   * @default null
   */
  one_inc_lienholder_loan_account_number?: string | null;
  /**
   * Pay To Line
   * @default null
   */
  pay_to_line?: string | null;
  /**
   * Payment Reference
   * @default null
   */
  payment_reference?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Sort Code
   * @default null
   */
  sort_code?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Us Bank Account Number
   * @default null
   */
  us_bank_account_number?: string | null;
  /**
   * Us Bank Name
   * @default null
   */
  us_bank_name?: string | null;
  /**
   * Us Routing Number
   * @default null
   */
  us_routing_number?: string | null;
}

/** ResponsePayeeModel */
export interface PaymentJsonResponseWithApiUidResponsePayeeModel {
  /** Contact Ref Id */
  contact_ref_id: number;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /** Is Primary */
  is_primary: boolean;
  /**
   * Name In Payment
   * @default null
   */
  name_in_payment?: string | null;
  /**
   * Payee Type
   * @default null
   */
  payee_type?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
}

/**
 * PaymentMethodConfigRequest
 * Request body for creating or updating a payment-method configuration.
 */
export interface PaymentMethodConfigRequest {
  /**
   * Is Disabled
   * @default false
   */
  is_disabled?: boolean;
  /** Method Configuration */
  method_configuration?: Record<string, any>;
  /**
   * Payment Method Display Name
   * @default null
   */
  payment_method_display_name?: string | null;
  /**
   * Payment Method External Id
   * @default null
   */
  payment_method_external_id?: string | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** PaymentTypesQueryParams */
export interface PaymentTypesQueryParams {
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/** PaymentTypesResponse */
export interface PaymentTypesResponse {
  /**
   * Records
   * List of payment method type records
   */
  records: PaymentTypesResponsePaymentMethodTypes[];
}

/** PaymentMethodTypes */
export interface PaymentTypesResponsePaymentMethodTypes {
  /**
   * Payable Type
   * Payable type (expenses or indemnity)
   */
  payable_type: string;
  /**
   * Payment Method
   * Payment method key
   */
  payment_method: string;
  /**
   * Payment Method External Id
   * External payment method identifier
   * @default null
   */
  payment_method_external_id?: string | null;
  /**
   * Payment Types
   * Available payment types
   */
  payment_types: PaymentTypesResponsePaymentTypeItem[];
  /**
   * Sub Organization External Id
   * Sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/** PaymentTypeItem */
export interface PaymentTypesResponsePaymentTypeItem {
  /**
   * Payment Type Description
   * Human-readable description of the payment type
   */
  payment_type_description: string;
  /**
   * Payment Type Key
   * The payment type key used in payment creation
   */
  payment_type_key: string;
}

/**
 * PaymentUpdateRequest
 * Bulk payment update request schema.
 */
export interface PaymentUpdateRequest {
  /**
   * Payments
   * List of payments to update (maximum 100)
   * @maxItems 100
   */
  payments: PaymentUpdateRequestPaymentUpdateItem[];
}

/**
 * CustomFieldModel
 * Custom field for payment updates.
 */
export interface PaymentUpdateRequestCustomFieldModel {
  /**
   * Display Name
   * Human-readable display name for the custom field
   */
  display_name: string;
  /**
   * Id
   * Custom field ID
   */
  id: string;
  /**
   * Value
   * Custom field value (must be string)
   */
  value: string;
}

/** LocationModel */
export interface PaymentUpdateRequestLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PaymentMethodSpecificFields */
export interface PaymentUpdateRequestPaymentMethodSpecificFields {
  /**
   * Account Details
   * The primary payee contact's account details captured when the payment request is created (later edits to the contact do not affect it). Null when the contact had no account details at request creation, and for payments created before the snapshot was introduced. Returned for custom payment methods only. Response-only: ignored on payment creation/update input - set it via the contacts API.
   * @default null
   */
  account_details?: string | null;
  /**
   * Account Number
   * @default null
   */
  account_number?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Check Date
   * @default null
   */
  check_date?: string | null;
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * Custom Display Name
   * @default null
   */
  custom_display_name?: string | null;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** @default null */
  mail_to_address?: PaymentUpdateRequestLocationModel | null;
  /**
   * Mail To Contact Ref Id
   * @default null
   */
  mail_to_contact_ref_id?: string | null;
  /**
   * Mail To Name
   * @default null
   */
  mail_to_name?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * One Inc Check Issuance Type
   * @default null
   */
  one_inc_check_issuance_type?: string | null;
  /**
   * One Inc Claimspay Method
   * @default null
   */
  one_inc_claimspay_method?: string | null;
  /**
   * One Inc Claimspay Type
   * @default null
   */
  one_inc_claimspay_type?: string | null;
  /**
   * One Inc Home Loan Account Number
   * @default null
   */
  one_inc_home_loan_account_number?: string | null;
  /**
   * One Inc Is Approval Required
   * @default null
   */
  one_inc_is_approval_required?: boolean | null;
  /**
   * One Inc Lienholder Loan Account Number
   * @default null
   */
  one_inc_lienholder_loan_account_number?: string | null;
  /**
   * Pay To Line
   * @default null
   */
  pay_to_line?: string | null;
  /**
   * Payment Reference
   * @default null
   */
  payment_reference?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Sort Code
   * @default null
   */
  sort_code?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Us Bank Account Number
   * @default null
   */
  us_bank_account_number?: string | null;
  /**
   * Us Bank Name
   * @default null
   */
  us_bank_name?: string | null;
  /**
   * Us Routing Number
   * @default null
   */
  us_routing_number?: string | null;
}

/**
 * PaymentUpdateItem
 * Individual payment update data for bulk updates.
 */
export interface PaymentUpdateRequestPaymentUpdateItem {
  /**
   * Api Uid
   * Payment API UID
   * @default null
   */
  api_uid?: string | null;
  /**
   * Custom Fields
   * Custom fields to update
   * @default null
   */
  custom_fields?: PaymentUpdateRequestCustomFieldModel[] | null;
  /**
   * External Payment Id
   * External payment ID
   * @default null
   */
  external_payment_id?: string | null;
  /**
   * Financial Status
   * New financial status
   * @default null
   */
  financial_status?: string | null;
  /**
   * Method-specific payment fields
   * @default null
   */
  method_specific_fields?: PaymentUpdateRequestPaymentMethodSpecificFields | null;
  /**
   * Payment Id
   * Payment ID to update
   */
  payment_id: string;
}

/** PaymentUpdateResultWithApiUidList */
export type PaymentUpdateResultWithApiUidList =
  PaymentUpdateResultWithApiUidListPaymentUpdateResultWithApiUid[];

/** PaymentUpdateResultWithApiUid */
export interface PaymentUpdateResultWithApiUidListPaymentUpdateResultWithApiUid {
  /**
   * Api Uid
   * Payment API UID
   */
  api_uid: null | string;
  /**
   * Errors
   * Error message if update failed
   * @default null
   */
  errors?: string | null;
  /**
   * Payment Id
   * Payment ID that was updated
   */
  payment_id: string;
  /**
   * Success
   * Whether the update was successful
   */
  success: boolean;
}

/** PaymentsConfigurationParams */
export interface PaymentsConfigurationParams {
  /**
   * Additional Approving User Ids
   * @default null
   */
  additional_approving_user_ids?: any[] | null;
  /**
   * Additional Submitting User Ids
   * @default null
   */
  additional_submitting_user_ids?: any[] | null;
  /**
   * Adjust Reserve After Payment Cancellation
   * @default null
   */
  adjust_reserve_after_payment_cancellation?: boolean | null;
  /**
   * Adjust Reserve Includes Deductible
   * @default null
   */
  adjust_reserve_includes_deductible?: boolean | null;
  /**
   * Allow Claim Multi Currency
   * @default null
   */
  allow_claim_multi_currency?: boolean | null;
  /**
   * Allow Indemnity Payments Only For Existing Property Owner
   * @default null
   */
  allow_indemnity_payments_only_for_existing_property_owner?: boolean | null;
  /**
   * Allow Multiple Pending Payment Requests
   * @default null
   */
  allow_multiple_pending_payment_requests?: boolean | null;
  /**
   * Amounts Basis
   * @default null
   */
  amounts_basis?: "gross" | "net" | null;
  /**
   * Cap Recoveries At Total Paid
   * @default null
   */
  cap_recoveries_at_total_paid?: "off" | "warn" | "block" | null;
  /**
   * Contact Au Tfn Mandatory Coverages
   * @default null
   */
  contact_au_tfn_mandatory_coverages?: string[] | null;
  /**
   * Disable Adjuster Modifying Self Payment Limits
   * @default null
   */
  disable_adjuster_modifying_self_payment_limits?: boolean | null;
  /**
   * Display Net Amounts
   * @default null
   */
  display_net_amounts?: boolean | null;
  /**
   * Duplicate Payments Action
   * @default null
   */
  duplicate_payments_action?: string | null;
  /**
   * Duplicate Payments Level Of Verification
   * @default null
   */
  duplicate_payments_level_of_verification?: string | null;
  /**
   * Duplicate Payments Verification Initialized
   * @default null
   */
  duplicate_payments_verification_initialized?: boolean | null;
  /**
   * Enable 1099 Fields
   * @default null
   */
  enable_1099_fields?: boolean | null;
  /**
   * Enable Approval Screen
   * @default null
   */
  enable_approval_screen?: boolean | null;
  /**
   * Enable Duplicate Payments Verification
   * @default null
   */
  enable_duplicate_payments_verification?: boolean | null;
  /**
   * Enable Paying Expenses If Coverage Issue Exists
   * @default null
   */
  enable_paying_expenses_if_coverage_issue_exists?: boolean | null;
  /**
   * Enable Paying Expenses If Exposure Is Closed
   * @default null
   */
  enable_paying_expenses_if_exposure_is_closed?: boolean | null;
  /**
   * Enable Paying Indemnity If Exposure Is Closed
   * @default null
   */
  enable_paying_indemnity_if_exposure_is_closed?: boolean | null;
  /**
   * Enable Sanctions Io Integration
   * @default null
   */
  enable_sanctions_io_integration?: boolean | null;
  /**
   * Enable Split General Recovery
   * @default null
   */
  enable_split_general_recovery?: boolean | null;
  /**
   * Enable Submission Screen
   * @default null
   */
  enable_submission_screen?: boolean | null;
  /**
   * Enable Trusted Payee Payments
   * @default null
   */
  enable_trusted_payee_payments?: boolean | null;
  /**
   * Enable Uk Bank Account Validation
   * @default null
   */
  enable_uk_bank_account_validation?: boolean | null;
  /**
   * Expenses Limit For Closed Exposure
   * @default null
   */
  expenses_limit_for_closed_exposure?: number | null;
  /**
   * Expenses Sub Reserves Config
   * @default null
   */
  expenses_sub_reserves_config?: Record<string, any> | null;
  /**
   * General Recoveries Configuration
   * @default null
   */
  general_recoveries_configuration?: Record<string, any> | null;
  /**
   * Include Vat In Finances Summary
   * @default null
   */
  include_vat_in_finances_summary?: boolean | null;
  /**
   * Include Vat In Payment Screen
   * @default null
   */
  include_vat_in_payment_screen?: boolean | null;
  /**
   * Indemnity Limit For Closed Exposure
   * @default null
   */
  indemnity_limit_for_closed_exposure?: number | null;
  /**
   * Is Anticipated Amount Included In Recoveries Calc
   * @default null
   */
  is_anticipated_amount_included_in_recoveries_calc?: boolean | null;
  /**
   * Is Expenses Limit For Closed Exposure Enabled
   * @default null
   */
  is_expenses_limit_for_closed_exposure_enabled?: boolean | null;
  /**
   * Is Expenses Sub Reserves Config Enabled
   * @default null
   */
  is_expenses_sub_reserves_config_enabled?: boolean | null;
  /**
   * Is General Recoveries Enabled
   * @default null
   */
  is_general_recoveries_enabled?: boolean | null;
  /**
   * Is Indemnity Limit For Closed Exposure Enabled
   * @default null
   */
  is_indemnity_limit_for_closed_exposure_enabled?: boolean | null;
  /**
   * Is Multiple Sub Reserve Payments Enabled
   * @default null
   */
  is_multiple_sub_reserve_payments_enabled?: boolean | null;
  /**
   * Is Org Level Configuration
   * @default null
   */
  is_org_level_configuration?: boolean | null;
  /**
   * Is Payment Method Auto Fill Mail To From Payee
   * @default null
   */
  is_payment_method_auto_fill_mail_to_from_payee?: boolean | null;
  /**
   * Is Prefill Reserve Amounts Capability Enabled
   * @default null
   */
  is_prefill_reserve_amounts_capability_enabled?: boolean | null;
  /**
   * Is Recoveries Included In Incurred Calc
   * @default null
   */
  is_recoveries_included_in_incurred_calc?: boolean | null;
  /**
   * Is Split Routing Enabled
   * @default null
   */
  is_split_routing_enabled?: boolean | null;
  /**
   * Is Sub Reserves Enabled
   * @default null
   */
  is_sub_reserves_enabled?: boolean | null;
  /** @default null */
  multi_currency_configuration?: PaymentsConfigurationParamsMultiCurrencyConfiguration | null;
  /**
   * Ofac Fuzzy Match Enabled
   * @default null
   */
  ofac_fuzzy_match_enabled?: boolean | null;
  /**
   * Ofac Fuzzy Match Score
   * @default null
   */
  ofac_fuzzy_match_score?: number | null;
  /**
   * Ofac Is Send Address Fields Enabled
   * @default null
   */
  ofac_is_send_address_fields_enabled?: boolean | null;
  /**
   * Prefill Indemnity Payee With Claimant
   * @default null
   */
  prefill_indemnity_payee_with_claimant?: boolean | null;
  /**
   * Reduce Reserves By Net Paid
   * @default null
   */
  reduce_reserves_by_net_paid?: boolean | null;
  /**
   * Require Approval For Every Payment
   * @default null
   */
  require_approval_for_every_payment?: boolean | null;
  /**
   * Require Tin For Indemnity Payees
   * @default null
   */
  require_tin_for_indemnity_payees?: boolean | null;
  /**
   * Require Verification For Contact Au Tfn Edit
   * @default null
   */
  require_verification_for_contact_au_tfn_edit?: boolean | null;
  /**
   * Require Verification For Contact Finance Edit
   * @default null
   */
  require_verification_for_contact_finance_edit?: boolean | null;
  /**
   * Sanctions Io Api Key
   * @default null
   */
  sanctions_io_api_key?: string | null;
  /**
   * Sanctions Io Data Sources
   * @default null
   */
  sanctions_io_data_sources?: string[] | null;
  /**
   * Sanctions Io Include Address
   * @default null
   */
  sanctions_io_include_address?: boolean | null;
  /**
   * Sanctions Io Min Score
   * @default null
   */
  sanctions_io_min_score?: number | null;
  /**
   * Should Disable Payment Exceeding Reserve
   * @default null
   */
  should_disable_payment_exceeding_reserve?: boolean | null;
  /**
   * Skip Approval For Record Only Payments
   * @default null
   */
  skip_approval_for_record_only_payments?: boolean | null;
}

/**
 * MultiCurrencyConfiguration
 * Configuration model for multi-currency payment settings.
 */
export interface PaymentsConfigurationParamsMultiCurrencyConfiguration {
  /**
   * Organization Currencies
   * List of allowed currency codes for the organization
   * @default null
   */
  organization_currencies?:
    | (
        | "AED"
        | "AFN"
        | "ALL"
        | "AMD"
        | "AOA"
        | "ARS"
        | "AUD"
        | "AZN"
        | "BAM"
        | "BBD"
        | "BDT"
        | "BGN"
        | "BHD"
        | "BIF"
        | "BND"
        | "BOB"
        | "BRL"
        | "BSD"
        | "BTN"
        | "BWP"
        | "BYN"
        | "BZD"
        | "CAD"
        | "CDF"
        | "CHF"
        | "CLP"
        | "CNY"
        | "COP"
        | "CRC"
        | "CUP"
        | "CVE"
        | "CZK"
        | "DJF"
        | "DKK"
        | "DOP"
        | "DZD"
        | "EGP"
        | "ERN"
        | "ETB"
        | "EUR"
        | "FJD"
        | "GBP"
        | "GEL"
        | "GHS"
        | "GMD"
        | "GNF"
        | "GTQ"
        | "GYD"
        | "HKD"
        | "HNL"
        | "HRK"
        | "HTG"
        | "HUF"
        | "IDR"
        | "ILS"
        | "INR"
        | "IQD"
        | "IRR"
        | "ISK"
        | "JMD"
        | "JOD"
        | "JPY"
        | "KES"
        | "KGS"
        | "KHR"
        | "KMF"
        | "KRW"
        | "KWD"
        | "KZT"
        | "LAK"
        | "LBP"
        | "LKR"
        | "LRD"
        | "LSL"
        | "LYD"
        | "MAD"
        | "MDL"
        | "MGA"
        | "MKD"
        | "MMK"
        | "MNT"
        | "MUR"
        | "MVR"
        | "MWK"
        | "MXN"
        | "MYR"
        | "MZN"
        | "NAD"
        | "NGN"
        | "NIO"
        | "NOK"
        | "NPR"
        | "NZD"
        | "OMR"
        | "PAB"
        | "PEN"
        | "PGK"
        | "PHP"
        | "PKR"
        | "PLN"
        | "PYG"
        | "QAR"
        | "RON"
        | "RSD"
        | "RWF"
        | "SAR"
        | "SBD"
        | "SCR"
        | "SDG"
        | "SEK"
        | "SGD"
        | "SLL"
        | "SOS"
        | "SRD"
        | "STP"
        | "SYP"
        | "SZL"
        | "THB"
        | "TJS"
        | "TMT"
        | "TND"
        | "TOP"
        | "TRY"
        | "TTD"
        | "TWD"
        | "TZS"
        | "UAH"
        | "UGX"
        | "USD"
        | "UYU"
        | "UZS"
        | "VES"
        | "VND"
        | "VUV"
        | "WST"
        | "XAF"
        | "XAG"
        | "XAU"
        | "XOF"
        | "XPD"
        | "XPT"
        | "ZAR"
        | "ZMW"
        | "ZWL"
      )[]
    | null;
  /**
   * Sub Organizations
   * List of sub-organization currency configurations
   * @default null
   */
  sub_organizations?:
    | PaymentsConfigurationParamsSubOrganizationCurrencyConfig[]
    | null;
}

/**
 * SubOrganizationCurrencyConfig
 * Configuration for a specific sub-organization's currency settings.
 */
export interface PaymentsConfigurationParamsSubOrganizationCurrencyConfig {
  /**
   * Currencies
   * List of allowed currency codes for this sub-organization
   */
  currencies: (
    | "AED"
    | "AFN"
    | "ALL"
    | "AMD"
    | "AOA"
    | "ARS"
    | "AUD"
    | "AZN"
    | "BAM"
    | "BBD"
    | "BDT"
    | "BGN"
    | "BHD"
    | "BIF"
    | "BND"
    | "BOB"
    | "BRL"
    | "BSD"
    | "BTN"
    | "BWP"
    | "BYN"
    | "BZD"
    | "CAD"
    | "CDF"
    | "CHF"
    | "CLP"
    | "CNY"
    | "COP"
    | "CRC"
    | "CUP"
    | "CVE"
    | "CZK"
    | "DJF"
    | "DKK"
    | "DOP"
    | "DZD"
    | "EGP"
    | "ERN"
    | "ETB"
    | "EUR"
    | "FJD"
    | "GBP"
    | "GEL"
    | "GHS"
    | "GMD"
    | "GNF"
    | "GTQ"
    | "GYD"
    | "HKD"
    | "HNL"
    | "HRK"
    | "HTG"
    | "HUF"
    | "IDR"
    | "ILS"
    | "INR"
    | "IQD"
    | "IRR"
    | "ISK"
    | "JMD"
    | "JOD"
    | "JPY"
    | "KES"
    | "KGS"
    | "KHR"
    | "KMF"
    | "KRW"
    | "KWD"
    | "KZT"
    | "LAK"
    | "LBP"
    | "LKR"
    | "LRD"
    | "LSL"
    | "LYD"
    | "MAD"
    | "MDL"
    | "MGA"
    | "MKD"
    | "MMK"
    | "MNT"
    | "MUR"
    | "MVR"
    | "MWK"
    | "MXN"
    | "MYR"
    | "MZN"
    | "NAD"
    | "NGN"
    | "NIO"
    | "NOK"
    | "NPR"
    | "NZD"
    | "OMR"
    | "PAB"
    | "PEN"
    | "PGK"
    | "PHP"
    | "PKR"
    | "PLN"
    | "PYG"
    | "QAR"
    | "RON"
    | "RSD"
    | "RWF"
    | "SAR"
    | "SBD"
    | "SCR"
    | "SDG"
    | "SEK"
    | "SGD"
    | "SLL"
    | "SOS"
    | "SRD"
    | "STP"
    | "SYP"
    | "SZL"
    | "THB"
    | "TJS"
    | "TMT"
    | "TND"
    | "TOP"
    | "TRY"
    | "TTD"
    | "TWD"
    | "TZS"
    | "UAH"
    | "UGX"
    | "USD"
    | "UYU"
    | "UZS"
    | "VES"
    | "VND"
    | "VUV"
    | "WST"
    | "XAF"
    | "XAG"
    | "XAU"
    | "XOF"
    | "XPD"
    | "XPT"
    | "ZAR"
    | "ZMW"
    | "ZWL"
  )[];
  /**
   * Enabled
   * Whether multi-currency is enabled for this sub-organization
   */
  enabled: boolean;
  /**
   * Sub Organization Id
   * ID of the sub-organization
   */
  sub_organization_id: number;
}

/** PaymentsConfigurationResponse */
export interface PaymentsConfigurationResponse {
  /**
   * Additional Approving User Ids
   * @default null
   */
  additional_approving_user_ids?: any[] | null;
  /**
   * Additional Submitting User Ids
   * @default null
   */
  additional_submitting_user_ids?: any[] | null;
  /**
   * Adjust Reserve After Payment Cancellation
   * @default null
   */
  adjust_reserve_after_payment_cancellation?: boolean | null;
  /**
   * Adjust Reserve Includes Deductible
   * @default null
   */
  adjust_reserve_includes_deductible?: boolean | null;
  /**
   * Allow Claim Multi Currency
   * @default null
   */
  allow_claim_multi_currency?: boolean | null;
  /**
   * Allow Indemnity Payments Only For Existing Property Owner
   * @default null
   */
  allow_indemnity_payments_only_for_existing_property_owner?: boolean | null;
  /**
   * Allow Multiple Pending Payment Requests
   * @default null
   */
  allow_multiple_pending_payment_requests?: boolean | null;
  /**
   * Amounts Basis
   * @default null
   */
  amounts_basis?: "gross" | "net" | null;
  /**
   * Cap Recoveries At Total Paid
   * @default null
   */
  cap_recoveries_at_total_paid?: "off" | "warn" | "block" | null;
  /**
   * Contact Au Tfn Mandatory Coverages
   * @default null
   */
  contact_au_tfn_mandatory_coverages?: string[] | null;
  /**
   * Disable Adjuster Modifying Self Payment Limits
   * @default null
   */
  disable_adjuster_modifying_self_payment_limits?: boolean | null;
  /**
   * Display Net Amounts
   * @default null
   */
  display_net_amounts?: boolean | null;
  /**
   * Duplicate Payments Action
   * @default null
   */
  duplicate_payments_action?: string | null;
  /**
   * Duplicate Payments Level Of Verification
   * @default null
   */
  duplicate_payments_level_of_verification?: string | null;
  /**
   * Duplicate Payments Verification Initialized
   * @default null
   */
  duplicate_payments_verification_initialized?: boolean | null;
  /**
   * Enable 1099 Fields
   * @default null
   */
  enable_1099_fields?: boolean | null;
  /**
   * Enable Approval Screen
   * @default null
   */
  enable_approval_screen?: boolean | null;
  /**
   * Enable Duplicate Payments Verification
   * @default null
   */
  enable_duplicate_payments_verification?: boolean | null;
  /**
   * Enable Paying Expenses If Coverage Issue Exists
   * @default null
   */
  enable_paying_expenses_if_coverage_issue_exists?: boolean | null;
  /**
   * Enable Paying Expenses If Exposure Is Closed
   * @default null
   */
  enable_paying_expenses_if_exposure_is_closed?: boolean | null;
  /**
   * Enable Paying Indemnity If Exposure Is Closed
   * @default null
   */
  enable_paying_indemnity_if_exposure_is_closed?: boolean | null;
  /**
   * Enable Sanctions Io Integration
   * @default null
   */
  enable_sanctions_io_integration?: boolean | null;
  /**
   * Enable Split General Recovery
   * @default null
   */
  enable_split_general_recovery?: boolean | null;
  /**
   * Enable Submission Screen
   * @default null
   */
  enable_submission_screen?: boolean | null;
  /**
   * Enable Trusted Payee Payments
   * @default null
   */
  enable_trusted_payee_payments?: boolean | null;
  /**
   * Enable Uk Bank Account Validation
   * @default null
   */
  enable_uk_bank_account_validation?: boolean | null;
  /**
   * Expenses Limit For Closed Exposure
   * @default null
   */
  expenses_limit_for_closed_exposure?: number | null;
  /**
   * Expenses Sub Reserves Config
   * @default null
   */
  expenses_sub_reserves_config?: Record<string, any> | null;
  /**
   * General Recoveries Configuration
   * @default null
   */
  general_recoveries_configuration?: Record<string, any> | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Include Vat In Finances Summary
   * @default null
   */
  include_vat_in_finances_summary?: boolean | null;
  /**
   * Include Vat In Payment Screen
   * @default null
   */
  include_vat_in_payment_screen?: boolean | null;
  /**
   * Indemnity Limit For Closed Exposure
   * @default null
   */
  indemnity_limit_for_closed_exposure?: number | null;
  /**
   * Is Anticipated Amount Included In Recoveries Calc
   * @default null
   */
  is_anticipated_amount_included_in_recoveries_calc?: boolean | null;
  /**
   * Is Expenses Limit For Closed Exposure Enabled
   * @default null
   */
  is_expenses_limit_for_closed_exposure_enabled?: boolean | null;
  /**
   * Is Expenses Sub Reserves Config Enabled
   * @default null
   */
  is_expenses_sub_reserves_config_enabled?: boolean | null;
  /**
   * Is General Recoveries Enabled
   * @default null
   */
  is_general_recoveries_enabled?: boolean | null;
  /**
   * Is Indemnity Limit For Closed Exposure Enabled
   * @default null
   */
  is_indemnity_limit_for_closed_exposure_enabled?: boolean | null;
  /**
   * Is Multiple Sub Reserve Payments Enabled
   * @default null
   */
  is_multiple_sub_reserve_payments_enabled?: boolean | null;
  /**
   * Is Org Level Configuration
   * @default null
   */
  is_org_level_configuration?: boolean | null;
  /**
   * Is Payment Method Auto Fill Mail To From Payee
   * @default null
   */
  is_payment_method_auto_fill_mail_to_from_payee?: boolean | null;
  /**
   * Is Prefill Reserve Amounts Capability Enabled
   * @default null
   */
  is_prefill_reserve_amounts_capability_enabled?: boolean | null;
  /**
   * Is Recoveries Included In Incurred Calc
   * @default null
   */
  is_recoveries_included_in_incurred_calc?: boolean | null;
  /**
   * Is Split Routing Enabled
   * @default null
   */
  is_split_routing_enabled?: boolean | null;
  /**
   * Is Sub Reserves Enabled
   * @default null
   */
  is_sub_reserves_enabled?: boolean | null;
  /** @default null */
  multi_currency_configuration?: PaymentsConfigurationResponseMultiCurrencyConfiguration | null;
  /**
   * Ofac Fuzzy Match Enabled
   * @default null
   */
  ofac_fuzzy_match_enabled?: boolean | null;
  /**
   * Ofac Fuzzy Match Score
   * @default null
   */
  ofac_fuzzy_match_score?: number | null;
  /**
   * Ofac Is Send Address Fields Enabled
   * @default null
   */
  ofac_is_send_address_fields_enabled?: boolean | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Payment Method Configurations
   * @default null
   */
  payment_method_configurations?:
    | PaymentsConfigurationResponsePaymentMethodConfigurationResponse[]
    | null;
  /**
   * Prefill Indemnity Payee With Claimant
   * @default null
   */
  prefill_indemnity_payee_with_claimant?: boolean | null;
  /**
   * Reduce Reserves By Net Paid
   * @default null
   */
  reduce_reserves_by_net_paid?: boolean | null;
  /**
   * Require Approval For Every Payment
   * @default null
   */
  require_approval_for_every_payment?: boolean | null;
  /**
   * Require Tin For Indemnity Payees
   * @default null
   */
  require_tin_for_indemnity_payees?: boolean | null;
  /**
   * Require Verification For Contact Au Tfn Edit
   * @default null
   */
  require_verification_for_contact_au_tfn_edit?: boolean | null;
  /**
   * Require Verification For Contact Finance Edit
   * @default null
   */
  require_verification_for_contact_finance_edit?: boolean | null;
  /**
   * Sanctions Io Api Key Output
   * @default null
   */
  sanctions_io_api_key_output?: string | null;
  /**
   * Sanctions Io Data Sources
   * @default null
   */
  sanctions_io_data_sources?: string[] | null;
  /**
   * Sanctions Io Include Address
   * @default null
   */
  sanctions_io_include_address?: boolean | null;
  /**
   * Sanctions Io Min Score
   * @default null
   */
  sanctions_io_min_score?: number | null;
  /**
   * Should Disable Payment Exceeding Reserve
   * @default null
   */
  should_disable_payment_exceeding_reserve?: boolean | null;
  /**
   * Skip Approval For Record Only Payments
   * @default null
   */
  skip_approval_for_record_only_payments?: boolean | null;
}

/**
 * MultiCurrencyConfiguration
 * Configuration model for multi-currency payment settings.
 */
export interface PaymentsConfigurationResponseMultiCurrencyConfiguration {
  /**
   * Organization Currencies
   * List of allowed currency codes for the organization
   * @default null
   */
  organization_currencies?:
    | (
        | "AED"
        | "AFN"
        | "ALL"
        | "AMD"
        | "AOA"
        | "ARS"
        | "AUD"
        | "AZN"
        | "BAM"
        | "BBD"
        | "BDT"
        | "BGN"
        | "BHD"
        | "BIF"
        | "BND"
        | "BOB"
        | "BRL"
        | "BSD"
        | "BTN"
        | "BWP"
        | "BYN"
        | "BZD"
        | "CAD"
        | "CDF"
        | "CHF"
        | "CLP"
        | "CNY"
        | "COP"
        | "CRC"
        | "CUP"
        | "CVE"
        | "CZK"
        | "DJF"
        | "DKK"
        | "DOP"
        | "DZD"
        | "EGP"
        | "ERN"
        | "ETB"
        | "EUR"
        | "FJD"
        | "GBP"
        | "GEL"
        | "GHS"
        | "GMD"
        | "GNF"
        | "GTQ"
        | "GYD"
        | "HKD"
        | "HNL"
        | "HRK"
        | "HTG"
        | "HUF"
        | "IDR"
        | "ILS"
        | "INR"
        | "IQD"
        | "IRR"
        | "ISK"
        | "JMD"
        | "JOD"
        | "JPY"
        | "KES"
        | "KGS"
        | "KHR"
        | "KMF"
        | "KRW"
        | "KWD"
        | "KZT"
        | "LAK"
        | "LBP"
        | "LKR"
        | "LRD"
        | "LSL"
        | "LYD"
        | "MAD"
        | "MDL"
        | "MGA"
        | "MKD"
        | "MMK"
        | "MNT"
        | "MUR"
        | "MVR"
        | "MWK"
        | "MXN"
        | "MYR"
        | "MZN"
        | "NAD"
        | "NGN"
        | "NIO"
        | "NOK"
        | "NPR"
        | "NZD"
        | "OMR"
        | "PAB"
        | "PEN"
        | "PGK"
        | "PHP"
        | "PKR"
        | "PLN"
        | "PYG"
        | "QAR"
        | "RON"
        | "RSD"
        | "RWF"
        | "SAR"
        | "SBD"
        | "SCR"
        | "SDG"
        | "SEK"
        | "SGD"
        | "SLL"
        | "SOS"
        | "SRD"
        | "STP"
        | "SYP"
        | "SZL"
        | "THB"
        | "TJS"
        | "TMT"
        | "TND"
        | "TOP"
        | "TRY"
        | "TTD"
        | "TWD"
        | "TZS"
        | "UAH"
        | "UGX"
        | "USD"
        | "UYU"
        | "UZS"
        | "VES"
        | "VND"
        | "VUV"
        | "WST"
        | "XAF"
        | "XAG"
        | "XAU"
        | "XOF"
        | "XPD"
        | "XPT"
        | "ZAR"
        | "ZMW"
        | "ZWL"
      )[]
    | null;
  /**
   * Sub Organizations
   * List of sub-organization currency configurations
   * @default null
   */
  sub_organizations?:
    | PaymentsConfigurationResponseSubOrganizationCurrencyConfig[]
    | null;
}

/** PaymentMethodConfigurationResponse */
export interface PaymentsConfigurationResponsePaymentMethodConfigurationResponse {
  /** Id */
  id: number;
  /** Is Disabled */
  is_disabled: boolean;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /** Method Configuration */
  method_configuration: Record<string, any>;
  /** Organization Id */
  organization_id: number;
  /** Payment Method */
  payment_method: string;
  /**
   * Payment Method Display Name
   * @default null
   */
  payment_method_display_name?: string | null;
  /**
   * Payment Method External Id
   * @default null
   */
  payment_method_external_id?: string | null;
  /** Payments Configuration Id */
  payments_configuration_id: number;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * SubOrganizationCurrencyConfig
 * Configuration for a specific sub-organization's currency settings.
 */
export interface PaymentsConfigurationResponseSubOrganizationCurrencyConfig {
  /**
   * Currencies
   * List of allowed currency codes for this sub-organization
   */
  currencies: (
    | "AED"
    | "AFN"
    | "ALL"
    | "AMD"
    | "AOA"
    | "ARS"
    | "AUD"
    | "AZN"
    | "BAM"
    | "BBD"
    | "BDT"
    | "BGN"
    | "BHD"
    | "BIF"
    | "BND"
    | "BOB"
    | "BRL"
    | "BSD"
    | "BTN"
    | "BWP"
    | "BYN"
    | "BZD"
    | "CAD"
    | "CDF"
    | "CHF"
    | "CLP"
    | "CNY"
    | "COP"
    | "CRC"
    | "CUP"
    | "CVE"
    | "CZK"
    | "DJF"
    | "DKK"
    | "DOP"
    | "DZD"
    | "EGP"
    | "ERN"
    | "ETB"
    | "EUR"
    | "FJD"
    | "GBP"
    | "GEL"
    | "GHS"
    | "GMD"
    | "GNF"
    | "GTQ"
    | "GYD"
    | "HKD"
    | "HNL"
    | "HRK"
    | "HTG"
    | "HUF"
    | "IDR"
    | "ILS"
    | "INR"
    | "IQD"
    | "IRR"
    | "ISK"
    | "JMD"
    | "JOD"
    | "JPY"
    | "KES"
    | "KGS"
    | "KHR"
    | "KMF"
    | "KRW"
    | "KWD"
    | "KZT"
    | "LAK"
    | "LBP"
    | "LKR"
    | "LRD"
    | "LSL"
    | "LYD"
    | "MAD"
    | "MDL"
    | "MGA"
    | "MKD"
    | "MMK"
    | "MNT"
    | "MUR"
    | "MVR"
    | "MWK"
    | "MXN"
    | "MYR"
    | "MZN"
    | "NAD"
    | "NGN"
    | "NIO"
    | "NOK"
    | "NPR"
    | "NZD"
    | "OMR"
    | "PAB"
    | "PEN"
    | "PGK"
    | "PHP"
    | "PKR"
    | "PLN"
    | "PYG"
    | "QAR"
    | "RON"
    | "RSD"
    | "RWF"
    | "SAR"
    | "SBD"
    | "SCR"
    | "SDG"
    | "SEK"
    | "SGD"
    | "SLL"
    | "SOS"
    | "SRD"
    | "STP"
    | "SYP"
    | "SZL"
    | "THB"
    | "TJS"
    | "TMT"
    | "TND"
    | "TOP"
    | "TRY"
    | "TTD"
    | "TWD"
    | "TZS"
    | "UAH"
    | "UGX"
    | "USD"
    | "UYU"
    | "UZS"
    | "VES"
    | "VND"
    | "VUV"
    | "WST"
    | "XAF"
    | "XAG"
    | "XAU"
    | "XOF"
    | "XPD"
    | "XPT"
    | "ZAR"
    | "ZMW"
    | "ZWL"
  )[];
  /**
   * Enabled
   * Whether multi-currency is enabled for this sub-organization
   */
  enabled: boolean;
  /**
   * Sub Organization Id
   * ID of the sub-organization
   */
  sub_organization_id: number;
}

/**
 * PaymentsListResponse
 * Response schema for payment list endpoints.
 */
export interface PaymentsListResponse {
  /** Pagination metadata */
  metadata: PaymentsListResponsePaginationMetadata;
  /**
   * Records
   * List of payment records
   */
  records: PaymentsListResponsePaymentsV1JsonResponse[];
}

/**
 * ApprovalRequestModel
 * Pydantic model for approval request data in external API responses.
 */
export interface PaymentsListResponseApprovalRequestModel {
  /**
   * Amounts Basis
   * The amounts basis the approver's authority was measured in, 'gross' or 'net'; absent on a request from before the setting existed, which was measured gross
   * @default null
   */
  amounts_basis?: string | null;
  /**
   * Approval Amount
   * Approved amount
   * @default null
   */
  approval_amount?: number | null;
  /**
   * Approval Datetime
   * Date and time when approved in ISO format
   * @default null
   */
  approval_datetime?: string | null;
  /**
   * Approval Note
   * Note provided during approval
   * @default null
   */
  approval_note?: string | null;
  /**
   * Approval Status
   * Status of the approval request
   */
  approval_status: string;
  /**
   * User who approved the request
   * @default null
   */
  approving_user?: PaymentsListResponseUserExternalAPIBaseModel | null;
  /**
   * Approving User Override Limit Reason
   * Reason for approving user to override limits
   * @default null
   */
  approving_user_override_limit_reason?: string | null;
  /**
   * Net Approval Amount
   * Approved amount net of the request's VAT/GST
   * @default null
   */
  net_approval_amount?: number | null;
  /**
   * Net Request Amount
   * Requested amount net of the request's VAT/GST
   * @default null
   */
  net_request_amount?: number | null;
  /**
   * Request Amount
   * Requested amount
   */
  request_amount: number;
  /**
   * Request Datetime
   * Date and time when request was made in ISO format
   */
  request_datetime: string;
  /** User from whom approval was requested */
  requested_from_user: PaymentsListResponseUserExternalAPIBaseModel;
  /** User who requested the approval */
  requesting_user: PaymentsListResponseUserExternalAPIBaseModel;
  /**
   * Requesting User Override Limit Reason
   * Reason for requesting user to override limits
   * @default null
   */
  requesting_user_override_limit_reason?: string | null;
}

/** ContactEmailModel */
export interface PaymentsListResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface PaymentsListResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: PaymentsListResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: PaymentsListResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface PaymentsListResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** DocumentOutModel */
export interface PaymentsListResponseDocumentOutModel {
  /**
   * Additional Fields
   * Values for the document type's configured additional fields, keyed by field id. Validated against the document type's configured_fields definition; mandatory fields must be present and field-type validation applies.
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** Api Uid */
  api_uid: string | null;
  /**
   * Datetime Uploaded
   * Timestamp (UTC, ISO-8601, with a Z suffix) at which the document was uploaded to the claim. This is the upload time shown in the Five Sigma UI, and is distinct from the business dates document_date and document_date_received. Null if not recorded.
   * @default null
   */
  datetime_uploaded?: string | null;
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Extension
   * @default null
   */
  document_extension?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Size
   * File size of the document in bytes. Null if size is not recorded.
   * @default null
   */
  document_size?: number | null;
  /** Document Type */
  document_type: string;
  /**
   * Document Url
   * @default null
   */
  document_url?: string | null;
  /**
   * Exposure Numbers
   * List of exposure numbers associated with the document
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Exposures
   * Deprecated: Use exposure_numbers instead
   * @deprecated
   * @default null
   */
  exposures?: string[] | null;
  /** External Id */
  external_id: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** LocationModel */
export interface PaymentsListResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PaginationLinks */
export interface PaymentsListResponsePaginationLinks {
  /**
   * Current
   * URL for current page
   */
  current: string | null;
  /**
   * Next
   * URL for next page, null if on last page
   */
  next: string | null;
  /**
   * Previous
   * URL for previous page, null if on first page
   */
  previous: string | null;
}

/** PaginationMetadata */
export interface PaymentsListResponsePaginationMetadata {
  /**
   * Current Page
   * Current page number
   * @min 1
   */
  current_page: number;
  links: PaymentsListResponsePaginationLinks;
  /**
   * Per Page
   * Number of results per page
   * @exclusiveMin 0
   */
  per_page: number;
  /**
   * Total Count
   * Total number of results
   */
  total_count: number;
  /**
   * Total Pages
   * Total number of pages
   */
  total_pages: number;
}

/** PaymentMethodSpecificFields */
export interface PaymentsListResponsePaymentMethodSpecificFields {
  /**
   * Account Details
   * The primary payee contact's account details captured when the payment request is created (later edits to the contact do not affect it). Null when the contact had no account details at request creation, and for payments created before the snapshot was introduced. Returned for custom payment methods only. Response-only: ignored on payment creation/update input - set it via the contacts API.
   * @default null
   */
  account_details?: string | null;
  /**
   * Account Number
   * @default null
   */
  account_number?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Check Date
   * @default null
   */
  check_date?: string | null;
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * Custom Display Name
   * @default null
   */
  custom_display_name?: string | null;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** @default null */
  mail_to_address?: PaymentsListResponseLocationModel | null;
  /**
   * Mail To Contact Ref Id
   * @default null
   */
  mail_to_contact_ref_id?: string | null;
  /**
   * Mail To Name
   * @default null
   */
  mail_to_name?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * One Inc Check Issuance Type
   * @default null
   */
  one_inc_check_issuance_type?: string | null;
  /**
   * One Inc Claimspay Method
   * @default null
   */
  one_inc_claimspay_method?: string | null;
  /**
   * One Inc Claimspay Type
   * @default null
   */
  one_inc_claimspay_type?: string | null;
  /**
   * One Inc Home Loan Account Number
   * @default null
   */
  one_inc_home_loan_account_number?: string | null;
  /**
   * One Inc Is Approval Required
   * @default null
   */
  one_inc_is_approval_required?: boolean | null;
  /**
   * One Inc Lienholder Loan Account Number
   * @default null
   */
  one_inc_lienholder_loan_account_number?: string | null;
  /**
   * Pay To Line
   * @default null
   */
  pay_to_line?: string | null;
  /**
   * Payment Reference
   * @default null
   */
  payment_reference?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Sort Code
   * @default null
   */
  sort_code?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Us Bank Account Number
   * @default null
   */
  us_bank_account_number?: string | null;
  /**
   * Us Bank Name
   * @default null
   */
  us_bank_name?: string | null;
  /**
   * Us Routing Number
   * @default null
   */
  us_routing_number?: string | null;
}

/**
 * PaymentsV1JsonResponse
 * Payload schema for payment response events with API UID and approval requests.
 */
export interface PaymentsListResponsePaymentsV1JsonResponse {
  /**
   * Amount
   * Payment amount
   * @min 0
   */
  amount: number;
  /**
   * Api Uid
   * Payment API UID
   */
  api_uid?: string | null;
  /**
   * Approval Requests
   * Approval requests
   * @default null
   */
  approval_requests?: PaymentsListResponseApprovalRequestModel[] | null;
  /**
   * Approved Date
   * Datetime when approved in ISO format
   * @default null
   */
  approved_date?: string | null;
  /**
   * Approving User Email
   * Email of approving user
   * @default null
   */
  approving_user_email?: string | null;
  /**
   * Approving User Name
   * Name of approving user
   * @default null
   */
  approving_user_name?: string | null;
  /**
   * Attached Documents
   * Attached document objects
   * @default null
   */
  attached_documents?: PaymentsListResponseDocumentOutModel[] | null;
  /**
   * Cancelled Date
   * Datetime when payment was cancelled in ISO format
   * @default null
   */
  cancelled_date?: string | null;
  /**
   * Claim Number
   * Claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contacts
   * Array of contact details with ref_id mappings
   * @default null
   */
  contacts?: PaymentsListResponseContactModel[] | null;
  /**
   * Coverage Display Name
   * Coverage type display name
   * @default null
   */
  coverage_display_name?: string | null;
  /**
   * Coverage Key
   * Coverage type key
   * @default null
   */
  coverage_key?: string | null;
  /**
   * Coverage Type
   * Legacy: use coverage_key instead
   * @default null
   */
  coverage_type?: string | null;
  /**
   * Currency
   * Currency
   * @default null
   */
  currency?: string | null;
  /**
   * Custom Fields
   * Custom fields array
   * @default null
   */
  custom_fields?: Record<string, any>[] | null;
  /**
   * Date Of Loss
   * Date of loss in ISO format
   * @default null
   */
  date_of_loss?: string | null;
  /**
   * Deductible Amount
   * Deductible amount if applied
   * @default null
   */
  deductible_amount?: number | null;
  /**
   * Exposure Number
   * Exposure number if applicable
   * @default null
   */
  exposure_number?: string | null;
  /**
   * External Payment Id
   * External payment ID
   * @default null
   */
  external_payment_id?: string | null;
  /**
   * Financial Status
   * Financial status
   * @default null
   */
  financial_status?: string | null;
  /**
   * Fund Account Number
   * Fund account the payment is sent from, resolved at approval
   * @default null
   */
  fund_account_number?: string | null;
  /**
   * Insured Contact Ref Id
   * Contact ref ID for insured party
   * @default null
   */
  insured_contact_ref_id?: string | null;
  /**
   * Invoice Number
   * Invoice number
   * @default null
   */
  invoice_number?: string | null;
  /**
   * Is 1099 Reportable
   * Whether payment is 1099 reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Deductible Applied
   * Whether deductible was applied to this payment
   * @default null
   */
  is_deductible_applied?: boolean | null;
  /**
   * Is Record Only
   * Whether this is record-only
   * @default null
   */
  is_record_only?: boolean | null;
  /**
   * Is Reissued Payment
   * Whether this is a reissued payment
   * @default null
   */
  is_reissued_payment?: boolean | null;
  /**
   * Is Vat Included
   * Whether VAT is included
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Last Modified Status Date
   * Last status modification datetime in ISO format
   * @default null
   */
  last_modified_status_date?: string | null;
  /**
   * Method-specific payment fields
   * @default null
   */
  method_specific_fields?: PaymentsListResponsePaymentMethodSpecificFields | null;
  /**
   * Payable Type
   * Type of payable (indemnity/expenses)
   * @default null
   */
  payable_type?: string | null;
  /**
   * Payees
   * List of payees
   */
  payees: PaymentsListResponseResponsePayeeModel[];
  /**
   * Payment Approval Status
   * Payment approval status
   * @default null
   */
  payment_approval_status?: string | null;
  /**
   * Payment Desc
   * Payment description
   * @default null
   */
  payment_desc?: string | null;
  /**
   * Payment Id
   * Payment ID
   * @default null
   */
  payment_id?: number | null;
  /**
   * Payment Method
   * Payment method
   */
  payment_method: string;
  /**
   * Payment Method Display Name
   * Display name for payment method
   * @default null
   */
  payment_method_display_name?: string | null;
  /**
   * Payment Other Type
   * Other payment type if applicable
   * @default null
   */
  payment_other_type?: string | null;
  /**
   * Payment Reason
   * Reason for payment
   * @default null
   */
  payment_reason?: string | null;
  /**
   * Payment Type
   * Type of payment
   * @default null
   */
  payment_type?: string | null;
  /**
   * Policy Number
   * Policy number
   * @default null
   */
  policy_number?: string | null;
  /** The payee the payment is made out to. Also included in the payees list. */
  primary_payee: PaymentsListResponseResponsePayeeModel;
  /**
   * Reportable 1099 Indemnity Amount
   * 1099 reportable amount
   * @default null
   */
  reportable_1099_indemnity_amount?: number | null;
  /**
   * Request Date
   * Datetime when payment was requested in ISO format
   * @default null
   */
  request_date?: string | null;
  /**
   * Requesting User Email
   * Email of requesting user
   * @default null
   */
  requesting_user_email?: string | null;
  /**
   * Requesting User Name
   * Name of requesting user
   * @default null
   */
  requesting_user_name?: string | null;
  /**
   * Service End Date
   * Service end date
   * @default null
   */
  service_end_date?: string | null;
  /**
   * Service Start Date
   * Service start date
   * @default null
   */
  service_start_date?: string | null;
  /**
   * Sub Org Name
   * Legacy: use sub_organization_name instead
   * @default null
   */
  sub_org_name?: string | null;
  /**
   * Sub Organization External Id
   * Sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Sub Organization Name
   * Sub-organization name
   * @default null
   */
  sub_organization_name?: string | null;
  /**
   * Time Of Loss
   * Time of loss in HH:MM format
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Vat Amount
   * VAT amount
   * @default null
   */
  vat_amount?: number | null;
}

/** ResponsePayeeModel */
export interface PaymentsListResponseResponsePayeeModel {
  /** Contact Ref Id */
  contact_ref_id: number;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /** Is Primary */
  is_primary: boolean;
  /**
   * Name In Payment
   * @default null
   */
  name_in_payment?: string | null;
  /**
   * Payee Type
   * @default null
   */
  payee_type?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
}

/** UserExternalAPIBaseModel */
export interface PaymentsListResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * PaymentsQueryParams
 * Query parameters for payment list endpoints (GET /payments and /payments/active).
 */
export interface PaymentsQueryParams {
  /**
   * Claim Number
   * Filter by claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * End Date
   * End date in ISO format (YYYY-MM-DD)
   */
  end_date: string;
  /**
   * Financial Status
   * Filter by financial status
   */
  financial_status?: string[];
  /**
   * Page
   * Page number for pagination
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Per Page
   * Results per page
   * @min 1
   * @max 100
   * @default 15
   */
  per_page?: number;
  /**
   * Start Date
   * Start date in ISO format (YYYY-MM-DD)
   */
  start_date: string;
  /**
   * Sub Org Id
   * Deprecated field, use sub_organization_external_id instead
   * @deprecated
   * @default null
   */
  sub_org_id?: string | null;
  /**
   * Sub Organization External Id
   * Sub-organization external ID filter
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * PaymentsV2FilterRequest
 * Request model for Payments V2 API with cursor-based pagination.
 *
 * All filters are optional flat parameters - no required timeframe constraint.
 * Inherits cursor, limit, order_by_field, order_by_direction from CursorPaginationRequest.
 */
export interface PaymentsV2FilterRequest {
  /**
   * Claim Number
   * Filter by claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * End Date
   * Optional end date filter
   * @default null
   */
  end_date?: string | null;
  /**
   * Exposure Number
   * Filter by exposure number
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Financial Statuses
   * Filter by financial statuses (list of statuses)
   * @default null
   */
  financial_statuses?:
    | (
        | "in_progress"
        | "submitted"
        | "issued"
        | "success"
        | "stopped"
        | "cancelled"
        | "pending_approval"
        | "cancel_pending"
        | "error"
        | "pending_submission"
        | "partially_failed"
      )[]
    | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Payable Types
   * Filter by payable types
   * @default null
   */
  payable_types?: ("indemnity" | "expenses" | "general_expenses")[] | null;
  /**
   * Payment Methods
   * Filter by payment methods (list of methods)
   * @default null
   */
  payment_methods?:
    | (
        | "custom_method"
        | "check"
        | "echeck"
        | "one_inc"
        | "uk_bank_transfer"
        | "iban_bank_transfer"
        | "commerce_bank"
        | "au_bank_transfer"
        | "nz_bank_transfer"
        | "us_ach"
      )[]
    | null;
  /**
   * Start Date
   * Optional start date filter
   * @default null
   */
  start_date?: string | null;
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * PaymentsV2ListResponse
 * Response schema for Payments V2 list endpoint with cursor pagination.
 */
export interface PaymentsV2ListResponse {
  /** Pagination metadata */
  metadata: PaymentsV2ListResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * List of payment records
   */
  records: PaymentsV2ListResponsePaymentJsonV2Response[];
}

/**
 * ApprovalRequestModel
 * Pydantic model for approval request data in external API responses.
 */
export interface PaymentsV2ListResponseApprovalRequestModel {
  /**
   * Amounts Basis
   * The amounts basis the approver's authority was measured in, 'gross' or 'net'; absent on a request from before the setting existed, which was measured gross
   * @default null
   */
  amounts_basis?: string | null;
  /**
   * Approval Amount
   * Approved amount
   * @default null
   */
  approval_amount?: number | null;
  /**
   * Approval Datetime
   * Date and time when approved in ISO format
   * @default null
   */
  approval_datetime?: string | null;
  /**
   * Approval Note
   * Note provided during approval
   * @default null
   */
  approval_note?: string | null;
  /**
   * Approval Status
   * Status of the approval request
   */
  approval_status: string;
  /**
   * User who approved the request
   * @default null
   */
  approving_user?: PaymentsV2ListResponseUserExternalAPIBaseModel | null;
  /**
   * Approving User Override Limit Reason
   * Reason for approving user to override limits
   * @default null
   */
  approving_user_override_limit_reason?: string | null;
  /**
   * Net Approval Amount
   * Approved amount net of the request's VAT/GST
   * @default null
   */
  net_approval_amount?: number | null;
  /**
   * Net Request Amount
   * Requested amount net of the request's VAT/GST
   * @default null
   */
  net_request_amount?: number | null;
  /**
   * Request Amount
   * Requested amount
   */
  request_amount: number;
  /**
   * Request Datetime
   * Date and time when request was made in ISO format
   */
  request_datetime: string;
  /** User from whom approval was requested */
  requested_from_user: PaymentsV2ListResponseUserExternalAPIBaseModel;
  /** User who requested the approval */
  requesting_user: PaymentsV2ListResponseUserExternalAPIBaseModel;
  /**
   * Requesting User Override Limit Reason
   * Reason for requesting user to override limits
   * @default null
   */
  requesting_user_override_limit_reason?: string | null;
}

/** ContactEmailModel */
export interface PaymentsV2ListResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface PaymentsV2ListResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: PaymentsV2ListResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: PaymentsV2ListResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface PaymentsV2ListResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** DocumentOutModel */
export interface PaymentsV2ListResponseDocumentOutModel {
  /**
   * Additional Fields
   * Values for the document type's configured additional fields, keyed by field id. Validated against the document type's configured_fields definition; mandatory fields must be present and field-type validation applies.
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** Api Uid */
  api_uid: string | null;
  /**
   * Datetime Uploaded
   * Timestamp (UTC, ISO-8601, with a Z suffix) at which the document was uploaded to the claim. This is the upload time shown in the Five Sigma UI, and is distinct from the business dates document_date and document_date_received. Null if not recorded.
   * @default null
   */
  datetime_uploaded?: string | null;
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Extension
   * @default null
   */
  document_extension?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Size
   * File size of the document in bytes. Null if size is not recorded.
   * @default null
   */
  document_size?: number | null;
  /** Document Type */
  document_type: string;
  /**
   * Document Url
   * @default null
   */
  document_url?: string | null;
  /**
   * Exposure Numbers
   * List of exposure numbers associated with the document
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Exposures
   * Deprecated: Use exposure_numbers instead
   * @deprecated
   * @default null
   */
  exposures?: string[] | null;
  /** External Id */
  external_id: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** LocationModel */
export interface PaymentsV2ListResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface PaymentsV2ListResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/**
 * PaymentJsonV2Response
 * Payload schema for payment response events.
 */
export interface PaymentsV2ListResponsePaymentJsonV2Response {
  /**
   * Amount
   * Payment amount
   * @min 0
   */
  amount: number;
  /**
   * Api Uid
   * Payment API UID
   */
  api_uid?: string | null;
  /**
   * Approval Requests
   * Approval requests
   * @default null
   */
  approval_requests?: PaymentsV2ListResponseApprovalRequestModel[] | null;
  /**
   * Approved Date
   * Datetime when approved in ISO format
   * @default null
   */
  approved_date?: string | null;
  /**
   * Approving User Email
   * Email of approving user
   * @default null
   */
  approving_user_email?: string | null;
  /**
   * Approving User Name
   * Name of approving user
   * @default null
   */
  approving_user_name?: string | null;
  /**
   * Attached Documents
   * Attached document objects
   * @default null
   */
  attached_documents?: PaymentsV2ListResponseDocumentOutModel[] | null;
  /**
   * Cancelled Date
   * Datetime when payment was cancelled in ISO format
   * @default null
   */
  cancelled_date?: string | null;
  /**
   * Claim Number
   * Claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contacts
   * Array of contact details with ref_id mappings
   * @default null
   */
  contacts?: PaymentsV2ListResponseContactModel[] | null;
  /**
   * Coverage Display Name
   * Coverage type display name
   * @default null
   */
  coverage_display_name?: string | null;
  /**
   * Coverage Key
   * Coverage type key
   * @default null
   */
  coverage_key?: string | null;
  /**
   * Currency
   * Currency
   * @default null
   */
  currency?: string | null;
  /**
   * Custom Fields
   * Custom fields array
   * @default null
   */
  custom_fields?: Record<string, any>[] | null;
  /**
   * Date Of Loss
   * Date of loss in ISO format
   * @default null
   */
  date_of_loss?: string | null;
  /**
   * Deductible Amount
   * Deductible amount if applied
   * @default null
   */
  deductible_amount?: number | null;
  /**
   * Exposure Label
   * Exposure label
   * @default null
   */
  exposure_label?: string | null;
  /**
   * Exposure Number
   * Exposure number if applicable
   * @default null
   */
  exposure_number?: string | null;
  /**
   * External Payment Id
   * External payment ID
   * @default null
   */
  external_payment_id?: string | null;
  /**
   * Financial Status
   * Financial status
   * @default null
   */
  financial_status?: string | null;
  /**
   * Fund Account Number
   * Fund account the payment is sent from, resolved at approval
   * @default null
   */
  fund_account_number?: string | null;
  /**
   * Insured Contact Ref Id
   * Contact ref ID for insured party
   * @default null
   */
  insured_contact_ref_id?: string | null;
  /**
   * Invoice Number
   * Invoice number
   * @default null
   */
  invoice_number?: string | null;
  /**
   * Is 1099 Reportable
   * Whether payment is 1099 reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Contact Financial Details Verified
   * True if contact financial details were verified/approved at payment creation time
   * @default null
   */
  is_contact_financial_details_verified?: boolean | null;
  /**
   * Is Deductible Applied
   * Whether deductible was applied to this payment
   * @default null
   */
  is_deductible_applied?: boolean | null;
  /**
   * Is Record Only
   * Whether this is record-only
   * @default null
   */
  is_record_only?: boolean | null;
  /**
   * Is Reissued Payment
   * Whether this is a reissued payment
   * @default null
   */
  is_reissued_payment?: boolean | null;
  /**
   * Is Vat Included
   * Whether VAT is included
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Last Modified Status Date
   * Last status modification datetime in ISO format
   * @default null
   */
  last_modified_status_date?: string | null;
  /**
   * Method-specific payment fields
   * @default null
   */
  method_specific_fields?: PaymentsV2ListResponsePaymentMethodSpecificFields | null;
  /**
   * Payable Type
   * Type of payable (indemnity/expenses)
   * @default null
   */
  payable_type?: string | null;
  /**
   * Payees
   * List of payees
   */
  payees: PaymentsV2ListResponseResponsePayeeModel[];
  /**
   * Payment Approval Status
   * Payment approval status
   * @default null
   */
  payment_approval_status?: string | null;
  /**
   * Payment Desc
   * Payment description
   * @default null
   */
  payment_desc?: string | null;
  /**
   * Payment Id
   * Payment ID
   * @default null
   */
  payment_id?: number | null;
  /**
   * Payment Method
   * Payment method
   */
  payment_method: string;
  /**
   * Payment Method Display Name
   * Display name for payment method
   * @default null
   */
  payment_method_display_name?: string | null;
  /**
   * Payment Other Type
   * Other payment type if applicable
   * @default null
   */
  payment_other_type?: string | null;
  /**
   * Payment Reason
   * Reason for payment
   * @default null
   */
  payment_reason?: string | null;
  /**
   * Payment Type
   * Type of payment
   * @default null
   */
  payment_type?: string | null;
  /**
   * Policy Number
   * Policy number
   * @default null
   */
  policy_number?: string | null;
  /** The payee the payment is made out to. Also included in the payees list. */
  primary_payee: PaymentsV2ListResponseResponsePayeeModel;
  /**
   * Reportable 1099 Indemnity Amount
   * 1099 reportable amount
   * @default null
   */
  reportable_1099_indemnity_amount?: number | null;
  /**
   * Request Date
   * Datetime when payment was requested in ISO format
   * @default null
   */
  request_date?: string | null;
  /**
   * Requesting User Email
   * Email of requesting user
   * @default null
   */
  requesting_user_email?: string | null;
  /**
   * Requesting User Name
   * Name of requesting user
   * @default null
   */
  requesting_user_name?: string | null;
  /**
   * Service End Date
   * Service end date
   * @default null
   */
  service_end_date?: string | null;
  /**
   * Service Start Date
   * Service start date
   * @default null
   */
  service_start_date?: string | null;
  /**
   * Sub Organization External Id
   * Sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Sub Organization Name
   * Sub-organization name
   * @default null
   */
  sub_organization_name?: string | null;
  /**
   * Time Of Loss
   * Time of loss in HH:MM format
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Vat Amount
   * VAT amount
   * @default null
   */
  vat_amount?: number | null;
}

/** PaymentMethodSpecificFields */
export interface PaymentsV2ListResponsePaymentMethodSpecificFields {
  /**
   * Account Details
   * The primary payee contact's account details captured when the payment request is created (later edits to the contact do not affect it). Null when the contact had no account details at request creation, and for payments created before the snapshot was introduced. Returned for custom payment methods only. Response-only: ignored on payment creation/update input - set it via the contacts API.
   * @default null
   */
  account_details?: string | null;
  /**
   * Account Number
   * @default null
   */
  account_number?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Check Date
   * @default null
   */
  check_date?: string | null;
  /**
   * Check Number
   * @default null
   */
  check_number?: string | null;
  /**
   * Custom Display Name
   * @default null
   */
  custom_display_name?: string | null;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /** @default null */
  mail_to_address?: PaymentsV2ListResponseLocationModel | null;
  /**
   * Mail To Contact Ref Id
   * @default null
   */
  mail_to_contact_ref_id?: string | null;
  /**
   * Mail To Name
   * @default null
   */
  mail_to_name?: string | null;
  /**
   * Nz Bank Account Number
   * @default null
   */
  nz_bank_account_number?: string | null;
  /**
   * One Inc Check Issuance Type
   * @default null
   */
  one_inc_check_issuance_type?: string | null;
  /**
   * One Inc Claimspay Method
   * @default null
   */
  one_inc_claimspay_method?: string | null;
  /**
   * One Inc Claimspay Type
   * @default null
   */
  one_inc_claimspay_type?: string | null;
  /**
   * One Inc Home Loan Account Number
   * @default null
   */
  one_inc_home_loan_account_number?: string | null;
  /**
   * One Inc Is Approval Required
   * @default null
   */
  one_inc_is_approval_required?: boolean | null;
  /**
   * One Inc Lienholder Loan Account Number
   * @default null
   */
  one_inc_lienholder_loan_account_number?: string | null;
  /**
   * Pay To Line
   * @default null
   */
  pay_to_line?: string | null;
  /**
   * Payment Reference
   * @default null
   */
  payment_reference?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Sort Code
   * @default null
   */
  sort_code?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Us Bank Account Number
   * @default null
   */
  us_bank_account_number?: string | null;
  /**
   * Us Bank Name
   * @default null
   */
  us_bank_name?: string | null;
  /**
   * Us Routing Number
   * @default null
   */
  us_routing_number?: string | null;
}

/** ResponsePayeeModel */
export interface PaymentsV2ListResponseResponsePayeeModel {
  /** Contact Ref Id */
  contact_ref_id: number;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /** Is Primary */
  is_primary: boolean;
  /**
   * Name In Payment
   * @default null
   */
  name_in_payment?: string | null;
  /**
   * Payee Type
   * @default null
   */
  payee_type?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
}

/** UserExternalAPIBaseModel */
export interface PaymentsV2ListResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * PendingVerificationsListResponse
 * Response schema for pending verifications list endpoint.
 */
export interface PendingVerificationsListResponse {
  /** Count */
  count: number;
  /** Verifications */
  verifications: PendingVerificationsListResponsePendingVerificationItem[];
}

/**
 * PendingVerificationItem
 * Schema for a single pending verification in the list.
 */
export interface PendingVerificationsListResponsePendingVerificationItem {
  /** Change Ulid */
  change_ulid: string;
  /** Changed Fields */
  changed_fields: Record<string, any>;
  /** Contact External Id */
  contact_external_id: string | null;
  /** Contact Id */
  contact_id: number;
  /** Contact Name */
  contact_name: string;
  /** Id */
  id: string;
  /**
   * Request Datetime
   * @format date-time
   */
  request_datetime: string;
  /** Requesting User */
  requesting_user: string;
  /** Requesting User Id */
  requesting_user_id: string;
}

/**
 * PendingVerificationsQueryParams
 * Query parameters for pending verifications list endpoint.
 */
export interface PendingVerificationsQueryParams {
  /**
   * Page Number
   * @min 1
   * @default 1
   */
  page_number?: number;
  /**
   * Results Per Page
   * @min 1
   * @default 10
   */
  results_per_page?: number;
}

/**
 * PerformOcrRequest
 * Request schema for OCR processing of SOP document.
 */
export interface PerformOcrRequest {
  /**
   * Stored File Id
   * ID of the stored file to process
   */
  stored_file_id: number;
  /**
   * Sub Organization Id
   * Sub-organization ID (for Phase 2)
   * @default null
   */
  sub_organization_id?: string | null;
}

/**
 * PerformOcrResponse
 * Response schema for OCR processed SOP document.
 */
export interface PerformOcrResponse {
  /**
   * Markdown Pages
   * List of markdown strings, one per page
   */
  markdown_pages: string[];
  /**
   * Page Count
   * Total number of pages processed
   */
  page_count: number;
}

/** PhoneProfileCreateRequest */
export interface PhoneProfileCreateRequest {
  /**
   * Auto Record Calls
   * @default null
   */
  auto_record_calls?: boolean | null;
  /**
   * Business Hours Configuration
   * @default null
   */
  business_hours_configuration?: Record<string, any> | null;
  /**
   * Business Hours Configuration Enabled
   * @default null
   */
  business_hours_configuration_enabled?: boolean | null;
  /**
   * Caller Id Enabled
   * @default null
   */
  caller_id_enabled?: boolean | null;
  /**
   * Inbound Call Message Enabled
   * @default null
   */
  inbound_call_message_enabled?: boolean | null;
  /** Name */
  name: string;
  /**
   * Outbound Call Message Enabled
   * @default null
   */
  outbound_call_message_enabled?: boolean | null;
  /**
   * Phone Survey Configuration Id
   * @default null
   */
  phone_survey_configuration_id?: number | null;
  /**
   * Phone Survey Enabled
   * @default null
   */
  phone_survey_enabled?: boolean | null;
  /**
   * Voicemail Message Enabled
   * @default null
   */
  voicemail_message_enabled?: boolean | null;
}

/** PhoneProfileInfo */
export interface PhoneProfileInfo {
  /** Auto Record Calls */
  auto_record_calls: boolean;
  /**
   * Business Hours Configuration
   * @default null
   */
  business_hours_configuration?: Record<string, any> | null;
  /** Business Hours Configuration Enabled */
  business_hours_configuration_enabled: boolean;
  /** Caller Id Enabled */
  caller_id_enabled: boolean;
  /** Id */
  id: number;
  /** @default null */
  inbound_call_message_configuration?: PhoneProfileInfoPhoneProfileVoiceMessageRef | null;
  /** Inbound Call Message Enabled */
  inbound_call_message_enabled: boolean;
  /** Is Default */
  is_default: boolean;
  /** Name */
  name: string;
  /** Organization Id */
  organization_id: number;
  /** @default null */
  out_of_office_message_configuration?: PhoneProfileInfoPhoneProfileVoiceMessageRef | null;
  /** @default null */
  outbound_call_message_configuration?: PhoneProfileInfoPhoneProfileVoiceMessageRef | null;
  /** Outbound Call Message Enabled */
  outbound_call_message_enabled: boolean;
  /**
   * Phone Survey Configuration Id
   * @default null
   */
  phone_survey_configuration_id?: number | null;
  /** Phone Survey Enabled */
  phone_survey_enabled: boolean;
  /** @default null */
  voicemail_message_configuration?: PhoneProfileInfoPhoneProfileVoiceMessageRef | null;
  /** Voicemail Message Enabled */
  voicemail_message_enabled: boolean;
}

/** PhoneProfileVoiceMessageRef */
export interface PhoneProfileInfoPhoneProfileVoiceMessageRef {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/** PhoneProfileListResponse */
export interface PhoneProfileListResponse {
  /** Phone Profiles */
  phone_profiles: PhoneProfileListResponsePhoneProfileInfo[];
}

/** PhoneProfileInfo */
export interface PhoneProfileListResponsePhoneProfileInfo {
  /** Auto Record Calls */
  auto_record_calls: boolean;
  /**
   * Business Hours Configuration
   * @default null
   */
  business_hours_configuration?: Record<string, any> | null;
  /** Business Hours Configuration Enabled */
  business_hours_configuration_enabled: boolean;
  /** Caller Id Enabled */
  caller_id_enabled: boolean;
  /** Id */
  id: number;
  /** @default null */
  inbound_call_message_configuration?: PhoneProfileListResponsePhoneProfileVoiceMessageRef | null;
  /** Inbound Call Message Enabled */
  inbound_call_message_enabled: boolean;
  /** Is Default */
  is_default: boolean;
  /** Name */
  name: string;
  /** Organization Id */
  organization_id: number;
  /** @default null */
  out_of_office_message_configuration?: PhoneProfileListResponsePhoneProfileVoiceMessageRef | null;
  /** @default null */
  outbound_call_message_configuration?: PhoneProfileListResponsePhoneProfileVoiceMessageRef | null;
  /** Outbound Call Message Enabled */
  outbound_call_message_enabled: boolean;
  /**
   * Phone Survey Configuration Id
   * @default null
   */
  phone_survey_configuration_id?: number | null;
  /** Phone Survey Enabled */
  phone_survey_enabled: boolean;
  /** @default null */
  voicemail_message_configuration?: PhoneProfileListResponsePhoneProfileVoiceMessageRef | null;
  /** Voicemail Message Enabled */
  voicemail_message_enabled: boolean;
}

/** PhoneProfileVoiceMessageRef */
export interface PhoneProfileListResponsePhoneProfileVoiceMessageRef {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/** PhoneProfilePatchRequest */
export interface PhoneProfilePatchRequest {
  /**
   * Auto Record Calls
   * @default null
   */
  auto_record_calls?: boolean | null;
  /**
   * Business Hours Configuration
   * @default null
   */
  business_hours_configuration?: Record<string, any> | null;
  /**
   * Business Hours Configuration Enabled
   * @default null
   */
  business_hours_configuration_enabled?: boolean | null;
  /**
   * Caller Id Enabled
   * @default null
   */
  caller_id_enabled?: boolean | null;
  /**
   * Inbound Call Message Enabled
   * @default null
   */
  inbound_call_message_enabled?: boolean | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Outbound Call Message Enabled
   * @default null
   */
  outbound_call_message_enabled?: boolean | null;
  /**
   * Phone Survey Configuration Id
   * @default null
   */
  phone_survey_configuration_id?: number | null;
  /**
   * Phone Survey Enabled
   * @default null
   */
  phone_survey_enabled?: boolean | null;
  /**
   * Voicemail Message Enabled
   * @default null
   */
  voicemail_message_enabled?: boolean | null;
}

/** PhoneSurveyConfigurationModel */
export interface PhoneSurveyConfigurationModel {
  /** @default null */
  ending_message_configuration?: PhoneSurveyConfigurationModelVoiceMessageConfigurationParams | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /** @default null */
  illegal_response_text_configuration?: PhoneSurveyConfigurationModelVoiceMessageConfigurationParams | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Questions
   * @default null
   */
  questions?:
    | PhoneSurveyConfigurationModelPhoneSurveyQuestionConfigurationModel[]
    | null;
  /** @default null */
  response_line_configuration?: PhoneSurveyConfigurationModelVoiceMessageConfigurationParams | null;
  /** @default null */
  welcome_message_configuration?: PhoneSurveyConfigurationModelVoiceMessageConfigurationParams | null;
}

/** PhoneSurveyAnswerOptionConfigurationModel */
export interface PhoneSurveyConfigurationModelPhoneSurveyAnswerOptionConfigurationModel {
  /** @default null */
  content_configuration?: PhoneSurveyConfigurationModelVoiceMessageConfigurationParams | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Position
   * @default null
   */
  position?: number | null;
  /**
   * Question Id
   * @default null
   */
  question_id?: number | null;
  /**
   * Question Key
   * @default null
   */
  question_key?: string | null;
}

/** PhoneSurveyQuestionConfigurationModel */
export interface PhoneSurveyConfigurationModelPhoneSurveyQuestionConfigurationModel {
  /**
   * Answer Options
   * @default null
   */
  answer_options?:
    | PhoneSurveyConfigurationModelPhoneSurveyAnswerOptionConfigurationModel[]
    | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Is Active
   * @default null
   */
  is_active?: boolean | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Position
   * @default null
   */
  position?: number | null;
  /** @default null */
  question_configuration?: PhoneSurveyConfigurationModelVoiceMessageConfigurationParams | null;
  /**
   * Question Key
   * @default null
   */
  question_key?: string | null;
  /**
   * Survey Configuration Id
   * @default null
   */
  survey_configuration_id?: number | null;
}

/** VoiceMessageConfigurationParams */
export interface PhoneSurveyConfigurationModelVoiceMessageConfigurationParams {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/**
 * PolicyAIConfigResponse
 * Response for Policy AI configuration
 */
export interface PolicyAIConfigResponse {
  /**
   * Policy Search Special Instructions
   * @default null
   */
  policy_search_special_instructions?: string | null;
}

/**
 * PolicyAIConfigUpdatePayload
 * Payload for updating Policy AI configuration
 */
export interface PolicyAIConfigUpdatePayload {
  /**
   * Clive Policy Config
   * JSON configuration for Policy AI Clive integration
   * @default null
   */
  clive_policy_config?: Record<string, any> | null;
}

/**
 * PolicyAIErrorResponse
 * Error response for Policy AI configuration operations
 */
export interface PolicyAIErrorResponse {
  /**
   * Message
   * Description of the error.
   */
  message: string;
  /**
   * Status
   * @default "error"
   */
  status?: string;
}

/**
 * PolicyApiSearchResponse
 * The response to a policy search.
 */
export interface PolicyApiSearchResponse {
  /**
   * Display Schema
   * The columns of the results table, in display order
   */
  display_schema: PolicyApiSearchResponsePolicyApiDisplaySchemaField[];
  /**
   * Results
   * The matched policies
   */
  results: PolicyApiSearchResponsePolicyApiSearchResult[];
  /**
   * Total Results
   * How many policies your search matched
   * @min 0
   */
  total_results: number;
}

/**
 * PolicyApiDisplaySchemaField
 * One column of the search-results table, as you ask Five Sigma to render it.
 */
export interface PolicyApiSearchResponsePolicyApiDisplaySchemaField {
  /**
   * Desc
   * The column header Five Sigma displays
   */
  desc: string;
  /**
   * Id
   * The key to read this column from every result's `display_fields`
   */
  id: string;
  /**
   * Type
   * How Five Sigma renders the column
   */
  type: "string" | "date" | "select";
}

/**
 * PolicyApiSearchResult
 * One matched policy, summarised for the results table.
 */
export interface PolicyApiSearchResponsePolicyApiSearchResult {
  /**
   * Display Fields
   * One entry per `display_schema` column, keyed by its `id`. Values are rendered as text.
   */
  display_fields: Record<string, string>;
  /**
   * Retrieval Token
   * Opaque token Five Sigma sends back to the retrieval endpoint to fetch the full policy
   */
  retrieval_token: string;
}

/** PolicyCategoryInfoList */
export type PolicyCategoryInfoList = PolicyCategoryInfoListPolicyCategoryInfo[];

/**
 * PolicyCategoryInfo
 * One policy category, as the configuration screen reads it.
 */
export interface PolicyCategoryInfoListPolicyCategoryInfo {
  /** Conditions Json */
  conditions_json: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Is Referenced */
  is_referenced: boolean;
  /** Key */
  key: string;
  /** Last Updated By User Name */
  last_updated_by_user_name: string | null;
  /**
   * Last Updated On
   * @format date-time
   */
  last_updated_on: string;
}

/**
 * PolicyFormatResponse
 * Response for formatted policy data
 */
export interface PolicyFormatResponse {
  /**
   * Policy Data
   * @default null
   */
  policy_data?: Record<string, any> | null;
}

/**
 * PolicyListResponse
 * Response model for policy list operations.
 */
export interface PolicyListResponse {
  /**
   * Policies
   * List of policy items
   */
  policies: PolicyListResponsePolicyListItemModel[];
}

/**
 * PolicyListItemModel
 * Model for individual policy items returned from mock policy server list endpoint.
 */
export interface PolicyListResponsePolicyListItemModel {
  /**
   * Created At
   * Creation timestamp (ISO format) - test compatibility
   * @default null
   */
  created_at?: string | null;
  /**
   * Display Name
   * User-defined display name for the policy
   * @default null
   */
  display_name?: string | null;
  /**
   * Effective Date
   * Policy effective date (ISO format)
   * @default null
   */
  effective_date?: string | null;
  /**
   * Expiration Date
   * Policy expiration date (ISO format)
   * @default null
   */
  expiration_date?: string | null;
  /**
   * File Path
   * Internal file path for storage
   * @default null
   */
  file_path?: string | null;
  /**
   * Insured Name
   * Name of the insured party
   * @default null
   */
  insured_name?: string | null;
  /**
   * Last Modified
   * Last modification timestamp (ISO format)
   * @default null
   */
  last_modified?: string | null;
  /**
   * Lob
   * Line of Business
   * @default null
   */
  lob?: string | null;
  /**
   * Policy Data
   * Original policy JSON data - test compatibility
   * @default null
   */
  policy_data?: Record<string, any> | null;
  /**
   * Policy Number
   * Policy number
   * @default null
   */
  policy_number?: string | null;
  /**
   * Policy Status
   * Policy status
   * @default null
   */
  policy_status?: string | null;
  /**
   * Policy Uuid
   * Unique policy UUID
   */
  policy_uuid: string;
  /**
   * Sub Organization External Id
   * Sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Updated At
   * Last update timestamp (ISO format) - test compatibility
   * @default null
   */
  updated_at?: string | null;
}

/**
 * PolicyRequest
 * Request model for policy creation and updates.
 */
export interface PolicyRequest {
  /**
   * Display Name
   * User-defined display name for the policy
   */
  display_name: string;
  /**
   * Lob
   * Line of Business
   */
  lob: string;
  /**
   * Policy
   * Policy data object
   */
  policy: Record<string, any>;
  /**
   * Sub Organization External Id
   * Sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * PolicyResponse
 * Response model for single policy operations.
 */
export interface PolicyResponse {
  /** PolicyContainer with metadata and policy data */
  policy: PolicyResponsePolicyContainerModel;
}

/**
 * PolicyContainerModel
 * Model for PolicyContainer objects returned from microservice.
 */
export interface PolicyResponsePolicyContainerModel {
  /**
   * Created At
   * Creation timestamp (ISO format)
   */
  created_at: string;
  /**
   * Display Name
   * Human-readable display name
   */
  display_name: string;
  /**
   * Policy Data
   * Original policy JSON data
   */
  policy_data: Record<string, any>;
  /**
   * Policy Uuid
   * Unique identifier for the policy
   */
  policy_uuid: string;
  /**
   * Updated At
   * Last update timestamp (ISO format)
   */
  updated_at: string;
}

/**
 * PolicySearchResponse
 * PolicySearchResponse
 */
export interface PolicySearchResponse {
  /** Entities */
  entities: PolicySearchResponseEntityInformation[];
  /** Policy Data */
  policy_data: Record<string, any>;
  /** Policy Number */
  policy_number: string;
}

/**
 * Address
 * Address
 */
export interface PolicySearchResponseAddress {
  /** Address Line 1 */
  address_line_1: string | null;
  /** Address Line 2 */
  address_line_2: string | null;
  /** City */
  city: string | null;
  /** Country */
  country: string | null;
  /** State */
  state: string | null;
  /** Zip Code */
  zip_code: string | null;
}

/**
 * ContactDetails
 * ContactDetails
 */
export interface PolicySearchResponseContactDetails {
  /**
   * Addresses
   * @default null
   */
  addresses?: PolicySearchResponseAddress[] | null;
  /**
   * Emails
   * @default null
   */
  emails?: string[] | null;
  /** First Name */
  first_name: string | null;
  /** Last Name */
  last_name: string | null;
  /** Middle Name */
  middle_name: string | null;
  /**
   * Phone Numbers
   * @default null
   */
  phone_numbers?: string[] | null;
}

/**
 * EntityInformation
 * EntityInformation
 */
export interface PolicySearchResponseEntityInformation {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Claim Role
   * @default null
   */
  claim_role?: string | null;
  contact_details: PolicySearchResponseContactDetails | null;
  /** Description */
  description: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /** Id */
  id: string;
  /** Identifier */
  identifier: string | null;
  /** Identifier Type */
  identifier_type: string | null;
  /** Name */
  name: string;
  /** EntityType */
  type: PolicySearchResponseEntityType;
}

/**
 * PolicySearchV2Request
 * Body of ``POST /policies/get_policies_by_api_v2``.
 *
 * ``fields`` carries the organization's own ``policy_api_configuration.configured_fields`` values,
 * which differ per organization and so cannot be enumerated here. As an object with open
 * properties it is expressible in OpenAPI, which a flat query-parameter list was not - the
 * generated spec showed ``"parameters": []`` for this route. Unknown keys are still rejected, by
 * ``validate_configured_fields_values`` against that organization's configuration.
 */
export interface PolicySearchV2Request {
  /** Fields */
  fields?: Record<string, any>;
  /**
   * Lob
   * @minLength 1
   */
  lob: string;
  /**
   * Sub Org Id
   * @default null
   */
  sub_org_id?: number | null;
}

/**
 * PolicySelectInput
 * Request body of `policy_select_tool`: the chosen handle and nothing else.  No policy number and no search parameters travel alongside it, so the carrier call that fetches the policy is driven entirely by what CMS put in the handle.
 */
export interface PolicySelectInput {
  /**
   * Selection Handle
   * The `selection_handle` of the chosen `PolicySearchCandidate`, sent back verbatim and unmodified. claims-ai never inspects or rewrites it; it is echoed from the search that produced it, so the carrier retrieval token inside it is the one that search issued.
   */
  selection_handle: Record<string, any>;
}

/** PossibleAdjustersResponse */
export type PossibleAdjustersResponse =
  PossibleAdjustersResponsePossibleAdjuster[];

/** PossibleAdjuster */
export interface PossibleAdjustersResponsePossibleAdjuster {
  /**
   * Email
   * @default null
   */
  email?: string | null;
  /** Id */
  id: string;
  /**
   * Is Active
   * @default null
   */
  is_active?: boolean | null;
  /**
   * Is Removed
   * @default null
   */
  is_removed?: boolean | null;
  /**
   * Is Sys Config Editor
   * @default null
   */
  is_sys_config_editor?: boolean | null;
  /** Licenses */
  licenses?: PossibleAdjustersResponsePossibleAdjusterLicense[];
  /**
   * Role Type
   * @default null
   */
  role_type?: string | null;
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Username
   * @default null
   */
  username?: string | null;
}

/** PossibleAdjusterLicense */
export interface PossibleAdjustersResponsePossibleAdjusterLicense {
  /**
   * Expiration Date
   * @format date
   */
  expiration_date: string;
  /** State */
  state: string;
}

/** PostBulkOperationParams */
export interface PostBulkOperationParams {
  /** Notification Ids */
  notification_ids: number[];
}

/** PostCategoryParams */
export interface PostCategoryParams {
  /** Color */
  color: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/** PostCommunicationCategoryParams */
export interface PostCommunicationCategoryParams {
  /** Color */
  color: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /** Key */
  key: string;
  /** Label */
  label: string;
}

/** PostFnolHookBindingResponse */
export interface PostFnolHookBindingResponse {
  /** @default null */
  hook_endpoint?: PostFnolHookBindingResponseHookEndpointResponse | null;
  /** Id */
  id: number;
  /** Incident Configuration Id */
  incident_configuration_id: number;
  /** Is Active */
  is_active: boolean;
}

/** HookEndpointResponse */
export interface PostFnolHookBindingResponseHookEndpointResponse {
  /** Callback Url */
  callback_url: string;
  /** Id */
  id: number;
  /** Key */
  key: string;
  /** Name */
  name: string;
  /** Timeout Seconds */
  timeout_seconds: number;
}

/** PostReminderParams */
export interface PostReminderParams {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /** Details */
  details: string;
  /** Due Datetime */
  due_datetime: string;
  /**
   * Is Restricted
   * @default null
   */
  is_restricted?: boolean | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /** Recipient */
  recipient:
    | ({
        type: "claim_handler";
      } & PostReminderParamsReminderSimpleRecipientParam)
    | ({
        type: "exposure_handler";
      } & PostReminderParamsReminderExposureRecipientParam)
    | ({
        type: "myself";
      } & PostReminderParamsReminderSimpleRecipientParam)
    | ({
        type: "organization_unit_leader";
      } & PostReminderParamsReminderOrganizationUnitLeaderRecipientParam)
    | ({
        type: "other_adjuster";
      } & PostReminderParamsReminderOtherAdjusterRecipientParam);
  /** Title */
  title: string;
}

/** ReminderExposureRecipientParam */
export interface PostReminderParamsReminderExposureRecipientParam {
  /** Exposure Id */
  exposure_id: number;
  /** Type */
  type: "exposure_handler";
}

/** ReminderOrganizationUnitLeaderRecipientParam */
export interface PostReminderParamsReminderOrganizationUnitLeaderRecipientParam {
  /** Organization Unit Id */
  organization_unit_id: number;
  /** Type */
  type: "organization_unit_leader";
}

/** ReminderOtherAdjusterRecipientParam */
export interface PostReminderParamsReminderOtherAdjusterRecipientParam {
  /** Other Adjuster Id */
  other_adjuster_id: string;
  /** Type */
  type: "other_adjuster";
}

/** ReminderSimpleRecipientParam */
export interface PostReminderParamsReminderSimpleRecipientParam {
  /** Type */
  type: "claim_handler" | "myself";
}

/** PreDefinedNotificationResponseList */
export type PreDefinedNotificationResponseList =
  PreDefinedNotificationResponseListPreDefinedNotificationResponse[];

/**
 * PreDefinedNotificationResponse
 * Response schema for GET /notifications/pre_defined.
 *
 * Provides defaults for DB-config fields that are absent on notifications
 * without a NotificationConfiguration record.
 */
export interface PreDefinedNotificationResponseListPreDefinedNotificationResponse {
  /**
   * Category
   * @default null
   */
  category?: Record<string, any> | null;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /** Content */
  content: string;
  /**
   * Default Disabled
   * @default false
   */
  default_disabled?: boolean;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /**
   * Is All States
   * @default true
   */
  is_all_states?: boolean;
  /**
   * Is Disabled
   * @default false
   */
  is_disabled?: boolean;
  /**
   * Is Due Date Immediate
   * @default null
   */
  is_due_date_immediate?: boolean | null;
  /**
   * Lob
   * @default "all"
   */
  lob?: string;
  /** Notification Key */
  notification_key: string;
  /** Notification Type */
  notification_type: string;
  /**
   * Predefined Notification Conditions
   * @default null
   */
  predefined_notification_conditions?: Record<string, any> | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /** Recipient */
  recipient: string;
  /**
   * Rule Name
   * @default null
   */
  rule_name?: string | null;
  /**
   * Scope
   * @default null
   */
  scope?: string | null;
  /**
   * Scope Types
   * @default "all"
   */
  scope_types?: string | null;
  /**
   * States
   * @default []
   */
  states?: string[] | null;
  /**
   * Sub Orgs
   * @default "all"
   */
  sub_orgs?: string;
  /** Title */
  title: string;
}

/**
 * PredefinedPromptsAdminRequest
 * The organization's full predefined prompt map, keyed by prompt key, replacing the stored one.
 */
export type PredefinedPromptsAdminRequest = Record<
  string,
  PredefinedPromptsAdminRequestPredefinedPromptAdminItem
>;

/**
 * PredefinedPromptAdminItem
 * A predefined prompt as shown to system-configuration admins, including its secret text.
 */
export interface PredefinedPromptsAdminRequestPredefinedPromptAdminItem {
  /** Prompt Text */
  prompt_text: string;
  /** Prompt Title */
  prompt_title: string;
}

/**
 * PredefinedPromptsAdminResponse
 * An organization's predefined prompts keyed by prompt key, for system-configuration admins only.
 */
export type PredefinedPromptsAdminResponse = Record<
  string,
  PredefinedPromptsAdminResponsePredefinedPromptAdminItem
>;

/**
 * PredefinedPromptAdminItem
 * A predefined prompt as shown to system-configuration admins, including its secret text.
 */
export interface PredefinedPromptsAdminResponsePredefinedPromptAdminItem {
  /** Prompt Text */
  prompt_text: string;
  /** Prompt Title */
  prompt_title: string;
}

/**
 * PredefinedPromptsResponse
 * Response containing dictionary of predefined prompts.
 *
 * Returns a dictionary mapping prompt keys to prompt objects:
 * {
 *     "prompt_key_1": {"prompt_title": "Title 1"},
 *     "prompt_key_2": {"prompt_title": "Title 2"}
 * }
 *
 * Note: prompt_text is NOT returned to frontend for security.
 * Uses RootModel for proper OpenAPI schema generation with strong typing.
 */
export type PredefinedPromptsResponse = Record<
  string,
  PredefinedPromptsResponsePredefinedPromptItem
>;

/**
 * PredefinedPromptItem
 * Individual prompt item for responses (without prompt_text for security).
 */
export interface PredefinedPromptsResponsePredefinedPromptItem {
  /**
   * Prompt Title
   * Display title for the prompt
   */
  prompt_title: string;
}

/** PrepareExposureForAggregativePaymentRequest */
export interface PrepareExposureForAggregativePaymentRequest {
  /** Coverage Id */
  coverage_id: number;
}

/** PrepareExposureForAggregativePaymentResponse */
export interface PrepareExposureForAggregativePaymentResponse {
  /** Deductible To Apply */
  deductible_to_apply: number;
  /** Exposure Id */
  exposure_id: number;
  /** Remaining To Pay */
  remaining_to_pay: number;
}

/** PrepareExposureForPaymentRequest */
export interface PrepareExposureForPaymentRequest {
  /** Amount */
  amount: number;
  /** Exposure Id */
  exposure_id: number;
}

/** PrepareExposureForPaymentResponse */
export interface PrepareExposureForPaymentResponse {
  /** Deductible To Apply */
  deductible_to_apply: number;
  /** Exposure Id */
  exposure_id: number;
  /** Remaining To Pay */
  remaining_to_pay: number;
}

/**
 * PreparedExternalCall
 * Everything the proxy Cloud Function needs to make one external-tool call itself.
 *
 * Returned by the ``external_tool/<tool_name>/prepare`` endpoint so CMS secrets and signing never
 * leave CMS: ``headers`` already carries the fixed HMAC / timestamp / contract-version signing
 * headers (merged over any configured extra headers; the fixed signing headers always win on a
 * name collision, case-insensitively), ``url`` is the configured URL with the config's query
 * params already composed onto it (each valued from what this call forwarded), and
 * ``response_json_schema`` is the tool's response contract the Cloud Function validates the
 * outbound response against.
 */
export interface PreparedExternalCall {
  /** Headers */
  headers: Record<string, string>;
  /** Response Json Schema */
  response_json_schema: Record<string, any>;
  /** Url */
  url: string;
}

/**
 * PreviewImportResponse
 * Response from previewing a snapshot before import.
 *
 * Returns everything the wizard needs to collect from the user before creating the organization.
 * @example {"email_domains":["claims-uat.fivesigma.tech"],"variables":[{"is_required":true,"name":"FALLBACK_USER","variable_type":"string"}]}
 */
export interface PreviewImportResponse {
  /**
   * Email Domains
   * Email domains found in the snapshot, for optional domain mapping
   */
  email_domains?: string[];
  /**
   * Variables
   * Config variable definitions that need bindings (name, variable_type, is_required)
   */
  variables?: Record<string, any>[];
}

/**
 * PromotionPreviewParams
 * Preview the change list a promotion would apply, without persisting anything.
 */
export interface PromotionPreviewParams {
  /** Pairing Id */
  pairing_id: number;
}

/**
 * PromotionPreviewResult
 * Preview output: the flat change list (FE groups by ``configuration_type``) + per-type counts,
 * plus the durable handoff to create.
 *
 * ``preview_token`` resolves the server-side handoff (source snapshot id + reviewed diff) at create.
 * Only the change list + summary + token cross the wire — never the config zips. ``new_members`` lists the
 * NEW LOB / sub-org members this diff would create (empty for the common no-new-member case); the FE shows
 * the interim opt-in step only when it is non-empty. It is re-derived from the diff on every preview/refine.
 */
export interface PromotionPreviewResult {
  /**
   * Blocked Sections
   * @default []
   */
  blocked_sections?: PromotionPreviewResultPromotionBlockedSection[];
  /** Changes */
  changes: Record<string, any>[];
  /**
   * The NEW LOB / sub-organization members a promotion's diff would create — derived from the diff's
   * member-defining CREATE changes on every preview/refine (never persisted separately), so it is always
   * authoritative. Drives the FE interim step instead of the FE sniffing raw change dicts.
   * @default {"lobs":[],"sub_organizations":[]}
   */
  new_members?: PromotionPreviewResultPromotionNewMembers;
  /** Preview Token */
  preview_token: string;
  /** Summary */
  summary: PromotionPreviewResultPromotionRequestTypeCounts[];
}

/**
 * PromotionBlockedSection
 * A configuration section left out of a preview because one side's export of it is blocked. It is absent
 * from the change list (not diffed at all). ``reasons`` are the per-offender sentences; they can name a
 * user's personal collection, so they are recomputed per request and never stored.
 */
export interface PromotionPreviewResultPromotionBlockedSection {
  /** Configuration Type */
  configuration_type: string;
  /** Reasons */
  reasons: string[];
  /** Side */
  side: "source" | "target";
}

/**
 * PromotionNewMember
 * A NEW LOB or sub-organization a promotion would create on the target — a candidate for the interim
 * "new members in this promotion" opt-in step. ``external_id`` is the member's stable identity key (the
 * LOB code / sub-org external_id); ``display_name`` is the human label (falls back to ``external_id``
 * when the member schema carries none).
 */
export interface PromotionPreviewResultPromotionNewMember {
  /** Display Name */
  display_name: string;
  /** External Id */
  external_id: string;
}

/**
 * PromotionNewMembers
 * The NEW LOB / sub-organization members a promotion's diff would create — derived from the diff's
 * member-defining CREATE changes on every preview/refine (never persisted separately), so it is always
 * authoritative. Drives the FE interim step instead of the FE sniffing raw change dicts.
 */
export interface PromotionPreviewResultPromotionNewMembers {
  /**
   * Lobs
   * @default []
   */
  lobs?: PromotionPreviewResultPromotionNewMember[];
  /**
   * Sub Organizations
   * @default []
   */
  sub_organizations?: PromotionPreviewResultPromotionNewMember[];
}

/**
 * PromotionRequestTypeCounts
 * Per-configuration-type CREATE/UPDATE/DELETE counts for a change list.
 */
export interface PromotionPreviewResultPromotionRequestTypeCounts {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Create Count
   * @default 0
   */
  create_count?: number;
  /**
   * Delete Count
   * @default 0
   */
  delete_count?: number;
  /**
   * Update Count
   * @default 0
   */
  update_count?: number;
}

/**
 * PromotionRequestInfo
 * Public representation of a created promotion request.
 *
 * Built from the target-side request, which carries no requester — attribution is source-side (see
 * ``ConfigurationPromotionOutgoing.requesting_user_id``).
 */
export interface PromotionRequestInfo {
  /** Approving User Id */
  approving_user_id: string | null;
  /** Changes Hash */
  changes_hash: string;
  /**
   * Conflict Detection Hash
   * @default null
   */
  conflict_detection_hash?: string | null;
  /** @default null */
  conflict_resolution?: PromotionRequestInfoPromotionConflictResolution | null;
  /**
   * Conflicts
   * @default []
   */
  conflicts?: PromotionRequestInfoPromotionConflictInfo[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Pairing Id */
  pairing_id: number;
  /** Reject Reason */
  reject_reason: string | null;
  /**
   * Request Name
   * @default null
   */
  request_name?: string | null;
  /** Request Uuid */
  request_uuid: string;
  /** Resolved At */
  resolved_at: string | null;
  /** Status */
  status: string;
  /** Summary */
  summary: PromotionRequestInfoPromotionRequestTypeCounts[];
}

/**
 * PromotionConflictInfo
 * A single per-change approve-time conflict surfaced to the approver: the previous/expected value the
 * promotion carries (``expected_old``) vs the current target value it would overwrite
 * (``actual_current``). API-facing — mapped from the facade ``ConflictInfo``; the engine/facade schema is
 * never exposed across the API boundary.
 */
export interface PromotionRequestInfoPromotionConflictInfo {
  /**
   * Actual Current
   * @default null
   */
  actual_current?: any;
  /** Change Id */
  change_id: string;
  /**
   * Expected Old
   * @default null
   */
  expected_old?: any;
  /** Field Path */
  field_path: string;
  /** Message */
  message: string;
}

/**
 * PromotionConflictResolution
 * The recorded outcome of an approver resolving conflicts: which conflicts they chose to override
 * (overwrite the target) vs skip (leave the target's current value). Persisted only on a committed
 * resolve; surfaced read-only on a resolved request. Who/when are on the request
 * (``approving_user_id`` / ``resolved_at``).
 */
export interface PromotionRequestInfoPromotionConflictResolution {
  /**
   * Overridden
   * @default []
   */
  overridden?: PromotionRequestInfoPromotionResolvedConflict[];
  /**
   * Skipped
   * @default []
   */
  skipped?: PromotionRequestInfoPromotionResolvedConflict[];
}

/**
 * PromotionRequestTypeCounts
 * Per-configuration-type CREATE/UPDATE/DELETE counts for a change list.
 */
export interface PromotionRequestInfoPromotionRequestTypeCounts {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Create Count
   * @default 0
   */
  create_count?: number;
  /**
   * Delete Count
   * @default 0
   */
  delete_count?: number;
  /**
   * Update Count
   * @default 0
   */
  update_count?: number;
}

/**
 * PromotionResolvedConflict
 * One conflict as recorded in the approver's resolution decision: the per-change conflict snapshot
 * (the previous/expected value and the target value at decision time). The promotion's written value is
 * recoverable from the change list, so it is not duplicated here.
 */
export interface PromotionRequestInfoPromotionResolvedConflict {
  /**
   * Actual Current
   * @default null
   */
  actual_current?: any;
  /** Change Id */
  change_id: string;
  /**
   * Expected Old
   * @default null
   */
  expected_old?: any;
  /** Field Path */
  field_path: string;
}

/**
 * ProviderStatusSyncResult
 * What the provider reported for one payment, and whether CMS moved the payment to match it.
 *
 * Returned by the provider handler and sent to the user unchanged: `message` is written for the person
 * who asked for the sync, and `is_changed` tells the screen whether the payment it shows is now stale.
 */
export interface ProviderStatusSyncResult {
  /** Is Changed */
  is_changed: boolean;
  /** Message */
  message: string;
}

/** PutCategoriesParams */
export interface PutCategoriesParams {
  /** Categories */
  categories: number[];
  /**
   * Claim Id
   * @default null
   */
  claim_id?: string | null;
}

/** PutControlFileJsonParams */
export interface PutControlFileJsonParams {
  /**
   * Control File Criteria
   * @default null
   */
  control_file_criteria?: string[] | null;
  /**
   * Control File Report Status
   * @default null
   */
  control_file_report_status?: string | null;
}

/** PutSiuJsonParams */
export interface PutSiuJsonParams {
  /**
   * Report Status
   * @default null
   */
  report_status?: string | null;
  /**
   * Siu Criteria
   * @default null
   */
  siu_criteria?: string[] | null;
}

/**
 * QueueVoicemailConfigurationInfo
 * Read-model for QueueVoicemailConfiguration ORM rows.
 *
 * Keyed by ``queue_sid`` — the immutable Twilio TaskQueue SID. The
 * friendly_name is not stored here; the FE correlates via the workspace
 * queue list when displaying.
 */
export interface QueueVoicemailConfigurationInfo {
  /** Id */
  id: number;
  /**
   * Notification User Id
   * @default null
   */
  notification_user_id?: string | null;
  /** Organization Id */
  organization_id: number;
  /** Queue Sid */
  queue_sid: string;
  /** @default null */
  voicemail_message_configuration?: QueueVoicemailConfigurationInfoVoiceMessageConfigurationInfo | null;
}

/**
 * VoiceMessageConfigurationInfo
 * Read-model for VoiceMessageConfiguration ORM rows.
 */
export interface QueueVoicemailConfigurationInfoVoiceMessageConfigurationInfo {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /** Id */
  id: number;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/**
 * QueueVoicemailConfigurationParams
 * PUT body for a per-queue override. All fields nullable — a null field
 * clears that specific override and falls back to the org default.
 */
export interface QueueVoicemailConfigurationParams {
  /**
   * Notification User Id
   * @default null
   */
  notification_user_id?: string | null;
  /** @default null */
  voicemail_message_configuration?: QueueVoicemailConfigurationParamsVoiceMessageConfigurationParams | null;
}

/** VoiceMessageConfigurationParams */
export interface QueueVoicemailConfigurationParamsVoiceMessageConfigurationParams {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/**
 * QueueVoicemailDefaultInfo
 * Read-model for the org-default voicemail config.
 *
 * ``task_timeout_seconds`` is read from TwilioConfiguration (our DB) and
 * emitted as a ``<Task timeout>`` attribute on every Enqueue TwiML.
 * ``fallback_notification_user_id`` is the bound value of the
 * ``VOICEMAIL_FALLBACK_USER`` config variable (or ``None`` if unbound).
 */
export interface QueueVoicemailDefaultInfo {
  /**
   * Fallback Notification User Id
   * @default null
   */
  fallback_notification_user_id?: string | null;
  /**
   * Task Timeout Seconds
   * @default null
   */
  task_timeout_seconds?: number | null;
  /** @default null */
  voicemail_message_configuration?: QueueVoicemailDefaultInfoVoiceMessageConfigurationInfo | null;
}

/**
 * VoiceMessageConfigurationInfo
 * Read-model for VoiceMessageConfiguration ORM rows.
 */
export interface QueueVoicemailDefaultInfoVoiceMessageConfigurationInfo {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /** Id */
  id: number;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /** Organization Id */
  organization_id: number;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/**
 * QueueVoicemailDefaultParams
 * PUT body for enable + update of org-level defaults.
 *
 * ``task_timeout_seconds`` is pushed through to the Twilio Workflow resource
 * on save; ``fallback_notification_user_id``, when supplied, binds the
 * ``VOICEMAIL_FALLBACK_USER`` config variable to that user in the same
 * request.
 */
export interface QueueVoicemailDefaultParams {
  /**
   * Fallback Notification User Id
   * @default null
   */
  fallback_notification_user_id?: string | null;
  /**
   * Task Timeout Seconds
   * @min 30
   * @max 1200
   * @default 60
   */
  task_timeout_seconds?: number;
  voicemail_message_configuration: QueueVoicemailDefaultParamsVoiceMessageConfigurationParams;
}

/** VoiceMessageConfigurationParams */
export interface QueueVoicemailDefaultParamsVoiceMessageConfigurationParams {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/**
 * RealTimeTokenResponse
 * Chat-scoped Firebase/Firestore credentials for subscribing to answer updates in real time.
 *
 * A thin pass-through of the AI service's ``IssueTokenResponse``. One token covers every exchange
 * in the chat: reuse it across exchanges and refresh before ``expires_at``.
 */
export interface RealTimeTokenResponse {
  /** Expires At */
  expires_at: string;
  /** Firebase Custom Token */
  firebase_custom_token: string;
  firebase_web_app_config: RealTimeTokenResponseFirebaseWebAppConfig;
  firestore_config: RealTimeTokenResponseFirestoreConnectionConfig;
  query_config: RealTimeTokenResponseFirestoreQueryConfig;
  /** Scopes */
  scopes?: Record<string, any>[];
}

/** FirebaseWebAppConfig */
export interface RealTimeTokenResponseFirebaseWebAppConfig {
  /** Api Key */
  api_key: string;
  /** App Id */
  app_id: string;
  /** Auth Domain */
  auth_domain: string;
  /**
   * Database Url
   * @default null
   */
  database_url?: string | null;
  /** Messaging Sender Id */
  messaging_sender_id: string;
  /** Project Id */
  project_id: string;
  /** Storage Bucket */
  storage_bucket: string;
}

/** FirestoreConnectionConfig */
export interface RealTimeTokenResponseFirestoreConnectionConfig {
  /** Collection Name */
  collection_name: string;
  /**
   * Database
   * @default null
   */
  database?: string | null;
  /**
   * Host
   * @default null
   */
  host?: string | null;
  /** Project Id */
  project_id: string;
}

/** FirestoreQueryConfig */
export interface RealTimeTokenResponseFirestoreQueryConfig {
  /**
   * Order By
   * @default null
   */
  order_by?: Record<string, any>[] | null;
  /** Where Clauses */
  where_clauses?: Record<string, any>[];
}

/**
 * RebuildIndexResponse
 * Response model for rebuild index operation.
 */
export interface RebuildIndexResponse {
  /** Message */
  message: string;
  /**
   * Stats
   * Statistics about the rebuilt index
   */
  stats?: Record<string, any>;
  /**
   * Success
   * @default true
   */
  success?: boolean;
}

/** RecipientOptionItemList */
export type RecipientOptionItemList =
  RecipientOptionItemListRecipientOptionItem[];

/**
 * RecipientOptionItem
 * One entry in the auto-comm recipient dropdown.
 */
export interface RecipientOptionItemListRecipientOptionItem {
  /** Desc */
  desc: string;
  /** Key */
  key: string;
}

/** RecordClaimMilestoneRequest */
export interface RecordClaimMilestoneRequest {
  /**
   * Occurred On
   * @format date
   */
  occurred_on: string;
}

/**
 * RecoveryRequestInfo
 * One recovery request as callers see it.
 */
export interface RecoveryRequestInfo {
  /** Claim Id */
  claim_id: number;
  /** Created Datetime */
  created_datetime: string | null;
  /** Currency */
  currency: string | null;
  /** What a caller sees: the stored lifecycle statuses plus the two settlement-derived ones. */
  derived_status: RecoveryRequestInfoRecoveryRequestDerivedStatus;
  /** Exposure Id */
  exposure_id: number | null;
  /** Failure Reason */
  failure_reason: string | null;
  /** General Recovery Type */
  general_recovery_type: string | null;
  /** Id */
  id: number;
  /** Payable Type */
  payable_type: string | null;
  /** Payer Contact Id */
  payer_contact_id: number;
  /** Provider Key */
  provider_key: string;
  /** Received Sum */
  received_sum: number;
  /** Requested Amount */
  requested_amount: number;
  /** Sent Datetime */
  sent_datetime: string | null;
  /** Status */
  status: string;
}

/** RecoveryRequestListQuery */
export interface RecoveryRequestListQuery {
  /**
   * Open Only
   * @default false
   */
  open_only?: boolean;
}

/** RecoveryRequestListResponse */
export interface RecoveryRequestListResponse {
  /** Recovery Requests */
  recovery_requests?: RecoveryRequestListResponseRecoveryRequestInfo[];
}

/**
 * RecoveryRequestInfo
 * One recovery request as callers see it.
 */
export interface RecoveryRequestListResponseRecoveryRequestInfo {
  /** Claim Id */
  claim_id: number;
  /** Created Datetime */
  created_datetime: string | null;
  /** Currency */
  currency: string | null;
  /** What a caller sees: the stored lifecycle statuses plus the two settlement-derived ones. */
  derived_status: RecoveryRequestListResponseRecoveryRequestDerivedStatus;
  /** Exposure Id */
  exposure_id: number | null;
  /** Failure Reason */
  failure_reason: string | null;
  /** General Recovery Type */
  general_recovery_type: string | null;
  /** Id */
  id: number;
  /** Payable Type */
  payable_type: string | null;
  /** Payer Contact Id */
  payer_contact_id: number;
  /** Provider Key */
  provider_key: string;
  /** Received Sum */
  received_sum: number;
  /** Requested Amount */
  requested_amount: number;
  /** Sent Datetime */
  sent_datetime: string | null;
  /** Status */
  status: string;
}

/**
 * RecoveryRequestsConfigInfo
 * Resolved configuration for one scope (an org row, or a sub-org row).
 */
export interface RecoveryRequestsConfigInfo {
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Provider Config
   * @default null
   */
  provider_config?: Record<string, string | null> | null;
  /**
   * Provider Config Is Inherited
   * @default false
   */
  provider_config_is_inherited?: boolean;
  /** Provider Key */
  provider_key: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/** RecoveryRequestsConfigInfoList */
export type RecoveryRequestsConfigInfoList =
  RecoveryRequestsConfigInfoListRecoveryRequestsConfigInfo[];

/**
 * RecoveryRequestsConfigInfo
 * Resolved configuration for one scope (an org row, or a sub-org row).
 */
export interface RecoveryRequestsConfigInfoListRecoveryRequestsConfigInfo {
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Provider Config
   * @default null
   */
  provider_config?: Record<string, string | null> | null;
  /**
   * Provider Config Is Inherited
   * @default false
   */
  provider_config_is_inherited?: boolean;
  /** Provider Key */
  provider_key: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * RefinePreviewParams
 * Re-project an existing preview's pinned exports under an opt-in NEW-member subset.
 *
 * ``preview_token`` resolves the stored handoff (the two pinned exports); ``included_new_member_ids`` is
 * the subset of ``new_members`` the caller keeps. References to opted-out members prune; the response
 * carries a fresh ``preview_token`` (same pinned exports) the FE then carries into ``create``.
 */
export interface RefinePreviewParams {
  /**
   * API opt-in set for a refine: the NEW-member ids the promotion keeps (creates) so co-promoted
   * references to them survive projection. A subset of the preview's ``new_members`` — the manager
   * validates it against the live diff (ids outside it → 422).
   */
  included_new_member_ids: RefinePreviewParamsScopeSelectionParams;
  /** Preview Token */
  preview_token: string;
}

/**
 * ScopeSelectionParams
 * API opt-in set for a refine: the NEW-member ids the promotion keeps (creates) so co-promoted
 * references to them survive projection. A subset of the preview's ``new_members`` — the manager
 * validates it against the live diff (ids outside it → 422).
 */
export interface RefinePreviewParamsScopeSelectionParams {
  /**
   * Lobs
   * @default []
   */
  lobs?: string[];
  /**
   * Sub Organizations
   * @default []
   */
  sub_organizations?: string[];
}

/** RegenerateExchangeRequest */
export interface RegenerateExchangeRequest {
  /**
   * Callback Url
   * @default null
   */
  callback_url?: string | null;
}

/**
 * RejectConductorAskRequest
 * The handler's reason for declining a request - what the agent reads on its next run.
 */
export interface RejectConductorAskRequest {
  /**
   * Reason
   * @minLength 1
   */
  reason: string;
}

/**
 * RejectPromotionParams
 * Reject a pending request (target-side) with a reason.
 */
export interface RejectPromotionParams {
  /**
   * Reason
   * @minLength 1
   */
  reason: string;
  /** Request Uuid */
  request_uuid: string;
}

/** RenameAgentConversationRequest */
export interface RenameAgentConversationRequest {
  /**
   * Title
   * @minLength 1
   * @maxLength 70
   */
  title: string;
}

/**
 * RenameChatRequest
 * Request schema for renaming a chat.
 */
export interface RenameChatRequest {
  /**
   * Title
   * @minLength 1
   * @maxLength 200
   */
  title: string;
}

/**
 * RenameChatResponse
 * Response schema for chat rename.
 */
export interface RenameChatResponse {
  /** Chat Title */
  chat_title: string;
  /** Id */
  id: number;
}

/** RenameRequest */
export interface RenameRequest {
  /**
   * Title
   * @minLength 1
   * @maxLength 200
   */
  title: string;
}

/** RenameResponse */
export interface RenameResponse {
  /** Chat Uid */
  chat_uid: string;
  /** Claim Number */
  claim_number: string;
  /** Title */
  title: string;
}

/** ReopenClaimParams */
export interface ReopenClaimParams {
  /** Note */
  note: string;
}

/** ReopenLegalActionPayload */
export interface ReopenLegalActionPayload {
  /** Reopen Reason */
  reopen_reason: string;
  /** Reopen Text */
  reopen_text: string;
}

/**
 * ReorderAssignmentRulesParams
 * One entity's rules in their new order.
 *
 * Claim rules and exposure rules are separate ordered lists, so a reorder names which one it is
 * reordering. ``ordered_ids`` is that list's whole target order, not a delta: it must name every
 * live rule of ``entity`` exactly once.
 */
export interface ReorderAssignmentRulesParams {
  /** Entity */
  entity: string;
  /** Ordered Ids */
  ordered_ids: number[];
}

/**
 * ReorderFundAccountRulesParams
 * The rule set's whole target order, not a delta: it must name every live fund-account
 * rule of the organization exactly once.
 */
export interface ReorderFundAccountRulesParams {
  /** Ordered Ids */
  ordered_ids: number[];
}

/**
 * ReorderGlobalFieldsParams
 * Body of the global-field reorder route.
 *
 * Reordering is scoped to one (placement, anchor) bucket because that is the unit the
 * projection orders within: a field's position is only ever compared with the positions of
 * fields sharing its placement and anchor. ``ordered_ids`` must therefore name every live field
 * of that bucket exactly once — a partial list has no meaning, since the positions it omits
 * would still be interleaved with the ones it sets.
 */
export interface ReorderGlobalFieldsParams {
  anchor: ReorderGlobalFieldsParamsGlobalFieldAnchor;
  /**
   * Ordered Ids
   * @minItems 1
   */
  ordered_ids: number[];
  placement: ReorderGlobalFieldsParamsGlobalFieldPlacement;
}

/**
 * ReorderMoiVendorAssignmentRulesParams
 * The whole target priority order; must name every live rule exactly once.
 */
export interface ReorderMoiVendorAssignmentRulesParams {
  /** Ordered Ids */
  ordered_ids: number[];
}

/**
 * ReportTemplateListResponse
 * Response schema for listing report templates.
 */
export interface ReportTemplateListResponse {
  /**
   * Templates
   * List of templates
   */
  templates?: ReportTemplateListResponseReportTemplateResponse[];
}

/**
 * MetabaseParameter
 * Schema for a Metabase question parameter (filter variable).
 */
export interface ReportTemplateListResponseMetabaseParameter {
  /**
   * Default
   * Default value for the parameter
   * @default null
   */
  default?: null;
  /**
   * Id
   * Parameter UUID
   */
  id: string;
  /**
   * Ismultiselect
   * Whether multiple values can be selected
   * @default false
   */
  isMultiSelect?: boolean;
  /**
   * Name
   * Human-readable parameter name
   */
  name: string;
  /**
   * Required
   * Whether the parameter must have a value
   * @default false
   */
  required?: boolean;
  /**
   * Slug
   * URL-friendly identifier matching the template-tag name
   */
  slug: string;
  /**
   * Target
   * Parameter-to-template-tag mapping
   */
  target?: any[];
  /**
   * Type
   * Parameter type, e.g., 'date/single', 'string/=', 'boolean/='
   */
  type: string;
  /**
   * Values Query Type
   * Type of values query to use for the parameter
   * @default null
   */
  values_query_type?: string | null;
}

/**
 * ReportTemplateResponse
 * Response schema for a report template.
 */
export interface ReportTemplateListResponseReportTemplateResponse {
  /**
   * Created At
   * Creation timestamp
   * @format date-time
   */
  created_at: string;
  /**
   * Created By Name
   * Display name of the creator
   * @default null
   */
  created_by_name?: string | null;
  /**
   * Created By User Id
   * User ID of the creator
   */
  created_by_user_id: string;
  /**
   * File Name
   * Original filename of the uploaded template file
   */
  file_name: string;
  /**
   * Id
   * Template ID
   * @default null
   */
  id?: number | null;
  /**
   * Is Active
   * Whether the template is active
   */
  is_active: boolean;
  /**
   * Name
   * Template name
   */
  name: string;
  /**
   * Sheets
   * List of sheet configurations
   */
  sheets?: ReportTemplateListResponseReportTemplateSheetResponse[];
}

/**
 * ReportTemplateSheetResponse
 * Response schema for a single sheet within a report template.
 */
export interface ReportTemplateListResponseReportTemplateSheetResponse {
  /**
   * Display Name
   * User-provided display name for this sheet
   */
  display_name: string;
  /**
   * Extracted Variables
   * Variables extracted from the sheet
   */
  extracted_variables?: string[];
  /**
   * Id
   * Sheet ID
   * @default null
   */
  id?: number | null;
  /**
   * Matched Variables
   * Variables that match Metabase columns
   */
  matched_variables?: string[];
  /**
   * Metabase Parameters
   * Filter parameters/variables defined on the Metabase question
   */
  metabase_parameters?: ReportTemplateListResponseMetabaseParameter[];
  /**
   * Metabase Question Id
   * Linked Metabase question ID
   */
  metabase_question_id: number;
  /**
   * Metabase Question Name
   * Name of the linked Metabase question
   * @default null
   */
  metabase_question_name?: string | null;
  /**
   * Position
   * Order position of the sheet
   */
  position: number;
  /**
   * Sheet Name
   * Original sheet name from the Excel file
   */
  sheet_name: string;
  /**
   * Unmatched Variables
   * Variables that do not match any Metabase column
   */
  unmatched_variables?: string[];
}

/**
 * ReportTemplateResponse
 * Response schema for a report template.
 */
export interface ReportTemplateResponse {
  /**
   * Created At
   * Creation timestamp
   * @format date-time
   */
  created_at: string;
  /**
   * Created By Name
   * Display name of the creator
   * @default null
   */
  created_by_name?: string | null;
  /**
   * Created By User Id
   * User ID of the creator
   */
  created_by_user_id: string;
  /**
   * File Name
   * Original filename of the uploaded template file
   */
  file_name: string;
  /**
   * Id
   * Template ID
   * @default null
   */
  id?: number | null;
  /**
   * Is Active
   * Whether the template is active
   */
  is_active: boolean;
  /**
   * Name
   * Template name
   */
  name: string;
  /**
   * Sheets
   * List of sheet configurations
   */
  sheets?: ReportTemplateResponseReportTemplateSheetResponse[];
}

/**
 * MetabaseParameter
 * Schema for a Metabase question parameter (filter variable).
 */
export interface ReportTemplateResponseMetabaseParameter {
  /**
   * Default
   * Default value for the parameter
   * @default null
   */
  default?: null;
  /**
   * Id
   * Parameter UUID
   */
  id: string;
  /**
   * Ismultiselect
   * Whether multiple values can be selected
   * @default false
   */
  isMultiSelect?: boolean;
  /**
   * Name
   * Human-readable parameter name
   */
  name: string;
  /**
   * Required
   * Whether the parameter must have a value
   * @default false
   */
  required?: boolean;
  /**
   * Slug
   * URL-friendly identifier matching the template-tag name
   */
  slug: string;
  /**
   * Target
   * Parameter-to-template-tag mapping
   */
  target?: any[];
  /**
   * Type
   * Parameter type, e.g., 'date/single', 'string/=', 'boolean/='
   */
  type: string;
  /**
   * Values Query Type
   * Type of values query to use for the parameter
   * @default null
   */
  values_query_type?: string | null;
}

/**
 * ReportTemplateSheetResponse
 * Response schema for a single sheet within a report template.
 */
export interface ReportTemplateResponseReportTemplateSheetResponse {
  /**
   * Display Name
   * User-provided display name for this sheet
   */
  display_name: string;
  /**
   * Extracted Variables
   * Variables extracted from the sheet
   */
  extracted_variables?: string[];
  /**
   * Id
   * Sheet ID
   * @default null
   */
  id?: number | null;
  /**
   * Matched Variables
   * Variables that match Metabase columns
   */
  matched_variables?: string[];
  /**
   * Metabase Parameters
   * Filter parameters/variables defined on the Metabase question
   */
  metabase_parameters?: ReportTemplateResponseMetabaseParameter[];
  /**
   * Metabase Question Id
   * Linked Metabase question ID
   */
  metabase_question_id: number;
  /**
   * Metabase Question Name
   * Name of the linked Metabase question
   * @default null
   */
  metabase_question_name?: string | null;
  /**
   * Position
   * Order position of the sheet
   */
  position: number;
  /**
   * Sheet Name
   * Original sheet name from the Excel file
   */
  sheet_name: string;
  /**
   * Unmatched Variables
   * Variables that do not match any Metabase column
   */
  unmatched_variables?: string[];
}

/**
 * RequestStatusResponse
 * The authoritative status + terminal reason of a target-side request (wraps the internal
 * ``RequestStatusSnapshot`` for the wire).
 */
export interface RequestStatusResponse {
  /**
   * Reject Reason
   * @default null
   */
  reject_reason?: string | null;
  /** Status */
  status: string;
}

/** ResolvedClaimFieldsResponse */
export interface ResolvedClaimFieldsResponse {
  /** Claim Bar */
  claim_bar: ResolvedClaimFieldsResponseResolvedClaimFieldEntry[];
  /** Claim Id */
  claim_id: number;
}

/**
 * EnumOption
 * A selectable value for a string-shaped field (select, multiselect, us_state_select, etc.).
 */
export interface ResolvedClaimFieldsResponseEnumOption {
  /** Label */
  label: string;
  /** Value */
  value: string;
}

/**
 * ResolvedClaimFieldEntry
 * One claim bar field as a claim renders it. A built-in key carries no ``source``; the claim screen
 * renders those itself.
 */
export interface ResolvedClaimFieldsResponseResolvedClaimFieldEntry {
  /** Display Name */
  display_name: string;
  /**
   * Enum Values
   * @default null
   */
  enum_values?: ResolvedClaimFieldsResponseEnumOption[] | null;
  /** Field Key */
  field_key:
    | "claim_number"
    | "policy_number"
    | "sub_organization"
    | "policyholder"
    | "preferred_contact"
    | "time_of_loss"
    | "date_of_report"
    | "file_owner"
    | "days_open"
    | "incident_type"
    | "reporter"
    | "claim_alerts"
    | "claim_stage"
    | "claim_flags"
    | "claim_complexity"
    | "broker"
    | "conductor_handling"
    | string;
  /** @default null */
  field_type?: ResolvedClaimFieldsResponseFieldType | null;
  /** Hints */
  hints?: Record<string, any>;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Source
   * @default null
   */
  source?: "api" | "configured_fields" | null;
  /**
   * Value
   * @default null
   */
  value?: any;
  /**
   * Value Labels
   * @default null
   */
  value_labels?: Record<string, string> | null;
}

/**
 * RetrievePolicyByApiV2Request
 * Body of ``POST /policies/retrieve_policy_by_api_v2``.
 *
 * ``min_length=1`` is the point of the model: the token is forwarded straight into the carrier's
 * query string, so an absent or empty one used to reach the carrier as the literal string
 * ``retrieval_token=None``.
 */
export interface RetrievePolicyByApiV2Request {
  /**
   * Retrieval Token
   * @minLength 1
   */
  retrieval_token: string;
}

/**
 * RollbackPreviewParams
 * Preview rolling back a deployed promotion (target-side), identified by its request uuid.
 */
export interface RollbackPreviewParams {
  /** Request Uuid */
  request_uuid: string;
}

/**
 * RollbackPreviewResult
 * Preview output for a rollback: whether the promotion is rollbackable and, if so, the restore change
 * list (FE groups by ``configuration_type``) + per-type counts + any post-deploy drift as conflicts.
 *
 * ``rollbackable`` is False for a fail-closed refusal (not the latest deployment, not deployed, missing a
 * snapshot, or an un-appliable restore), with ``blocked_reason`` carrying the operator-facing message and
 * the change/conflict fields left empty. When True, conflicts do NOT block — they are resolvable exactly
 * like an approve, and ``conflict_detection_hash`` is echoed back on the resolve as the stale-override
 * guard.
 *
 * ``blocked_sections`` (``side`` is always ``'target'``) are the sections the restore leaves out because the
 * target's export of them is blocked; the rollback must acknowledge them. They are also listed when a second
 * rollback is refused because the sections it would restore are still blocked.
 */
export interface RollbackPreviewResult {
  /**
   * Blocked Reason
   * @default null
   */
  blocked_reason?: string | null;
  /**
   * Blocked Sections
   * @default []
   */
  blocked_sections?: RollbackPreviewResultPromotionBlockedSection[];
  /**
   * Changes
   * @default []
   */
  changes?: Record<string, any>[];
  /**
   * Conflict Detection Hash
   * @default null
   */
  conflict_detection_hash?: string | null;
  /**
   * Conflicts
   * @default []
   */
  conflicts?: RollbackPreviewResultPromotionConflictInfo[];
  /** Rollbackable */
  rollbackable: boolean;
  /**
   * Summary
   * @default []
   */
  summary?: RollbackPreviewResultPromotionRequestTypeCounts[];
}

/**
 * PromotionBlockedSection
 * A configuration section left out of a preview because one side's export of it is blocked. It is absent
 * from the change list (not diffed at all). ``reasons`` are the per-offender sentences; they can name a
 * user's personal collection, so they are recomputed per request and never stored.
 */
export interface RollbackPreviewResultPromotionBlockedSection {
  /** Configuration Type */
  configuration_type: string;
  /** Reasons */
  reasons: string[];
  /** Side */
  side: "source" | "target";
}

/**
 * PromotionConflictInfo
 * A single per-change approve-time conflict surfaced to the approver: the previous/expected value the
 * promotion carries (``expected_old``) vs the current target value it would overwrite
 * (``actual_current``). API-facing — mapped from the facade ``ConflictInfo``; the engine/facade schema is
 * never exposed across the API boundary.
 */
export interface RollbackPreviewResultPromotionConflictInfo {
  /**
   * Actual Current
   * @default null
   */
  actual_current?: any;
  /** Change Id */
  change_id: string;
  /**
   * Expected Old
   * @default null
   */
  expected_old?: any;
  /** Field Path */
  field_path: string;
  /** Message */
  message: string;
}

/**
 * PromotionRequestTypeCounts
 * Per-configuration-type CREATE/UPDATE/DELETE counts for a change list.
 */
export interface RollbackPreviewResultPromotionRequestTypeCounts {
  /** Configuration Type */
  configuration_type: string;
  /**
   * Create Count
   * @default 0
   */
  create_count?: number;
  /**
   * Delete Count
   * @default 0
   */
  delete_count?: number;
  /**
   * Update Count
   * @default 0
   */
  update_count?: number;
}

/**
 * RollbackPromotionParams
 * Roll back a deployed promotion (target-side), restoring the objects it changed to their pre-apply
 * values.
 *
 * Phase 1 (report): ``override_change_ids`` omitted — detect post-deploy drift and, if any, surface it as
 * conflicts to resolve. Phase 2 (resolve): ``override_change_ids`` carries the conflicting change ids the
 * operator chose to restore anyway, and ``expected_conflict_hash`` is the hash the conflicts were reported
 * under (the stale-override guard). ``rollback_reason`` is the operator's free-text "why".
 *
 * ``acknowledged_blocked_configuration_types`` are the preview's ``blocked_sections`` the operator accepts
 * will NOT be restored by this rollback. It must match exactly the blocked sections the restore writes, as
 * re-checked against the live target, or the rollback is refused with nothing applied.
 */
export interface RollbackPromotionParams {
  /**
   * Acknowledged Blocked Configuration Types
   * @default []
   */
  acknowledged_blocked_configuration_types?: string[];
  /**
   * Expected Conflict Hash
   * @default null
   */
  expected_conflict_hash?: string | null;
  /**
   * Override Change Ids
   * @default null
   */
  override_change_ids?: string[] | null;
  /** Request Uuid */
  request_uuid: string;
  /**
   * Rollback Reason
   * @default null
   */
  rollback_reason?: string | null;
}

/** RootModel[Annotated[Union[Annotated[AutoPolicyModel, Tag], Annotated[GeneralPolicyModel, Tag]], Discriminator]] */
export type RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminator =
  | RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorAutoPolicyModel
  | RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorGeneralPolicyModel;

/** AutoPolicyModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorAutoPolicyModel {
  /** Additional Fields */
  additional_fields: Record<string, any> | null;
  /** Api Uid */
  api_uid: string | null;
  /**
   * Broker Contact Ref Id
   * @default null
   */
  broker_contact_ref_id?: string | null;
  /** Cancelled Date */
  cancelled_date: string | null;
  /** Cancelled Time */
  cancelled_time: string | null;
  /** @default null */
  capacity_data?: RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCapacityDataResponseSchema | null;
  /**
   * Covered Vehicles
   * @default null
   */
  covered_vehicles?:
    | RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoveredVehicleModel[]
    | null;
  /** Created On */
  created_on: string | null;
  /** Custom Fields */
  custom_fields:
    | Record<
        string,
        RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorPolicyCustomFieldModel
      >[]
    | null;
  /**
   * Drivers Contact Ref Ids
   * @default null
   */
  drivers_contact_ref_ids?: string[] | null;
  /** Effective Date */
  effective_date: string | null;
  /** Effective Time */
  effective_time: string | null;
  /** Expiration Date */
  expiration_date: string | null;
  /** Expiration Time */
  expiration_time: string | null;
  /** External Id */
  external_id: string | null;
  /** Is Cancelled */
  is_cancelled: boolean;
  /** Is Claims Made */
  is_claims_made: boolean | null;
  /**
   * Is Manually Created
   * @default null
   */
  is_manually_created?: boolean | null;
  /**
   * Is Manually Filled
   * @default null
   */
  is_manually_filled?: boolean | null;
  /** Last Modified On */
  last_modified_on: string | null;
  /** Limit Per Claim */
  limit_per_claim: number | null;
  /** Limit Per Policy */
  limit_per_policy: number | null;
  /**
   * Lob
   * Line of Business
   */
  lob: string;
  /**
   * Policy Country
   * @default null
   */
  policy_country?: string | null;
  /** Policy Document Url */
  policy_document_url: string | null;
  /** Policy Holder Contact Ref Id */
  policy_holder_contact_ref_id: string | null;
  /** Policy Number */
  policy_number: string;
  /** Policy Status */
  policy_status: string | null;
  /** Policy Type */
  policy_type: string | null;
  /**
   * Policy Us State
   * @default null
   */
  policy_us_state?: string | null;
  /** Renewal Date */
  renewal_date: string | null;
  /** Retroactive Date */
  retroactive_date: string | null;
  /** Retroactive Time */
  retroactive_time: string | null;
  /** Runoff Provision */
  runoff_provision: number | null;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
  /** Version */
  version: 1;
}

/**
 * CapacityAgreementResponseSchema
 * Response schema for capacity agreement (AU: Binder, UK: BAA, US: MGA)
 */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCapacityAgreementResponseSchema {
  /** Agreement Number */
  agreement_number: string;
  /** Capacity Slots */
  capacity_slots: RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCapacitySlotResponseSchema[];
  /** Carrier Name */
  carrier_name: string;
  /** Effective Date */
  effective_date: string;
  /** Expiration Date */
  expiration_date: string;
  /** External Id */
  external_id: string;
  /** Lloyds Risk Code */
  lloyds_risk_code: string | null;
  /** Umr */
  umr: string | null;
}

/**
 * CapacityDataResponseSchema
 * Response schema for policy capacity data
 */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCapacityDataResponseSchema {
  /** Capacity Agreements */
  capacity_agreements: RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCapacityAgreementResponseSchema[];
}

/**
 * CapacitySlotResponseSchema
 * Response schema for capacity slot (AU: Section)
 */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCapacitySlotResponseSchema {
  /** Details */
  details: string | null;
  /** External Id */
  external_id: string;
  /** Slot Name */
  slot_name: string;
  /** Slot Number */
  slot_number: number | null;
}

/** CoverageModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoverageModel {
  /**
   * Coinsurance Insurer Percentage
   * Percentage of insurance covered by insurer
   */
  coinsurance_insurer_percentage: number | null;
  /** Coverage Display Name */
  coverage_display_name: string;
  /** Coverage Key */
  coverage_key: string;
  /** Deductible */
  deductible: number | null;
  /** Is Covered */
  is_covered: boolean;
  /** Limit Per Incident */
  limit_per_incident: number | null;
  /** Limit Per Person */
  limit_per_person: number | null;
  /** Limit Per Policy Per Entity */
  limit_per_policy_per_entity: number | null;
  /**
   * Participations
   * @default null
   */
  participations?:
    | RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoverageParticipationResponseSchema[]
    | null;
}

/** CoverageObjectModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoverageObjectModel {
  /** Coverages */
  coverages:
    | RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoverageModel[]
    | null;
  /**
   * Deductible Per Policy Per Covered Entity
   * @default null
   */
  deductible_per_policy_per_covered_entity?: number | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * Limit Per Covered Entity
   * @default null
   */
  limit_per_covered_entity?: number | null;
  /**
   * Limit Per Policy Per Covered Entity
   * @default null
   */
  limit_per_policy_per_covered_entity?: number | null;
  /**
   * Shared Coverages
   * @default null
   */
  shared_coverages?:
    | RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorSharedCoverageModel[]
    | null;
}

/**
 * CoverageParticipationResponseSchema
 * Response schema for coverage participation (AU: multi-binder split)
 */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoverageParticipationResponseSchema {
  /** Allocation Percentage */
  allocation_percentage: string;
  /** Capacity Slot Id */
  capacity_slot_id: string | null;
  /** External Id */
  external_id: string;
  /** Is Lead */
  is_lead: boolean;
}

/** CoveredObjectModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoveredObjectModel {
  /** Additional Fields */
  additional_fields: Record<string, any> | null;
  coverage_object: RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoverageObjectModel;
  /** Display Name */
  display_name: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /** Type */
  type: string;
}

/** CoveredVehicleModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoveredVehicleModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  coverage_object: RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoverageObjectModel;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  vehicle: RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorVehicleDetailsModel;
}

/** GeneralPolicyModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorGeneralPolicyModel {
  /** Additional Fields */
  additional_fields: Record<string, any> | null;
  /** Api Uid */
  api_uid: string | null;
  /**
   * Broker Contact Ref Id
   * @default null
   */
  broker_contact_ref_id?: string | null;
  /** Cancelled Date */
  cancelled_date: string | null;
  /** Cancelled Time */
  cancelled_time: string | null;
  /** @default null */
  capacity_data?: RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCapacityDataResponseSchema | null;
  /**
   * Covered Objects
   * @default null
   */
  covered_objects?:
    | RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorCoveredObjectModel[]
    | null;
  /** Created On */
  created_on: string | null;
  /** Custom Fields */
  custom_fields:
    | Record<
        string,
        RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorPolicyCustomFieldModel
      >[]
    | null;
  /** Effective Date */
  effective_date: string | null;
  /** Effective Time */
  effective_time: string | null;
  /** Expiration Date */
  expiration_date: string | null;
  /** Expiration Time */
  expiration_time: string | null;
  /** External Id */
  external_id: string | null;
  /** Is Cancelled */
  is_cancelled: boolean;
  /** Is Claims Made */
  is_claims_made: boolean | null;
  /**
   * Is Manually Created
   * @default null
   */
  is_manually_created?: boolean | null;
  /**
   * Is Manually Filled
   * @default null
   */
  is_manually_filled?: boolean | null;
  /** Last Modified On */
  last_modified_on: string | null;
  /** Limit Per Claim */
  limit_per_claim: number | null;
  /** Limit Per Policy */
  limit_per_policy: number | null;
  /**
   * Lob
   * Line of Business
   */
  lob: string;
  /**
   * Policy Country
   * @default null
   */
  policy_country?: string | null;
  /** Policy Document Url */
  policy_document_url: string | null;
  /** Policy Holder Contact Ref Id */
  policy_holder_contact_ref_id: string | null;
  /** Policy Number */
  policy_number: string;
  /** Policy Status */
  policy_status: string | null;
  /** Policy Type */
  policy_type: string | null;
  /**
   * Policy Us State
   * @default null
   */
  policy_us_state?: string | null;
  /** Renewal Date */
  renewal_date: string | null;
  /** Retroactive Date */
  retroactive_date: string | null;
  /** Retroactive Time */
  retroactive_time: string | null;
  /** Runoff Provision */
  runoff_provision: number | null;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
  /** Version */
  version: 1;
}

/** PolicyCustomFieldModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorPolicyCustomFieldModel {
  /** Display Name */
  display_name: string;
  /** Value */
  value: string;
}

/** SharedCoverageModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorSharedCoverageModel {
  /**
   * Limit Per Incident
   * @default null
   */
  limit_per_incident?: number | null;
  /** Shared Coverage Display Name */
  shared_coverage_display_name: string;
  /** Shared Coverage Key */
  shared_coverage_key: string;
}

/** VehicleDetailsModel */
export interface RootModelAnnotatedUnionAnnotatedAutoPolicyModelTagAnnotatedGeneralPolicyModelTagDiscriminatorVehicleDetailsModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Claim Free Years
   * @default null
   */
  claim_free_years?: number | null;
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Engine Capacity
   * @default null
   */
  engine_capacity?: number | null;
  /**
   * Engine Type
   * @default null
   */
  engine_type?: string | null;
  /**
   * Existing Damage
   * @default null
   */
  existing_damage?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Fuel Type
   * @default null
   */
  fuel_type?: string | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: boolean | null;
  /**
   * Make
   * @default null
   */
  make?: string | null;
  /**
   * Make Ncic Code
   * NCIC code for the vehicle make
   * @default null
   */
  make_ncic_code?: string | null;
  /**
   * Mileage
   * @default null
   */
  mileage?: number | null;
  /**
   * Model
   * @default null
   */
  model?: string | null;
  /**
   * Number Of Seats
   * @default null
   */
  number_of_seats?: number | null;
  /**
   * Ownership Status
   * @default null
   */
  ownership_status?: string | null;
  /**
   * Plate Number
   * @default null
   */
  plate_number?: string | null;
  /**
   * Series
   * @default null
   */
  series?: string | null;
  /**
   * Vehicle Cost New
   * @default null
   */
  vehicle_cost_new?: number | null;
  /**
   * Vehicle Owner Contact Ref Id
   * @default null
   */
  vehicle_owner_contact_ref_id?: string | null;
  /**
   * Vehicle Plate State
   * @default null
   */
  vehicle_plate_state?: string | null;
  /**
   * Vehicle Type
   * @default null
   */
  vehicle_type?: string | null;
  /**
   * Vehicle Use
   * @default null
   */
  vehicle_use?: string | null;
  /**
   * Vehicle Value
   * @default null
   */
  vehicle_value?: number | null;
  /**
   * Vehicle Weight
   * @default null
   */
  vehicle_weight?: number | null;
  /**
   * Vin
   * Vehicle Identification Number
   * @default null
   */
  vin?: string | null;
  /**
   * Year
   * @default null
   */
  year?: number | null;
}

/** RootModel[Annotated[Union[Annotated[ClaimsPartialResponse, Tag], Annotated[ClaimsFullResponse, Tag]], Discriminator]] */
export type RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminator =
  | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorClaimsPartialResponse
  | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorClaimsFullResponse;

/** AccidentFollowUpModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorAccidentFollowUpModel {
  /**
   * Direction Ph Vehicle Was Going
   * @default null
   */
  direction_ph_vehicle_was_going?: string | null;
  /**
   * First Party Way Sign Or A Headlight
   * @default null
   */
  first_party_way_sign_or_a_headlight?: string | null;
  /**
   * Journey Purpose
   * @default null
   */
  journey_purpose?: string | null;
  /**
   * Street Condition
   * @default null
   */
  street_condition?: string | null;
  /**
   * Was Ambulance Called
   * @default null
   */
  was_ambulance_called?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Anyone Under The Influence Of Drugs Alcohol
   * @default null
   */
  was_anyone_under_the_influence_of_drugs_alcohol?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Was First Party Driver Using The Phone
   * @default null
   */
  was_first_party_driver_using_the_phone?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Weather Conditions
   * @default null
   */
  weather_conditions?: string | null;
  /**
   * Were First Party Vehicle Lights On
   * @default null
   */
  were_first_party_vehicle_lights_on?: "yes" | "no" | "na" | "unknown" | null;
}

/** AutoGenericPropertyModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorAutoGenericPropertyModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Damages */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /** Items */
  items?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyItemIncomingModel[];
  /** @default null */
  location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** Type */
  type: "generic_involved_property";
}

/** AutoIncidentAdditionalModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorAutoIncidentAdditionalModel {
  /** @default null */
  accident_follow_up?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorAccidentFollowUpModel | null;
  /**
   * Are Convictions Or Claims In The Last 5 Years
   * @default null
   */
  are_convictions_or_claims_in_the_last_5_years?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Convictions Or Claim Description
   * @default null
   */
  convictions_or_claim_description?: string | null;
  /**
   * Does Policyholder Second Occupation Exist
   * @default null
   */
  does_policyholder_second_occupation_exist?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /** @default null */
  fault_assessment?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorFaultAssessmentModel | null;
  /**
   * Is Policyholder Occupation Right
   * @default null
   */
  is_policyholder_occupation_right?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  police_and_fire_department?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPoliceAndFireDepartmentModel | null;
  /**
   * Policyholder Current Occupation
   * @default null
   */
  policyholder_current_occupation?: string | null;
  /**
   * Policyholder Second Occupation
   * @default null
   */
  policyholder_second_occupation?: string | null;
  /**
   * Replacement Car Rental Date
   * @default null
   */
  replacement_car_rental_date?: string | null;
  /** @default null */
  theft_follow_up?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorTheftFollowUpModel | null;
  /**
   * Was Replacement Car Rented
   * @default null
   */
  was_replacement_car_rented?: boolean | null;
}

/** BodilyInjuryLossModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorBodilyInjuryLossModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /** Bodily Injuries */
  bodily_injuries: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorBodilyInjuryModel[];
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /** Icd Codes */
  icd_codes: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorICDCodeModel[];
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/** ClaimInfoResponse */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorClaimInfoResponse {
  /** Claim Number */
  claim_number: string;
  /** Claim Status */
  claim_status: "open" | "closed" | "reopened";
  /**
   * Close Reason Display Name
   * @default null
   */
  close_reason_display_name?: string | null;
  /**
   * Close Reason Key
   * @default null
   */
  close_reason_key?: string | null;
  /**
   * Complexity
   * Deprecated. Use complexity_level instead
   * @default null
   */
  complexity?: string | null;
  /**
   * Complexity Level
   * Claim complexity level. One of: low, medium, high
   * @default null
   */
  complexity_level?: string | null;
  /**
   * Complexity Reason
   * Reason for the assigned complexity level
   * @default null
   */
  complexity_reason?: string | null;
  /** Contacts */
  contacts: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorContactModel[];
  /** Creation Datetime */
  creation_datetime: string | null;
  /** Exposures */
  exposures?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorExposureSummaryModel[];
  /** External Claim Numbers */
  external_claim_numbers: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorExternalClaimNumberExternalModel[];
  file_owner: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorUserExternalAPIBaseModel | null;
  /** Fnol Handler Contact Ref Id */
  fnol_handler_contact_ref_id: string | null;
  /** Fnol Method */
  fnol_method: string | null;
  incident_details: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorIncidentDetailsModel;
  /** Involved Parties */
  involved_parties?: (
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorGenericInvolvedPersonModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedGenericPropertyModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedDriverModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedPassengerModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedNonMotoristModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedVehicleModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorAutoGenericPropertyModel
  )[];
  /**
   * Is Manually Created
   * @default null
   */
  is_manually_created?: boolean | null;
  /**
   * Is Manually Filled
   * @default null
   */
  is_manually_filled?: boolean | null;
  /**
   * Legal Action Status
   * @default null
   */
  legal_action_status?: "Active" | "Closed" | null;
  /** Lob */
  lob: string;
  /** Policy External Id */
  policy_external_id: string | null;
  /** Policy Holder Contact Ref Id */
  policy_holder_contact_ref_id: string | null;
  /** Policy Number */
  policy_number: string;
  /** Reported Date */
  reported_date: string | null;
  /**
   * Stage Key
   * @default null
   */
  stage_key?: string | null;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
  /** Submission Mode */
  submission_mode: string | null;
}

/** ClaimSummarizedResponse */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorClaimSummarizedResponse {
  /** Claim Number */
  claim_number: string;
  /** Claim Status */
  claim_status: "open" | "closed" | "reopened";
  /** Contacts */
  contacts: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorContactModel[];
  /** Creation Datetime */
  creation_datetime: string | null;
  file_owner: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorUserExternalAPIBaseModel | null;
  incident_details: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorIncidentDetailsSummarizedModel;
  /**
   * Is Manually Created
   * @default null
   */
  is_manually_created?: boolean | null;
  /**
   * Is Manually Filled
   * @default null
   */
  is_manually_filled?: boolean | null;
  /** Lob */
  lob: string;
  /** Policy Holder Contact Ref Id */
  policy_holder_contact_ref_id: string | null;
  /** Policy Number */
  policy_number: string;
  /** Reported Date */
  reported_date: string | null;
  /**
   * Stage Key
   * @default null
   */
  stage_key?: string | null;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * ClaimsFullResponse
 * Response model for paginated claims data.
 *
 * Extends the base CursorPaginationResponse with claims-specific data.
 */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorClaimsFullResponse {
  /** Pagination metadata */
  metadata: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Partial Data
   * Indicates whether the response is partial or full data
   */
  partial_data: boolean;
  /**
   * Records
   * List of claims matching the filter criteria
   */
  records: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorClaimInfoResponse[];
}

/**
 * ClaimsPartialResponse
 * Response model for paginated claims data with partial_data=true.
 */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorClaimsPartialResponse {
  /** Pagination metadata */
  metadata: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Partial Data
   * Indicates whether the response is partial or full data
   */
  partial_data: boolean;
  /**
   * Records
   * List of claims with partial data
   */
  records: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorClaimSummarizedResponse[];
}

/** ContactEmailModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorContactEmailModel[]
    | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorContactPhoneModel[]
    | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ExposureSummaryModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorExposureSummaryModel {
  /** Coverage Display Name */
  coverage_display_name: string;
  /**
   * Coverage Group Display Name
   * @default null
   */
  coverage_group_display_name?: string | null;
  /**
   * Coverage Group Key
   * @default null
   */
  coverage_group_key?: string | null;
  /** Coverage Key */
  coverage_key: string;
  /** Exposure Number */
  exposure_number: string;
  /** Exposure Status */
  exposure_status: "open" | "closed";
  /**
   * Involved Api Uid
   * @default null
   */
  involved_api_uid?: string | null;
  /**
   * Involved External Id
   * @default null
   */
  involved_external_id?: string | null;
}

/** ExternalClaimNumberExternalModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorExternalClaimNumberExternalModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** External Claim Number */
  external_claim_number: string;
  /**
   * External Contact Ref Id
   * @default null
   */
  external_contact_ref_id?: string | null;
}

/** ExternalWitnessModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorExternalWitnessModel {
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
}

/** FaultAssessmentModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorFaultAssessmentModel {
  /**
   * Claim Handler Fault Assessment
   * @default null
   */
  claim_handler_fault_assessment?: string | null;
  /**
   * First Party Fault Assessment
   * @default null
   */
  first_party_fault_assessment?: string | null;
  /**
   * Is Fraud Review Needed
   * @default null
   */
  is_fraud_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Indemnity Review Needed
   * @default null
   */
  is_indemnity_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Liability Summary
   * @default null
   */
  liability_summary?: string | null;
  /**
   * Percentage Of Insured Liability
   * @default null
   */
  percentage_of_insured_liability?: string | null;
}

/** GenericInvolvedPersonModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorGenericInvolvedPersonModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorBodilyInjuryLossModel | null;
  /** Contact Ref Id */
  contact_ref_id: string;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPecuniaryLossDetailsModel | null;
  /** @default null */
  related_property_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyLossWithItemsModel | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: string;
}

/** ICDCodeModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** IncidentDetailsModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorIncidentDetailsModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** @default null */
  auto_incident_additional?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorAutoIncidentAdditionalModel | null;
  /**
   * Can Take Photos Of Damage
   * @default null
   */
  can_take_photos_of_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Cat Code
   * The catastrophe `code` of the linked cat event. Accepted as input (alternative to `cat_code_name`) and returned in responses. If both `cat_code` and `cat_code_name` are sent, they must reference the same cat.
   * @default null
   */
  cat_code?: string | null;
  /**
   * Cat Code Name
   * @default null
   */
  cat_code_name?: string | null;
  /**
   * Date Of Loss
   * @format date
   */
  date_of_loss: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Did Anyone Take Photos Or Video
   * @default null
   */
  did_anyone_take_photos_or_video?: "yes" | "no" | "na" | "unknown" | null;
  /** Incident Sub Type */
  incident_sub_type: string;
  /** Incident Type */
  incident_type: string;
  /**
   * Is Notification Only
   * @default null
   */
  is_notification_only?: boolean | null;
  /**
   * Is Other Policy Covering
   * @default null
   */
  is_other_policy_covering?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  loss_location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel | null;
  /**
   * Other Policy Description
   * @default null
   */
  other_policy_description?: string | null;
  /**
   * Photographer Contact Ref Id
   * @default null
   */
  photographer_contact_ref_id?: string | null;
  /**
   * Preferred Contact Ref Id
   * @default null
   */
  preferred_contact_ref_id?: string | null;
  /**
   * Reporter Contact Id
   * Required only if the field is active in the FNOL configuration for the organization.
   * @default null
   */
  reporter_contact_id?: string | null;
  /**
   * Special Internal Note
   * @default null
   */
  special_internal_note?: string | null;
  /**
   * Time Of Loss
   * Local wall-clock time of the loss (HH:MM), no timezone.
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Was Cctv Footage
   * @default null
   */
  was_cctv_footage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were There Any Witnesses
   * @default null
   */
  were_there_any_witnesses?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Witnesses
   * @default null
   */
  witnesses?:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorExternalWitnessModel[]
    | null;
  /**
   * Witnesses Note
   * @default null
   */
  witnesses_note?: string | null;
}

/** IncidentDetailsSummarizedModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorIncidentDetailsSummarizedModel {
  /** Date Of Loss */
  date_of_loss: string;
  /** Incident Sub Type */
  incident_sub_type: string;
  /** Incident Type */
  incident_type: string;
  /**
   * Time Of Loss
   * @default null
   */
  time_of_loss?: string | null;
}

/** InvolvedDriverModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedDriverModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Any Dvla Medical Conditions
   * @default null
   */
  any_dvla_medical_conditions?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Dvla Medical Conditions Description
   * @default null
   */
  dvla_medical_conditions_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * License Issuing State
   * @default null
   */
  license_issuing_state?: string | null;
  /**
   * License Number
   * @default null
   */
  license_number?: string | null;
  /**
   * License Type
   * @default null
   */
  license_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_driver";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Who Authorized The Driver To Drive The Vehicle
   * @default null
   */
  who_authorized_the_driver_to_drive_the_vehicle?: string | null;
  /**
   * Years Of Driving Experience
   * @default null
   */
  years_of_driving_experience?: number | null;
}

/** InvolvedGenericPropertyModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedGenericPropertyModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /** @default null */
  pecuniary_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPecuniaryLossDetailsModel | null;
  /** @default null */
  property_damage?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyDamageModel | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** @default null */
  related_property_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyLossWithItemsModel | null;
  /** Type */
  type: string;
}

/** InvolvedNonMotoristModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedNonMotoristModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /** Means Of Transportation */
  means_of_transportation: string;
  /**
   * Non Motorist Type
   * @deprecated
   * @default null
   */
  non_motorist_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_non_motorist";
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedPassengerModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedPassengerModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Position
   * @default null
   */
  position?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_passenger";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedVehicleModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorInvolvedVehicleModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Appraiser Contact Ref Id
   * @default null
   */
  appraiser_contact_ref_id?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Auto Repair Facility Contact Ref Id
   * @default null
   */
  auto_repair_facility_contact_ref_id?: string | null;
  /**
   * Child Seats
   * @default null
   */
  child_seats?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Covered Vehicle Id
   * @default null
   */
  covered_vehicle_id?: string | null;
  /**
   * Damage Areas
   * Areas of the vehicle that were damaged
   * @default null
   */
  damage_areas?: string[] | null;
  /**
   * Damage Description
   * @default null
   */
  damage_description?: string | null;
  /**
   * Damage Level
   * @default null
   */
  damage_level?: string | null;
  /**
   * Did Vehicle Have Previous Damage
   * @default null
   */
  did_vehicle_have_previous_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Does The Vehicle Have Any Modifications
   * @default null
   */
  does_the_vehicle_have_any_modifications?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is Car Safe To Drive
   * @default null
   */
  is_car_safe_to_drive?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Drivable
   * @default null
   */
  is_drivable?: "yes" | "no" | "na" | "unknown" | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Total Loss
   * @default null
   */
  is_total_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Tow
   * @default null
   */
  is_tow?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Active
   * @default null
   */
  is_vehicle_camera_active?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel | null;
  /**
   * Modification Description
   * @default null
   */
  modification_description?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Point Of Impact
   * @default null
   */
  point_of_impact?: string | null;
  /**
   * Previous Damage Description
   * @default null
   */
  previous_damage_description?: string | null;
  /**
   * Previous Damage Level
   * @default null
   */
  previous_damage_level?: string | null;
  /**
   * Scheduling Inspection Contact Ref Id
   * @default null
   */
  scheduling_inspection_contact_ref_id?: string | null;
  /**
   * Tower Contact Ref Id
   * @default null
   */
  tower_contact_ref_id?: string | null;
  /** Type */
  type: "involved_vehicle";
  /**
   * Detailed vehicle information
   * @default null
   */
  vehicle?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorVehicleDetailsModel | null;
  /**
   * Location details for the vehicle
   * @default null
   */
  vehicle_location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel | null;
  /**
   * Vehicle Speed
   * @default null
   */
  vehicle_speed?: string | null;
}

/** LocationModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/** PecuniaryLossDetailsModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPecuniaryLossDetailsModel {
  /** Losses */
  losses:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPecuniaryLossItemModel[]
    | null;
}

/** PecuniaryLossItemModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPecuniaryLossItemModel {
  /** Claimed Amount */
  claimed_amount: number | null;
  /** Claimed Loss */
  claimed_loss: string | null;
  /** Display Name */
  display_name: string | null;
  /** Note */
  note: string | null;
}

/** PoliceAndFireDepartmentModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPoliceAndFireDepartmentModel {
  /**
   * Did Speak With Officer
   * @default null
   */
  did_speak_with_officer?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Fire Department Description
   * @default null
   */
  fire_department_description?: string | null;
  /**
   * Pending Prosecutions Or Investigations Exists
   * @default null
   */
  pending_prosecutions_or_investigations_exists?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Police Crime Reference Number
   * @default null
   */
  police_crime_reference_number?: string | null;
  /**
   * Police Department Contact Ref Id
   * @default null
   */
  police_department_contact_ref_id?: string | null;
  /**
   * Police Description
   * @default null
   */
  police_description?: string | null;
  /**
   * Police Report
   * @default null
   */
  police_report?: string | null;
  /**
   * Violation Title
   * @default null
   */
  violation_title?: string | null;
  /**
   * Was Ticket Received
   * @default null
   */
  was_ticket_received?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Any Hazardous Good Being Carried
   * @default null
   */
  were_any_hazardous_good_being_carried?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Were Fire Department Involved
   * @default null
   */
  were_fire_department_involved?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Police Involved
   * @default null
   */
  were_police_involved?: "yes" | "no" | "na" | "unknown" | null;
}

/** PropertyDamageModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyDamageModel {
  /** Is Property Stolen */
  is_property_stolen: boolean | null;
  location: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel;
  /** Note */
  note: string | null;
  /** Property Damages */
  property_damages: string[] | null;
  /** Property Damages Description */
  property_damages_description: string | null;
}

/** PropertyItemIncomingModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyItemOutgoingModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyItemOutgoingModel {
  /** Category */
  category: string | null;
  /** Claimed Amount */
  claimed_amount: number | null;
  /** Description */
  description: string | null;
  /** Purchase Date */
  purchase_date: string | null;
  /** Purchase Price */
  purchase_price: number | null;
  /** Quantity */
  quantity: number | null;
  /** Scheduled */
  scheduled: string | null;
}

/** PropertyLossWithItemsModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyLossWithItemsModel {
  /** Damages */
  damages: string[] | null;
  /** Damages Description */
  damages_description: string | null;
  /** Is Stolen */
  is_stolen: boolean | null;
  /** Items */
  items:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorPropertyItemOutgoingModel[]
    | null;
  /** @default null */
  location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel | null;
  /** Note */
  note: string | null;
}

/** TheftFollowUpModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorTheftFollowUpModel {
  /**
   * Belongings Stolen
   * @default null
   */
  belongings_stolen?: string | null;
  /**
   * Crime Reference Number
   * @default null
   */
  crime_reference_number?: string | null;
  /**
   * Current Num Of Keys
   * @default null
   */
  current_num_of_keys?: number | null;
  /**
   * Date Noticed Vehicle Missing
   * @default null
   */
  date_noticed_vehicle_missing?: string | null;
  /**
   * Date Vehicle Last Seen
   * @default null
   */
  date_vehicle_last_seen?: string | null;
  /**
   * Discovered The Loss Contact Ref Id
   * @default null
   */
  discovered_the_loss_contact_ref_id?: string | null;
  /**
   * Is Vehicle For Sale
   * @default null
   */
  is_vehicle_for_sale?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  keys_location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Num Of Keys Received On Purchase
   * @default null
   */
  num_of_keys_received_on_purchase?: number | null;
  /**
   * Person Liable For The Theft Is Known
   * @default null
   */
  person_liable_for_the_theft_is_known?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Security Devices Description
   * @default null
   */
  security_devices_description?: string | null;
  /**
   * Time Noticed Vehicle Missing
   * @default null
   */
  time_noticed_vehicle_missing?: string | null;
  /**
   * Time Vehicle Last Seen
   * @default null
   */
  time_vehicle_last_seen?: string | null;
  /**
   * Tracking Devices Description
   * @default null
   */
  tracking_devices_description?: string | null;
  /**
   * Vehicle Fitted With Security Devices
   * @default null
   */
  vehicle_fitted_with_security_devices?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Vehicle Fitted With Tracking Devices
   * @default null
   */
  vehicle_fitted_with_tracking_devices?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  vehicle_last_seen_location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorLocationModel | null;
  /**
   * Vehicle Windows Closed And Secured
   * @default null
   */
  vehicle_windows_closed_and_secured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Vehicle Found With Keys
   * @default null
   */
  was_vehicle_found_with_keys?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Belongings Stolen From Vehicle
   * @default null
   */
  were_belongings_stolen_from_vehicle?: "yes" | "no" | "na" | "unknown" | null;
}

/** UserExternalAPIBaseModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** VehicleDetailsModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullResponseTagDiscriminatorVehicleDetailsModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Claim Free Years
   * @default null
   */
  claim_free_years?: number | null;
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Engine Capacity
   * @default null
   */
  engine_capacity?: number | null;
  /**
   * Engine Type
   * @default null
   */
  engine_type?: string | null;
  /**
   * Existing Damage
   * @default null
   */
  existing_damage?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Fuel Type
   * @default null
   */
  fuel_type?: string | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: boolean | null;
  /**
   * Make
   * @default null
   */
  make?: string | null;
  /**
   * Make Ncic Code
   * NCIC code for the vehicle make
   * @default null
   */
  make_ncic_code?: string | null;
  /**
   * Mileage
   * @default null
   */
  mileage?: number | null;
  /**
   * Model
   * @default null
   */
  model?: string | null;
  /**
   * Number Of Seats
   * @default null
   */
  number_of_seats?: number | null;
  /**
   * Ownership Status
   * @default null
   */
  ownership_status?: string | null;
  /**
   * Plate Number
   * @default null
   */
  plate_number?: string | null;
  /**
   * Series
   * @default null
   */
  series?: string | null;
  /**
   * Vehicle Cost New
   * @default null
   */
  vehicle_cost_new?: number | null;
  /**
   * Vehicle Owner Contact Ref Id
   * @default null
   */
  vehicle_owner_contact_ref_id?: string | null;
  /**
   * Vehicle Plate State
   * @default null
   */
  vehicle_plate_state?: string | null;
  /**
   * Vehicle Type
   * @default null
   */
  vehicle_type?: string | null;
  /**
   * Vehicle Use
   * @default null
   */
  vehicle_use?: string | null;
  /**
   * Vehicle Value
   * @default null
   */
  vehicle_value?: number | null;
  /**
   * Vehicle Weight
   * @default null
   */
  vehicle_weight?: number | null;
  /**
   * Vin
   * Vehicle Identification Number
   * @default null
   */
  vin?: string | null;
  /**
   * Year
   * @default null
   */
  year?: number | null;
}

/** RootModel[Annotated[Union[Annotated[ClaimsPartialResponse, Tag], Annotated[ClaimsFullWithFlagsResponse, Tag]], Discriminator]] */
export type RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminator =
  | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorClaimsPartialResponse
  | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorClaimsFullWithFlagsResponse;

/** AccidentFollowUpModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorAccidentFollowUpModel {
  /**
   * Direction Ph Vehicle Was Going
   * @default null
   */
  direction_ph_vehicle_was_going?: string | null;
  /**
   * First Party Way Sign Or A Headlight
   * @default null
   */
  first_party_way_sign_or_a_headlight?: string | null;
  /**
   * Journey Purpose
   * @default null
   */
  journey_purpose?: string | null;
  /**
   * Street Condition
   * @default null
   */
  street_condition?: string | null;
  /**
   * Was Ambulance Called
   * @default null
   */
  was_ambulance_called?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Anyone Under The Influence Of Drugs Alcohol
   * @default null
   */
  was_anyone_under_the_influence_of_drugs_alcohol?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Was First Party Driver Using The Phone
   * @default null
   */
  was_first_party_driver_using_the_phone?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Weather Conditions
   * @default null
   */
  weather_conditions?: string | null;
  /**
   * Were First Party Vehicle Lights On
   * @default null
   */
  were_first_party_vehicle_lights_on?: "yes" | "no" | "na" | "unknown" | null;
}

/** AutoGenericPropertyModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorAutoGenericPropertyModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Damages */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /** Items */
  items?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyItemIncomingModel[];
  /** @default null */
  location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** Type */
  type: "generic_involved_property";
}

/** AutoIncidentAdditionalModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorAutoIncidentAdditionalModel {
  /** @default null */
  accident_follow_up?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorAccidentFollowUpModel | null;
  /**
   * Are Convictions Or Claims In The Last 5 Years
   * @default null
   */
  are_convictions_or_claims_in_the_last_5_years?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Convictions Or Claim Description
   * @default null
   */
  convictions_or_claim_description?: string | null;
  /**
   * Does Policyholder Second Occupation Exist
   * @default null
   */
  does_policyholder_second_occupation_exist?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /** @default null */
  fault_assessment?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorFaultAssessmentModel | null;
  /**
   * Is Policyholder Occupation Right
   * @default null
   */
  is_policyholder_occupation_right?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  police_and_fire_department?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPoliceAndFireDepartmentModel | null;
  /**
   * Policyholder Current Occupation
   * @default null
   */
  policyholder_current_occupation?: string | null;
  /**
   * Policyholder Second Occupation
   * @default null
   */
  policyholder_second_occupation?: string | null;
  /**
   * Replacement Car Rental Date
   * @default null
   */
  replacement_car_rental_date?: string | null;
  /** @default null */
  theft_follow_up?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorTheftFollowUpModel | null;
  /**
   * Was Replacement Car Rented
   * @default null
   */
  was_replacement_car_rented?: boolean | null;
}

/** BodilyInjuryLossModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorBodilyInjuryLossModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /** Bodily Injuries */
  bodily_injuries: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorBodilyInjuryModel[];
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /** Icd Codes */
  icd_codes: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorICDCodeModel[];
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/**
 * ClaimMilestoneSummaryModel
 * One of the claim's milestones and the date it was reached, null while the milestone is not recorded.
 * The shape the external Claims API lists on a claim.
 */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorClaimMilestoneSummaryModel {
  /** Key */
  key: string;
  /** Label */
  label: string;
  /**
   * Occurred On
   * @default null
   */
  occurred_on?: string | null;
}

/** ClaimSummarizedResponse */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorClaimSummarizedResponse {
  /** Claim Number */
  claim_number: string;
  /** Claim Status */
  claim_status: "open" | "closed" | "reopened";
  /** Contacts */
  contacts: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorContactModel[];
  /** Creation Datetime */
  creation_datetime: string | null;
  file_owner: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorUserExternalAPIBaseModel | null;
  incident_details: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorIncidentDetailsSummarizedModel;
  /**
   * Is Manually Created
   * @default null
   */
  is_manually_created?: boolean | null;
  /**
   * Is Manually Filled
   * @default null
   */
  is_manually_filled?: boolean | null;
  /** Lob */
  lob: string;
  /** Policy Holder Contact Ref Id */
  policy_holder_contact_ref_id: string | null;
  /** Policy Number */
  policy_number: string;
  /** Reported Date */
  reported_date: string | null;
  /**
   * Stage Key
   * @default null
   */
  stage_key?: string | null;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * ClaimsFullWithFlagsResponse
 * The customer Claims API's full-list response: identical to ClaimsFullResponse but each record
 * carries the applied claim flags and the claim's milestones (CustomerClaimRecordResponse). Kept
 * separate from the vendor model so the service-provider contract never advertises fields it doesn't
 * populate.
 */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorClaimsFullWithFlagsResponse {
  /** Pagination metadata */
  metadata: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Partial Data
   * Indicates whether the response is partial or full data
   */
  partial_data: boolean;
  /**
   * Records
   * List of claims matching the filter criteria
   */
  records: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorCustomerClaimRecordResponse[];
}

/**
 * ClaimsPartialResponse
 * Response model for paginated claims data with partial_data=true.
 */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorClaimsPartialResponse {
  /** Pagination metadata */
  metadata: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Partial Data
   * Indicates whether the response is partial or full data
   */
  partial_data: boolean;
  /**
   * Records
   * List of claims with partial data
   */
  records: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorClaimSummarizedResponse[];
}

/** ContactEmailModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorContactEmailModel[]
    | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorContactPhoneModel[]
    | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * CustomerClaimRecordResponse
 * The claim record the Claims API returns and the new-claim webhook delivers: the claim with its applied
 * claim flags and its milestones.
 */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorCustomerClaimRecordResponse {
  /**
   * Claim Flag Keys
   * Keys of the flags currently applied to the claim, in configured display order. Omitted from webhook deliveries to vendor / service-provider clients, which receive the flagless claim record.
   */
  claim_flag_keys?: string[];
  /**
   * Claim Flag Labels
   * Labels of the flags currently applied to the claim, parallel to claim_flag_keys. Omitted from webhook deliveries to vendor / service-provider clients, which receive the flagless claim record.
   */
  claim_flag_labels?: string[];
  /** Claim Number */
  claim_number: string;
  /** Claim Status */
  claim_status: "open" | "closed" | "reopened";
  /**
   * Close Reason Display Name
   * @default null
   */
  close_reason_display_name?: string | null;
  /**
   * Close Reason Key
   * @default null
   */
  close_reason_key?: string | null;
  /**
   * Complexity
   * Deprecated. Use complexity_level instead
   * @default null
   */
  complexity?: string | null;
  /**
   * Complexity Level
   * Claim complexity level. One of: low, medium, high
   * @default null
   */
  complexity_level?: string | null;
  /**
   * Complexity Reason
   * Reason for the assigned complexity level
   * @default null
   */
  complexity_reason?: string | null;
  /** Contacts */
  contacts: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorContactModel[];
  /** Creation Datetime */
  creation_datetime: string | null;
  /** Exposures */
  exposures?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorExposureSummaryModel[];
  /** External Claim Numbers */
  external_claim_numbers: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorExternalClaimNumberExternalModel[];
  file_owner: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorUserExternalAPIBaseModel | null;
  /** Fnol Handler Contact Ref Id */
  fnol_handler_contact_ref_id: string | null;
  /** Fnol Method */
  fnol_method: string | null;
  incident_details: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorIncidentDetailsModel;
  /** Involved Parties */
  involved_parties?: (
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorGenericInvolvedPersonModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedGenericPropertyModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedDriverModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedPassengerModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedNonMotoristModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedVehicleModel
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorAutoGenericPropertyModel
  )[];
  /**
   * Is Manually Created
   * @default null
   */
  is_manually_created?: boolean | null;
  /**
   * Is Manually Filled
   * @default null
   */
  is_manually_filled?: boolean | null;
  /**
   * Legal Action Status
   * @default null
   */
  legal_action_status?: "Active" | "Closed" | null;
  /** Lob */
  lob: string;
  /**
   * Milestones
   * Every enabled milestone in the claim's line of business and sub-organization scope, in configured order, with the date the claim reached it, or null while that date is not recorded. A milestone with conditions is listed only while the claim matches them. Empty while claim milestones are not enabled for the organization.
   */
  milestones: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorClaimMilestoneSummaryModel[];
  /** Policy External Id */
  policy_external_id: string | null;
  /** Policy Holder Contact Ref Id */
  policy_holder_contact_ref_id: string | null;
  /** Policy Number */
  policy_number: string;
  /** Reported Date */
  reported_date: string | null;
  /**
   * Stage Key
   * @default null
   */
  stage_key?: string | null;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
  /** Submission Mode */
  submission_mode: string | null;
}

/** ExposureSummaryModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorExposureSummaryModel {
  /** Coverage Display Name */
  coverage_display_name: string;
  /**
   * Coverage Group Display Name
   * @default null
   */
  coverage_group_display_name?: string | null;
  /**
   * Coverage Group Key
   * @default null
   */
  coverage_group_key?: string | null;
  /** Coverage Key */
  coverage_key: string;
  /** Exposure Number */
  exposure_number: string;
  /** Exposure Status */
  exposure_status: "open" | "closed";
  /**
   * Involved Api Uid
   * @default null
   */
  involved_api_uid?: string | null;
  /**
   * Involved External Id
   * @default null
   */
  involved_external_id?: string | null;
}

/** ExternalClaimNumberExternalModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorExternalClaimNumberExternalModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** External Claim Number */
  external_claim_number: string;
  /**
   * External Contact Ref Id
   * @default null
   */
  external_contact_ref_id?: string | null;
}

/** ExternalWitnessModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorExternalWitnessModel {
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
}

/** FaultAssessmentModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorFaultAssessmentModel {
  /**
   * Claim Handler Fault Assessment
   * @default null
   */
  claim_handler_fault_assessment?: string | null;
  /**
   * First Party Fault Assessment
   * @default null
   */
  first_party_fault_assessment?: string | null;
  /**
   * Is Fraud Review Needed
   * @default null
   */
  is_fraud_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Indemnity Review Needed
   * @default null
   */
  is_indemnity_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Liability Summary
   * @default null
   */
  liability_summary?: string | null;
  /**
   * Percentage Of Insured Liability
   * @default null
   */
  percentage_of_insured_liability?: string | null;
}

/** GenericInvolvedPersonModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorGenericInvolvedPersonModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorBodilyInjuryLossModel | null;
  /** Contact Ref Id */
  contact_ref_id: string;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPecuniaryLossDetailsModel | null;
  /** @default null */
  related_property_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyLossWithItemsModel | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: string;
}

/** ICDCodeModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** IncidentDetailsModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorIncidentDetailsModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** @default null */
  auto_incident_additional?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorAutoIncidentAdditionalModel | null;
  /**
   * Can Take Photos Of Damage
   * @default null
   */
  can_take_photos_of_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Cat Code
   * The catastrophe `code` of the linked cat event. Accepted as input (alternative to `cat_code_name`) and returned in responses. If both `cat_code` and `cat_code_name` are sent, they must reference the same cat.
   * @default null
   */
  cat_code?: string | null;
  /**
   * Cat Code Name
   * @default null
   */
  cat_code_name?: string | null;
  /**
   * Date Of Loss
   * @format date
   */
  date_of_loss: string;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Did Anyone Take Photos Or Video
   * @default null
   */
  did_anyone_take_photos_or_video?: "yes" | "no" | "na" | "unknown" | null;
  /** Incident Sub Type */
  incident_sub_type: string;
  /** Incident Type */
  incident_type: string;
  /**
   * Is Notification Only
   * @default null
   */
  is_notification_only?: boolean | null;
  /**
   * Is Other Policy Covering
   * @default null
   */
  is_other_policy_covering?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  loss_location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel | null;
  /**
   * Other Policy Description
   * @default null
   */
  other_policy_description?: string | null;
  /**
   * Photographer Contact Ref Id
   * @default null
   */
  photographer_contact_ref_id?: string | null;
  /**
   * Preferred Contact Ref Id
   * @default null
   */
  preferred_contact_ref_id?: string | null;
  /**
   * Reporter Contact Id
   * Required only if the field is active in the FNOL configuration for the organization.
   * @default null
   */
  reporter_contact_id?: string | null;
  /**
   * Special Internal Note
   * @default null
   */
  special_internal_note?: string | null;
  /**
   * Time Of Loss
   * Local wall-clock time of the loss (HH:MM), no timezone.
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Was Cctv Footage
   * @default null
   */
  was_cctv_footage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were There Any Witnesses
   * @default null
   */
  were_there_any_witnesses?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Witnesses
   * @default null
   */
  witnesses?:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorExternalWitnessModel[]
    | null;
  /**
   * Witnesses Note
   * @default null
   */
  witnesses_note?: string | null;
}

/** IncidentDetailsSummarizedModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorIncidentDetailsSummarizedModel {
  /** Date Of Loss */
  date_of_loss: string;
  /** Incident Sub Type */
  incident_sub_type: string;
  /** Incident Type */
  incident_type: string;
  /**
   * Time Of Loss
   * @default null
   */
  time_of_loss?: string | null;
}

/** InvolvedDriverModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedDriverModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Any Dvla Medical Conditions
   * @default null
   */
  any_dvla_medical_conditions?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Dvla Medical Conditions Description
   * @default null
   */
  dvla_medical_conditions_description?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * License Issuing State
   * @default null
   */
  license_issuing_state?: string | null;
  /**
   * License Number
   * @default null
   */
  license_number?: string | null;
  /**
   * License Type
   * @default null
   */
  license_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_driver";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Who Authorized The Driver To Drive The Vehicle
   * @default null
   */
  who_authorized_the_driver_to_drive_the_vehicle?: string | null;
  /**
   * Years Of Driving Experience
   * @default null
   */
  years_of_driving_experience?: number | null;
}

/** InvolvedGenericPropertyModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedGenericPropertyModel {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /** @default null */
  pecuniary_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPecuniaryLossDetailsModel | null;
  /** @default null */
  property_damage?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyDamageModel | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** @default null */
  related_property_loss?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyLossWithItemsModel | null;
  /** Type */
  type: string;
}

/** InvolvedNonMotoristModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedNonMotoristModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /** Means Of Transportation */
  means_of_transportation: string;
  /**
   * Non Motorist Type
   * @deprecated
   * @default null
   */
  non_motorist_type?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_non_motorist";
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedPassengerModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedPassengerModel {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** Bodily Injuries */
  bodily_injuries?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorBodilyInjuryModel[];
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Legal Venue Reason
   * Only present for US territory
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * Only present for US territory
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Position
   * @default null
   */
  position?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: "involved_passenger";
  /**
   * Vehicle Api Uid
   * @default null
   */
  vehicle_api_uid?: string | null;
  /**
   * Vehicle Id
   * @default null
   */
  vehicle_id?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Seat Belt Worn
   * @default null
   */
  was_seat_belt_worn?: "yes" | "no" | "na" | "unknown" | null;
}

/** InvolvedVehicleModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorInvolvedVehicleModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Appraiser Contact Ref Id
   * @default null
   */
  appraiser_contact_ref_id?: string | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Auto Repair Facility Contact Ref Id
   * @default null
   */
  auto_repair_facility_contact_ref_id?: string | null;
  /**
   * Child Seats
   * @default null
   */
  child_seats?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Configured Fields Values
   * Custom configured field values
   */
  configured_fields_values?: Record<string, any>;
  /**
   * Covered Vehicle Id
   * @default null
   */
  covered_vehicle_id?: string | null;
  /**
   * Damage Areas
   * Areas of the vehicle that were damaged
   * @default null
   */
  damage_areas?: string[] | null;
  /**
   * Damage Description
   * @default null
   */
  damage_description?: string | null;
  /**
   * Damage Level
   * @default null
   */
  damage_level?: string | null;
  /**
   * Did Vehicle Have Previous Damage
   * @default null
   */
  did_vehicle_have_previous_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Does The Vehicle Have Any Modifications
   * @default null
   */
  does_the_vehicle_have_any_modifications?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is Car Safe To Drive
   * @default null
   */
  is_car_safe_to_drive?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Drivable
   * @default null
   */
  is_drivable?: "yes" | "no" | "na" | "unknown" | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Total Loss
   * @default null
   */
  is_total_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Tow
   * @default null
   */
  is_tow?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Active
   * @default null
   */
  is_vehicle_camera_active?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel | null;
  /**
   * Modification Description
   * @default null
   */
  modification_description?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /**
   * Point Of Impact
   * @default null
   */
  point_of_impact?: string | null;
  /**
   * Previous Damage Description
   * @default null
   */
  previous_damage_description?: string | null;
  /**
   * Previous Damage Level
   * @default null
   */
  previous_damage_level?: string | null;
  /**
   * Scheduling Inspection Contact Ref Id
   * @default null
   */
  scheduling_inspection_contact_ref_id?: string | null;
  /**
   * Tower Contact Ref Id
   * @default null
   */
  tower_contact_ref_id?: string | null;
  /** Type */
  type: "involved_vehicle";
  /**
   * Detailed vehicle information
   * @default null
   */
  vehicle?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorVehicleDetailsModel | null;
  /**
   * Location details for the vehicle
   * @default null
   */
  vehicle_location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel | null;
  /**
   * Vehicle Speed
   * @default null
   */
  vehicle_speed?: string | null;
}

/** LocationModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/** PecuniaryLossDetailsModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPecuniaryLossDetailsModel {
  /** Losses */
  losses:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPecuniaryLossItemModel[]
    | null;
}

/** PecuniaryLossItemModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPecuniaryLossItemModel {
  /** Claimed Amount */
  claimed_amount: number | null;
  /** Claimed Loss */
  claimed_loss: string | null;
  /** Display Name */
  display_name: string | null;
  /** Note */
  note: string | null;
}

/** PoliceAndFireDepartmentModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPoliceAndFireDepartmentModel {
  /**
   * Did Speak With Officer
   * @default null
   */
  did_speak_with_officer?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Fire Department Description
   * @default null
   */
  fire_department_description?: string | null;
  /**
   * Pending Prosecutions Or Investigations Exists
   * @default null
   */
  pending_prosecutions_or_investigations_exists?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Police Crime Reference Number
   * @default null
   */
  police_crime_reference_number?: string | null;
  /**
   * Police Department Contact Ref Id
   * @default null
   */
  police_department_contact_ref_id?: string | null;
  /**
   * Police Description
   * @default null
   */
  police_description?: string | null;
  /**
   * Police Report
   * @default null
   */
  police_report?: string | null;
  /**
   * Violation Title
   * @default null
   */
  violation_title?: string | null;
  /**
   * Was Ticket Received
   * @default null
   */
  was_ticket_received?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Any Hazardous Good Being Carried
   * @default null
   */
  were_any_hazardous_good_being_carried?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Were Fire Department Involved
   * @default null
   */
  were_fire_department_involved?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Police Involved
   * @default null
   */
  were_police_involved?: "yes" | "no" | "na" | "unknown" | null;
}

/** PropertyDamageModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyDamageModel {
  /** Is Property Stolen */
  is_property_stolen: boolean | null;
  location: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel;
  /** Note */
  note: string | null;
  /** Property Damages */
  property_damages: string[] | null;
  /** Property Damages Description */
  property_damages_description: string | null;
}

/** PropertyItemIncomingModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyItemOutgoingModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyItemOutgoingModel {
  /** Category */
  category: string | null;
  /** Claimed Amount */
  claimed_amount: number | null;
  /** Description */
  description: string | null;
  /** Purchase Date */
  purchase_date: string | null;
  /** Purchase Price */
  purchase_price: number | null;
  /** Quantity */
  quantity: number | null;
  /** Scheduled */
  scheduled: string | null;
}

/** PropertyLossWithItemsModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyLossWithItemsModel {
  /** Damages */
  damages: string[] | null;
  /** Damages Description */
  damages_description: string | null;
  /** Is Stolen */
  is_stolen: boolean | null;
  /** Items */
  items:
    | RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorPropertyItemOutgoingModel[]
    | null;
  /** @default null */
  location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel | null;
  /** Note */
  note: string | null;
}

/** TheftFollowUpModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorTheftFollowUpModel {
  /**
   * Belongings Stolen
   * @default null
   */
  belongings_stolen?: string | null;
  /**
   * Crime Reference Number
   * @default null
   */
  crime_reference_number?: string | null;
  /**
   * Current Num Of Keys
   * @default null
   */
  current_num_of_keys?: number | null;
  /**
   * Date Noticed Vehicle Missing
   * @default null
   */
  date_noticed_vehicle_missing?: string | null;
  /**
   * Date Vehicle Last Seen
   * @default null
   */
  date_vehicle_last_seen?: string | null;
  /**
   * Discovered The Loss Contact Ref Id
   * @default null
   */
  discovered_the_loss_contact_ref_id?: string | null;
  /**
   * Is Vehicle For Sale
   * @default null
   */
  is_vehicle_for_sale?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  keys_location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Num Of Keys Received On Purchase
   * @default null
   */
  num_of_keys_received_on_purchase?: number | null;
  /**
   * Person Liable For The Theft Is Known
   * @default null
   */
  person_liable_for_the_theft_is_known?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Security Devices Description
   * @default null
   */
  security_devices_description?: string | null;
  /**
   * Time Noticed Vehicle Missing
   * @default null
   */
  time_noticed_vehicle_missing?: string | null;
  /**
   * Time Vehicle Last Seen
   * @default null
   */
  time_vehicle_last_seen?: string | null;
  /**
   * Tracking Devices Description
   * @default null
   */
  tracking_devices_description?: string | null;
  /**
   * Vehicle Fitted With Security Devices
   * @default null
   */
  vehicle_fitted_with_security_devices?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Vehicle Fitted With Tracking Devices
   * @default null
   */
  vehicle_fitted_with_tracking_devices?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  vehicle_last_seen_location?: RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorLocationModel | null;
  /**
   * Vehicle Windows Closed And Secured
   * @default null
   */
  vehicle_windows_closed_and_secured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Vehicle Found With Keys
   * @default null
   */
  was_vehicle_found_with_keys?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Belongings Stolen From Vehicle
   * @default null
   */
  were_belongings_stolen_from_vehicle?: "yes" | "no" | "na" | "unknown" | null;
}

/** UserExternalAPIBaseModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** VehicleDetailsModel */
export interface RootModelAnnotatedUnionAnnotatedClaimsPartialResponseTagAnnotatedClaimsFullWithFlagsResponseTagDiscriminatorVehicleDetailsModel {
  /**
   * Api Uid
   * @default null
   */
  api_uid?: string | null;
  /**
   * Claim Free Years
   * @default null
   */
  claim_free_years?: number | null;
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Engine Capacity
   * @default null
   */
  engine_capacity?: number | null;
  /**
   * Engine Type
   * @default null
   */
  engine_type?: string | null;
  /**
   * Existing Damage
   * @default null
   */
  existing_damage?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Fuel Type
   * @default null
   */
  fuel_type?: string | null;
  /**
   * Is Vehicle Camera Installed
   * @default null
   */
  is_vehicle_camera_installed?: boolean | null;
  /**
   * Make
   * @default null
   */
  make?: string | null;
  /**
   * Make Ncic Code
   * NCIC code for the vehicle make
   * @default null
   */
  make_ncic_code?: string | null;
  /**
   * Mileage
   * @default null
   */
  mileage?: number | null;
  /**
   * Model
   * @default null
   */
  model?: string | null;
  /**
   * Number Of Seats
   * @default null
   */
  number_of_seats?: number | null;
  /**
   * Ownership Status
   * @default null
   */
  ownership_status?: string | null;
  /**
   * Plate Number
   * @default null
   */
  plate_number?: string | null;
  /**
   * Series
   * @default null
   */
  series?: string | null;
  /**
   * Vehicle Cost New
   * @default null
   */
  vehicle_cost_new?: number | null;
  /**
   * Vehicle Owner Contact Ref Id
   * @default null
   */
  vehicle_owner_contact_ref_id?: string | null;
  /**
   * Vehicle Plate State
   * @default null
   */
  vehicle_plate_state?: string | null;
  /**
   * Vehicle Type
   * @default null
   */
  vehicle_type?: string | null;
  /**
   * Vehicle Use
   * @default null
   */
  vehicle_use?: string | null;
  /**
   * Vehicle Value
   * @default null
   */
  vehicle_value?: number | null;
  /**
   * Vehicle Weight
   * @default null
   */
  vehicle_weight?: number | null;
  /**
   * Vin
   * Vehicle Identification Number
   * @default null
   */
  vin?: string | null;
  /**
   * Year
   * @default null
   */
  year?: number | null;
}

/** RootModel[Annotated[Union[ChangeOwnerAutoRulesRequest, ChangeOwnerStaticRequest], Discriminator]] */
export type RootModelAnnotatedUnionChangeOwnerAutoRulesRequestChangeOwnerStaticRequestDiscriminator =
  | ({
      assignment_method: "auto_rules";
    } & RootModelAnnotatedUnionChangeOwnerAutoRulesRequestChangeOwnerStaticRequestDiscriminatorChangeOwnerAutoRulesRequest)
  | ({
      assignment_method: "static";
    } & RootModelAnnotatedUnionChangeOwnerAutoRulesRequestChangeOwnerStaticRequestDiscriminatorChangeOwnerStaticRequest);

/** ChangeOwnerAutoRulesRequest */
export interface RootModelAnnotatedUnionChangeOwnerAutoRulesRequestChangeOwnerStaticRequestDiscriminatorChangeOwnerAutoRulesRequest {
  /** Assignment Method */
  assignment_method: "auto_rules";
  /** Do Not Reassign Closed Exposures */
  do_not_reassign_closed_exposures: boolean;
  /** Note */
  note: string | null;
}

/** ChangeOwnerStaticRequest */
export interface RootModelAnnotatedUnionChangeOwnerAutoRulesRequestChangeOwnerStaticRequestDiscriminatorChangeOwnerStaticRequest {
  /**
   * Assignee User Email
   * Email of the adjuster to assign. Accepts either the user login email or the claims email address
   */
  assignee_user_email: string;
  /** Assignment Method */
  assignment_method: "static";
  /** Do Not Reassign Closed Exposures */
  do_not_reassign_closed_exposures: boolean;
  /** Note */
  note: string | null;
}

/** RuleAssigneeOptionInfoList */
export type RuleAssigneeOptionInfoList =
  RuleAssigneeOptionInfoListRuleAssigneeOptionInfo[];

/**
 * RuleAssigneeOptionInfo
 * One selectable assignee for a rule.
 *
 * ``key`` is the primitive the FE select binds to (MUI options need a primitive value);
 * ``kind`` + ``id`` are the tagged pair the FE submits for the chosen option.
 */
export interface RuleAssigneeOptionInfoListRuleAssigneeOptionInfo {
  /** Display Name */
  display_name: string;
  /** Id */
  id: string | number | null;
  /** Key */
  key: string | number;
  /** The four kinds an assignment rule's assignee can be. */
  kind: RuleAssigneeOptionInfoListRuleAssigneeKind;
}

/** RuleIdsResponse */
export interface RuleIdsResponse {
  /**
   * Extra Data
   * @default null
   */
  extra_data?: any;
  /** Ids */
  ids: string[];
  /** Results Truncated */
  results_truncated: boolean;
}

/** RulesByIdsResponse */
export interface RulesByIdsResponse {
  /**
   * Meta
   * @default null
   */
  meta?: any;
  /** Results */
  results: RulesByIdsResponseWorkflowRuleModel[];
}

/**
 * WorkflowRuleModel
 * Response model for workflow rules
 */
export interface RulesByIdsResponseWorkflowRuleModel {
  /** Action */
  action: Record<string, any>;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /**
   * Engine Configuration
   * @default null
   */
  engine_configuration?: Record<string, any> | null;
  /** Event Key */
  event_key: string;
  /** Id */
  id: string;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Lobs */
  lobs: string[];
  /** Priority */
  priority: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
  /**
   * Timeout Seconds
   * @default null
   */
  timeout_seconds?: number | null;
  /** Workflow Engine */
  workflow_engine: string;
  /**
   * Workflow Id
   * External workflow ID
   */
  workflow_id: string;
  /** Workflow Name */
  workflow_name: string;
}

/**
 * RulesEngineConditionFieldsParams
 * Query params for the framework QueryBuilder field-registry endpoint.
 *
 * ``rule_set_type`` is the consumer key registered via
 * ``ServiceRegistrationInfo.get_rule_set_configs`` (e.g.
 * ``'assignment_claim_rule'`` / ``'assignment_exposure_rule'``,
 * ``'autocomm'``, etc.).
 *
 * ``event_key`` narrows the catalog by the firing event's scope: a claim-scoped
 * event drops ``exposure.*`` and ``involved_party.*`` paths.
 *
 * ``lobs`` carries every LOB the rule is scoped to, repeated as
 * ``lobs[]=a&lobs[]=b`` on the wire exactly like ``sub_org_ids[]``. The catalog
 * is the intersection across them. ``is_all_lobs`` is the scope that list cannot
 * express — "every LOB the organization supports, including future ones", the
 * same ``lobs=None`` a saved all-LOBs rule carries. ``is_all_lobs`` takes precedence:
 * when it is set the endpoint ignores ``lobs[]`` (the flag is the whole LOB scope);
 * otherwise ``lobs[]`` must be present and names the scope.
 *
 * ``is_all_sub_orgs`` / ``sub_org_ids`` narrow enum enrichment to specific
 * sub-orgs' configs (None / all-flag → all sub-orgs). ``filtering_mode`` is
 * documented for forward compat; only ``INTERSECTION`` is wired through the
 * catalog flow today.
 */
export interface RulesEngineConditionFieldsParams {
  /**
   * Event Key
   * @default null
   */
  event_key?: string | null;
  /** @default "intersection" */
  filtering_mode?: RulesEngineConditionFieldsParamsFilteringMode;
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  "lobs[]": RulesEngineConditionFieldsParamsEnsuredListStr;
  /** Rule Set Type */
  rule_set_type: string;
  "sub_org_ids[]"?: RulesEngineConditionFieldsParamsEnsuredListInt;
}

export type RulesEngineConditionFieldsParamsEnsuredListInt = number[];

export type RulesEngineConditionFieldsParamsEnsuredListStr = string[];

/** SalvageFilterRequest */
export interface SalvageFilterRequest {
  /**
   * Completed Datetime End
   * Filter recoveries completed on or before this date (ISO 8601 format)
   * @default null
   */
  completed_datetime_end?: string | null;
  /**
   * Completed Datetime Start
   * Filter recoveries completed on or after this date (ISO 8601 format)
   * @default null
   */
  completed_datetime_start?: string | null;
  /**
   * Created Datetime End
   * Filter recoveries created on or before this date (ISO 8601 format)
   * @default null
   */
  created_datetime_end?: string | null;
  /**
   * Created Datetime Start
   * Filter recoveries created on or after this date (ISO 8601 format)
   * @default null
   */
  created_datetime_start?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
}

/**
 * SalvageRecoveredAmountsFilterRequest
 * Filters for the salvage recovered-amounts endpoint.
 */
export interface SalvageRecoveredAmountsFilterRequest {
  /**
   * Claim Number
   * Filter by claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * End Date
   * Only include recovered amounts on or before this recovery date
   * @default null
   */
  end_date?: string | null;
  /**
   * Exposure Number
   * Filter by exposure number
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Include Cancelled
   * Include cancelled recovered amounts (defaults to excluding them)
   * @default false
   */
  include_cancelled?: boolean | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Start Date
   * Only include recovered amounts on or after this recovery date
   * @default null
   */
  start_date?: string | null;
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * SalvageRecoveredAmountsListResponse
 * Response schema for the salvage recovered-amounts list endpoint.
 */
export interface SalvageRecoveredAmountsListResponse {
  /** Pagination metadata */
  metadata: SalvageRecoveredAmountsListResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * Salvage recovered-amount records
   */
  records: SalvageRecoveredAmountsListResponseSalvageRecoveredAmountResponse[];
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface SalvageRecoveredAmountsListResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/**
 * SalvageRecoveredAmountResponse
 * A single salvage recovered-amount line item.
 */
export interface SalvageRecoveredAmountsListResponseSalvageRecoveredAmountResponse {
  /**
   * Amount
   * Recovered amount
   * @default null
   */
  amount?: number | null;
  /**
   * Anticipated Amount
   * Anticipated recovery amount for the parent recovery
   * @default null
   */
  anticipated_amount?: number | null;
  /**
   * Cancellation Datetime
   * When the amount was cancelled (ISO 8601)
   * @default null
   */
  cancellation_datetime?: string | null;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Completed Datetime
   * When the parent recovery was completed (ISO 8601)
   * @default null
   */
  completed_datetime?: string | null;
  /**
   * Currency
   * Currency code
   * @default null
   */
  currency?: string | null;
  /**
   * Exposure Number
   * Exposure number, if the recovery is exposure-level
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Id
   * Recovered amount ID
   */
  id: number;
  /**
   * Is Cancelled
   * Whether this recovered amount has been cancelled
   */
  is_cancelled: boolean;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the amount
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * Recovery note
   * @default null
   */
  note?: string | null;
  /**
   * Parent Recovery Api Uid
   * API UID of the parent recovery case
   */
  parent_recovery_api_uid: string;
  /**
   * Recovery Created Datetime
   * When the parent recovery was created (ISO 8601)
   * @default null
   */
  recovery_created_datetime?: string | null;
  /**
   * Recovery Date
   * When the amount was recovered (ISO 8601)
   * @default null
   */
  recovery_date?: string | null;
  /**
   * Recovery Note
   * Parent-recovery-level note
   * @default null
   */
  recovery_note?: string | null;
  /**
   * Recovery Status
   * Parent recovery status
   */
  recovery_status: "open" | "completed";
  /**
   * Salvage Parts
   * Damaged vehicle parts (auto claims only)
   * @default null
   */
  salvage_parts?: string[] | null;
  /**
   * Vat Amount
   * GST/VAT amount included in the recovery
   * @default null
   */
  vat_amount?: number | null;
  /**
   * Vendor Referral Number
   * Vendor referral number
   * @default null
   */
  vendor_referral_number?: string | null;
}

/** SalvageRecoveryListResponse */
export interface SalvageRecoveryListResponse {
  /** Pagination metadata */
  metadata: SalvageRecoveryListResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * List of salvage recovery records for this page
   */
  records: SalvageRecoveryListResponseSalvageRecoveryResponse[];
}

/** ContactEmailModel */
export interface SalvageRecoveryListResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface SalvageRecoveryListResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: SalvageRecoveryListResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: SalvageRecoveryListResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface SalvageRecoveryListResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface SalvageRecoveryListResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/** SalvageRecoveryResponse */
export interface SalvageRecoveryListResponseSalvageRecoveryResponse {
  /**
   * Anticipated Salvage Amount
   * Anticipated salvage recovery amount
   * @default null
   */
  anticipated_salvage_amount?: number | null;
  /**
   * Api Uid
   * API identifier for the recovery
   */
  api_uid: string;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Completed Datetime
   * When recovery was completed (ISO 8601)
   * @default null
   */
  completed_datetime?: string | null;
  /**
   * Contacts
   * Array of contact models related to this recovery
   */
  contacts?: SalvageRecoveryListResponseContactModel[];
  /**
   * Created Datetime
   * When the recovery was created (ISO 8601)
   */
  created_datetime: string;
  /**
   * Currency
   * Currency code (e.g., 'USD')
   * @default null
   */
  currency?: string | null;
  /**
   * Exposure Number
   * Exposure number
   */
  exposure_number: string;
  /**
   * Note
   * Recovery notes
   * @default null
   */
  note?: string | null;
  /**
   * Reopened Datetime
   * When recovery was reopened (ISO 8601)
   * @default null
   */
  reopened_datetime?: string | null;
  /**
   * Salvage Parts
   * List of damaged vehicle parts for auto claims
   * @default null
   */
  salvage_parts?: string[] | null;
  /**
   * Salvage Recoveries Sum
   * Total amount recovered from salvage
   * @default null
   */
  salvage_recoveries_sum?: number | null;
  /**
   * Status
   * Recovery status
   */
  status: "completed" | "open";
  /**
   * Type
   * Recovery type
   */
  type: "salvage";
  /**
   * Vendor Contact Ref Id
   * Reference ID of the vendor contact
   * @default null
   */
  vendor_contact_ref_id?: string | null;
  /**
   * Vendor Referral Number
   * Vendor referral number
   * @default null
   */
  vendor_referral_number?: string | null;
}

/** SalvageRecoveryResponse */
export interface SalvageRecoveryResponse {
  /**
   * Anticipated Salvage Amount
   * Anticipated salvage recovery amount
   * @default null
   */
  anticipated_salvage_amount?: number | null;
  /**
   * Api Uid
   * API identifier for the recovery
   */
  api_uid: string;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Completed Datetime
   * When recovery was completed (ISO 8601)
   * @default null
   */
  completed_datetime?: string | null;
  /**
   * Contacts
   * Array of contact models related to this recovery
   */
  contacts?: SalvageRecoveryResponseContactModel[];
  /**
   * Created Datetime
   * When the recovery was created (ISO 8601)
   */
  created_datetime: string;
  /**
   * Currency
   * Currency code (e.g., 'USD')
   * @default null
   */
  currency?: string | null;
  /**
   * Exposure Number
   * Exposure number
   */
  exposure_number: string;
  /**
   * Note
   * Recovery notes
   * @default null
   */
  note?: string | null;
  /**
   * Reopened Datetime
   * When recovery was reopened (ISO 8601)
   * @default null
   */
  reopened_datetime?: string | null;
  /**
   * Salvage Parts
   * List of damaged vehicle parts for auto claims
   * @default null
   */
  salvage_parts?: string[] | null;
  /**
   * Salvage Recoveries Sum
   * Total amount recovered from salvage
   * @default null
   */
  salvage_recoveries_sum?: number | null;
  /**
   * Status
   * Recovery status
   */
  status: "completed" | "open";
  /**
   * Type
   * Recovery type
   */
  type: "salvage";
  /**
   * Vendor Contact Ref Id
   * Reference ID of the vendor contact
   * @default null
   */
  vendor_contact_ref_id?: string | null;
  /**
   * Vendor Referral Number
   * Vendor referral number
   * @default null
   */
  vendor_referral_number?: string | null;
}

/** ContactEmailModel */
export interface SalvageRecoveryResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface SalvageRecoveryResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: SalvageRecoveryResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: SalvageRecoveryResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface SalvageRecoveryResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * SaveConfigurationRequest
 * Request schema for saving SOP configuration.
 */
export interface SaveConfigurationRequest {
  /**
   * Markdown Pages
   * Processed markdown pages
   */
  markdown_pages: string[];
  /**
   * Sub Organization Id
   * Sub-organization ID (for Phase 2)
   * @default null
   */
  sub_organization_id?: string | null;
  /**
   * Toc Markdown
   * Generated table of contents
   */
  toc_markdown: string;
}

/** SaveInvoiceAndUpdateAiRequest */
export interface SaveInvoiceAndUpdateAiRequest {
  /** Analysis Results Id */
  analysis_results_id: string;
  invoice_analysis: SaveInvoiceAndUpdateAiRequestAiInvoiceAnalysis;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /** Invoice Document Source Id */
  invoice_document_source_id: string;
  /**
   * Invoice Number
   * @default null
   */
  invoice_number?: string | null;
  invoice_processing_type: SaveInvoiceAndUpdateAiRequestInvoiceProcessingType;
  /**
   * Vendor
   * @default null
   */
  vendor?: string | null;
}

/** AiCoverageItemData */
export interface SaveInvoiceAndUpdateAiRequestAiCoverageItemData {
  /** Amounts */
  amounts: Record<string, number>;
  /** Coverage */
  coverage: string;
  /** Id */
  id: string;
}

/** AiInvoiceAnalysis */
export interface SaveInvoiceAndUpdateAiRequestAiInvoiceAnalysis {
  /** Coverages */
  coverages: SaveInvoiceAndUpdateAiRequestAiCoverageItemData[];
  /** Line Items */
  line_items: SaveInvoiceAndUpdateAiRequestAiLineItemData[];
  /** Task Id */
  task_id: string;
}

/** AiLineItemData */
export interface SaveInvoiceAndUpdateAiRequestAiLineItemData {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: SaveInvoiceAndUpdateAiRequestCoverageDecisionOption;
  /**
   * Coverage Id
   * @default null
   */
  coverage_id?: number | null;
  /**
   * Coverage Key
   * @default null
   */
  coverage_key?: string | null;
  /**
   * Covered Amount
   * @default null
   */
  covered_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /** Id */
  id: string;
  /**
   * Is Depreciation Overridden
   * @default null
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default null
   */
  is_locked?: boolean | null;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: SaveInvoiceAndUpdateAiRequestPayableType | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/** SaveInvoiceRequest */
export interface SaveInvoiceRequest {
  /**
   * Complete Action Id
   * @default null
   */
  complete_action_id?: number | null;
  /** Document Id */
  document_id: number;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /**
   * Invoice Id
   * @default null
   */
  invoice_id?: number | null;
  /**
   * Invoice Number
   * @default null
   */
  invoice_number?: string | null;
  invoice_processing_type: SaveInvoiceRequestInvoiceProcessingType;
  /** Line Items */
  line_items: SaveInvoiceRequestDisplayedLineItemData[];
  /**
   * Vendor
   * @default null
   */
  vendor?: string | null;
}

/** DisplayedLineItemData */
export interface SaveInvoiceRequestDisplayedLineItemData {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: SaveInvoiceRequestCoverageDecisionOption;
  /**
   * Coverage Id
   * @default null
   */
  coverage_id?: number | null;
  /**
   * Coverage Key
   * @default null
   */
  coverage_key?: string | null;
  /**
   * Covered Amount
   * @default null
   */
  covered_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * Id
   * @default null
   */
  id?: string | number | null;
  /**
   * Is Depreciation Overridden
   * @default null
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default null
   */
  is_locked?: boolean | null;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: SaveInvoiceRequestPayableType | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/** SaveInvoiceResponse */
export interface SaveInvoiceResponse {
  invoice: SaveInvoiceResponseInvoiceResponse;
}

/** InvoiceResponse */
export interface SaveInvoiceResponseInvoiceResponse {
  /** Claim Id */
  claim_id: number;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Document Id */
  document_id: number;
  /** Excluded Amount */
  excluded_amount: number;
  /** Extra */
  extra: Record<string, any>;
  /** Id */
  id: number;
  /**
   * Invoice Currency
   * @default null
   */
  invoice_currency?: string | null;
  /** Invoice Date */
  invoice_date: string | null;
  /** Invoice Number */
  invoice_number: string;
  invoice_processing_type: SaveInvoiceResponseInvoiceProcessingType;
  /** Line Items */
  line_items: SaveInvoiceResponseLineItemResponse[];
  /** Not Covered Amount */
  not_covered_amount: number;
  /** Organization Id */
  organization_id: number;
  /** Submitted Amount */
  submitted_amount: number;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Vendor */
  vendor: string | null;
}

/** LineItemResponse */
export interface SaveInvoiceResponseLineItemResponse {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: SaveInvoiceResponseCoverageDecisionOption;
  /** Coverage Id */
  coverage_id: number | null;
  /** Coverage Key */
  coverage_key: string | null;
  /** Covered Amount */
  covered_amount: number;
  /**
   * Depreciation Applied Amount
   * @default null
   */
  depreciation_applied_amount?: number | null;
  /**
   * Depreciation Percentage
   * @default null
   */
  depreciation_percentage?: number | null;
  /** Description */
  description: string;
  /**
   * Entry Type
   * @default "line_item"
   */
  entry_type?: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /** Id */
  id: number;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /**
   * Is Depreciation Overridden
   * @default false
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default false
   */
  is_locked?: boolean;
  /**
   * Is Removed
   * @default false
   */
  is_removed?: boolean;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: SaveInvoiceResponsePayableType | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/**
 * ScanStateDTO
 * A file's scan state, as the rescan route answers it.
 */
export interface ScanStateDTO {
  /** Scan Message */
  scan_message: string | null;
  /**
   * The malware-scan verdict per uploaded file. ``ERROR`` blocks, exactly like ``SUSPICIOUS``.
   *
   * This path fails closed: a scan that errored is never treated as clean, and the recovery is a
   * rescan rather than an override.
   */
  scan_state: ScanStateDTODocumentRequestFileScanState;
  /** Uploaded File Id */
  uploaded_file_id: string;
}

/** ScheduledReportExportListResponse */
export interface ScheduledReportExportListResponse {
  /**
   * Schedules
   * List of scheduled report exports
   */
  schedules?: ScheduledReportExportListResponseScheduledReportExportResponse[];
}

/** ScheduledReportExportResponse */
export interface ScheduledReportExportListResponseScheduledReportExportResponse {
  /**
   * Created At
   * Creation timestamp
   * @format date-time
   */
  created_at: string;
  /**
   * Created By Name
   * Display name of the creator
   * @default null
   */
  created_by_name?: string | null;
  /**
   * Created By User Id
   * User ID of the creator
   */
  created_by_user_id: string;
  /**
   * Day Of Month
   * Day of month (1-28) for monthly recurrence
   * @default null
   */
  day_of_month?: number | null;
  /**
   * Display Name
   * Schedule display name
   */
  display_name: string;
  /**
   * End Date
   * End date for the schedule
   * @default null
   */
  end_date?: string | null;
  /**
   * Export Days
   * Days of the week to run
   */
  export_days?: string[];
  /**
   * Export Hour
   * Hour to run (HH:MM format)
   * @default null
   */
  export_hour?: string | null;
  /**
   * Id
   * Schedule ID
   * @default null
   */
  id?: number | null;
  /**
   * Is Active
   * Whether the schedule is active
   */
  is_active: boolean;
  /**
   * Last Run At
   * Last successful run timestamp
   * @default null
   */
  last_run_at?: string | null;
  /**
   * Organization Id
   * Organization ID
   */
  organization_id: number;
  /**
   * Parameters
   * Filter parameter values keyed by parameter ID
   * @default null
   */
  parameters?: Record<string, any> | null;
  /**
   * Recurrence Type
   * Schedule recurrence: daily or monthly
   */
  recurrence_type: "daily" | "monthly";
  /**
   * Report Template Id
   * Report template ID
   */
  report_template_id: number;
  /**
   * Report Template Name
   * Report template name
   * @default null
   */
  report_template_name?: string | null;
  /**
   * Target Configurations
   * Target-specific configuration
   */
  target_configurations?: Record<string, any>;
  /**
   * Target Type
   * Delivery target type
   */
  target_type: string;
  /**
   * User Email
   * User email for email delivery
   * @default null
   */
  user_email?: string | null;
  /**
   * User Id
   * User ID for email delivery
   * @default null
   */
  user_id?: string | null;
}

/** ScheduledReportExportResponse */
export interface ScheduledReportExportResponse {
  /**
   * Created At
   * Creation timestamp
   * @format date-time
   */
  created_at: string;
  /**
   * Created By Name
   * Display name of the creator
   * @default null
   */
  created_by_name?: string | null;
  /**
   * Created By User Id
   * User ID of the creator
   */
  created_by_user_id: string;
  /**
   * Day Of Month
   * Day of month (1-28) for monthly recurrence
   * @default null
   */
  day_of_month?: number | null;
  /**
   * Display Name
   * Schedule display name
   */
  display_name: string;
  /**
   * End Date
   * End date for the schedule
   * @default null
   */
  end_date?: string | null;
  /**
   * Export Days
   * Days of the week to run
   */
  export_days?: string[];
  /**
   * Export Hour
   * Hour to run (HH:MM format)
   * @default null
   */
  export_hour?: string | null;
  /**
   * Id
   * Schedule ID
   * @default null
   */
  id?: number | null;
  /**
   * Is Active
   * Whether the schedule is active
   */
  is_active: boolean;
  /**
   * Last Run At
   * Last successful run timestamp
   * @default null
   */
  last_run_at?: string | null;
  /**
   * Organization Id
   * Organization ID
   */
  organization_id: number;
  /**
   * Parameters
   * Filter parameter values keyed by parameter ID
   * @default null
   */
  parameters?: Record<string, any> | null;
  /**
   * Recurrence Type
   * Schedule recurrence: daily or monthly
   */
  recurrence_type: "daily" | "monthly";
  /**
   * Report Template Id
   * Report template ID
   */
  report_template_id: number;
  /**
   * Report Template Name
   * Report template name
   * @default null
   */
  report_template_name?: string | null;
  /**
   * Target Configurations
   * Target-specific configuration
   */
  target_configurations?: Record<string, any>;
  /**
   * Target Type
   * Delivery target type
   */
  target_type: string;
  /**
   * User Email
   * User email for email delivery
   * @default null
   */
  user_email?: string | null;
  /**
   * User Id
   * User ID for email delivery
   * @default null
   */
  user_id?: string | null;
}

/** SearchClaimParamsSchema */
export interface SearchClaimParamsSchema {
  /**
   * Claim Date Of Loss End Date
   * @default null
   */
  claim_date_of_loss_end_date?: string | null;
  /**
   * Claim Date Of Loss Start Date
   * @default null
   */
  claim_date_of_loss_start_date?: string | null;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contact Company Name
   * @default null
   */
  contact_company_name?: string | null;
  /**
   * Contact First Name
   * @default null
   */
  contact_first_name?: string | null;
  /**
   * Contact Last Name
   * @default null
   */
  contact_last_name?: string | null;
  /**
   * Contact Ssn
   * @default null
   */
  contact_ssn?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * External Claim Number
   * @default null
   */
  external_claim_number?: string | null;
  /**
   * Is Company
   * @default null
   */
  is_company?: string | null;
  /**
   * Line Of Business
   * @default null
   */
  line_of_business?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Policy Number
   * @default null
   */
  policy_number?: string | null;
  /**
   * Sub Org External Id
   * @default null
   */
  sub_org_external_id?: string | null;
  /**
   * Vehicle Make
   * @default null
   */
  vehicle_make?: string | null;
  /**
   * Vehicle Model
   * @default null
   */
  vehicle_model?: string | null;
  /**
   * Vehicle Plate Number
   * @default null
   */
  vehicle_plate_number?: string | null;
  /**
   * Vehicle Vin
   * @default null
   */
  vehicle_vin?: string | null;
  /**
   * Vehicle Year
   * @default null
   */
  vehicle_year?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** SearchContactsRequest */
export interface SearchContactsRequest {
  /**
   * Accepted Expertise
   * @default []
   */
  accepted_expertise?: string[] | null;
  /** Accepted Roles */
  accepted_roles: string[];
  /**
   * Claim Id
   * @default null
   */
  claim_id?: number | null;
  /**
   * Excluded Contact Ids
   * @default []
   */
  excluded_contact_ids?: string[] | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Include Single Claim Contacts
   * @default false
   */
  include_single_claim_contacts?: boolean | null;
  /**
   * Limit
   * @default 10
   */
  limit?: number;
  /**
   * Offset
   * @default null
   */
  offset?: number | null;
  /**
   * Order By
   * @default null
   */
  order_by?: string | null;
  /**
   * Page
   * @default null
   */
  page?: number | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /** Search */
  search: string;
  /**
   * Social Security Number
   * @default null
   */
  social_security_number?: string | null;
  /**
   * Sort By
   * @default null
   */
  sort_by?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** SearchParams */
export interface SearchParams {
  /** Exposure Ids */
  exposure_ids: number[];
  /** Method Specific */
  method_specific: Record<string, any>;
  /** Moi Method Key */
  moi_method_key: string;
  /** Name */
  name: string;
  /** Radius */
  radius: number;
  /** Vendor Type */
  vendor_type: string;
}

/** SearchVendorResponse */
export interface SearchVendorResponse {
  /** Vendors */
  vendors: SearchVendorResponseMoiVendor[];
}

/** MoiVendor */
export interface SearchVendorResponseMoiVendor {
  address: SearchVendorResponseVendorAddress;
  /** Appraiser Code */
  appraiser_code: string;
  /** Capacity */
  capacity: string;
  /** Distance */
  distance: number;
  /** Name */
  name: string;
  /** Phone Number */
  phone_number: string;
}

/** VendorAddress */
export interface SearchVendorResponseVendorAddress {
  /** Address Line */
  address_line: string;
  /** City */
  city: string;
  /** Postal Code */
  postal_code: string;
  /** State */
  state: string;
}

/** SelectVendorParams */
export interface SelectVendorParams {
  address: SelectVendorParamsVendorAddress;
  /** Appraiser Code */
  appraiser_code: string;
  /** Appraiser Name */
  appraiser_name: string;
  /** Exposure Ids */
  exposure_ids: number[];
  /** Method Specific */
  method_specific: Record<string, any>;
  /** Moi Method Key */
  moi_method_key: string;
  /** Name */
  name: string;
  /** Phone Number */
  phone_number: string;
  /** Radius */
  radius: number;
  /** Vendor Type */
  vendor_type: string;
}

/** VendorAddress */
export interface SelectVendorParamsVendorAddress {
  /** Address Line */
  address_line: string;
  /** City */
  city: string;
  /** Postal Code */
  postal_code: string;
  /** State */
  state: string;
}

/** SelectVendorResponse */
export interface SelectVendorResponse {
  /** Contact Id */
  contact_id: number;
}

/** SelectableLocalesResponse */
export interface SelectableLocalesResponse {
  /**
   * Locales
   * Every locale an organization can be configured with, ordered by territory name. Derived from the territories `holidays` covers and the language CLDR gives each of them, so the list cannot drift from what the write path accepts.
   */
  locales: SelectableLocalesResponseSelectableLocale[];
}

/** SelectableLocale */
export interface SelectableLocalesResponseSelectableLocale {
  /**
   * Code
   * Locale code stored in the organization's configuration, e.g. 'en-gb'.
   */
  code: string;
  /**
   * Name
   * English territory name, for display in the settings select.
   */
  name: string;
}

/**
 * SendConductorMessageRequest
 * The handler's message to the conductor.
 *
 * The upstream body's ``author`` is absent because the author is the signed-in user, so a body naming
 * one is refused rather than answered for an author that was dropped.
 */
export interface SendConductorMessageRequest {
  /**
   * Text
   * @minLength 1
   */
  text: string;
}

/** SendEmailJsonParams */
export interface SendEmailJsonParams {
  /**
   * Adjuster Email
   * Email of the adjuster sending the email. Accepts either the user login email or the claims email address
   */
  adjuster_email: string;
  /**
   * Body
   * @default null
   */
  body?: string | null;
  /** Contacts */
  contacts: (
    | ({
        creation_mode: "";
      } & SendEmailJsonParamsContactInNewParam)
    | ({
        creation_mode: "existing";
      } & SendEmailJsonParamsContactInExistingParam)
    | ({
        creation_mode: "new";
      } & SendEmailJsonParamsContactInNewParam)
  )[];
  /** Subject */
  subject: string;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** ContactEmailModel */
export interface SendEmailJsonParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface SendEmailJsonParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface SendEmailJsonParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: SendEmailJsonParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: SendEmailJsonParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface SendEmailJsonParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** SendEmailResponse */
export interface SendEmailResponse {
  /** Success */
  success: boolean;
}

/** SendMessageRequest */
export interface SendMessageRequest {
  /**
   * Callback Url
   * @default null
   */
  callback_url?: string | null;
  /**
   * Document Api Uids
   * @maxItems 50
   */
  document_api_uids?: string[];
  /**
   * User Input
   * @minLength 1
   */
  user_input: string;
}

/** SessionActivityResponse */
export interface SessionActivityResponse {
  /**
   * Session Expires At
   * @default null
   */
  session_expires_at?: number | null;
}

/** SessionTimeoutConfigurationParams */
export interface SessionTimeoutConfigurationParams {
  /**
   * Session Timeout Minutes
   * Session timeout in minutes. Must be between 10 minutes and 3 months ({MAX_SESSION_TIMEOUT_MINUTES} minutes) when provided.
   * @default null
   */
  session_timeout_minutes?: number | null;
}

/**
 * SetAiExpertScopeRequest
 * Body for ``PUT /ai_experts/scopes/<expert_key>`` — a whole-row upsert.
 *
 * Every field is written on every save, so a field the caller omits is *reset to its default*,
 * not left unchanged. That matters most for the two mode booleans: omitting one means **off**.
 * A screen that owns only a subset of the row therefore has to echo back every field it does
 * not own, or it clears what another screen set — ``qa_expert`` is configurable from both the
 * QA Configuration tab and the Experts section, and both write this one row.
 *
 * Deliberately not typed ``bool | None`` to fake a patch: a PUT whose meaning depends on which
 * keys are present is the ambiguity this API should not grow, and every screen holds both
 * values already.
 */
export interface SetAiExpertScopeRequest {
  /**
   * Conductor Enabled
   * Whether the conductor may consult this expert for claims in this scope. Omitted means off.
   * @default false
   */
  conductor_enabled?: boolean;
  /**
   * Configured Fields
   * Per-scope structured-output fields; empty means the expert has no schema.
   */
  configured_fields?: SetAiExpertScopeRequestConfiguredField[];
  /**
   * Instructions
   * Per-scope prompt; null falls back to the expert's catalog instructions.
   * @default null
   */
  instructions?: string | null;
  /**
   * Lob
   * The scope's line of business.
   */
  lob: string;
  /**
   * How the structured output is rendered in the insight UI.
   * @default "key_value"
   */
  render_component?: SetAiExpertScopeRequestStructuredOutputComponent;
  /**
   * Standalone Confidence Threshold
   * Suppression floor for the standalone run only. Valid only when standalone_enabled is true; null falls back to the catalog confidence.
   * @default null
   */
  standalone_confidence_threshold?: number | null;
  /**
   * Standalone Enabled
   * Whether the expert runs on its own trigger (cron, or on_demand for the QA expert) for claims in this scope. Omitted means off. Both booleans false turns the expert off for the scope.
   * @default false
   */
  standalone_enabled?: boolean;
  /**
   * Sub Organization Id
   * The scope's sub-organization; null for a flat organization.
   * @default null
   */
  sub_organization_id?: number | null;
}

/** ConfiguredField */
export interface SetAiExpertScopeRequestConfiguredField {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Claim Closing Mandatory
   * @default false
   */
  claim_closing_mandatory?: boolean | null;
  /**
   * Clive Additional Instructions
   * Clive Additional Instructions
   * @default null
   */
  clive_additional_instructions?: string | null;
  /**
   * Exclude from Clive
   * If true, this field will be excluded from the FNOL schema sent to Clive
   * @default false
   */
  clive_excluded?: boolean | null;
  /**
   * Db Field
   * @default null
   */
  db_field?: string | null;
  /** Desc */
  desc: string;
  /** Id */
  id: string;
  /**
   * Include In Management Preview
   * @default false
   */
  include_in_management_preview?: boolean | null;
  /**
   * Location Type
   * @default null
   */
  location_type?: string | null;
  /**
   * Mandatory
   * @default false
   */
  mandatory?: boolean | null;
  /**
   * Options
   * @default null
   */
  options?: SetAiExpertScopeRequestConfiguredFieldSelectOption[] | null;
  /**
   * Show In Involved
   * @default false
   */
  show_in_involved?: boolean | null;
  type: SetAiExpertScopeRequestConfiguredFieldType;
  [key: string]: any;
}

/** ConfiguredFieldSelectOption */
export interface SetAiExpertScopeRequestConfiguredFieldSelectOption {
  /**
   * Active
   * @default true
   */
  active?: boolean | null;
  /**
   * Desc
   * @minLength 1
   */
  desc: string;
  /**
   * Id
   * @minLength 1
   */
  id: string;
  /**
   * Incident Sub Type Categories
   * @default null
   */
  incident_sub_type_categories?: string[] | null;
}

/** SetExposureDeductibleJsonParams */
export interface SetExposureDeductibleJsonParams {
  /**
   * Deductible Amount
   * @default null
   */
  deductible_amount?: number | null;
  /**
   * Deductible Reason
   * @default null
   */
  deductible_reason?: string | null;
  /** Is Deductible Waived */
  is_deductible_waived: boolean;
}

/** SetIsActiveRequest */
export interface SetIsActiveRequest {
  /**
   * Is Active
   * Whether the schedule should be active
   */
  is_active: boolean;
}

/** SetTableauAccountsEnableParams */
export interface SetTableauAccountsEnableParams {
  /** Enable */
  enable: boolean;
}

/** SetTableauAccountsMaxLimitParams */
export interface SetTableauAccountsMaxLimitParams {
  /** Tableau Accounts Max Limit */
  tableau_accounts_max_limit: number;
}

/** SetTableauSiteLicensesLimitParams */
export interface SetTableauSiteLicensesLimitParams {
  /**
   * Tier Explorer Capacity
   * @default null
   */
  tier_explorer_capacity?: number | null;
  /**
   * Tier Viewer Capacity
   * @default null
   */
  tier_viewer_capacity?: number | null;
}

/**
 * SharedCoverageConfigCreateParams
 * Parameters for creating a new shared coverage config.
 */
export interface SharedCoverageConfigCreateParams {
  /** Coverage Config Keys */
  coverage_config_keys: string[];
  /** Is Limit Per Incident */
  is_limit_per_incident: boolean;
  /** Lob */
  lob: string;
  /**
   * Shared Coverage Key
   * @minLength 1
   * @maxLength 50
   */
  shared_coverage_key: string;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/**
 * SharedCoverageConfigInfo
 * Public data representation for shared coverage config.
 */
export interface SharedCoverageConfigInfo {
  /** Coverage Config Display Names */
  coverage_config_display_names: string[];
  /** Coverage Config Keys */
  coverage_config_keys: string[];
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Disabled */
  is_disabled: boolean;
  /** Is Limit Per Incident */
  is_limit_per_incident: boolean;
  /** Is Org Level */
  is_org_level: boolean;
  /** Lob */
  lob: string;
  /** Organization Id */
  organization_id: number;
  /** Shared Coverage Key */
  shared_coverage_key: string;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
  /** Sub Organizations */
  sub_organizations: SharedCoverageConfigInfoSubOrganizationInfo[];
}

/**
 * SubOrganizationInfo
 * Public data representation for sub-organization.
 */
export interface SharedCoverageConfigInfoSubOrganizationInfo {
  /** External Id */
  external_id: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** SharedCoverageConfigInfoList */
export type SharedCoverageConfigInfoList =
  SharedCoverageConfigInfoListSharedCoverageConfigInfo[];

/**
 * SharedCoverageConfigInfo
 * Public data representation for shared coverage config.
 */
export interface SharedCoverageConfigInfoListSharedCoverageConfigInfo {
  /** Coverage Config Display Names */
  coverage_config_display_names: string[];
  /** Coverage Config Keys */
  coverage_config_keys: string[];
  /** Display Name */
  display_name: string;
  /** Id */
  id: number;
  /** Is Disabled */
  is_disabled: boolean;
  /** Is Limit Per Incident */
  is_limit_per_incident: boolean;
  /** Is Org Level */
  is_org_level: boolean;
  /** Lob */
  lob: string;
  /** Organization Id */
  organization_id: number;
  /** Shared Coverage Key */
  shared_coverage_key: string;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
  /** Sub Organizations */
  sub_organizations: SharedCoverageConfigInfoListSubOrganizationInfo[];
}

/**
 * SubOrganizationInfo
 * Public data representation for sub-organization.
 */
export interface SharedCoverageConfigInfoListSubOrganizationInfo {
  /** External Id */
  external_id: string;
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/**
 * SharedCoverageConfigUpdateParams
 * Parameters for updating an existing shared coverage config.
 */
export interface SharedCoverageConfigUpdateParams {
  /**
   * Coverage Config Keys
   * @default null
   */
  coverage_config_keys?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** SignalConfigEntryList */
export type SignalConfigEntryList = SignalConfigEntryListSignalConfigEntry[];

/**
 * AppliesTo
 * The documents a signal is asked about, selected before any LLM call.  ``type_groups`` names the document type groups the signal applies to; empty means the signal applies to documents of every group. A selector key or a group this version does not know is a newer consumer's vocabulary, not a contract break: it is skipped with a log, never a validation error.
 */
export interface SignalConfigEntryListAppliesTo {
  /**
   * Type Groups
   * @default null
   */
  type_groups?: SignalConfigEntryListDocumentTypeGroup[] | null;
}

/**
 * SignalConfigEntry
 * One configured document signal: a yes/no question asked about a document.  ``prompt`` is the question. ``applies_to`` selects the documents the question is asked about, by document type group. ``min_confidence`` is the lowest confidence, from 0 to 1, at which a detection counts. ``config_version`` is an opaque string naming the revision of this entry.
 */
export interface SignalConfigEntryListSignalConfigEntry {
  /** The documents a signal is asked about, selected before any LLM call.  ``type_groups`` names the document type groups the signal applies to; empty means the signal applies to documents of every group. A selector key or a group this version does not know is a newer consumer's vocabulary, not a contract break: it is skipped with a log, never a validation error. */
  applies_to: SignalConfigEntryListAppliesTo;
  /** Config Version */
  config_version: string;
  /** Key */
  key: string;
  /**
   * Min Confidence
   * @default 0.5
   */
  min_confidence?: number | null;
  /** Prompt */
  prompt: string;
}

/**
 * SingleChatExchangeResponse
 * A single chat exchange plus its processing status.
 *
 * Returned by the pass-through single-exchange GET so the frontend can fetch and poll a
 * possibly still-processing exchange. status is claims_llm's ExchangeStatus value
 * (processing | completed | failed); error carries the failure detail when status is failed.
 */
export interface SingleChatExchangeResponse {
  /** Context Document Ids */
  context_document_ids: number[];
  /**
   * Created At
   * @default null
   */
  created_at?: string | null;
  /** Documents Used */
  documents_used: string[];
  /**
   * Error
   * @default null
   */
  error?: string | null;
  /**
   * Exchange Metadata
   * @default null
   */
  exchange_metadata?: Record<string, any> | null;
  /** Id */
  id: string;
  /** Response */
  response: string;
  /**
   * Response Time
   * @default null
   */
  response_time?: number | null;
  /**
   * Status
   * @default null
   */
  status?: string | null;
  /**
   * User Feedback Score
   * @default null
   */
  user_feedback_score?: number | null;
  /**
   * User Feedback Text
   * @default null
   */
  user_feedback_text?: string | null;
  /** User Input */
  user_input: string;
}

/** SlaRecipientOptionItemList */
export type SlaRecipientOptionItemList =
  SlaRecipientOptionItemListSlaRecipientOptionItem[];

/**
 * SlaRecipientOptionItem
 * One entry in the SLA action recipient dropdown.
 *
 * ``action_types`` is what makes the catalog serve two vocabularies from one list: an action
 * that sends a communication targets a contact role, and a notification action targets a user
 * role, so an option is only offered for the action types it can actually resolve against. The
 * save-path gate narrows the same catalog by the same field, so whatever the dialog is built to
 * offer cannot drift from what a write will accept.
 */
export interface SlaRecipientOptionItemListSlaRecipientOptionItem {
  /** Action Types */
  action_types: SlaRecipientOptionItemListSlaActionType[];
  /** Desc */
  desc: string;
  /** Key */
  key: string;
}

/**
 * SlaRuleCreateRequest
 * Create body. ``entity_level`` is absent on purpose - it is derived from the card's
 * column set, never chosen by the author, and ``extra='forbid'`` makes sending it a 400.
 */
export interface SlaRuleCreateRequest {
  /** Context Params */
  context_params?: Record<string, any>;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 255
   */
  display_name: string;
  /**
   * Is Business Days
   * @default false
   */
  is_business_days?: boolean;
  /**
   * Is Enabled
   * @default false
   */
  is_enabled?: boolean;
  /** Metabase Card Id */
  metabase_card_id: number;
  /**
   * Thresholds
   * @minItems 1
   */
  thresholds: SlaRuleCreateRequestSlaThresholdRequest[];
}

/**
 * SlaThresholdActionRequest
 * One action on a threshold. A threshold carries one or more.
 */
export interface SlaRuleCreateRequestSlaThresholdActionRequest {
  /**
   * The action menu the SLA engine offers.
   *
   * Deliberately independent of the automation engine's action taxonomy: the SLA engine
   * does not run the automation rule engine and reads none of its action models.
   */
  action_type: SlaRuleCreateRequestSlaActionType;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Config Json
   * @default null
   */
  config_json?: Record<string, any> | null;
  /**
   * Generic Template Id
   * @default null
   */
  generic_template_id?: number | null;
  /** Recipient */
  recipient: string;
}

/** SlaThresholdRequest */
export interface SlaRuleCreateRequestSlaThresholdRequest {
  /**
   * Actions
   * @minItems 1
   */
  actions: SlaRuleCreateRequestSlaThresholdActionRequest[];
  /**
   * Repeat Every Days
   * @exclusiveMin 0
   */
  repeat_every_days: number;
  /**
   * Sla Days
   * @exclusiveMin 0
   */
  sla_days: number;
}

/**
 * SlaRuleCreatedResponse
 * The create route's body. A declared model rather than a bare JSON number, so the
 * generated ``data-contracts.ts`` types the id the dialog needs after a save.
 */
export interface SlaRuleCreatedResponse {
  /** Id */
  id: number;
}

/**
 * SlaRuleDTO
 * A rule with its thresholds and actions nested, plus the list view's state and display columns.
 *
 * ``created_by_user_id``, ``error_state`` and ``error_reason`` are optional because their
 * columns are nullable: a configuration-repository import has no authoring user, and a
 * healthy rule has no error. ``created_by_user_name`` is ``None`` for the same missing user.
 *
 * ``sub_organization_ids`` and ``lobs`` are the rule's scope, read from ``context_params``.
 * ``None`` means the rule selects none, which leaves it unrestricted: it applies to every
 * sub-organization / LOB.
 */
export interface SlaRuleDTO {
  /** Context Params */
  context_params: Record<string, any>;
  /**
   * Created By User Id
   * @default null
   */
  created_by_user_id?: string | null;
  /**
   * Created By User Name
   * @default null
   */
  created_by_user_name?: string | null;
  /** Display Name */
  display_name: string;
  /** What a rule's card returns one row per, derived from its column set. */
  entity_level: SlaRuleDTOSlaEntityLevel;
  /**
   * Error Reason
   * @default null
   */
  error_reason?: string | null;
  /**
   * Error State
   * @default null
   */
  error_state?: string | null;
  /** Id */
  id: number;
  /** Is Business Days */
  is_business_days: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /** Metabase Card Id */
  metabase_card_id: number;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /** Thresholds */
  thresholds: SlaRuleDTOSlaThresholdDTO[];
}

/** SlaThresholdActionDTO */
export interface SlaRuleDTOSlaThresholdActionDTO {
  /**
   * The action menu the SLA engine offers.
   *
   * Deliberately independent of the automation engine's action taxonomy: the SLA engine
   * does not run the automation rule engine and reads none of its action models.
   */
  action_type: SlaRuleDTOSlaActionType;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Config Json
   * @default null
   */
  config_json?: Record<string, any> | null;
  /**
   * Generic Template Id
   * @default null
   */
  generic_template_id?: number | null;
  /** Id */
  id: number;
  /** Recipient */
  recipient: string;
}

/** SlaThresholdDTO */
export interface SlaRuleDTOSlaThresholdDTO {
  /** Actions */
  actions: SlaRuleDTOSlaThresholdActionDTO[];
  /** Id */
  id: number;
  /** Repeat Every Days */
  repeat_every_days: number;
  /** Sla Days */
  sla_days: number;
}

/**
 * SlaRuleListResponse
 * The rules list view: every rule plus the per-run entity cap its disclaimer quotes.
 *
 * ``entity_cap`` rides on the list rather than on each rule because the disclaimer shows even
 * when the organization has no rules yet.
 */
export interface SlaRuleListResponse {
  /** Entity Cap */
  entity_cap: number;
  /** Rules */
  rules: SlaRuleListResponseSlaRuleDTO[];
}

/**
 * SlaRuleDTO
 * A rule with its thresholds and actions nested, plus the list view's state and display columns.
 *
 * ``created_by_user_id``, ``error_state`` and ``error_reason`` are optional because their
 * columns are nullable: a configuration-repository import has no authoring user, and a
 * healthy rule has no error. ``created_by_user_name`` is ``None`` for the same missing user.
 *
 * ``sub_organization_ids`` and ``lobs`` are the rule's scope, read from ``context_params``.
 * ``None`` means the rule selects none, which leaves it unrestricted: it applies to every
 * sub-organization / LOB.
 */
export interface SlaRuleListResponseSlaRuleDTO {
  /** Context Params */
  context_params: Record<string, any>;
  /**
   * Created By User Id
   * @default null
   */
  created_by_user_id?: string | null;
  /**
   * Created By User Name
   * @default null
   */
  created_by_user_name?: string | null;
  /** Display Name */
  display_name: string;
  /** What a rule's card returns one row per, derived from its column set. */
  entity_level: SlaRuleListResponseSlaEntityLevel;
  /**
   * Error Reason
   * @default null
   */
  error_reason?: string | null;
  /**
   * Error State
   * @default null
   */
  error_state?: string | null;
  /** Id */
  id: number;
  /** Is Business Days */
  is_business_days: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /** Metabase Card Id */
  metabase_card_id: number;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /** Thresholds */
  thresholds: SlaRuleListResponseSlaThresholdDTO[];
}

/** SlaThresholdActionDTO */
export interface SlaRuleListResponseSlaThresholdActionDTO {
  /**
   * The action menu the SLA engine offers.
   *
   * Deliberately independent of the automation engine's action taxonomy: the SLA engine
   * does not run the automation rule engine and reads none of its action models.
   */
  action_type: SlaRuleListResponseSlaActionType;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Config Json
   * @default null
   */
  config_json?: Record<string, any> | null;
  /**
   * Generic Template Id
   * @default null
   */
  generic_template_id?: number | null;
  /** Id */
  id: number;
  /** Recipient */
  recipient: string;
}

/** SlaThresholdDTO */
export interface SlaRuleListResponseSlaThresholdDTO {
  /** Actions */
  actions: SlaRuleListResponseSlaThresholdActionDTO[];
  /** Id */
  id: number;
  /** Repeat Every Days */
  repeat_every_days: number;
  /** Sla Days */
  sla_days: number;
}

/**
 * SlaRulePreviewRequest
 * An unsaved rule, as the preview endpoint receives it.
 *
 * ``display_name`` is carried because the shared classifier renders it into every fire's SLA
 * context - a preview that dropped it would have to run a different function from the daily
 * job, which is precisely what this endpoint exists to rule out.
 *
 * ``rule_id`` names the rule being edited, and is absent when the author is creating one. It
 * is what makes the answer match the next run: an edit keeps the row, and with it the fire
 * log, of every threshold whose schedule survived, so those thresholds' repeat windows still
 * apply. Without it a preview of a live rule would report every entity as firing today.
 *
 * ``is_enabled`` is absent, and ``extra='forbid'`` makes sending it a 400: a preview neither
 * reads it nor could act on it.
 */
export interface SlaRulePreviewRequest {
  /** Context Params */
  context_params?: Record<string, any>;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 255
   */
  display_name: string;
  /**
   * Is Business Days
   * @default false
   */
  is_business_days?: boolean;
  /** Metabase Card Id */
  metabase_card_id: number;
  /**
   * Rule Id
   * @default null
   */
  rule_id?: number | null;
  /**
   * Thresholds
   * @minItems 1
   */
  thresholds: SlaRulePreviewRequestSlaThresholdPreviewRequest[];
}

/**
 * SlaThresholdPreviewRequest
 * One threshold in a preview payload.
 *
 * Deliberately narrower than ``SlaThresholdRequest``: classification reads only the schedule,
 * and preview dispatches nothing, so an action list has nothing to contribute. Requiring one
 * would also force an author to finish configuring recipients before they may ask what the
 * rule matches, which is the opposite of what the preview is for.
 */
export interface SlaRulePreviewRequestSlaThresholdPreviewRequest {
  /**
   * Repeat Every Days
   * @exclusiveMin 0
   */
  repeat_every_days: number;
  /**
   * Sla Days
   * @exclusiveMin 0
   */
  sla_days: number;
}

/**
 * SlaRulePreviewResult
 * What the next daily run would do with this payload.
 *
 * ``snapshot_date`` is returned because the answer is as of the latest export, not as of now,
 * and the dialog has to be able to say so.
 *
 * ``would_fire_count`` is reported even when ``is_over_entity_cap`` is set: a run over the cap
 * fires nothing at all, and the count is the number the author needs in order to see why.
 */
export interface SlaRulePreviewResult {
  /** Candidate Row Count */
  candidate_row_count: number;
  /** Entity Cap */
  entity_cap: number;
  /**
   * Evaluation Date
   * @format date
   */
  evaluation_date: string;
  /** Is Over Entity Cap */
  is_over_entity_cap: boolean;
  /** Matched Entity Count */
  matched_entity_count: number;
  /**
   * Snapshot Date
   * @format date
   */
  snapshot_date: string;
  /** Thresholds */
  thresholds?: SlaRulePreviewResultSlaThresholdPreviewResult[];
}

/**
 * SlaPreviewSampleRow
 * One entity a threshold would fire against today, and one the requesting user may open.
 *
 * ``claim_id_display`` is optional because ``claim.claim_id_display`` is a nullable column.
 * A claim the snapshot named and the database no longer has yields no row at all rather than a
 * row with a null display id: the sample is narrowed to the claims this user may access, and an
 * id no claim row carries cannot be shown to be one of them.
 */
export interface SlaRulePreviewResultSlaPreviewSampleRow {
  /**
   * Anchor Date
   * @format date
   */
  anchor_date: string;
  /** Claim Id */
  claim_id: number;
  /**
   * Claim Id Display
   * @default null
   */
  claim_id_display?: string | null;
  /** Days Elapsed */
  days_elapsed: number;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
}

/**
 * SlaThresholdPreviewResult
 * One threshold's answer, identified by the schedule the author typed.
 *
 * Keyed by ``(sla_days, repeat_every_days)`` rather than by an index or an id: that pair is a
 * threshold's author-visible identity everywhere else in this module, and an unsaved
 * threshold has no id to offer.
 */
export interface SlaRulePreviewResultSlaThresholdPreviewResult {
  /** Repeat Every Days */
  repeat_every_days: number;
  /** Sample Rows */
  sample_rows?: SlaRulePreviewResultSlaPreviewSampleRow[];
  /** Sla Days */
  sla_days: number;
  /** Would Fire Count */
  would_fire_count: number;
}

/**
 * SlaRuleUpdateRequest
 * Update body. Same field set as create, and the threshold list is authoritative: a
 * shorter one is a deletion, not an omission. A threshold whose ``(sla_days,
 * repeat_every_days)`` is still in the list keeps its row, so its fire log survives the
 * edit; one the engine has already fired against cannot be dropped (409).
 */
export interface SlaRuleUpdateRequest {
  /** Context Params */
  context_params?: Record<string, any>;
  /**
   * Display Name
   * @minLength 1
   * @maxLength 255
   */
  display_name: string;
  /**
   * Is Business Days
   * @default false
   */
  is_business_days?: boolean;
  /**
   * Is Enabled
   * @default false
   */
  is_enabled?: boolean;
  /** Metabase Card Id */
  metabase_card_id: number;
  /**
   * Thresholds
   * @minItems 1
   */
  thresholds: SlaRuleUpdateRequestSlaThresholdRequest[];
}

/**
 * SlaThresholdActionRequest
 * One action on a threshold. A threshold carries one or more.
 */
export interface SlaRuleUpdateRequestSlaThresholdActionRequest {
  /**
   * The action menu the SLA engine offers.
   *
   * Deliberately independent of the automation engine's action taxonomy: the SLA engine
   * does not run the automation rule engine and reads none of its action models.
   */
  action_type: SlaRuleUpdateRequestSlaActionType;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Config Json
   * @default null
   */
  config_json?: Record<string, any> | null;
  /**
   * Generic Template Id
   * @default null
   */
  generic_template_id?: number | null;
  /** Recipient */
  recipient: string;
}

/** SlaThresholdRequest */
export interface SlaRuleUpdateRequestSlaThresholdRequest {
  /**
   * Actions
   * @minItems 1
   */
  actions: SlaRuleUpdateRequestSlaThresholdActionRequest[];
  /**
   * Repeat Every Days
   * @exclusiveMin 0
   */
  repeat_every_days: number;
  /**
   * Sla Days
   * @exclusiveMin 0
   */
  sla_days: number;
}

/** SlaTemplateItemList */
export type SlaTemplateItemList = SlaTemplateItemListSlaTemplateItem[];

/**
 * SlaTemplateItem
 * One card in the SLA template picker.
 *
 * A breaching card is returned rather than filtered out: the picker shows it disabled with
 * ``invalid_reasons`` as the tooltip, so the author sees why a card they expected is
 * unavailable instead of an unexplained absence.
 */
export interface SlaTemplateItemListSlaTemplateItem {
  /** Card Id */
  card_id: number;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** @default null */
  entity_level?: SlaTemplateItemListSlaEntityLevel | null;
  /** Invalid Reasons */
  invalid_reasons?: string[];
  /** Is Valid */
  is_valid: boolean;
  /** Name */
  name: string;
  /**
   * Which SLA collection a template card came from.
   *
   * Also the picker's grouping: the curated system cards come first, the organization's own
   * folder after.
   */
  source: SlaTemplateItemListSlaTemplateSource;
}

/**
 * SlaTemplateMetadata
 * A template card's shape, in this module's own vocabulary.
 *
 * Deliberately not ``MetabaseCardMetadata`` re-exported: the service interface's contract
 * must not make every consumer depend on the ``data_reports`` package's schema, nor pin
 * this module's HTTP contract to a legacy package's type.
 */
export interface SlaTemplateMetadata {
  /** Card Id */
  card_id: number;
  /** Columns */
  columns?: SlaTemplateMetadataSlaTemplateColumn[];
  /** Name */
  name: string;
  /** Parameters */
  parameters?: SlaTemplateMetadataSlaTemplateParameter[];
}

/**
 * SlaTemplateColumn
 * One column a template card returns.
 */
export interface SlaTemplateMetadataSlaTemplateColumn {
  /** Base Type */
  base_type: string;
  /** Display Name */
  display_name: string;
  /** Name */
  name: string;
}

/**
 * SlaTemplateParameter
 * One filter parameter a template card declares. ``id`` is what the parameter-values
 * route is addressed by; ``slug`` is the key a rule's ``context_params`` stores under.
 */
export interface SlaTemplateMetadataSlaTemplateParameter {
  /**
   * Default
   * @default null
   */
  default?: null;
  /** Id */
  id: string;
  /** Name */
  name: string;
  /**
   * Required
   * @default false
   */
  required?: boolean;
  /** Slug */
  slug: string;
  /** Type */
  type: string;
}

/**
 * SlaTemplateParameterValues
 * A card-backed value list for one parameter.
 *
 * ``values`` stays loosely typed because Metabase returns rows of ``[value]`` or
 * ``[value, label]`` - flattening here would discard the label the dropdown renders.
 */
export interface SlaTemplateParameterValues {
  /**
   * Has More Values
   * @default false
   */
  has_more_values?: boolean;
  /** Values */
  values?: any[];
}

/** SnapshotDatesResponse */
export interface SnapshotDatesResponse {
  /**
   * Dates
   * Available snapshot dates in ISO format (YYYY-MM-DD), sorted descending
   */
  dates?: string[];
}

/**
 * SnapshotListResponse
 * Response schema for listing snapshots.
 * @example {"snapshots":[{"created_at":"2024-01-15T10:30:00Z","created_by_user_id":"user123","description":"Full configuration export","file_size_mb":1.2,"id":1,"snapshot_hash":"abc123def456","snapshot_name":"Production Export 2024-01-15"}],"total_count":1}
 */
export interface SnapshotListResponse {
  /**
   * Snapshots
   * List of configuration snapshots
   */
  snapshots: SnapshotListResponseConfigurationSnapshot[];
  /**
   * Total Count
   * Total number of snapshots
   */
  total_count: number;
}

/**
 * ConfigurationSnapshot
 * Pydantic model for configuration snapshot responses.
 */
export interface SnapshotListResponseConfigurationSnapshot {
  /**
   * Created At
   * When snapshot was created
   */
  created_at: string;
  /**
   * Created By User Id
   * User who created the snapshot
   * @default null
   */
  created_by_user_id?: string | null;
  /**
   * Created By Username
   * Username of user who created the snapshot
   * @default null
   */
  created_by_username?: string | null;
  /**
   * Description
   * Optional description
   * @default null
   */
  description?: string | null;
  /**
   * Id
   * Database ID of the snapshot
   */
  id: number;
  /**
   * Organization Id
   * Organization ID
   */
  organization_id: number;
  /**
   * Reason
   * Reason for snapshot creation
   */
  reason: string;
  /**
   * Snapshot Hash
   * SHA-256 hash of the snapshot
   */
  snapshot_hash: string;
  /**
   * Snapshot Name
   * Name of the snapshot
   */
  snapshot_name: string;
}

/**
 * SopConfigurationResponse
 * Response schema for retrieving SOP configuration.
 */
export interface SopConfigurationResponse {
  /**
   * Markdown Pages
   * Processed markdown pages
   */
  markdown_pages: string[];
  /**
   * Metadata
   * Configuration metadata (e.g., page_count)
   */
  metadata: Record<string, any>;
  /**
   * Toc Markdown
   * Generated table of contents
   */
  toc_markdown: string;
}

/**
 * SorActiveAttemptResponse
 * The claim's open attempt, or null when no attempt on the claim is open, and the organization's SoR.
 */
export interface SorActiveAttemptResponse {
  /** @default null */
  attempt?: SorActiveAttemptResponseSorCommitAttemptView | null;
  /** The organization's SoR, as the claim page names it: organization configuration, not claim content. */
  sor: SorActiveAttemptResponseSorOrganizationView;
}

/**
 * SorCommitAttemptView
 * The claim's open attempt, as the frontend's claim lock reads it.
 *
 * Carries no claim content: nothing here is written by the SoR or copied from the claim, which is why the
 * route serving it checks no access to the claim. A field that adds content brings that check back.
 */
export interface SorActiveAttemptResponseSorCommitAttemptView {
  /** Entity Type */
  entity_type: string;
  /** Label */
  label: string;
  /** Needs Attention */
  needs_attention: boolean;
  /** Operation */
  operation: string;
  /**
   * Started At
   * @format date-time
   */
  started_at: string;
  status: SorActiveAttemptResponseSorCommitStatus;
}

/**
 * SorOrganizationView
 * The organization's SoR, as the claim page names it: organization configuration, not claim content.
 */
export interface SorActiveAttemptResponseSorOrganizationView {
  /** Name */
  name: string;
}

/**
 * SorConfigurationParams
 * A partial update: a field left out (or null) keeps its stored value.
 */
export interface SorConfigurationParams {
  /**
   * Api Base Url
   * @default null
   */
  api_base_url?: string | null;
  /**
   * Api Token
   * @default null
   */
  api_token?: string | null;
  /** @default null */
  auth_mode?: SorConfigurationParamsSorAuthMode | null;
  /**
   * Connect Timeout Seconds
   * @default null
   */
  connect_timeout_seconds?: number | null;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * Enabled Operations
   * @default null
   */
  enabled_operations?: string[] | null;
  /**
   * Extra Header Enabled
   * @default null
   */
  extra_header_enabled?: boolean | null;
  /**
   * Extra Header Name
   * @default null
   */
  extra_header_name?: string | null;
  /**
   * Extra Header Value
   * @default null
   */
  extra_header_value?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Max Tries
   * @default null
   */
  max_tries?: number | null;
  /**
   * Read Timeout Seconds
   * @default null
   */
  read_timeout_seconds?: number | null;
  /**
   * Sso Token Scope
   * @default null
   */
  sso_token_scope?: string | null;
}

/** SorConfigurationResponse */
export interface SorConfigurationResponse {
  /** @default null */
  configuration?: SorConfigurationResponseSorConfigurationInfo | null;
  /** Is Sso Offline Access Enabled */
  is_sso_offline_access_enabled: boolean;
}

/**
 * SorConfigurationInfo
 * The stored configuration. The token and the extra header's value themselves never leave the server:
 * ``api_token_output`` and ``extra_header_value_output`` are placeholders that only say one is set.
 */
export interface SorConfigurationResponseSorConfigurationInfo {
  /**
   * Api Base Url
   * @default null
   */
  api_base_url?: string | null;
  /**
   * Api Token Output
   * @default null
   */
  api_token_output?: string | null;
  /** How CMS authenticates its calls to the organization's SoR. */
  auth_mode: SorConfigurationResponseSorAuthMode;
  /** Connect Timeout Seconds */
  connect_timeout_seconds: number;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /** Enabled Operations */
  enabled_operations: string[];
  /** Extra Header Enabled */
  extra_header_enabled: boolean;
  /**
   * Extra Header Name
   * @default null
   */
  extra_header_name?: string | null;
  /**
   * Extra Header Value Output
   * @default null
   */
  extra_header_value_output?: string | null;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Max Tries */
  max_tries: number;
  /** Organization Id */
  organization_id: number;
  /** Read Timeout Seconds */
  read_timeout_seconds: number;
  /**
   * Sso Token Scope
   * @default null
   */
  sso_token_scope?: string | null;
}

/**
 * SorConnectionTestResult
 * Reachable or not, with how long the probe took either way; when not, with the SoR error's
 * ``error_code`` (``sor_unreachable``, ``sor_unconfirmed``, ``sor_rejected`` or ``sor_request_refused``) and
 * its technical detail in ``error_message``. When the user's SSO token cannot be had, no probe is made:
 * ``sor_not_configured`` or ``sor_login_required`` carry the message the user reads, and ``sor_unreachable``
 * the technical detail.
 */
export interface SorConnectionTestResult {
  /**
   * Error Code
   * @default null
   */
  error_code?: string | null;
  /**
   * Error Message
   * @default null
   */
  error_message?: string | null;
  /** Is Reachable */
  is_reachable: boolean;
  /**
   * Latency Ms
   * @default null
   */
  latency_ms?: number | null;
}

/**
 * SorContractQueryParams
 * Which System of Record contract to download: the organization's own (``configured``) or every
 * operation's (``full``).
 */
export interface SorContractQueryParams {
  /** Scope */
  scope: "configured" | "full";
}

/**
 * SorIssue
 * One attempt as the Issues tab lists it: everything an operator needs to resolve it, behind the Issues
 * permission, unlike the claim lock's view, which carries no claim content. ``status`` stays the stored status;
 * ``issue_status`` is the one the tab filters on; ``max_tries`` is the organization's configuration.
 */
export interface SorIssue {
  /** Api Identifier */
  api_identifier: string;
  /** Claim Id */
  claim_id: number;
  /** Claim Number */
  claim_number: string;
  /** Entity Id */
  entity_id: number;
  /** Entity Type */
  entity_type: string;
  /**
   * Error
   * @default null
   */
  error?: string | null;
  /** Id */
  id: number;
  /** Idempotency Key */
  idempotency_key: string;
  /**
   * An attempt's status as the Issues tab lists it: the stored status, except that an open attempt the
   * reconciler stopped retrying (``tries >= max_tries``) is ``needs_attention`` rather than ``pending`` or
   * ``remote_done``. Not stored: it is derived from the counter, so no write has to keep it in step.
   */
  issue_status: SorIssueSorIssueStatus;
  /** Label */
  label: string;
  /**
   * Last Reconciled At
   * @default null
   */
  last_reconciled_at?: string | null;
  /** Max Tries */
  max_tries: number;
  /** Operation */
  operation: string;
  /**
   * Replayed As User Id
   * @default null
   */
  replayed_as_user_id?: string | null;
  /** Requested By User Id */
  requested_by_user_id: string;
  /**
   * Resolution Note
   * @default null
   */
  resolution_note?: string | null;
  /**
   * Resolved By User Id
   * @default null
   */
  resolved_by_user_id?: string | null;
  /**
   * Responded At
   * @default null
   */
  responded_at?: string | null;
  /**
   * Sent At
   * @default null
   */
  sent_at?: string | null;
  /**
   * Sent Payload
   * @default null
   */
  sent_payload?: Record<string, any> | null;
  /**
   * Sor External Id
   * @default null
   */
  sor_external_id?: string | null;
  /**
   * Sor Latency Ms
   * @default null
   */
  sor_latency_ms?: number | null;
  /**
   * Sor Response
   * @default null
   */
  sor_response?: Record<string, any> | null;
  /**
   * Started At
   * @format date-time
   */
  started_at: string;
  status: SorIssueSorCommitStatus;
  /** Tries */
  tries: number;
}

/**
 * SorIssueIdsParams
 * The Issues tab's filters. A filter left out (or null) does not filter.
 */
export interface SorIssueIdsParams {
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Iso Datetime From
   * @default null
   */
  iso_datetime_from?: string | null;
  /**
   * Iso Datetime To
   * @default null
   */
  iso_datetime_to?: string | null;
  /**
   * Limit
   * @min 1
   * @max 5000
   * @default 1000
   */
  limit?: number;
  /**
   * Operation
   * @default null
   */
  operation?: string | null;
  /**
   * Status
   * @default null
   */
  status?: SorIssueIdsParamsSorIssueStatus[] | null;
}

/** SorIssuesByIdsParams */
export interface SorIssuesByIdsParams {
  /** Ids */
  ids: number[];
}

/**
 * SorOpenAttemptCounts
 * The organization's open attempts (``pending`` or ``remote_done``), and how many of them have used every
 * try its configuration allows.
 */
export interface SorOpenAttemptCounts {
  /** Needs Attention */
  needs_attention: number;
  /** Open Attempts */
  open_attempts: number;
}

/** SorOperationsResponse */
export interface SorOperationsResponse {
  /** Operations */
  operations: SorOperationsResponseSorOperationInfo[];
}

/**
 * SorOperationInfo
 * An operation some module contributes a handler for, as the configuration screen lists it.
 */
export interface SorOperationsResponseSorOperationInfo {
  /** Label */
  label: string;
  /** Operation */
  operation: string;
}

/**
 * SorReconcileReport
 * What one reconciler pass over an organization did: how many attempts ended each visit each way, how many
 * visits failed and were rolled back, for the next tick to take up, and whether it ran out of time before the last
 * attempt. Every outcome is present; an ``unreachable`` one is the visit the pass stopped at, leaving the attempts
 * after it to the next pass. A ``login_required`` one does not stop it: the next attempt may be another user's.
 */
export interface SorReconcileReport {
  /** Errored */
  errored: number;
  /** Outcomes */
  outcomes: Record<string, number>;
  /** Truncated */
  truncated: boolean;
}

/** SorResolveAttemptParams */
export interface SorResolveAttemptParams {
  /**
   * Note
   * @minLength 1
   */
  note: string;
  /** What an operator found at the SoR for an attempt the reconciler stopped retrying. */
  outcome: SorResolveAttemptParamsSorResolution;
  /**
   * Replay As User Id
   * @default null
   */
  replay_as_user_id?: string | null;
  /**
   * Sor External Id
   * @default null
   */
  sor_external_id?: string | null;
}

/** StatReserveConfigurationResponse */
export interface StatReserveConfigurationResponse {
  /** Stat Reserve Configurations */
  stat_reserve_configurations: StatReserveConfigurationResponseStatReserveConfigurationBase[];
}

/** StatReserveConfigurationBase */
export interface StatReserveConfigurationResponseStatReserveConfigurationBase {
  /** Coverage Config Id */
  coverage_config_id: number;
  /** Coverage Display Name */
  coverage_display_name: string;
  /**
   * Coverage Indemnity Sub Reserves Config
   * @default null
   */
  coverage_indemnity_sub_reserves_config?: Record<
    string,
    StatReserveConfigurationResponseSubReservesConfig
  > | null;
  /** Coverage Is Indemnity Sub Reserves Config Enabled */
  coverage_is_indemnity_sub_reserves_config_enabled: boolean;
  /** Coverage Key */
  coverage_key: string;
  /**
   * Expenses Reserve Amount
   * @min 0
   */
  expenses_reserve_amount: number;
  /**
   * Expenses Sub Reserves Amounts
   * @default null
   */
  expenses_sub_reserves_amounts?: Record<
    string,
    StatReserveConfigurationResponseStatSubReserve
  > | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Indemnity Reserve Amount
   * @min 0
   */
  indemnity_reserve_amount: number;
  /**
   * Indemnity Sub Reserves Amounts
   * @default null
   */
  indemnity_sub_reserves_amounts?: Record<
    string,
    StatReserveConfigurationResponseStatSubReserve
  > | null;
  /** Is Expenses Sub Reserves Config Enabled */
  is_expenses_sub_reserves_config_enabled: boolean;
  /** Lob */
  lob: string;
}

/** StatSubReserve */
export interface StatReserveConfigurationResponseStatSubReserve {
  /**
   * Amount
   * @min 0
   */
  amount: number;
  /** Display Name */
  display_name: string;
}

/** SubReservesConfig */
export interface StatReserveConfigurationResponseSubReservesConfig {
  /** Desc */
  desc: string;
  /**
   * Is Hidden
   * @default null
   */
  is_hidden?: boolean | null;
}

/** StatReserveConfigurationSubRule */
export interface StatReserveConfigurationSubRule {
  /**
   * Countries
   * @default []
   */
  countries?: string[] | null;
  /** Coverage Config Id */
  coverage_config_id: number;
  /** Coverage Display Name */
  coverage_display_name: string;
  /**
   * Coverage Indemnity Sub Reserves Config
   * @default null
   */
  coverage_indemnity_sub_reserves_config?: Record<
    string,
    StatReserveConfigurationSubRuleSubReservesConfig
  > | null;
  /** Coverage Is Indemnity Sub Reserves Config Enabled */
  coverage_is_indemnity_sub_reserves_config_enabled: boolean;
  /** Coverage Key */
  coverage_key: string;
  /**
   * Expenses Reserve Amount
   * @min 0
   */
  expenses_reserve_amount: number;
  /**
   * Expenses Sub Reserves Amounts
   * @default null
   */
  expenses_sub_reserves_amounts?: Record<
    string,
    StatReserveConfigurationSubRuleStatSubReserve
  > | null;
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Indemnity Reserve Amount
   * @min 0
   */
  indemnity_reserve_amount: number;
  /**
   * Indemnity Sub Reserves Amounts
   * @default null
   */
  indemnity_sub_reserves_amounts?: Record<
    string,
    StatReserveConfigurationSubRuleStatSubReserve
  > | null;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean;
  /** Is Expenses Sub Reserves Config Enabled */
  is_expenses_sub_reserves_config_enabled: boolean;
  /**
   * Is Sub Rule
   * @default true
   */
  is_sub_rule?: boolean;
  /** Lob */
  lob: string;
  /**
   * States
   * @default []
   */
  states?: string[];
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[];
}

/** StatSubReserve */
export interface StatReserveConfigurationSubRuleStatSubReserve {
  /**
   * Amount
   * @min 0
   */
  amount: number;
  /** Display Name */
  display_name: string;
}

/** SubReservesConfig */
export interface StatReserveConfigurationSubRuleSubReservesConfig {
  /** Desc */
  desc: string;
  /**
   * Is Hidden
   * @default null
   */
  is_hidden?: boolean | null;
}

/** StoredFilesResponse */
export interface StoredFilesResponse {
  /** Stored Files */
  stored_files: StoredFilesResponseStoredFileModel[];
}

/** StoredFileModel */
export interface StoredFilesResponseStoredFileModel {
  /** Filename */
  filename: string | null;
  /** Id */
  id: number;
  /** Mime Type */
  mime_type: string;
  /** Original Filename */
  original_filename: string;
}

/** StripeConfigurationArguments */
export interface StripeConfigurationArguments {
  /**
   * Enabled Rails
   * @default null
   */
  enabled_rails?: ("uk_faster_payments" | "eu_sepa_credit_transfer")[] | null;
  /**
   * Financial Account Currency
   * @default null
   */
  financial_account_currency?: string | null;
  /**
   * Financial Account External Id
   * @default null
   */
  financial_account_external_id?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Secret Key
   * @default null
   */
  secret_key?: string | null;
  /**
   * Statement Descriptor
   * @default null
   */
  statement_descriptor?: string | null;
  /**
   * Webhook Signing Secret
   * @default null
   */
  webhook_signing_secret?: string | null;
}

/** StripeConfigurationResponse */
export interface StripeConfigurationResponse {
  /** @default null */
  configuration?: StripeConfigurationResponseStripeConfiguration | null;
}

/** StripeConfiguration */
export interface StripeConfigurationResponseStripeConfiguration {
  /** Enabled Rails */
  enabled_rails: ("uk_faster_payments" | "eu_sepa_credit_transfer")[];
  /** Financial Account Currency */
  financial_account_currency: string;
  /** Financial Account External Id */
  financial_account_external_id: string;
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Organization Id */
  organization_id: number;
  /**
   * Statement Descriptor
   * @default null
   */
  statement_descriptor?: string | null;
}

/**
 * StripeEventDestinationStatus
 * Where Stripe currently sends this org's events, as Stripe itself reports it.
 *
 * Every field but the first is optional because an unregistered org has nothing to report. They are
 * read together: the integration screen only shows the rest once `is_registered` is true.
 *
 * The signing secret is absent for the same reason it is absent from `StripeConfiguration` above -
 * it is machine-written and never leaves the backend.
 */
export interface StripeEventDestinationStatus {
  /**
   * Are Expected Events Subscribed
   * @default false
   */
  are_expected_events_subscribed?: boolean;
  /** Enabled Events */
  enabled_events?: string[];
  /**
   * Event Destination Id
   * @default null
   */
  event_destination_id?: string | null;
  /** Expected Events */
  expected_events?: string[];
  /** Is Registered */
  is_registered: boolean;
  /**
   * Is Url Current
   * @default false
   */
  is_url_current?: boolean;
  /**
   * Url
   * @default null
   */
  url?: string | null;
}

/** SubmitAgentExchangeRequest */
export interface SubmitAgentExchangeRequest {
  /**
   * User Input
   * @minLength 1
   */
  user_input: string;
}

/** SubrogationFilterRequest */
export interface SubrogationFilterRequest {
  /**
   * Completed Datetime End
   * Filter recoveries completed on or before this date (ISO 8601 format)
   * @default null
   */
  completed_datetime_end?: string | null;
  /**
   * Completed Datetime Start
   * Filter recoveries completed on or after this date (ISO 8601 format)
   * @default null
   */
  completed_datetime_start?: string | null;
  /**
   * Created Datetime End
   * Filter recoveries created on or before this date (ISO 8601 format)
   * @default null
   */
  created_datetime_end?: string | null;
  /**
   * Created Datetime Start
   * Filter recoveries created on or after this date (ISO 8601 format)
   * @default null
   */
  created_datetime_start?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
}

/**
 * SubrogationRecoveredAmountsFilterRequest
 * Filters for the subrogation recovered-amounts endpoint.
 */
export interface SubrogationRecoveredAmountsFilterRequest {
  /**
   * Claim Number
   * Filter by claim number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * End Date
   * Only include recovered amounts on or before this recovery date
   * @default null
   */
  end_date?: string | null;
  /**
   * Exposure Number
   * Filter by exposure number
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Include Cancelled
   * Include cancelled recovered amounts (defaults to excluding them)
   * @default false
   */
  include_cancelled?: boolean | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Start Date
   * Only include recovered amounts on or after this recovery date
   * @default null
   */
  start_date?: string | null;
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * SubrogationRecoveredAmountsListResponse
 * Response schema for the subrogation recovered-amounts list endpoint.
 */
export interface SubrogationRecoveredAmountsListResponse {
  /** Pagination metadata */
  metadata: SubrogationRecoveredAmountsListResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * Subrogation recovered-amount records
   */
  records: SubrogationRecoveredAmountsListResponseSubrogationRecoveredAmountResponse[];
}

/** ContactEmailModel */
export interface SubrogationRecoveredAmountsListResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface SubrogationRecoveredAmountsListResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: SubrogationRecoveredAmountsListResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: SubrogationRecoveredAmountsListResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface SubrogationRecoveredAmountsListResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface SubrogationRecoveredAmountsListResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/**
 * SubrogationRecoveredAmountResponse
 * A single subrogation recovered-amount line item.
 */
export interface SubrogationRecoveredAmountsListResponseSubrogationRecoveredAmountResponse {
  /**
   * Adverse Carrier Contact Ref Id
   * Reference ID of the adverse carrier contact
   * @default null
   */
  adverse_carrier_contact_ref_id?: string | null;
  /**
   * Amount
   * Recovered amount
   * @default null
   */
  amount?: number | null;
  /**
   * Anticipated Amount
   * Anticipated recovery amount for the parent recovery
   * @default null
   */
  anticipated_amount?: number | null;
  /**
   * Cancellation Datetime
   * When the amount was cancelled (ISO 8601)
   * @default null
   */
  cancellation_datetime?: string | null;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Completed Datetime
   * When the parent recovery was completed (ISO 8601)
   * @default null
   */
  completed_datetime?: string | null;
  /**
   * Contacts
   * Contacts related to the parent recovery
   */
  contacts?: SubrogationRecoveredAmountsListResponseContactModel[];
  /**
   * Currency
   * Currency code
   * @default null
   */
  currency?: string | null;
  /**
   * Exposure Number
   * Exposure number, if the recovery is exposure-level
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Id
   * Recovered amount ID
   */
  id: number;
  /**
   * Is Cancelled
   * Whether this recovered amount has been cancelled
   */
  is_cancelled: boolean;
  /**
   * Is Vat Included
   * Whether GST/VAT is included in the amount
   * @default null
   */
  is_vat_included?: boolean | null;
  /**
   * Note
   * Recovery note
   * @default null
   */
  note?: string | null;
  /**
   * Parent Recovery Api Uid
   * API UID of the parent recovery case
   */
  parent_recovery_api_uid: string;
  /**
   * Recovery Created Datetime
   * When the parent recovery was created (ISO 8601)
   * @default null
   */
  recovery_created_datetime?: string | null;
  /**
   * Recovery Date
   * When the amount was recovered (ISO 8601)
   * @default null
   */
  recovery_date?: string | null;
  /**
   * Recovery Note
   * Parent-recovery-level note
   * @default null
   */
  recovery_note?: string | null;
  /**
   * Recovery Status
   * Parent recovery status
   */
  recovery_status: "open" | "completed";
  /**
   * Vat Amount
   * GST/VAT amount included in the recovery
   * @default null
   */
  vat_amount?: number | null;
}

/**
 * SubrogationRecoveryListResponse
 * Response model for paginated subrogation recovery data.
 */
export interface SubrogationRecoveryListResponse {
  /** Pagination metadata */
  metadata: SubrogationRecoveryListResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * List of subrogation recovery records for this page
   */
  records: SubrogationRecoveryListResponseSubrogationRecoveryResponse[];
}

/** ContactEmailModel */
export interface SubrogationRecoveryListResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface SubrogationRecoveryListResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: SubrogationRecoveryListResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: SubrogationRecoveryListResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface SubrogationRecoveryListResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface SubrogationRecoveryListResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/** SubrogationRecoveryResponse */
export interface SubrogationRecoveryListResponseSubrogationRecoveryResponse {
  /**
   * Adverse Carrier Contact Ref Id
   * Reference ID of the adverse carrier contact
   * @default null
   */
  adverse_carrier_contact_ref_id?: string | null;
  /**
   * Anticipated Subro Amount
   * Anticipated subrogation recovery amount
   * @default null
   */
  anticipated_subro_amount?: number | null;
  /**
   * Api Uid
   * API identifier for the recovery
   */
  api_uid: string;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Completed Datetime
   * When recovery was completed (ISO 8601)
   * @default null
   */
  completed_datetime?: string | null;
  /**
   * Contacts
   * Array of contact models related to this recovery
   */
  contacts?: SubrogationRecoveryListResponseContactModel[];
  /**
   * Created Datetime
   * When the recovery was created (ISO 8601)
   */
  created_datetime: string;
  /**
   * Currency
   * Currency code (e.g., 'USD')
   * @default null
   */
  currency?: string | null;
  /**
   * Exposure Number
   * Exposure number
   */
  exposure_number: string;
  /**
   * Note
   * Recovery notes
   * @default null
   */
  note?: string | null;
  /**
   * Reopened Datetime
   * When recovery was reopened (ISO 8601)
   * @default null
   */
  reopened_datetime?: string | null;
  /**
   * Status
   * Recovery status
   */
  status: "completed" | "open";
  /**
   * Subro Recoveries Sum
   * Total amount recovered from subrogation
   * @default null
   */
  subro_recoveries_sum?: number | null;
  /**
   * Type
   * Recovery type
   */
  type: "subro";
  /**
   * Vendor Contact Ref Id
   * Reference ID of the vendor contact
   * @default null
   */
  vendor_contact_ref_id?: string | null;
}

/** SubrogationRecoveryResponse */
export interface SubrogationRecoveryResponse {
  /**
   * Adverse Carrier Contact Ref Id
   * Reference ID of the adverse carrier contact
   * @default null
   */
  adverse_carrier_contact_ref_id?: string | null;
  /**
   * Anticipated Subro Amount
   * Anticipated subrogation recovery amount
   * @default null
   */
  anticipated_subro_amount?: number | null;
  /**
   * Api Uid
   * API identifier for the recovery
   */
  api_uid: string;
  /**
   * Claim Number
   * Claim number
   */
  claim_number: string;
  /**
   * Completed Datetime
   * When recovery was completed (ISO 8601)
   * @default null
   */
  completed_datetime?: string | null;
  /**
   * Contacts
   * Array of contact models related to this recovery
   */
  contacts?: SubrogationRecoveryResponseContactModel[];
  /**
   * Created Datetime
   * When the recovery was created (ISO 8601)
   */
  created_datetime: string;
  /**
   * Currency
   * Currency code (e.g., 'USD')
   * @default null
   */
  currency?: string | null;
  /**
   * Exposure Number
   * Exposure number
   */
  exposure_number: string;
  /**
   * Note
   * Recovery notes
   * @default null
   */
  note?: string | null;
  /**
   * Reopened Datetime
   * When recovery was reopened (ISO 8601)
   * @default null
   */
  reopened_datetime?: string | null;
  /**
   * Status
   * Recovery status
   */
  status: "completed" | "open";
  /**
   * Subro Recoveries Sum
   * Total amount recovered from subrogation
   * @default null
   */
  subro_recoveries_sum?: number | null;
  /**
   * Type
   * Recovery type
   */
  type: "subro";
  /**
   * Vendor Contact Ref Id
   * Reference ID of the vendor contact
   * @default null
   */
  vendor_contact_ref_id?: string | null;
}

/** ContactEmailModel */
export interface SubrogationRecoveryResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface SubrogationRecoveryResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: SubrogationRecoveryResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: SubrogationRecoveryResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface SubrogationRecoveryResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * SupportedEventsResponse
 * Response model for supported events endpoint
 */
export interface SupportedEventsResponse {
  /**
   * Events
   * Dictionary of supported events keyed by event_key
   */
  events: Record<string, SupportedEventsResponseSupportedEventModel>;
}

/**
 * SupportedEventModel
 * Model for a single supported event
 */
export interface SupportedEventsResponseSupportedEventModel {
  /**
   * Desc
   * Human-readable event description
   */
  desc: string;
  /**
   * Scope
   * Event scope (claim, exposure, etc.)
   */
  scope: string;
}

/** SysconfigDataImportGetSchemaParams */
export interface SysconfigDataImportGetSchemaParams {
  additional_configurations: SysconfigDataImportGetSchemaParamsDataImportConfig;
}

/** DataImportConfig */
export interface SysconfigDataImportGetSchemaParamsDataImportConfig {
  /**
   * Should Generate Claim Numbers
   * @default true
   */
  should_generate_claim_numbers?: boolean;
}

/** TableauAccountList */
export type TableauAccountList = TableauAccountListTableauAccount[];

/** TableauAccount */
export interface TableauAccountListTableauAccount {
  /** Created By User Id */
  created_by_user_id: string;
  /** Created By Username */
  created_by_username: string;
  /**
   * Created Datetime
   * @format date-time
   */
  created_datetime: string;
  /** Id */
  id: number;
  /**
   * Last Active Datetime
   * @default null
   */
  last_active_datetime?: string | null;
  /**
   * Site Role
   * @default null
   */
  site_role?: string | null;
  /** Tableau User Active */
  tableau_user_active: boolean;
  /** User Id */
  user_id: string;
  /** Username */
  username: string;
}

/** TableauProject */
export interface TableauProject {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /**
   * Parent Id
   * @default null
   */
  parent_id?: string | null;
}

/** TableauProjectList */
export type TableauProjectList = TableauProjectListTableauProject[];

/** TableauProject */
export interface TableauProjectListTableauProject {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /**
   * Parent Id
   * @default null
   */
  parent_id?: string | null;
}

/** TableauSite */
export interface TableauSite {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /**
   * Tier Explorer Capacity
   * @default null
   */
  tier_explorer_capacity?: number | null;
  /**
   * Tier Viewer Capacity
   * @default null
   */
  tier_viewer_capacity?: number | null;
}

/** TableauUserList */
export type TableauUserList = TableauUserListTableauUser[];

/** TableauUser */
export interface TableauUserListTableauUser {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /**
   * Org User Id
   * @default null
   */
  org_user_id?: string | null;
  /** Site Role */
  site_role: string;
}

/** TableauViewList */
export type TableauViewList = TableauViewListTableauView[];

/** TableauView */
export interface TableauViewListTableauView {
  /** Content Url */
  content_url: string;
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Owner Id */
  owner_id: string;
  /** Workbook Id */
  workbook_id: string;
}

/** TableauWorkbookList */
export type TableauWorkbookList = TableauWorkbookListTableauWorkbook[];

/** TableauWorkbook */
export interface TableauWorkbookListTableauWorkbook {
  /** Content Url */
  content_url: string;
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Owner Id */
  owner_id: string;
  /**
   * Project Id
   * @default null
   */
  project_id?: string | null;
  /**
   * Project Name
   * @default null
   */
  project_name?: string | null;
  /**
   * Updated At
   * @default null
   */
  updated_at?: string | null;
}

/**
 * TemplateRequest
 * Query parameters for template generation.
 */
export interface TemplateRequest {
  /**
   * Lob
   * Line of Business (e.g., 'auto_claim', 'general_liability')
   */
  lob: string;
  /**
   * Sub Organization External Id
   * Sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
}

/**
 * TemplateResponse
 * Response model for template operations.
 */
export interface TemplateResponse {
  /** Template */
  template: Record<string, any>;
}

/**
 * TemplateSectionConditionFieldsParams
 * The scope the section editor's condition catalog is read for: the LOBs and sub-organizations the
 * template form holds, in the shared catalog route's query parameters. The rule set is this module's.
 */
export interface TemplateSectionConditionFieldsParams {
  /**
   * Event Key
   * @default null
   */
  event_key?: string | null;
  /** @default "intersection" */
  filtering_mode?: TemplateSectionConditionFieldsParamsFilteringMode;
  /**
   * Is All Lobs
   * @default false
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default false
   */
  is_all_sub_orgs?: boolean;
  "lobs[]": TemplateSectionConditionFieldsParamsEnsuredListStr;
  /**
   * Rule Set Type
   * @default "template_section_condition"
   */
  rule_set_type?: "template_section_condition";
  "sub_org_ids[]"?: TemplateSectionConditionFieldsParamsEnsuredListInt;
}

export type TemplateSectionConditionFieldsParamsEnsuredListInt = number[];

export type TemplateSectionConditionFieldsParamsEnsuredListStr = string[];

/**
 * TemplateUploadResponse
 * Response schema for template file upload.
 */
export interface TemplateUploadResponse {
  /**
   * Filename
   * Original filename of the uploaded template
   */
  filename: string;
  /**
   * Gcs Path
   * GCS path where the uploaded template is stored
   */
  gcs_path: string;
  /**
   * Sheets
   * List of sheets found in the Excel file with their extracted variables
   */
  sheets?: TemplateUploadResponseSheetUploadInfo[];
}

/**
 * SheetUploadInfo
 * Per-sheet information extracted during upload.
 */
export interface TemplateUploadResponseSheetUploadInfo {
  /**
   * Extracted Variables
   * Variables extracted from the sheet (e.g., ['Claim Number', 'Status'])
   */
  extracted_variables?: string[];
  /**
   * Sheet Name
   * Original sheet name from the Excel file
   */
  sheet_name: string;
}

/**
 * TemplatesFilterRequest
 * Request model for filtering templates with cursor-based pagination.
 *
 * Extends the base CursorPaginationRequest with templates-specific filters
 * as flat parameters for better REST API design.
 * Supports all template types: email, notification, sms, etc.
 */
export interface TemplatesFilterRequest {
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Is Enabled
   * Filter by enabled status
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Lob
   * Filter by line of business
   * @default null
   */
  lob?: string | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Sub Organization External Id
   * Filter by sub-organization external ID
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Template Level
   * Filter by template level (exposure, claim)
   * @default null
   */
  template_level?: "exposure" | "claim" | null;
  /**
   * Template Type
   * Filter by template type (email, notification, sms, note)
   * @default null
   */
  template_type?: "email" | "notification" | "sms" | "note" | null;
}

/** TemplatesResponse */
export interface TemplatesResponse {
  /** Pagination metadata */
  metadata: TemplatesResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /**
   * Records
   * List of templates matching the filter criteria
   */
  records: TemplatesResponseTemplateResponse[];
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface TemplatesResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/**
 * TemplateResponse
 * Response model for a single template (any type).
 */
export interface TemplatesResponseTemplateResponse {
  /**
   * Api Uid
   * Unique API identifier for the template
   */
  api_uid: string;
  /**
   * Countries
   * List of countries this template applies to, null if applies to all countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Datetime Created
   * When the template was created
   * @format date-time
   */
  datetime_created: string;
  /**
   * Dynamic Token Fields
   * Available dynamic tokens fields
   */
  dynamic_token_fields: string[];
  /**
   * Is All Countries
   * Whether template applies to all countries
   * @default null
   */
  is_all_countries?: boolean | null;
  /**
   * Is All States
   * Whether template applies to all states (if relevant)
   */
  is_all_states: boolean;
  /**
   * Is Enabled
   * Whether the template is enabled
   */
  is_enabled: boolean;
  /**
   * Last Update Datetime
   * When the template was last updated
   * @format date-time
   */
  last_update_datetime: string;
  /**
   * Lobs
   * List of lines of business this template applies to
   */
  lobs: string[];
  /**
   * States
   * List of states this template applies to, null if no state restrictions
   * @default null
   */
  states?: string[] | null;
  /**
   * Template Level
   * Template level (exposure, claim)
   */
  template_level: "exposure" | "claim";
  /**
   * Template Name
   * Human-readable name of the template
   */
  template_name: string;
  /**
   * Template Type
   * Type of template (email, notification, sms, note)
   */
  template_type: "email" | "notification" | "sms" | "note";
}

/**
 * TemporaryUploadFinalizeRequest
 * Request to validate a snapshot ZIP uploaded to its upload session.
 */
export interface TemporaryUploadFinalizeRequest {
  /**
   * Upload Key
   * Upload UUID returned with the upload session
   * @format uuid
   */
  upload_key: string;
}

/**
 * TemporaryUploadResponse
 * Response from temporary snapshot upload.
 * @example {"manifest":{"files":[],"format_version":"1.0.0","organization_external_id":"acme-corp","snapshot_hash":"b3f1c9e6...","totals":{}},"upload_key":"a1b2c3d4-e5f6-7890-1234-567890abcdef"}
 */
export interface TemporaryUploadResponse {
  /** Full manifest from ZIP archive */
  manifest: TemporaryUploadResponseSnapshotManifestV1;
  /**
   * Upload Key
   * Opaque UUID for referencing this upload
   */
  upload_key: string;
}

/**
 * ManifestFileEntry
 * Entry for a single file in the archive manifest.
 *
 * Provides metadata and integrity information for each file.
 */
export interface TemporaryUploadResponseManifestFileEntry {
  /**
   * Configuration Type
   * Configuration type name (required for config files)
   * @default null
   */
  configuration_type?: string | null;
  /**
   * Content Type
   * MIME type of the file
   */
  content_type: string;
  /**
   * Name
   * Relative path of file inside ZIP archive
   */
  name: string;
  /** Role of the file (config or asset) */
  role: TemporaryUploadResponseFileRole;
  /**
   * Schema Version
   * Adapter schema semantic version for config files
   * @default null
   */
  schema_version?: string | null;
  /**
   * Sha256
   * SHA-256 hash of file bytes (hex)
   * @pattern ^[a-f0-9]{64}$
   */
  sha256: string;
  /**
   * Size Bytes
   * Size of file in bytes
   * @min 0
   */
  size_bytes: number;
}

/**
 * ManifestTotals
 * Summary statistics for the archive.
 */
export interface TemporaryUploadResponseManifestTotals {
  /**
   * Bytes Uncompressed
   * Total uncompressed size in bytes
   * @min 0
   */
  bytes_uncompressed: number;
  /**
   * Configuration Types
   * Number of configuration types
   * @min 0
   */
  configuration_types: number;
  /**
   * Files
   * Total number of files
   * @min 0
   */
  files: number;
}

/**
 * SnapshotManifestV1
 * Manifest schema for configuration snapshot ZIP archives (format version 1.0.0).
 *
 * The manifest provides machine-readable description and integrity details
 * for each file in the archive. It is always named 'manifest.json' at the
 * root of the ZIP archive.
 *
 * Follows the specification in docs/export_format.md
 * @example {"created_at":"2025-10-01T12:34:56Z","files":[{"configuration_type":"organization_settings","content_type":"application/json","name":"organization_settings.json","role":"config","schema_version":"1.0.0","sha256":"a1b2c3d4e5f6...","size_bytes":12345}],"format_version":"1.0.0","organization_external_id":"acme-corp","snapshot_hash":"b3f1c9e6d2a8f7b4e5c1d3a2f9e8b7c6d5a4e3f2b1c0d9e8f7a6b5c4d3e2f1","totals":{"bytes_uncompressed":2048576,"configuration_types":5,"files":7}}
 */
export interface TemporaryUploadResponseSnapshotManifestV1 {
  /**
   * Blocked Configuration Types
   * Configuration types left out because their export was blocked
   * @default null
   */
  blocked_configuration_types?: string[] | null;
  /**
   * Created At
   * ISO 8601 timestamp when snapshot was created (UTC)
   * @pattern ^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$
   */
  created_at: string;
  /**
   * Files
   * List of files in the archive
   * @minItems 1
   */
  files: TemporaryUploadResponseManifestFileEntry[];
  /**
   * Format Version
   * Manifest format version (semantic versioning)
   */
  format_version: "1.0.0";
  /**
   * Organization External Id
   * External ID of source organization
   */
  organization_external_id: string;
  /**
   * Snapshot Hash
   * Content-addressed SHA-256 hash of snapshot
   * @pattern ^[a-f0-9]{64}$
   */
  snapshot_hash: string;
  /** Summary statistics for the archive */
  totals: TemporaryUploadResponseManifestTotals;
}

/**
 * TemporaryUploadUrlRequest
 * Request to start a direct-to-GCS upload of a snapshot ZIP.
 * @example {"file_name":"Acme-Corp-snapshot-2026-10-23.zip","file_size":50376559,"file_type":"application/zip"}
 */
export interface TemporaryUploadUrlRequest {
  /**
   * File Name
   * Name of the file to upload; must end in .zip
   */
  file_name: string;
  /**
   * File Size
   * File size in bytes; the upload session accepts exactly this many
   */
  file_size: number;
  /**
   * File Type
   * MIME type the browser reports for the file; the stored file is always application/zip
   */
  file_type: string;
}

/**
 * TemporaryUploadUrlResponse
 * Upload session for a snapshot ZIP.
 */
export interface TemporaryUploadUrlResponse {
  /**
   * Upload Key
   * Opaque UUID for referencing this upload
   */
  upload_key: string;
  /**
   * Upload Url
   * Resumable GCS upload session URL to PUT the file to
   */
  upload_url: string;
}

/**
 * TfnApproveVerificationResponse
 * Response schema for approve TFN verification endpoint.
 */
export interface TfnApproveVerificationResponse {
  /**
   * Approved At
   * @format date-time
   */
  approved_at: string;
  /** Approved By */
  approved_by: string;
  /** Status */
  status: string;
  /** Verification Id */
  verification_id: number;
}

/**
 * TfnVerificationDetailsResponse
 * Response schema for TFN verification details endpoint.
 */
export interface TfnVerificationDetailsResponse {
  /** Change Ulid */
  change_ulid: string;
  /**
   * Deciding User
   * @default null
   */
  deciding_user?: string | null;
  /**
   * Decision Datetime
   * @default null
   */
  decision_datetime?: string | null;
  /**
   * Request Datetime
   * @format date-time
   */
  request_datetime: string;
  /** Requesting User */
  requesting_user: string;
  /** Requesting User Id */
  requesting_user_id: string;
  /** Status */
  status: string;
}

/**
 * TfnVerificationItemIdsParams
 * Parameters for fetching pending TFN verification IDs.
 */
export interface TfnVerificationItemIdsParams {
  /**
   * Limit
   * @default 1000
   */
  limit?: number | null;
}

/**
 * TfnVerificationItemsByIdsParams
 * Parameters for fetching TFN verifications by their change ULIDs.
 */
export interface TfnVerificationItemsByIdsParams {
  /** Ids */
  ids: string[];
}

/**
 * ToggleBookmarkResponse
 * Response schema for bookmark toggle.
 */
export interface ToggleBookmarkResponse {
  /** Id */
  id: number;
  /** Is Bookmarked */
  is_bookmarked: boolean;
}

/** TogglePreConfiguredJson */
export interface TogglePreConfiguredJson {
  /** Is Disabled */
  is_disabled: boolean;
  /** Notification Key */
  notification_key: string;
}

/** ToggleSelfConfiguredJson */
export interface ToggleSelfConfiguredJson {
  /** Is Disabled */
  is_disabled: boolean;
  /** Notification Id */
  notification_id: number;
}

/**
 * TwilioConfigurationPatch
 * PATCH body for /twilio_configuration. Queue/wrap-up columns only.
 *
 * The 7-section legacy passthrough (caller_id_enabled, voicemail_message_enabled, etc.)
 * was retired with Phone Profiles T6 — those settings now PATCH directly via
 * /phone_profiles/<id>.
 */
export interface TwilioConfigurationPatch {
  /**
   * Ddi Routing Enabled
   * @default null
   */
  ddi_routing_enabled?: boolean | null;
  /**
   * Default Queue Sid
   * @default null
   */
  default_queue_sid?: string | null;
  /**
   * Direct Call Timeout Seconds
   * @default null
   */
  direct_call_timeout_seconds?: number | null;
  /**
   * Workspace Configuration
   * @default null
   */
  workspace_configuration?: Record<string, any> | null;
  /**
   * Wrap Up Time Enabled
   * @default null
   */
  wrap_up_time_enabled?: boolean | null;
  /**
   * Wrap Up Time Seconds
   * @default null
   */
  wrap_up_time_seconds?: number | null;
}

/**
 * TwilioConfigurationResponse
 * What a response may carry of a TwilioConfiguration row: everything but its credentials.
 *
 * Exposes the TwilioConfiguration's own columns (workspace, queue/wrap-up). The legacy
 * 7-section default-profile passthrough was removed after the FE migrated to
 * profile-aware reads (Phone Profiles T6) — those settings now live exclusively
 * on PhoneProfile and are read through PhoneProfileInfo.
 */
export interface TwilioConfigurationResponse {
  /** Account Sid */
  account_sid: string;
  /** Application Sid */
  application_sid: string;
  /**
   * Ddi Routing Enabled
   * @default null
   */
  ddi_routing_enabled?: boolean | null;
  /** Ddi Routing Initiated */
  ddi_routing_initiated: boolean;
  /**
   * Default Phone Profile Id
   * @default null
   */
  default_phone_profile_id?: number | null;
  /**
   * Default Queue Sid
   * @default null
   */
  default_queue_sid?: string | null;
  /**
   * Direct Call Timeout Seconds
   * @default null
   */
  direct_call_timeout_seconds?: number | null;
  /** Id */
  id: number;
  /**
   * Is Queues Enabled
   * @default false
   */
  is_queues_enabled?: boolean;
  /** Organization Id */
  organization_id: number;
  /**
   * Queue Voicemail Enabled
   * @default false
   */
  queue_voicemail_enabled?: boolean;
  /** Queue Voicemail Initiated */
  queue_voicemail_initiated: boolean;
  /**
   * Queue Voicemail Task Timeout Seconds
   * @default null
   */
  queue_voicemail_task_timeout_seconds?: number | null;
  workspace_configuration: TwilioConfigurationResponseWorkspaceConfiguration;
  /**
   * Wrap Up Time Enabled
   * @default null
   */
  wrap_up_time_enabled?: boolean | null;
  /** Wrap Up Time Initiated */
  wrap_up_time_initiated: boolean;
  /**
   * Wrap Up Time Seconds
   * @default null
   */
  wrap_up_time_seconds?: number | null;
}

/** WorkspaceConfiguration */
export interface TwilioConfigurationResponseWorkspaceConfiguration {
  /** Activities */
  activities?: Record<string, string>;
  /** Twilio Workspace Sid */
  twilio_workspace_sid: string;
  /**
   * Twilio Workspace Workflow Sid
   * @default null
   */
  twilio_workspace_workflow_sid?: string | null;
  [key: string]: any;
}

/** UnitActivationJson */
export interface UnitActivationJson {
  /** Is Active */
  is_active: boolean;
  /**
   * Member User Ids
   * @default null
   */
  member_user_ids?: string[] | null;
}

/** UnitRelatedConfigurationsResponse */
export interface UnitRelatedConfigurationsResponse {
  /** Configurations */
  configurations: Record<
    string,
    UnitRelatedConfigurationsResponseUnitRelatedConfiguration[]
  >;
}

/** UnitRelatedConfiguration */
export interface UnitRelatedConfigurationsResponseUnitRelatedConfiguration {
  /** Name */
  name: string;
}

/** UnlinkContactFromClaimRequest */
export interface UnlinkContactFromClaimRequest {
  /** Reason */
  reason: string;
}

/** UnlinkEligibilityResponse */
export interface UnlinkEligibilityResponse {
  /** Can Unlink */
  can_unlink: boolean;
  /**
   * Reasons
   * @default []
   */
  reasons?: string[];
}

/** UpdateAssignmentDefaultsParams */
export interface UpdateAssignmentDefaultsParams {
  /**
   * Fallback User Id
   * @default null
   */
  fallback_user_id?: string | null;
  /**
   * Is License Correlation Enabled
   * @default null
   */
  is_license_correlation_enabled?: boolean | null;
  /**
   * Is License Presentation Enabled
   * @default null
   */
  is_license_presentation_enabled?: boolean | null;
}

/** UpdateAssignmentGroupParams */
export interface UpdateAssignmentGroupParams {
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * User Ids
   * @default null
   */
  user_ids?: string[] | null;
}

/** UpdateAssignmentJsonParams */
export interface UpdateAssignmentJsonParams {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Completion Datetime
   * @default null
   */
  completion_datetime?: string | null;
  /**
   * Note
   * @default ""
   */
  note?: string | null;
  /**
   * Reject Reason
   * @default null
   */
  reject_reason?: string | null;
  /**
   * Update Datetime
   * @default null
   */
  update_datetime?: string | null;
  /** Updated Status */
  updated_status: string;
}

/** UpdateAssignmentResponse */
export interface UpdateAssignmentResponse {
  /** Success */
  success: boolean;
}

/** UpdateAssignmentRuleParams */
export interface UpdateAssignmentRuleParams {
  /** @default null */
  assignee?: UpdateAssignmentRuleParamsRuleAssignee | null;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * Entity
   * @default null
   */
  entity?: string | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /**
   * Lob
   * @default null
   */
  lob?: string | null;
  /**
   * Method
   * @default null
   */
  method?: string | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/**
 * RuleAssignee
 * Who an assignment rule assigns to, tagged with its kind.
 *
 * ``id`` carries the target's identifier for the two kinds that reference one — a user id for
 * ``user``, an assignment-group id for ``group`` — and is ``None`` for the two sentinel kinds,
 * which name a role resolved at assignment time (``fnol_taker`` is the user who filed the FNOL;
 * ``claim_owner`` is the owner of the exposure's claim).
 *
 * The tag is the only thing that says which kind an assignee is: no consumer may re-derive it
 * from the rule's ``(method, entity)`` pair or from the type of ``id``.
 */
export interface UpdateAssignmentRuleParamsRuleAssignee {
  /**
   * Id
   * @default null
   */
  id?: string | number | null;
  /** The four kinds an assignment rule's assignee can be. */
  kind: UpdateAssignmentRuleParamsRuleAssigneeKind;
}

/** UpdateClaimComplexityParams */
export interface UpdateClaimComplexityParams {
  /** Complexity */
  complexity: string;
  /**
   * Complexity Reason
   * @default null
   */
  complexity_reason?: string | null;
}

/**
 * UpdateClaimComplexityRequest
 * Request model for updating claim complexity via external API.
 */
export interface UpdateClaimComplexityRequest {
  /**
   * Complexity Level
   * New complexity level for the claim. One of: low, medium, high
   */
  complexity_level: "low" | "medium" | "high";
  /**
   * Complexity Reason
   * Reason for the complexity level change
   * @default null
   */
  complexity_reason?: string | null;
}

/** UpdateCommunicationCategoriesParams */
export interface UpdateCommunicationCategoriesParams {
  /**
   * Categories
   * List of category IDs to associate with the communication
   */
  categories: number[];
  /**
   * Claim Id
   * Claim ID if communication is claim-related
   * @default null
   */
  claim_id?: number | null;
}

/**
 * UpdateCommunicationExternalRequest
 * Request model for updating a communication via the external API.
 *
 * Every field is optional and an omitted one is left unchanged, mirroring
 * ``UpdateContactExternalRequest``: presence is read from ``model_fields_set``, so a second
 * updatable field can be added here without forcing callers that do not touch the categories to
 * resend them (and risk replacing the tags by getting them wrong). A request that provides no
 * field at all is rejected rather than silently doing nothing, as that sibling also does.
 *
 * ``category_keys``, when provided, is the full desired set: the categories not listed are
 * removed, so an empty list clears them. Categories are identified by ``key`` rather than id —
 * the config repository treats ``key`` as a category's identity and exports it without an id, so
 * the same category has a different id in every environment.
 */
export interface UpdateCommunicationExternalRequest {
  /**
   * Category Keys
   * Keys of the categories to apply. The full desired set; [] clears the communication's categories. Omit the field to leave them unchanged — null is rejected, since it would be indistinguishable from omitting it.
   * @default null
   */
  category_keys?: string[] | null;
}

/**
 * UpdateContactExternalRequest
 * Flat request model for updating a contact via the external API.
 *
 * All fields are optional — only explicitly provided fields are updated.
 * Uses ``model_fields_set`` to distinguish provided-as-None from not-provided.
 */
export interface UpdateContactExternalRequest {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Emails
   * @default null
   */
  emails?: UpdateContactExternalRequestContactEmailModel[] | null;
  /**
   * Explanation
   * Free-text explanation, required when reason is "other"
   * @default null
   */
  explanation?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Company
   * @default null
   */
  is_company?: boolean | null;
  /**
   * Is Deceased
   * @default null
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default null
   */
  phones?: UpdateContactExternalRequestContactPhoneModel[] | null;
  /**
   * Reason
   * Reason for the update (typo, addition, update, other, ...)
   */
  reason: string;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /**
   * Role
   * Contact role (e.g. claimant, insured, witness, vendor). Cannot be changed for policy contacts (insured/named driver linked to a policy).
   * @default null
   */
  role?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactEmailModel */
export interface UpdateContactExternalRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactPhoneModel */
export interface UpdateContactExternalRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/**
 * UpdateCotConfigurationRequest
 * Request model for updating an existing CotConfiguration.
 */
export interface UpdateCotConfigurationRequest {
  /** Updated COT configuration data */
  configuration: UpdateCotConfigurationRequestCotConfigurationData;
}

/**
 * CotConfigurationData
 * Pydantic model for Clive on Top configuration data stored in JSONB field.
 *
 * This represents the structure of the 'configuration' JSON field in CotConfiguration model.
 * @example {"cot_organization_external_id":"cot_org_external_id","enabled_event_keys":["new_claim_created_event"],"is_enabled":true,"service_account_token":"secret_token_here"}
 */
export interface UpdateCotConfigurationRequestCotConfigurationData {
  /**
   * Cot Organization External Id
   * External ID of the COT organization for API calls
   */
  cot_organization_external_id: string;
  /**
   * Enabled Event Keys
   * List of event keys that should trigger cross-organization communication
   */
  enabled_event_keys?: string[];
  /**
   * Is Enabled
   * Whether this COT configuration is active
   * @default true
   */
  is_enabled?: boolean;
  /**
   * Service Account Token
   * Service account token for authentication with COT organization
   */
  service_account_token: string;
}

/** UpdateDAConfigParams */
export interface UpdateDAConfigParams {
  /** Enabled */
  enabled: boolean;
  /**
   * Round Robin Approver Selection Enabled
   * @default null
   */
  round_robin_approver_selection_enabled?: boolean | null;
}

/** UpdateDocumentTemplateForm */
export interface UpdateDocumentTemplateForm {
  /** Comment */
  comment: string;
  /** Countries */
  countries: string;
  /** Coverages */
  coverages: string;
  /** Display Name */
  display_name: string;
  /** Document Type */
  document_type: string;
  /**
   * File
   * @default null
   */
  file?: File | null;
  /** Filename */
  filename: string;
  /** Is All Countries */
  is_all_countries: string;
  /** Is All Coverages */
  is_all_coverages: string;
  /** Is All Lobs */
  is_all_lobs: string;
  /** Is All Sub Orgs */
  is_all_sub_orgs: string;
  /** Lobs */
  lobs: string;
  /** States */
  states: string;
  /** Sub Organization Ids */
  sub_organization_ids: string;
}

/** UpdateESignConfigRequest */
export interface UpdateESignConfigRequest {
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * UpdateExposureLineItemsRequest
 * Request to update line items for an exposure.
 */
export interface UpdateExposureLineItemsRequest {
  /** Line Items */
  line_items: UpdateExposureLineItemsRequestExposureLineItemData[];
}

/**
 * ExposureLineItemData
 * Line item data for exposure-based updates.
 *
 * Either `invoice_id` (existing or already-known invoice) or `document_id` (a claim
 * document for which the BE will create the invoice during the upsert) must be set.
 */
export interface UpdateExposureLineItemsRequestExposureLineItemData {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  /**
   * Base Amount
   * @default null
   */
  base_amount?: number | null;
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Conversion Date
   * @default null
   */
  conversion_date?: string | null;
  /**
   * Conversion Rate
   * @default null
   */
  conversion_rate?: number | null;
  coverage_decision: UpdateExposureLineItemsRequestCoverageDecisionOption;
  /**
   * Coverage Id
   * @default null
   */
  coverage_id?: number | null;
  /**
   * Coverage Key
   * @default null
   */
  coverage_key?: string | null;
  /**
   * Covered Amount
   * @default null
   */
  covered_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Document Id
   * @default null
   */
  document_id?: number | null;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * Id
   * @default null
   */
  id?: string | number | null;
  /**
   * Invoice Id
   * @default null
   */
  invoice_id?: number | null;
  /**
   * Is Depreciation Overridden
   * @default null
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Is Locked
   * @default null
   */
  is_locked?: boolean | null;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /**
   * Months Owned
   * @default null
   */
  months_owned?: number | null;
  /** @default null */
  payable_type?: UpdateExposureLineItemsRequestPayableType | null;
  /**
   * Payment Request Id
   * @default null
   */
  payment_request_id?: number | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/** UpdateExposureRulesConfigParams */
export interface UpdateExposureRulesConfigParams {
  /** Require Coverage For Automatic Exposures */
  require_coverage_for_automatic_exposures: boolean;
}

/**
 * UpdateExternalToolConfigParams
 * PUT body. ``tool_name`` (URL path) and ``sub_organization_id`` (query param) are immutable
 * scope identity — they address the resource, so they never live in the mutable body.
 */
export interface UpdateExternalToolConfigParams {
  /**
   * Extra Headers
   * @default null
   */
  extra_headers?: Record<string, string> | null;
  /** Is Enabled */
  is_enabled: boolean;
  /** Payload Fields */
  payload_fields: UpdateExternalToolConfigParamsExternalToolPayloadFieldSchema[];
  /** Query Params */
  query_params?: Record<string, string>;
  /**
   * Url
   * @minLength 1
   * @maxLength 2048
   */
  url: string;
}

/**
 * ExternalToolPayloadFieldSchema
 * CMS-native ("configured field") request-contract shape for one external-tool payload field.
 *
 * The service interface accepts these rather than fivesigma-ai's
 * ``DynamicDataFieldConfigurationSchema`` so consumers (e.g. the sysconfig API) speak CMS types
 * only and never import a fivesigma-ai type. The service dumps them to plain dicts at the
 * manager boundary, where they are validated and persisted (see
 * ``payload_fields_schema.validate_payload_fields``).
 */
export interface UpdateExternalToolConfigParamsExternalToolPayloadFieldSchema {
  /** Description */
  description: string;
  /**
   * Enum Values
   * @default null
   */
  enum_values?: string[] | null;
  /**
   * The payload-field types an external tool may declare.
   *
   * Restricted to the three types the design doc allows for external-tool payloads; the
   * manager re-validates the same allow-list against the persisted fields.
   */
  field_type: UpdateExternalToolConfigParamsExternalToolPayloadFieldType;
  /**
   * Is Required
   * @default null
   */
  is_required?: boolean | null;
  /** Key */
  key: string;
  /** Title */
  title: string;
}

/**
 * UpdateFundAccountEngineConfigParams
 * PUT body for the engine config — a full replacement of both fields.
 *
 * An omitted ``default_account_id`` therefore clears it, and an explicit
 * ``default_behavior: null`` clears the behavior. ``default_account_id`` is
 * required when the behavior is ``default_account`` — and a blank one does not
 * satisfy that, since it normalizes to None here before the gate sees it.
 */
export interface UpdateFundAccountEngineConfigParams {
  /**
   * Default Account Id
   * @default null
   */
  default_account_id?: string | null;
  default_behavior: UpdateFundAccountEngineConfigParamsFundAccountDefaultBehavior | null;
}

/** UpdateGenericTemplateEnablementRequest */
export interface UpdateGenericTemplateEnablementRequest {
  /** Is Enabled */
  is_enabled: boolean;
}

/** UpdateGenericTemplateMoiEmailRequest */
export interface UpdateGenericTemplateMoiEmailRequest {
  /**
   * Applies To Moi Method Keys
   * MOI method mappings (by method key) to set on update. `None` (omitted) leaves the existing mappings untouched, while an empty list `[]` clears all mappings.
   * @default null
   */
  applies_to_moi_method_keys?: string[] | null;
  /**
   * Body Template
   * @default null
   */
  body_template?: string | null;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverage Keys
   * @default null
   */
  coverage_keys?: string[] | null;
  /**
   * Document Template Id
   * @default null
   */
  document_template_id?: number | null;
  /**
   * External Template Id
   * @default null
   */
  external_template_id?: string | null;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All States
   * @default null
   */
  is_all_states?: boolean | null;
  /**
   * Is All Suborgs
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /**
   * Is Claim Level
   * @default null
   */
  is_claim_level?: boolean | null;
  /**
   * Is Default
   * @default null
   */
  is_default?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Template Name
   * @default null
   */
  template_name?: string | null;
  /**
   * Template Type
   * @default null
   */
  template_type?: string | null;
  /**
   * Title Template
   * @default null
   */
  title_template?: string | null;
}

/** UpdateGenericTemplateRequest */
export interface UpdateGenericTemplateRequest {
  /**
   * Body Template
   * @default null
   */
  body_template?: string | null;
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Countries
   * @default null
   */
  countries?: string[] | null;
  /**
   * Coverage Keys
   * @default null
   */
  coverage_keys?: string[] | null;
  /**
   * Document Template Id
   * @default null
   */
  document_template_id?: number | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /**
   * External Template Id
   * @default null
   */
  external_template_id?: string | null;
  /**
   * Is All Countries
   * @default true
   */
  is_all_countries?: boolean | null;
  /**
   * Is All Coverages
   * @default null
   */
  is_all_coverages?: boolean | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All States
   * @default null
   */
  is_all_states?: boolean | null;
  /**
   * Is All Suborgs
   * @default null
   */
  is_all_suborgs?: boolean | null;
  /**
   * Is Claim Level
   * @default null
   */
  is_claim_level?: boolean | null;
  /**
   * Is Due Date Immediate
   * @default true
   */
  is_due_date_immediate?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * Sections
   * The conditional sections the body wraps in `data-section-key` elements, one entry per key. Omitted: the stored sections are kept. `[]` removes every section. Without the conditional template sections feature a non-empty list is rejected and `[]` removes nothing.
   * @default null
   */
  sections?: UpdateGenericTemplateRequestTemplateSectionRequest[] | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Template Name
   * @default null
   */
  template_name?: string | null;
  /**
   * Template Type
   * @default null
   */
  template_type?: string | null;
  /**
   * Title Template
   * @default null
   */
  title_template?: string | null;
}

/**
 * TemplateSectionRequest
 * One conditional section of the body, named by the ``data-section-key`` of the element wrapping it.
 */
export interface UpdateGenericTemplateRequestTemplateSectionRequest {
  /**
   * Conditions Json
   * The condition tree. Omitted: an existing section keeps its condition. A new section needs one.
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Key
   * The ULID in the `data-section-key` attribute of the section wrapper
   */
  key: string;
  /**
   * Label
   * @minLength 1
   * @maxLength 255
   */
  label: string;
}

/**
 * UpdateGlobalFieldParams
 * Body of the global-field update route — an all-optional PATCH shape.
 *
 * ``key`` is intentionally absent: it is immutable after creation because every projected
 * entry's ``id`` and every stored value is keyed by it. Combined with ``extra='forbid'``,
 * sending it is a 400 rather than a silently ignored field.
 *
 * The two scope halves are validated together, so a request narrowing ``is_all_lobs`` to
 * false must send the ``lobs`` it narrows to in the same body.
 *
 * A body that moves the field to another (placement, anchor) bucket without a ``position``
 * places it last in that bucket: the position it held is only meaningful among its old peers.
 */
export interface UpdateGlobalFieldParams {
  /** @default null */
  anchor?: UpdateGlobalFieldParamsGlobalFieldAnchor | null;
  /**
   * Definition
   * @default null
   */
  definition?: Record<string, any> | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /** @default null */
  placement?: UpdateGlobalFieldParamsGlobalFieldPlacement | null;
  /**
   * Position
   * @default null
   */
  position?: number | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/**
 * UpdateGlobalPolicyCategoryParams
 * Body of the global-category update route — an all-optional PATCH shape.
 *
 * ``key`` is intentionally absent: it is immutable after creation, and a global field's limit
 * list references it. With ``extra='forbid'``, sending it is a 400 rather than a silently
 * ignored field.
 */
export interface UpdateGlobalPolicyCategoryParams {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
}

/** UpdateHookEndpointParams */
export interface UpdateHookEndpointParams {
  /**
   * Callback Url
   * @default null
   */
  callback_url?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Timeout Seconds
   * @default null
   */
  timeout_seconds?: number | null;
}

/**
 * UpdateIncomeProtectionDaSettingRequest
 * Request schema for updating an existing Income Protection DA setting.
 */
export interface UpdateIncomeProtectionDaSettingRequest {
  /**
   * Average Weekly Income
   * Average weekly income of the claimant
   * @default null
   */
  average_weekly_income?: number | string | null;
  /**
   * Benefit Period Num Of Days
   * Benefit period in days
   * @default null
   */
  benefit_period_num_of_days?: number | null;
  /**
   * Claimant Weekly Limit
   * Maximum weekly payment limit for the claimant
   * @default null
   */
  claimant_weekly_limit?: number | string | null;
  /**
   * Payee Contact Id
   * ID of the contact who will receive payments
   * @default null
   */
  payee_contact_id?: number | null;
  /**
   * Payment Frequency Num Of Days
   * Payment frequency in days (e.g., 7, 14, or custom)
   * @default null
   */
  payment_frequency_num_of_days?: number | null;
  /**
   * Start Date
   * Start date of the income protection
   * @default null
   */
  start_date?: string | null;
  /**
   * Waiting Period Num Of Days
   * Waiting period in days before payments start
   * @default null
   */
  waiting_period_num_of_days?: number | null;
  /**
   * Weekly Income Percentage
   * Percentage of weekly income to pay (0-100)
   * @default null
   */
  weekly_income_percentage?: number | string | null;
  /**
   * Weekly Payment Limit
   * Maximum weekly payment limit
   * @default null
   */
  weekly_payment_limit?: number | string | null;
}

/**
 * UpdateIncomeProtectionMedicalRecordRequest
 * Request schema for updating an existing income protection medical record (document_id cannot be changed).
 */
export interface UpdateIncomeProtectionMedicalRecordRequest {
  /**
   * Certificate End
   * Certificate end date
   * @default null
   */
  certificate_end?: string | null;
  /**
   * Certificate Start
   * Certificate start date
   * @default null
   */
  certificate_start?: string | null;
  /**
   * Diagnoses
   * Diagnoses text
   * @default null
   */
  diagnoses?: string | null;
  /**
   * Medical Practitioner Contact Id
   * ID of the medical practitioner contact
   * @default null
   */
  medical_practitioner_contact_id?: number | null;
  /**
   * Rtw Date
   * Return to work date
   * @default null
   */
  rtw_date?: string | null;
}

/** UpdateInvoiceRequest */
export interface UpdateInvoiceRequest {
  /**
   * Extra
   * @default null
   */
  extra?: Record<string, any> | null;
  /**
   * Invoice Date
   * @default null
   */
  invoice_date?: string | null;
  /**
   * Invoice Number
   * @default null
   */
  invoice_number?: string | null;
  /**
   * Line Items
   * @default null
   */
  line_items?: UpdateInvoiceRequestLineItemData[] | null;
  /**
   * Vendor
   * @default null
   */
  vendor?: string | null;
}

/** LineItemData */
export interface UpdateInvoiceRequestLineItemData {
  /** Amount */
  amount: number;
  /**
   * Amount Currency
   * @default null
   */
  amount_currency?: string | null;
  coverage_decision: UpdateInvoiceRequestCoverageDecisionOption;
  /**
   * Coverage Id
   * @default null
   */
  coverage_id?: number | null;
  /**
   * Covered Amount
   * @default null
   */
  covered_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Explanation
   * @default null
   */
  explanation?: string | null;
  /**
   * Exposure Id
   * @default null
   */
  exposure_id?: number | null;
  /**
   * Is Depreciation Overridden
   * @default null
   */
  is_depreciation_overridden?: boolean | null;
  /**
   * Item Date
   * @default null
   */
  item_date?: string | null;
  /** @default null */
  payable_type?: UpdateInvoiceRequestPayableType | null;
  /**
   * Third Party Amount
   * @default null
   */
  third_party_amount?: number | null;
}

/**
 * UpdateLevelParams
 * key is immutable — omitted. name and limits independently optional.
 */
export interface UpdateLevelParams {
  /** @default null */
  limits?: UpdateLevelParamsLimitSnapshot | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
}

/**
 * LimitSnapshot
 * Snapshot of all 6 limit fields. All fields required (no None).
 * Decimal matches request/approval amount precision (Numeric(19, 4)).
 */
export interface UpdateLevelParamsLimitSnapshot {
  /** Expenses Payments Limit */
  expenses_payments_limit: number | string;
  /** Expenses Reserves Limit */
  expenses_reserves_limit: number | string;
  /** Indemnity Payments Limit */
  indemnity_payments_limit: number | string;
  /** Indemnity Reserves Limit */
  indemnity_reserves_limit: number | string;
  /** Payments Limit */
  payments_limit: number | string;
  /** Reserves Limit */
  reserves_limit: number | string;
}

/** UpdateLoadBalancingParams */
export interface UpdateLoadBalancingParams {
  /**
   * Is Load Balancing Enabled
   * @default false
   */
  is_load_balancing_enabled?: boolean;
  /**
   * Is Out Of Office Days Excluded
   * @default false
   */
  is_out_of_office_days_excluded?: boolean;
  /**
   * Look Back Period Amount
   * @default null
   */
  look_back_period_amount?: number | null;
  /**
   * Look Back Period Type
   * @default null
   */
  look_back_period_type?: string | null;
}

/** UpdateMaxAssignmentsParams */
export interface UpdateMaxAssignmentsParams {
  /**
   * Is Daily Max Enabled
   * @default false
   */
  is_daily_max_enabled?: boolean;
  /**
   * Max Daily Claim Assignments
   * @default null
   */
  max_daily_claim_assignments?: number | null;
  /**
   * Max Daily Exposure Assignments
   * @default null
   */
  max_daily_exposure_assignments?: number | null;
}

/**
 * UpdateMetabaseConfigurationRequest
 * Request schema for updating Metabase configuration (PATCH /update).
 */
export interface UpdateMetabaseConfigurationRequest {
  /** Is Enabled */
  is_enabled: boolean;
}

/**
 * UpdateN8nConfigurationParams
 * Parameters for updating an existing n8n configuration.
 */
export interface UpdateN8NConfigurationParams {
  /**
   * Is Enabled
   * Whether the configuration is enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Timeout Seconds
   * Request timeout in seconds
   * @default null
   */
  timeout_seconds?: number | null;
}

/**
 * UpdateOneIncInboundTenantConfigParams
 * A tenant write.
 *
 * Every key is optional so an administrator editing only the base URL does not have to retype
 * secrets they cannot read back. An omitted, blank or ``*****`` value leaves the stored key
 * untouched (``SecretManager.update_encrypted_field_if_valid``); the *first* write for an
 * organization has to supply both **PortalOne** keys, since a tenant row with one credential can
 * neither send a message nor open the modal. The webhook signing key is exempt from that rule --
 * it is provisioned by One Inc Support on its own schedule and is not needed to send.
 */
export interface UpdateOneIncInboundTenantConfigParams {
  /**
   * Authentication Key
   * @default null
   */
  authentication_key?: string | null;
  /** Base Url */
  base_url: string;
  /**
   * Ui Authentication Key
   * @default null
   */
  ui_authentication_key?: string | null;
  /**
   * Webhook Signing Key
   * @default null
   */
  webhook_signing_key?: string | null;
}

/**
 * UpdateOverrideRuleParams
 * Full-replacement-of-provided-fields semantics: a field absent from the
 * request is untouched; when present, its value replaces the prior value
 * wholesale (conditions tree replaces the whole tree; overrides dict replaces
 * the whole dict).
 */
export interface UpdateOverrideRuleParams {
  /**
   * Clear Conditions Json
   * @default false
   */
  clear_conditions_json?: boolean;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * Is All Lobs
   * @default null
   */
  is_all_lobs?: boolean | null;
  /**
   * Is All Sub Orgs
   * @default null
   */
  is_all_sub_orgs?: boolean | null;
  /**
   * Lobs
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Overrides
   * @default null
   */
  overrides?: Record<
    string,
    UpdateOverrideRuleParamsLevelOverrideLimits
  > | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/**
 * LevelOverrideLimits
 * PATCH values for a single level inside a rule's action JSONB.
 * Null = keep level default.
 */
export interface UpdateOverrideRuleParamsLevelOverrideLimits {
  /**
   * Expenses Payments Limit
   * @default null
   */
  expenses_payments_limit?: number | string | null;
  /**
   * Expenses Reserves Limit
   * @default null
   */
  expenses_reserves_limit?: number | string | null;
  /**
   * Indemnity Payments Limit
   * @default null
   */
  indemnity_payments_limit?: number | string | null;
  /**
   * Indemnity Reserves Limit
   * @default null
   */
  indemnity_reserves_limit?: number | string | null;
  /**
   * Payments Limit
   * @default null
   */
  payments_limit?: number | string | null;
  /**
   * Reserves Limit
   * @default null
   */
  reserves_limit?: number | string | null;
}

/**
 * UpdatePolicyCategoryParams
 * Body of the policy-category update route — an all-optional PATCH shape.
 *
 * ``key`` is intentionally absent: it is immutable after creation, and the blob
 * references it. Combined with ``extra='forbid'``, sending it is a 400 rather than a
 * silently ignored field.
 */
export interface UpdatePolicyCategoryParams {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Display Name
   * @default null
   */
  display_name?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
}

/** UpdatePreDefinedNotificationJson */
export interface UpdatePreDefinedNotificationJson {
  /**
   * Category Id
   * @default null
   */
  category_id?: number | null;
  /**
   * Due Date Number
   * @default null
   */
  due_date_number?: number | null;
  /**
   * Due Date Timeframe
   * @default null
   */
  due_date_timeframe?: string | null;
  /**
   * Is All States
   * @default null
   */
  is_all_states?: boolean | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /**
   * Is Due Date Immediate
   * @default null
   */
  is_due_date_immediate?: boolean | null;
  /**
   * Notification Key
   * @default null
   */
  notification_key?: string | null;
  /**
   * Predefined Notification Conditions
   * @default null
   */
  predefined_notification_conditions?: Record<string, any> | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /**
   * States
   * @default null
   */
  states?: string[] | null;
}

/** UpdateRecoveryRequestsConfigParams */
export interface UpdateRecoveryRequestsConfigParams {
  /** Is Enabled */
  is_enabled: boolean;
  /**
   * Provider Config
   * @default null
   */
  provider_config?: Record<string, string | null> | null;
  /**
   * Provider Key
   * @default "manual"
   */
  provider_key?: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * UpdateReportTemplateRequest
 * Request schema for full template editing (name, file, sheets).
 */
export interface UpdateReportTemplateRequest {
  /**
   * Gcs Path
   * New file GCS path from upload step (omit to keep existing file)
   * @default null
   */
  gcs_path?: string | null;
  /**
   * Name
   * Template name
   * @default null
   */
  name?: string | null;
  /**
   * Sheets
   * Sheet configurations (sheets not included will be deleted)
   * @default null
   */
  sheets?: UpdateReportTemplateRequestUpdateSheetConfiguration[] | null;
}

/**
 * UpdateSheetConfiguration
 * Configuration for updating a single sheet within a template.
 */
export interface UpdateReportTemplateRequestUpdateSheetConfiguration {
  /**
   * Display Name
   * User-provided display name
   * @minLength 1
   * @maxLength 255
   */
  display_name: string;
  /**
   * Id
   * Sheet ID for existing sheets (omit for new sheets)
   * @default null
   */
  id?: number | null;
  /**
   * Metabase Question Id
   * ID of the Metabase question to map to this sheet
   */
  metabase_question_id: number;
  /**
   * Sheet Name
   * Sheet name from the Excel file
   */
  sheet_name: string;
}

/** UpdateReservesJsonResponseWithApiUid */
export interface UpdateReservesJsonResponseWithApiUid {
  /** Api Uid */
  api_uid?: string | null;
  /**
   * Approved Date
   * @default null
   */
  approved_date?: string | null;
  /**
   * Approving User Email
   * @default null
   */
  approving_user_email?: string | null;
  /**
   * Approving User Name
   * @default null
   */
  approving_user_name?: string | null;
  /**
   * Automatic Adjustment Upon Payment Id
   * @default null
   */
  automatic_adjustment_upon_payment_id?: string | null;
  /**
   * Change Amount
   * @default null
   */
  change_amount?: number | null;
  /** Claim Number */
  claim_number: string;
  /**
   * Coverage Display Name
   * @default null
   */
  coverage_display_name?: string | null;
  /**
   * Coverage Key
   * @default null
   */
  coverage_key?: string | null;
  /** Currency */
  currency: string;
  /**
   * Date Of Loss
   * @format date
   */
  date_of_loss: string;
  /**
   * Exposure Number
   * @default null
   */
  exposure_number?: string | null;
  /** Insured Contact Ref Id */
  insured_contact_ref_id: string;
  /** Payable Type */
  payable_type: string;
  /** Policy Number */
  policy_number: string;
  /** Request Date */
  request_date: string;
  /**
   * Requesting User Email
   * @default null
   */
  requesting_user_email?: string | null;
  /**
   * Requesting User Name
   * @default null
   */
  requesting_user_name?: string | null;
  /** Reserve Amount */
  reserve_amount: number;
  /** Reserve Change Approval Status */
  reserve_change_approval_status: string;
  /** Reserve Change Id */
  reserve_change_id: number;
  /** Reserve Change Reason */
  reserve_change_reason: string;
  /**
   * Sub Organization External Id
   * @default null
   */
  sub_organization_external_id?: string | null;
  /**
   * Sub Organization Name
   * @default null
   */
  sub_organization_name?: string | null;
  /**
   * Sub Reserves
   * @default null
   */
  sub_reserves?: Record<string, number> | null;
  /**
   * Time Of Loss
   * @default null
   */
  time_of_loss?: string | null;
}

/** UpdateSalvageRecoveryRequest */
export interface UpdateSalvageRecoveryRequest {
  /**
   * Anticipated Amount
   * Anticipated salvage recovery amount
   * @default null
   */
  anticipated_amount?: number | null;
  /**
   * Contacts
   * List of contacts to associate
   */
  contacts?: (
    | ({
        creation_mode: "";
      } & UpdateSalvageRecoveryRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & UpdateSalvageRecoveryRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & UpdateSalvageRecoveryRequestContactInNewParam)
  )[];
  /**
   * Note
   * Salvage recovery note
   * @default null
   */
  note?: string | null;
  /**
   * Salvage Parts
   * List of damaged vehicle parts (only for auto claims)
   * @default null
   */
  salvage_parts?: string[] | null;
  /**
   * Vendor Referral Number
   * Vendor referral number
   * @default null
   */
  vendor_referral_number?: string | null;
}

/** ContactEmailModel */
export interface UpdateSalvageRecoveryRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface UpdateSalvageRecoveryRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface UpdateSalvageRecoveryRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: UpdateSalvageRecoveryRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: UpdateSalvageRecoveryRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface UpdateSalvageRecoveryRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** UpdateSalvageRecoveryResponse */
export interface UpdateSalvageRecoveryResponse {
  /**
   * Api Uid
   * Recovery API UID
   */
  api_uid: string;
}

/** UpdateScheduledReportExportRequest */
export interface UpdateScheduledReportExportRequest {
  /**
   * Day Of Month
   * Day of month (1-28) for monthly recurrence
   * @default null
   */
  day_of_month?: number | null;
  /**
   * Display Name
   * Name for this scheduled export
   * @default null
   */
  display_name?: string | null;
  /**
   * End Date
   * Optional end date for the schedule
   * @default null
   */
  end_date?: string | null;
  /**
   * Export Days
   * Days of the week to run
   * @default null
   */
  export_days?: ("0" | "1" | "2" | "3" | "4" | "5" | "6")[] | null;
  /**
   * Export Hour
   * Hour to run (HH:00 format)
   * @default null
   */
  export_hour?: string | null;
  /**
   * Is Active
   * Whether the schedule is active
   * @default null
   */
  is_active?: boolean | null;
  /**
   * Parameters
   * Filter parameter values keyed by parameter ID
   * @default null
   */
  parameters?: Record<string, any> | null;
  /**
   * Recurrence Type
   * Schedule recurrence: daily or monthly
   * @default null
   */
  recurrence_type?: "daily" | "monthly" | null;
  /**
   * Report Template Id
   * ID of the report template to schedule
   * @default null
   */
  report_template_id?: number | null;
  /**
   * Target-specific configuration
   * @default null
   */
  target_configurations?: UpdateScheduledReportExportRequestTargetConfigurations | null;
  /**
   * Target Type
   * Delivery target type
   * @default null
   */
  target_type?: "email" | "sftp" | "s3_bucket" | "gcs_bucket" | null;
  /**
   * User Id
   * User ID for email delivery target
   * @default null
   */
  user_id?: string | null;
}

/** GcsConfig */
export interface UpdateScheduledReportExportRequestGcsConfig {
  /**
   * Bucket Name
   * GCS bucket name
   * @minLength 1
   */
  bucket_name: string;
  /**
   * Path
   * Path within the bucket
   * @minLength 1
   */
  path: string;
  /**
   * Secret Json
   * GCS service account JSON or masked placeholder
   * @minLength 1
   */
  secret_json: string;
}

/** S3Config */
export interface UpdateScheduledReportExportRequestS3Config {
  /**
   * Access Key Id
   * AWS access key ID
   * @minLength 1
   */
  access_key_id: string;
  /**
   * Access Key Secret
   * AWS secret access key
   * @minLength 1
   */
  access_key_secret: string;
  /**
   * Bucket Name
   * S3 bucket name
   * @minLength 1
   */
  bucket_name: string;
  /**
   * Path
   * Path within the bucket
   * @minLength 1
   */
  path: string;
}

/** SftpConfig */
export interface UpdateScheduledReportExportRequestSftpConfig {
  /**
   * Host
   * SFTP host
   * @minLength 1
   */
  host: string;
  /**
   * Password
   * SFTP password
   * @minLength 1
   */
  password: string;
  /**
   * Path
   * Remote path
   * @minLength 1
   */
  path: string;
  /**
   * Port
   * SFTP port
   * @minLength 1
   */
  port: string;
  /**
   * User
   * SFTP username
   * @minLength 1
   */
  user: string;
}

/** TargetConfigurations */
export interface UpdateScheduledReportExportRequestTargetConfigurations {
  /** @default null */
  gcs_bucket?: UpdateScheduledReportExportRequestGcsConfig | null;
  /** @default null */
  s3_bucket?: UpdateScheduledReportExportRequestS3Config | null;
  /** @default null */
  sftp?: UpdateScheduledReportExportRequestSftpConfig | null;
}

/** UpdateSubrogationRecoveryRequest */
export interface UpdateSubrogationRecoveryRequest {
  /**
   * Adverse Carrier Contact Ref Id
   * Reference ID of the adverse carrier contact
   * @default null
   */
  adverse_carrier_contact_ref_id?: string | null;
  /**
   * Anticipated Amount
   * Anticipated recovery amount
   * @default null
   */
  anticipated_amount?: number | null;
  /**
   * Contacts
   * List of contacts to associate
   */
  contacts?: (
    | ({
        creation_mode: "";
      } & UpdateSubrogationRecoveryRequestContactInNewParam)
    | ({
        creation_mode: "existing";
      } & UpdateSubrogationRecoveryRequestContactInExistingParam)
    | ({
        creation_mode: "new";
      } & UpdateSubrogationRecoveryRequestContactInNewParam)
  )[];
  /**
   * Note
   * Recovery note
   * @default null
   */
  note?: string | null;
}

/** ContactEmailModel */
export interface UpdateSubrogationRecoveryRequestContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface UpdateSubrogationRecoveryRequestContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface UpdateSubrogationRecoveryRequestContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: UpdateSubrogationRecoveryRequestContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: UpdateSubrogationRecoveryRequestContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface UpdateSubrogationRecoveryRequestContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** UpdateSubrogationRecoveryResponse */
export interface UpdateSubrogationRecoveryResponse {
  /**
   * Api Uid
   * Recovery API UID
   */
  api_uid: string;
}

/**
 * UpdateTemplateIsActiveRequest
 * Lightweight request for toggling template active status only.
 */
export interface UpdateTemplateIsActiveRequest {
  /**
   * Is Active
   * Enable or disable the template
   */
  is_active: boolean;
}

/** UploadDocumentPayload */
export interface UploadDocumentPayload {
  /**
   * Document Date
   * @format date
   */
  document_date: string;
  /**
   * Document Date Received
   * @format date
   */
  document_date_received: string;
  /** Document Name */
  document_name: string;
  /** Exposure Ids */
  exposure_ids: number[];
  /** File Name */
  file_name: string;
  /** File Type */
  file_type: string;
  /** Storage Filename */
  storage_filename: string;
  /** Summary */
  summary: string;
  /** Type */
  type: string;
}

/** UploadDocumentRequestParams */
export interface UploadDocumentRequestParams {
  /** Stored File Ids */
  stored_file_ids: number[];
}

/** UploadDocumentTemplateForm */
export interface UploadDocumentTemplateForm {
  /** Comment */
  comment: string;
  /** Countries */
  countries: string;
  /** Coverages */
  coverages: string;
  /** Display Name */
  display_name: string;
  /** Document Type */
  document_type: string;
  /**
   * File
   * @format binary
   */
  file: File;
  /** Filename */
  filename: string;
  /** Is All Countries */
  is_all_countries: string;
  /** Is All Coverages */
  is_all_coverages: string;
  /** Is All Lobs */
  is_all_lobs: string;
  /** Is All Sub Orgs */
  is_all_sub_orgs: string;
  /** Lobs */
  lobs: string;
  /** States */
  states: string;
  /** Sub Organization Ids */
  sub_organization_ids: string;
}

/**
 * UploadSopFileRequest
 * Request schema for registering uploaded SOP file.
 */
export interface UploadSopFileRequest {
  /**
   * File Name
   * Original filename
   */
  file_name: string;
  /**
   * File Size
   * File size in bytes
   */
  file_size: number;
  /**
   * File Type
   * MIME type of the file
   */
  file_type: string;
  /**
   * Last Modified
   * File last modified timestamp (ISO format)
   */
  last_modified: string;
  /**
   * Storage Filename
   * Storage filename in GCS
   */
  storage_filename: string;
}

/**
 * UploadSopFileResponse
 * Response schema for uploaded SOP file registration.
 */
export interface UploadSopFileResponse {
  /**
   * Storage Filename
   * Storage filename in GCS
   */
  storage_filename: string;
  /**
   * Stored File Id
   * ID of the registered stored file
   */
  stored_file_id: number;
}

/** UploadUrlParams */
export interface UploadUrlParams {
  /** File Extension */
  file_extension: string;
  /** File Size */
  file_size: number;
  /** Mime Type */
  mime_type: string;
}

/** UploadUrlResponse */
export interface UploadUrlResponse {
  /** Storage File Uuid */
  storage_file_uuid: string;
  /** Upload Url */
  upload_url: string;
}

/**
 * UpsertClaimActionConfigRequest
 * Body for the per-action upsert endpoint (PUT).
 */
export interface UpsertClaimActionConfigRequest {
  /**
   * Confidence Threshold
   * @default null
   */
  confidence_threshold?: number | null;
  /** Enabled */
  enabled: boolean;
  /** Execution Mode */
  execution_mode: "always_human" | "always_ai" | "above_threshold";
  /**
   * Instructions
   * @default null
   */
  instructions?: string | null;
  /** Lob */
  lob: string;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
}

/**
 * UserBasicListResponseModel
 * Pydantic model for list of basic user information
 */
export interface UserBasicListResponseModel {
  /** Users */
  users: UserBasicListResponseModelUserBasicModel[];
}

/**
 * UserBasicModel
 * Pydantic model for basic user information
 */
export interface UserBasicListResponseModelUserBasicModel {
  /** Email */
  email: string | null;
  /** Id */
  id: string;
  /** Is Active */
  is_active: boolean | null;
  /** Is Removed */
  is_removed: boolean;
  /** Role Type */
  role_type: string | null;
  /**
   * Sub Organization Ids
   * @default []
   */
  sub_organization_ids?: number[];
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /** Username */
  username: string | null;
}

/** UserPhoneProfileAssignmentRequest */
export interface UserPhoneProfileAssignmentRequest {
  /**
   * Phone Profile Id
   * @default null
   */
  phone_profile_id?: number | null;
}

/** ValidatePreDefinedRequiredFieldsRequest */
export interface ValidatePreDefinedRequiredFieldsRequest {
  /**
   * Lob
   * @default null
   */
  lob?: string | null;
  /** Policy Data */
  policy_data?: Record<string, any>;
  /**
   * Sub Org Id
   * @default null
   */
  sub_org_id?: number | null;
}

/** ValidatePreDefinedRequiredFieldsResponse */
export interface ValidatePreDefinedRequiredFieldsResponse {
  /** Missing */
  missing?: Record<string, string>[];
}

/** VendorAddDocument */
export interface VendorAddDocument {
  /** Assignment Token */
  assignment_token: string;
  document: VendorAddDocumentDocumentParam;
}

/** DocumentParam */
export interface VendorAddDocumentDocumentParam {
  /**
   * Additional Fields
   * Values for the document type's configured additional fields, keyed by field id. Validated against the document type's configured_fields definition; mandatory fields must be present and field-type validation applies.
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Document Date
   * @default null
   */
  document_date?: string | null;
  /**
   * Document Date Received
   * @default null
   */
  document_date_received?: string | null;
  /**
   * Document Extension
   * @default null
   */
  document_extension?: string | null;
  /** Document Name */
  document_name: string;
  /**
   * Document Type
   * @default null
   */
  document_type?: string | null;
  /**
   * Document Url
   * @default null
   */
  document_url?: string | null;
  /**
   * Exposure Numbers
   * List of exposure numbers associated with the document
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Exposures
   * Deprecated: Use exposure_numbers instead
   * @deprecated
   * @default null
   */
  exposures?: string[] | null;
  /** External Id */
  external_id: string;
  /**
   * Storage File Uuid
   * @default null
   */
  storage_file_uuid?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
}

/** VendorAddInvolvedPartyParams */
export interface VendorAddInvolvedPartyParams {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Contacts
   * @default []
   */
  contacts?:
    | (
        | ({
            creation_mode: "";
          } & VendorAddInvolvedPartyParamsContactInNewParam)
        | ({
            creation_mode: "existing";
          } & VendorAddInvolvedPartyParamsContactInExistingParam)
        | ({
            creation_mode: "new";
          } & VendorAddInvolvedPartyParamsContactInNewParam)
      )[]
    | null;
  /** Involved Party */
  involved_party:
    | VendorAddInvolvedPartyParamsAddGenericInvolvedPersonParams
    | VendorAddInvolvedPartyParamsAddInvolvedGenericPropertyParams;
}

/** AddGenericInvolvedPersonParams */
export interface VendorAddInvolvedPartyParamsAddGenericInvolvedPersonParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: VendorAddInvolvedPartyParamsBodilyInjuryLossParams | null;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /** Contact Ref Id */
  contact_ref_id: string;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: VendorAddInvolvedPartyParamsPecuniaryLossDetailsParams | null;
  /** @default null */
  related_property_loss?: VendorAddInvolvedPartyParamsPropertyLossWithItemsParams | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /** Type */
  type: string;
}

/** AddInvolvedGenericPropertyParams */
export interface VendorAddInvolvedPartyParamsAddInvolvedGenericPropertyParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /** Is First Party */
  is_first_party: boolean;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: VendorAddInvolvedPartyParamsLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /** Owner Contact Ref Id */
  owner_contact_ref_id: string;
  /** @default null */
  pecuniary_loss?: VendorAddInvolvedPartyParamsPecuniaryLossDetailsParams | null;
  /** @default null */
  property_damage?: VendorAddInvolvedPartyParamsPropertyDamageParams | null;
  /** Property Description */
  property_description: string;
  /** @default null */
  related_property_loss?: VendorAddInvolvedPartyParamsPropertyLossWithItemsParams | null;
  /** Type */
  type: string;
}

/** BodilyInjuryLossParams */
export interface VendorAddInvolvedPartyParamsBodilyInjuryLossParams {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Bodily Injuries
   * @default null
   */
  bodily_injuries?: VendorAddInvolvedPartyParamsBodilyInjuryModel[] | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Icd Codes
   * @default null
   */
  icd_codes?: VendorAddInvolvedPartyParamsICDCodeModel[] | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface VendorAddInvolvedPartyParamsBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/** ContactEmailModel */
export interface VendorAddInvolvedPartyParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface VendorAddInvolvedPartyParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface VendorAddInvolvedPartyParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: VendorAddInvolvedPartyParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: VendorAddInvolvedPartyParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface VendorAddInvolvedPartyParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ICDCodeModel */
export interface VendorAddInvolvedPartyParamsICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** LocationModel */
export interface VendorAddInvolvedPartyParamsLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PecuniaryLossDetailsParams */
export interface VendorAddInvolvedPartyParamsPecuniaryLossDetailsParams {
  /**
   * Losses
   * @default null
   */
  losses?: VendorAddInvolvedPartyParamsPecuniaryLossItemParams[] | null;
}

/** PecuniaryLossItemParams */
export interface VendorAddInvolvedPartyParamsPecuniaryLossItemParams {
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /**
   * Claimed Loss
   * @default null
   */
  claimed_loss?: string | null;
  /** Display Name */
  display_name: string;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** PropertyDamageParams */
export interface VendorAddInvolvedPartyParamsPropertyDamageParams {
  /**
   * Is Property Stolen
   * @default null
   */
  is_property_stolen?: boolean | null;
  /** @default null */
  location?: VendorAddInvolvedPartyParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Property Damages
   * @default null
   */
  property_damages?: string[] | null;
  /**
   * Property Damages Description
   * @default null
   */
  property_damages_description?: string | null;
}

/** PropertyItemIncomingModel */
export interface VendorAddInvolvedPartyParamsPropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyLossWithItemsParams */
export interface VendorAddInvolvedPartyParamsPropertyLossWithItemsParams {
  /**
   * Damages
   * @default null
   */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /**
   * Items
   * @default null
   */
  items?: VendorAddInvolvedPartyParamsPropertyItemIncomingModel[] | null;
  /** @default null */
  location?: VendorAddInvolvedPartyParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** VendorClaimsNotificationsQueryParams */
export interface VendorClaimsNotificationsQueryParams {
  /**
   * Adjuster Email
   * Email of the adjuster to filter by. Accepts either the user login email or the claims email address
   * @default null
   */
  adjuster_email?: string | null;
  /** Assignment Token */
  assignment_token: string;
  /**
   * End Created Date
   * Filter by creation date - end of range
   * @default null
   */
  end_created_date?: string | null;
  /**
   * End Due Date
   * Filter by due date - end of range
   * @default null
   */
  end_due_date?: string | null;
  /**
   * Include Dismissed
   * 'only_dismissed' - only dismissed, 'not_dismissed' - only not dismissed, 'both' - all
   * @default "not_dismissed"
   */
  include_dismissed?: "only_dismissed" | "not_dismissed" | "both" | null;
  /**
   * Page Number
   * Page number for pagination
   * @default 1
   */
  page_number?: number | null;
  /**
   * Per Page
   * Number of results per page
   * @default 10
   */
  per_page?: number | null;
  /**
   * Priorities
   * List for filter by priority - high, medium, low
   * @default null
   */
  priorities?: ("high" | "medium" | "low")[] | null;
  /**
   * Sort By Column
   * field to sort results by
   * @default null
   */
  sort_by_column?:
    | "type"
    | "effective_user"
    | "due_date"
    | "due_datetime"
    | "creation_datetime"
    | "claim_number"
    | "title"
    | "priority"
    | "dismissing_user"
    | "dismissed_datetime"
    | null;
  /**
   * Sort By Order
   * order to sort results by - asc or desc
   * @default "asc"
   */
  sort_by_order?: "asc" | "desc" | null;
  /**
   * Start Created Date
   * Filter by creation date - start of range
   * @default null
   */
  start_created_date?: string | null;
  /**
   * Start Due Date
   * Filter by due date - start of range
   * @default null
   */
  start_due_date?: string | null;
}

/** VendorCloseClaimJsonParams */
export interface VendorCloseClaimJsonParams {
  /** Assignment Token */
  assignment_token: string;
  /** Close Reason Key */
  close_reason_key: string;
  /**
   * Dismiss All Notifications
   * @default null
   */
  dismiss_all_notifications?: boolean | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** VendorCloseExposureJsonParams */
export interface VendorCloseExposureJsonParams {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Close Reason Key
   * Why the exposure closed, as the organization's closing reasons name it.
   */
  close_reason_key: string;
  /**
   * Dismiss All Notifications
   * Whether the close dismissed the exposure's open notifications.
   * @default null
   */
  dismiss_all_notifications?: boolean | null;
  /**
   * Note
   * Free text about the close.
   * @default null
   */
  note?: string | null;
}

/** VendorCommunicationResponse */
export interface VendorCommunicationResponse {
  /** Api Uuid */
  api_uuid: string;
  /**
   * Categories
   * The communication's categories (tags). Empty when none are applied. A category is identified by its `key`, which is stable across environments.
   */
  categories?: VendorCommunicationResponseCommunicationCategoryModel[];
  /** Channel */
  channel: string;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Contacts
   * Array of contact details with ref_id mappings
   */
  contacts?: VendorCommunicationResponseContactModel[];
  /**
   * Datetime
   * @format date-time
   */
  datetime: string;
  /** Direction */
  direction: string;
  /** @default null */
  email_specific?: VendorCommunicationResponseVendorEmailSpecificModel | null;
  /**
   * Exposure Ids
   * @default null
   */
  exposure_ids?: number[] | null;
  /**
   * Exposure Numbers
   * Exposure numbers in the format accepted by the add-document external API (e.g. 'ABC-12345-01'). '0' denotes a general communication not bound to an exposure. Ordered consistently with exposure_ids.
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Is Automatic
   * @default null
   */
  is_automatic?: boolean | null;
  /**
   * Is Handled
   * Whether an incoming communication has been actioned: `false` while it is still awaiting action, `true` once it has been handled. Always `null` on outgoing communications, which carry no handled status. Some incoming communications are already `true` when they arrive — an answered phone call, for example — so `true` does not necessarily mean someone acted on it.
   * @default null
   */
  is_handled?: boolean | null;
  /** @default null */
  phone_call_specific?: VendorCommunicationResponsePhoneCallSpecificModel | null;
  /** @default null */
  physical_mail_specific?: VendorCommunicationResponsePhysicalMailSpecificModel | null;
  /** @default null */
  sms_specific?: VendorCommunicationResponseSmsSpecificModel | null;
  /**
   * Source
   * @default null
   */
  source?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /** @default null */
  user?: VendorCommunicationResponseUserExternalAPIBaseModel | null;
  /** @default null */
  video_call_specific?: VendorCommunicationResponseVideoCallSpecificModel | null;
}

/**
 * CommunicationAttachmentResponse
 * Communication attachment response model.
 */
export interface VendorCommunicationResponseCommunicationAttachmentResponse {
  /**
   * File Name
   * @default null
   */
  file_name?: string | null;
  /**
   * Url
   * @default null
   */
  url?: string | null;
}

/**
 * CommunicationCategoryModel
 * A communication category (tag) as the external API exposes it.
 *
 * Deliberately a local model rather than the categories module's ``CategoryInfo``: that schema is
 * the service *interface* boundary, so a field added to it for an internal consumer would join
 * this public response — and every ``incoming_email_received`` webhook — with no change in this
 * module and nothing in CI to catch it.
 *
 * The field set is the minimum defensible one, because a public API field is a one-way door:
 * adding one later is cheap, removing one is breaking. Deliberately **not** exposed:
 *
 * - ``id`` — environment-local. The config repository identifies a category by ``key`` and exports
 *   it without an id, so the same category has a different id in every environment. Publishing it
 *   would invite integrations to key on it and break the moment they cross environments, which is
 *   worse than not shipping it at all.
 * - ``type`` — constant ``communication_category`` on this surface, so it carries no information.
 * - ``description`` — internal configuration copy; the internal ``category_model`` does not
 *   expose it either.
 *
 * Optionality mirrors the source columns, which are all nullable
 * (``server/modules/categories/internal/models/category.py``): one NULL ``color`` would otherwise
 * 500 a whole page rather than degrade a single record.
 */
export interface VendorCommunicationResponseCommunicationCategoryModel {
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /**
   * Key
   * @default null
   */
  key?: string | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
}

/** ContactEmailModel */
export interface VendorCommunicationResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface VendorCommunicationResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: VendorCommunicationResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: VendorCommunicationResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface VendorCommunicationResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** EmailAddressModel */
export interface VendorCommunicationResponseEmailAddressModel {
  /** Email */
  email: string;
  /**
   * Name
   * @default null
   */
  name?: string | null;
}

/** LocationModel */
export interface VendorCommunicationResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/**
 * PhoneCallSpecificModel
 * Phone call-specific fields.
 */
export interface VendorCommunicationResponsePhoneCallSpecificModel {
  /**
   * Call Duration Seconds
   * @default null
   */
  call_duration_seconds?: number | null;
  /**
   * Forwarded Phone Number
   * @default null
   */
  forwarded_phone_number?: string | null;
  /**
   * Is No Answer
   * @default null
   */
  is_no_answer?: boolean | null;
  /**
   * Is Phone Call Recorded
   * @default null
   */
  is_phone_call_recorded?: boolean | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Recording Url
   * @default null
   */
  recording_url?: string | null;
  /**
   * Voicemail Url
   * @default null
   */
  voicemail_url?: string | null;
}

/**
 * PhysicalMailSpecificModel
 * Physical mail-specific fields.
 */
export interface VendorCommunicationResponsePhysicalMailSpecificModel {
  /** @default null */
  address?: VendorCommunicationResponseLocationModel | null;
  /**
   * Attachments
   * @default null
   */
  attachments?:
    | VendorCommunicationResponseCommunicationAttachmentResponse[]
    | null;
  /**
   * Physical Mail Type
   * @default null
   */
  physical_mail_type?: string | null;
  /**
   * Recipient Name
   * @default null
   */
  recipient_name?: string | null;
}

/**
 * SmsSpecificModel
 * SMS-specific fields.
 */
export interface VendorCommunicationResponseSmsSpecificModel {
  /**
   * Message
   * @default null
   */
  message?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
}

/** UserExternalAPIBaseModel */
export interface VendorCommunicationResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/**
 * VendorEmailSpecificModel
 * The carrier email fields plus the sender and the visible recipients. BCC recipients are never listed.
 */
export interface VendorCommunicationResponseVendorEmailSpecificModel {
  /**
   * Attachments
   * @default null
   */
  attachments?:
    | VendorCommunicationResponseCommunicationAttachmentResponse[]
    | null;
  /**
   * Body
   * @default null
   */
  body?: string | null;
  /** Cc Addresses */
  cc_addresses?: VendorCommunicationResponseEmailAddressModel[];
  /**
   * Delivery Status
   * @default null
   */
  delivery_status?: string | null;
  /** @default null */
  from_address?: VendorCommunicationResponseEmailAddressModel | null;
  /**
   * Recipient Type
   * @default null
   */
  recipient_type?: string | null;
  /**
   * Subject
   * @default null
   */
  subject?: string | null;
  /** To Addresses */
  to_addresses?: VendorCommunicationResponseEmailAddressModel[];
}

/**
 * VideoCallSpecificModel
 * Video call-specific fields.
 */
export interface VendorCommunicationResponseVideoCallSpecificModel {
  /**
   * Joined Participants
   * @default null
   */
  joined_participants?: string[] | null;
  /**
   * Meeting End Datetime
   * @default null
   */
  meeting_end_datetime?: string | null;
  /**
   * Meeting Start Datetime
   * @default null
   */
  meeting_start_datetime?: string | null;
  /**
   * Provider
   * @default null
   */
  provider?: string | null;
  /**
   * Recording Status
   * @default null
   */
  recording_status?: string | null;
  /**
   * Recording Url
   * @default null
   */
  recording_url?: string | null;
  /**
   * Transcript
   * @default null
   */
  transcript?: string | null;
}

/**
 * VendorCommunicationsFilterRequest
 * Query of the service provider Get Communications list: the claim's emails, newest first by default.
 */
export interface VendorCommunicationsFilterRequest {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Cursor
   * Encoded cursor token for pagination. If null, starts from the beginning.
   * @default null
   */
  cursor?: string | null;
  /**
   * Direction
   * Filter by email direction
   * @default null
   */
  direction?: "Incoming" | "Outgoing" | null;
  /**
   * End Datetime
   * Emails sent or received until this datetime (ISO format)
   * @default null
   */
  end_datetime?: string | null;
  /**
   * Limit
   * Number of records per page. Defaults to 10, maximum 1000.
   * @default 10
   */
  limit?: number | null;
  /**
   * Order By Direction
   * Sort direction: "asc" for ascending, "desc" for descending
   * @default null
   */
  order_by_direction?: "asc" | "desc" | null;
  /**
   * Order By Field
   * Field name to sort by (e.g., "creation_date", "claim_number")
   * @default null
   */
  order_by_field?: string | null;
  /**
   * Start Datetime
   * Emails sent or received from this datetime (ISO format)
   * @default null
   */
  start_datetime?: string | null;
}

/** VendorCommunicationsResponse */
export interface VendorCommunicationsResponse {
  /** Pagination metadata */
  metadata: VendorCommunicationsResponsePaginationMetadata;
  /**
   * Next Cursor
   * Encoded cursor token for the next page. Null if this is the last page.
   * @default null
   */
  next_cursor?: string | null;
  /** Records */
  records: VendorCommunicationsResponseVendorCommunicationResponse[];
}

/**
 * CommunicationAttachmentResponse
 * Communication attachment response model.
 */
export interface VendorCommunicationsResponseCommunicationAttachmentResponse {
  /**
   * File Name
   * @default null
   */
  file_name?: string | null;
  /**
   * Url
   * @default null
   */
  url?: string | null;
}

/**
 * CommunicationCategoryModel
 * A communication category (tag) as the external API exposes it.
 *
 * Deliberately a local model rather than the categories module's ``CategoryInfo``: that schema is
 * the service *interface* boundary, so a field added to it for an internal consumer would join
 * this public response — and every ``incoming_email_received`` webhook — with no change in this
 * module and nothing in CI to catch it.
 *
 * The field set is the minimum defensible one, because a public API field is a one-way door:
 * adding one later is cheap, removing one is breaking. Deliberately **not** exposed:
 *
 * - ``id`` — environment-local. The config repository identifies a category by ``key`` and exports
 *   it without an id, so the same category has a different id in every environment. Publishing it
 *   would invite integrations to key on it and break the moment they cross environments, which is
 *   worse than not shipping it at all.
 * - ``type`` — constant ``communication_category`` on this surface, so it carries no information.
 * - ``description`` — internal configuration copy; the internal ``category_model`` does not
 *   expose it either.
 *
 * Optionality mirrors the source columns, which are all nullable
 * (``server/modules/categories/internal/models/category.py``): one NULL ``color`` would otherwise
 * 500 a whole page rather than degrade a single record.
 */
export interface VendorCommunicationsResponseCommunicationCategoryModel {
  /**
   * Color
   * @default null
   */
  color?: string | null;
  /**
   * Is Disabled
   * @default null
   */
  is_disabled?: boolean | null;
  /**
   * Key
   * @default null
   */
  key?: string | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
}

/** ContactEmailModel */
export interface VendorCommunicationsResponseContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactModel */
export interface VendorCommunicationsResponseContactModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /** Api Uid */
  api_uid: string;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * Au Employment Basis
   * Employment basis declared on the TFN declaration (full_time, part_time, casual, superannuation_annuity, labour_hire). Present only for AU-region organizations.
   * @default null
   */
  au_employment_basis?: string | null;
  /**
   * Au Has Help Debt
   * Whether the contact has a HELP/HECS study-loan debt. Present only for AU-region organizations.
   * @default null
   */
  au_has_help_debt?: boolean | null;
  /**
   * Au Has Tax Free Threshold
   * Whether the contact claims the tax-free threshold. Present only for AU-region organizations.
   * @default null
   */
  au_has_tax_free_threshold?: boolean | null;
  /**
   * Au Nz Business Number
   * Australian Business Number (ABN) or New Zealand Business Number (NZBN). AU/NZ organizations only.
   * @default null
   */
  au_nz_business_number?: string | null;
  /**
   * Au Nz Company Number
   * Australian Company Number (ACN) or New Zealand company number. AU/NZ organizations only.
   * @default null
   */
  au_nz_company_number?: string | null;
  /**
   * Au Residency Status
   * Residency status for Australian tax purposes (australian_resident, foreign_resident, working_holiday_maker). Present only for AU-region organizations.
   * @default null
   */
  au_residency_status?: string | null;
  /**
   * Au Tfn
   * Australian Tax File Number (9 digits). Present only for AU-region organizations (TFN is AU-specific); null when the contact has not supplied one. Distinct from `tin`, which is the US W-9 taxpayer identification number.
   * @default null
   */
  au_tfn?: string | null;
  /**
   * Au Tfn Exemption
   * Reason the contact is exempt from supplying a TFN (applied_for_tfn, under_18_low_income, receiving_pension_benefit). Present only for AU-region organizations; null when no exemption was claimed. Mutually exclusive with `au_tfn`.
   * @default null
   */
  au_tfn_exemption?: string | null;
  /**
   * Business Legal Name
   * Registered legal name of the business, when the contact is a company.
   * @default null
   */
  business_legal_name?: string | null;
  /**
   * Business Trading Name
   * Trading (doing-business-as) name of the business, when the contact is a company.
   * @default null
   */
  business_trading_name?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Deactivated At
   * @default null
   */
  deactivated_at?: string | null;
  /**
   * Deactivation Reason
   * @default null
   */
  deactivation_reason?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: VendorCommunicationsResponseContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean | null;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Is Vat Registered
   * Whether the contact is registered for VAT. Distinct from `vat_number`.
   * @default null
   */
  is_vat_registered?: boolean | null;
  /**
   * Language
   * The contact's preferred correspondence language, as a lowercase ISO 639-1 code.
   * @default null
   */
  language?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: VendorCommunicationsResponseContactPhoneModel[] | null;
  /** Ref Id */
  ref_id: string;
  /**
   * Reference Contact Id
   * @default null
   */
  reference_contact_id?: number | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * Role Other Desc
   * Free-text description of the contact's role, supplied when `role` is 'other'.
   * @default null
   */
  role_other_desc?: string | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Title
   * Personal title (Mr, Ms, Dr, …).
   * @default null
   */
  title?: string | null;
  /**
   * Trusted Payee Status
   * @default null
   */
  trusted_payee_status?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface VendorCommunicationsResponseContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** EmailAddressModel */
export interface VendorCommunicationsResponseEmailAddressModel {
  /** Email */
  email: string;
  /**
   * Name
   * @default null
   */
  name?: string | null;
}

/** LocationModel */
export interface VendorCommunicationsResponseLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/**
 * PaginationMetadata
 * Pagination metadata for cursor-based pagination responses.
 *
 * Provides essential information about the current page state
 * aligned with existing API pagination patterns.
 */
export interface VendorCommunicationsResponsePaginationMetadata {
  /**
   * Has Next
   * Indicates if there are more pages available
   */
  has_next: boolean;
  /**
   * Last Record Id
   * ID of the last record on this page, useful for debugging
   * @default null
   */
  last_record_id?: number | string | null;
  /**
   * Limit
   * Maximum number of records per response, defaults to 10
   * @min 1
   * @max 1000
   * @default 10
   */
  limit?: number;
  /**
   * Total Count
   * Total number of records matching the filters (may be expensive to compute)
   * @default null
   */
  total_count?: number | null;
}

/**
 * PhoneCallSpecificModel
 * Phone call-specific fields.
 */
export interface VendorCommunicationsResponsePhoneCallSpecificModel {
  /**
   * Call Duration Seconds
   * @default null
   */
  call_duration_seconds?: number | null;
  /**
   * Forwarded Phone Number
   * @default null
   */
  forwarded_phone_number?: string | null;
  /**
   * Is No Answer
   * @default null
   */
  is_no_answer?: boolean | null;
  /**
   * Is Phone Call Recorded
   * @default null
   */
  is_phone_call_recorded?: boolean | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Recording Url
   * @default null
   */
  recording_url?: string | null;
  /**
   * Voicemail Url
   * @default null
   */
  voicemail_url?: string | null;
}

/**
 * PhysicalMailSpecificModel
 * Physical mail-specific fields.
 */
export interface VendorCommunicationsResponsePhysicalMailSpecificModel {
  /** @default null */
  address?: VendorCommunicationsResponseLocationModel | null;
  /**
   * Attachments
   * @default null
   */
  attachments?:
    | VendorCommunicationsResponseCommunicationAttachmentResponse[]
    | null;
  /**
   * Physical Mail Type
   * @default null
   */
  physical_mail_type?: string | null;
  /**
   * Recipient Name
   * @default null
   */
  recipient_name?: string | null;
}

/**
 * SmsSpecificModel
 * SMS-specific fields.
 */
export interface VendorCommunicationsResponseSmsSpecificModel {
  /**
   * Message
   * @default null
   */
  message?: string | null;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
}

/** UserExternalAPIBaseModel */
export interface VendorCommunicationsResponseUserExternalAPIBaseModel {
  /**
   * Email Address
   * @default null
   */
  email_address?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /** Name */
  name: string;
  /**
   * Phone Number
   * @default null
   */
  phone_number?: string | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** VendorCommunicationResponse */
export interface VendorCommunicationsResponseVendorCommunicationResponse {
  /** Api Uuid */
  api_uuid: string;
  /**
   * Categories
   * The communication's categories (tags). Empty when none are applied. A category is identified by its `key`, which is stable across environments.
   */
  categories?: VendorCommunicationsResponseCommunicationCategoryModel[];
  /** Channel */
  channel: string;
  /**
   * Claim Number
   * @default null
   */
  claim_number?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Contacts
   * Array of contact details with ref_id mappings
   */
  contacts?: VendorCommunicationsResponseContactModel[];
  /**
   * Datetime
   * @format date-time
   */
  datetime: string;
  /** Direction */
  direction: string;
  /** @default null */
  email_specific?: VendorCommunicationsResponseVendorEmailSpecificModel | null;
  /**
   * Exposure Ids
   * @default null
   */
  exposure_ids?: number[] | null;
  /**
   * Exposure Numbers
   * Exposure numbers in the format accepted by the add-document external API (e.g. 'ABC-12345-01'). '0' denotes a general communication not bound to an exposure. Ordered consistently with exposure_ids.
   * @default null
   */
  exposure_numbers?: string[] | null;
  /**
   * Is Automatic
   * @default null
   */
  is_automatic?: boolean | null;
  /**
   * Is Handled
   * Whether an incoming communication has been actioned: `false` while it is still awaiting action, `true` once it has been handled. Always `null` on outgoing communications, which carry no handled status. Some incoming communications are already `true` when they arrive — an answered phone call, for example — so `true` does not necessarily mean someone acted on it.
   * @default null
   */
  is_handled?: boolean | null;
  /** @default null */
  phone_call_specific?: VendorCommunicationsResponsePhoneCallSpecificModel | null;
  /** @default null */
  physical_mail_specific?: VendorCommunicationsResponsePhysicalMailSpecificModel | null;
  /** @default null */
  sms_specific?: VendorCommunicationsResponseSmsSpecificModel | null;
  /**
   * Source
   * @default null
   */
  source?: string | null;
  /**
   * Summary
   * @default null
   */
  summary?: string | null;
  /** @default null */
  user?: VendorCommunicationsResponseUserExternalAPIBaseModel | null;
  /** @default null */
  video_call_specific?: VendorCommunicationsResponseVideoCallSpecificModel | null;
}

/**
 * VendorEmailSpecificModel
 * The carrier email fields plus the sender and the visible recipients. BCC recipients are never listed.
 */
export interface VendorCommunicationsResponseVendorEmailSpecificModel {
  /**
   * Attachments
   * @default null
   */
  attachments?:
    | VendorCommunicationsResponseCommunicationAttachmentResponse[]
    | null;
  /**
   * Body
   * @default null
   */
  body?: string | null;
  /** Cc Addresses */
  cc_addresses?: VendorCommunicationsResponseEmailAddressModel[];
  /**
   * Delivery Status
   * @default null
   */
  delivery_status?: string | null;
  /** @default null */
  from_address?: VendorCommunicationsResponseEmailAddressModel | null;
  /**
   * Recipient Type
   * @default null
   */
  recipient_type?: string | null;
  /**
   * Subject
   * @default null
   */
  subject?: string | null;
  /** To Addresses */
  to_addresses?: VendorCommunicationsResponseEmailAddressModel[];
}

/**
 * VideoCallSpecificModel
 * Video call-specific fields.
 */
export interface VendorCommunicationsResponseVideoCallSpecificModel {
  /**
   * Joined Participants
   * @default null
   */
  joined_participants?: string[] | null;
  /**
   * Meeting End Datetime
   * @default null
   */
  meeting_end_datetime?: string | null;
  /**
   * Meeting Start Datetime
   * @default null
   */
  meeting_start_datetime?: string | null;
  /**
   * Provider
   * @default null
   */
  provider?: string | null;
  /**
   * Recording Status
   * @default null
   */
  recording_status?: string | null;
  /**
   * Recording Url
   * @default null
   */
  recording_url?: string | null;
  /**
   * Transcript
   * @default null
   */
  transcript?: string | null;
}

/** VendorCreateExposureJsonParams */
export interface VendorCreateExposureJsonParams {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Coverage Key
   * The coverage the exposure is for, as the organization's coverages name it.
   */
  coverage_key: string;
  /**
   * Expenses Reserve
   * The expenses reserve the exposure opens with. Send this or expenses_sub_reserves.
   * @default null
   */
  expenses_reserve?: number | null;
  /**
   * Expenses Sub Reserves
   * The expenses reserve split by sub-reserve key; the reserve is their sum. Send this or expenses_reserve.
   * @default null
   */
  expenses_sub_reserves?: Record<string, number> | null;
  /**
   * Indemnity Reserve
   * The indemnity reserve the exposure opens with. Send this or indemnity_sub_reserves.
   * @default null
   */
  indemnity_reserve?: number | null;
  /**
   * Indemnity Sub Reserves
   * The indemnity reserve split by sub-reserve key; the reserve is their sum. Send this or indemnity_reserve.
   * @default null
   */
  indemnity_sub_reserves?: Record<string, number> | null;
  /**
   * Involved Api Uid
   * The involved party the exposure is for. Omit it for a coverage whose involved type is first-party unspecified: the exposure is then the insured's, with no specific involved party.
   * @default null
   */
  involved_api_uid?: string | null;
  /**
   * Use Stat Reserve Configuration
   * Open with the organization's statistical reserves instead of reserves sent with the request.
   * @default null
   */
  use_stat_reserve_configuration?: boolean | null;
}

/** VendorCreateExposureJsonResponse */
export interface VendorCreateExposureJsonResponse {
  /** Exposure Number */
  exposure_number: string;
}

/** VendorCreateNoteJsonParams */
export interface VendorCreateNoteJsonParams {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Exposure Numbers
   * @default ["0"]
   */
  exposure_numbers?: string[] | null;
  /**
   * Is Confidential
   * @default false
   */
  is_confidential?: boolean | null;
  /** Note */
  note: string;
  /** Title */
  title: string;
}

/** VendorCreateNoteJsonResponse */
export interface VendorCreateNoteJsonResponse {
  /** Api Uid */
  api_uid: string;
}

/** VendorCreateReminderJsonParams */
export interface VendorCreateReminderJsonParams {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Category Key
   * @default null
   */
  category_key?: string | null;
  /**
   * Details
   * @default ""
   */
  details?: string | null;
  /**
   * Due Date
   * @default null
   */
  due_date?: string | null;
  /**
   * Due Datetime
   * @default null
   */
  due_datetime?: string | null;
  /**
   * Exposure Number
   * @default null
   */
  exposure_number?: string | null;
  /**
   * Priority
   * @default null
   */
  priority?: string | null;
  /** Title */
  title: string;
  /**
   * User Email
   * Email of the user to assign the reminder to. Accepts either the user login email or the claims email address
   * @default null
   */
  user_email?: string | null;
}

/** VendorCreateReminderJsonResponse */
export interface VendorCreateReminderJsonResponse {
  /** Api Uid */
  api_uid: string;
}

/** VendorGetCommunicationQueryParams */
export interface VendorGetCommunicationQueryParams {
  /** Assignment Token */
  assignment_token: string;
}

/** VendorGetSiuJsonResponse */
export interface VendorGetSiuJsonResponse {
  /** Is Marked As Siu */
  is_marked_as_siu: boolean;
  /**
   * Report Status
   * @default null
   */
  report_status?: string | null;
  /**
   * Siu Criteria
   * @default null
   */
  siu_criteria?: string[] | null;
}

/** VendorGetSiuQueryParams */
export interface VendorGetSiuQueryParams {
  /** Assignment Token */
  assignment_token: string;
}

/** VendorPatchIncidentDetailsParams */
export interface VendorPatchIncidentDetailsParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /** Assignment Token */
  assignment_token: string;
  /** @default null */
  auto_incident_additional?: VendorPatchIncidentDetailsParamsAutoIncidentAdditionalModel | null;
  /**
   * Can Take Photos Of Damage
   * @default null
   */
  can_take_photos_of_damage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Cat Code
   * The catastrophe `code` of the linked cat event. Accepted as input (alternative to `cat_code_name`). If both `cat_code` and `cat_code_name` are sent, they must reference the same cat.
   * @default null
   */
  cat_code?: string | null;
  /**
   * Cat Code Name
   * @default null
   */
  cat_code_name?: string | null;
  /**
   * Contacts
   * @default null
   */
  contacts?:
    | (
        | ({
            creation_mode: "";
          } & VendorPatchIncidentDetailsParamsContactInNewParam)
        | ({
            creation_mode: "existing";
          } & VendorPatchIncidentDetailsParamsContactInExistingParam)
        | ({
            creation_mode: "new";
          } & VendorPatchIncidentDetailsParamsContactInNewParam)
      )[]
    | null;
  /**
   * Date Of Loss
   * @default null
   */
  date_of_loss?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Did Anyone Take Photos Or Video
   * @default null
   */
  did_anyone_take_photos_or_video?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Incident Sub Type
   * @default null
   */
  incident_sub_type?: string | null;
  /**
   * Incident Type
   * @default null
   */
  incident_type?: string | null;
  /**
   * Is Notification Only
   * @default null
   */
  is_notification_only?: boolean | null;
  /**
   * Is Other Policy Covering
   * @default null
   */
  is_other_policy_covering?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  loss_location?: VendorPatchIncidentDetailsParamsLocationModel | null;
  /**
   * Other Policy Description
   * @default null
   */
  other_policy_description?: string | null;
  /**
   * Photographer Contact Ref Id
   * @default null
   */
  photographer_contact_ref_id?: string | null;
  /**
   * Preferred Contact Ref Id
   * @default null
   */
  preferred_contact_ref_id?: string | null;
  /**
   * Special Internal Note
   * @default null
   */
  special_internal_note?: string | null;
  /**
   * Time Of Loss
   * @default null
   */
  time_of_loss?: string | null;
  /**
   * Was Cctv Footage
   * @default null
   */
  was_cctv_footage?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were There Any Witnesses
   * @default null
   */
  were_there_any_witnesses?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Witnesses
   * @default null
   */
  witnesses?: VendorPatchIncidentDetailsParamsExternalWitnessModel[] | null;
  /**
   * Witnesses Note
   * @default null
   */
  witnesses_note?: string | null;
}

/** AccidentFollowUpModel */
export interface VendorPatchIncidentDetailsParamsAccidentFollowUpModel {
  /**
   * Direction Ph Vehicle Was Going
   * @default null
   */
  direction_ph_vehicle_was_going?: string | null;
  /**
   * First Party Way Sign Or A Headlight
   * @default null
   */
  first_party_way_sign_or_a_headlight?: string | null;
  /**
   * Journey Purpose
   * @default null
   */
  journey_purpose?: string | null;
  /**
   * Street Condition
   * @default null
   */
  street_condition?: string | null;
  /**
   * Was Ambulance Called
   * @default null
   */
  was_ambulance_called?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Anyone Under The Influence Of Drugs Alcohol
   * @default null
   */
  was_anyone_under_the_influence_of_drugs_alcohol?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Was First Party Driver Using The Phone
   * @default null
   */
  was_first_party_driver_using_the_phone?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Weather Conditions
   * @default null
   */
  weather_conditions?: string | null;
  /**
   * Were First Party Vehicle Lights On
   * @default null
   */
  were_first_party_vehicle_lights_on?: "yes" | "no" | "na" | "unknown" | null;
}

/** AutoIncidentAdditionalModel */
export interface VendorPatchIncidentDetailsParamsAutoIncidentAdditionalModel {
  /** @default null */
  accident_follow_up?: VendorPatchIncidentDetailsParamsAccidentFollowUpModel | null;
  /**
   * Are Convictions Or Claims In The Last 5 Years
   * @default null
   */
  are_convictions_or_claims_in_the_last_5_years?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Convictions Or Claim Description
   * @default null
   */
  convictions_or_claim_description?: string | null;
  /**
   * Does Policyholder Second Occupation Exist
   * @default null
   */
  does_policyholder_second_occupation_exist?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /** @default null */
  fault_assessment?: VendorPatchIncidentDetailsParamsFaultAssessmentModel | null;
  /**
   * Is Policyholder Occupation Right
   * @default null
   */
  is_policyholder_occupation_right?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  police_and_fire_department?: VendorPatchIncidentDetailsParamsPoliceAndFireDepartmentModel | null;
  /**
   * Policyholder Current Occupation
   * @default null
   */
  policyholder_current_occupation?: string | null;
  /**
   * Policyholder Second Occupation
   * @default null
   */
  policyholder_second_occupation?: string | null;
  /**
   * Replacement Car Rental Date
   * @default null
   */
  replacement_car_rental_date?: string | null;
  /** @default null */
  theft_follow_up?: VendorPatchIncidentDetailsParamsTheftFollowUpModel | null;
  /**
   * Was Replacement Car Rented
   * @default null
   */
  was_replacement_car_rented?: boolean | null;
}

/** ContactEmailModel */
export interface VendorPatchIncidentDetailsParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface VendorPatchIncidentDetailsParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface VendorPatchIncidentDetailsParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: VendorPatchIncidentDetailsParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: VendorPatchIncidentDetailsParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface VendorPatchIncidentDetailsParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ExternalWitnessModel */
export interface VendorPatchIncidentDetailsParamsExternalWitnessModel {
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
}

/** FaultAssessmentModel */
export interface VendorPatchIncidentDetailsParamsFaultAssessmentModel {
  /**
   * Claim Handler Fault Assessment
   * @default null
   */
  claim_handler_fault_assessment?: string | null;
  /**
   * First Party Fault Assessment
   * @default null
   */
  first_party_fault_assessment?: string | null;
  /**
   * Is Fraud Review Needed
   * @default null
   */
  is_fraud_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Indemnity Review Needed
   * @default null
   */
  is_indemnity_review_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Liability Summary
   * @default null
   */
  liability_summary?: string | null;
  /**
   * Percentage Of Insured Liability
   * @default null
   */
  percentage_of_insured_liability?: string | null;
}

/** LocationModel */
export interface VendorPatchIncidentDetailsParamsLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PoliceAndFireDepartmentModel */
export interface VendorPatchIncidentDetailsParamsPoliceAndFireDepartmentModel {
  /**
   * Did Speak With Officer
   * @default null
   */
  did_speak_with_officer?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Fire Department Description
   * @default null
   */
  fire_department_description?: string | null;
  /**
   * Pending Prosecutions Or Investigations Exists
   * @default null
   */
  pending_prosecutions_or_investigations_exists?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Police Crime Reference Number
   * @default null
   */
  police_crime_reference_number?: string | null;
  /**
   * Police Department Contact Ref Id
   * @default null
   */
  police_department_contact_ref_id?: string | null;
  /**
   * Police Description
   * @default null
   */
  police_description?: string | null;
  /**
   * Police Report
   * @default null
   */
  police_report?: string | null;
  /**
   * Violation Title
   * @default null
   */
  violation_title?: string | null;
  /**
   * Was Ticket Received
   * @default null
   */
  was_ticket_received?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Any Hazardous Good Being Carried
   * @default null
   */
  were_any_hazardous_good_being_carried?:
    | "yes"
    | "no"
    | "na"
    | "unknown"
    | null;
  /**
   * Were Fire Department Involved
   * @default null
   */
  were_fire_department_involved?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Police Involved
   * @default null
   */
  were_police_involved?: "yes" | "no" | "na" | "unknown" | null;
}

/** TheftFollowUpModel */
export interface VendorPatchIncidentDetailsParamsTheftFollowUpModel {
  /**
   * Belongings Stolen
   * @default null
   */
  belongings_stolen?: string | null;
  /**
   * Crime Reference Number
   * @default null
   */
  crime_reference_number?: string | null;
  /**
   * Current Num Of Keys
   * @default null
   */
  current_num_of_keys?: number | null;
  /**
   * Date Noticed Vehicle Missing
   * @default null
   */
  date_noticed_vehicle_missing?: string | null;
  /**
   * Date Vehicle Last Seen
   * @default null
   */
  date_vehicle_last_seen?: string | null;
  /**
   * Discovered The Loss Contact Ref Id
   * @default null
   */
  discovered_the_loss_contact_ref_id?: string | null;
  /**
   * Is Vehicle For Sale
   * @default null
   */
  is_vehicle_for_sale?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  keys_location?: VendorPatchIncidentDetailsParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Num Of Keys Received On Purchase
   * @default null
   */
  num_of_keys_received_on_purchase?: number | null;
  /**
   * Person Liable For The Theft Is Known
   * @default null
   */
  person_liable_for_the_theft_is_known?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Security Devices Description
   * @default null
   */
  security_devices_description?: string | null;
  /**
   * Time Noticed Vehicle Missing
   * @default null
   */
  time_noticed_vehicle_missing?: string | null;
  /**
   * Time Vehicle Last Seen
   * @default null
   */
  time_vehicle_last_seen?: string | null;
  /**
   * Tracking Devices Description
   * @default null
   */
  tracking_devices_description?: string | null;
  /**
   * Vehicle Fitted With Security Devices
   * @default null
   */
  vehicle_fitted_with_security_devices?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Vehicle Fitted With Tracking Devices
   * @default null
   */
  vehicle_fitted_with_tracking_devices?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  vehicle_last_seen_location?: VendorPatchIncidentDetailsParamsLocationModel | null;
  /**
   * Vehicle Windows Closed And Secured
   * @default null
   */
  vehicle_windows_closed_and_secured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Vehicle Found With Keys
   * @default null
   */
  was_vehicle_found_with_keys?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Were Belongings Stolen From Vehicle
   * @default null
   */
  were_belongings_stolen_from_vehicle?: "yes" | "no" | "na" | "unknown" | null;
}

/** VendorPatchInvolvedPartyParams */
export interface VendorPatchInvolvedPartyParams {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Contacts
   * @default []
   */
  contacts?:
    | (
        | ({
            creation_mode: "";
          } & VendorPatchInvolvedPartyParamsContactInNewParam)
        | ({
            creation_mode: "existing";
          } & VendorPatchInvolvedPartyParamsContactInExistingParam)
        | ({
            creation_mode: "new";
          } & VendorPatchInvolvedPartyParamsContactInNewParam)
      )[]
    | null;
  /** Involved Party */
  involved_party:
    | VendorPatchInvolvedPartyParamsPatchGenericInvolvedPersonParams
    | VendorPatchInvolvedPartyParamsPatchInvolvedGenericPropertyParams;
}

/** BodilyInjuryLossParams */
export interface VendorPatchInvolvedPartyParamsBodilyInjuryLossParams {
  /**
   * Admission Datetime
   * @default null
   */
  admission_datetime?: string | null;
  /**
   * Bodily Injuries
   * @default null
   */
  bodily_injuries?: VendorPatchInvolvedPartyParamsBodilyInjuryModel[] | null;
  /**
   * Discharge Datetime
   * @default null
   */
  discharge_datetime?: string | null;
  /**
   * Hospital Contact Ref Id
   * @default null
   */
  hospital_contact_ref_id?: string | null;
  /**
   * Icd Codes
   * @default null
   */
  icd_codes?: VendorPatchInvolvedPartyParamsICDCodeModel[] | null;
  /**
   * Injuries Description
   * @default null
   */
  injuries_description?: string | null;
  /**
   * Legal Venue Reason
   * @default null
   */
  legal_venue_reason?: string | null;
  /**
   * Legal Venue State
   * @default null
   */
  legal_venue_state?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Was Ambulance Needed
   * @default null
   */
  was_ambulance_needed?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Was Hospitalized
   * @default null
   */
  was_hospitalized?: "yes" | "no" | "na" | "unknown" | null;
}

/** BodilyInjuryModel */
export interface VendorPatchInvolvedPartyParamsBodilyInjuryModel {
  /**
   * Body Part
   * @default null
   */
  body_part?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Injury Severity
   * @default null
   */
  injury_severity?: string | null;
  /** Injury Type */
  injury_type: string;
  /**
   * Other Body Part
   * @default null
   */
  other_body_part?: string | null;
}

/** ContactEmailModel */
export interface VendorPatchInvolvedPartyParamsContactEmailModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Email Address */
  email_address: string;
}

/** ContactInExistingParam */
export interface VendorPatchInvolvedPartyParamsContactInExistingParam {
  /** Api Uid */
  api_uid: string;
  /**
   * Creation Mode
   * @default "existing"
   */
  creation_mode?: "existing";
  /** Ref Id */
  ref_id: string;
}

/** ContactInNewParam */
export interface VendorPatchInvolvedPartyParamsContactInNewParam {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * Au Bank Account Number
   * @default null
   */
  au_bank_account_number?: string | null;
  /**
   * Au Bsb Number
   * @default null
   */
  au_bsb_number?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Company Name
   * @default null
   */
  company_name?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Creation Mode
   * @default "new"
   */
  creation_mode?: "new" | "";
  /**
   * Date Of Birth
   * @default null
   */
  date_of_birth?: string | null;
  /**
   * Driving License Number
   * @default null
   */
  driving_license_number?: string | null;
  /**
   * Driving License State
   * @default null
   */
  driving_license_state?: string | null;
  /**
   * Emails
   * @default []
   */
  emails?: VendorPatchInvolvedPartyParamsContactEmailModel[] | null;
  /**
   * Entity Id
   * @default null
   */
  entity_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * First Name
   * @default null
   */
  first_name?: string | null;
  /**
   * Full Name
   * @default null
   */
  full_name?: string | null;
  /**
   * Gender
   * @default null
   */
  gender?: string | null;
  /**
   * Government Id
   * @default null
   */
  government_id?: string | null;
  /**
   * Iban
   * @default null
   */
  iban?: string | null;
  /**
   * Is 1099 Reportable
   * @default null
   */
  is_1099_reportable?: boolean | null;
  /**
   * Is Au Tfn Verified
   * Present only for AU-region organizations (TFN is AU-specific). True if the contact's TFN details are currently verified/approved; False or null if not yet approved.
   * @default null
   */
  is_au_tfn_verified?: boolean | null;
  /**
   * Is Company
   * @default false
   */
  is_company?: boolean;
  /**
   * Is Deceased
   * @default false
   */
  is_deceased?: boolean | null;
  /**
   * Is Emailing Allowed
   * @default null
   */
  is_emailing_allowed?: boolean | null;
  /**
   * Is Finance Verified
   * @default null
   */
  is_finance_verified?: boolean | null;
  /**
   * Is Smsing Allowed
   * @default null
   */
  is_smsing_allowed?: boolean | null;
  /**
   * Last Name
   * @default null
   */
  last_name?: string | null;
  /**
   * License Issue Date
   * @default null
   */
  license_issue_date?: string | null;
  /**
   * Middle Name
   * @default null
   */
  middle_name?: string | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Occupation
   * @default null
   */
  occupation?: string | null;
  /**
   * Phones
   * @default []
   */
  phones?: VendorPatchInvolvedPartyParamsContactPhoneModel[] | null;
  /**
   * Ref Id
   * @default null
   */
  ref_id?: string | null;
  /**
   * Report Type 1099
   * @default null
   */
  report_type_1099?: string | null;
  /** Role */
  role: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Swift Bic
   * @default null
   */
  swift_bic?: string | null;
  /**
   * Tin
   * @default null
   */
  tin?: string | null;
  /**
   * Uk Bank Account Number
   * @default null
   */
  uk_bank_account_number?: string | null;
  /**
   * Uk Sort Code
   * @default null
   */
  uk_sort_code?: string | null;
  /**
   * Vat Number
   * @default null
   */
  vat_number?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** ContactPhoneModel */
export interface VendorPatchInvolvedPartyParamsContactPhoneModel {
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /** Phone Number */
  phone_number: string;
  /** Phone Type */
  phone_type: string;
}

/** ICDCodeModel */
export interface VendorPatchInvolvedPartyParamsICDCodeModel {
  /** Icd Code */
  icd_code: string;
  /** Icd Code Description */
  icd_code_description: string;
}

/** LocationModel */
export interface VendorPatchInvolvedPartyParamsLocationModel {
  /**
   * Address1
   * @default null
   */
  address1?: string | null;
  /**
   * Address2
   * @default null
   */
  address2?: string | null;
  /**
   * City
   * @default null
   */
  city?: string | null;
  /**
   * Country
   * @default null
   */
  country?: string | null;
  /**
   * Country In Uk
   * @default null
   */
  country_in_uk?: string | null;
  /**
   * County
   * @default null
   */
  county?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  /**
   * Is Highway
   * @default null
   */
  is_highway?: boolean | null;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /**
   * Zipcode
   * @default null
   */
  zipcode?: string | null;
}

/** PatchGenericInvolvedPersonParams */
export interface VendorPatchInvolvedPartyParamsPatchGenericInvolvedPersonParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /** @default null */
  bodily_injury_loss?: VendorPatchInvolvedPartyParamsBodilyInjuryLossParams | null;
  /**
   * Contact Id
   * @deprecated
   * @default null
   */
  contact_id?: string | null;
  /**
   * Contact Ref Id
   * @default null
   */
  contact_ref_id?: string | null;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Injury Date
   * @default null
   */
  injury_date?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is First Party
   * @default null
   */
  is_first_party?: boolean | null;
  /**
   * Is Injured
   * @default null
   */
  is_injured?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  pecuniary_loss?: VendorPatchInvolvedPartyParamsPecuniaryLossDetailsParams | null;
  /** @default null */
  related_property_loss?: VendorPatchInvolvedPartyParamsPropertyLossWithItemsParams | null;
  /**
   * Relationship To Policyholder
   * @default null
   */
  relationship_to_policyholder?: string | null;
  /**
   * Representative Contact Ref Id
   * @default null
   */
  representative_contact_ref_id?: string | null;
  /**
   * Type
   * @default null
   */
  type?: string | null;
}

/** PatchInvolvedGenericPropertyParams */
export interface VendorPatchInvolvedPartyParamsPatchInvolvedGenericPropertyParams {
  /**
   * Additional Fields
   * @default null
   */
  additional_fields?: Record<string, any> | null;
  /**
   * Attorney Contact Ref Id
   * @default null
   */
  attorney_contact_ref_id?: string | null;
  /**
   * Attorney Reference Number
   * @default null
   */
  attorney_reference_number?: string | null;
  /**
   * Covered Object External Id
   * @default null
   */
  covered_object_external_id?: string | null;
  /**
   * External Id
   * @default null
   */
  external_id?: string | null;
  /**
   * Insurer Contact Ref Id
   * @default null
   */
  insurer_contact_ref_id?: string | null;
  /**
   * Insurer Policy Number
   * @default null
   */
  insurer_policy_number?: string | null;
  /**
   * Insurer Reference Number
   * @default null
   */
  insurer_reference_number?: string | null;
  /**
   * Is First Party
   * @default null
   */
  is_first_party?: boolean | null;
  /**
   * Is Pecuniary Loss
   * @default null
   */
  is_pecuniary_loss?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Property Damaged
   * @default null
   */
  is_property_damaged?: "yes" | "no" | "na" | "unknown" | null;
  /**
   * Is Related Property Loss
   * @default null
   */
  is_related_property_loss?: "yes" | "no" | "na" | "unknown" | null;
  /** @default null */
  location?: VendorPatchInvolvedPartyParamsLocationModel | null;
  /**
   * Owner Contact Id
   * @deprecated
   * @default null
   */
  owner_contact_id?: string | null;
  /**
   * Owner Contact Ref Id
   * @default null
   */
  owner_contact_ref_id?: string | null;
  /** @default null */
  pecuniary_loss?: VendorPatchInvolvedPartyParamsPecuniaryLossDetailsParams | null;
  /** @default null */
  property_damage?: VendorPatchInvolvedPartyParamsPropertyDamageParams | null;
  /**
   * Property Description
   * @default null
   */
  property_description?: string | null;
  /** @default null */
  related_property_loss?: VendorPatchInvolvedPartyParamsPropertyLossWithItemsParams | null;
  /**
   * Type
   * @default null
   */
  type?: string | null;
}

/** PecuniaryLossDetailsParams */
export interface VendorPatchInvolvedPartyParamsPecuniaryLossDetailsParams {
  /**
   * Losses
   * @default null
   */
  losses?: VendorPatchInvolvedPartyParamsPecuniaryLossItemParams[] | null;
}

/** PecuniaryLossItemParams */
export interface VendorPatchInvolvedPartyParamsPecuniaryLossItemParams {
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /**
   * Claimed Loss
   * @default null
   */
  claimed_loss?: string | null;
  /** Display Name */
  display_name: string;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** PropertyDamageParams */
export interface VendorPatchInvolvedPartyParamsPropertyDamageParams {
  /**
   * Is Property Stolen
   * @default null
   */
  is_property_stolen?: boolean | null;
  /** @default null */
  location?: VendorPatchInvolvedPartyParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
  /**
   * Property Damages
   * @default null
   */
  property_damages?: string[] | null;
  /**
   * Property Damages Description
   * @default null
   */
  property_damages_description?: string | null;
}

/** PropertyItemIncomingModel */
export interface VendorPatchInvolvedPartyParamsPropertyItemIncomingModel {
  /**
   * Category
   * @default null
   */
  category?: string | null;
  /**
   * Claimed Amount
   * @default null
   */
  claimed_amount?: number | null;
  /** Description */
  description: string;
  /**
   * Purchase Date
   * @default null
   */
  purchase_date?: string | null;
  /**
   * Purchase Price
   * @default null
   */
  purchase_price?: number | null;
  /**
   * Quantity
   * @default null
   */
  quantity?: number | null;
  /**
   * Scheduled
   * @default null
   */
  scheduled?: string | null;
}

/** PropertyLossWithItemsParams */
export interface VendorPatchInvolvedPartyParamsPropertyLossWithItemsParams {
  /**
   * Damages
   * @default null
   */
  damages?: string[] | null;
  /**
   * Damages Description
   * @default null
   */
  damages_description?: string | null;
  /**
   * Is Stolen
   * @default null
   */
  is_stolen?: boolean | null;
  /**
   * Items
   * @default null
   */
  items?: VendorPatchInvolvedPartyParamsPropertyItemIncomingModel[] | null;
  /** @default null */
  location?: VendorPatchInvolvedPartyParamsLocationModel | null;
  /**
   * Note
   * @default null
   */
  note?: string | null;
}

/** VendorPutSiuJsonParams */
export interface VendorPutSiuJsonParams {
  /** Assignment Token */
  assignment_token: string;
  /**
   * Report Status
   * @default null
   */
  report_status?: string | null;
  /**
   * Siu Criteria
   * @default null
   */
  siu_criteria?: string[] | null;
}

/**
 * VerificationDetailsResponse
 * Response schema for verification details endpoint.
 */
export interface VerificationDetailsResponse {
  /** Change Ulid */
  change_ulid: string;
  /**
   * Deciding User
   * @default null
   */
  deciding_user?: string | null;
  /**
   * Decision Datetime
   * @default null
   */
  decision_datetime?: string | null;
  /**
   * Request Datetime
   * @format date-time
   */
  request_datetime: string;
  /** Requesting User */
  requesting_user: string;
  /** Requesting User Id */
  requesting_user_id: string;
  /** Status */
  status: string;
}

/** VitesseConfigurationArguments */
export interface VitesseConfigurationArguments {
  /** Client Id */
  client_id: string;
  /** Client Secret */
  client_secret: string;
  /**
   * Hub
   * @default null
   */
  hub?: "standard" | "us" | null;
}

/** VitesseConfigurationResponse */
export interface VitesseConfigurationResponse {
  /** @default null */
  configuration?: VitesseConfigurationResponseVitesseConfiguration | null;
}

/** VitesseConfiguration */
export interface VitesseConfigurationResponseVitesseConfiguration {
  /**
   * Client Id
   * @default null
   */
  client_id?: string | null;
  /**
   * Client Secret
   * @default null
   */
  client_secret?: string | null;
  /**
   * Hub
   * @default "standard"
   */
  hub?: "standard" | "us";
  /** Id */
  id: number;
  /** Is Enabled */
  is_enabled: boolean;
  /** Organization Id */
  organization_id: number;
  /**
   * Webhook Password
   * @default null
   */
  webhook_password?: string | null;
  /** Webhook Url */
  webhook_url: string;
  /** Webhook Username */
  webhook_username: string;
}

/**
 * VitessePaymentRequestsWebhookStatus
 * What Vitesse currently holds for this org's Payment-Requests webhook, read from Vitesse.
 *
 * Mirrors `StripeEventDestinationStatus` field-for-field, plus the fields Stripe has no counterpart for:
 * `is_enabled`, `live_state_failure` and its message, and `expected_event_groups`.
 * A stored subscription id says a subscription was *made*, not that it still exists, still points at
 * this deployment, still carries the events this deployment handles, or is even switched on.
 */
export interface VitessePaymentRequestsWebhookStatus {
  /**
   * Are Expected Events Subscribed
   * @default false
   */
  are_expected_events_subscribed?: boolean;
  /** Enabled Events */
  enabled_events?: string[];
  /** Expected Event Groups */
  expected_event_groups: VitessePaymentRequestsWebhookStatusVitessePaymentRequestsWebhookExpectedEventGroup[];
  /** Expected Events */
  expected_events?: string[];
  /**
   * Is Enabled
   * @default false
   */
  is_enabled?: boolean;
  /** Is Registered */
  is_registered: boolean;
  /**
   * Is Url Current
   * @default false
   */
  is_url_current?: boolean;
  /**
   * Live State Failure
   * @default null
   */
  live_state_failure?: "unreachable" | "refused" | null;
  /**
   * Live State Failure Message
   * @default null
   */
  live_state_failure_message?: string | null;
  /**
   * Subscription Id
   * @default null
   */
  subscription_id?: string | null;
  /**
   * Url
   * @default null
   */
  url?: string | null;
}

/**
 * VitessePaymentRequestsWebhookExpectedEventGroup
 * One header of the expected events, and the event types listed under it.
 */
export interface VitessePaymentRequestsWebhookStatusVitessePaymentRequestsWebhookExpectedEventGroup {
  /** Event Types */
  event_types: string[];
  /** Label */
  label: string;
}

/**
 * VitesseProgrammeCheckArguments
 * The payments-config values to check a programme against, as posted by the Verify button.
 *
 * Field names mirror the `payment_provider_specific` keys rather than `VitesseVerificationConfig`'s
 * so the dump can be handed to the very same normalization the send path uses — including its
 * tolerance of the legacy shape. Anything the caller leaves out stays out (`exclude_unset`), because
 * that normalization keys its legacy inference off key *presence*: defaulting an unsent flag to
 * `False` would make a legacy row look like "no verification enabled" here while the send path still
 * reads it as a passphrase.
 *
 * A POST with a body, not a GET on the stored row, so the user can verify values before saving them.
 */
export interface VitesseProgrammeCheckArguments {
  /**
   * Vitesse Account Id
   * @default null
   */
  vitesse_account_id?: string | null;
  /** Vitesse Programme Id */
  vitesse_programme_id: string;
  /**
   * Vitesse Verification Method Field Key
   * @default null
   */
  vitesse_verification_method_field_key?: string | null;
  /**
   * Vitesse Verification Method Id
   * @default null
   */
  vitesse_verification_method_id?: string | null;
  /**
   * Vitesse Verification Method Source
   * @default null
   */
  vitesse_verification_method_source?:
    | "claim_number"
    | "policy_number"
    | "incident_configured_field"
    | null;
  /**
   * Vitesse Verification Passphrase Enabled
   * @default false
   */
  vitesse_verification_passphrase_enabled?: boolean;
  /**
   * Vitesse Verification Sms Enabled
   * @default false
   */
  vitesse_verification_sms_enabled?: boolean;
}

/** VitesseProgrammeCheckResult */
export interface VitesseProgrammeCheckResult {
  /** Issues */
  issues: VitesseProgrammeCheckResultVitesseProgrammeIssue[];
  /**
   * Passphrase Methods
   * @default []
   */
  passphrase_methods?: VitesseProgrammeCheckResultVitessePassphraseMethodOption[];
}

/**
 * VitessePassphraseMethodOption
 * One passphrase definition the programme declares.
 *
 * Returned so the config screen can offer the programme's own methods instead of asking someone to
 * paste a GUID out of Vitesse's portal — which is also what keeps the id valid when a config is
 * promoted between environments, since the ids are environment-specific.
 */
export interface VitesseProgrammeCheckResultVitessePassphraseMethodOption {
  /**
   * Is Default
   * @default false
   */
  is_default?: boolean;
  /** Method Id */
  method_id: string;
  /**
   * Name
   * @default null
   */
  name?: string | null;
}

/**
 * VitesseProgrammeIssue
 * One finding from checking a Vitesse programme against an org's payee-choice config.
 *
 * `code` is a stable machine-readable identifier (the FE groups on `severity`, not on `code`);
 * `message` is the user-facing text, and is also what a send-time `error` carries into the claim
 * reminder.
 */
export interface VitesseProgrammeCheckResultVitesseProgrammeIssue {
  /** Code */
  code: string;
  /** Message */
  message: string;
  /** Severity */
  severity: "error" | "warning" | "info";
}

/** VitesseWebhookCredentials */
export interface VitesseWebhookCredentials {
  /** Webhook Password */
  webhook_password: string;
  /** Webhook Username */
  webhook_username: string;
}

/** VoiceMessageConfigurationParams */
export interface VoiceMessageConfigurationParams {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/**
 * VoicemailConfigurationParams
 * Phone-profile voicemail PUT body: nests the voicemail + out-of-office voice messages.
 */
export interface VoicemailConfigurationParams {
  out_of_office_message_configuration: VoicemailConfigurationParamsVoiceMessageConfigurationParams;
  voicemail_message_configuration: VoicemailConfigurationParamsVoiceMessageConfigurationParams;
}

/** VoiceMessageConfigurationParams */
export interface VoicemailConfigurationParamsVoiceMessageConfigurationParams {
  /** Configuration Type */
  configuration_type: "text_message" | "uploaded_text_message";
  /**
   * Id
   * @default null
   */
  id?: number | null;
  /**
   * Message Text
   * @default null
   */
  message_text?: string | null;
  /**
   * Organization Id
   * @default null
   */
  organization_id?: number | null;
  /**
   * Permanent Audio File Url
   * @default null
   */
  permanent_audio_file_url?: string | null;
  /**
   * Stored File Id
   * @default null
   */
  stored_file_id?: number | null;
}

/** WebhookEventCallbacksUpdate */
export interface WebhookEventCallbacksUpdate {
  /**
   * Callback Urls
   * @default null
   */
  callback_urls?: string[] | null;
  /**
   * Events
   * @default null
   */
  events?: string[] | null;
}

/** WebhookEventCategoryResponseList */
export type WebhookEventCategoryResponseList =
  WebhookEventCategoryResponseListWebhookEventCategoryResponse[];

/** WebhookEventCategoryResponse */
export interface WebhookEventCategoryResponseListWebhookEventCategoryResponse {
  /** Callback Urls */
  callback_urls: string[];
  /** Category */
  category: string;
  /** Event Specific Callback Urls */
  event_specific_callback_urls: Record<string, string[]> | null;
  /** Events */
  events: string[] | null;
  /** Id */
  id: number;
  /** Organization Id */
  organization_id: number;
}

/** WebhookEventTest */
export interface WebhookEventTest {
  /** Category */
  category: string;
  /**
   * Event Name
   * @default null
   */
  event_name?: string | null;
}

/**
 * WebpagePreviewRequest
 * Request schema for fetching webpage preview.
 */
export interface WebpagePreviewRequest {
  /**
   * Url
   * URL to fetch Open Graph metadata for
   */
  url: string;
}

/**
 * WebpagePreviewResponse
 * Response schema containing webpage preview data.
 */
export interface WebpagePreviewResponse {
  /** Webpage preview data */
  preview: WebpagePreviewResponseWebpagePreviewData;
}

/**
 * WebpagePreviewData
 * Open Graph metadata for a single webpage.
 */
export interface WebpagePreviewResponseWebpagePreviewData {
  /**
   * Description
   * Page description from OG metadata or meta description
   * @default null
   */
  description?: string | null;
  /**
   * Error
   * Error message if fetch failed
   * @default null
   */
  error?: string | null;
  /**
   * Image Url
   * Image URL from OG metadata
   * @default null
   */
  image_url?: string | null;
  /**
   * Title
   * Page title from OG metadata or HTML title tag
   * @default null
   */
  title?: string | null;
  /**
   * Url
   * The URL of the webpage
   */
  url: string;
}

/**
 * WorkflowExecutionItemIdsParams
 * Request schema for getting workflow execution IDs with filtering and pagination
 */
export interface WorkflowExecutionItemIdsParams {
  /**
   * Event Key
   * Filter by event key
   * @default null
   */
  event_key?: string | null;
  /**
   * Iso Datetime From
   * Filter executions created from this datetime (ISO format)
   * @default null
   */
  iso_datetime_from?: string | null;
  /**
   * Iso Datetime To
   * Filter executions created until this datetime (ISO format)
   * @default null
   */
  iso_datetime_to?: string | null;
  /**
   * Limit
   * Maximum number of IDs to return
   * @default 1000
   */
  limit?: number | null;
  /**
   * Rule Id
   * Filter by workflow rule ID
   * @default null
   */
  rule_id?: number | null;
  /**
   * Sort By
   * Sort field with optional direction (+/-). Available: created_datetime, submitted_datetime, started_datetime
   * @default "-created_datetime"
   */
  sort_by?: string | null;
  /**
   * Status
   * Filter by execution status. Valid values: ['PENDING', 'PROCESSING', 'SUCCESS', 'FAILED', 'EXPIRED']
   * @default null
   */
  status?: string[] | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Workflow Engine
   * Filter by workflow engine. Valid values: ['n8n', 'test']
   * @default null
   */
  workflow_engine?: string | null;
  /**
   * Workflow Id
   * Filter by workflow ID
   * @default null
   */
  workflow_id?: string | null;
}

/**
 * WorkflowExecutionItemsByIdsParams
 * Request schema for getting workflow executions by IDs
 */
export interface WorkflowExecutionItemsByIdsParams {
  /**
   * Ids
   * List of execution IDs to fetch
   */
  ids: string[];
  /**
   * Include Event Payload
   * Include complete event payload data
   * @default false
   */
  include_event_payload?: boolean | null;
  /**
   * Include Execution Details
   * Include detailed execution metadata
   * @default false
   */
  include_execution_details?: boolean | null;
}

/**
 * WorkflowExecutionModel
 * Response model for workflow executions
 */
export interface WorkflowExecutionModel {
  /**
   * Completed Datetime
   * @default null
   */
  completed_datetime?: string | null;
  /**
   * Created Datetime
   * @format date-time
   */
  created_datetime: string;
  /**
   * Error Summary
   * @default null
   */
  error_summary?: string | null;
  /** Event Key */
  event_key: string;
  /**
   * Event Payload
   * @default null
   */
  event_payload?: Record<string, any> | null;
  /**
   * Execution Details
   * @default null
   */
  execution_details?: Record<string, any> | null;
  /** Execution Uuid */
  execution_uuid: string;
  /**
   * External Execution Id
   * @default null
   */
  external_execution_id?: string | null;
  /** Id */
  id: string;
  /** Organization Id */
  organization_id: number;
  /**
   * Raw Status Response
   * @default null
   */
  raw_status_response?: Record<string, any> | null;
  /**
   * Rule Display Name
   * @default null
   */
  rule_display_name?: string | null;
  /**
   * Started Datetime
   * @default null
   */
  started_datetime?: string | null;
  /** Status */
  status: string;
  /**
   * Storage Path
   * @default null
   */
  storage_path?: string | null;
  /**
   * Sub Organization Id
   * @default null
   */
  sub_organization_id?: number | null;
  /**
   * Submitted Datetime
   * @default null
   */
  submitted_datetime?: string | null;
  /** Workflow Action Id */
  workflow_action_id: number;
  /** Workflow Engine */
  workflow_engine: string;
  /** Workflow Id */
  workflow_id: string;
  /**
   * Workflow Name
   * @default null
   */
  workflow_name?: string | null;
}

/**
 * WorkflowRuleItemIdsParams
 * Request schema for getting workflow rule IDs with filtering and pagination
 */
export interface WorkflowRuleItemIdsParams {
  /**
   * Active
   * @default null
   */
  active?: boolean | null;
  /**
   * Event Key
   * @default null
   */
  event_key?: string | null;
  /**
   * Limit
   * Maximum number of IDs to return
   * @default 1000
   */
  limit?: number | null;
  /**
   * Lobs
   * Filter by LOB keys (None or empty list means all LOBs)
   * @default null
   */
  lobs?: string[] | null;
  /**
   * Search Term
   * Search term to filter by display name (case-insensitive)
   * @default null
   */
  search_term?: string | null;
  /**
   * Sort By
   * Sort field with optional direction (+/-)
   * @default "-last_updated_datetime"
   */
  sort_by?: string | null;
  /**
   * Sub Organization Ids
   * Filter by multiple sub-organization IDs for rule-level filtering (None or empty list means all sub-organizations)
   * @default null
   */
  sub_organization_ids?: number[] | null;
  /**
   * Workflow Id
   * @default null
   */
  workflow_id?: string | null;
}

/**
 * WorkflowRuleItemsByIdsParams
 * Request schema for getting workflow rules by IDs
 */
export interface WorkflowRuleItemsByIdsParams {
  /**
   * Ids
   * List of rule IDs to fetch
   */
  ids: string[];
  /**
   * Include Configuration
   * Include detailed configuration
   * @default false
   */
  include_configuration?: boolean | null;
}

/**
 * WorkflowRuleModel
 * Response model for workflow rules
 */
export interface WorkflowRuleModel {
  /** Action */
  action: Record<string, any>;
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /** Display Name */
  display_name: string;
  /**
   * Engine Configuration
   * @default null
   */
  engine_configuration?: Record<string, any> | null;
  /** Event Key */
  event_key: string;
  /** Id */
  id: string;
  /** Is All Lobs */
  is_all_lobs: boolean;
  /** Is All Sub Orgs */
  is_all_sub_orgs: boolean;
  /** Is Enabled */
  is_enabled: boolean;
  /** Lobs */
  lobs: string[];
  /** Priority */
  priority: number;
  /** Sub Organization Ids */
  sub_organization_ids: number[];
  /**
   * Timeout Seconds
   * @default null
   */
  timeout_seconds?: number | null;
  /** Workflow Engine */
  workflow_engine: string;
  /**
   * Workflow Id
   * External workflow ID
   */
  workflow_id: string;
  /** Workflow Name */
  workflow_name: string;
}

/**
 * WorkflowRuleParams
 * Unified schema for creating and updating workflow rules (PUT semantics)
 */
export interface WorkflowRuleParams {
  /**
   * Conditions Json
   * @default null
   */
  conditions_json?: Record<string, any> | null;
  /**
   * Display Name
   * Human-readable rule name
   */
  display_name: string;
  /**
   * Event Key
   * CMS event that triggers this rule
   */
  event_key: string;
  /**
   * Is All Lobs
   * @default true
   */
  is_all_lobs?: boolean;
  /**
   * Is All Sub Orgs
   * @default true
   */
  is_all_sub_orgs?: boolean;
  /**
   * Is Enabled
   * Whether the rule is enabled
   * @default true
   */
  is_enabled?: boolean;
  /** Lobs */
  lobs?: string[];
  /** Sub Organization Ids */
  sub_organization_ids?: number[];
  /**
   * Sync Key
   * @default null
   */
  sync_key?: string | null;
  /**
   * Timeout Seconds
   * @default 300
   */
  timeout_seconds?: number | null;
  /**
   * Workflow Engine
   * Workflow engine type
   * @default "n8n"
   */
  workflow_engine?: string;
  /**
   * Workflow Id
   * External workflow ID
   */
  workflow_id: string;
  /**
   * Workflow Name
   * Human-readable workflow name
   */
  workflow_name: string;
}

/** XactAnalysisAssignment */
export interface XactAnalysisAssignment {
  /** Assignment Documents */
  assignment_documents: XactAnalysisAssignmentXactAssignmentDocument[];
  /** Xact Transaction Id */
  xact_transaction_id: string;
}

/** XactAssignmentDocument */
export interface XactAnalysisAssignmentXactAssignmentDocument {
  /** Document Id */
  document_id: number;
}

/** XactAnalysisConfigurationCreatedParams */
export interface XactAnalysisConfigurationCreatedParams {
  /**
   * Import Password
   * @minLength 1
   */
  import_password: string;
  /**
   * Import Username
   * @minLength 1
   */
  import_username: string;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /** Name */
  name: string;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** XactAnalysisConfigurationEnablementParams */
export interface XactAnalysisConfigurationEnablementParams {
  /** Is Enabled */
  is_enabled: boolean;
}

/** XactAnalysisConfigurationPatchParams */
export interface XactAnalysisConfigurationPatchParams {
  /**
   * Import Password
   * @default null
   */
  import_password?: string | null;
  /**
   * Import Username
   * @default null
   */
  import_username?: string | null;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Last Updated
   * @default null
   */
  last_updated?: string | null;
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}

/** XactAnalysisConfigurationResponse */
export interface XactAnalysisConfigurationResponse {
  /** Id */
  id: number;
  /**
   * Is Enabled
   * @default null
   */
  is_enabled?: boolean | null;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /** Name */
  name: string;
  /**
   * Sub Organization Ids
   * @default null
   */
  sub_organization_ids?: number[] | null;
}
